import * as React from "react"
import styled from "styled-components";


const Svg = styled.svg`
   



  @media (max-width: 668px) {
   width: 100%;
  }


`







function SvgComponent(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={696.389}
      viewBox="0 0 696.389 582"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EDF4F9"
        d="M501.142 260.803c.286-2.117 2.976-3.707 5.149-2.943 1.833.643 3.398.568 5.241-.371 2.139-1.088 4.672-.254 7.024-.414 1.106-.072 2.364.234 2.61-1.434.137-.912.886-1.145 1.637-1.041 5.565.76 10.848-2.059 16.409-1.275-.811 1.1-2.115 1.432-3.271 1.561-9.473 1.057-18.581 4.283-28.158 4.699-2.26.097-4.322 1.373-6.641 1.218z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F3F3F3"
        d="M308.284 200.903c1.798-.113 3.533-.15 3.121 2.496-1.578-.16-2.34-1.342-3.121-2.496z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF8F8"
        d="M637.567 122.453c.906-.093 1.715.201 2.488.633.703 2.896 3.225 4.407 4.984 6.494.859 1.019 2.25 1.828 2.471 3.095.516 2.963 2.391 4.191 5.023 4.762-.121 1.945.564 3.588 1.877 4.994 2.594 10.186 1.996 20.171-1.869 29.953-1.055 1.655-1.563 3.653-3.121 4.991-1.953.127-3.27-.456-4.029-2.536-.701-1.917-3.305-2.009-4.43-3.69-.408-.385-.75-.829-1.123-1.246-1.52-.777-2.791-1.8-3.439-3.439a6.315 6.315 0 00-1.258-.965c-1.357-.369-2.846-.15-4.098-.937-1.381-.296-2.018.552-2.5 1.632-.34.472-.779.799-1.357.921-.885.088-1.494-.458-2.137-.925-.531-.403-1.146-.286-1.748-.257-.41-.034-.758-.188-1.02-.516-2.559-1.223-3.684.585-4.902 2.318 1.746-.493 3.357-1.499 5.236-.833 1.08.516 1.096 1.343.678 2.299-.299.551-.717.956-1.361 1.077a4.1 4.1 0 01-.865.002c-2.943.145-.631 1.526-.553 2.376.273 1.187-.213 2.031-1.188 2.658-.43.359-1.242.417-1.195 1.154.047.757.867.673 1.363.939a2.7 2.7 0 01.734.439c.174.228.299.481.377.756.523 1.597-1.432 2.616-.965 4.196 1.314 1.19 2.732 2.27 3.627 3.836.225.127.441.272.65.416.715.511 1.5-.247 2.227.113.537.319.736.838.854 1.408.264 1.18-.275 2.829 1.754 2.961.977.085 1.805-.308 2.605-.794.639-.337 1.408-.262 2.119-.716-.035-.911-1.055-.705-1.445-1.185-.229-2.315 1.563-1.542 2.701-1.771.58-.097 1.162-.204 1.756-.229.455.01.871.13 1.223.43-1.27 3.556.268 6.677 1.533 9.841.033.091.125.16.189.239.111.594.025 1.351.361 1.756 3.301 3.979 3.313 9.479 6.33 13.577.162.221.121.593.174.895-.846.99-1.291 2.926-3.227 1.381-2.424-.787-4.689-1.97-7.4-1.845-3.861.179-6.098 1.517-7.289 5.243-.734 2.289-2.221 2.402-4.107 2.002-.43.055-.961-.841-1.117-.251-.164.628.469 1.274 1.303 1.368 1.518.177 2.486.943 2.678 2.516.131 1.063.854 1.865 1.223 2.819.283 1.1-.244 2.86 1.963 2.4 1.41.349 2.732.844 3.619 2.083-.09.265-.215.496-.547.518.463.079.514-.376.768-.588 1.244-1.078 2.791-.871 4.242-1.055.85-.115 1.695-.481 2.549-.041.453.14.313.677.607.926-.037-.322-.191-.583-.436-.809a1.27 1.27 0 01-.145-.781c1.205-1.738 2.289-3.574 4.08-4.811.543-.027.803.28.898.776.143-.744.504-1.478.125-2.254a3.878 3.878 0 01-.201-.843c.08-1.349-.65-3.5 2.146-2.196 2.492 2.938 3.221 6.551 3.861 10.188.123.703.025 1.446.648 1.975 1.037 3.744 2.076 7.487 3.117 11.231a3.697 3.697 0 01-.742.526c-1.42.513-2.982-.028-4.379.625-.387.201-.779.384-1.186.539-3.609.641-5.082 2.188-5.625 5.937-.057.608-.271 1.138-.771 1.519-2.613.884-2.406 3.613-3.564 5.449 1.135.539.904 1.846 1.414 2.595 1.367 2.004 1.813 4.235 2.396 6.46.027 1.313.773 1.879 2.018 1.921.725.212 1.395.521 1.303 1.427-.092.895-.021 1 .959.914.236.171.42.387.553.646 1.404 3.098 1.629-1.1 2.641-.434 2.266-.454 4.551-.266 6.834-.28.941-.007 1.85.104 2.631.697.504.593.518 1.322.502 2.034-.109 4.479 1.594 8.698 1.881 13.12.24 5.57.625 11.239.35 16.701-.434 8.661.16 17.336-.734 26.002-.424 4.096-1.58 8.104-1.5 12.248-2.084 1.021-2.75-.318-3.172-1.955-.23-.889-.232-1.877-1.441-2.072-1.236-.201-1.934.406-2.303 1.52-1.631 3.021-3.248 3.42-5.76 1.283-.916-.781-1.703-1.537-2.969-.865-1.197.639-.814 1.699-.775 2.727.109 2.887-1.074 3.779-4.635 3.621-2.744.049-3.311.83-2.152 2.971 1.934 3.582 1.486 4.842-2.242 6.053-.855.277-1.564.605-1.666 1.582-.125 1.189.732 1.5 1.637 1.916 2.928 1.342 3.342 3.006 1.584 5.848-.859.688-2.018 1.201-1.463 2.674.533 1.414 1.541 1.271 2.764 1.045 2.16-.4 3.475.787 4.271 2.682.043.287.037.574-.012.857-.453 1.398-2.002 2.939.537 3.928.779.316 1.645.465 2.238 1.141.199.234.404.463.607.693.414.471.844.945 1.557.652.305-.123.467-.449.297-.74-.406-.701-1.078-.35-1.656-.332-.455.016-.77-.197-1.039-.529-.318-1.602.662-2.371 1.955-2.67 1.461-.338 3.047.275 3.367 1.607.678 2.822 2.777 3.299 5.014 3.809.387 1.225-.314 1.646-1.346 1.793-.877.121-1.832-.068-2.541.68-.232 1.711-1.631 3.129-1.254 4.992-1.037 3.158-2.121 6.301-3.354 9.389-.316.793-.318 1.918-1.574 2.01-1.838-1.457-3.234-3.691-6.262-2.783-1.02.307-2.156-.35-1.955-1.977.076-.609-.619.172-.891-.15-1.779-2.836-1.381-4.564 1.459-6.357 3.115-1.963 3.211-2.811 1.418-5.941-1.127-1.971-2.457-1.789-4.176-1.131-1.84.707-3.598 1.354-5.406-.477-2.627-2.654-2.873-3.486-1.014-7.365 1.545-1.857 1.451-3.354-.887-4.473-.723-.348-1.266-.988-1.811-1.586-1.352-1.367-2.652-.574-3.93.115-.9.49-1.645 1.232-2.631 1.605-2.828 1.066-4.236.277-4.646-2.857-.182-1.385-.631-2.543-1.432-3.66-2.176-3.043-4.201-3.152-6.955-.287-.684 1.734-.885 3.594-1.445 5.352-.553 1.742-1.627 2.574-3.488 1.641-1.236-1.973-.398-3.842.281-5.723.602-1.078.377-2.32.684-3.459.807-7.975 1.65-15.943.449-23.953-.152-1.02-.102-2.055-.125-3.082.109-2.072-.754-4.057-.586-6.133-.326-2.85.934-5.1 2.525-7.344 1.801-2.537 1.539-3.356-1-5.275-.344-.295-.576-.672-.764-1.078-.725-1.957-.725-1.957-.523-3.799-1.025-.381-2.291.241-3.18-.747-1.588-6.629-4.186-13.013-4.744-19.886.459-.927 1.322-1.145 2.232-1.275 1.252-.103 2.506-.064 3.758-.072 1.199.117 2.449-.082 3.582.502 1.527 2.514 3.373 4.863 4.201 7.76-1.816 1.262-2.514 2.821-1.281 4.886.453 1.01-.303 1.795-.49 2.683.109.997.949 1.461 1.533 2.111.186.184.352.387.514.593.416.588 1.082.647 1.709.791.268.129.43.336.496.62-.143.587-.072 1.462-.514 1.697-2.539 1.348-2.594 2.823-.609 4.764.484.473.211 1.354-.334 1.93-1.238 1.418-.51 2.885-.055 4.313.172.543.395 1.195 1.162 1.234.201.008.387-.121.492-.305.451-.799-.268-1.059-.684-1.445-1.092-1.012-2.098-2.043-1.055-3.664.68-.706 1.709-1.205 1.158-2.531-.531-1.283.299-2.563.176-3.88-.061-.659-.006-1.594.852-1.787.693-.155.928.634 1.309 1.089 1.068 1.288 2.211 2.433 4.098 1.479 2.131-1.463 4.395-2.142 6.938-1.189 2.135 1.267 3.006.357 3.258-1.82.131-1.119.287-2.231.258-3.36-.191-1.811.574-3.733-.664-5.413-.439-.536-.77-1.136-1.055-1.765-.066-1.657-2.035.066-2.283-1.272-.367-.605-.615-1.269-.93-1.899-2.039-4.321-2.209-4.358-6.348-2.294-1.463.732-2.91 1.401-4.248 2.418-1.686 1.283-3.377.367-3.738-1.744 1.617-.77 3.064-1.707 3.475-3.634.678-1.145-.025-1.656-.914-2.195-.959-.584-2.205-.721-2.877-1.777-.111-.291-.297-.646-.18-.893 1.58-3.305.902-6.546-.232-9.78a21.783 21.783 0 01-.018-1.491c.047-1.161-.066-2.345.389-3.459.15-.306.393-.514.715-.618 1.432-.041 1.492 1.053 1.725 2.043.23.984-.295 2.028.246 2.938.031.034.039.141.127.194-.326-.261.158.021-.154-.282-.012-1.295.838-2.27 1.188-3.425.824-1.145 1.072-2.228-.332-3.134-.527-.341-.877-.824-1.242-1.329-1.84-2.55-1.871-2.539-3.496-.025-.895.282-1.729.18-2.502-.361-.994-.837-1.605-1.879-1.631-3.198a466.71 466.71 0 01-.002-17.309c.012-.73.193-1.431.768-1.956 1.6.805 1.746 2.407 2.045 3.878.219 1.074.027 2.238.76 3.188.889 4.026 2.533 7.55 6.121 9.967 1.863 1.254 3.514 1.915 5.971 1.47 2.604-.473 5.494.521 7.975-1.022 1.475-.92 2.686-2.302 4.637-2.158 3.277.452 2.92-1.896 3-3.906 1.51-3.554.598-6.765-1.385-9.824a4.648 4.648 0 01-.758-1.09c-.236-.561-.309-1.149-.289-1.753.021-.43.121-.845.289-1.238.082-.57 1.168-1.162-.055-1.701-1.42-.11-1.83-2.438-3.656-1.63-3.146-1.349-6.268-2.819-9.85-2.066-4.033.847-7.387 2.664-9.227 6.591-.416.664-.828 1.335-1.682 1.506-.625-.109-1.178-.27-.766-1.117-.666.695 1.025 2.199-.836 2.471-1.379.134-1.148-1.333-1.859-1.868.26-2.877-.621-5.603-1.107-8.381.055-.473.203-.914.473-1.308.402-.489.953-.883 1.529-.964 3.76-.529 4.523-4.34 6.928-6.364 1.271-1.073-.824-1.67-1.34-2.518-.395-.631-.094-1.166.23-1.701.688-.877 1.566-1.455 2.652-1.709 2.979-.845 6.297-1.191 7.238-4.991.205-.371.445-.721.664-1.083.777-1.63 1.604-3.244 1.531-5.127-.305-2.274.947-4.816-1.629-6.692-1.109-.81.391-1.737.764-2.589.154-.255.434-.454.451-.774.002-.057-.334-.042-.545.086-1.389.234-2.193 2.859-4.074.983.475-3.37-1.578-5.034-4.25-6.277-.5-.352-.828-.819-.945-1.422.875-2.503-.895-4.062-2.092-5.818-.305-.638-.699-.974-1.381-.423a6.35 6.35 0 01-.641.5c-.371.24-.766.384-1.205.414a3.218 3.218 0 01-.873-.134c-2.098-1.198-4.332-.454-6.518-.456a1.37 1.37 0 01-.764-.54c-.096-.822.742-.996 1.057-1.531.104-.183.23-.371.23-.568-.008-4.431.25-8.834 1.029-13.21.193-1.077.188-2.253-.371-3.363-.191 4.262-.553 8.511-.582 12.785-.01 1.518.396 3.104-.434 4.551-2.615.907-3.385.542-3.443-2.215-.098-4.647-.43-9.316.428-13.942-.107.557.152 1.241-.582 1.564-1.879.131-2.105-1.246-2.318-2.583-.176-1.093.023-2.265-.742-3.218-1.387-2.87-4.016-4.797-5.682-7.454-.607-.23 1.381-1.003-.209-1.013-.988-.007-1.977.135-2.973-.017-8.355-.228-16.709.271-25.049-.256-1.516-.585-1.514-1.768-1.09-3.029.326-.975.746-1.922.395-2.964-.1-.294.08-.767-.436-.86-.074.478-.395.668-.842.703-.547-.384-.645-.955-.662-1.562.293-1.253-.215-2.198-1.16-2.968-1.293-1.46-2.041-3.15-4.578-3.576-2.494-.419-2.16-3.035-1.414-5.119.623-.679 1.436-.596 2.109-.583-1.068-.187-2.188-.115-3.061.883-.873.385-1.686.185-2.477-.238-.844-.573-1.768-.505-2.705-.317a4.095 4.095 0 01-.836-.026c-1.252-.251-2.518-.187-3.783-.187-1.107-.073-2.148.189-3.145.662-.838.028-1.785-.15-1.99 1.071-.48.638-1.025 1.235-1.113 2.081-.609 1.208-1.941.625-2.834 1.15-1.861.103-3.771-.151-5.521.79.557 1.267 1.32.54 2 .193.943-.482 1.859-1.06 2.619.249.223.644-.018 1.154-.457 1.607-1.223 1.505-2.563 2.86-3.004 4.934-.457 2.123-2.227 2.962-4.285 2.842-4.75-.277-9.496 1.279-14.455-.223 2.328 2.215 2.311 3.691.164 4.517a3.8 3.8 0 01-1.373-.28c-2.803-1.757-5.672-3.403-8.506-5.104-6.262-3.76-13.324-4.915-20.24-6.583-2.146-.586-4.301-.5-6.457-.078-.592.164-1.195.276-1.803.373-6.465.867-11.576 4.076-15.717 9.017-.715.852-1.344 1.857-2.482 2.269a1.558 1.558 0 01-.861-.144c-.641-1.783-.641-3.529.279-5.418-1.41-.136-2.057.74-2.715 1.824-.77 1.272-.891 2.968-2.402 3.772-.541.029-.986-.164-1.348-.565-1.166-1.671-2.963-1.284-4.555-1.291-10.166-.052-20.334-.02-30.501-.03-1.35-.001-2.707.041-4.029-.27-1.361-.32-2.385-.9-1.688-2.577 1-.593 1.189-1.549 1.131-2.257.021-.769-.564-.359-.148-.397.061-.005.098.087.09.275-.021.509.029 1.022-.111 1.522-1.559-.552-1.559-.552-1.439-3.509-1.359.201.252 4.139-2.758 2.207-.498-.413-.734-1.05-1.234-1.761-.203 1.767.883 2.063 1.92 2.405 1.264.929 2.732 1.791 1.215 3.646-2.916 3.532-3.316 3.663-6.389 2.098-.924-2.866.258-5.705.031-8.59-.109-.031-.152.081-.16.362-.117 6.992.154 6.695-6.219 6.8-2.34.039-4.656-.288-7.18-.288 2.889.373 2.889.373 2.246 2.369-6.496.569-12.978.786-19.459-.115-1.346-2.116-3.504-1.897-5.564-1.898-18.81-.008-37.617-.056-56.427.039-3.719.018-7.435-.684-11.176.107-1.718.364-2.535-.79-2.097-2.479.54-2.082.562-4.326 2.091-6.115.99-1.158.861-2.736 1.058-4.159.282-.771.247-1.583.245-2.394-.016.715-.068 1.423-.377 2.09-.47 1.047-.51 2.198-.838 3.273-.21.691-.469 1.445-1.392 1.354-.871-.086-1.125-.83-1.227-1.546-.202-1.422-.27-2.854.098-4.266.847-1.495 1.569-2.994.038-4.517-.867-3.785-.244-7.621-.308-11.429-.079-4.671-.039-9.351.066-14.024.033-1.471-.527-1.45-1.561-1.077-.618-.393-.76-1.019-.856-1.67-.296-2.616 1.317-4.497 2.515-6.538.684-.93 1.305-1.908 2.006-2.829.76-.944 1.912-1.518 2.487-2.64.54-.95 1.064-1.913 1.983-2.569.679-.479 1.124-1.157 1.551-1.851 1.593-1.41 1.749-3.553 2.698-5.293.387-.286.824-.407 1.3-.407.476.035.867.251 1.205.571.815.918.539 1.882.106 2.849-.558 1.248-.74 2.494.042 3.738-.146-2.23 1.272-4.515-.27-6.702-.4-2.258 2.088-3.115 2.426-5.017 2.891-.694 4.87-1.892 4.208-5.514-.294-1.606 1.111-2.995 2.652-3.486 2.777-.886 4.888-3.196 7.902-3.525.51-.056.887-.511 1.008-1.072 1.434-1.705 3.716-1.737 5.532-2.329 8.711-2.838 17.514-5.351 26.532-7.205 8.621-1.771 17.235-3.338 25.983-4.198 2.529-.687 5.152-.429 7.707-.53a525.994 525.994 0 0147.903.273c.193.01.377.167.564.257 5.607-.111 11.002 1.537 16.525 2.015 7.516.65 14.596 3.317 22.016 4.487 3.768.593 7.707 1.929 11.387 3.488.986 1.336 2.416 1.754 3.969 1.856 1.004.066 2.033-.027 2.9.634 4.611 1.032 8.896 2.91 13.105 4.994 1.66.844 3.316 1.691 4.994 2.496 4.643 2.409 9.418 4.509 14.352 6.245 5.986 2.71 11.566 6.164 17.275 9.388 3.947 2.229 7.668 4.813 11.566 7.115 3.291 1.944 6.094 4.756 9.268 7.001 2.945 2.083 5.762 4.37 8.508 6.717 4.693 4.012 9.289 8.141 13.924 12.221.535 1.959 1.963 3.029 3.74 3.745.26.164.553.292.777.494 3.883 3.503 3.896 3.524 8.176.219.713-.552 1.438-.745 2.279-.718 1.641-1.069 4.152-.522 5.156-2.78 6.654-2.398 13.725-1.355 20.523-2.516 1.477-.252 2.604.632 3.805 1.043 3.563 1.214 7.502 1.577 10.475 4.248zM239.986 501.93c-.311-.02-.772.09-.911-.072-3.614-4.273-8.604-7.012-12.286-11.242-4.502-5.174-9.283-10.105-13.97-15.117-.637-.684-1.573-.393-2.379-.396-4.779-.023-9.559.004-14.338-.029-.996-.008-2.108.346-2.92-.613 1.085-1.104 2.497-.85 3.813-.857 6.006-.037 12.012-.016 18.016-.021.917-.053 1.827.025 2.725.221 1.477.525 2.972.523 4.481.119a5.66 5.66 0 011.648.082c4.147.461 8.303.164 12.45.191 8.516.055 17.051-.348 25.545.09 18.261.947 36.524.289 54.783.592 1.561.025 3.112.014 4.652-.193 1.258-.26 2.109.396 2.961 1.225 5.008 4.869 8.648 4.467 12.294-1.324.485-.406.999-.33 1.527-.102 5.592.783 11.205.293 16.804.307 24.217.047 48.436.146 72.649-.066 1.133-.096 1.881.652 2.725 1.23 2.826 1.941 5.43 1.959 8.258.027 1.021-.695 1.967-1.516 3.33-1.363 10.691.188 21.381.717 32.057-.314 1.969-.189 3.947-.09 5.922-.09 10.912-.008 21.826 0 32.738-.01 3.354.104 6.717-.176 10.066.197 2.67 1.094 5.287-.199 7.936-.189 6.594.023 13.189.02 19.785-.002 1.332-.002 2.686.127 3.979-.352 1.277-.301 2.58-.23 3.875-.264 1.488.137 3.129-.359 4.375.971-1.723 1.568-1.723 1.568-7.064 1.387 3.295.141 6.639-.246 9.879.215 3.316.471 6.609.412 9.545.504-2.143-.191-4.703.203-7.641-.26 1.191-1.412 2.338-.814 3.258-.984-.9-.158-1.971.227-2.904-.436 2.145-1.859 22.17-2.031 25.104-.152-1.16.936-2.383.408-3.527.588 4.063-.494 7.836 1.537 11.994 1.252-.426-.17-.766.049-1.09-.039-.822-.221-2.004.57-2.451-.611-.434-1.148 1.008-2.885 2.352-3.008 1.955-.176 3.961.246 5.861-.559 5.359-1.23 10.76-.828 16.158-.434 2.029 1.041 1.145 3.51 2.406 4.934.207.002.412.004.619.004.504 1.645 1.836 2.814 2.5 4.367 0 .209.002.414.004.621.842.621.699 1.73 1.244 2.498 1.07 2.418 1.383 5.088 2.5 7.488 1.104.123 1.336.898 1.227 1.797-.479 4.002.971 7.785 1.393 11.682.541 5.023-.191 9.744-1.146 14.633-1.021 5.234-2.84 10.107-5.305 14.688-5.842 10.859-14.504 19.072-25.574 24.385-8.23 3.951-17.166 5.568-26.33 5.188-13.143-.545-24.557-5.242-34.465-14.053-5.172-4.598-9.189-9.881-12.559-15.807-.762-1.334-1.959-1.629-3.475-.855-4.572 2.33-9.074 4.863-13.828 6.752-8.371 3.326-16.594 7.014-25.188 9.838-5.01 1.645-10.199 2.443-15.156 4.168-2.65 1.334-5.701 1.227-8.428 1.42-5.865.412-11.152 3.146-17.039 3.369-3.02.111-6.041.896-9.137.875-1.35-.01-2.596.67-3.469 1.814-7.145-.006-14.246.807-21.365 1.127-8.05.361-16.118-.559-24.177-.936-5.689-.262-11.396-.408-16.97-1.496-6.016-1.178-12.104-1.891-18.085-3.377-3.468-.859-7.096-1.281-10.578-2.27-8.037-2.277-15.952-4.904-23.873-7.566-8.081-2.715-15.815-6.166-23.462-9.719-5.699-2.648-11.286-5.773-16.774-8.986-4.179-2.447-8.343-5.098-12.847-7.129-2.449-1.105-4.632-3.352-6.874-5.135-4.94-3.928-10.541-7.064-14.731-11.916-.709-1.254-1.846-1.963-3.122-2.502zM228.132 92.494l1.249.003c4.004.061 4.516.729 4.619 6.022.07 3.661-.592 7.455 1.917 10.675 2.394 1.199 4.663-.238 6.991-.334.729-.174 1.459-.214 2.193-.042.847-.018 1.563 1.039 2.503.297 1.153-.278 2.148-1.125 3.43-.924 2.315.937 3.829 2.628 4.691 4.943.442 1.274.728 2.575.711 3.931.009 1.701.013 3.402.004 5.103-.098 3.427-1.305 6.532-2.78 9.561a3.938 3.938 0 01-.968 1.03c-2.137 2.349-5.661 2.207-8.13 4.5 1.923-.125 3.125-1.555 4.768-1.687 1.028-.082 2.266-.263 2.652.975.383 1.228-.877 1.398-1.646 1.849-2.194 1.286-4.914 1.741-6.444 4.073-.14.249-.307.478-.495.692-.729.671-1.677.998-2.474 1.566a7.397 7.397 0 01-1.472.79c-.929.324-1.82.724-2.653 1.252-1.146.707-2.298 1.396-3.705 1.413-2.058-.003-4.14.005-5.878 1.305-1.117.835-2.431-.352-3.487.5-.617 1.188-1.763 1.161-2.613 1.208 1.452.625 2.167-1.087 3.427-1.536 1.715 1.735.127 3.004-1.041 3.102-4.146.346-8.553 2.147-12.312-1.326-.579-.534-1.326-.578-2.045-.572-11.907.102-23.817-.355-35.721.249-.544.028-1.602-.42-.44.87.62.688-.876 1.092-1.607 1.196-2.151.308-4.348-.134-6.495.329-2.005.869-3.712 2.311-5.79 3.035a2.519 2.519 0 01-.868-.088c-.284-.112-.547-.285-.833-.401-.473-.19-1.14-.485-1.371.062-.233.552.585.689.916 1.04.196.222.306.476.326.77-.384 1.875-1.715 3.445-1.724 5.441.065.702-.05 1.387-.126 2.082-.1 37.816-.018 75.624-.038 113.433-.013 24.201.002 48.404-.012 72.605-.001 1.547.212 3.123-.406 4.619-1.254 1.393-1.919.438-2.33-.699-.479-1.32-.575-2.736-.576-4.145.541-3.963.524-7.92-.154-11.871.146 1.416.684 2.877-.547 4.111-2.446-1.324-1.161-3.621-1.449-5.506.108-1.115.24-2.416 1.294-2.895 1.909-.871 1.093-1.953.532-3.105.072-1.797 1.191-3.5.471-5.365-.044-1.713-.746-2.791-2.458-3.482-1.919-.775-2.604-2.264-1.217-4.205 1.362-1.9.567-2.654-1.478-2.502-2.188.164-3.957-.15-4.164-2.836.25-.788.585-1.487 1.555-1.549.341.222.366.475.076.761.009.689-.121 1.425.615 1.874 2.792-.322 4.517-1.386 3.806-4.691-.297-1.379-.586-3.229.177-4.235.597-.789 1.624-1.055.666-2.109-1.219-1.341-.449-2.979-.826-4.451-.38-1.48.156-3.106-.338-4.628-.658-2.027-2.821-1.429-4.111-2.354-.513-.011-.979-.118-1.247-.623-1.289-1.641-3.348-2.052-4.993-3.123v.002c-.941-2.214-3.048-2.871-4.994-3.746v.003c-.699-1.656-2.397-1.813-3.744-2.499-.466-.173-1.147-.207-1.364-.541-1.305-2.023-3.101-3.104-5.5-3.198.633-.65 1.338-1.243 1.748-2.156-.62.742-1.052 1.558-1.755 2.149-1.949-5.47-6.9-8.58-10.259-12.948-3.277-4.262-6.218-8.707-9.015-13.276-3.936-6.426-7.012-13.31-9.517-20.336-1.3-3.646-2.523-7.524-3.033-11.483-1.918-15.187-2.141-30.374-.001-45.561l.008-2.493c1.61-.841 1.726-2.396 1.852-3.93.099-1.21-.169-2.48.637-3.563.057-4.631 2.704-8.384 4.396-12.419 4.54-10.822 11.556-20.107 19.137-28.925 5.313-6.181 11.572-11.379 18.296-16.045 8.427-5.846 17.683-10.025 26.969-14.207 2.038-.917 4.043-.707 6.092-.806 14.142-3.917 28.57-3.837 43.047-3.097.415.02.907-.063 1.215.186 4.059 3.268 8.982 1.465 13.446 2.325.749.138 1.528.179 2.212.581zM50.88 320.311c5.849-3.334 12.096-5.683 18.712-6.797 7.392-1.245 14.778-.961 22.059 1.1 8.326 2.357 15.882 6.084 22.367 11.908 1.052.943 2.673 2.275 3.174-.676.109-.646.69-1.059 1.357-1.109 1.594-.115 2.039-1.178 2.193-2.52l.393-.213c.305.076.529.252.677.527.278.754.235 1.492-.088 2.219a3.07 3.07 0 01-.906.988c-.715.652-2.134.588-2.143 1.936-.009 1.357 1.22 1.121 2.038 1.391.294.086.564.219.818.391.681.689 1.022 1.521 1.042 2.486a2.921 2.921 0 01-.182.865c-1.999 2.852-1.999 2.852 1.06 4.842.325.42.305.973.701 1.758.163-1.102-.474-1.748-.445-2.482.26-.703.793-.793 1.436-.645 2.921 1.295 1.728 3.727 1.627 5.859 1.208 2.449 2.416 4.891 3.432 7.426 2.74 6.648 3.57 13.604 3.315 20.723-.081 2.275-.17 4.57-1.492 6.574-.795.744-1.538.371-2.274-.109a5.574 5.574 0 01-.717-.586c-.472-.367-.921-1.15-1.505-.906-2.197.926-4.233 2.168-5.662 4.137-.458.631.095 1.383.35 2.047.127.254.23.516.326.781.252.98.842 1.789 1.353 2.641 1.596 3.658-1.307 5.402-3.212 7.578-1.094.492-2.207.482-3.329.123a2.623 2.623 0 01-.79-.484c-1.276-2.133-2.81-3.752-5.657-3.131-.584.125-1.192-.266-1.599-.799-1.611-2.111.483-7.926 3.126-8.273 1.894-.25 3.657-1.037 3.929-2.672.273-1.646-.107-3.604-2.284-4.625-1.96-.924-1.793-2.535.171-3.672.795-.459 1.621-.891 2.516-1.193.869-.293 2.5.232 2.359-1.305-.122-1.34.11-3.178-1.464-3.855-2.549-1.098-2.696-3.08-2.561-5.381.071-1.213.143-2.504-.785-3.529a10.129 10.129 0 01-.915-.855 3.412 3.412 0 01-.477-.666c-.173-.354-.312-.727-.476-1.084-.569-.832-1.284-.537-1.996-.246-.367.201-.743.369-1.157.441-2.726-1.303-3.229-4.17-4.552-6.455-.772-.318-1.542-.625-2.371-.748-.782-.037-1.353.346-1.916.842-4.331 3.813-6.228 3.297-7.894-2.113-1.762-1.57-3.047-1.025-4.018.898-.599 4.662-3.281 5.906-6.875 3.096-1.164-.91-2.125-1.121-3.344-.283-1.252.859-.947 1.805-.438 2.973 1.384 3.168.233 4.941-3.558 5.688-1.563-.459-3.295-1.783-4.254.838-1.293 1.914.235 2.611 1.479 3.43 2.513 2.842 1.792 5.619-1.856 6.609-1.246.338-1.76.836-1.736 2.063.024 1.232.257 2.293 1.716 2.514 1.438.215 2.896.367 3.822 1.715.857 1.635.697 3.252-.544 4.533-1.485 1.533-1.534 2.988-.307 4.607.77 1.391 1.619.764 2.47.088 3.116-1.631 4.396-1.102 6.145 2.525-.003.297-.051.59-.14.877-.658 1.436-1.443 2.824.596 3.928 1.796.971 2.527-.086 3.479-1.35 1.86-2.467 5.512-1.828 6.706 1.031.396.951-.118 2.451 1.527 2.691.416.029.83.039 1.244.016 1.775-.164 1.483-1.656 1.796-2.77.979-3.477 3.762-4.422 6.713-2.297.22.191.423.398.621.607.58.631 1.201 1.217 1.941 1.658.173.105.33.236.504.334 3.628 2.041 3.628 2.041 2.823 6.359-.876 2.395.066 3.902 2.284 4.871.846.371 1.586.957 2.32 1.541.268.199.503.42.729.662 1.679 2.887.476 5.594-.686 8.189-.69 1.545-2.532 1.07-3.861 1.49-1.297.41-2.646.344-3.975.451-3.648 3.074-8.122 4.475-12.447 6.186a6.577 6.577 0 01-2.117.475c-7.901.352-15.739 2.867-23.733.559-1.286-.369-2.802.732-4.223-.023-3.594-1.971-7.76-2.492-11.318-4.621-8.079-4.834-14.783-11.027-19.965-18.932-2.834-4.322-4.304-9.182-6.172-13.895-2.413-3.596-1.807-7.799-2.076-11.732-.401-5.875-.127-11.779 1.336-17.57.718-2.84 1.545-5.594 3.367-7.93.542-.693.834-1.383.838-2.258.008-1.557.699-2.783 1.961-3.682 2.997-1.209 5.194-2.74 6.911-6.031 1.359-2.609 3.792-5.926 7.644-6.543 1.032-.164 1.731-.725 2.115-1.635.696-1.649 1.989-2.891 2.874-4.404zM220.64 34.454c2.89-8.306 8.029-14.434 16.074-18.479 8.228-4.137 16.574-4.041 25.027-1.979 4.176 1.019 7.747 3.971 10.975 6.688 3.921 3.302 6.907 7.681 8.911 12.544.225.546.123 1.227.172 1.844-1.18 1.721-1.74 3.54-1.761 5.711-.024 2.561.675 4.161 3.097 5.358 2.917 1.442 4.232 5.143 3.314 7.916-1.851.298-3.165-1.077-4.776-1.521-1.84-.658-3.707-.544-5.577-.176-.262.107-.531.201-.795.299-1.293.362-1.936 1.605-3.024 2.246-1.04.487-2.139.896-3.276.627-2.072-.492-3.85.17-5.578 1.176-1.233.461-2.05 1.735-3.488 1.798-.205-.03-.386-.122-.576-.188-.891-.313-1.156-2.068-2.427-1.291-1.049.641-.531 1.838-.421 2.831.042.387-.144.731-.285 1.145.575-1 .904-2.293 2.319-2.14.668.073.718.885.759 1.506-1.063 3.192-2.156 6.376-2.551 9.74a1.838 1.838 0 01-.504.671c-1.669.56-.324 1.505-.28 2.28.092.275.14.559.157.848-.011.436-.127.835-.421 1.167-.932-.207-1.75.377-2.655.396-1.033-.184-1.822-.865-2.722-1.321-.643-.387-1.208-.849-1.499-1.572-.398-1.811-1.5-2.458-3.295-2.043-.78.181-1.579.246-2.377.072-5.331-3.151-9.639-7.231-11.919-13.149-1.477-2.397-3.272-2.357-5.302-.72-.876.707-1.77 1.426-3.007.741-2.323-1.282-3.335-3.259-3.189-5.886.081-1.449-.053-2.858-.763-4.193-.44-.828-.625-1.859-.357-2.719 1.044-3.342.922-6.904 2.02-10.227z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF8F8"
        d="M608.848 72.527c1.268 3.801 1.807 7.502 1.449 11.693-.75 8.856-8.285 15.295-15.641 17.011-7.57 1.765-14.074-.518-19.143-5.882-5.803-6.139-6.889-13.806-4.008-21.649 2.182-5.933 6.775-9.644 13-11.164 3.748-1.107 7.494-.718 11.24.001 2.82-.127 5.207.694 6.865 3.12 2.055 2.314 4.707 4.083 6.238 6.87zM632.571 427.031c-2.84 4.93-5.514 9.969-8.629 14.719-.859 1.314-.934 2.885-1.988 4.006-1.297 1.203-2.924.744-4.434.875-6.326-.021-12.652.029-18.975-.021-4.305-.035-4.773-.777-3.184-4.738.127-4.949.014-9.928 1.91-14.646.357-.484.846-.58 1.398-.449 1.523 1.473 1.254 3.434 1.254 5.232-.002 2.5 1.854 2.391 3.406 2.691 1.564.305 2.914.006 3.395-1.816.133-.5.219-1.012.334-1.514.807-3.5 1.742-4.23 5.426-4.852 2.85-.482 3.842 1.379 4.826 3.393.271.559.58 1.098.848 1.656 1.996 4.186 2.777 3.959 6.477 1.055 2.262-1.777 2.242-3.52 2.141-5.727-.021-.516.004-1.033.041-1.549.125-1.811.867-3.277 2.707-3.727 2.1-.512 2.488 1.35 3.217 2.66.252.459.385.957.393 1.484-.03.495-.243.907-.563 1.268z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EAF4FD"
        d="M636.311 82.514c-2.506-.69-3.68-2.494-4.01-4.923-1.219-8.948.85-12.487 9.121-14.073 4.279-.821 7.375 1.999 9.818 5.068 2.156 2.71 1.838 7.294-.223 10.034-1.047 1.392-1.775 3.076-3.471 3.893-3.743 1.402-7.489 1.092-11.235.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E4E4F5"
        d="M231.832 56.937c2.166 5.74 6.485 9.624 11.28 13.098.902.973.825 2.187.835 3.379-.007.783-.038 1.567-.274 2.323-.466.844-.77 1.781-1.361 2.565-1.409-.199-1.107 1.204-1.675 1.793-.381.26-.788.301-1.219.148-.369-.234-.625-.572-.863-.924-1.087-1.463-2.786-.799-4.178-1.2-3.376-.01-6.767-.13-9.958 1.285-.407.337-.842.355-1.3.113a1.159 1.159 0 01-.14-.885c3.716-3.933 6.461-8.412 7.707-13.736.982-2.569-.555-5.499 1.146-7.959z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BED9EF"
        d="M215.653 474.473l-22.471-.014c-3.318-.004-6.635-.008-9.951-.014-6.288-.447-12.586-.689-18.851.133-2.342.305-4.52-.516-6.778-.453-9.637.281-19.238-.945-28.875-.629-1.496.051-3.168.391-4.287-1.139 2.612-2.543 5.66-3.07 9.064-1.969 1.41.92 3.005.689 4.547.691 13.088.014 26.179-.182 39.262.086 6.913.141 13.779 1.58 20.742 1.117 4.328-.082 8.662-.172 12.98.064 1.704.095 3.847-.225 4.618 2.127z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EEF4F9"
        d="M226.261 92.498c-3.008 0-6.018.05-9.024-.02-1.711-.04-3.797.771-4.467-1.996-.184-.764-1.484-.471-2.292-.472-8.194-.014-16.506-.83-24.539.313-4.515.643-9.374-.238-13.731 2.01-1.075.554-2.652.134-3.999.162 3.646-2.122 7.756-2.42 11.788-3.164 8.201-1.515 16.467-1.394 24.712-1.126 6.234.202 12.426 1.196 18.432 3.045.788 1.044 2.71-.743 3.12 1.248z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FBFDFA"
        d="M144.508 312.815l-.017-.626a20.595 20.595 0 00-1.601-1.229c-.68-.41-1.402-.528-2.178-.306-2.672 1.716-4.311-.721-6.342-1.553-1.953.218-1.337 2.216-2.205 3.181-.382.28-.808.342-1.265.257-1.105-.514-2.057-1.202-2.633-2.317 1.931-2.122 2.359-4.334.471-6.736-.399-.507-.196-1.172.4-1.168 2.089.009 4.358-.87 6.083 1.205 3.103 3.729 5.247 3.436 7.231-.925 1.376 2.488.984 3.62-1.8 5.209 3.605 1.139 4.637 2.478 3.856 5.008z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E6F5FD"
        d="M660.032 272.25c-.832 0-1.666-.002-2.498-.005-.703-.922-1.574-1.018-2.703-.854-2.406.347-4.848.398-7.283.231-1.396.791-2.869.746-4.553.442.445-1.401 1.703-.759 2.428-1.168 1.242-.703.408-.967-.369-1.146a9.283 9.283 0 01-2.496-2.49c.977-.943-4.873-1.095-.291-2.479.041-.013.049-.475-.041-.525-1.965-1.128-1.768-3.558-3.09-5.081-1.26-1.457 1.041-6.046 3.412-6.901.367.355.463.799.426 1.288-.949 2.771-1.281 5.543.002 8.311.777 2.28 2.271 3.945 4.379 5.083 4.268 2.321 8.264 1.863 12.023-1.141.938-.748 1.627-1.914 3.061-1.842l.107.769c.371.428.324.849-.016 1.264-1.078-.029-.957.553-.635 1.239-2.057 1.082-1.703 2.695-.967 4.396-.099.496-.318.818-.896.609z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EDF4FA"
        d="M63.367 419.541c3.501-1.15 7.038-.201 10.494.092 6.222.529 12.126-1.84 18.331-1.51 1.922.1 3.917-1.467 5.84-2.404 2.678-1.307 5.344-2.557 7.772-4.291a.93.93 0 01.187.836c-.783 2.947.454 5.877.089 8.822-.093.119-.187.238-.281.355-1.586-.766-1.358-2.248-1.214-3.529.317-2.842-1.252-2.455-2.94-1.828-2.658.988-5.208 2.201-7.927 3.098-6.097 2.012-12.321 2.389-18.604 2.18-3.959-.133-7.885-.868-11.747-1.821z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EEF4F8"
        d="M432.848 50.056l-56.174-.001c2.464-1.281 5.242-.854 7.82-1.107a199.702 199.702 0 0131.296-.598c5.669.335 11.519-.225 17.058 1.706z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F8FCFD"
        d="M32.156 339.029c-3.026 3.139-4.106 7.375-5.338 11.232-2.013 6.313-3.386 12.939-2.731 19.684.394 4.07 1.203 8.102 1.826 12.148-1.861.238-2.552-.5-2.531-2.443.087-8.158-.053-16.316.074-24.477.063-4.023 1.144-7.799 4.428-10.516.942-.781 1.071-1.48.831-2.676-.642-3.189.749-4.727 4.064-4.826.669.915.201 1.454-.623 1.874z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EFF5F8"
        d="M90.821 174.882c.001 3.724-.194 7.46.05 11.168.327 4.945-2.667 9.735-1.177 14.527 2.057 6.617.585 13.264 1.128 19.868-1.638-2.682-1.286-5.802-1.666-8.695-1.558-11.868-1.198-23.732 1.038-35.513.091-.475.413-.905.627-1.355z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF5F9"
        d="M32.156 339.029l.624-1.873c5.042-6.68 10.358-13.066 18.101-16.846-.066 2.949-3.028 6.527-5.708 6.857-.732.09-1.604.033-1.685.986-.119 1.385-1.34 1.764-2.095 2.561-1.32 1.389-2.877 2.232-3.381 4.641-.469 2.231-3.114 3.665-5.856 3.674z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EFF5FA"
        d="M637.567 122.453c-4.143-1.433-8.299-2.83-12.41-4.342-.561-.205-1.137-.834-1.668-.506-3.572 2.204-7.475.852-11.211 1.043-3.279.168-6.289 2.089-9.666 1.313-.213.218-.422.217-.629-.004 1.135-1.699 3.166-1.919 4.789-2.357 7.168-1.936 14.537-2.157 21.611.058 3.194.998 7.293 1.012 9.184 4.795z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8F5F9"
        d="M641.313 170.514c1.816 2.012 5.217 2.427 5.691 5.879.104.746 2.303-1.204 2.416.982-2.045 2.35-3.373 5.479-6.85 6.262l-.354-.216c-.49-.809-1.137-1.451-2.01-1.854-.953-1.229-1.852-2.461-.256-3.855 2.527-.994 1.373-1.853-.111-2.7-1.715-2.222-.206-3.389 1.474-4.498z"
      />
      <path
        
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#382F60"
        d="M217.549 69.442c.673-1.174.998-2.454 1.144-3.788-.027-.545.335-.883.661-1.24l2.719-4.923c.08-1.079.355-2.005 1.661-2.126.649-.493 1.286-1.003 1.95-1.477 2.698-1.92 4.082-1.68 6.148 1.048.279 2.938.583 5.877-.647 8.704-1.427-.15-1.152-1.334-1.359-2.224-.049-1.344.126-2.7-.063-4.037-.291-2.051-1.214-2.452-2.969-1.314-1.724 1.117-2.639 2.898-3.609 4.609-2.013 3.552-3.439 7.285-3.64 11.438-.11 2.285.735 3.551 3.095 3.639.433.242.77.531.542 1.097a5.58 5.58 0 01-.126.506c-2.923 2.302-5.107 1.587-5.853-1.941-.123-.58-.542-1.125-.274-1.768l.035-2.917c.687-1.015-.354-2.338.592-3.305l-.007.019z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EBF5F8"
        d="M318.626 63.787c.623 2.339-1.605 2.114-2.55 2.314-2.61.554-4.118 3.014-6.797 3.465-.972.165-1.788 1.447-1.593 3.002.548 4.394-.013 4.908-4.649 4.958a1.672 1.672 0 01-.553-.764c-.198-.615-.231-1.252-.248-1.891a73.008 73.008 0 01-.024-2.387c.02-.976-.041-1.959.244-2.913.116-.32.31-.582.579-.788 3.928.085 7.134-2.268 10.702-3.372 1.59-.494 3.403-.686 4.889-1.624z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F8FCFA"
        d="M652.542 232.302c-2.293-.539-.906-2.607-1.566-3.871-1.34-2.562-1.447-5.674-3.428-7.988-1.152-1.709-1.965-3.494-1.238-5.619 1.561-.477 1.719-3.808 4.135-2.288 1.811 1.138.711 3.235.805 4.879.286 4.977 2.081 9.822 1.292 14.887z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F1F7F6"
        d="M223.733 57.365l-1.661 2.126c-3.211-3.842-3.419-8.582-3.907-13.223-.128-1.221-.021-2.466-.022-3.701.54-2.795.331-5.819 2.496-8.114-.273 3.115.692 6.324-1.12 9.346-.528.881-.528 2.533.354 3.548.786.905.892 1.894.74 2.892-.468 3.07.585 5.406 3.12 7.126z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EDF4F9"
        d="M652.534 137.437c-1.143-.006-2.285-.009-3.43-.019-.809-.007-1.566-.277-1.488-1.192.326-3.818-2.689-5.638-4.887-7.742-1.082-1.037-1.611-2.534-3.119-3.279-1.506-.745.063-1.438.445-2.118 5.256 3.83 8.938 9.028 12.479 14.35z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BFD7EC"
        d="M632.563 465.117c10.344-.256 20.594 1.016 30.855 2.002.83.08 3.588-.385 2.195 2.334l-.295-.006-.295.018c-1.203 1.027-2.586.85-3.984.613a4.13 4.13 0 01-.971-.361c-3.035-1.844-6.383-1.979-9.811-1.896-2.352.055-4.721.219-7.066-.209a3.985 3.985 0 01-.93-.367c-2.609-1.367-5.441-.348-8.145-.742-.512-.057-.986-.207-1.414-.496-.291-.259-.336-.554-.139-.89z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6EFE4"
        d="M286.201 53.798c-.486-3.206-.774-6.513-4.725-7.599-.542-.149-1.05-.65-1.437-1.105-1.872-2.2-.75-8.463 1.76-10.021 1.477 1.222 3.565-.062 5.025 1.227-.103.114-.206.227-.307.342-.45.273-.952.378-1.461.47-1.653.3-3.32.564-3.632 2.698-.321 2.192.394 4.019 2.379 4.912 3.033 1.365 3.928 4.028 4.74 6.831.174.6.184 1.221.054 1.84a3.402 3.402 0 01-.874 1.617 1.213 1.213 0 01-.859.245c-.574-.324-.989-.721-.663-1.457z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EFF7F9"
        d="M144.497 292.22c3.338-.561 4.541.428 5.037 4.821.241 2.131-1.137 4.537 1.128 6.441.399.338.163 1.594-.998 2.503-.844.661-.666 3.527-.018 5.006 1.352 3.087-.184 3.553-2.583 3.78-.661.062-1.321.771-1.939-.082 3.033-1.542 3.288-4.297 3.113-7.213-.191-3.175.445-6.317.105-9.53-.245-2.314-.165-4.345-3.058-4.815-.303-.05-.527-.595-.787-.911z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BFD7EC"
        d="M638.78 471.953l-6.207.057c-1.627 1.117-3.289 1.105-4.982.152-.682-1.234.061-1.75 1.074-2.129 3.303-.449 6.625-.158 9.941-.195 1.238-.014 2.506.148 3.6-.658.336-.188.691-.32 1.064-.416 5.809-.207 11.637-.969 17.367.697l.033.037c-.281 1.582-1.611 1.406-2.676 1.5-5.273.471-10.568.496-15.854.662-1.12.033-2.284-.305-3.36.293z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F1F6FA"
        d="M652.542 172.384c-.326-1.929.697-3.528 1.195-5.277 2.113-7.419 1.574-14.958.73-22.494-.08-.72-.039-1.454-.057-2.182 2.588 6.886 3.457 13.856 1.238 21.043-.754 2.447-1.271 4.969-1.816 7.475-.171.795-.39 1.376-1.29 1.435z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9F9FC"
        d="M123.277 312.189c-.088-.884-.549-1.773.045-2.646-.262-1.825-1.555-2.278-3.132-2.352-1.271-.28-2.542-.561-3.814-.84.339-.954 1.667.239 1.834-.828.03-.192-.764-.514-1.178-.774.365-.758 1.23-.805 1.801-1.271.245.184.666.566.71.525 2.915-2.597 3.82.51 5.137 1.922 1.167 1.251 1.997 2.819 2.975 4.246-.14.59-.619.9-1.031 1.271-.774.62-1.508 1.335-2.628 1.191a1.77 1.77 0 01-.719-.444z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C2D8EB"
        d="M103.313 471.285c-5.872.254-11.618-1.322-17.481-1.203-.885-.076-1.872.275-2.568-.605.027-.182.039-.365.036-.547-.337-.453-.339-.898.025-1.34 1.533-1.188 3.333-.395 4.989-.668 1.315 1.342 2.942 1.689 4.768 1.645 2.459-.061 4.924-.096 7.381.033 1.283.066 2.776-.074 3.222 1.682a1.602 1.602 0 01-.372 1.003z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BED7ED"
        d="M116.413 442.008c-1.93-.135-2.412-1.734-3.133-3.096-.251-.266-.257-.537-.019-.813 3.294.717 5.771-1.367 8.591-2.391 2.862-1.037 6.889 2.783 6.731 6.094-1.993.977-2.675-1.379-4.182-1.639-1.75-1.209-3.44-.52-4.944.395-.984.598-2.055.921-3.044 1.45z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9FCFA"
        d="M639.434 197.352c-.463-.784-.854-1.618-1.395-2.342-1.834-2.455-2.293-4.962-.465-7.625-.34-1.194.004-1.788 1.336-1.531 1.258.318 2.346-1.077 3.641-.364 0 1.141-.055 2.286.014 3.423.102 1.7-.736 2.813-2.225 3.313-1.682.566-1.188-1.589-2.381-2.127-.998 2.815 2.172 4.687 1.475 7.253z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6FCFC"
        d="M632.571 427.031l-.004-1.248c.621-1.383.994-2.895 2.078-4.043 1.125-2.229 3.277-3.93 3.4-6.668.041-.602.127-1.193.338-1.762.381-.656.643-1.477 1.678-1.256 1.207 3.57.199 6.717-1.883 9.639-.65.914-1.383 1.438-1.281 3.033.08 1.253-2.572 1.973-4.326 2.305z"
      />
      <path
      className="audio-altavoz"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#262431"
        d="M214.503 55.384c-2.929-4.668-6.01-9.231-9.4-13.581l.094-1.045c.975-.419 1.504.116 2.013.863 3.243 4.764 6.506 9.514 9.765 14.266.63.918 1.296 1.834-.499 2.199-1.009-.644-1.625-1.575-1.973-2.702z"
      />
      <path
      className="audio-altavoz"

        fillRule="evenodd"
        clipRule="evenodd"
        fill="#242231"
        d="M208.847 61.719l-.688-.339c-3.897-1.903-7.806-3.782-11.682-5.728-.716-.358-2.235-.44-1.552-1.736.49-.931 1.465-.019 2.193.237.772.271 1.526.599 2.289.902 3.795 2.17 7.738 4.03 11.8 5.642.859.763 3.438-.222 2.457 2.416-1.121.541-1.974-.494-3-.51-.856.221-1.364-.274-1.817-.884z"
      />
      <path
      className="audio-altavoz"

        fillRule="evenodd"
        clipRule="evenodd"
        fill="#272531"
        d="M212.239 68.268c.645 1.02.606 1.685-.819 1.821-1.099.105-2.258-.154-3.283.47-4.416.268-8.83.569-13.249.778-.927.044-2.523.707-2.667-.471-.184-1.516 1.526-.877 2.393-.983 3.674-.449 7.366-.765 11.05-1.129 2.169.068 4.332.048 6.455-.492l.12.006z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5FDFE"
        d="M645.051 398.32c1.648-2.328 2.201-5.117 3.275-7.688.506-1.209.531-2.664 1.713-3.547.623 2.09-.711 3.818-1.348 5.533-1.467 3.951-2.73 7.795-2.566 12.127.041 1.072-1.578 2.742-3.572 2.313-.359-.398-.42-.863-.318-1.369.787-1.549.953-3.273 1.354-4.928.236-.978.294-2.034 1.462-2.441z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#569FC9"
        d="M662.438 263.973c-3.762 4.407-8.256 6.529-14.059 4.463-.555-.199-1.021-.654-1.529-.99a1.33 1.33 0 01-.234-.86c.475-1.166 1.332-.566 2.068-.43 2.004.37 4.014.607 6.045.271 1.932-.828 3.961-1.48 4.883-3.701.393-.952 1.33-1.145 2.316-.976.297.09.555.244.773.46.223.449.199.886-.07 1.308a.662.662 0 00-.193.455z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EEF3FC"
        d="M642.553 405.814v1.244l-2.492 4.996c-.416.414-.83.83-1.246 1.246-1.867-.313-2.959-1.207-2.904-3.307.051-1.998 1.195-3.123 2.854-3.574 1.204-.327 2.362-1.536 3.788-.605z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EEF7F9"
        d="M522.096 76.271c-1.961.138-3.73-.234-5.547-1.159-2.117-1.075-4.061-2.614-6.656-2.758-1.025-.057-1.93-1.083-2.148-2.328 5.056 1.459 10.127 2.877 14.351 6.245z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C0DBEB"
        d="M661.907 342.166c.207.002.414-.004.621-.016.625 2.51-.32 3.619-2.594 2.959-1.332-.387-2.516-1.146-2.971-2.518-.504-1.512-1.617-2.045-2.998-2.328a1.908 1.908 0 01-.814-.617c-.311-2.172.846-2.566 2.736-2.537 1.762.025 2.461.664 2.289 2.387-.176 1.783.568 2.771 2.461 2.682.432.592.854.592 1.27-.012z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F2F6FB"
        d="M660.032 272.25l.625-.627c.209-.293.414-.293.621 0 .115 5.224 1.676 10.334 1.244 15.604-1.914-4.814-3.111-9.743-2.49-14.977z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8F2F8"
        d="M646.309 214.824c.414 1.873.826 3.746 1.238 5.619-2.658-.875-.121 1.732-1.258 1.879-1.055.604-1.695-.06-1.787-.907-.24-2.195-.809-4.36-.693-6.593.541.178 1.217.559 1.219-.474.004-1.05.453-1.163 1.271-.769.002.416.006.83.01 1.245z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F1FBFC"
        d="M110.836 436.373c-1.875-1.736-2.256-3.221.412-4.686 2.101-1.152 3.161-3.373 4.515-5.262l.432-.123c1.914 1.361 1.377 2.701-.034 4.033-.92.592-1.787 1.264-2.634 1.961-.436.305-.896.574-1.296.93-1.207.721-.683 2.21-1.395 3.147z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5F4F7"
        d="M636.311 82.514l11.236-.001c-3.574 2.49-8.916 2.49-11.236.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7DAC3"
        d="M233.112 83.757c.103-1.754-.412-3.667 1.284-5.012 3.014-.931 3.376-.68 3.261 2.248-.833 1.936-2.484 2.872-4.357 3.531-.334-.188-.398-.444-.188-.767z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E7F6FB"
        d="M123.277 312.189c.223.008.444.017.667.027 1.417 1.466 2.423 3.019 1.078 5.074-.302.373-.667.67-1.097.883-.569.242-1.167.293-1.774.236-2.539-.926-2.26 1.52-3.114 2.613-.275.158-.524.117-.751-.094-.001-.412-.02-.826-.002-1.238.208-4.97.939-4.12 4.68-2.945.631-1.484.173-3.046.313-4.556z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E9F7FC"
        d="M665.024 378.348c-1.326-.314-2.258 1.855-3.736.598 1.543-1.613 3.047-3.133 2.604-5.773-.209-1.244.98-2.182 2.184-2.732a2.618 2.618 0 011.383.01c.684.355 1.543.578 1.307 1.656-1.012-.008-2.016-.035-2.93.553-.465.297-.838.652-.686 1.201.686 2.461.704 2.457-.126 4.487z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C0DAEF"
        d="M668.764 372.105c-.416-.412-.836-.824-1.252-1.24.254-.369.629-.568 1.027-.734 2.234-.338.691-1.953.992-2.943.105-.27.264-.502.484-.697.877.33 1.424 1.301 2.48 1.279.273 2.751-.436 4.658-3.731 4.335z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F2F5F8"
        d="M93.318 164.896c0 1.719-.102 3.446.028 5.155.149 1.955-.77 2.536-2.516 2.337 1.192-2.376.464-5.391 2.488-7.492z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F3F6F5"
        d="M489.645 62.536c-1.514.001-3.039-.098-4.543.028-1.959.164-2.523-.781-2.326-2.518 2.445.399 4.887.81 6.869 2.49z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F0F3F2"
        d="M595.747 62.538l-11.24-.001c3.747-2.183 7.493-1.588 11.24.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F4F8FB"
        d="M608.848 72.527c-2.102-2.268-5.061-3.761-6.236-6.869 3.099 1.364 5.347 3.498 6.236 6.869z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6EFE4"
        d="M286.825 36.3c4.246.374 6.14 3.03 6.246 8.755l-.059.01c-.949.186-1.408-.523-1.524-1.17-.525-2.933-2.299-4.956-4.544-6.696-.241-.186-.24-.542-.157-.852l.038-.047z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F1F4FA"
        d="M133.263 284.729c2.71-.145 5.124.105 4.994 3.746-2.002-.799-3.969-1.642-4.994-3.746z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C8DAEE"
        d="M110.836 436.373c-.68-1.588-.669-2.955 1.197-3.725 1.849 1.545 2.714 3.314 1.271 5.607l-.025.656c-.815-.845-1.628-1.69-2.443-2.538z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F0F3F2"
        d="M601.983 119.956l.629.004c.084 4.342-3.273 1.785-5.002 2.493.848-1.904 2.834-1.806 4.373-2.497z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F2F7FB"
        d="M631.323 491.938c-2.318-2-2.004-4.877-2.5-7.488 1.801 2.175 2.594 4.683 2.5 7.488z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5F5F5"
        d="M586.377 122.458c-3.049.552-4.291-.7-3.74-3.745 1.196 1.3 3.389 1.602 3.74 3.745z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C2C0C8"
        d="M118.833 303.479c.033 1.321-.911 1.26-1.801 1.271-.39-.445-.979-.837-1.121-1.35-.188-.683-.94-1.628.112-2.161 1.051-.53 1.313.533 1.776 1.155.295.397.686.727 1.034 1.085z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EDD3E6"
        d="M236.894 81.253c1.096-2.756-.764-2.568-2.498-2.507l-.02-.627c1.847-1.169 3.484-.776 4.982.664-.957.688-.478 2.808-2.464 2.47z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EEF7F9"
        d="M507.745 70.026c-2.188.216-3.771-.781-4.994-2.496 2.111-.061 3.847.627 4.994 2.496z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F4F8F6"
        d="M661.278 271.623h-.622c-.449-1.705-2.076-3.741 1.238-4.379.42 1.26.42 1.26-.734 1.853-.474.244-.474.244.118 2.526z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BCBBBE"
        d="M118.015 288.38c-.447.778-.259 2.104-1.483 2.413-.631.16-.854-.492-.752-1.029.19-.999.343-2.133 1.516-2.449.557-.151.912.332.719 1.065z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B9B8B9"
        d="M121.482 282.156c-.571.762-.61 2.15-1.899 2.386-.651.117-.786-.605-.565-1.076.454-.963.615-2.266 1.963-2.445.68-.088.764.466.501 1.135z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B7B6C0"
        d="M120.189 307.191c1.596-1.551 2.554.14 3.578.828.831.559.416 1.215-.446 1.525l-3.132-2.353z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F1F4FA"
        d="M138.257 288.474c1.904.659 4.403.363 4.993 3.123-1.851-.743-3.696-1.495-4.993-3.123z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F3F3F3"
        d="M129.519 282.233c1.71.139 4.144-.805 3.744 2.499-1.536-.402-2.82-1.181-3.744-2.499z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F2F2EC"
        d="M642.551 185.49c-1.277.045-2.221 2.016-3.742.642-.404-.522-.35-1.021.072-1.505 1.275-.751 2.498-.686 3.66.242.006.207.008.414.01.621z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ABB0C0"
        d="M126.466 310.972c.197-.563.689-.685 1.188-.8l.613.051c1.116.268 2.013.813 2.444 1.943-1.815 1.028-3.171.421-4.245-1.194z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ADADB0"
        d="M115.056 293.792c1.064 1.651.86 2.733.295 4.137-1.302-1.249-.964-2.381-.295-4.137z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7FCFB"
        d="M627.575 481.33c-1.393-1.135-2.514-2.428-2.5-4.367.972 1.377 2.691 2.324 2.5 4.367z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8F5F9"
        d="M642.542 184.869l-3.719.011c-.291-1.167.826-1.102 1.354-1.557.227-.138.465-.251.711-.356.779-.363 1.264.04 1.664.65 0 0 .018.02.02.02-.013.411-.021.822-.03 1.232z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FDFAEF"
        d="M303.034 68.782l-.023.659c-2.479-.577-2.194-2.064-1.245-3.772l.03-.02c.817.884.967 2.033 1.238 3.133z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A49FBA"
        d="M233.031 86.262l.089-1.253c.651-.302 1.132.026 1.595.427.513.602.846 1.246.448 2.047-.249.207-.51.231-.783.042l-1.224-.719a2 2 0 00-.125-.544z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F2F7FB"
        d="M628.823 484.449c-.813-.635-1.148-1.506-1.244-2.498 1.664.209 1.129 1.518 1.244 2.498z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF8F8"
        d="M118.285 320.93l.646-.008c.36-.354.781-.396 1.241-.246.523.367.923.787.614 1.496l-.044.045c-.959-.162-1.839-.475-2.457-1.287z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B6D8F7"
        d="M655.042 377.117l-.012 2.48c-3.174.891-4.264.34-5-2.744-.32-1.35-1.309-1.885-2.377-2.064-1.623-.271-2.363.824-2.613 2.303l.004-.004c-.865-.072-1.836.326-2.514-.566-1.023-1.365-1.16-2.854-.613-4.434a7.47 7.47 0 01.014-.598c.258-2.555-1.523-2.701-3.332-2.828-3.16-.223-3.537-.893-2.301-4.072 1.527-2.857.943-4.465-2.057-4.92-1.662-.252-1.67-1.182-1.67-2.383 0-1.352.201-2.389 1.887-2.666 3.938-.656 4.395-1.965 1.813-5.061-1.197-1.436-.256-2.531.426-3.627.809-1.301 1.799-1.189 2.748-.076 3.252 1.178 4.377.643 5.234-2.488.107-.4.162-.813.23-1.221.205-1.203 1.057-1.895 2.141-1.887 1.305.014 1.045 1.285 1.254 2.133-1.039 3.74-2.434 7.35-3.893 11.156.316.564 1.385.293 1.945.916-1.016 2.857-.885 5.574.455 8.387.664 1.4 1.258 2.27 2.867 2.211.932-.035 1.867.033 2.742.42 2.906 1.324 5.59 1.293 7.99-1.127.52-.523 1.338-.496 2.078-.457.465.041.9.166 1.311.387 1.152 1.268 2.783 1.883 4.059 2.984.359.807.324 1.586-.176 2.326-2.4 1.139-4.881 2.178-4.424 5.623.105.785-.139 1.721-1.041 2.064-.977.373-1.438-.582-2.074-1.025-.498-.348-.834-.904-1.354-1.244-1.509.231-3.394-.202-3.747 2.102z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E9F2F9"
        d="M291.787 137.425c-.006 2.348.253 4.579-1.912 6.523-1.433 1.286-.199 3.935-1.602 5.739-.423.544 1.137 1.115 1.547.719 2.097-2.018 4.367-.447 6.52-.456 15.974-.062 31.947-.033 47.919-.033 5.395 0 10.787.062 16.181-.034 1.858-.033 2.767.52 2.503 2.459-.746.931-1.82.928-2.852.928-23.878.004-47.757.109-71.635-.049-.205-.001-.41-.063-.61-.095-2.096-.814-1.492-2.978-2.23-4.474.542-3.609 1.679-7.229-.173-10.804-.141-.93-.497-1.821-.523-2.773a2.536 2.536 0 01.328-1.298c1.865-1.559 2.168.543 3.047 1.304.136.419.098.797-.246 1.108.132 1.929-.291 3.892.326 5.969 2.122-1.049-.501-4.135 2.174-4.726.41-.368.823-.365 1.238-.007z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5616CC"
        d="M290 95.001l-1.779 2.498c-3.479 2.588-3.642 6.201-3.088 10.032-.006.837-.078 1.663-.413 2.443-1.331 1.664-.493 3.794-1.188 5.594-.485.892-.878 1.832-1.355 2.731-.354.669-.768.114-1.151.137 1.057 3.289-.901 7.259 2.282 10.066.511 1.617 1.039 3.229 1.288 4.914-.815.43-.661 1.735-1.738 1.936-2.99-1.755-5.185.739-7.326 1.52 1.122.254 3.113-1.105 4.054 1.209-1.705 2.594-4.35 1.01-6.533 1.484-4.335-.107-8.675.181-13.005-.164-1.525-.485-3.018-1.068-4.509-1.657-.482-.516-1.094-1.007-.371-1.776 2.585-.455 5.173.239 7.758-.012 3.078.26 5.993-.332 8.762-1.684 4.544-1.574 6.646-4.757 6.12-9.536-.486-4.412 1.326-8.563 1.302-12.928-.016-2.918-.255-5.801-.888-8.624-.595-2.647.082-4.683 2.216-6.279 1.476-1.103 2.333-2.952 4.242-3.526 1.544-.159 2.643 2.202 4.421.791.476.088.609.544.899.831z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF3FA"
        d="M602.61 231.055v1.249c-.473.474-.617 1.064-.602 1.709.211 8.402-.197 16.803-.01 25.205.045 1.987-.24 3.675-2.182 4.776-.803.456.248.37.352.602.859 1.623 2.133.945 3.471.847 1.49-.111 3.838-1.339 3.963 1.811v.002c-.977 1.01-2.463.646-3.564 1.328-1.064.53-2.201.744-3.381.749-1.83-.081-3.656.173-5.486.038-.934-.537-2.156-1.649-1.574-2.318 1.453-1.665.186-3.776 1.336-5.351.496-.726.545-1.549.547-2.383.027-8.069.033-16.14 0-24.209-.004-.839-.117-1.65-.566-2.382-.209-.499-.25-1.005-.063-1.519 1.631-1.559 4.018-.642 5.785-1.76.863 0 1.367.552 1.816 1.189.054.137.105.278.158.417z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F53C51"
        d="M600.01 287.175c-1.197 0-2.398-.002-3.596-.004-.855-.471-1.885-.368-2.744-.834-1.031-.555-2.047-1.128-2.639-2.208a2.778 2.778 0 01-.186-.877c.021-.465.16-.88.488-1.22a2.083 2.083 0 011.123-.353c.377-.007.721.18 1.096.186-.799-.361-1.102-1.168-1.607-1.79-.217.316-.178.746-.477 1.035-.424.259-.859.273-1.309.104-.564-.363-.873-.913-1.115-1.512a5.307 5.307 0 01-.297-1.423c-.148-1.646.305-3.196.734-4.751.285-.769.76-1.365 1.527-1.694.697-.231 1.352-.197 1.943.297-.152-.563-.965-.96-.564-1.73.189-.435.488-.771.9-1.005a2.39 2.39 0 011.369-.17c.711.396 1.498-.162 2.217.17.932.436.873 1.315.795 2.271.996-.663-.447-1.784.697-2.237 1.242-.497 2.518-.278 3.789-.199.322.088.613.237.877.44 3.268 2.922 4.889 6.431 3.854 10.878-.244.71-.832 1.236-1.045 1.966-.35.967-1.045 1.735-1.5 2.643-.929 1.778-2.816 1.497-4.33 2.017z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8F2F9"
        d="M505.729 152.488l1.426-.294c-.492-1.288-.473-2.986-2.561-2.931 1.176-1.681 2.516-1.38 4.174-1.086 4.369.773 8.76-.362 13.16-.347 1.033.004 2.152-1.282 2.02-2.745-.229-2.516 1.881-3.229 3.316-4.473.691.741 1.057 1.661 1.441 2.573.34 1.681-1.025 2.467-1.846 3.539-.539 1.551.564 2.164 1.607 2.808.615.468 1.162.984 1.342 1.778-.377 1.674-1.715 2.248-3.131 2.743a3.26 3.26 0 01-1.051-.069c-6.268-.32-12.549.261-18.813-.309-.557-.216-1.018-.521-1.084-1.187z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#247FC1"
        d="M625.624 295.411l.48 1.739c-.096.772-.291 1.531-.275 2.318 0 .813 0 1.626.049 2.439.041.692.195 1.382.072 2.081-.307.824-1.086 1.196-1.67 1.757-.965.615-.188 2.04-1.211 2.629-.48.178-1.182.65-1.406.483-1.381-1.024-2.408-1.513-3.193.667-.244.681-1.314.255-2.018.118-.174-.107-.365-.325-.521-.302-2.676.404-3.951-1.134-4.742-3.365-1.186-.485-1.855-1.324-1.824-2.648a25.198 25.198 0 01-.045-1.761c.002-.735.008-1.474.146-2.201.068-.282.189-.545.348-.791 1.424-.766 1.408-2.325 1.949-3.577.127-.561.27-1.112.611-1.589.529-.521 1.207-.706 1.908-.846 1.107.133 1.623-1.005 2.572-1.208.703.006 1.357.23 2.018.447 1.174.624 2.561-.576 3.688.425l.525 1.703c-.151 2.203 2.134.228 2.539 1.482z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E9F2F9"
        d="M402.263 147.421c-.873 1.365-.828 2.3 1.098 2.369 1.033.038 2.064.121 3.098.122 11.188.01 22.38.032 33.569-.02 1.807-.008 3.137.187 2.803 2.457-.941 1.095-2.244.926-3.461.93-11.887.027-23.771.047-35.657-.006-3.512-.015-4.092-.587-3.896-3.361 1.375-1.881-.852-2.149-1.416-3.161-.264-.444-.209-.845.16-1.205 1.461-.121 1.461-.121.723-2.496 2.326-.719 2.799.335 2.381 2.399-.14.689-.111 1.471.598 1.972z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B6B7D1"
        d="M399.816 149.912c.148 1.941 1.201 2.561 3.115 2.548 13.3-.087 26.601-.084 39.899-.11l1.254-.008c1.461-.994 2.924-1.073 4.387 0 .197.026.396.048.598.067.186.429.084.768-.314 1.017-.359.2-.742.329-1.146.395-21.535.23-43.075.031-64.612.108-6.279-.021-12.556-.011-18.838 0-25.121-.023-50.242.001-75.364-.013-1.555-.001-3.115.094-4.657-.146a2.542 2.542 0 01-.995-.473c-.562-.932-.114-1.602.584-2.203.814-.262 1.335.471 2.038.601.395.134.751.332 1.035.646l76.145.001 19.971.007c3.744-1.423 7.488-1.416 11.234-.008 1.777-.257 4.791 1.517 4.207-2.667-.068-.461.994-.211 1.459.238z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#44A3E4"
        d="M631.35 239.668c.018.604.033 1.209.051 1.813 1.148 2.325.643 4.762.504 7.175-.201.897-.596 1.563-1.682 1.359-1.316-1.082-.842-2.604-.961-3.976-.148-1.694.293-3.442-.42-5.134-.895.214-.619 1.228-1.207 1.596-.693.488-1.479.576-2.295.546a3.21 3.21 0 01-1.352-.383c-1.615-1.67-.582-3.438-.111-5.162-.748-.574-1.139.284-1.701.324-1.068.309-2.125.363-3.146-.17-.713-.567-.541-1.23.102-2.163-4.281.986-7.939 2.305-10.387 5.825-.498.128-.947.053-1.326-.319-.15-.5-.076-.982.109-1.457 2.797-6.075 10.293-8.952 16.686-6.363 1.141.461 2.209 1.091 3.314 1.643 1.953 1.08 3.232 2.691 3.822 4.846z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BAD7F2"
        d="M626.323 365.885c.414 1.07 1.48 1.432 2.332 1.906 2.535 1.41 2.227 2.801.191 4.338-.115-.086-.232-.178-.352-.262-2.088-3.141-2.088-3.141-4.234-.32-.123.164-.227.49-.359.484-2.57-.141-5.127 1.541-7.563.607-1.904-.729-3.934-1.926-4.451-4.338-.309-1.436-1.006-2.729-1.447-4.113-.299-.93-1.049-1.246-1.984-1.098-.877.139-1.174.789-1.242 1.568-.211 2.455-.41 4.902-3.658 5.225-.203.02-.219.199-.344.387-1.658 2.459-1.666 2.455-3.229-.307a2.031 2.031 0 01-.16-.9c.287-.709.434-1.592 1.557-1.283 1.207.301 2.176.139 2.469-1.293.426-2.068.842-4.139 1.264-6.207.807-.547 1.787-.523 2.666-.627 4.084-.482 6.117 1.189 6.242 5.264.055 1.854.486 3.248 2.326 3.857 1.857.613 3.373.221 4.607-1.475 1.345-1.845 2.927-3.433 5.369-1.413z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BAD7F2"
        d="M628.846 372.129c.369 1.85-2.436 3.215-.553 5.445 1.957 2.318 3.799 3.15 6.742 1.789 3.061-1.42 3.639-.814 5.604 3.348 1.219 2.584.162 3.936-2.098 4.805-2.945 1.135-3.701 3.037-2.254 5.828.484 1.682 1.516 2.412 3.332 2.219 1.305-.141 2.676-.039 3.342 1.465.092.525.006 1.008-.309 1.443-3.918 1.367-6.674.773-7.982-1.715-2.648-5.037-2.232-9.27 1.172-11.68.676-.479 1.525-.816 1.512-1.811-.014-.887-.725-1.18-1.441-1.406-.943-.297-1.568-.117-1.836.988-.17.715-.83.771-1.518.688-3.914-.473-7.904-6.236-6.924-10.045.465-1.797 1.443-2.482 3.182-1.389l.029.028z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E4F6FC"
        d="M622.559 292.228c-1.291-.737-2.621 2.287-3.898-.04-.486-.623-1.135-.605-1.816-.471-.553.864-1.016 1.899-2.361 1.209-.709-.028-1.498-.305-1.896.618-.029.534-.063 1.069-.092 1.604-1.012 1.112-2.389.821-3.658.954.074-.895-1.221-.569-1.234-1.387-1.266-2.483-3.822-4.325-3.744-7.483a10.994 10.994 0 013.75-3.75c1.705-.44 2.889.867 4.188 1.48 1.273.602 1.168 1.782-.449 2.266-1.832.663-3.078 1.908-3.74 3.739.506 1.814 2.592 1.818 3.078 1.209 1.322-1.656 3.242-1.953 4.834-2.916 3.662-2.208 4.793-1.806 6.646 2.129.13.281.259.558.392.839z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DEF7FD"
        d="M630.069 257.269c-2.873-.156-4.285 3.067-7.096 3.078-.172 0-.381.357-.506.321-3.959-1.157-8.443 1.583-12.195-2.347-2.777-2.906-5.229-5.568-5.168-9.789-.895-2.082-1.004-4.163.002-6.245.883-.509-.656-1.556.418-1.942.188-.066.588.458.889.71.787.873.563 1.87.377 2.877-.377 2.039-.193 4.03.588 5.956.832 3.191 2.924 5.354 5.699 6.958 6.789 3.757 16.24.891 18.83-8.798.307-1.918-.43-3.872.217-5.774 2.359 2.796 3.127 7.326 1.693 10-1.272 1.651-2.649 3.218-3.748 4.995z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5EAF8"
        d="M643.809 214.822c.932 1.586 1.51 3.232 1.275 5.138-.117.952-.303 2.146 1.205 2.362l.008.617c.941 1.514-.752 1.302-1.232 1.884-.813 1.993-2.426 3.382-3.76 4.982-.52.479-1.135.271-1.727.242-.607-.55-.244-1.07.037-1.597.768-1.03 1.811-1.817 2.541-2.88 1.004-1.759 1.828-3.549 1.203-5.649-.264-1.029-.404-2.113-1.285-2.87-1.383-1.218-2.582-2.723-4.654-2.778-3.754-.93-6.184.894-8.051 3.874-.93 1.85-.727 3.76-.307 5.681.395 2.492 2.021 3.937 4.189 4.921 1.83.583 3.893-.29 5.623.906.277.482.285.95-.074 1.397-1.707-.15-3.357.132-4.982.624l-3.744-1.873c-.916-.611-1.666-1.348-1.875-2.49-.795-.879-2.002-1.517-1.861-2.96.189-1.97-1.033-2.147-2.51-2.036-.619-.832-.76-1.663.006-2.491 2.316.279 3.453-.205 4.061-3.021.789-3.667 8.283-6.106 11.818-3.951 1.346.823 3.61-.353 4.096 1.968z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#277FBE"
        d="M641.313 170.514c.002 1.544-2.773 2.316-1.195 4.298.551.956 1.5 1.913-.008 2.862-.465.171-.914.145-1.346-.096-1.248-1.63-1.168-4.315-3.828-4.833-1.955-1.846-4.285-2.393-6.889-1.974-1.701.172-2.664 1.878-4.346 2.096-1.244-.04-2.012-.79-2.631-1.767-.135-.494-.082-.943.313-1.31l1.346-.532c.795-1.857 2.021-2.994 4.213-2.495.441-.222.883-.444 1.326-.665.588-2.355 2.008-.822 3.135-.683 1.01.347 2.064.353 3.115.407 1.027.351.768 1.999 2.086 2.061.896 1.623 2.779.676 3.971 1.523l.738 1.108z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E7F6F9"
        d="M288.046 134.938c-.378.017-1.131.631-1.04-.165.165-1.436-.763-.99-1.425-1.089-.733-4.135-2.979-8.047-1.247-12.527 1.001-2.588-.62-5.564.634-8.245 1.182-1.805 1.427-3.647.195-5.544-.169-.662-.138-1.276.423-1.761 1.253-.485 1.125-1.838 1.484-2.772 1.183.135.966.898.959 1.442-.109 8.686.307 17.377-.372 26.056-.054.689.253 1.407.392 2.111.62.833.76 1.664-.003 2.494z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E6F5FD"
        d="M643.805 277.232c.074-1.188-2.016-1.793-.82-3.351 2.363.913 4.605 1.619 4.854 4.995.09 1.224.68 3.744 3.451 3.459 1.521-.156 1.625 1.729 1.063 2.238-2.127 1.918-3.084 4.776-5.232 6.53-2.414 1.973-3.396-.027-4.092-2.07a.788.788 0 01.139-.753c.213-.163.449-.287.699-.377.889-.216 1.717-.547 2.326-1.277.949-1.469.729-2.883-.178-4.268-.106-1.977-2.067-3.16-2.21-5.126z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E64251"
        d="M635.024 287.275c-2.26-3.179-2.117-4.922.711-8.65.324-.478.836-.587 1.348-.698 1.736-.288 3.422.402 5.15.262 2.178.106 2.584 1.957 3.375 3.429.162 1.181.373 2.362.117 3.558-.18.839-.504 1.603-1.129 2.214-.58.386-1.201.435-1.852.225-.805-.415-1.563-.902-2.188-1.576-.086-.3-.061-.597-.004-.9.152-.822 1.18-1.654.092-2.465-.498-.372-1.182-.342-1.779-.154-1.295.409-.715 1.498-.809 2.341a3.5 3.5 0 01-.105.601c-.568 1.26-2.724-.041-2.927 1.813z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E6F6FE"
        d="M600.114 264.758c-.293.088-.637.107-.873.276-.617.435-1.25 1.579-1.926.413-.385-.666.266-1.635 1.191-1.847 2.602-.595 2.902-2.435 2.881-4.697a1531.75 1531.75 0 01.002-23.58c.01-1.09-.682-2.628 1.221-3.02.598 2.884 2.117 5.704.625 8.737-.955.813-.604 1.923-.611 2.918-.031 4.772.076 9.547-.057 14.318-.055 1.925.301 3.626 1.291 5.232-.842 1.633-1.979 2.387-3.744 1.25z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#222250"
        d="M467.18 140.606l1.555-.119a24.79 24.79 0 017.516.004c10.529 1.395 19.984 5.395 28.475 11.737.252.612-.109.896-.598 1.113-.682.13-1.305-.084-1.922-.333-2.4-1.011-4.672-2.296-6.838-3.71-7.289-4.762-15.49-6.194-23.93-6.848-1.164-.398-2.412.137-3.574-.314-.555-.364-.918-.813-.684-1.53z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E4F5FC"
        d="M642.571 397.027c-1.182-.854-2.623-1.096-3.957-1.115-1.916-.031-2.52-.83-2.326-2.568.404.338 1.186-1.85 1.096-.021-.107 2.141 1.014 2.094 2.201 1.699 3.221-1.064 4.334 1.07 5.467 3.299-.414 1.758-.91 3.5-1.207 5.277-.158.965-.33 1.779-1.291 2.217-1.443.111-2.441 1.373-4.023 1.389-.949.008-1.967 1.486-1.838 2.17.178.953-.715 2.953 1.596 2.908.168-.004.352.662.527 1.02-.004.625-.006 1.25-.008 1.875-5.133-1.281-6.738-4.801-4.193-9.105.727-1.221 1.838-1.553 3.123-1.68 1.324-.127 2.699.209 3.965-.404.893-2.248 1.934-4.47.868-6.961z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E4F5FD"
        d="M626.323 365.885c-1.82-.777-3.273-.732-4.283 1.363-1.508 3.137-3.836 3.297-6.838 1.928-1.52-.693-1.959-1.465-2.006-2.979-.178-5.58-.447-5.799-6.225-5.934-.617-.016-1.238.008-1.859.016 1.107-.68 2.014-1.697 3.398-1.896 3.066-.441 6.371 2.465 6.559 5.887.068 1.252-.139 2.912 1.174 3.201 1.234.271 2.703.047 4.01-1.031 1.728-1.426 3.8-3.276 6.07-.555z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF3FA"
        d="M609.282 220.981c1.637.013 2.795.859 3.182 2.362.389 1.523-1.248 1.249-1.973 1.806-.561.428-1.383.987-1.428 1.541-.338 4.232-3.975 3.418-6.453 4.365-.709-.424-.332-1.654-1.367-1.833-.67.058-1.375.171-1.402-.846.498-1.311 1.809-1.686 2.791-2.44 2.941-.34 4.803-2.035 5.893-4.699.198-.239.456-.316.757-.256z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2A7FBC"
        d="M638.805 177.376l1.236.002c.223.132.305.275.244.429-.061.158-.125.238-.195.238-1.152 1.539.414 2.453.834 3.63.324.706.248 1.334-.361 1.858l.055-.036c-2.633-.045-3.094 2.308-4.273 3.868l-1.178.545c-.924-.567-1.971-.95-2.727-1.771.504-1.229-.82-2.028-.752-3.16.221-1.304 1.652-1.373 2.281-2.262.742-.868 1.344-1.843 2.094-2.708.768-.836 1.57-1.543 2.742-.633z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E9F2F9"
        d="M394.148 152.343l-11.234.008c-.262-1.537-1.484-1.1-2.449-1.183-1.084-.095-2.255.279-3.24-1.25h11.047c4.748 0 5.465-.765 4.973-5.468-.07-.695-.596-1.406.338-1.857.258-.123.709-.203.887-.066.92.717-.383 1.061-.352 1.757.124 2.681.038 5.372.03 8.059z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5618D1"
        d="M289.313 94.369c-1.688 2.278-2.833 1.414-3.771-.649-.794-1.131-.024-1.91.607-2.721.728-.623 1.486-1.219 1.985-2.065.912-1.164 1.872-2.292 2.633-3.571.956-.288 1.723.134 2.471.643.573.518 1.151 1.032 1.476 1.76.253.821.047 1.56-.411 2.252l-2.009 2.395c-.94.735-1.76 1.651-2.981 1.956z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#262456"
        d="M594.438 287.852c1.721 6.646 3.441 13.293 5.164 19.939.314.404.281.823.047 1.249-2.24.364-2.869-1.603-4.039-2.785-.291-.747-.404-1.549-.66-2.306a1.02 1.02 0 01.18-.709c.326-.406.316-.861.17-1.339-.078-.832.238-1.752-.578-2.408-.316-.661-.391-1.376-.506-2.08-.32-1.163-.539-2.353-.92-3.499-.25-2.165-1.771-4.127-1.049-6.45.277-.473.709-.618 1.227-.591.528.12.804.494.964.979z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#25284E"
        d="M601.379 367.779c-.406.432-.814.863-1.221 1.297-.67-.51-.793-1.262-.898-2.02-.08-1.691-.141-3.385.309-5.045 1.721-4.488 2.297-9.146 2.191-13.932-.084-3.813-.016-7.629-.023-11.441.354-1.721-.859-3.865 1.363-5.084 1.004 9.383 1.184 18.748-.484 28.084-.746.986.021 2.23-.555 3.246-.9 1.538-.896 3.2-.682 4.895z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECE7FA"
        d="M285.555 112.464c-1.097 3.687 1.216 7.698-1.152 11.327-.466.715-.357 2.084.292 2.975 1.576 2.165.533 4.622.885 6.917l-.048 1.305c-.37.155-.661.062-.872-.279-.468-3.548-1.872-6.899-2.225-10.473a9.457 9.457 0 01.005-3.729c.975-3.433.4-7.123 1.732-10.496l.168-2.211c.873-1.273-.633-3.185 1.133-4.218l.112 2.025-.021 1.875c.891 1.662.9 3.324-.009 4.982z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E9F8F2"
        d="M595.116 167.396c1.148-1.333-1.145-3.21 1.254-4.801v7.747c0 3.203.092 6.408-.035 9.605-.076 1.942.684 2.659 2.529 2.418l.008.009c-.207.403-.416.805-.625 1.208-.303.896-1.404 1.063-1.758 1.925-.27.154-.545.178-.84.095-.627-.279-1.006-.78-1.287-1.378-1.914-3.865-1.717-7.789-.65-11.998 1.521.659.924 1.796 1.117 2.607.195-2.512-1.618-5.013.287-7.437z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#529FD1"
        d="M656.295 247.19c2.258 1.299 4.75 2.33 5.771 5.042-.48.579-1.1.609-1.77.447-.746-.284-1.254-.907-1.889-1.347-1.646-1.06-3.344-1.792-5.371-2.061-3.926-.519-5.912 2.165-8.232 4.416-.676.658-1.084 1.939-2.432 1.054-.143-.464-.135-.911.145-1.328l.029-1.139c.463-.239.658-.643.697-1.143 2.283-4.633 8.621-6.547 13.052-3.941z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1F7EC9"
        d="M621.336 171.144l2.568 1.274c.203.231.473.518.396.791-1.016 3.617.59 6.484 2.592 9.25.188 1.05.211 2.184-.889 2.646-1.883.789-2.535-1.211-3.773-1.905-2.262-.798-.977-3.251-2.133-4.569a.418.418 0 01-.123-.396c-.305-.634-.873-1.372-.508-1.98.952-1.602.783-3.584 1.87-5.111z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EDF4F6"
        d="M598.864 182.366c0-5.8-.018-11.6.021-17.4.006-.936-.443-2.367 1.129-2.425 1.854-.069 1.225 1.523 1.338 2.535.611 5.456-2.088 10.649-1.297 16.131.107.736-.514 1.053-1.184 1.168l-.007-.009z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#252351"
        d="M467.18 140.606c.209.402.416.805.623 1.207.193.267.18.53-.01.791-5.947.915-10.398 4.362-14.42 8.532-1.145 1.268-2.064 2.742-3.445 3.802a.943.943 0 01-.844-.012c-.645-.662-.566-1.337-.033-2.017.021-.167.025-.333.018-.501 4.642-6.073 10.26-10.653 18.111-11.802z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EAF4F6"
        d="M445.331 87.504c-.332 1.276-1.725 2.2-1.248 3.746-5.023-1.216-6.686-2.355-7.209-6.325-.246-1.87-1.934-1.518-2.773-2.392.195-.248.438-.434.723-.563 1.34-.274 2.645-.872 4.059-.433.264.146.467.359.613.621.5 1.542.537 3.334 2.271 4.209.248.072.49.157.736.235.836.304 1.777.165 2.578.612.084.096.168.193.25.29z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EBF4F7"
        d="M633.667 378.287c-2.402.158-3.76-.213-3.549-2.232.176-1.674.857-2.566 2.803-1.551 1.164.609 2.023-.502 2.908-1.219.639-.518 1.021-2.484 2.162-1.061.869 1.086 1.605 2.984-.113 4.119-1.473.977-3.239 1.509-4.211 1.944z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EEF1FC"
        d="M600.114 264.758c1.543.476 2.469-.915 3.744-1.249h2.498c2.654.149 4.844 2.341 4.992 4.993.477 1.547-.916 2.469-1.25 3.746-1.516-.195-1.16-1.376-1.256-2.345-.098-1.021.471-2.377-1.24-2.65-1.213-2.343-3.365-1.518-4.686-.747-2.55 1.486-2.818.352-2.802-1.748z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E5F6F5"
        d="M611.329 305.455c.393.293 1.098.561 1.121.879.135 1.75-.127 3.534 2.586 1.725 1.088-.726 1.408.607 1.416 1.585-1.754 1.333-3.863.353-5.58-2.856-.113 2.191-.717 3.93.17 5.9.959 2.124-.861 1.964-2.189 2-.107-.699.027-1.608-.361-2.066-2.258-2.654-2.275-2.582.621-4.693.5-.363.662-1.188.98-1.797.15-.707.777-.536 1.236-.677z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BEDAF1"
        d="M647.547 342.148c-.172-.488.371-1.48-.627-1.324-.379.061-1.215.281-1.193 1.584.033 1.76-.764 3.873-2.816 4.576-1.23.422-2.729.514-3.469-1.127 3.992.025 4.578-.516 3.674-4.09-.406-1.6.451-1.916 1.455-2.533 1.396-.857 2.369-.643 3.477.566 2.289 2.504 3.354 2.412 5.104-.154.211.004.426.006.637.008.84 2.533-.828 3.074-2.721 3.328-1.251.17-2.497.065-3.521-.834z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECE2FC"
        d="M595.116 167.396v8.128c-1.186-.595-.131-1.814-1.139-2.567-.234 4.147-.33 8.095 1.156 11.917.482 2.124-.738 1.777-1.996 1.375-.707-.793-.709-1.779-.752-2.752-.121-6.583.213-13.17-.191-19.75-.182-.734-.227-1.464.078-2.179l.355-.423c1.41.645 1.248 1.917 1.25 3.125.004 1.203-.179 2.482 1.239 3.126z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E3F2F5"
        d="M656.295 247.19c-5.178-1.418-9.416.255-13.051 3.941-1.439-2.671 1.738-3.655 2.213-5.737.307-1.33 2.59-.37 3.959-.612l1.873.006c.266.563-.078.747-.535.864.762.053 1.283-.39 1.789-.864 1.885-.19 3.116.642 3.752 2.402z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DFF4FA"
        d="M616.965 197.355c.721.79 1.434.813 1.828-.231.504-1.341 1.596-.923 2.531-1.02.338.413.387.827.008 1.243-.012 1.109-1.795 2.227.801 3.319 1.146.482.49 3.991.393 6.138-1.766-.419-1.693-2.429-2.898-3.331a14.155 14.155 0 01-3.063-3.479c-.393-.893-1.363-1.619-.82-2.788.439-.216.851-.191 1.22.149z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EE3F51"
        d="M635.024 287.275c.055-1.105.109-2.214.16-3.183 1.752-1.078.436 2.783 2.393 1.226 1.107-.398 2.086-.174 2.959.595.947.07 1.965.045 2.061 1.384.313.336.533.706.479 1.188a5.058 5.058 0 01-.047.55c-.783.223-1.566.445-2.352.67-1.031.494-2.055.811-3.043-.095l.006.011c-.982-.408-2.047-.69-2.568-1.767a3.287 3.287 0 01-.048-.579z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D5F2F9"
        d="M548.928 133.7c.045 4.29.047 4.278 4.426 5.005 1.066.178 2.318.397.291 1.363-.064.032 1.713 1.075 1.527 2.354-.494.533-1.088.55-1.725.329-.561-.301-.881-.825-1.23-1.321-.414-.897-1.176-.947-2.053-.984-1.734-.075-2.953-.702-2.873-2.809.068-1.805-.734-2.339-2.232-1.048-.822.71-1.67.701-2.578.222a2.607 2.607 0 01-.689-.596c-.488-1-.764-2.035-.498-3.154.258-.278.523-.283.795-.016.197.01.396.017.592.022.576-.445-.229 1.577.781.429.445-.508 1.133-.397 1.742-.423.773.426 1.58.719 2.482.615.418-.374.83-.326 1.242.012z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EBF1F2"
        d="M459.09 74.428c1.855-.177 2.213 1.813 3.502 2.48.168.086.059 1.299-.115 1.351-1.342.406-2.395 2.089-3.795 1.541-1.262-.495-2.893-.83-3.521-2.406-.107-.579.195-1.003.521-1.422.258-.308.543-.586.85-.844.652-.502 1.328-.954 2.209-.91.117.069.234.139.349.21z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5D26CE"
        d="M445.948 72.489l1.734.095c.244.153.494.298.748.438.748.339 1.988-.088 2.041 1.326a1.84 1.84 0 01-.758.678c-3.969 1.145-7.945 1.522-11.953.175-.656-.88-.67-1.79-.125-2.726.951-.884 2.16-.745 3.313-.833 1.709.02 3.345.485 5 .847z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4E8EB6"
        d="M612.463 218.518l-2.336 1.359c-.645-.267-1.102-.736-1.451-1.328-.104-.618.195-1.074.594-1.492a5.4 5.4 0 01.682-.522c2.988-1.723 5.207-4.608 8.605-5.714.939.12 1.711.467 2 1.471-.154.213-.309.427-.461.641-2.17 2.374-4.838 4.067-7.633 5.585z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9E8EC"
        d="M607.608 283.482c-.752 1.746-2.006 2.993-3.75 3.75l-3.848-.058c1.24-.813 2.926-.841 3.859-2.192.131-1.076 1.594-1.151 1.688-2.255.16-.415.332-.821.643-1.155 1.25-2.221.996-4.539.326-6.828-.256-.875-.881-1.646-.26-2.589.463-.265.91-.273 1.332.093-.191 2.149 1.465 3.813 1.387 6.079-.067 1.939-1.863 3.218-1.377 5.155z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E9F2F9"
        d="M448.471 152.341l-4.387.001c-.07-2.2 1.221-3.81 2.434-5.414.82-1.085 2.121-1.102 3.049-.363 1.809 1.434-.719.919-.861 1.62-.286 1.389.744 2.833-.235 4.156z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#568DB0"
        d="M598.924 183.648c2.361-.862 4.688-1.339 6.795.615.186 1.303-.686 1.456-1.637 1.463-.98.007-1.979-.179-2.91.282-1.641.806-3.092 1.895-4.529 3.007-.469.348-.969.623-1.564.68-2.549-.65-.52-1.87-.359-2.862.486-.524 1.004-1.01 1.664-1.314l.008-.006c.525-1.055 1.708-1.216 2.532-1.865z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EDE9FC"
        d="M445.948 72.489l-4.85-.069c-1.502-.423-2.977-.283-4.428.236-1.352.229-2.684-.09-4.025-.127-.84-1.572-.348-2.311 1.771-2.485 4.081-.335 8.002.151 11.532 2.445z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5F22D5"
        d="M452.84 78.869c-1.258 1-2.514 2.001-3.771 3.002a8.766 8.766 0 01-2.676 2.417l-1.602.739c-1.078.778-2.15.933-3.217-.011.764-2.608 1.656-4.791 5.121-4.938 2.203-.094 3.484-2.92 5.967-3.047.301.051.57.175.814.357.294.712-.061 1.144-.636 1.481z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EAF4F5"
        d="M622.596 167.383c-2.344-.461-4.01.993-5.744 2.349-.715-3.162 2.043-6.31 4.943-6.086 1.781.138.527 1.408.875 2.066.457.578.411 1.134-.074 1.671z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EEF4F5"
        d="M556.424 146.797c.748-.017.301-1.664 1.316-1.095 1.238.695 1.471 2.002 1.064 3.247-.369 1.125-1.455 2.006-1.139 3.375-1.617 1.465-3.354.724-5.074.283-.305-.28-.391-.719-.609-1.015-.771-1.049 2.65-.102.707-1.564 1.027-.963 1.945-2.021 2.453-3.356 1.4.473.727 1.488.988 2.105.04-.644-.198-1.362.294-1.98z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E6F6FE"
        d="M611.348 268.502a12.469 12.469 0 00-4.992-4.993c.205-.89-1.314-1.322-.74-2.118.506-.703 1.652-.601 2.281-.237 2.031 1.173 3.064 3.365 4.594 5.056.48.531.39 2.087-1.143 2.292z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5D9FC4"
        d="M620.557 212.292c-.664-.342-1.404-.586-1.76-1.338a1.17 1.17 0 01-.139-.814c.564-1.448.912-2.881-.332-4.187-.342-.454-.561-.945-.439-1.529.396-1.008 1.4-1.076 2.221-1.422 1.262.978 1.641 2.516 2.418 3.802.017 2.071-.453 3.966-1.969 5.488z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E5E8F7"
        d="M552.709 152.359c1.652-.012 3.305-.022 4.957-.035 7.875.024 15.746.036 23.621.088 1.105.007 2.303-.326 3.275.548-.139.145-.281.289-.418.436-.736.456-1.566.495-2.395.499-8.992.031-17.982.039-26.975-.003-.725-.004-1.447-.063-2.113-.4-.33-.391-1.155-.804.048-1.133z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D4F1FA"
        d="M552.709 152.359l-.66.475c-.094.102-.191.204-.287.306-.465-.111-.693-.449-.836-.87a3.86 3.86 0 01.064-2.136c.107-.262.26-.499.451-.709.273-.984 3.107-.312 1.576-2.452-.781-.397-1.613-.724-2.012-1.596-.365-1.344-.23-2.49 1.227-3.111 1.568.616 2.295 2.556 4.186 2.676 0 .619.002 1.237.006 1.856v2.543c-1.041-.435-.311-1.359-1.004-1.974-.479.915.143 2.64-1.623 2.576 1.192 1.504-2.183.955-1.088 2.416z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E6F3F2"
        d="M616.965 197.355l-1.123-.012c-2.49-.712-3.309-2.689-3.752-4.956 0-.497.129-.941.52-1.279 3.412.378 5.441 3.288 4.355 6.247z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E2F4F7"
        d="M623.069 308.375c.154-.956-1.148-2.3.742-2.796 1-.248 1.824-.715 2.201-1.746.271-.725.615-1.33 1.561-1.005.248 2.71-.896 5.141-1.6 7.934-1.094-.742-1.598-2.124-2.904-2.387z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#675794"
        d="M603.346 312.625c3.168 1.263 3.783 3.068 2.016 5.902-1.314 2.111-3.625 3.805-2.855 6.795-.738.129-1.006-.594-1.537-.838-.484-.16-1.02-.25-1.191-.846 0-1.74 1.295-2.805 2.256-3.947 1.682-2.002 2.572-3.955.871-6.352.044-.301.19-.538.44-.714z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5890BF"
        d="M600.735 185.295c1.438-1.427 3.658.931 4.984-1.032.174.005.346.02.514.045 2.379 1.056 3.359 3.161 4.09 5.454-.238.784-.752 1.298-1.527 1.557-2.119-.443-2.643-2.636-4.141-3.764-.856-1.533-3.024-.801-3.92-2.26z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C0D9EB"
        d="M636.297 364.59c-.58 3.055.861 4.045 3.727 3.795 2.541-.223 3.258.848 1.906 3.105-1.029-1.439-2.057-3.273-4.166-2.199-2.49 1.268-2.889-.713-3.488-2.043-.815-1.81.644-2.295 2.021-2.658z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2A7CB4"
        d="M622.577 182.363c.512.062 1.006.175 1.182.748.273.903.629 1.875 1.779 1.585 1.211-.305.65-1.488.813-2.304.979-.472 1.807-.116 2.59.473.162 1.375.926 2.806-.359 4.057-.859.197-1.693-.067-2.537-.126-.852-.173-1.332 1.108-2.275.582h-.273l-.273-.027c-1.354-1.177-.527-2.881-1.035-4.265.056-.28.186-.521.388-.723z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EAF6F5"
        d="M300.885 82.517c1.412 2.683.699 5.474.874 8.408-2.401-.548-2.38-2.111-2.525-3.796-.153-1.774 1.961-2.788 1.651-4.612z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8F8F0"
        d="M608.877 314.662c-.164 1.226-.006 2.471 1.15 2.982 4.029 1.783.76 2.836-.26 4.227-2.725-3.652-2.917-5.291-.89-7.209z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7E1E7"
        d="M644.29 287.137c.283-.55.564-1.102.848-1.651.338-1.329.434-2.655-.049-3.973-.83-1.008-1.141-2.445-2.496-3.019-.182-.088-.264-.201-.246-.34.02-.15.051-.228.1-.228.453-.23.904-.462 1.359-.694 1.432 1.362 2.875 2.719 2.523 4.984.855 1.675.893 3.343-.027 5.006-.563 1.187-1.549 1.371-2.709 1.138-.091-.592.521-.783.697-1.223z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E4F6FC"
        d="M609.942 301.767l.174 1.782c-.576.438-.557 1.232-1.027 1.734-.484.39-.977.516-1.486.041v-.62c.238-1.899-1.664-1.664-2.494-2.499.416-.832.83-1.664 1.248-2.494.43-1.33.584-2.896 2.52-2.941.875.229 1.465.701 1.455 1.69-.082.237-.166.473-.246.71-1.334.796-.705 1.698-.144 2.597z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E5F6F5"
        d="M608.885 297.204c-1.818-.15-.74 2.627-2.529 2.507-2.273-.708-1.127-2.561-1.133-3.868-.004-1.484 1.445-1.012 2.379-1.127.305.546 1.559.144 1.27 1.277.365.398.365.802.013 1.211z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D2F7FB"
        d="M612.463 218.518c2.387-2.075 4.717-4.23 7.633-5.586.727 2.473-1.393 3.661-2.785 4.176-1.51.559-3.037 1.69-4.848 1.41z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5AA1D1"
        d="M606.856 250.642c-1.773-3.12-.959-6.36-.443-9.586.373-.503.742-1.005 1.115-1.51l.141 1.508c1.451 2.514.852 5.169.551 7.807-.243.755-.6 1.425-1.364 1.781z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EDF4F3"
        d="M647.547 271.623c2.223-1.477 4.961.25 7.092-.984 2.232-1.294 2.736-.374 2.895 1.606-2.496.003-4.992.003-7.488.005-.836.658-1.668.658-2.498-.002l-.001-.625z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF3F3"
        d="M527.846 139.499c-1.551-.881-2.32.581-3.336 1.181-.752.445-1.459.654-1.621-.312-.113-.685-.785-1.541.555-2.298 1.857-1.051 3.729-.127 5.518-.635.4.354 1.332.17 1.258.929-.076.809-.93.851-1.555 1.064-.27.058-.543.079-.819.071z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#282558"
        d="M601.389 323.422c.373.633.746 1.266 1.117 1.9.197 2.078.395 4.156.594 6.232-1 1.578-.238 3.344-.531 4.998-2.273-.775-.949-3.018-1.795-4.377-.412-2.16-.174-4.373-.51-6.543-.019-.935.695-1.499 1.125-2.21z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CEF3FD"
        d="M610.106 189.873c-1.293-1.855-2.582-3.709-3.873-5.564l1.354-.685c2.227 1.543 4.477 3.067 4.387 6.236l.635 1.25c-.02.479-.039.959-.057 1.439-1.661-.12-2.298-1.176-2.446-2.676z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#417FAA"
        d="M528.317 143.154c-.861-.636-1.637-1.308-1.053-2.542.193-.372.387-.743.582-1.114l-.047-.025c1.631-.489 3.303-.738 4.998-.827.217.356.398.819.152 1.131-1.193 1.506-2.545 2.883-2.637 5.008-.021.466-.781.502-1.301.325-.753-.468-.007-1.466-.694-1.956z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EDF4F2"
        d="M630.069 257.269c-.139-2.706 1.783-3.865 3.748-4.993 0 .402-.059.815.008 1.207.523 3.035-.657 4.357-3.756 3.786z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#604E87"
        d="M603.346 312.625c-.064.307-.127.61-.189.916-2.129-.214-3.342-2.06-5.131-2.882-1.102-1.127-2.857-1.645-3.256-3.439.061-.665.361-1.146 1.039-1.335 1.24 1.055 2.482 2.109 3.727 3.162 2.02-.255 2.244 2.021 3.67 2.604.046.325.091.65.14.974z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F0F1FD"
        d="M607.606 290.968c-.561-3.051.689-4.295 3.74-3.739.098 2.59-1.146 3.839-3.74 3.739z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#704CC3"
        d="M586.926 154.44c2.576 1.661 4.342 4.011 5.701 6.705a6.556 6.556 0 00-.355-.066c-2.037.689-2.389-1.439-3.594-2.145-.871-1.396-2.963-1.683-3.275-3.591.045-.294.166-.551.355-.778.367-.271.739-.483 1.168-.125z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF6EA"
        d="M611.973 189.859c-.668-2.636-3.334-3.868-4.387-6.236l.029-.018c.832-.652 1.66-.652 2.482.021.716 2.051 3.958 3.342 1.876 6.233z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EEF4F4"
        d="M645.04 377.092c.293-.08.691-.064.859-.256 1.043-1.205 2.066-.896 2.672.268.451.861.592 2.16-.871 2.404-1.146.193-2.605.471-2.637-1.5l-.02-.92-.003.004z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D5F4FA"
        d="M627.573 302.828c-.65.27-1.076.753-1.326 1.4-.268.125-.48.064-.641-.184-.357-.59-.719-1.179-.502-1.919.822-1.005 1.234-2.013.02-3.031-.184-.904-.094-1.673.98-1.944.963-.273 1.549-.135 1.486 1.091-.074 1.526-.017 3.057-.017 4.587z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EBF7EF"
        d="M445.338 86.258c2.002-.551 3.662-.129 4.734 1.764.318.565.344 1.281-.262 1.67-.664.426-1.629.453-1.779-.428-.293-1.711-1.369-1.84-2.701-1.759l-.004-.003c-.359-.419-.384-.834.012-1.244z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EEF1FC"
        d="M607.598 272.248l-1.434.06c-1.557-.349-2.436-1.626-3.545-2.591l-.004-.002c-.488-.685-1.949.308-1.992-1.151 1.121-.029 2.24-.058 3.234-.685 1.961.185 2.656 1.89 3.744 3.119.001.417-.001.832-.003 1.25z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3987B8"
        d="M622.577 182.363c-.023.267-.047.535-.068.802-1.262.811-2.51 1.412-3.615-.229-1.275-1.904 1.773-2.599 1.205-4.306 1.09.086 1.242.833 1.234 1.722-.01.922-.081 1.905 1.244 2.011z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D4F5FA"
        d="M542.088 133.045l-.729.058c-1.172.769-2.371 1.512-2.709 3.029-.178.25-.398.45-.648.621-1.482.708-2.695.708-3.166-1.214.02-.301.111-.581.262-.843.666-.976 1.738-1.487 2.602-2.242 1.463.205 3.054-.56 4.388.591z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EFEAF0"
        d="M603.206 311.65c-1.535-.429-2.439-1.744-3.67-2.604.021-.42.045-.837.066-1.256 1.221-.657 2.465-.43 4.176-.156-1.416 1.365-1.838 2.669-.572 4.016z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6F1EE"
        d="M628.829 192.359c-3.307.398-2.365-2.037-2.504-3.751.502-1.567 1.32-1.62 2.385-.494.221.21.396.45.539.719.123.286.203.581.256.887.099.963.038 1.885-.676 2.639z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EAF6F5"
        d="M303.019 76.88c.005.216.012.431.018.646.632 2.4-2.127 3.095-2.506 4.987l-1.276-.017c-.556-.59-.648-1.284-.46-2.041.09-.274.225-.527.398-.758 1.339-.848 1.809-2.885 3.826-2.817z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#502C98"
        d="M285.474 103.582l-1.133 4.216c-.19-3.398-.438-6.791 2.345-9.488.479-.465.874-.815 1.535-.811-.65 2.148-3.124 3.472-2.747 6.083z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#331C69"
        d="M439.004 81.801c-1.451-.021-2.693 1.255-4.234.68-.568-.583-.568-1.212-.154-1.875l.238-.605c.191-.209.4-.4.621-.578.865-.481 1.67-.161 2.475.182.52.256 1.02.542 1.352 1.045.142.445.107.846-.298 1.151z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B3BFC9"
        d="M398.56 145.546l-.16 1.205c-1.188.831-1.789-.106-2.137-.908-.41-.939-.486-2.091.123-2.98.465-.677 1.111-.366 1.398.337.307.762.522 1.563.776 2.346z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3987B8"
        d="M621.336 171.144c.254 2.499-1.506 4.612-1.361 7.09a1.175 1.175 0 01-.57-.217c-1.227-.839-1.498-1.856-.58-3.095 1.166-.452 1.35-1.377 1.193-2.468-.598-1.422-.52-2.504 1.352-2.684l.014.02-.048 1.354z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DFF9FC"
        d="M607.602 270.998c-1.723-.471-2.473-2.106-3.744-3.119 1.094-1.134 2.496-.426 3.744-.624v3.743z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EDF6EE"
        d="M291.784 124.378c-.018.85-.037 1.717-1.21 1.735-1.158.017-1.262-.814-1.262-1.683.001-.949-.012-1.966 1.363-1.879 1.173.074 1.069 1.016 1.109 1.827z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E6F6FE"
        d="M605.106 242.288c-.002 2.082-.002 4.163-.002 6.245-2.289-.69-.875-2.593-1.248-3.904-.326-1.162-.424-2.39-.621-3.587.646.379.902 1.349 1.871 1.246z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EEF4F5"
        d="M556.418 144.941c-1.086.436-2.832-.612-3.756-2.254.043-.342.236-.453.559-.363l1.951.098c1.549.279 1.805 1.198 1.246 2.519z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F0F2EE"
        d="M631.977 188.601l1.514.022c.928.017 1.596.318 1.492 1.411-.092.948-.809 1.044-1.543 1.065-.705.021-1.412.006-2.119.006-.518-.47-.527-1.045-.344-1.661.211-.427.523-.733 1-.843z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C5EBF4"
        d="M618.893 182.937c1.127 1.316 2.438-.283 3.615.229 1.398 1.197-.281 2.919.713 4.185-1.441-1.472-2.887-2.943-4.328-4.414z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EDE9FC"
        d="M447.997 73.009a24.42 24.42 0 01-.314-.425c3.715-.185 7.406-.087 11.096.524 1.605.267 1.285.623.313 1.319l-.135-.094c-.91-.178-1.793.229-2.701.135a7.905 7.905 0 01-1.434-.221c-2.279-.404-4.638-.341-6.825-1.238z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F0EFE6"
        d="M298.036 82.546c.374 2.375-.449 4.228-2.424 5.584-.702-.14-.933-.697-1.138-1.28-.084-.637.146-1.168.545-1.644 1.171-.716.743-2.908 2.681-2.923l.336.263z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D5F2F9"
        d="M636.344 187.366c.182-.244.563-.539.516-.727-.898-3.65 1.055-3.832 3.758-3.14-.213.963-1.477.559-1.795 1.381l-.014 1.251c-1.152-.312-.691.965-1.234 1.253l-1.231-.018z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D6F3FA"
        d="M532.688 138.674c-1.328 2.121-3.26.532-4.889.798-.615-1.25 3.143-.009 1.162-2.038.662-.842 1.85.475 2.457-.595.109-.056.221-.112.328-.169.695.177.953.737 1.172 1.332a.822.822 0 01-.23.672z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4997D5"
        d="M632.124 242.275c.455 2.061.801 4.129.301 6.236-.363.393-.732.383-1.107.015l.084-7.043c.241.264.483.527.722.792z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DBFAFD"
        d="M631.329 189.306c-.002.6-.004 1.2-.008 1.801-.201 1.669-1.512 1.135-2.492 1.252l.01-3.146c.668-.573 1.393-.679 2.18-.264.105.117.206.237.31.357z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B5BEC8"
        d="M422.624 87.154c-.768 1.019-1.865 1.717-3.135 2.107-.391.12-.906-.283-.742-.711.527-1.376 1.77-1.904 3.088-2.212.39-.091.775.182.789.816z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B1BBC5"
        d="M406.207 102.073c-.656.822-.85 2.326-2.367 2.566-.357.056-.711-.447-.533-.899.482-1.221 1.059-2.435 2.482-2.754.414-.092.595.441.418 1.087z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D2F2FC"
        d="M631.35 239.668c-1.273-1.615-2.549-3.229-3.822-4.846 1.166-.014 2.635-.579 2.656 1.473l1.137-.248c.482.826.594 1.658.029 2.495v1.126z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C4DAED"
        d="M641.917 372.088c.371 1.453.855 2.893.613 4.434-3.569-1.014-2.156-2.715-.613-4.434z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4296C6"
        d="M608.795 218.529c.848.05 1.293.497 1.332 1.348l-.846 1.104a.486.486 0 00-.428.177 2.443 2.443 0 01-.836.37c-.863.025-1.498-.324-1.855-1.13.221-1.549 1.137-2.12 2.633-1.869z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E5F6F5"
        d="M605.108 302.205c1.135.199 2.543-.571 3.361.512.496.656-.236 1.459-.867 1.987-1.318-.347-2.154-1.177-2.494-2.499z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B3BCC6"
        d="M408.875 98.567c-.733.004-1.065-.354-.972-.76.275-1.182 1.118-2.004 2.163-2.497.596-.282 1.004.268.857.854-.303 1.188-1.335 1.768-2.048 2.403z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ACB5C0"
        d="M402.273 108.271c-.244.93-.488 2.091-1.584 2.626-.58.284-.99-.277-.822-.834.32-1.056.621-2.235 1.6-2.841.517-.32.822.314.806 1.049z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B6BFCC"
        d="M396.255 124.88c-.982-.323-.93-1.098-.555-1.706.461-.752-.318-2.423 1.307-2.229.982.117.457 1.165.334 1.795-.158.794.282 1.947-1.086 2.14z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CDEFF8"
        d="M634.346 166.091c-.982.736-1.953.556-2.914-.043-.775-.692-.84-1.465-.266-2.311 1.17 1.512 3.246-.041 4.459 1.321-.294.506-.81.742-1.279 1.033z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3987B8"
        d="M622.596 167.383l.074-1.671 1.131-.153c.432.252.875.025 1.313.031.609.391 1.217.783 1.828 1.174-1.746.253-2.912 1.49-4.213 2.495.227-.645.746-1.311-.133-1.876z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6443AB"
        d="M441.616 84.358c.859 1.158 2.113.46 3.176.668-.063.18-.098.366-.105.558-.473 1.1-1.094 1.931-2.48 1.344l-.033-.027c-1.367-.979-2.797-1.931-1.699-3.966 1.113-.114 1.647.237 1.141 1.423z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A9B2BE"
        d="M429.17 83.563c-1.248 1.079-2.121 2.132-3.711 1.707-.15-.041-.35-.637-.262-.731.977-1.054 2.095-1.727 3.973-.976z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#AEB7C2"
        d="M416.385 91.546c-.764.745-1.422 1.827-2.715 2.042-.459.077-.783-.427-.564-.825.551-1.006 1.342-1.836 2.51-2.1.384-.086.785.184.769.883z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6239BD"
        d="M435.348 79.955c-.16.044-.328.06-.494.046-.307-2.299.217-4.764-1.373-6.804.416-.926 1.09-1.152 2.004-.743.572.676.607 1.5.646 2.325.025.484.023.97.027 1.455a8.05 8.05 0 01-.002.97c-.001.994-.195 1.935-.808 2.751z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DDFCFA"
        d="M291.787 137.425c-.413.003-.826.005-1.238.009.131-1.532-.322-3.144.619-5.238.946 2.089.487 3.699.619 5.229z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B0B9C7"
        d="M398.664 113.785c.49.08.973.236.844.719-.273 1.028-.166 2.318-1.422 2.807-.387.151-.822-.214-.729-.694.203-1.051.256-2.206 1.307-2.832z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4C83A5"
        d="M631.167 163.736l.266 2.312c-1.049.41-2.139-1.616-3.164.051-.345-2.396 1.11-2.582 2.898-2.363z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DEFBF4"
        d="M623.834 219.826l-.006 2.491c-1.803-.189-1.059-2.189-2.09-2.988-.275-.214.287-.649.701-.694.866-.093 1.323.334 1.395 1.191z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DEFAFC"
        d="M636.301 277.234c-1.064-.129-1.516-.852-1.053-1.701.779-1.433 2.035-.577 3.246-.674-.236 1.579-2.365.811-2.188 2.368l-.005.007z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B5E4F3"
        d="M640.575 169.406c-1.475-.273-3.518 1.198-4.238-1.384-.523-.918-.076-1.654.447-2.376.802 1.718 2.008 3.029 3.791 3.76z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#487588"
        d="M636.784 165.646c.486.912.057 1.651-.447 2.376-2.176.913-1.08-1.541-1.99-1.932.121-.725.465-1.169 1.279-1.033l1.158.589z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E6F5FD"
        d="M647.547 272.248c.83 0 1.666 0 2.498.002-.145.909.42 2.275-1.102 2.385-1.812.131-1.263-1.388-1.396-2.387z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#261C63"
        d="M503.983 153.05l.742-.821 1.004.259.73.546c.559.465 1.586.332 1.725 1.34.061.483-.039.925-.35 1.307-1.722.016-2.955-.826-3.851-2.631z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8F2F9"
        d="M502.987 144.934c1.154.837 2.213 1.175 2.055 2.471-.057.468-.539.628-.973.508-1.326-.367-1.358-1.333-1.082-2.979z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF5EE"
        d="M548.928 133.7l-1.242-.01c1.277-2.453 3.066-.776 5.361-.894-1.707 1.248-2.97.741-4.119.904z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A7B1BB"
        d="M396.05 134.901c.609 2.001 1.205 3.088.725 4.331-.053.136-.664.252-.756.148-.994-1.127-.852-2.339.031-4.479z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CAEDF3"
        d="M631.977 188.601c-.217.234-.432.469-.648.705l-.109-.205c-.479-.53-.533-1.152-.396-1.816.313-.804.732-1.463 1.766-1.26 1.326-.009 1.76 1.202 2.578 1.888-1.103.051-2.382-.722-3.191.688z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8F2F8"
        d="M645.065 224.823c-.371-1.138 1.582-.757 1.232-1.884 1.035.161 1.631.735.818 1.616-.668.721-.77 1.603-1.105 2.67-.914-.779.153-2.03-.945-2.402z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#588E9F"
        d="M618.825 174.922c-.061 1.079.068 2.123.582 3.095-1.041.027-2.152.063-2.262-1.348-.086-1.103.17-2.082 1.68-1.747z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EFEFE4"
        d="M537.7 132.454c-.322 1.316-1.145 2.127-2.459 2.448-.486-.263-.674-.684-.652-1.218.626-1.451 1.906-1.244 3.111-1.23z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EFF6ED"
        d="M627.635 162.815c-1.461 1.576-2.482 1.073-3.707.231 1.174-.971 2.225-.705 3.707-.231z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#AFB7CE"
        d="M434.616 80.605c.051.625.104 1.25.154 1.875-.225.017-.447.034-.67.053-.713-.244-2.086.47-2.078-.537.006-1.403 1.506-1.295 2.594-1.391z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9AA3AF"
        d="M395.769 132.691c-.588-1.942-.707-3.143.121-4.71 1.002 1.554.811 2.732-.121 4.71z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4F7E9D"
        d="M621.37 169.771c-1.096.569-1.357 1.559-1.352 2.684-.873-.452-2.02-.745-1.252-2.151.658-1.204 1.481-1.603 2.604-.533z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D4F5FA"
        d="M534.588 133.685c.496.257.604.722.652 1.218l-.23.204c-.691.294-1.389.374-2.1.072-.096-.107-.189-.216-.283-.325-.309-.751-.775-1.551.273-2.09.964-.497 1.046.752 1.688.921z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FAEAF6"
        d="M633.372 291.821c-1.025-.924-.893-1.921-.395-3.159 1.352 1.023.625 2.144.395 3.159z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DAFAFA"
        d="M628.2 227.313c.68.788 1.754 1.282 1.875 2.49-2.578.642-2.961-.372-1.875-2.49z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F4F2F1"
        d="M642.557 267.261c1.326.334 2.15 1.173 2.496 2.49-1.931.271-2.777-.543-2.496-2.49z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E5E8F7"
        d="M586.926 154.44l-.969.327c-.887-.151-1.436-.648-1.58-1.556l.184-.249c1.027-.564 2.127-.769 2.992.128.617.639-.627.786-.627 1.35z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CCF2F6"
        d="M628.192 188.599c-.627-.848-1.248-.835-1.867.009-.023-.577-.201-1.061-.783-1.302-.178-.453-.236-.869.334-1.095.857-.169 1.689-.223 2.354.51.205.206.344.449.416.73.036.457-.116.839-.454 1.148z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EAF4F6"
        d="M443.969 91.216c1.215.169 2.381-.256 3.393.716-1.172.472-2.381 1.308-3.393-.716z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F8EAFE"
        d="M288.046 134.938l.004-2.492c1.948 1.249 1.921 2.497-.002 3.745l-.002-1.253z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EBF1F2"
        d="M452.84 78.869c.26-.418.523-.836.787-1.255.197-.207.34-.176.434.094-.141 1.102.92 2.419-.549 3.351-.955-.568.002-1.624-.672-2.19z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B65259"
        d="M642.446 277.927c.074.183.123.373.146.567-1.926-.027-3.85-.058-5.775-.086.131-1.445 1.559-.468 2.109-1.127 1.147.358 2.285.773 3.52.646z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2A2B52"
        d="M476.25 140.492l-7.516-.004c2.505-.715 5.011-.802 7.516.004z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6F0ED"
        d="M545.204 133.074c-.84-.312-1.689 3.028-2.523-.006.843-.888 1.683-.875 2.523.006z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D6F5FA"
        d="M636.299 289.735c-.215.76.531 2.226-.777 2.138-1.457-.095-.273-1.427-.445-2.183.271-.365.547-.78 1.08-.615.312.096.261.402.142.66z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E9F4E4"
        d="M297.85 91.901c-.836.789-1.63.818-2.428.247-.094-.069.002-.679.173-.794.891-.597 1.574-.198 2.255.547z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EBDFFC"
        d="M446.393 84.288c.234-1.534 1.719-1.683 2.676-2.417-.569 1.163-.381 3.164-2.676 2.417z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#503591"
        d="M289.313 94.369c.926-.754 1.498-2.048 2.98-1.956-.213 1.35-1.435 1.809-2.293 2.587l-.687-.631z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EBDFFC"
        d="M442.206 86.928c1.133.116 1.619-.959 2.48-1.344l.652.674c-.004.415-.01.829-.012 1.243-1.046-.15-2.226.406-3.12-.573z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CCEEF7"
        d="M625.624 295.411c-.713-.723-3.023 1.294-2.539-1.48 2.117.427 2.144.443 2.539 1.48z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DEF7FD"
        d="M631.299 258.569c.396.036.887.023.883.575-.002.544-.486.563-.885.565-.404.002-.889-.02-.887-.567.005-.538.485-.542.889-.573z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EEF1FC"
        d="M610.85 274.534c-1.066-.706-.619-1.57-.752-2.286.191.047.406.049.568.145.901.542.77 1.234.184 2.141z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F8F0E2"
        d="M628.911 232.345c.375.104.928.085.783.682-.111.462-.588.52-1 .464-.389-.052-.93-.079-.785-.672.111-.46.578-.489 1.002-.474z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8F2F8"
        d="M642.186 231.29c.029.528.023 1.097-.73.939-.352-.075-.92-.415-.914-.625.012-.594.461-1.061 1.07-1.129.512-.058.656.349.574.815z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#523D81"
        d="M435.356 72.577l-1.875.62-.836-.667c1.123-1.543 2.611-.467 3.938-.55.172.258.166.502-.055.732-.418.201-.813.18-1.172-.135z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5E0C8"
        d="M299.293 80.024l-.039 2.471-1.219.05-.004-.091c-.743-1.415-1.059-2.607 1.262-2.43z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5C3F95"
        d="M294.878 86.967l.733 1.163c-.099.863-.356 1.617-1.309 1.888l-.044-2.407c-.153-.156-.217-.323-.191-.5.027-.181.062-.271.106-.271.276-.185.511-.143.705.127z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FDEAF3"
        d="M610.098 183.627l-2.482-.021c.061-.674.334-1.148 1.096-1.192.865-.049 1.328.347 1.386 1.213z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CEEDFA"
        d="M598.924 183.648c-.66.873-1.557 1.423-2.535 1.863-.963-2.167 1.098-1.422 1.857-1.928l.678.065z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EFF5E9"
        d="M623.786 191.114c-.035.402-.029.887-.578.882s-.563-.494-.563-.894c.002-.402.031-.887.576-.883.551.004.535.493.565.895z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6F3E4"
        d="M621.333 197.347l-.008-1.243c.189-.32.328-.86.572-.914.467-.102.609.389.637.796.062.852-.34 1.314-1.201 1.361z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E3F2F5"
        d="M655.028 243.896c-1.531 1.904-3.33.531-4.98.947 1.531-1.892 3.327-.534 4.98-.947z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6591A1"
        d="M608.911 304.604c.281-.49.572-.969 1.205-1.055-.396 1.145.672 1.358 1.213 1.906-.412.227-.826.451-1.236.676a.651.651 0 00-.449-.268c-.774-.111-.423-.877-.733-1.259z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF0E9"
        d="M631.35 238.543c-.012-.832-.02-1.663-.029-2.495 1.162.819 1.873 1.642.029 2.495z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EEDAE0"
        d="M636.299 289.735c-.383-.692-.813-.074-1.223-.042l-.006-1.84 2.568 1.769-1.339.113z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FECCDE"
        d="M594.438 287.852a177.37 177.37 0 00-.576-.7c-.369-.415-.295-.794.092-1.148l2.461 1.168c-.676.172-1.495-.057-1.977.68z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E3F2F5"
        d="M654.547 241.513c-.635 1.748-1.65 1.239-2.57 1.076l2.57-1.076z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EEDAE0"
        d="M637.633 289.609l3.043.095c-1.043.951-2.093 2.047-3.043-.095z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4E85A1"
        d="M625.875 186.211l-.332 1.095c-.594-.045-1.111 1.771-1.773.071l2.105-1.166z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#386075"
        d="M625.114 165.589c-.297.517-.65 1.134-1.299.958-.531-.144-.004-.646-.014-.989.453-.629.889-.598 1.313.031z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E9F2F9"
        d="M402.263 147.42v-3.01c.672 1.037.936 2.057 0 3.01z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7042BC"
        d="M454.061 77.708a5.412 5.412 0 00-.434-.094l-.25-.107c-.113-1.307.695-1.64 1.779-1.684.326.06.596.217.809.471l-.805 1.1-1.099.314z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7E0EE"
        d="M638.926 277.281c-.701.376-1.404.751-2.109 1.127-.361.073-.721.146-1.082.217.189-.463.379-.927.566-1.391l.006-.007 2.619.054z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8F2F8"
        d="M639.434 229.809l1.871-.003v.625c-.91-.099-1.721.208-2.504.623.008-.4.018-.8.025-1.2.188-.224.389-.239.608-.045z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D4F5FA"
        d="M531.418 136.84c-1.068-1.558.313-1.625 1.209-1.986l.145.15c.154.239.18.492.078.757-.27.515-.738.773-1.256.965l-.176.114z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8F2F8"
        d="M633.819 231.676c-.549.587-1.072 1.259-2.127.57.572-.928 1.449-.416 2.127-.57z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E5F6F5"
        d="M608.911 304.604l.732 1.26c-.855.483-1.621.627-2.041-.539.563-.013 1.049-.161 1.309-.721z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#312A6F"
        d="M602.061 362.885c-.012-1.117-.492-2.311.555-3.246.041 1.121.029 2.23-.555 3.246z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8F2F8"
        d="M643.961 212.274c-.141-.149-.324-.347-.508-.545.217-.132.422-.333.652-.37.131-.021.375.198.445.362.189.445-.155.494-.589.553z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B7DAF2"
        d="M627.573 471.945c-.836.006-1.67.012-2.506.016-1.521-1.186-3.215-.313-4.809-.33-7.654-.084-15.311-.055-22.965-.023-1.301.008-2.732-.352-3.768.879-.305.502-.672.938-1.23 1.168-7.154.277-14.33.23-21.465.629-4.203.236-8.383-.416-12.553.17-1.242.004-2.486.008-3.727.014-3.283.65-6.602.236-9.9.279-6.945.09-13.893-.086-20.832.281a3.119 3.119 0 01-1.092-.404 1.434 1.434 0 01-.27-1.098c.145-.377.402-.648.768-.822 3.17-.783 6.389-.309 9.59-.377 8.389.039 16.814.484 25.154-.213 6.611-.557 13.193-.705 18.734-.762-5.992-.131-13.043.061-20.096.311-1.137.039-2.281.01-3.402-.277a4.496 4.496 0 01-1.068-.426c-1.115-.766-2.391-.598-3.621-.6-23.836-.014-47.674-.012-71.514-.002-1.131.002-2.287-.113-3.355.404a4.326 4.326 0 01-.982.488c-4.508.719-9.053.211-13.584.348-2.057.064-4.135-.137-6.119.637-.191.076-.439.201-.594.125-3.072-1.547-6.131-.762-9.193.023-1.412-1.283-.393-2.246.523-3.057a12.036 12.036 0 014.893-2.641c.777-.043 1.469.275 2.182.51 1.451.232 2.908.141 4.361.141 53.621.004 107.242.004 160.861-.002 2.771.045 5.57-.217 8.311.129 1.936.242 4.457.191 4.518 3.254-.795.021-1.221.422-1.25 1.228z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B7D9F4"
        d="M215.653 474.473c-2.835-1.754-5.998-1.182-9.062-1.242-2.808-.059-5.617-.016-8.426-.02-1.152-.625-2.398-.215-3.598-.313-2.009-.166-2.292-1.018-1.077-2.533 1.253-.693 2.627-.518 3.963-.518 23.753-.016 47.506-.018 71.259.002 1.429 0 2.927-.25 4.213.684.673.936.312 1.561-.654 1.885-.794.268-1.646.168-2.474.168-10.785.006-21.57.006-32.355.002 11.206.01 22.421.303 33.613-.084 10.271-.354 20.533-.133 30.799-.264 5.173-.063 10.34.672 15.523.117 1.132-.123 2.3-.084 3.226.787.311.859-.012 1.361-.854 1.654-.906.318-1.828.299-2.765.295-5.392-.016-10.785-.031-16.179-.004-25.09.129-50.177-.566-75.267-.332-.814.008-1.666.188-2.434-.277-.403 0-.806.002-1.209.004-1.257-.061-2.517.74-3.772-.012l-2.47.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1A1840"
        d="M448.473 466.928c-1.764 1.863-4.738 2.313-5.809 4.982.086.439-.059.828-.254 1.209-.398.732-.748 1.514-1.564 1.904-4.182 4.623-8.756 4.652-12.383.08-.359-.33-.422-.742-.352-1.197.236-.855.725-1.572 1.246-2.27 1.205-1.133 1.572-3.059 3.398-3.598.293.1.541.275.703.537.156.26.318.533.115.846.322-.246.1-.533.049-.801-.059-.299-.102-.596-.064-.902.061-.264.174-.502.336-.719.52-.141 1.273-.016 1.084-.971a.986.986 0 01.518-.49c.701-2.219 1.436-4.422 1.986-6.688.242-.43.582-.756 1.023-.977.311-.121.635-.176.965-.178 2.348.787 4.748 1.154 7.225.898 2.482-.389 3.324.873 3.221 3.148-.043.916.006 1.838-.035 2.758a4.467 4.467 0 01-.303 1.482c-.22.486-.619.769-1.105.947z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BAD5EB"
        d="M428.493 473.844c-.01.42-.021.838-.029 1.26-1.125.703-2.381.613-3.625.613-28.155-.002-56.307.012-84.46-.02-1.11-.002-2.623.65-3.094-1.184 1.782-1.566 3.943-.754 5.939-.896 1.742-.125 3.506-.033 5.256-.023.669.002 1.343.016 2.01.027.934.096 1.755-.23 2.533-.709.796-.234 1.5.064 2.206.365 1.837.701 3.692.322 5.549.096.359-.02.706.018 1.055.094 10.982.051 21.958.139 32.935.016 10.438-.121 20.874.146 31.31-.012.821-.012 1.663-.09 2.415.373z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E7F2FA"
        d="M558.278 474.453c.637-.738 1.506-.602 2.322-.58 10.688.256 21.354-.385 32.029-.664 4.367-1.389 8.732-1.418 13.1 0-2.332 1.504-5.037.012-7.563.879 1.289.895 2.945-.227 4.188.975-1.256 1.293-2.906.127-4.377 1.104 1.445.107 2.633.193 4.5.33-5.287 1.361-9.668-.24-14.777-1.191l4.244-.365a11.738 11.738 0 01-.021-.324H568.37c-.006.139-.01.281-.012.42h3.57l.027.514c-1.205.107-2.41.211-3.617.316.006.139.01.275.014.412h8.48c-7.799.557-15.594 1.182-24.174-.266l9.252-1.109c.016-.15.027-.299.043-.449-1.226-.002-2.451-.002-3.675-.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BED9EF"
        d="M223.107 474.48c30.924-.006 61.848-.006 92.773-.033 1.615 0 3.429.482 4.616-1.23-.152-.154-.208-.314-.167-.477.041-.168.086-.248.133-.248.273-.111.545-.1.813.016.55.463.931 1.053 1.258 1.684.097.271.101.547.004.818-1.379.889-2.984.885-4.498.902-3.622.043-7.244-.164-10.868-.193-27.146-.227-54.292-.432-81.438-.652-.907-.006-1.893.24-2.626-.587z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BCD4E9"
        d="M440.846 475.023c.178-.965.684-1.746 1.354-2.438.59.068 1.119.285 1.602.627 1.398.566 2.865.361 4.305.361 19.883.016 39.764.004 59.646.021 1.537.002 3.113-.23 4.6.432.412.227.539.561.381 1.002-6.525.023-13.053.121-19.574.055-16.039-.162-32.057 1.049-48.098.625-1.44-.036-2.915.188-4.216-.685z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B5D6F3"
        d="M349.215 474.461l-11.931.053c-.221.25-.438.5-.658.752-.697.07-1.175-.307-1.607-.785-1.266-1.848-3.168-3.164-4.351-5.061-.554-.891-1.89-1.943-.128-3.018 2.613-.379 5.224-.574 7.813.164.303.178.516.434.639.762-.306 5.033-.306 5.031 4.989 5.047 1.243.006 2.505-.119 3.722.152.957.213 2.259.319 1.512 1.934z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1A1A3D"
        d="M335.595 474.211c.342.352.687.703 1.031 1.055-1.525 5.18-8.087 6.484-11.995 2.359-.766-.809-1.399-1.738-2.095-2.615l-.141-.605c-.719-.953-.15-1.559.635-1.957.957-.49 1.908-.109 2.519.607 1.354 1.59 2.749 2.965 4.882 3.549 1.039.283.916.527 1.816-.594.684-.854 1.15-2.535 2.793-1.045.102.092.157-.643.555-.754z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C2D7E8"
        d="M605.729 473.209c-4.367 0-8.732 0-13.1.002l-.006-1.236c.773-.664 1.717-.621 2.645-.621 8.451-.014 16.904-.016 25.355.004.912.002 1.881-.141 2.621.621l-.672.607c-5.614.207-11.263-.494-16.843.623z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E7F2FA"
        d="M522.737 474.479l31.814-.012c-.918 1.018-2.135.598-3.223.602-6.938.037-13.877.102-20.814-.02-2.602-.045-5.199 1.785-7.795.031-.156-.139-.205-.273-.148-.404s.111-.197.166-.197zM538.471 475.869h8.572v.313h-8.574c.002-.104.002-.207.002-.313z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B7DAF2"
        d="M522.737 474.479c-.008.201-.016.4-.018.602-3.33-.018-6.658-.031-9.986-.049l.004-.563c3.324-1.424 6.65-1.338 9.979-.012l.021.022z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BED9EF"
        d="M218.126 474.473c1.256.467 2.518-1.047 3.772.01-1.26.892-2.517.892-3.772-.01z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FEFEFE"
        d="M131.381 377.111c1.718-4.91 1.245-9.934 1.01-15-.212-4.576-2.3-8.652-2.874-13.096-.38-.5-.5-1.082-.595-1.695-.165-1.061 1.25-2.506-.743-3.164-.04-.012.172-.535.342-.791.311-.346.695-.592 1.107-.795 1.815-1.303 3.132-1.1 4.2 1.061.888 1.799 3.655 2.314 4.205.805 1.241-3.404 3.871-2.014 6.035-2.332.196-.209.403-.396.617-.58 1.158-.766 1.547-1.838 1.441-3.197-.102-1.316.186-2.527 1.701-2.898 1.5-.369 2.279.586 2.909 1.734.286 2.07-.64 4.262.627 6.234 2.305 2.182.84 4.992 1.248 7.49 1.191 1.684-.468 4.279 1.793 5.623.422.33.76.758.77 1.287.114 6.361.7 12.734-.308 19.08-.697.893-1.599.947-2.587.625-1.654-1.33-1.464-3.324-1.815-5.117-.55-2.801-1.322-3.412-3.97-3.043-4.784.668-4.904.668-4.856 5.576.027 2.725-.975 4.336-3.627 4.951-.907.213-1.714.746-2.643.932-2.539.078-4.175-.822-3.987-3.69z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B8D7F7"
        d="M126.466 310.972c1.358.6 2.706 1.241 4.246 1.194l1.302.008c.764-1.745 1.211-4.018 3.999-2.413 1.776 2.456 2.67 2.447 4.777-.047.909-.096 1.712.197 2.465.672.708 1.019.47 2.039.015 3.062.431 2.196 1.707 2.967 3.801 2.139 1.283-.507 2.031-.099 2.853.963.993 1.281-.016 2.016-.614 2.623-1.912 1.947-.722 3.256 1.061 3.473 2.895.354 2.482 2.053 2.254 3.904-.508 1.65-3.076 2.24-2.322 4.537.184 2.24-1.527 2.984-3.047 3.883a5.247 5.247 0 01-.846.467c-.279.139-.599.277-.741.547-1.863 3.525-1.874 3.537-5.972 2.955-.661-.299-1.46-.645-1.377-1.459.085-.857 1-.881 1.681-1.057.667-.172 1.447-.066 2.068-1.008-2.797-.033-5.39-.1-7.729 1.443-1.935 1.277-4.076 1.252-6.26.973-.863-.252-1.485-.689-1.356-1.721 1.245-2.99 4.305-3.213 6.726-4.418 1.409-.529 2.881-.324 4.329-.373 2.511-.318 4.399-2.609 3.958-5.057-.197-1.094-.398-2.236-.857-3.271-1.873-4.221-5.775-4.93-10.475-1.91-.662.426-1.058 1.328-2.066 1.105-.239-.186-.516-.418-.527-.697-.073-1.92-.797-2.58-2.622-1.521-.339.197-.742-.154-.995-.496-.37-.828-.118-1.561.335-2.264 1.479-1.858-.595-3.303-.584-4.992l2.52-1.244z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#866EF9"
        d="M154.435 377.084l-.029-20.574c.039-7.273.109-14.545.111-21.818.006-55.184-.007-110.369.021-165.552.001-1.611-.504-3.325.522-4.844 1.47 1.585.906 3.555.907 5.361.032 59.745.026 119.489.026 179.234 0 9.352-.005 18.703.007 28.055-.025 7.105-.01 14.213-.002 21.318-.026 8.066.011 16.129-.022 24.193-.006 1.428.242 2.912-.597 4.232-.314.365-.665.404-1.053.117-.775-.955-.812-2.107-.812-3.244 0-8.176-.132-16.352.056-24.525.141-6.773-.102-13.549.123-20.322.079-.621.356-1.152.742-1.631z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E7EEF7"
        d="M223.762 149.917c3.123-.992 5.93-3.239 9.516-2.39-.047 1.557-1.472 1.865-2.382 2.642a4.308 4.308 0 01-.747.335c-.918.264-1.792.616-2.509 1.284-.816.709-1.536 1.549-2.624 1.882-.523.162-1.06.2-1.605.222-16.623.055-33.24.012-49.856.031-2.901-.117-5.815.18-8.713-.208a2.155 2.155 0 01-.98-.616c2.749-1.655 5.861-.008 8.729-.958-1.19-.946-2.883.325-4.379-1.306 2.936-.333 5.507-.856 8.083-.878 10.997-.093 21.995-.085 32.992.022 1.264.013 3.959-1.349 3.316 2.12-.085.459.652.291 1.007.293 2.905.019 5.81.013 8.715.003 1.149-.004 2.039-.525 2.401-1.609.238-.713-.47-.759-.962-.869h-.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#603CBA"
        d="M155.204 377.098c-.028-28.188-.074-56.373-.081-84.56-.011-41.916.007-83.834.008-125.75 0-.831-.046-1.662-.071-2.493l-.427-1.3c2.306-.123 1.689 1.706 1.969 2.94.028 68.881.01 137.763.006 206.643 0 1.342.157 2.711-.392 4.004-.216.408-.554.576-1.012.516z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EBF1F7"
        d="M112.043 214.198c1.2-1.412 2.623-2.672 4.493-1.507 1.938 1.208 2.667 4.985 1.752 6.664-.855 1.568-1.632 3.065-3.574 3.548-.698.174-.301.843-.194 1.314-1.707.967-2.274-.158-2.736-1.485-.174-.787.065-1.506.373-2.214.233-.523.506-1.028.814-1.503.28-.435.824-.948-.311-.967-1.042-.016-2.038-.253-3.043-.442-1.905-.19-3.832.098-5.727-.265-.616-.144-1.187-.403-1.74-.702-.537-.301-1.059-.623-1.345-1.206.001-.2.002-.399.001-.598.28-.49.748-.608 1.261-.636 1.559.229 2.142 2.802 4.371 1.633l-1.382-2.775c1.424-.739 2.805-1.705 2.694 1.181-.021.577.188.585 3.052.59.757.465 1.362.63 1.241-.63z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FC3748"
        d="M239.45 144.969l1.141-.766c.926.196 1.832-.153 2.75-.105.514-.011 1.03-.011 1.542.049 1.05.125 2.108.296 2.392 1.553.32 1.419-.487 2.33-1.518 3.127-.918.71-2.192.366-3.18 1.079.862.756 2.064.297 2.877.972.622.622.216 1.162-.129 1.711-1.465 1.171-2.497 3.176-4.896 2.576-1.749-1.279-4.033-.111-5.811-1.258-.06-.078-.158-.151-.174-.239-.266-1.443 1.263-1.314 1.806-2.052-1.296-.571-1.361-1.595-1.021-2.77.646-1.157 1.776-1.854 2.663-2.783.363-.587 1.638.125 1.558-1.094z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F1EFFC"
        d="M243.134 142.486c1.314-3.516 5.059-3.395 7.599-5.077.238-.158.494-.29.953-.557-2.48-1.688-4.091.437-5.861 1.096-.991.368-1.862 1.274-2.51-.084-.574-1.206.692-1.286 1.412-1.833 2.333-1.772 5.245-2.183 7.708-3.593 1.183 1.062.629 2.582 1.023 3.852.067.297.091.598.082.901-.085.837-.64 1.329-1.287 1.753a7.043 7.043 0 01-.763.451c-1.84.888-3.648 1.844-5.501 2.706-.895.417-1.79 1.116-2.855.385z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F3E1C7"
        d="M233.129 98.747c1.729-3.375 1.045-7.052 1.331-10.608.923-.095 1.447.399 1.768 1.195.717 5.959.261 11.938.279 17.911-.081.976-.05 1.989-.885 2.718-1.951-1.427-2.198-3.632-2.438-5.742-.204-1.804-.05-3.648-.055-5.474z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7040DE"
        d="M155.755 165.521c-.146-.943.408-2.196-1.122-2.525.748-1.67 1.064-3.543 2.343-4.962.37-.847 1.205-1.259 1.785-1.909l5.101-3.024.624.149c2.637.25 5.281.039 7.92.114.341-.021.646.073.915.281a.964.964 0 01-.31.866c-.807.567-1.751.612-2.667.55-5.519-.367-9.553 1.84-12.01 6.831-.648.885-.524 2.033-1.007 2.975-.394.531-.84.939-1.572.654z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#723FD0"
        d="M255.78 116.893l-.788-3.808c.251-.539.583-.919 1.253-.638.536.353 1.027.847 1.068 1.45.402 6.015 1.405 12.081-1.29 17.871-.586 1.259-1.454 1.979-2.933 1.456-.363-.499-.347-1.012-.053-1.533 1.079-3.041 2.5-5.982 2.672-9.284.377-1.835.246-3.674.071-5.514z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5C2EAF"
        d="M102.065 216.052l1.371.512c.154.282.15.565.009.851a2.203 2.203 0 01-.764.46c-.422.122-.856.17-1.293.187-2.663.594.267 1.437-.086 2.13.266.957.318 1.874-.454 2.65-1.623-.913-2.305-2.738-3.729-3.843-.767-.042-1.05-.561-1.195-1.216-.191-.579-.919-.932-.703-1.681v-.002l1.193-.227c1.892-.224 3.779-.257 5.651.179z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EBF4F0"
        d="M109.549 226.062c1.747.3 1.295 1.665 1.153 2.687-.187 1.35-1.302.802-2.186.922-1.208.163-2.342-.209-3.662 1.119-1.18 1.189-1.478-1.063-1.546-2.239 2.137-.69 3.921-2.262 6.241-2.489z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E9F5FB"
        d="M146.384 334.668c.207-.014.412-.031.618-.057 1.718-.393 3.75-.143 4.628-2.256.125-.072.251-.141.378-.211 1.747 1.656 1.722 2.002-.084 3.014-.746.416-1.185 1.104-1.187 2.004-1.036-.531-1.901-1.813-3.273-.996-1.132.674-.571 1.783-.498 2.773.132 1.775-.578 2.965-2.49 3.172.067-1.648 1.108-3.146.454-4.963-.345-.953.667-1.816 1.454-2.48zM152.612 350.887c-1.236-2.361-.108-5.115-1.248-7.49v-4.416c2.072 1.566 2.664 8.033 1.248 11.906z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E9F5FB"
        d="M149.489 330.93c-.656-2.678 1.027-3.682 3.136-4.381 1.547 2.061.249 3.805-.617 5.596l-.016.016c-1.301.538-1.868-.413-2.503-1.231z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7DCC4"
        d="M235.623 109.963l.003-2.494c2.512-.161 4.933.363 7.342.981.3.255.358.557.175.906-2.484.498-4.878 2.085-7.52.607z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E54B53"
        d="M243.134 142.486l8.681-3.902c.471.562.475 1.268-.018 1.665-2.519 2.029-4.986 4.255-8.631 3.638-.276-.277-.311-.581-.104-.913.015-.163.039-.326.072-.488z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7349BF"
        d="M255.623 112.461l-.63.625c-.924-2.066-2.272-3.72-4.442-4.576-.313-.424-.279-.858-.036-1.3.185-.258.403-.481.651-.68.402-.328.861-.686 1.375-.534 1.693.499 3.586 4.537 3.082 6.465z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6220D3"
        d="M100.848 222.841l-.078-2.985c.276-.727.768-1.243 1.498-1.527 1.883.041 3.511.713 4.892 1.988.104.282.094.563-.023.841-1.206 1.122-3.005.184-4.235 1.22-.334.411-.65.838-1.086 1.152-.124.048-.249.093-.374.138l-.594-.827z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DD505E"
        d="M238.162 146.214c-.423 1.257-1.23 2.117-2.54 2.459-1.571 1.099-3.021 2.747-5.19 1.152.531-1.283 2.214-1.139 2.846-2.298 1.396.079 2.269-1.209 3.574-1.366.451-.346.889-.355 1.31.053z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5122A9"
        d="M250.537 107.475l.014 1.034c-1.183-.259-1.671 1.917-3.077.877-.591-.318-1.179-.643-1.68-1.104-.576-.614-1.179-1.218-1.109-2.164.136-.454.445-.714.901-.813 2.084-.268 3.443 1.122 4.951 2.17z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EDE4FB"
        d="M109.549 226.062c-1.794 1.546-3.703 2.807-6.241 2.489.617-.848-.023-1.706.021-2.56.556-.252 1.031.045 1.524.214.694.297 1.242-.017 1.761-.437.307-.274.616-.542.938-.798.583-.447 1.23-.723 1.974-.741.448.005.867.112 1.238.372.144.16.209.331.195.513-.015.188-.042.282-.081.282-.521.062-1.045.125-1.329.666z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E5D2CE"
        d="M244.906 106.254l1.262 1.883c.037.502-.118.912-.57 1.178l-2.457.042-.036-.637c-.593-.622-.75-1.38-.695-2.208.041-.481.181-.929.467-1.324 1.256-.75 1.626.19 2.029 1.066z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8F7E8"
        d="M100.824 225.42c.094.62 1.566.871.671 1.629-.685.58-1.771.433-2.545-.198-.819-.669-.666-1.622-.544-2.66.954-.439 1.508.904 2.399.624.196.128.264.261.205.397-.061.137-.122.208-.186.208z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EDF6EC"
        d="M156.963 157.407c-.916-.141-2.182.415-2.393-1.144-.072-.524.099-1.121.687-1.185 1.117-.122 2.504-.804 2.968 1.029-.116.729-.668 1.035-1.262 1.3z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B7C0CB"
        d="M125.341 229.989c1.037.623 2.038 1.382 2.502 2.546.192.48-.451 1.039-.97.806-1.13-.505-2.094-1.345-2.57-2.496-.21-.509.396-.843 1.038-.856z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B9C3CD"
        d="M122.244 228.434c-.622.922-1.319.593-1.906.19-.761-.521-2.274-.55-1.878-1.954.26-.922 1.231-.626 1.76-.14.682.625 2.033.623 2.024 1.904z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8F5EA"
        d="M95.923 217.783l1.195 1.216c-.043 1.061-.078 2.13-1.588 2.051-.492-.025-1.158.082-1.274-.542-.251-1.351 1.119-1.806 1.667-2.725z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B5BEC8"
        d="M133.333 241.415c2.033.695 1.917 2.227 2.102 3.579.011.078-.596.401-.739.314-1.423-.849-1.546-2.19-1.363-3.893z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B2BCC6"
        d="M132.895 263.539c-.515.879-.574 2.214-1.757 2.663-.5.19-1.008-.435-.792-.981.402-1.017.563-2.3 1.738-2.747.522-.2.881.354.811 1.065z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E7EEF7"
        d="M223.764 149.918c-.971 3.245-3.314 1.479-5.193 1.409 1.465-1.435 3.678-.149 5.191-1.41l.002.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#AFB8C3"
        d="M128.841 235.184c2.643.62 3.271 1.918 3.705 3.897-2.108-.534-2.713-1.889-3.705-3.897z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B3B8C7"
        d="M122.647 278.487c.023-.207-.02-.453.078-.611.664-1.078.604-2.742 2.274-3.001.457-.071.778.485.645.868-.495 1.427-1.304 2.584-2.989 2.751l-.008-.007z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B2BBC5"
        d="M135.376 256.9c-.482.843.156 2.45-1.5 2.574-.665.051-.654-.736-.54-1.191.242-.961.288-2.17 1.43-2.51.521-.154.808.475.61 1.127z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5E33BB"
        d="M107.679 225.44l-.607.649c-.759.539-1.618.621-2.51.55l-1.231-.648-.843-1.194c.131-.121.261-.241.391-.364 1.563-.608 3.115-.648 4.653.091.32.261.369.566.147.916z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A5AFB9"
        d="M126.89 272.297c0-.467-.108-.813.018-1.003.59-.895.586-2.309 2.029-2.456.142-.016.52.492.465.635-.446 1.191-.847 2.468-2.512 2.824z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9EA7B2"
        d="M135.273 252.465c-.138-1.216-1.121-2.431.029-3.576.072-.073.645.14.711.321.429 1.157.661 2.325-.74 3.255z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9FA6B0"
        d="M112.222 222.3c.586.856.616 2.375 2.298 1.918l-.005-.013c1.242 1.202 1.243 1.3.037 1.89-.766-.535-1.644-.649-2.544-.679-.414-.468-.63-1.011-.605-1.643.014-.304.075-.598.175-.884.135-.283.355-.475.644-.589z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EFF6EC"
        d="M102.067 214.201c-.274.503-.745.613-1.261.636-.74-.08-1.58.193-2.434-.773 1.438-.581 2.561-.868 3.695.137z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E9F2DF"
        d="M112.043 214.198c.65.107 1.234.288 1.104 1.139-.077.502-.485.637-.902.682-.87.094-1.377-.288-1.442-1.189l1.24-.632z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8D7F6"
        d="M102.065 216.052l-5.652-.179c1.298-1.808 2.982.254 4.391-.438.509.027.979.13 1.261.617z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D05762"
        d="M243.062 142.975l.091.727c.329.425.325.827-.083 1.201-.859-.12-1.896.396-2.48-.7.674-.711 1.563-.991 2.472-1.228z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7433EF"
        d="M255.78 116.893c.639 1.846.75 3.686-.069 5.513l.069-5.513z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF8E2"
        d="M95.22 216.102c-1.56-.024-2.376-.523-1.403-2.254 1.077.42.811 1.611 1.404 2.252l-.001.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E7DFF7"
        d="M245.599 109.315c-.001-.485.086-.928.57-1.178l1.306 1.25c-.69 1.654-1.242-.28-1.876-.072z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7B6A95"
        d="M253.039 131.689l.086 1.385c.206.247.375.516.512.807.202.629.217 1.269.118 1.917-.102.491-.298.924-.743 1.204-1.113-1.404-.354-3.047-.578-4.564l.605-.749z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F1EFFC"
        d="M243.435 133.017c.226-.481.614-.563 1.022-.509.382.052.911.084.772.666-.109.456-.573.507-.982.462-.395-.042-.821-.096-.812-.619z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D45E68"
        d="M238.162 146.214l-1.31-.053c.708-.74 1.542-1.205 2.597-1.192l.61.924-1.897.321z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D4D2D6"
        d="M143.27 313.447l-.015-3.062c.871.286 1.229.924 1.237 1.804l-1.222 1.258z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E1DAF9"
        d="M156.963 157.407l1.262-1.299c.179.009.357.014.536.016.127 1.311-.974 1.475-1.785 1.909a130.71 130.71 0 00-.013-.626z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EBF1F7"
        d="M114.552 226.095c1.062-.651.356-1.268-.037-1.89 1.013.038 1.369.631 1.207 1.546-.142.805-.574.927-1.17.344z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E7DFF7"
        d="M249.361 111.208l1.413-1.7c.376 1.58-.626 1.534-1.407 1.705l-.006-.005z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1B0E41"
        d="M112.003 223.627l.005 1.788-1.127-.019a2.035 2.035 0 00-.232-.437c-.148-1.051.279-1.52 1.354-1.332z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E3F4DA"
        d="M249.367 111.213c-.115.572-.127 1.294-1.032.941-.189-.073-.263-.44-.389-.673l1.415-.274.006.006z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8DEFA"
        d="M100.824 225.42a30.056 30.056 0 00-.02-.605l.636-1.146a1.202 1.202 0 01.016-.317c.932.058 1.48.447 1.275 1.484l-.245-.038-1.662.622z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B5D8F8"
        d="M113.304 438.256c.605-2.104-.964-3.713-1.271-5.607.265-.49.722-.609 1.228-.635.875-.57 2.037-.764 2.474-1.902 1.099-1.217 1.659-2.447.069-3.713-.856-4.547-1.358-4.984-5.676-4.99-1.436-.002-2.87-.014-4.305-.023-1.061-2.521-.289-5.311-1.17-7.877-.272-.791.228-1.375 1.126-1.465 2.006-.463 4.063-.561 6.096-.572 2.109-.014 3.039-.912 3.057-2.951.008-.828.057-1.688.416-2.432 1.093-2.266.231-3.486-2.031-4.031l-.017-.01c-.51-.742-.839-1.572-1.82-1.975-1.624-.664-2.79-1.77-2.388-3.775.542-2.695 2.532-4.787 4.766-4.986 1.144-.104 2.256.006 3.207.76 1.229-.004 2.458-.004 3.688-.004 1.12-1.035 2.528-.82 3.84-.779 2.123.068 2.893-.957 3.083-2.965.467-4.947.529-4.939-4.909-5.693a4.953 4.953 0 01-.75-.518l.018-.021c-.486-.988-.757-2.045.245-2.803 1.247-.941 2.298-2.01 3.309-3.209 1.054-1.248 2.558-1.152 3.931-.225l.006-.008c1.501 2.145 2.346 5.121 5.904 4.664.911-.213 1.883-.701 2.745-.396 2.518.889 2.818-.918 3.142-2.518.244-1.209.002-2.488.088-3.73.185-2.652 2.468-4.75 5.183-4.814 2.218-.053 3.754 1.398 3.66 4.414-.095 3.074 2.378 4.439 3.52 6.666.079 5.535.294 11.07-.107 16.598-1.394 1.824-3.435 1.258-5.175 1.139-4.106-.287-7.601.492-9.865 4.283-2.772 1.217-3.749 3.951-4.3 6.395-.924 4.098-.018 8.305.665 12.432 3.06 1.096 2.994 6.6 7.666 5.424.331.08.64.207.937.369 2.099 1.379 4.342 2.137 6.907 1.951 1.198-.088 2.492-.053 3.25 1.225.752 4.629.317 9.281.282 13.924-.018 2.385-1.778 2.74-3.688 2.75-5.38.029-10.76.02-16.136.01-2.813.211-4.743-.924-5.602-3.689a3.214 3.214 0 01-.333-.951c-.452-3.916-4.416-6.643-7.558-4.879-2.441 1.366-4.69 2.32-7.407 1.142z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B5D8F9"
        d="M94.566 392.01c-.415.004-.829.01-1.244.018-.734-.715-.793-1.662-.863-2.592-.142-1.877-1.212-3.066-2.88-3.674-1.806-.658-3.445-.246-4.85 1.115-.827.803-1.394 2.35-2.987 1.445-1.561-.885-1.625-2.244-.911-3.742l-.005.004c.677-2.695-.415-4.648-3-5.311-.803-.207-1.663-.096-2.461-.326-1.6-.457-2.843-1.129-1.328-2.98 1.32-1.611.893-2.818-.823-3.76-1.139-1.398-3.257-1.209-4.339-2.816-1.109-1.65-.981-3.328.883-3.6 3.861-.564 2.957-3.219 2.929-5.59-.205-1.615-2.781-1.928-2.194-3.98a.942.942 0 01.638-.533c2.503-.557 5.152-.287 7.564-1.439 1.001-.479 2.008-.021 2.959.477.879.461.998-.313 1.226-.865.396-.961-.215-.994-.896-1.01-1.155-.031-2.374-.041-2.852-1.377-.4-1.117-.483-2.35.53-3.158 1.169-.932 2.68-1 3.702.059 1.309 1.361 2.123.965 3.338-.086 3.205-2.77 4.257-2.344 5.144 1.877 2.972-3.926 8.001-2.252 11.671-4.287.715.984.676 2.141.608 3.24-.114 1.836.795 2.34 2.412 2.129.689-.029 1.36.072 2.029.217 1.602.061 3.312-.666 4.729.672l.011-.006c.659 1.004.913 2.092.667 3.275-.122.621-.515 1.107-.82 1.646-1.285 2.27-.904 3.281 1.59 3.998.76.219 1.352.453 1.607 1.24.461 2.42-.875 3.955-2.585 5.311-3.74 2.783-3.795 3.113-.696 6.645.771.877 1.047 1.787.667 2.844-.482 1.342-1.624.934-2.642.932-3.932-.012-5.589 2.369-4.142 6.064.396 1.01.414 1.771-.326 2.537-.984 1.021-2.064 1.348-3.313.461l-.002-.002c-.751-1.732-1.859-2.395-3.886-1.965-1.886.398-2.926 1.125-3.001 3.109-.059 1.504-.849 2.713-1.858 3.784z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B8D8F3"
        d="M103.306 345.895c-2.349 2.033-4.991 3.041-8.153 2.523-1.32-.217-1.864.563-1.842 1.848.014.844-.021 1.754-1.213 1.773-1.185.016-1.169-.863-1.286-1.721-.143-1.045.618-2.529-.865-3-1.469-.463-2.063 1.078-2.981 1.832-1.347 1.105-2.646 3.4-3.923-.154-.359-1.002-1.665-.693-2.531-.465-1.26.332-.89 1.471-.869 2.35.027 1.141.891 1.289 1.767 1.23.712-.049 1.411-.291 2.124-.342.369-.027.857.07 1.106.305.347.33.165.846-.235 1.025-1.625.732-.687 2.434-1.434 3.686-3.412-3.957-7.085-.146-10.659-.357-.712-.043-.956-.453-1.458-.547-.254-2.262-.254-2.262 3.148-1.266 3.685-.754 4.588-2.279 2.931-5.246-.854-1.531-.963-2.604.791-3.516 1.43-.744 2.674-2.211 4.149.006.871 1.311 1.892 2.129 3.886 1.475 2.329-.766 1.85-2.385 1.965-3.955 1.388-2.557 3.494-1.855 5.583-1.23.194.689.477 1.367.561 2.068.147 1.238.496 2.17 1.968 2.277 1.418.104 2.605-.109 3.494-1.398.781-1.131 1.229-3.148 3.361-1.703.943.65 1.499 1.4.615 2.502z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E3F5FD"
        d="M115.796 362.092c-1.063-.953-3.035.934-3.812-1.449-.675-2.068-.632-3.58 1.308-4.762.919-.838.268-2.297 1.231-3.115 1.954 1.398 1.419 3.412 1.3 5.314-.101 1.619-.167 3.086 1.979 3.568 2.803.629 1.673 3.486 2.401 5.205.518 1.221-1.785 1.342-3.098 1.59-1.063.201-2.124.732-3.035 1.342-1.141.764-1.128 1.633.238 2.268 1.75.813 4.282 5.758 3.17 6.488-1.237.811-2.792 2.689-4.14 2.064-2.035-.941-2.026 1.615-3.373 1.332 1.069 1.998-1.479 3.951-.075 5.922.193.271.795.52 1.078.42 3.21-1.148 4.805.678 6.062 3.188-.083.057-.184.182-.248.164-3.475-.9-6.29-.375-7.657 3.441-.088.244-.524.24-.829.125l1.064-4.766c-1.937.885-2.901-.656-4.181-1.477 1.827-2.273 2.792-4.482 1.661-7.662-.665-1.871 2.339-3.803 4.48-3.129 1.444.453 2.525.697 3.338-.951.698-1.418.186-2.217-.896-3.162-2.332-2.035-2.384-3.432-.567-6.453 4.407-1.454 4.709-2.095 2.601-5.505z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B5D8FA"
        d="M124.52 319.678c1.557.025 2.071-1.471 3.261-2.445.831 1.75.347 3.387.492 4.943-.031.139-.061.275-.089.412-.545 2.174-.731 4.342.107 6.49.155.221.283.455.394.699.292.674.373 1.529 1.386 1.576.839.096 1.693.016 2.508.285.277.119.504.299.684.541-1.79 1.729-4.5 1.922-6.242 3.73-.586.516-1.25.572-1.962.33-2.229-.08-3.989-.574-3.039-3.451l.04-.625c1.14-1.201.075-1.801-.682-2.482a7.055 7.055 0 01-.582-.045c.063-1.449-2.718-2.883-.02-4.344l.594-.637c1.262-.793.928-1.764.297-2.766-.369-1.084-.386-2.037.912-2.506.61.322 1.323-.01 1.941.295z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BAD9F0"
        d="M113.302 367.764c-.756 2.555-1.542 5.014 1.984 6.354 1.624.615.962 1.818.301 3.059-.76 1.426-1.157 2.961-3.3 2.205-1.248-.438-2.454-1.842-3.83-.086-1.136 1.447-1.403 2.756-.37 4.438.992 1.615.838 3.133-1.316 3.838-.704.229-1.279.672-1.591 1.385-.854-.395-1.49-1.006-1.869-1.873 3.298-.375 3.506-.76 1.988-3.688-1.22-2.354 2.167-6.285 5.293-6.338.847-.016 2.071 1.379 2.61-.342.449-1.434-.705-1.674-1.689-2.365-3.077-2.156-2.371-4.725 1.779-7.236.216.141.29.285.221.43-.069.146-.14.219-.211.219z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B9D8F3"
        d="M122.653 382.094c6.827-.004 7.246.457 5.958 7.184-.345 1.801-1.055 3.354-3.541 2.852-1.388-.279-2.877-.057-4.321-.063.019-1.029.715-1.668 1.39-2.279 1.629-1.477 2.003-3.193 1.131-5.199-.463-.769-.878-1.548-.617-2.495z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BDD7EE"
        d="M125.149 335.914l1.871-.004c.025.809.439 1.227 1.249 1.248 1.264 2.004 4.002 2.617 7.15 1.375 1.414-.559 2.695-.895 4.086-.131.714 0 1.431-.039 2.142.01 1.699.117 3.093-.031 2.888-2.332-.115-1.295.854-1.434 1.851-1.412-.399 1.447-1.492 2.67-.224 4.451.798 1.121-1.266 1.867-1.684 2.994l.007.014c-.762.691-1.265.146-1.766-.377-1.27-1.322-2.642-1.244-4.077-.301-1.377.615-2.447 1.633-3.482 2.693-1.107.068-1.233-.91-1.644-1.564-1.034-1.643-2.109-1.863-3.283-.143-.737.623-1.626.834-2.55.957-.894-.047-1.483-.539-1.892-1.293.624-1.955 1.275-3.91-.639-5.574-.219-.135-.292-.27-.219-.408.07-.137.143-.203.216-.203z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BBD8F2"
        d="M73.355 372.102c3.298.449 3.42 1.59.58 5.443 1.099 1.072 2.498.75 3.813.809 2.173.092 3.229 1.777 4.117 3.303.492.844.882 2.52-1.039 2.928-1.551-3.432-2.651-3.918-5.599-2.477-1.044.877-2.082.93-3.111-.025-1.536-2.078-2.375-4.025.463-5.844 1.222-.781.678-2.27.751-3.473-.183-.154-.24-.305-.172-.449.068-.143.133-.215.197-.215z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BBD8F2"
        d="M80.831 384.58c.032 1.027-.156 2.121.765 2.902.54.457 1.114 1.16 1.662-.023 1.394-3.01 4.165-3.514 6.708-2.625 2.373.83 3.911 3.01 3.365 5.947-.074.402-.008.83-.007 1.246-2.231.275-1.818-1.381-1.911-2.641-.149-2.012-1.69-2.264-3.201-2.691-1.271-.359-2.06.105-2.437 1.207-1.094 3.197-2.965 2.721-5.171 1.24-2.505-1.679-.789-3.089.227-4.562z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BAD7EF"
        d="M113.315 402.057c4.321.057 4.353.109 2.705 4.297-.111.279-.154.59-.207.891-.259 1.488.711 3.42-.592 4.398-1.394 1.049-3.389.307-5.117.395-1.438.072-2.883.008-4.326.006.014-.205.022-.41.025-.615 2.092.297 4.055-.584 6.107-.678.381-.02.838-.172 1.111-.424 1.196-1.108 1.368-6.886.294-8.27z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BFD8EE"
        d="M108.298 395.197c1.584-4.35 4.246-6.178 8.733-3.73.004.201.014.402.031.604-2.918-.141-5.426-.178-6.842 3.457-.886 2.273-.116 3.273 1.359 3.811 1.547.563 1.813 1.383 1.72 2.709-.787-.488-1.526-1.09-2.37-1.439-2.512-1.046-3.793-2.617-2.631-5.412z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C2DAEE"
        d="M73.355 372.102l-.025.664c-.886-.482-1.548-1.4-2.734-1.287-2.118.203-3.583-.172-3.553-2.904.025-2.311.598-3.566 3.128-3.383 1.049.076 1.765-.502 1.891-1.627.167-1.486.626-3.068-1.211-3.941.112-.105.226-.213.338-.324.792-.377 1.513-.281 2.154.332.021 2.82.729 5.889-3.447 6.701-.994.193-1.448 1.273-.427 2.652 1.08 1.458 3.222 1.337 3.886 3.117z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BBD8F2"
        d="M94.566 392.01c-.086-2.242 1.168-4.18 1.544-6.359.363-2.104 3.135-.738 4.816-1.041 1.924-.346 2.598.672 2.382 2.471-1.233-.416-1.768-2.348-3.731-1.316-1.837.965-2.663 2.217-2.488 4.189.176 1.976-.951 2.267-2.523 2.056z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BCD8EE"
        d="M129.518 375.854c-1.099.109-3.097-.334-3.149.34-.234 3.006-4.75 2.643-4.335 5.896-1.625-1.639-1.79-3.123.377-4.477 1.217-.76 2.431-1.559 3.519-2.486 1.585-1.357 2.717-1.125 3.588.727z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E0F5FD"
        d="M108.282 352.125l-1.824-.01c-2.29-.926-2.933-2.609-2.209-4.891.335-1.055.362-2.197.91-3.191.358.172 1.046.412 1.027.5-.655 3.072 2.077 4.328 3.353 6.35.358 1.201-.949.717-1.257 1.242z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C0D8EE"
        d="M105.159 344.033c.463.746.624 1.5.154 2.322-1.281 2.244-.646 4.121 1.146 5.762-2.586.461-3.494-.697-3.173-3.188.128-.996.021-2.023.021-3.035.101-.91-.205-1.719-.617-2.502.823.213 1.645.426 2.469.641z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C4DBEA"
        d="M125.149 335.914c.002.203.002.406.002.611-.518.016-.994.121-1.295.602a.967.967 0 01-.597.6c-1.713.295-2.891-.738-3.349-2.045-.543-1.551 1.126-2.109 2.108-2.893.11 1.977 1.139 3.033 3.131 3.125z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C1D7E8"
        d="M120.774 325.293c-.161.936-1.34 1.922.192 2.76 1.147.629.132 1.08-.173 1.584-1.163-.225-2.842.768-3.142-1.451-.34-2.516 1.595-2.457 3.123-2.893z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6FCFC"
        d="M125.79 342.1l1.864.674c.303.432.957.182 1.248.639 1.132 1.766.59 3.717.616 5.604l-3.728-6.917z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C4DAF2"
        d="M135.135 380.848c-3.338-.102-5.262-1.816-5.611-5 .619.422 1.239.84 1.858 1.264.809 1.572 1.471 3.322 3.756 3.117.211.137.281.275.21.414-.071.136-.142.205-.213.205z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B8D7F7"
        d="M123.283 319.68c-1.67.201-1.139 1.506-1.25 2.49-.204.227-.411.221-.62.01-.209-.004-.418-.006-.626-.008l-.664-1.217c-.216-1.557.297-2.666 1.907-3.1.626-.012 1.253-.02 1.879-.029.603.891.07 1.401-.626 1.854z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C3DBF0"
        d="M108.282 352.125c.419-.414.838-.826 1.256-1.242l.632-.615c1.227-.695 2.19-.143 3.104.654l.02 1.213-5.012-.01z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF3F7"
        d="M123.259 337.727c.199-.199.399-.398.598-.6.428.441.863.875 1.286 1.32.649.684.081 1.08-.355 1.52-.354.357-.647.889-1.267.604-.809-.375-.409-1.021-.315-1.607.065-.405.038-.825.053-1.237z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C2D5DC"
        d="M93.306 342.148c-1.898.24-4.071-.764-5.583 1.23a3.324 3.324 0 015.583-1.23z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C2DAEE"
        d="M74.002 354.615c-.909.771-3.113-1.678-3.148 1.266l-.001.002c-.271.328-.61.379-.996.248-.09-.086-.179-.174-.268-.262 1.137-3.08 1.442-3.168 4.413-1.254z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BDD6EA"
        d="M121.412 322.18l.62-.01c.864.086 1.289.543 1.188 1.426-.135 1.184-1.045 1.037-1.852 1.061l.044-2.477z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C3D8E8"
        d="M121.376 329.682c.801.027 1.707-.119 1.845 1.055.102.867-.293 1.346-1.164 1.428l-.681-2.483z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CEE2E9"
        d="M114.523 352.766c.029 1.213.227 2.49-1.231 3.115l.012-3.752c.406.211.813.424 1.219.637z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C2DAEE"
        d="M70.851 359.623c-1.782-.793-3.501-1.607-1.262-3.754l.024.021c.373 1.254 1.842 2.135 1.257 3.715l-.019.018z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E0F5FD"
        d="M113.274 350.922c-1.035-.219-2.07-.438-3.104-.654 1.249-.799 2.452-1.379 3.104.654z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D4E4F1"
        d="M72.117 382.082c1.034.33 2.072.279 3.111.025-1.051 1.608-2.089 1.717-3.111-.025z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D3DFEC"
        d="M122.653 382.094c.426.777.728 1.586.618 2.494-1.116-.473-1.307-1.414-1.256-2.477.213-.004.425-.009.638-.017z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2C2468"
        d="M263.013 56.094c2.739-2.622 6.223-1.353 9.379-1.792.676.114 1.358-.354 2.032.02.313.282.538.628.749.985.66 1.203 1.85 1.479 3.049 1.74.693.292 1.208.735 1.294 1.539-.186.797-.766 1.496-.584 2.372.589 1.178 1.195.026 1.791.005.279-.056.553-.056.829 0 3.035 2.284.765 5.072.593 7.595-.099 1.439-1.351 2.686-1.261 4.344.055 1.012-.836 1.326-1.747 1.245-.876-.078-1.391.189-1.376 1.146-.247 1.079-.617 2.029-2.007 1.895-.725-.278-1.229-.851-1.803-1.335-1.117-1.258-1.827-2.723-2.196-4.357-.142-.541-.134-1.134-.57-1.568-1.472-.58-2.819-.071-4.218.347-3.058.912-6.097 1.025-9.001-.61-.958-.54-1.674-1.024-1.081-2.41 1.683-3.926 2.451-8.333 6.128-11.161z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#241E4F"
        d="M286.201 53.798l.699.95c.175.252.242.531.205.835-2.574 3.182-2.583 3.187-.173 7.001.638 1.011.368 1.969-.041 2.945-.63 1.502-.264 2.749.88 3.914 1.062-.959.584-2.27 1.132-3.237.46-.616.723-1.612 1.841-.96.92 1.408.596 2.96.53 4.482-.874 3.289-1.261 6.801-4.126 9.2-1.592.658-2.73-.437-4-1.034a2.298 2.298 0 01-.622-.716c-.761-1.558-1.771-3.106-1.236-4.931.419-1.428 1.079-1.417 1.589.022.111.153.226.305.376.426-.208-.182-.351-.411-.481-.659-1.282-2.479-.399-5.003-.148-7.499.135-1.349.308-2.647-.658-3.772-.519-.691-2.018-.506-1.741-1.926a2.961 2.961 0 011.142-1.668c.167-.098.459-.223.456-.361-.003-.165-.293-.212-.541-.146-1.611-.198-2.283-2.162-4.022-2.081-.599-.077-1.185-.193-1.708-.518-.635-.573-.899-1.253-.604-2.095.093-.167.227-.213.402-.137 2.164.093 4.33-.057 6.493.076 1.713.025 2.871 1.336 4.356 1.889z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2E2C5D"
        d="M263.013 56.094c-1.783 2.882-3.202 5.925-4.568 9.034-1.39 3.162-1.073 4.576 2.462 4.812 2.156.144 4.367.533 6.581-.842 1.249-.775 3.371-.949 4.922.375-3.552 4.307-8.312 3.36-12.928 2.921-.911-.085-1.788-.512-2.691-.75-.487-.222-.884-.497-.638-1.132.016-3.684 1.023-7.122 2.579-10.425.436-.629.226-1.72 1.336-1.865l2.945-2.128z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8D1D8"
        d="M256.769 71.24c1.441-1.023 2.417.53 3.655.721 4.355.668 8.298-.174 11.986-2.488l.003 1.754c-.902 3.02-3.454 1.936-5.462 2.208-1.518-.109-3.042.019-4.559-.044-1.829-.342-3.142.513-4.252 1.843-.471.176-.909.146-1.293-.21l-1.254-.004.084-1.393c.311-.82.237-1.817 1.092-2.387z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EAF3F4"
        d="M260.069 58.222l-1.336 1.865c-1.876-.779-1.831 1.26-2.856 1.933-.606-.903.362-1.919-.424-3.017-.788-1.102.322-2.576 1.459-3.309 1.448-.933 1.423.932 2.152 1.408.406.265.675.739 1.005 1.12z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F8E5F2"
        d="M243.125 73.772l-.012-3.738c.89-.127 1.777-.29 2.671-.376 2.175-.21 3.874.186 3.546 2.976-.369.314-.791.331-1.236.225-3.078-1.464-3.078-1.464-3.605 1.386-.694.531-1.018-.003-1.364-.473z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D7353E"
        d="M252.959 75.063c.422 2.025.834 4.049-1.067 5.634a1.556 1.556 0 01-.574-.727c-.308-1.664-.449-3.366-1.106-4.955-.057-.495.031-.944.406-1.303 1.064-.041 1.427 1.133 2.341 1.351z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E7F4F1"
        d="M255.064 66.508c.169-.178 1.151 1.01-.007.714-.636-.163-2.438.564-1.947-1.382.159-.63-.509-1.957.991-1.555.656.175 2.544-.242.963 2.223z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E02B37"
        d="M250.619 73.711c-.011.44-.021.881-.033 1.321-1.885.43-3.466-.465-5.094-1.167-.422-1.083.062-1.626 1.098-1.84.539-.013 1.023.187 1.509.382l1.23.226 1.29 1.078z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#302443"
        d="M281.843 51.909c-2.173.718-4.339.859-6.493-.075 2.177-1.052 4.34-.903 6.493.075zM274.948 51.97l.624 1.847c-.32.485-.791.629-1.34.596-.632.289-1.29.991-1.838-.111.543-1.115 1.255-2.044 2.554-2.332z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4C4061"
        d="M256.769 71.24c.072.995-.144 1.859-1.093 2.387a.454.454 0 00-.106-.475c-.36-.792-.633-1.577.143-2.298.158-.1.305-.213.441-.341l.615.727z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F8F5F3"
        d="M255.712 70.854l-.143 2.298c-.719-.618-1.194-1.308-.668-2.288.263-.489.536-.487.811-.01z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B5D8F8"
        d="M628.817 372.102c-.861.127-2.227-.342-2.32.902-.145 1.871-.867 3.879.732 5.609 1.756 1.895 3.545 3.68 6.211 4.355 1.557-.273-1.551-2.002.516-2.094 1.709-.074 3.666-.502 4.627 1.588.695 1.508-.449 2.387-1.447 3.051-3.861 2.563-3.465 3.705-2.602 8.225 1.045 5.488 4.525 4.539 8.016 4.586 1.268 1.389-.014 2.957.313 4.406-.932 2.42-2.762 2.797-4.656 1.508-1.672-1.145-2.205-.555-2.928.898-1.137 2.281-1.9 4.686-2.684 7.348.777.143 1.676.143 2.453.59 3.08 1.777 3.406 3.428.982 5.963-.9.939-1.391 2.346-2.852 2.703a1.624 1.624 0 01-.824-.275c-.455-.41-.645-1.049-1.137-1.41-3.697-2.725-5.008-2.697-5.701 1.553-.271.566-.748.922-1.258 1.246-1.377 1.203-.867 2.549-.27 3.877.766 1.701.791 3.352-.227 4.967-3.508 2.43-4.137 2.463-6.182.355-.41-.713-.859-1.406-1.219-2.145-1.338-2.758-5.484-3.656-7.527-1.35-.848.955-1.143 2.684-1.133 4.059.02 3.143-1.939 3.375-4.154 3.037-2.535-.387-5.645-.297-4.422-4.652.297-1.061-.188-2.629-.266-3.971-1.383-1.391-2.994-2.529-4.373-3.938-.344-3.535-.428-7.064.043-10.594 1.375-1.541.453-4.664 3.479-5.078.508-.021.908.186 1.201.596.668 3.887 3.535 1.703 5.512 1.977 2.809.107 5.441-.445 7.801-2.047a4.495 4.495 0 011.342-.393c3.412-.275 3.412-.275 4.598-5.553 1.471-3.477 1.117-7.725-.801-9.406-2.027-1.936-4.232-3.703-5.799-6.078-.297-1.035-1.148-1.021-1.99-1.068-4.941-.275-9.799.057-14.461 1.918-1.674-1.051-1.313-2.758-1.402-4.32 2.002-4.523 3.936-9.082 6.309-13.438 1.424.01.607 1.881 2 2.225.102-1.551.385-2.699 2.41-2.979 1.387-.195 1.711-2.059 1.664-3.641-.035-1.299-.633-3.086 1.805-3.105 1.744-.012 2.936-.084 3.322 2.395.42 2.709 1.348 5.578 4.125 7.197 1.258.732 2.723.725 3.703.172 1.477-.828 2.656-1.609 3.967.26.832-1.725-.09-4.215 2.705-3.744 2.076.347 2.953 1.656 2.799 3.713z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E7F6FA"
        d="M617.581 432.053c2.125 1.893 3.809.029 5.631-.66 2.078-1.16 1.717-2.826.82-4.475-.883-1.633-1.328-3.197-.152-4.857.506-.023.953-.156 1.205-.646 2.264-3.576 4.008-3.582 7.494-.027l.014.016c.682.768 1.852-.299 2.48.662-.912 1.188-1.063 2.889-2.506 3.719-.023-.68-.51-1.078-.891-1.57-.602-.783-.301-2.635-2.068-1.98-1.305.484-2.018 1.553-2.064 3.123-.088 2.934-.006 4.205.934 6.453-1.803.063-3.055.639-4.154 2.34-1.968 3.033-4.968 2.003-6.743-2.098z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F4F0FD"
        d="M617.59 445.76c.416.387.832.773 1.248 1.164-.645.832-1.584.912-2.514.922-6.795.057-13.592.074-20.385-.01-.729-.008-1.436-.137-2.055-.564-.477-.443-.764-1.02-.768-1.645-.049-6.387-.512-12.781.244-19.16.322-.551.723-.93 1.416-.615.334.176.598.434.783.764 1.193 3.938-.066 7.918.184 11.875.076 1.193-.313 2.48.625 3.523-1.676 3.74-1.676 3.74 2.896 3.74l18.326.006z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E6F7F5"
        d="M596.37 442.014c-2.355-.854-1.262-2.885-1.162-4.256.277-3.801-.139-7.566-.088-11.348 1.076-.695 1.846-.234 2.502.664-.102 5.006-2.086 9.856-1.252 14.94z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B8DBE9"
        d="M597.622 427.074c-.832-.221-1.668-.441-2.502-.664l.018-.066c-.574-.807-.783-1.617-.008-2.43 3.49-1.652 2.365 2.225 3.73 3.117-.414.014-.826.03-1.238.043z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B6D8F9"
        d="M103.311 470.719c-.225-1.525-1.415-1.23-2.4-1.236-3.302-.021-6.608-.098-9.907.021-1.945.07-2.992-.469-2.69-2.582 2.402-1.205 5.089-.75 7.595-.998 3.691-.363 7.426-.629 11.148-.84 1.487-1.254 3.329-.578 4.98-.92.296-.057.597-.064.893-.033.277.063.54.176.782.324.687.5 1.493.592 2.31.627.415.018.666-.09.251-.059-.015.002-.044-.184-.067-.295a.87.87 0 01.481-.582c.417-.137.833-.135 1.255-.061 1.455.311 2.964.422 4.281 1.213.594.447 1.364.785 1.105 1.764-.309.279-.656.475-.368.479.697-.07 2.21.236 3.311-1.063 1.379-.512 2.812-.289 4.224-.342.761.014 1.522.041 2.242.322 1.215.221-.281 1.664.869 1.93.314.684.313 1.363-.029 2.035l-.312.297c-3.092-.756-5.787 1.256-8.77 1.26-.401-.004-.802-.012-1.204-.016-3.514-.541-6.951-2.248-10.606-.691-3.121-.314-6.273.008-9.374-.554z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4F2B89"
        d="M107.057 459.963c-3.119-1.463-4.83-3.658-4.273-7.346.244-1.619-.028-3.314-.066-4.975a.761.761 0 00.202-.521c.166.053.333.102.502.143.21.227.361.488.459.779.083.291.129.588.158.887.064.811.146 1.641.034 2.439-.397 2.848.753 4.922 3.05 6.482.286.391.405.828.377 1.309-.054.32-.202.588-.443.803z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CFD4D2"
        d="M83.324 467.59l-.025 1.338c-.565-.178-1.602.203-1.47-.838.081-.629.942-.449 1.495-.5z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#382E69"
        d="M230.548 62.996c.197.885-.212 1.917.637 2.646-1.308 5.227-3.43 9.959-8.004 13.207l-.835-.78c-.051-1.526 1.212-2.301 1.989-3.316.833-1.09 1.09-2.131.511-3.371.678-1.777 2.488-3.111 1.954-5.383-.142-.602.632-.997 1.161-1.326 1.034-.289 1.459-1.529 2.587-1.677z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EDD3E6"
        d="M246.986 81.791l-2.614.72c-1.903.507-3.269.066-3.67-2.079-.034-.136-.065-.274-.096-.41.046-1.115-.37-2.63 1.714-1.984.126.05.252.1.38.147.54.599 1.095 1.177 1.878 1.468.911.593 2.226.731 2.408 2.138z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CCC5CA"
        d="M234.304 85.672l-1.183-.664.02-.662c.893-1.467 2.944-1.525 3.753-3.094 1.434-.214.791-2.497 2.464-2.471.019.407.037.813.054 1.22.746 1.281-.185 1.979-.947 2.738-1.569.717-2.804 1.912-4.161 2.933z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CFDDF7"
        d="M238.102 82.505c.385-.861 1.342-1.423 1.31-2.503l1.194.02.002.003c.684 2.864.328 3.216-2.506 2.48z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F1D4DC"
        d="M243.125 73.772l1.113.522.374.306c.438 1.328.108 2.215-1.393 2.432-.307-.218-.36-.487-.158-.806l.064-2.454z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EDD3E6"
        d="M243.062 76.226l.157.896c.192.647.179 1.152-.725 1.026l-.172-.11c-.252-.808-.65-1.675.74-1.812z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B6D8FD"
        d="M193.181 470.721c-.082 1.264.409 1.889 1.776 1.896 1.081.008 2.299-.436 3.208.594-4.043.002-8.162.506-12.116-.086-16.762-2.514-33.595-.461-50.375-1.164-.985-.041-2.189.301-2.411-1.24 1.199-1.07 2.686-.998 4.131-.998 17.226-.021 34.451-.021 51.677-.002 1.241.002 2.501-.041 3.651.576.154.139.306.279.459.424z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4612AB"
        d="M637.547 461.898c-1.002.783-2.145 1.223-3.395 1.4-1.393.207-2.783 1.027-4.178.006-.346-2.322 1.615-1.887 3.064-2.496-2.814-.506-5.467-.635-7.971.061-2.455.68-4.889.877-7.387.877-52.91-.002-105.816 0-158.725-.008-1.66 0-3.334.137-4.965-.307-.988-.27-1.646-.859-1.619-1.986.029-1.133.73-1.678 1.729-1.889 1.539-.324 3.105-.197 4.664-.197 56.025-.008 112.053 0 168.078-.02 1.844 0 3.766.369 5.469-.744 3.258-.678 6.525-.818 9.801-.111.494.24.754.645.787 1.189-1.381 1.911-4.35 1.823-5.352 4.225z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#43329A"
        d="M630.069 463.229l4.084.07c-.922.418-1.848.834-2.771 1.252-.99 1.242-2.531 1.244-3.867 1.727a8.04 8.04 0 01-1.461.264c-1.809-.096-3.656 1.311-5.426-.145.021-1.438 1.18-2.033 2.199-2.271 2.367-.55 4.761-1.151 7.242-.897z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#442097"
        d="M637.547 461.898c.248-3.141 2.453-3.633 4.984-3.682.203.125.271.254.209.389-.064.135-.127.201-.193.201-.691.609-1.383 1.219-2.074 1.826-.974.423-1.951.845-2.926 1.266z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BBC4F8"
        d="M627.364 465.623l4.018-1.072c.395.188.787.379 1.182.566 0 .203 0 .404-.002.605-.705.811-1.678.789-2.625.867-.958-.058-1.929-.077-2.573-.966z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B4D9F8"
        d="M647.547 342.148c2.174-.594 5.514 1.723 6.24-2.494 1.939-.014 3.951-.494 3.951 2.744 0 1.186 1.77 2.15 3.299 2.205 1.834.066 1.396-1.385 1.49-2.453l-.004-.004c.783-.506 1.594-.734 2.477-.252.904.898.783 2.01.721 3.152-.102 1.869.408 3.426 2.496 3.949.717.02 1.428-.094 2.131-.086 2.359.027 2.791.711 2.186 3.25l-.008-.006c-.965.771-2.92.572-2.689 2.504.176 1.453.596 2.846 2.313 3.344.697.201 1.25.734 1.652 1.365.98 1.535.52 2.881-1.309 2.986-1.656.094-2.039 1.084-2.482 2.252-.174.031-.35.047-.523.055-1.074 1.086-.303 1.779.525 2.459.426 1.525 1.43 3.244-1.244 3.738-.305-.379-.768-.57-1.098-.918a12.149 12.149 0 01-.154-.326l.004-2.5c-1.018-1.176-1.463-3.215-3.746-2.496h-1.246c-1.213-1.41-.76-3.117-.865-4.73-.096-1.52.332-3.096-.482-4.531-1.24-1.492-2.121-3.348-3.75-4.447-2.664-1.799-4.754-1.346-7.232 1.297-1.4.643-2.582 1.643-3.898 2.426-.828-.01-1.656-.004-2.482-.041-.547-.023-1.014-.242-1.131-.842-.129-.658-.039-1.365.713-1.473 1.773-.252 1.744-1.504 1.641-2.768-.164-1.9 1.131-3.236 1.879-4.74.442-.894.592-1.703.625-2.619z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C0DAEF"
        d="M670.01 364.605c.072-1.084-.285-2.404 1.506-2.484.869-.041 2.027.24 2.141-1.152.1-1.223-.938-1.777-1.73-2.377-.541-.408-1.43-.18-1.885-.912-.891-1.439-1.777-2.994-1.102-4.652.67-1.648 2.359-.643 3.586-.873-2.172 3.285-1.916 4.471 1.48 5.582 1.611.527 1.633 1.596 1.617 2.873-.016 1.379-.68 2.254-2.059 2.084-1.726-.214-2.634.788-3.554 1.911z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C7D9EA"
        d="M672.534 352.16c.098-4.355-3.27-1.826-5.014-2.521-.377-.447-.332-.885.033-1.311 1.287.289 2.455-.211 3.611-.613 2.1-.727 2.072 1.146 2.674 2.16.85 1.424.143 2.1-1.304 2.285z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C7D8E7"
        d="M665.02 342.154c-.832-.004-1.662-.006-2.496-.008.887-1.496 1.609-3.084 3.828-1.461 2.301 1.684 1.471 3.092-.061 4.604-1.103-.768-.191-2.355-1.271-3.135z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BCD6F2"
        d="M665.02 342.154c2.023.395.959 2.043 1.271 3.135.422 1.014.842 2.025 1.26 3.039l-.031 1.311c-3.955-1.453-2.025-4.869-2.5-7.485z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BDD8F0"
        d="M670.012 367.119c-1.121.004-1.23-.867-1.416-1.654-.184-.779.371-.777.887-.805-.068.682-.164 1.371.533 1.83l-.004.629z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BED9EF"
        d="M113.291 470.725c.275-1.73 1.72-1.443 2.634-1.162 2.145.666 4.242 1.346 6.531 1.271.555-.02.742.611.834 1.131-3.333.002-6.667.006-10 .01-1.256-.24-2.659.42-3.787-.615 1.162-.811 2.625.175 3.788-.635z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E7F8FC"
        d="M140.79 309.714c-.292 1.395-.727 2.522-2.538 2.514-1.803-.009-2.262-1.098-2.505-2.522-.529-.306-1.145-.528-1.237-1.262.696-.862 1.358-.419 1.628.263 1.081 2.73 2.848 1.86 4.652 1.007z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BCD4E0"
        d="M134.51 308.443c.584.25 1.046.625 1.237 1.262-2.063-.415-2.496 1.635-3.733 2.469-.076-1.851-.371-3.849 2.496-3.731z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6394B2"
        d="M642.518 253.412l.092 1.402c1.32 2.154.834 4.446.512 6.727a1.653 1.653 0 01-.674.811c-1.627-2.994-1.567-5.973.07-8.94z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#51A1C9"
        d="M646.917 266.606c-.021.278-.045.559-.066.839-2.158-1.1-3.801-2.646-4.402-5.094l.188-.137c.633-.555 1.344-.636 2.117-.349.268.141.453.359.57.635.063.993.35 1.897 1.09 2.612.385.425.139 1.06.503 1.494z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4382AC"
        d="M640.09 178.046a36.701 36.701 0 00-.049-.667c.666-.837-.297-1.721.074-2.567 1.045.084 2.357-.354 2.441 1.439.089 1.905-1.235 1.758-2.466 1.795z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D5F2F9"
        d="M640.563 183.534c.121-.619.24-1.238.359-1.858 1.771-.381 1.254 1.154 1.629 1.941-.646-.431-1.316-.274-1.988-.083z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C3ADF8"
        d="M230.548 62.996c-.588.926-.435 2.735-2.403 2.013-2.586.914-3.468 2.618-3.288 6.358 1.688.527 2.296 1.304.826 2.823-1.184 1.223-2.23 2.58-3.337 3.878-2.681 1.082-3.729-.229-3.708-2.703.054-6.616 2.593-12.302 6.812-17.279.933-1.1 2.143-2.259 3.744-1.666 1.708.634 1.391 2.359 1.442 3.777.033.931-.054 1.866-.088 2.799z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FBDBBA"
        d="M299.293 80.024c-1.658.167-1.152 1.459-1.262 2.431-1.934.189-.721 2.867-2.507 3.172-2.112-.282-2.978-2.9-5.287-2.816-.763-.233-1.241-.775-1.597-1.454-1.762-2.371-.493-4.23 1.158-5.856 1.431-1.409 2.417-3 2.948-4.905.269-.544.605-1.045.719-1.674.179-.979.197-2.222 1.561-2.285 1.457-.067 2.085.955 2.5 2.243.443 1.38.728 3.596 2.729 1.031 1.063-.964 1.808-.823 2.083.646.129.693.093 1.424.646 1.973l.005 2.48c-.917 1.903-3.492 2.585-3.698 5.014h.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6E0C3"
        d="M302.985 72.532c-1.066-.085-1.253-.816-1.197-1.683.066-1.043-.411-1.197-1.253-.822-1.217-4.513-3.442-8.597-5.426-12.785-.314-.664-.361-1.402-.275-2.14.088-.52.29-.978.713-1.314 2.696 3.634 4.03 7.982 6.221 11.882.101 1.36-.397 2.919 1.244 3.771-.011 1.03-.019 2.06-.027 3.091z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5E0C8"
        d="M299.292 80.026c-.808-3.177 1.83-3.812 3.698-5.014l.029 1.869c-1.473.775-1.889 2.803-3.727 3.145z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C1D8DF"
        d="M113.291 470.725c-1.107 1.133-2.529.398-3.787.635l-6.191-.074a21.366 21.366 0 01-.001-.566l9.979.005z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5417CB"
        d="M593.887 446.945c8.318-.008 16.633-.016 24.951-.021 8.295.096 16.59.189 24.885.287-.186 1.025-1.039 1.059-1.807 1.221-16.023.064-32.047.234-48.064-.08a2.514 2.514 0 01-1.008-.506c-.291-.32-.287-.645.008-.963a.993.993 0 011.035.062z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4E2196"
        d="M645.055 448.25l-.01 7.494c-.387.357-.822.375-1.283.17-.354-.318-.543-.729-.67-1.176-.67-1.713-.004-3.494-.262-5.232.012-.311.086-.602.232-.875.579-.565 1.179-1.049 1.993-.381z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#492F87"
        d="M643.827 455.75l1.219-.006c.166 1.834-1.35 2.299-2.498 3.063a29.041 29.041 0 01-.016-.59l.047-1.225c.129-.703.539-1.121 1.248-1.242z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4B2D86"
        d="M645.055 448.25c-.637.213-1.271.428-1.91.641-.492.188-.721-.096-.885-.496a.907.907 0 01.26-.719c.4-.156.803-.313 1.203-.465.893-.229 1.555-.162 1.332 1.039z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BDD8EC"
        d="M658.782 374.604c1.059.74 2.119 1.477 3.74 2.607-.449-4.277.031-7.67 4.994-7.598.383 1.211-.951.691-1.236 1.227-1.529 1.242-2.178 2.531-1.543 4.721.758 2.605-2.197 2.316-3.449 3.385-.838-1.232-1.676-2.465-2.516-3.697-.209-.145-.279-.291-.207-.432s.143-.213.217-.213z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BDD3E3"
        d="M658.782 374.604c-.002.215-.008.432-.01.645-1.215.682-2.896.426-3.73 1.869-.413-3.311 2.015-2.388 3.74-2.514z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B6D8F9"
        d="M660.637 469.461l-18.084.012c-.719-.832-.719-1.666 0-2.498 4.041.002 8.08.02 12.121-.002 2.35-.014 4.243 1.023 5.963 2.488z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B4DAED"
        d="M642.553 466.975v2.498-.002c-1.238.799-2.941 1.191-3.545-.123-.607-1.332-1.16-.309-1.473-.279-4.043.391-5.984-.432-7.453-3.332l2.479-.014 1.264.01c1.639.885 3.426.529 5.158.625 1.211.07 2.504-.297 3.57.617z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B8D4FC"
        d="M642.553 466.975c-2.902-.445-6.09 1.082-8.729-1.242 2.131-.004 4.262-.02 6.393 0 .975.007 2.135-.256 2.336 1.242z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7DEBC"
        d="M295.545 53.787l-.013 1.268c-1.807-.87-3.23.628-4.871.792-.487-.835-1.122-1.395-2.181-1.165-.403-.17-.797-.345-.419-.884-.556-3.33-.796-6.757-4.667-8.323-3.093-1.25-3.507-4.128-2.679-6.744.876-2.771 3.709-2.396 6.072-2.386 3.69 1.753 4.835 5.323 6.225 8.718l-.027 1.257c-1.516 1.108-2.429.35-3.217-.991-.742-1.262-1.103-2.653-1.547-4.024-.27-.833-.88-1.485-1.824-1.382-1.214.132-.36 1.174-.626 1.674-.918 1.725-.412 2.661 1.287 3.463 1.257.594 1.629 2.062 2.276 3.229 1.375 2.48 1.548 2.494 3.724.487l2.475 3.781c.003.411.008.82.012 1.23z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#312643"
        d="M290.453 65.119l-1.156 1.164c-1.789-3.307-2.596-6.845-2.51-10.595l.113-.939c.18.044.361.086.542.127.932-.052 1.464.517 1.912 1.222 1.118 2.642 1.563 5.422 1.652 8.274-.09.317-.276.567-.553.747z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF8F8"
        d="M288.746 56.253l-1.304-1.378c.021-.466.144-.872.618-1.076l.591.658c.563.214.935.577.946 1.219-.121.431-.321.748-.851.577z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B7D7F8"
        d="M630.083 465.736c1.996 1.912 4.297 3.01 7.125 2.475 1.992-.379 3.256 2.172 5.346 1.26-.285 1.717-1.645 1.217-2.672 1.23-3.686.045-7.371.016-11.059.016-1.219-1.805-3.043-2.43-5.088-2.48-2.467-.061-4.934-.016-7.398-.018-.4-.492-.354-.979.021-1.461.441-.346.947-.504 1.496-.564 3.357.693 6.768.18 10.813.49-.254-.027-.436-.533-.477-.117-.006.059-.109.08-.305.053-.623-.088-1.57.4-1.533-.861l1.012-.135c.908.036 1.812.073 2.719.112z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#52A3DC"
        d="M663.762 260.379c-.367.652-.732 1.308-1.1 1.962.002 0-.193-.169-.193-.169-1.451-2.571-.811-5.274-.51-7.96.143-.351.379-.62.707-.813.359.688.721 1.374 1.08 2.06a.728.728 0 00.082.579c.348 1.454.473 2.904-.066 4.344v-.003z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#52A3DC"
        d="M660.03 252.27c.68-.013 1.357-.025 2.037-.036.492.237.561.694.6 1.167 0-.002-.203.185-.203.185-1.434.714-2.612.953-2.434-1.316z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF8F8"
        d="M652.543 244.789c-.469 2.002-1.979 1.027-3.566 1.23l2.313-1.23h1.253z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BED7F1"
        d="M635.073 422.064c-.852-.127-1.844.273-2.48-.662 1.402-1.426 2.9-2.771 4.168-4.311.832-1.012-1.375-3.523-3.295-3.768-.982-.123-1.979-.119-3.299-.193 3.283-2.539 3.467-6.225 4.775-9.289.76-1.777 1.371-2.447 2.637-.994 1.652 1.893 3.162 1.84 4.959.461.373.42.373.848.02 1.277-1.352 1.137-2.959.529-4.438.555-1.744.029-2.484.551-3.264 2.344-1.242 2.854-.918 4.564 1.83 5.949.797.4 1.418 1.15 2.121 1.742-.09 2.923-2.248 4.723-3.734 6.889z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D2CBC1"
        d="M235.636 88.776l-1.177-.638a2.265 2.265 0 01-.079-.612c.205-.032.41-.04.616-.025.39-.363.821-.374 1.279-.147.327.4.365.837.167 1.304-.236.252-.506.281-.806.118z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#43A3E5"
        d="M660.03 252.27c.164 1.643 1.492 1.121 2.436 1.315 0 2.863.002 5.727.004 8.589-.756.185-1.979-.188-2.174.689-.648 2.9-3.268 3.215-5.264 4.363-.729-.9-1.627-1.522-2.752-1.861-.84-.254-1.521-.71-1.098-1.788 1.225-1.403 3.223-.383 4.547-1.459a8.076 8.076 0 001.541-1.391c1.084-1.2.814-2.588.557-3.97-.127-.244-.238-.497-.35-.75a2.941 2.941 0 01-.232-.802c.008-.28.07-.55.18-.807.715-1.018.383-2.462 1.361-3.375.804.027 1.214.447 1.244 1.247z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3FA7EB"
        d="M651.293 263.509c.092 1.072.824 1.317 1.709 1.236 1.943-.18 2.146 1.008 2.029 2.481-2.76.507-5.436-.063-8.115-.62-.514-.255-.596-.723-.615-1.224-.131-.978-1.451-1.356-1.254-2.499 0-.203-.002-.406-.006-.609-.396-.926-.889-1.854.102-2.728 1.961-.466 1.791 2.316 3.477 2.27.744.567 1.594.952 2.42 1.38.085.103.171.208.253.313z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B6D7FD"
        d="M623.245 471.979l-30.621-.004c.211-1.541 1.412-1.246 2.398-1.248 9.213-.014 18.43-.014 27.645.002.979.002 2.189-.316 2.402 1.234-.61.004-1.217.008-1.824.016z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C2D8E3"
        d="M115.735 430.111c.534 2.402-1.254 1.779-2.474 1.902.559-.98 1.251-1.786 2.474-1.902z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C3D5E1"
        d="M122.028 317.855l-1.906 3.1-1.192-.033c.301-1.764-.568-4.707 3.098-3.067zM123.283 319.68l.624-1.854c.207-.209.414-.414.621-.619l-.008 2.471c-.413.054-.825.687-1.237.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FCDCB4"
        d="M293.057 48.777c-.121 1.053.329 2.405-1.474 2.52-1.293.083-1.895-.332-2.482-1.644-.915-2.048-1.639-4.482-4.469-5.041-.396-.078-2.72-1.346-.049-2.117.477-.137.765-.502.506-.893-.877-1.321-1.454-2.543.86-2.742 1.979-.17 3.261.938 3.275 2.858.011 1.604 1.253 2.535 1.569 3.952.209.936 1.406.557 2.192.65.023.82.047 1.638.072 2.457z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5416CD"
        d="M123.275 446.934h4.352c1.813-1.461 3.881-.26 5.807-.553 5.701.002 11.401-.016 17.102.014 1.114.004 2.298-.262 3.302.518-.264 2.066-1.95 1.523-3.126 1.545-5.791.111-11.584.037-17.376.059-6.627-.021-13.256-.008-19.883-.002-3.31-.406-6.767.869-9.962-.865a1.344 1.344 0 01-.07-.385c6.619-.111 13.237-.222 19.854-.331z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B6D8F7"
        d="M666.28 370.84l1.236-1.227c.813.018 1.23.434 1.252 1.244-.418.004-.838.006-1.256.008l-1.232-.025z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DDDAF1"
        d="M236.233 87.496c-.413.001-.824.003-1.236.006l-.692-1.83c.427-2.06 1.971-2.784 3.797-3.167 1.935.284 2.793-.518 2.506-2.48.96 1.274 2.459 1.732 3.764 2.485-1.01 1.123-2.687.271-3.741 1.263-1.274 1.469-2.237 3.303-4.398 3.723z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BBD7F1"
        d="M646.299 354.631c.553-1.867 1.826-2.664 3.738-2.502l.156.408c-.012.102-.002.217-.045.307-3.596 7.355-3.51 7.785 2.484 12.609l-.105.426c-6.156-.037-5.75-.172-7.68-6.035-.872-2.656.318-3.67 1.452-5.213z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BDD8F0"
        d="M661.278 354.631c1.5.207 1.236 1.371 1.242 2.354.02 2.543.008 5.088.008 7.633-.559.387-1.201-.318-1.951.793-1.584 2.336-6.277 2.316-8.049.469l.016-.018c1.318-1.191 3.268-.646 4.633-1.697 3.391-2.422 3.9-4.303 2.539-9.408.423-1.292.98-.866 1.562-.126zM663.774 364.617c.109-1.057.799-1.473 1.678-1.094 1.516.652 2.301 1.861 2.068 3.59-1.92.172-3.191-.623-3.746-2.496z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C71F30"
        d="M286.195 137.399c1.733 3.76 1.25 7.515-.021 11.268-.312.204-.597.171-.856-.096-.483-.685-.529-1.477-.559-2.271.316-2.897.623-5.795-.614-8.587.567-.872 1.272-.83 2.05-.314z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C31C4B"
        d="M286.195 137.399c-.673.075-1.442-.113-1.856.673.193.277.183.539-.062.781-.457.204-.887.157-1.292-.136-.323-.351-.471-.773-.514-1.24a2.533 2.533 0 01.289-1.293c.446-.569 1.099-.923 1.562-1.478.291-.085.543-.026.75.201.149.055.302.082.46.081l.663 2.411z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DFF6EC"
        d="M285.601 148.794c.185-.07.375-.112.572-.126.421 1.189 1.73 2.228.625 3.675l-1.216-.01c-.611-.477-.706-1.231-1.011-1.875-.09-.823.11-1.467 1.03-1.664z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7433EF"
        d="M253.141 133.671a3.126 3.126 0 01-.016-.596c3.424-.298 3.097-3.789 3.387-5.426.786-4.433.58-9.086.076-13.638-.061-.545-.631-1.035-.966-1.55.433-2.659-2.51-3.589-3.037-5.824-.109-.462-.834.708-1.466.728-1.162-.777-.954-2.147-1.346-3.274-1.278.261-2.163 1.846-3.67.94-.087-.191-.096-.409-.169-.594-1.894-4.721 1.856-6.724 4.457-9.281.233-.229.554-.449.823-.346 3.453 1.332 3.35-1.522 4.057-3.422.928-.969 1.775-.154 2.646.116.906.139 1.763.02 2.552-.483a2.18 2.18 0 01.789-.157c.581.057 1.05.341 1.479.712.314.289.57.622.777.995.141.241.263.494.378.747 2.848 2.219 5.131.243 7.506-1.008.529-.407 1.012-.872 1.534-1.289.719-.455 1.741-.518 2.009-1.563.4-.911 1.058-1.651 1.591-2.475 2.381-1.478 4.979-1.497 7.637-1.12.699.387 1.218.963 1.695 1.587.31 1.263 1.721 2.258.936 3.791-.785.641-1.129 1.505-1.258 2.479-2.812 1.271-4.669 3.717-6.483 5.969-1.339 1.663.224 3.997.477 6.001.51 4.046.782 8.055-.297 11.994-.733 2.679-.502 5.348-.525 8.026-.045 5.434-1.51 7.447-6.882 9.236-3.792 1.484-7.558.109-11.343-.173 1.694.292 3.401.384 5.202.701-.49 1.645-1.951.564-2.589 1.305-2.721.001-5.462.293-8.125-.562-.244.178-.496.183-.757.041-.722-.71-.252-1.919-1.079-2.587z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#561AC1"
        d="M283.136 120.8l-.045 3.208c.365 1.574.517 3.145-.085 4.703-1.968-.638-2.531-2.071-2.467-4.018.107-3.244-.599-6.674 2.461-9.11.676 1.723.388 3.47.136 5.217z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5117D1"
        d="M283.119 136.248l-.142 1.128c-1.182 1.043-2.389 1.032-3.618.087h-7.135l-.153-1.049c2.616-.037 4.829-.713 6.794-2.49 1.259-1.138 2.809.434 4.168 1.02.412.41.389.848.086 1.304z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7631E8"
        d="M263.102 136.779c.4-.701 1.256-.496 2.226-.922-1.687-.534-2.882-.153-4.116.201-1.546.443-2.068-.806-3.55-2.378 5.325.184 9.678 2.028 14.17 1.267-2.68 1.707-5.65 2.033-8.73 1.832z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7D119A"
        d="M279.359 137.463l3.618-.086.104 1.318a28.46 28.46 0 00-.289.309c-1.039.434-2.089.844-3.072 1.412a4.604 4.604 0 01-.878.226c-1.09.123-2.183.094-3.275.111-.976-.023-1.963.025-2.867-.451-.789-.675-.294-1.115.283-1.54 2.062-.748 4.672 1.199 6.376-1.299z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#AA1A76"
        d="M272.983 138.762l-.506 1.094a1.117 1.117 0 01-.822.376c-2.291-.136-4.583-.267-6.871.06-.154.022-.308.037-.462.059a4.113 4.113 0 01-.934-.041c-1.986-.465-4.059.109-6.034-.497a1.404 1.404 0 01-.685-.634c-.037-.348.096-.612.396-.792.797-.252 1.553-.061 2.299.222 4.54.051 9.08.101 13.619.153z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#512D9A"
        d="M283.005 128.711l.085-4.702 1.982 10.898-.734.108c-.394-.434-.401-.89-.08-1.365-.882-1.529-1.516-3.12-1.253-4.939z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5E4C86"
        d="M283.136 120.8a9081.75 9081.75 0 00-.137-5.217c.639-1.806-1.087-4.109 1.173-5.572l-1.036 10.789z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#750A84"
        d="M259.364 138.608l-2.467.03c-1.112.086-2.349.44-2.631-1.238.44-.37.883-.299 1.328-.01 1.367.062 2.738.117 3.77 1.218z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#591DBB"
        d="M255.593 137.391l-1.266.062c-.444.353-.856.365-1.225-.111a.363.363 0 01-.089-.339c.043-.473.087-.948.129-1.423.662-.377.853.273 1.212.554.208.027.415.056.622.084l.617 1.173z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5821A9"
        d="M284.258 133.65l.08 1.365c.003.815-.47 1.162-1.219 1.232l-.084-1.304c.583-.264.133-1.506 1.223-1.293z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EDE4FE"
        d="M594.29 269.668c-.32-.023-.639-.05-.957-.073-1.791-2.314-.598-5.012-.971-7.509.016-9.986-.006-19.972.014-29.958.004-1.448-.162-2.918.332-4.331.404-.83 1.088-1.021 1.934-.845.559.208.871.641 1.049 1.188.148.513.18 1.036.115 1.566-.08.522-.348.952-.682 1.348l-.004 1.249c.664.784.615 1.735.617 2.668.01 8.206.01 16.412 0 24.618-.002.933.049 1.885-.613 2.668-.633 1.472 1.256 3.467-1.105 4.704-.496.259 1.107.999 1.104 1.889.112.674-.449.655-.833.818z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EAF6EB"
        d="M595.124 262.258l-.004-29.954c1.543.216 1.236 1.418 1.238 2.4.016 8.384.016 16.768 0 25.151-.002.982.309 2.186-1.234 2.403zM595.124 231.055v-1.247c1.174-1.087 2.885-.649 4.154-1.463a.95.95 0 01.836.223c.416.681.826.049 1.24-.005.398.412.334.827.002 1.242-1.848 1.553-4.072 1.239-6.232 1.25z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DC4678"
        d="M594.29 269.668l.832-.817c1.816-.469 3.66-.357 5.504-.287.664.386 1.328.769 1.992 1.151l-4.367.032c-.424.378-.848.368-1.273-.002l-2.688-.077z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF8F8"
        d="M601.356 229.803c0-.415 0-.828-.002-1.242 2.545-.24.645 1.759 1.256 2.493-.817-.019-1.227-.442-1.254-1.251z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F1EDEB"
        d="M601.405 279.756c-3.367 2.506-3.717 2.469-6.32-.629-.283-.9-.748-1.741-.873-2.693a1.9 1.9 0 01.277-.787c.74-.872 1.691-.976 2.734-.762.26.084.502.217.719.379.154.137.342.316.527.287 3.912-.625 4.033-.503 3.41 3.493-.134.255-.295.49-.474.712z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D55254"
        d="M601.405 279.756c.012-.164.016-.329.014-.496 1.293-3.975 1.293-3.975-3.771-3.889l-.037-.032c-1.217-.564-2.314-.518-3.205.616l.018-.061c-.109.341-.285.381-.533.122-.268-1.813.391-2.693 2.346-2.548 1.633.12 3.299-.119 4.914.09 2.074.274 2.699 1.744 2.746 3.744.045 1.884-.631 2.681-2.492 2.454z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CC5A60"
        d="M602.62 269.717c1.563.347 2.328 1.775 3.545 2.591 1.336 3.281 2.449 6.567.184 9.917-.344-.423-.369-.864-.066-1.319.915-4.429-1.146-7.885-3.663-11.189z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6A1D4F"
        d="M589.215 278.321c.086.502.17 1.005.252 1.508.486.836.705 1.664-.066 2.464-.311.097-.578.02-.805-.209-.482-.941-1.002-1.863-1.504-2.796-.35-1.453-.469-2.896.186-4.305.594-.721 1.127-.342 1.654.099.504 1.042.11 2.165.283 3.239z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F43F40"
        d="M596.977 269.745c.426.002.85.002 1.273.002-.186 1.499 1.633.872 2.068 1.959-1.594.901-3.168.546-4.736.362-.509-1.512 2.543-.554 1.395-2.323z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FC3339"
        d="M591.366 281.004v-1.985c1.822.438 1.713 2.516 3.113 3.179h-3.061c-.361-.384-.419-.78-.052-1.194z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6C1838"
        d="M593.954 286.003c-.029.385-.059.766-.092 1.148a250.74 250.74 0 01-1.221-.021c-1.215-.762-2.713-1.315-2.398-3.22.447-.214.869-.16 1.266.122l2.445 1.971z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#635593"
        d="M593.202 262.271c.043 2.44.086 4.882.131 7.324l-.689.941-.391-.394c-.723-2.535-.732-5.07.01-7.607.234-.359.546-.449.939-.264z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#682267"
        d="M591.508 284.032l-1.338.109c-1.119-.194-2.018-.528-1.225-1.934.82-.65.48-1.558.521-2.379.551.18.561.69.691 1.127.799.629.633 1.744 1.24 2.467.057.202.092.405.111.61z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6E0944"
        d="M589.215 278.321c-.619-.952-.203-2.043-.404-3.051-.469-.819-.521-1.543.463-2.03a.831.831 0 01.859.311l-.918 4.77z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7C15A2"
        d="M590.133 273.551a51.43 51.43 0 00-.668-.105c-.594-.254-.885-.665-.693-1.328.412-.604.875-1.151 1.574-1.442.465-.09.881-.006 1.223.345.205.447.17.869-.133 1.263-.644.203-1.055.653-1.303 1.267z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DC4678"
        d="M591.436 272.282l-.064-1.301c-.193-.264-.191-.522.014-.776.414-.244.834-.268 1.26-.03 0 .12 0 .241-.002.361 1.179 1.677.202 1.861-1.208 1.746z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9E5E8"
        d="M593.889 276.017c.174-.058.352-.098.533-.122l.662 3.232c-1.142-.753-1.095-1.959-1.195-3.11z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CE3B63"
        d="M591.399 283.423c-.922-.566-1.254-1.429-1.24-2.467.402.016.805.03 1.207.048.018.397.037.795.053 1.193-.006.408-.012.818-.02 1.226z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A6545C"
        d="M605.823 283.049c-.311.988-1.303 1.285-1.953 1.932-.236-1.213 1.285-1.615 1.264-2.732.65-.095.98.087.689.8z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D3505B"
        d="M605.823 283.049c-.229-.266-.461-.533-.689-.801-.029-.8.395-1.215 1.148-1.341l.066 1.315c-.174.277-.349.552-.525.827z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#207EC5"
        d="M532.688 138.674c-.016-.209-.035-.419-.053-.628-.297-.6-.352-1.214-.105-1.845 1.857-1.078 3.047 1.666 4.877.86.252-.11.607.012.895.137-.238-.223-.623-.342-.553-.784a.867.867 0 01.531-.269c1.271-.93 2.545-.948 3.814.001l.639.263c.504.636 1.141.822 1.92.593.752-.22 1.738-.155 1.916.535.781 3.057 3.158 3.038 5.539 3.165.275.015.535.292.803.447.104.393.205.785.311 1.177l-.559.362c-1.604.417-1.273 1.652-1.178 2.787.488.958.889 1.933.613 3.044-.15.508-.381.983-.611 1.459l.014-.013c-.385.306-.785.341-1.197.066-.691-.599-.824-1.366-.678-2.217-.158.814-.057 1.559.598 2.155.807.874.529 1.938.531 2.953a2.24 2.24 0 01-.379.805 1.673 1.673 0 01-.809.322 2.212 2.212 0 01-.836-.206c-.732-.662-1.875-.666-2.482-1.535.486-2.739 1.684-5.487-.104-8.193-.371-.592-.865-1.066-1.422-1.483-4.568-3.55-9.18-2.147-11.338 3.456-.4 1.099-.02 2.179.094 3.266.018 1.035.516 2.029.266 3.087-.174.475-.498.78-1.004.873-1.568.035-2.758-.517-3.256-2.122-.641-.185-1.01-.646-1.264-1.228-.559-1.154-1.541-2.208-.865-3.657.48-.545.859-1.215 1.648-1.398 1.277-1.251 1.277-1.251.313-3.375 1.432-.584 3.316-.677 3.371-2.86z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#663EB0"
        d="M507.739 154.31l-1.279-1.276c6.299-.05 12.598-.101 18.896-.147.537-.004 1.018.13 1.307.643-.982 1.264-2.406.957-3.703.992-4.518.12-9.043-.155-13.559.168-.608.108-1.164-.011-1.662-.38z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#703ED2"
        d="M508.995 154.286c1.773-1.235 3.775-.522 5.664-.593 3.998-.152 8.004-.119 12.006-.162l.172.043c.393-.25.729-.188 1.008.187.049.434-.119.755-.502.965-5.973.68-11.947.742-17.92-.035a54.082 54.082 0 01-.428-.405z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2080B6"
        d="M527.653 153.708l-.816-.133c.434-1.294 2.346-.946 2.648-2.385.764 1.157 2.283.996 3.223 1.849-1.381 2.509-3.229 1.511-5.055.669z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#41759B"
        d="M527.676 146.231c-.676 1.369 1.59 2.308.545 3.73-2.561-.141-2.84-1.715-2.365-3.764.617-.448 1.225-.491 1.82.034z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B5E7F4"
        d="M527.676 146.231l-1.82-.034c1.004-.866 2.512-1.326 2.461-3.043.959.297.578 1.122.688 1.752-.241.642-.688 1.081-1.329 1.325z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#489FE0"
        d="M613.206 299.075c-.168-2.554 1.943-2.965 3.596-3.508 1.76-.58 3.453-.115 4.508 1.653-.188.354-.348.731-.781.855-.789.082-1.559-.169-2.342-.151-.395.006-.791.002-1.188.011-.881-.009-1.613.353-2.277.888-.346.235-.721.4-1.146.424-.122-.056-.247-.113-.37-.172z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#489FE0"
        d="M620.102 304.708c-2.109 1.66-4.113.843-5.773-.588-1.475-1.273-2.574-2.963-1.123-5.045l.012.007c.604.255 1.094.681 1.172 1.322.342 2.708 2.176 3.484 4.545 3.617.464.103.874.295 1.167.687z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3A7BA3"
        d="M608.885 297.204c-.006-.404-.01-.807-.014-1.211.973-1.284 2.455-.39 3.623-.845-.832 1.03-.137 3.063-2.164 3.313l-1.445-1.257z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4DA0DE"
        d="M620.102 304.708l-1.313-.025a.757.757 0 01-.025-.805c2.221-1.515 2.27-3.727 1.949-6.061l.596-.597c2.156 3.283 1.875 5.013-1.207 7.488z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4A80A6"
        d="M609.942 301.767c-1.027-.038-1.85-.257-1.723-1.598.123-1.337 1.123-.898 1.865-1.001-.046.866-.095 1.734-.142 2.599z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4F80A4"
        d="M625.124 299.095c.889.163 1.873.242 1.895 1.482.021 1.301-1.291 1.017-1.914 1.549.005-1.01.011-2.022.019-3.031z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3A6771"
        d="M625.606 304.045c.215.063.428.122.641.184-.404 1.188-.947 2.127-2.436 1.351.244-.926 1.174-1.05 1.795-1.535z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3A6F8E"
        d="M612.586 293.544c-.498-.61-.053-.972.408-1.175.611-.268 1.221-.235 1.488.557-.472.692-1.232.507-1.896.618z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#415E66"
        d="M616.844 291.717c.902-.988 1.529-.914 1.816.471-.654.034-1.324.124-1.816-.471z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#663AB4"
        d="M283.136 153.004c25.678.003 51.356.005 77.035.015 1.35 0 2.7.067 4.048.103.09.46-.075.795-.494 1.005-1.08.5-2.238.409-3.376.409-24.433.013-48.864.012-73.296 0-1.237 0-2.507.136-3.667-.495-.414-.267-.497-.612-.25-1.037z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#653AB4"
        d="M382.886 153.123l65.646.01c.436 1.195-.336 1.359-1.219 1.432-19.785-.052-39.569 0-59.353-.032-1.543-.002-3.117.221-4.607-.409-.416-.213-.568-.547-.467-1.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2F1874"
        d="M447.774 154.241c.52-.188.643-.646.758-1.109l.52-.223c.074.71-.113 1.505.645 1.995.338.594.102 1.147-.115 1.703-1.055 2.182-2.324 4.242-2.771 6.72-.221 1.219-.965 2.461-2.227 3.144-.477.109-.916.034-1.303-.278-.754-1.26-.107-2.426.232-3.613.588-1.186 1.004-2.437 1.367-3.707.908-1.437 1.623-2.984 2.514-4.431.126-.068.255-.134.38-.201z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#663DA7"
        d="M382.886 153.123c.016.169.021.338.018.508-.275.318-.607.635-1.016.664a114.92 114.92 0 01-16.669-.001c-.407-.03-.738-.348-1.011-.667a4.019 4.019 0 01.011-.503c6.222-.002 12.445-.001 18.667-.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DF0C29"
        d="M283.136 153.004a1.562 1.562 0 00-.094.606c-.174.522-.568.887-.915 1.29-.477.519-.959 1.032-1.535 1.45-.879.489-1.75.574-2.608-.051-.717-1.261.441-2.111.686-3.167.986-1.668 2.42-1.698 4.026-1.101.127.117.253.235.379.354l.061.619z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D20B1C"
        d="M285.601 148.794c-.225.583-.828 1.038-.608 1.774-.111.39-.359.631-.762.707l-1.156 1.111-.09-.079a2.09 2.09 0 01-.528-1.229c-.064-1.604.617-2.984 1.347-4.338.364-.675.868-1.177 1.712-.612l.085 2.666z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E9F2F9"
        d="M284.231 151.275l.762-.707c.665.432.524 1.133.589 1.765-.837.141-1.246-.264-1.351-1.058z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#39A6EF"
        d="M627.549 242.315c.131-1.103-.234-2.261.553-3.71 3.637 3.371 1.23 7.595 1.979 11.186 1.094 1.4.258 2.472-.598 3.544-2.639 3.305-5.84 5.365-10.297 4.839-1.211-.144-2.459.038-3.648-.354-1.006-.518-2.004-1.061-3.063-1.477-1.367-1.025-3.201-1.693-3.025-3.914.18-.974.525-1.828 1.744-1.288 1.225.542 2.084-.235 3.057-.661 1.314-.411 2.666-.27 4.004-.316 1.328.06 2.686-.151 3.961.398 1.27.877.436 1.594-.354 2.397 3.609-1.324 5.18-3.763 4.936-7.43-.073-1.112-.139-2.294.751-3.214z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4AA2DC"
        d="M618.204 251.044l-4.35.025c-2.457.567-4.023-.316-4.473-2.676-.398-2.094-.182-4.142.936-6.018.117-.5.178-1.019.338-1.515.365-1.139.967-2.146 2.168-2.466 1.643-.441 1.369 1.513 2.338 2.062 1.088-1.224.926-3.928 3.67-3.167l3.744.011c.344.328.404.729.301 1.173a1.759 1.759 0 01-.836.905c-.131.03-.262.06-.391.092-.131-.002-.264-.006-.393-.004-.721-.162-1.166.218-1.512.793-.971 1.398-1.766 2.949-3.359 3.79a4.48 4.48 0 01-.838.214c-1.518.043-2.186.811-2.17 2.338.016 1.446.463 2.399 2.088 2.385.303.005.598.04.895.084.789.142 1.498.422 1.971 1.117.156.315.113.6-.127.857z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#39A6F0"
        d="M618.831 237.29c-1.406.403-2.266 1.302-2.473 2.773-.121.859.223 2.054-1.166 2.113-1.639.073-1.23-1.275-1.371-2.219-.045-.298-.141-.589-.248-1.032-1.885.435-2.33 1.709-2.242 3.357-1.344.612-2.699 1.249-2.488-1.246.674-3.021 2.961-4.286 5.637-4.961 2.084-.526 4.037-2.221 6.498-.847-.13 1.282-2.356.501-2.147 2.062z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5FA5CA"
        d="M615.12 257.238c2.283.009 4.563.043 6.844.024 3.391-.027 7.695-4.005 8.117-7.472.807-.035 1.217-.461 1.236-1.265l1.107-.015c-2.129 9.243-11.857 13.554-19.861 8.802.109-.116.219-.232.328-.35.805-.403 1.543-.286 2.229.276z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3EA4EA"
        d="M608.842 241.036c.207 1.665 1.502 1.143 2.488 1.246-.766 1.517-1.346 3.009-1.289 4.824.08 2.641 1.131 3.993 3.813 3.962-.535 1.85-1.809 1.383-2.887.761-.816-.472-.791-.049-.885.479-.359.323-.762.357-1.201.19-.813-.674-.814-1.785-1.402-2.582-.131-.273-.105-.526.105-.75l.084-8.112c.393-.005.784-.012 1.174-.018z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#56A3D2"
        d="M627.549 242.315c-.365 2.591.744 5.252-.871 7.823-1.896 3.017-3.811 3.94-7.471 2.817.6-1.54 3.123.347 3.297-1.849.434-.802 1.641-.849 1.83-1.887 1.139-4.176 1.139-4.176-1.867-5.716.227-1.794 1.963-.336 2.615-1.215.821.01 1.645.019 2.467.027z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3AA6F1"
        d="M622.543 238.602l.031-1.302c.076-1.086.824-1.505 1.664-1.135.846.373.887 1.593.422 2.064-1.211 1.23-.672 2.664-.844 4.013-2.214-.311-2.335-.65-1.273-3.64z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6198AD"
        d="M622.543 238.602c.52 1.181-1.07 3.101 1.273 3.641l1.266.047c-.568 1.001-1.766.351-2.486.947-1.361.834-1.547.726-1.922-1.115.486-.959.438-2.162 1.311-2.953l.558-.567z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1E245C"
        d="M600.317 369.609c-.865 5.051-3.539 9.295-6.066 13.604-.234.652-.469 1.303-1.111 1.691a2.229 2.229 0 01-.834.164c-.629-.086-1.092-.371-1.248-1.027.156-1.83 1.588-2.992 2.355-4.504 1.025-1.426 2.123-2.814 2.471-4.607.102-.258.236-.5.393-.727 1.055-1.352 1.436-2.965 1.768-4.598.311-1.143.252-2.584 2.037-2.531.025.668.051 1.336.078 2.002a.629.629 0 00.157.533z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C0D5E0"
        d="M642.557 404.586c-.006-.426-.012-.852-.02-1.277l.012-4.984.021-1.297c1.047.145 1.361.883 1.195 1.756-.366 1.939-.175 4.001-1.208 5.802z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5C9CC4"
        d="M608.866 252.265l1.217.042c-.672 2.275 2.277 2.057 2.541 3.689.342.396.348.797.021 1.204l-.082.112c-2.805-1.453-4.736-3.651-5.705-6.671.109-.557.156-1.147.729-1.476.014.203.025.406.033.612.83.62.673 1.738 1.246 2.488z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E14554"
        d="M637.577 213.542c2.391-.185 3.545 1.696 5.039 3.011.383.642.295 1.279-.008 1.918-.686 1.819-.654 3.847-1.816 5.545-1.914 2.797-5.004 3.381-7.125 1.23.066-.834.688-.857 1.297-.883 1.32.797 1.547-.775 2.348-1.105.506-.42.951-.893 1.277-1.473.832-1.608.186-2.316-1.461-2.332-1.621-.015-3.262.161-4.727-.78-.48-.684-.525-1.424-.299-2.199a1.73 1.73 0 01.543-.696c1.365-.719 2.465.256 3.688.551.832.201 2.303.824 1.426-1.186-.255-.514-.577-1.019-.182-1.601z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DF4C5F"
        d="M632.571 229.196c-2.275-.967-3.711-2.615-4.129-5.089.211-.662-.168-1.459.465-2.024.412-.177.82-.165 1.215.047.766.785.713 2.015 1.521 2.774.723.742 1.586 1.342 2.211 2.182.375.973-.363 1.418-.926 1.949-.117.055-.236.107-.357.161z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D33447"
        d="M637.577 213.542c.195.427.393.854.586 1.28-1.752.931-3.98-.292-5.598 1.241l-.008.009c-1.225.935-1.582 3.106-3.783 2.646-.199-.272-.201-.541.021-.801 1.745-3.696 4.481-5.06 8.782-4.375z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C45263"
        d="M643.899 219.706c1.051 2.473.111 4.537-1.342 6.495-.393-.309-.578-.734-.676-1.208a4.937 4.937 0 01.156-2.23c.393-.854 1.053-1.576 1.297-2.513a1.24 1.24 0 01.565-.544z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E74455"
        d="M642.479 224.782c.025.473.053.943.078 1.417-.549 1.129-1.596 1.75-2.537 2.479-.102-.117-.205-.236-.311-.354a2.438 2.438 0 01-.201-1.383c.606-1.246 1.022-2.76 2.971-2.159z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F0CED8"
        d="M639.434 229.809a3.857 3.857 0 00-.607.044c-2.082-.255-4.281.618-6.256-.657l-.004-.304c2.453-.892 4.99-.691 7.521-.574a.674.674 0 01-.068.359l-.586 1.132z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E54756"
        d="M641.92 217.992c.551-.325.631-.878.695-1.439.992.821 1.291 1.925 1.283 3.153l-.209.199c-.387.441-.074 1.746-1.35 1.091-.546-.943-.485-1.974-.419-3.004z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#AD5461"
        d="M628.795 217.917c.055.212.107.425.16.638.867 1.281.834 2.539-.105 3.77-.135.593-.273 1.186-.408 1.781-.797-2.115-.951-4.193.353-6.189z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#40A1E4"
        d="M628.817 183.005l-2.467-.614c-3.309-2.713-3.793-6.118-2.445-9.973 1.189-.889 2.188-2.059 3.674-2.512.336.359.482.784.451 1.274-.098.634-.443 1.129-.885 1.567-2.654 2.959-2.387 5.515.801 7.6 1.605.634 3.219-.118 4.824.03.646.063 1.256.203 1.684.749-.369 1.262-1.854.997-2.525 1.847a1.656 1.656 0 01-.799.563c-.862.224-1.639.069-2.313-.531z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#48A2DE"
        d="M634.454 181.125l-1.883-.006c-.35-1.024.646-1.412 1.012-2.091 1.271-2.359.92-4.37-1.158-6.256-1.252-1.625-3.41-.549-4.846-1.624v-1.243c2.811-.051 5.766-.532 7.576 2.477 2.781 1.62 2.205 3.881 1.188 6.225l-1.889 2.518z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1C82CA"
        d="M636.342 178.608c.188-2.187.453-4.389-1.189-6.225 3.307.138 3.457 2.583 3.652 4.994-1.144-.237-1.779.546-2.463 1.231z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E6F6EA"
        d="M285.555 112.464l.009-4.983c1.985 1.665 2.009 3.327-.009 4.983z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7EEF9"
        d="M646.301 287.223c.01-1.669.02-3.338.027-5.006 1.942 1.679 2.001 3.347-.027 5.006z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D46B79"
        d="M644.29 287.137c-.23.408-.463.814-.697 1.224a5.144 5.144 0 01-.518.124c-.459-.273-.48-.728-.479-1.188l1.694-.16z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F4E0E2"
        d="M640.536 285.913c-1.039.07-2.068.083-2.959-.595-.086-1.395-2.328-3.583 1.18-3.66 1.078-.023 2.594-.877 3.352.62.87 1.722-.894 2.484-1.573 3.635z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D46B79"
        d="M645.088 281.513c.873 1.313.844 2.638.049 3.973-.015-1.325-.031-2.649-.049-3.973z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#332A7B"
        d="M600.081 367.074c-1.367.674-1.209 1.947-1.234 3.146-.83.305-1.229-.572-1.904-.697-.531-.098-1.025-.006-1.381.416-.5.594-.273 1.109.258 1.555 1.061.883 1.58 1.863.555 3.117l.002-.002c-.57 1.797-2.332 3.006-2.484 5.01-.324 1.75-1.752 2.857-2.525 4.348-1.227 1.98-2.213 4.266-5.154 4.09-2.314-.717-2.814.885-3.262 2.561-1.195 1.264-2.936 1.369-4.393 2.084-6.137 1.316-12.215 1.311-18.189-.844-.854-.646-1.596-1.475-2.719-1.693a2.483 2.483 0 01-.73-.496c-1.092-2.971-4.279-1.637-6.188-2.975-.443-.311-1.207-.088-1.818-.162-4.779-1.471-8.805-4.23-12.609-7.365-2.904-2.234-5.43-5.01-9.021-6.25-1.131-.539-.771-1.938-1.553-2.682-3.123-2.572-6.27-5.111-8.734-8.357a3.065 3.065 0 01-.311-.779c-.41-1.992-2.115-2.646-3.627-3.502-3.584-2.82-5.734-6.93-9.033-10.008-4.047-5.678-8.529-11.018-12.41-16.844-2.965-4.451-5.334-9.332-8.998-13.313-.576-.977-.908-2.065-1.395-3.086-.967-3.776-4.398-6.256-5.314-10.059-.244-1.436 1.346-3.504-1.416-4.057a2.326 2.326 0 01-.68-.466c-.434-.67-.859-1.35-1.4-1.951-.539-.802-.92-1.698-1.51-2.471-3.656-6.918-7.266-13.858-10.063-21.183a13.1 13.1 0 00-.926-1.951c-3.369-8.732-6.512-17.545-9.672-26.355-1.289-7.349-4-14.337-5.471-21.639-.25-.973-.291-1.967-.291-2.964-.074-1.706.412-3.493-.746-5.042a5.149 5.149 0 01-.414-1.413c0-1.715-.756-3.25-1.17-4.87-.572-7.484-.826-14.988-1.449-22.464-.375-4.528 1.082-8.791 1.439-13.2.336-1.281 1.012-2.433 1.422-3.687.162-.378.354-.748.596-1.084.598-.828.447-2.42 2.193-2.075 1.275.251 2.006.932 2.213 2.24.109.681.148 1.527 1.152 1.585a.73.73 0 00.723-.474c.316-.79-.102-1.405-.551-1.986-.572-.738-1.324-1.322-1.875-2.074-1.561-2.128-1.395-5.323.594-6.762 1.703-1.23.975-2.449.471-3.787l.619-1.254-.002-.004c1.564-.808 2.391-2.234 3.117-3.743 1.158-3.581 4.939-4.208 7.313-6.428 2.09-1.955 4.771-2.69 7.676-2.323 1.014-.319 2.039-.579 3.109-.622 9.902-.068 18.939 2.723 27.209 8.146 1.461.96 3.08 1.684 4.625 2.517 2.934 4.449 5.965 8.771 12.063 8.972.432.192.734.511.924.939-.152 4.082 1.926 6.53 5.656 7.827 1.641.569 2.738 1.757 3.482 3.326 1.023 2.153 2.469 3.692 5.162 3.135.305.034.598.107.885.204 1.275.627 2.186 1.556 2.451 3.003.039.946.309 1.766 1.254 2.208.217.173.4.372.566.591 1.992 3.613 4.482 6.804 7.846 9.256 1.291 1.234 3.031 2.004 3.855 3.724.23.596.316 1.218.336 1.852.012.787-.063 1.561-.367 2.296-1.18 1.997-1.266 4.022-.143 6.075 1.006 2.78 2.904 4.723 5.572 5.946.26.136.484.314.684.526.559 1.042 1.334 1.742 2.604 1.732 1.377-.011 2.498.68 3.623 1.364.537.316 1.006.708 1.373 1.215 3.674 5.42 6.633 11.248 9.703 17.009 1.162 2.18.889 2.565-1.813 2.996-2.906-1.571-6.068-.831-9.125-1-1.555-.104-3.08-.026-4.494.747a2.088 2.088 0 01-.904-.102c-2.955-3.568-4.809-7.816-7.221-11.72-.426-.888-.996-1.694-1.482-2.55-.455-.845-.699-1.78-1.111-2.644-.455-1.021-1.236-1.784-2.018-2.548-5.729-8.026-11.131-16.285-17.402-23.922-8.932-10.876-18.461-21.104-30.295-28.935-.951-.63-1.92-1.268-2.289-2.456-.215-1.083-.664-1.916-1.898-2.143-.938-.172-1.744-.698-2.381-1.394-1.682-1.832-3.775-2.369-6.186-2.258-1.949.089-3.854.068-5.717-.955-1.248-.684-2.889-.467-4.266-.009-2.355.785-4.512 2.043-6.711 3.191-1.24.646-1.299 1.757-1.453 2.885-1.498 3.295-3.879 6.077-4.99 9.637-2.6 8.317-2.801 16.831-2.156 25.338 1.438 19.013 6.455 37.239 12.867 55.114.248.687.545 1.35.842 2.011 4.391 10.272 8.773 20.549 13.598 30.636 2.992 6.26 6.107 12.452 9.602 18.446 1.875 3.222 3.877 6.371 5.49 9.742.83 1.732 2.004 3.13 3.832 3.881-.125 1.97.504 3.614 1.631 5.298 6.088 9.076 12.541 17.865 19.74 26.098.902 1.033 1.654 2.135 1.939 3.506.938 3.961 4.104 6.074 7.076 8.225 1.805 1.303 3.586 2.453 4.246 4.711.217.736.635 1.285 1.359 1.592 4.809 2.025 8.504 5.572 12.275 9.01.309.285.633.699 1.012.674 3.48-.236 5.926 2.102 8.76 3.457 1.576.756 3.25.508 4.9.535 2.156.041 4.314-.107 6.461.123 5.236.332 9.404-2.639 10.113-7.234 7.1-12.418 6.416-25.828 5.055-39.33-.115-1.127-.395-2.254 0-3.379 2.119-1.563 3.021.74 4.445 1.395 2.518 1.422 3.541 1.121 5.496-1.191 1.133-1.34 1.363-3.584 3.65-3.822 1.107 2.205.393 4.574.611 6.859 1.045 7.264.91 14.559.518 21.854-.064 1.199-.193 2.594-1.148 3.463-1.58 1.443-1.297 2.984-.604 4.646-.014 1.649-.03 3.302-.047 4.95z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#342B70"
        d="M514.61 161.778c-4.525.464-7.414-1.299-9.385-5.731-.08-.184-.201-.542-.205-.541-4.074 1.436-1.557-2.021-2.277-3.06l1.24.604c1.055 1.123 2.131 2.212 3.748 2.482 2.139.816 3.752 2.441 5.59 3.708.783.539 1.679 1.282 1.289 2.538z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2A2B52"
        d="M470.909 141.784c-.955.622-2.016.707-3.109.622 0-.197.002-.395.004-.592 1.04.414 2.06-1.099 3.105-.03z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DCF5FB"
        d="M608.393 221.114c.154.006.307.021.461.044-.461 3.452-2.971 5.467-6.189 4.959-.064-.127-.131-.254-.197-.381 1.304-2.402 3.613-3.512 5.925-4.622z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DCF5FB"
        d="M600.114 228.567l-.629.006c-1.455.743-2.912.926-4.365-.011l.033-1.019c.049-.301.229-.487.516-.575 1.088-.084 2.199.326 3.268-.156 1.213-.223 2.264-1.159 3.602-.83l.127.135c-.156 1.544-1.943 1.382-2.552 2.45z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2F7DAE"
        d="M631.315 183.01a10.5 10.5 0 01.613-.038c.203 1.021 2.258 1.641.66 3.051l-1.297 1.349c-.414 1.396-1.25 1.944-2.67 1.333a1.008 1.008 0 01-.43-.107l.086-1.244c1.821-.882 1.958-2.942 3.038-4.344z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7435EB"
        d="M285.551 87.505c-.809-.02-1.226-.434-1.25-1.244.196-1.006.415-2.003.555-3.024.301-2.188 1.937-2.823 3.655-1.445.882.707 1.427 1.747 2.224 2.554.197.425.198.84-.073 1.238.703 1.994-1.585 2.396-2.015 3.788-.688.517-1.193.307-1.319-.481-.171-1.075-.942-1.238-1.777-1.386z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7035E3"
        d="M285.551 87.505c1.413-.698 2.48-.324 2.38.991-.061.802.181.825.717.876-.395.841-.997 1.478-1.848 1.87-.339-1.272-1.723-2.195-1.249-3.737z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6429AB"
        d="M290.663 85.584l-.153-1.186c-.656-.583-1.199-1.156.143-1.558 1.472.32 2.618.987 2.82 2.657a1.26 1.26 0 01-.477.786l-2.333-.699z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#54248B"
        d="M292.996 86.283l.147-.918c.851.082 1.296.51 1.199 1.402l-.083.844c-.765-.115-1.191-.554-1.263-1.328z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#332A7A"
        d="M588.946 282.208c-.18 1.016.85 1.269 1.225 1.934.744 1.063 2.18 1.556 2.471 2.991-.361 2.455 1.539 4.511 1.232 6.958.24 2.231.342 4.472.301 6.157.117.971.775.541.367.635-.143.035-.248-.015-.23-.126.197-1.191-1.055-2.712.797-3.527l.018 2.469c.576.733.178 1.598.314 2.392.129.514.039.978-.309 1.384l.012-.011c-.893.866-1.967.766-3.059.595a3.664 3.664 0 01-.816-.314c-.588-.239-1.307-1.213-1.572.298-.299.699-1.043 1.1-1.225 1.876a2.47 2.47 0 01-.496.618c-1.299 1.01-2.576 2.032-2.654 3.881-.262.397-.602.667-1.096.697-.482-.152-.783-.496-1.016-.92-.975-3.284-2.213-6.504-2.447-9.969-.416-.586 2.078-1.583-.283-1.902a2.744 2.744 0 01-.346-.841c-.174-1.15.158-2.16.842-3.069 1.264-3.249 2.082-6.6 2.371-10.022-.58 1.994-1.223 4.021-1.49 6.136-.646 1.067-1.414.603-1.93-.02-.555-.67-1.139-.648-1.838-.503-.443-.111-.746-.397-.979-.774-1.023-2.077-1.285-4.454-2.537-6.441a4.5 4.5 0 01-.598-1.179c-.229-.851-.307-1.752-.848-2.503-1.498-3.501-2.852-7.053-3.723-10.772-.023-2.58 1.336-3.945 3.807-4.373.771-.135 1.746-.103 1.721-1.303-.074-3.191 1.959-2.4 3.785-2.02 1.148 1.477 1.953 3.312 3.986 3.883.658 1.157 1.588 2.043 2.764 2.679 1.125 2.424 3.387 4.52 2.193 7.611l-.008 4.895c.318.349.416.963.107 1.104-2.441 1.119-2.09 3.236-1.984 4.91.014-.35-.021-1.065-.002-1.782.021-.749.119-1.482.816-1.917.789-.49 1.578-.445 2.289.197l.068-.012z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#362587"
        d="M591.372 303.465c1.258-.002 2.514-.002 3.771-.002.674.685 1.471 1.335.664 2.422-.232.485-.465.972-.695 1.459-.477.088-.818-.147-1.123-.469-.492-1.427-2.787-1.476-2.617-3.41z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#312C70"
        d="M595.108 297.229c-1.299 1.241-.098 2.986-1.18 4.911.285-3.073-1.039-5.506-.055-8.05.993.818.481 2.226 1.235 3.139z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#362587"
        d="M595.131 303.474c-.002-.423-.008-.847-.01-1.269.203-.297.42-.306.646-.023.424.229 1 .526.703 1.024-.151.262-.874.189-1.339.268z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#312C70"
        d="M595.768 302.182c-.217.009-.43.015-.646.023l.004-2.507c1.816.415.087 1.743.642 2.484z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#312A6F"
        d="M600.127 362.125c-1.91-2.443-1.898-2.436.535-5.637.305-.4.576-.93.609-1.414.268-3.814.969-7.689.559-11.439-.42-3.842-.324-7.65-.469-11.473 1.395 1.191-.123 3.184 1.209 4.391-.221 7.621.814 15.303-1.156 22.842-.265 1.013-.431 2.019-1.287 2.73z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CEEDFA"
        d="M596.383 185.518l-1.268 1.316c-.531.715-1.121 1.206-2.016.528-.189-.494-.188-.934.34-1.23.896.029 1.668-.114 1.693-1.258l1.251.644z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#39A5EF"
        d="M645.053 259.763c-.307.837.65 1.678-.012 2.512l-2.41-.06c-.006-2.467-.014-4.934-.023-7.4 2.217-1.76 3.295-4.78 6.246-5.718 3.721-1.181 7.584-.958 9.932 1.928-.416 1.262 1.004 3.155-1.299 3.767-.676.249-1.117-.128-1.529-.576-1.129-1.414-1.695-3.862-4.391-2.36-.863 1.94-3.219 2.003-4.406 3.534-.299 1.653-1.075 3.077-2.108 4.373z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#322A6C"
        d="M452.811 151.157c.1 2.196-.727 3.622-3.117 3.743.652-1.57 1.715-2.796 3.117-3.743z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#621CE6"
        d="M455.264 76.258c-.891.023-1.471.512-1.887 1.249-.848-.027-1.604.155-2.268.746-2.225 1.978-4.6 3.637-7.764 3.074-.33 1.677 1.688.726 1.604 2.062l-3.336.97c-.131-.913-.676-1.265-1.564-1.152-.512-.044-.746-.397-.914-.826a5.837 5.837 0 00-.129-.58c.012-.387.027-.773.043-1.161-.533-3.276.48-4.063 4.656-3.625 1.613 1.336 2.744.388 3.818-.826 1.221-1.125 2.879-1.215 4.313-1.845 1.485.026 3.268-.477 3.428 1.914z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EDDFFC"
        d="M439.135 82.38c.307.276.613.552.916.827.707 1.231 1.412 2.462 2.121 3.694-2.933-.217-3.002-2.358-3.037-4.521z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#703AD9"
        d="M588.893 158.632c1.648.093 1.645 2.473 3.379 2.447.143.575.281 1.152.422 1.728.531 6.762.088 13.536.234 20.301.002 1.339-.01 2.68.006 4.021.137.832.031 1.533-.957 1.752a1.136 1.136 0 01-.961-.501c-.752-1.455-.48-3.032-.494-4.563-.033-4.542-.117-9.088.021-13.627.113-3.68-.383-7.182-2-10.503a1.56 1.56 0 01.35-1.055z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#694DA4"
        d="M592.661 183.639c.01-6.943.023-13.887.033-20.831 1.146 2.665.527 5.471.582 8.209.086 4.206-.047 8.416-.086 12.623-.178.271-.356.258-.529-.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#685389"
        d="M592.661 183.639c.174-.011.352-.01.529.001.084.831.168 1.66.25 2.491-.061.388-.123.774-.186 1.162-.158.239-.352.271-.578.094l-.015-3.748z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#508EA9"
        d="M610.106 189.873l2.445 2.675c.646 1.908 2.039 3.304 3.291 4.796.133.933 1.432 1.251 1.244 2.353.254.702-.082 1.164-.625 1.542-.666.192-1.16-.117-1.617-.543-1.258-1.706-2.75-3.239-3.875-5.052-.668-1.503-2.525-2.423-2.182-4.424.245-.64.663-1.109 1.319-1.347z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#39A0D2"
        d="M616.313 201.276c.258-.526.514-1.052.773-1.578 1.006 1.101 2.014 2.201 3.021 3.304.027 1.382-1.326.618-1.828 1.176-.738-.03-1.17-.523-1.588-1.045-.327-.578-.628-1.161-.378-1.857z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#367DAA"
        d="M552.911 141.148c-2.678-.021-5.67.842-6.715-3.046-.418-1.551-2.99.326-3.463-1.694 1.133.398 1.893.006 2.504-1.014.521-.87 1.279-.85 2.105-.284.729.498 1.33.988.957 1.99-1.021 2.727.232 3.179 2.533 2.482 1.467-.443 1.776.53 2.079 1.566zM542.094 136.146l-3.814-.001c-.219-2.275.746-3.353 3.08-3.041.769.887.619 1.996.734 3.042z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#572AB8"
        d="M455.264 76.258c-.764-1.779-2.348-1.087-3.658-1.214-.354-.377-1.023-.137-1.299-.666.004-.201.006-.403.002-.604 1.74-.549 3.486-.378 5.236-.073l.979.014c.615.589.434 1.275.238 1.963l-.797.615c-.232-.011-.468-.022-.701-.035z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#594C90"
        d="M456.762 75.679c-.08-.654-.16-1.309-.238-1.963.887-.104 1.814-.348 2.432.618l-2.194 1.345z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4D0EC7"
        d="M450.307 74.379c.531.03 1.014.154 1.299.666-1.217.7-2.832.583-3.779 1.84-1.201.5-2.398 1.004-3.746.64-2.33-.017-4.984-.553-5.031 3.116-.506-.022-.947-.166-1.217-.636a1.305 1.305 0 01-.367-.751c1.014-2.175-.34-2.739-2.072-3.042 0-.406 0-.812-.002-1.218.816-.654 1.629-.612 2.436.022 4.171.014 8.348.188 12.479-.637z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#621AE8"
        d="M437.827 75.014l-2.436-.021-.035-2.417 1.229-.143c.445-.236.867-.276 1.236.147l.006 2.434z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#634599"
        d="M455.545 73.702l-5.236.073c-.789-.203-1.852.421-2.314-.766 2.533.071 5.088-.095 7.55.693z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#65508D"
        d="M437.821 72.581l-1.236-.146c.002-.152 0-.304-.002-.456 1.525-.057 3.059-.208 4.516.441l-3.278.161z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E6F5F7"
        d="M618.823 210.413a3.149 3.149 0 00-.025.541c-2.904 2.092-5.807 4.185-8.709 6.278-.484-.924-1.063-1.77-1.969-2.349-.201-.647.137-1.098.543-1.527 1.539-1.29 3.232-2.387 4.727-3.734.781-.638 1.58-1.24 2.652-1.261.271.062.492.209.654.429.4 1.126 1.549.479 2.238.932.156.263.129.494-.111.691z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E6F6F7"
        d="M608.795 218.529c-1.053.348-1.875.993-2.498 1.906-.953 1.758-2.426 2.796-4.385 3.162-.754-.011-1.469-.124-1.902-.821-.113-.203.338-.343.104-.588a.575.575 0 01-.301.428c-.535.242-1.031.193-1.508-.111-.387-2.563 2.219-2.752 3.291-4.163.229-.187.473-.352.721-.511 1.375-.617 2.25-2.479 4.189-1.705.32.354-.008 1.378 1.055.979.77-.288 1.57-.553 2.176.334-.315.363-.629.726-.942 1.09z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F0F6EA"
        d="M609.737 217.438c-.594.065-1.316-.06-1.754.237-.783.53-1.604 1.374-2.377.521-.629-.695.934-1.206.771-2.089.076-1.002.359-1.763 1.617-1.387 1.662.033 2.932.394 2.094 2.512a.36.36 0 01-.351.206z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6FAF3"
        d="M595.11 189.228c.418-.203.84-.405 1.26-.607.77-.517 1.594-.737 2.512-.478 1.852 1.372.824 2.627-.402 3.444-1.662 1.106-3.566 2.605-5.303-.035-.501-1.722 1.003-1.784 1.933-2.324z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4F89CA"
        d="M595.11 189.228c-.637.61-1.271 1.221-1.906 1.832-.023.144-.049.286-.072.43-.322.707-.898 1.137-1.576 1.466-.555.202-1.115.439-1.645-.066-.699-1.348.309-2.18.939-3.129.338-.473.814-.794 1.26-1.149.188-.408.379-.815.566-1.223.195-.017.389-.048.578-.094.748.365 1.256-.248 1.861-.46.788.799-1.527 1.591-.005 2.393z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E1F9FA"
        d="M598.86 188.611l-2.488.009c1.168-1.484 2.941-2.172 4.363-3.325 1.754.054 3.604-.12 4.545 1.89-.041.133-.082.266-.121.399-.656.823-1.428.629-2.221.263-.574-.336-1.16-.389-1.762-.051-.736.389-1.634.291-2.316.815z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF9F8"
        d="M617.042 202.942c.412.413.824.824 1.238 1.236-.105.554.066.997.541 1.315.152 1.258-.832 1.049-1.541 1.2a3.617 3.617 0 01-.906-.17c-.713-.299-1.328-.708-1.645-1.45.182-.98-.822-1.228-1.178-1.885 0-.996.646-1.305 1.486-1.413.921-.045 1.462.56 2.005 1.167z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E4F7F5"
        d="M616.7 206.233c.732-.177 1.588.004 2.121-.74 1.854 1.639 1.596 3.279.002 4.919a10.26 10.26 0 00-.012-.608c-.488-1.04-1.633-.717-2.41-1.159l-.158-.161c-.268-.835-.004-1.563.457-2.251z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#683FB0"
        d="M584.377 153.211c.51.535 1.602.479 1.58 1.556a1.114 1.114 0 00-.264.178c-.232.427-.457.863-1.004.966-1.287.12-2.205-.749-3.279-1.205-7.787-.387-15.572-.058-23.355-.174-1.658-.025-3.324.156-4.969-.221-.555-.231-1.08-.486-1.006-1.23l-.031-.246c9.227.015 18.453.017 27.682.061 1.549.007 3.098.205 4.646.315z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#367AA9"
        d="M551.458 148.686l.027-3.213 2.457.786c.428 2.862.412 2.876-2.484 2.427z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B72C8"
        d="M552.081 153.08c.217.191.436.382.65.573.186.24.332.501.443.783.057.3.064.601.02.903-.24.85-.75 1.288-1.676 1.083-.682-.35-1.195-.878-1.592-1.529-.143-.454-.1-.869.256-1.22l.008-.026c.545-.236.002-1.52 1.141-1.187l.75.62z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3782B8"
        d="M551.331 152.46l-1.141 1.188-.006-3.729v-.001l1.316.045-.169 2.497z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#427596"
        d="M551.458 148.686c1.85.235 2.734-.514 2.484-2.427 1.152 2.54 1.152 2.54-2.455 3.717l-.029-1.29z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F3EAF6"
        d="M598.317 310.118c1.613 1.143 3.227 2.282 4.84 3.423 2.248 1.423 2.203 3.072.633 5.035-1.391 1.736-2.627 3.6-3.93 5.408-.615 2.625-2.449 4.455-4.236 6.264-.93.939-2.25.891-3.496.471-1.168-1.172-3.088-1.572-3.57-3.453.076-.898.682-1.311 1.443-1.584 1.088-.17 1.922.453 2.816.887 1.227.648 1.527-.178 1.752-1.117.447-1.996 1.152-4.004-2.131-4.268-1.027-.082-1.107-1.275-.904-2.242a1.52 1.52 0 01.535-.682 1.47 1.47 0 01.855.07c1.922.801 4.305.738 5.275 3.32.691-1.275.09-2.236.426-3.125.17-.256.393-.453.666-.586.814-.396 1.848-.748 1.352-1.923-.479-1.139-1.479-.713-2.346-.45a1.393 1.393 0 01-.807-.177 1.79 1.79 0 01-.336-.749c-.018-1.333 1.279-2.402.768-3.838a1.04 1.04 0 01.395-.684z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5B43A5"
        d="M592.069 330.068c1.924.582 3.318.004 4.43-1.721.992-1.537 2.232-2.916 3.361-4.363l1.529-.563c-.213.627-.428 1.254-.639 1.881-1.135 1.602-2.23 3.23-3.408 4.797-1.77 2.355-3.744 2.609-6.006.846.063-.443.323-.722.733-.877z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E1F9FA"
        d="M608.788 191.22l2.744 4.199c-1.195.961-2.256.309-3.324-.271-1.016-1.511-1.65-3.254-2.902-4.634-.828-.915-.988-1.986-.25-3.08.072-.083.146-.166.223-.247 1.169 1.342 2.339 2.688 3.509 4.033z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1C83CB"
        d="M631.315 183.01c.145 2.256-.279 4.118-3.037 4.345-.018-.211-.033-.423-.049-.634 1.166-1.085-.182-2.568.588-3.715l2.498.004z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9F8F9"
        d="M597.6 314.668c0 .199.004.398.01.598.174 1.02.625 2.02.242 3.088a1.582 1.582 0 01-.748.596c-1.488.074-3.006.461-4.385-.469l-.182-.109c-.412-.49-.494-1.063-.412-1.674-.25-1.011 1.758-3.229-1.434-2.655a8.754 8.754 0 01-1.463.737c-.789.287-1.539.659-2.275 1.065-1.213.536-2.33 1.376-3.773 1.181-.814-.211-1.34-.727-1.598-1.524-.232-1.173.393-2.012 1.098-2.817.564-.607 1.074-1.269 1.703-1.818.213-.228.43-.452.645-.679.615-1.761 1.82-3.071 3.223-4.233l.004-.009c2.42-2.275 2.918-2.212 6.137.787.238.204.479.407.721.612l3.205 2.776-.076.828c.126 1.298-2.482 2.125-.642 3.719z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#631DDA"
        d="M585.102 155.515c.199-.19.396-.381.592-.571.313 1.882 2.924 1.774 3.199 3.688-.016.233-.027.467-.041.7-.273.481-.115 1.203-.807 1.456a2.648 2.648 0 01-.896.059c-4.07-.568-4.07-.568-2.588-4.579.166-.261.348-.51.541-.753z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#367DAA"
        d="M537.749 136.413c.035.354 1.285.683.26.956-1.836.49-3.625-.045-5.207-1.141-.385-.185-.434-.434-.143-.748a3.23 3.23 0 00.113-.476c.758-.232 1.521-.578 2.238.102.393 1.525 1.471 1.613 2.739 1.307z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4C85B0"
        d="M628.622 188.706c1.146.07 1.982-.487 2.67-1.333-.023.577-.049 1.153-.072 1.729l-2.381.112a3.937 3.937 0 00-.217-.508z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3B1292"
        d="M437.827 79.382c.016.207.018.415.006.622-.826-.029-1.646-.546-2.484-.048l.023-3.093c1.796-.113 1.931 1.394 2.455 2.519z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F4D3DA"
        d="M294.342 86.767l-1.199-1.401-2.5-2.378c-.225-.063-.315-.156-.273-.278.047-.138.102-.206.165-.206 2.857-.864 3.258 2.193 4.99 3.125-.51.304-.582.819-.646 1.339a2.594 2.594 0 00-.537-.201z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#607A82"
        d="M532.659 135.479c.047.249.094.499.143.748-.055.606-.109 1.212-.166 1.818l-1.041-1.32c.171-.57.327-1.155 1.064-1.246z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#508EAF"
        d="M602.057 222.977a4319.28 4319.28 0 004.24-2.542c.697.227 1.396.454 2.096.679-1.953 1.624-3.902 3.247-5.855 4.87-1.227.471-2.152 1.636-3.611 1.569-.418-.293-.541-.719-.551-1.199.061-.814.586-1.368 1.072-1.945.607-.955 1.709-1.009 2.609-1.432z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4711B3"
        d="M437.827 79.382c-.816-.839-1.637-1.679-2.455-2.518.006-.218.012-.435.021-.653 1.121-.567 2.664-.793 3.334-.057.932 1.029-.56 2.126-.9 3.228z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2C177C"
        d="M514.61 161.778c-1.492-2.963-5.264-3.415-6.877-6.246l.006-1.224 1.256-.023.016.053c1.484.149 1.707 1.904 2.975 2.331.254.104.492.23.727.369.234.147.449.318.654.504 2.008 1.441 3.643 3.344 5.775 4.632.898.936 1.977 1.705 2.641 2.861.115.472.049.906-.258 1.296-.535.397-1.135.461-1.771.355-2.107-.791-3.059-2.805-4.521-4.281l-.623-.627z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BBC4F8"
        d="M616.348 466.91c-.006.436-.008.873-.012 1.309-54.207 0-108.418.008-162.623-.029-1.359 0-2.943.656-4.063-.783.344-1.154 1.346-1.158 2.266-1.254 1.033-.105 2.076-.059 3.113-.059 52.072-.002 104.143-.01 156.211.02 1.721-.001 3.565-.464 5.108.796z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#34189B"
        d="M616.348 466.91c-22.252-.021-44.506-.055-66.756-.061-32.238-.006-64.477.002-96.713.035-1.078.002-2.295-.488-3.229.521-.395-.158-.785-.318-1.178-.479l.508-.666c.746-.568 1.639-.748 2.523-.961a4.412 4.412 0 011.459-.059c.344.064.682.127 1.025.184 6.424-.133 12.863.6 19.266-.443 13.717-.303 27.432-.125 41.146-.119 12.674.006 25.35-.223 38.021.135 1.189.381 2.412.479 3.658.479 7.736-.008 15.475.002 23.209-.01 1.031-.002 2.068.043 3.057-.336 1.707-.348 3.42-.311 5.135-.07 1.811.627 3.686.383 5.543.412 6.748.006 13.494-.016 20.24.01 1.336.006 2.709-.182 3.975.477.432.26.473.574.129.941-.338.002-.678.006-1.018.01z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B2D9FA"
        d="M442.831 473.219l-.631-.633c.156-.225.311-.451.465-.676.518.002 1.252.229 1.518-.029 2.393-2.307 4.547-2.545 7.287-.242.928.779 2.746-1.068 4.518-1 5.594.217 11.203.082 16.803.082 1.625.418 3.285.365 4.938.365 13.35.002 26.695-.002 40.043.004 1.139 0 2.289-.094 3.406.135 1.021.211 2.127.48 1.545 1.992-1.088.861-2.383.609-3.605.609-24.227.016-48.451.016-72.676.002-1.229-.002-2.52.25-3.611-.609z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B6D9F4"
        d="M522.721 473.217c-.396-1.906-1.939-1.217-3.031-1.221-14.623-.041-29.244-.014-43.869-.057-1.092-.002-2.633.688-3.031-1.219 1.09-.865 2.385-.613 3.607-.613 24.227-.014 48.451-.014 72.678 0 1.225 0 2.516-.252 3.605.613v-.002c.494 2.395-1.373 1.813-2.498 1.834-4.74.086-9.48.021-14.219.045-1.113.008-2.289-.213-3.256.617l-9.986.003zM442.831 473.219l79.891-.002-.006 1.24c-3.328.002-6.652.006-9.979.012-22.189-.002-44.375.01-66.563-.041-1.162-.002-2.836.836-3.343-1.209z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B4D7FE"
        d="M552.68 470.721h-79.891c.221-1.545 1.428-1.242 2.414-1.242 25.02-.01 50.043-.01 75.064 0 .987 0 2.192-.301 2.413 1.242z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B4D8FC"
        d="M532.708 473.215c.299-1.729 1.676-1.219 2.707-1.229 4.854-.043 9.707.004 14.561-.035 1.031-.012 2.41.496 2.705-1.232h29.457c.152 1.381-.648 1.264-1.189 1.223-11.561-.869-22.98 1.924-34.541 1.314-4.554-.242-9.132-.041-13.7-.041zM320.59 472.422c-.03.264-.062.529-.094.795h-87.353c1.05-1.721 2.283-1.221 3.263-1.227 11.209-.035 22.419-.004 33.628-.051 1.093-.004 2.636.688 3.034-1.219l.42-.396c1.356-.703 2.832-.555 4.274-.557 10.17-.016 20.342.104 30.509-.076 3.05-.053 5.837 1.617 8.895.945 1.307-.598 2.4-.314 3.288.805.203.303.246.631.136.981z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B4D7FE"
        d="M273.069 470.721H193.18c-.59-1.307.32-1.672 1.268-1.932 1.012-.281 2.066-.195 3.104-.195 23.715-.008 47.429-.008 71.144 0 1.038 0 2.092-.086 3.104.195.949.26 1.859.625 1.269 1.932z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#332A7B"
        d="M446.598 459.432c-2.602.164-5.197.295-7.514-1.25-.354-.365-.387-.797-.264-1.262 1.166-1.861.775-3.639-.299-5.381-1.129-5.621-1.242-11.449-3.475-16.838-1.225-1.623.549-4.137-1.637-5.475-1.74-.297-3.566.244-5.248-.555-.855-1.652.588-1.545 1.424-1.729 1.152-.252 2.287-.395 2.357-1.92-.008-.859-.076-1.719.061-2.572-.072-1.17.586-2.506-.785-3.373-.393-.193-.756-.42-1.031-.771a1.985 1.985 0 01-.068-.889c-.08-5.223-.729-10.383-1.641-15.514-.879-3.125-1.445-6.305-1.797-9.523-.367-1.629-.955-3.197-1.436-4.787-.385-1.037-.885-1.068-1.279-.049-.715 1.828-.234 3.531.75 5.145.426 2.873.258 5.752.129 8.631a5.594 5.594 0 01-.217 1.004c-1.229 2.906-.723 6.035-1.158 9.045a2.491 2.491 0 01-.531.91c-.279.223-.59.391-.922.52-1.518.379-1.76 1.479-1.764 2.852-.014 5.975-.795 11.928.758 17.906.791 3.043.293 6.389.105 9.596-.09.402-.156.988-.488 1.088-3.781 1.162-2.984 4.277-3.189 7.061-.1 1.365.668 3.67-2.234 3.24-.793-.977-.785-2.166-.664-3.281.535-4.947-1.438-9.631-1.473-14.512-.004-.404-.301-.768-.508-1.127a4.45 4.45 0 01-.35-.975c-.258-1.465-.17-2.947-.168-4.422-.012-.699.08-1.418-.326-2.061-.34-.572-.977-1.002-.881-1.793 1.104-1.203-.328-2.525.162-3.754-.084-.773-.16-1.551-.43-2.289-.223-.92-1.027-1.379-1.598-2.027a1.118 1.118 0 01.068-.77c.467-.484 1.039-.895 1.055-1.666.154-1.766-.082-3.551.344-5.295.652-2.838.188-5.715.313-8.568.014-2.215.01-4.428 0-6.641.1-2.111-.188-4.24.264-6.334.773-1.496 1.648-2.992.064-4.533-.436-4.059.447-7.977 1.256-11.898.227-.721 1.631-1.076.662-2.178-.264-.928-.264-1.818.314-2.637a.929.929 0 01.9-.17c.719.557 1.371 1.256 2.412 1.143 2.365-.254 4.365.834 6.418 1.744 3.293 1.213 6.574 1.248 9.846-.09 1.359-.518 2.783-.352 4.189-.412.367-.012.732-.01 1.1-.006 1.654.154 3.432-.377 4.902.846.777 3.885 2.57 7.764.098 11.678-1.617.482-1.691 1.834-1.898 3.203-1.52 9.98-1.195 20.037-1.373 30.08-.066 3.738.896 7.123 2.252 10.482.354 1.238.117 2.637.994 3.738.244.592.271 1.195.092 1.807-2.064 2.348.689 3.602 1.227 5.361.041.453-.076.848-.434 1.148-1.611 1.113-1.611 1.113-1.82 5.299-.061.414.508.131.094.156-.088.008-.123-.094-.072-.293.482-1.861.73-3.816 2.094-5.338 1.488.635 1.563 2.057 1.785 3.338.684 3.938 1.164 7.908 1.873 11.846.172.965-.045 2.109 1.051 2.727.441.145.859.338 1.229.621.34.34.445.75.359 1.215-1.199.881-2.83.639-4.029 1.528z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B6D8FA"
        d="M428.493 473.844c-5.514 1.322-11.113.402-16.668.58-4.782.148-9.567.039-14.353.037-11.789-.008-23.578-.014-35.368-.055-.345-.002-.687-.371-1.03-.566.387-1.158 1.617-1.607 2.184-2.619.437-.512.965-.861 1.635-.99 7.784-1.129 15.566-1.994 23.471-1.75 3.447.107 6.629 1.863 10.117 1.221.896.051 1.57.572 2.26 1.053 3.428 2.359 6.887 2.117 10.444.254 1.703-.891 3.061-2.488 5.152-2.607.875.117 1.74.289 2.625.346 1.113.133 2.195.563 3.35.377.289.016.564.086.832.195 1.287.824 2.82.471 4.189.855.965.27 2.455-.035 2.365 1.729l-1.205 1.94z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B5D5F0"
        d="M429.698 471.902c-1.178-1.568-2.924-1.01-4.471-1.176-.971-.107-2.17.283-2.369-1.256-.549-.465 1.076-1.146-.152-1.551.262-.834.943-1.188 1.674-1.49.318-.117.646-.188.982-.227 2.721.209 5.568-.861 8.139.814.279.67-.115.984-.646 1.223-1.024 1.247-1.728 2.769-3.157 3.663z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3E2495"
        d="M439.106 457.006c-.008.393-.016.785-.021 1.178a2.346 2.346 0 01-.592.063c-.324.25-.623.225-.898-.078-.307-.438-.459-.928-.527-1.449-.336-2.957.488-6.047-1.018-8.875a4.844 4.844 0 01-.24-1.021c-.098-2.641-.176-5.264-1.059-7.824-.461-1.338-.451-2.816.252-4.166.131-.121.264-.244.396-.363 2.059 1.016 2.135 3.635 2.137 4.895.006 4.316 2.232 8.299 1.563 12.621.898 1.671.888 3.343.007 5.019z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3E1899"
        d="M437.799 458.203c.23.016.461.027.693.043-.213.23-.422.463-.633.693-1.166 2.129-1.656 4.514-2.547 6.748l.002.006c-.361.359-.789.574-1.307.592-.5-.004-.945-.154-1.305-.512.467-2.42.588-4.908 2.244-7.014.929-1.177 1.713-1.337 2.853-.556z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#321D86"
        d="M432.825 465.701c.432.014.861.025 1.291.039.346.412.377.842.064 1.287-.043.191-.07.381-.084.574-.225.207-.441.211-.65-.02-2.789-1.539-5.814-.301-8.697-.742-.369-.92-.072-1.709.486-2.447.27-.137.553-.184.854-.146.832.287 1.627.73 2.559.629 1.431.086 2.942-.236 4.177.826z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2E1776"
        d="M446.598 459.432c1.139-.695 1.957-2.383 3.703-1.195 1.172 1.568 1.102 3.287.629 5.061-.516.711-.512 1.967-1.867 1.807.01-1.131-.1-2.277.055-3.387.287-2.093-.594-2.724-2.52-2.286z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#20164F"
        d="M435.313 465.688c-.057-2.592.336-5.014 2.547-6.75.59 2.525-1.52 4.502-1.4 7.029.048 1.041-.686-.363-1.147-.279z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#321886"
        d="M449.063 465.104c.416-.625.836-1.25 1.252-1.875.77.672.996 1.607 1.242 2.533-.725.863-1.678.537-2.574.5.025-.387.051-.774.08-1.158z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#20164F"
        d="M434.18 467.027l-.064-1.287c.4-.016.799-.029 1.199-.047-.082.654.313 1.377-.24 1.934-.051.049-.584-.387-.895-.6zM433.446 467.582l.65.02-.227 1.928c-.688-.154-.717-.828-1.016-1.289.196-.22.396-.44.593-.659z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#181A44"
        d="M363.392 471.963c-.316 1.188-1.66 1.107-2.318 1.877l-.645.102a.86.86 0 01-.789.043c-1.344-.414-2.688-.4-4.031.006a.743.743 0 01-.77-.105c-.618-.246-1.238-.49-1.859-.736-.647.131-1.276.084-1.885-.191-2.652-2.166-5.572-3.564-9.123-3.357-.912.053-1.902-.088-2.375-1.129-.013-1.875 1.385-2.068 2.738-2.219 2.287-.26 4.518.053 6.695.777 1.424.473 2.808 2.031 4.264-.156.375-.563 1.31.166 1.827.682 1.1 1.092 1.087 2.301-.047 4.006 3.263-2.45 5.763-.784 8.318.4z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B5D7F8"
        d="M339.875 468.164c.719.93 1.858.926 2.755.82 3.729-.438 6.592 1.068 9.075 3.629.485.848-1.628.824-.62 1.848h-1.87c-.216-1.512-1.391-1.225-2.372-1.238-1.842-.023-3.684-.004-5.525-.008-4.131-.01-4.625-.785-2.959-4.604.16-.371.221-.781.327-1.176.601-.089.92.28 1.189.729z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B5D6F3"
        d="M351.085 474.461c-1.66-1.242.471-1.213.62-1.848.586-.203.967.082 1.274.535-.054 1.27-.937 1.344-1.894 1.313z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B7D0EB"
        d="M359.806 473.779c.208.053.416.109.623.162-1.871.813-3.734.885-5.59-.057l.64-.137c1.444-.37 2.888-.419 4.327.032z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1A1744"
        d="M320.524 471.896l-2.464-1.334c-1.773-.309-3.324-.951-4.098-2.754-.059-.76-.215-1.502-.377-2.246-.158-2.072-.349-4.156 1.918-5.359 2.402-.383 4.72.348 7.075.537 2.715.732 2.264 3.27 2.95 5.893.663-1.916.169-3.404.938-4.578.311-.352.707-.461 1.156-.408 1.632.801.802 2.77 1.83 3.857.301.461.465.955.398 1.51 1.441 2.775 3.96 4.693 5.744 7.197-2.492.623-2.939 4.717-6.632 3.795l2.235-1.039c-3.125.32-4.488-1.01-5.716-2.918-.895-1.391-2.372-2.432-3.087.355-.914-.279-1.051-1.066-1.209-1.838.26-1.256 1.697-.934 2.35-1.727-.303-1.016-1.303-1.682-1.329-2.906-.599 1.399.186 3.243-1.682 3.963z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1A1A3D"
        d="M320.524 471.896c.905-1.867.497-4.156 1.968-5.98-.145 2.379 1.239 3.906 2.938 5.49-1.45.943-3.108.201-4.242 1.16a20.74 20.74 0 00-.597-.145 4.03 4.03 0 00-.067-.525z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1B173F"
        d="M339.875 468.164a471.48 471.48 0 01-1.189-.729 10.96 10.96 0 00-.025-.57c-.738-2.742-.331-5.473.092-8.197.693-1.092 1.603-.51 2.394-.232 1.468.514 2.939.541 4.441.281 2.676-.307 5.158.109 7.241 1.969.214.203.399.436.561.686.629 1.518 1.917 2.219 3.382 2.699.9.41 1.793.838 2.689 1.26 1.311.758 2.744 1.248 4.099 1.924 1.17.971 1.707 2.07.708 3.477-.291.412-.584.822-.875 1.232-1.365.088-2.656-.082-3.904-.746-1.016-.543-1.991-.934-2.871.52-.979 1.617-2.121-.467-3.529.055 2.595-1.432 3.26-2.803.402-4.613-1.558 5.684-3.872.287-5.849.24-2.678-.066-5.314-1.326-7.767.744z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#311A87"
        d="M339.255 458.285c-.205 2.859.316 5.77-.595 8.58l-8.81.148c-.512-.271-.618-.748-.629-1.27.201-.266.46-.455.768-.572 1.234-.365 2.501-.236 3.757-.254 2.271.352 3.497-.506 3.389-2.924.04-.953.013-1.904.002-2.857.032-1.07-.009-2.158.903-2.959 1.78-.089 1.821.823 1.215 2.108z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BEDAEC"
        d="M135.135 380.848l.003-.619c.093-.045.181-.113.279-.133 4.724-.902 6.208-3.818 5.368-8.357-.357-1.928.696-2.662 2.665-2.807 6.975-.518 6.976-.588 8.418 6.301.125.598.111 1.227.162 1.844.629.58 1.813.365 2.089 1.453-.015.59.112 1.295-.885 1.07-2.261-1.244-4.072-2.736-3.762-5.723.226-2.168-.294-4.002-2.919-4.234-1.815-.164-4.361 2.264-4.536 4.289-.191 2.209.182 4.369-1.037 6.59-.822 1.496-.832.828-1.832.457-1.189-.446-2.663-.124-4.013-.131z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6FCFC"
        d="M138.287 340.916c2.723-2.957 4.243.234 6.196 1.211-.094.859-.537 2.586-1.243 1.549-2.026-2.98-1.681.775-2.329.748-1.217-.463-.297-1.381-.802-2.027-.198.209-.494.375-.524.578-.216 1.484-.759 3.254-2.263 3.156-1.571-.098-3.975.557-4.401-2.521-.298-2.148-1.731-1.418-2.78-.217-.368-.408-.357-.816.008-1.223 1.137-2.125 2.428-2.314 3.745-.588.563.736.357 1.852 1.247 2.406 1.365-.701 2.755-1.375 3.146-3.072z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E1DAF9"
        d="M153.865 378.355l-1.836-1.279c.802.002 1.604.004 2.406.008l-.03 1.248c-.166.309-.345.332-.54.023z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF8F8"
        d="M130.148 342.17l-.008 1.223c-.413.008-.826.014-1.239.02-.51-.029-.983-.129-1.247-.639.907.109 1.713-.196 2.494-.604z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BDD8EC"
        d="M132.667 332.15c-1.047.002-2.095.004-3.142.008-.849-.613-.39-1.885-1.253-2.492-.953-2.496-.953-4.992 0-7.486v-.004c1.183-2.664 3.977-2.779 6.169-3.607 2.773-1.051 5.963.797 7.234 4.049 1.033 2.643 1.5 5.373-.408 8.072-.867 1.225-1.73 1.605-3.053 1.455-.358-1.096.479-1.746.992-2.473 1.408-1.988 1.643-4.051.338-6.115-1.306-2.064-3.274-2.758-5.658-2.256-.253.123-.511.234-.765.352-3.825 2.781-4.165 5.342-1.182 8.943.377.457.956.814.728 1.554z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B5D8FA"
        d="M139.504 338.402c-3.588.826-7.175 1.66-11.115 1.693-.413-.664.004-1.832-.121-2.938 2.519.27 4.917-.064 6.931-1.715 1.184-.969 2.515-.803 3.832-.766 1.346.041 2.624-.061 3.756-1.152 1.095 2.902.132 3.898-2.53 3.641-.98-.093-2.115-.153-.753 1.237z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F1FBFD"
        d="M133.271 320.93c2.546-1.543 4.82-.32 6.364 1.375 1.566 1.721 2.496 4.135.897 6.563-.736 1.117-1.542 2.188-2.317 3.277l-4.952.033a3.384 3.384 0 00-.595-.027c-5.043-4.018-4.786-8.838.6-11.217.882 1.412-.586 1.982-1.048 2.91-.776 1.555-1.271 3.287-.039 4.648 1.274 1.406 3.306 1.09 4.963.852.848-.123 1.751-1.01 1.71-2.502-.049-1.738-.599-3.307-2.026-3.713-1.507-.43-2.391-1.453-3.557-2.199z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BDD7EE"
        d="M149.489 330.93c.833.412 1.668.822 2.503 1.23-.425 3.338-2.381 3.561-4.99 2.451.333-1.56 3.379-1.291 2.487-3.681z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FDFDFE"
        d="M154.427 398.963l.161 28.105-.428.252a1.97 1.97 0 01-.976-.045c-4-2.08-8.425-1.715-12.706-2.188-.906-.328-1.685-.904-2.544-1.328-1.755-1.703-2.66-3.885-3.44-6.137-1.348-4.738-.182-9.037 2.299-13.104.134-.289.299-.557.485-.813.727-.826 1.509-1.605 2.188-2.475 3.657-4.285 8.597-3.57 13.387-3.441.716.133 1.126.68 1.574 1.174z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C7D3F8"
        d="M154.427 398.963c-.402-.199-.805-.398-1.207-.6-.354-.434-.356-.867.012-1.297l.002-17.467c.501-.268.614-.73.631-1.244.18-.006.36-.014.54-.023l.022 20.631z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#603EB3"
        d="M155.084 427.041l.067-28.717c.428-.17.756-.057.986.342.513.957.472 2.008.457 3.037-.122 8.168.311 16.344-.23 24.51a2.021 2.021 0 01-.696.939c-.194-.035-.389-.074-.584-.111z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5940CC"
        d="M155.714 398.328l-.281-.004h-.281l.052-21.227c.171 0 .341-.002.511-.006.787.684.856 1.625.866 2.557.058 5.375.058 10.75 0 16.123-.011.936-.08 1.875-.867 2.557z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#866EF6"
        d="M154.588 427.068c.165-.018.33-.029.497-.027l.113-.043c.393.5.693 1.061.695 1.695.016 5.881.416 11.768-.22 17.645a1.542 1.542 0 01-.828.818 1.319 1.319 0 01-.857-.764c-.339-5.893.065-11.795-.211-17.689-.031-.65.267-1.199.65-1.707l.161.072z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#663AB4"
        d="M173.155 153.02c17.075-.01 34.15-.02 51.225-.028.203.439.099.787-.309 1.047-1.054.586-2.216.495-3.353.496-14.558.017-29.116.019-43.674-.004-1.326-.001-2.737.221-3.843-.848l.008-.068c-.201-.115-.275-.241-.224-.379.052-.145.109-.216.17-.216z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F63A4E"
        d="M230.432 149.825c1.995.809 3.251-1.708 5.19-1.152-.768 3.047 2.19 2.121 3.792 3.137-1.816 1.029-3.951.154-5.042 1.853l-.334.236c-1.608.06-1.638-2.541-3.496-2.064-.438-.07-.84-.221-1.18-.515-.401-.75.25-1.041.634-1.449a.725.725 0 01.436-.046z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BD338C"
        d="M224.272 153.719l.107-.728c.386-.042.772-.082 1.158-.122.661.462.784 1.148.791 1.884-.986 1.79-.236 4.505-2.875 5.422-1.242-.6-.98-1.85-1.243-2.873a2.47 2.47 0 01.136-1.275c.107-.244.251-.471.412-.684.319-.382.659-.753 1.025-1.097.17-.168.333-.344.489-.527z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#67439A"
        d="M173.155 153.02c.032.197.049.395.053.595-2.905-.182-5.846.518-8.722-.365 2.875-.631 5.773-.368 8.669-.23z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CC4B5D"
        d="M225.619 154.917l-.081-2.047 2.038-1.666c.27-.285.521-.27.753.046.242 1.536-.666 2.653-1.402 3.833-.469.21-.911.19-1.308-.166z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D86F7A"
        d="M228.207 151.277l-.63-.073c.554-.904 1.375-1.323 2.421-1.333l-.605 1.287c-.366.341-.759.398-1.186.119z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6F34E4"
        d="M155.714 398.328v-21.236c.006-69.065.011-138.135.019-207.203 0-1.456.015-2.912.022-4.368l1.154-.624c1.506 1.571.928 3.548.929 5.351.033 59.674.026 119.348.026 179.021 0 3.014 0 6.029.009 9.045-.026 27.83-.003 55.658-.004 83.488-.017 1.242.085 2.498-.155 3.721-.209 1.066-.574 2.1-2.058 1.504-.34-6.672-.432-13.344.045-20.014l.013-28.685z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5E23D1"
        d="M102.7 217.337l.636-.054c2.224-.537 4.479-.163 6.718-.228 1.092.109 2.183.219 3.274.33.515.64.338 1.3.06 1.965l-.661 1.162c-.797.101-1.566-.043-2.328-.269-2.316-.264-4.459-1.188-6.698-1.744-.592-.145-1.192-.324-1.001-1.162z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#471E97"
        d="M110.796 219.818c.722.014 1.497-.121 1.931.694l-.504 1.786-.135.661c-.702.291-1.162-.077-1.575-.578-.376-.737-.411-1.482-.044-2.236l.327-.327z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#573C91"
        d="M110.054 217.056c-2.224.522-4.478.177-6.718.228l.099-.72c2.22-.006 4.438-.001 6.619.492z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5C4E7F"
        d="M113.388 219.351l-.06-1.965c.547-.056 1.394-.34 1.48.315.105.804-.707 1.292-1.42 1.65z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EA0618"
        d="M240.647 154.987c2.034.122 2.453-2.463 4.338-2.589 2.215-2.141 5.067-3.418 7.374-5.441.557-.488 1.248-.708 1.985-.291.585 1.488-.506 2.63-.805 3.938-3.527 4.068-7.752 7.277-12.362 10.016-2.224.259-4.745-.507-6.35 1.86-1.303 1.196-.932 2.453-.136 3.728.126.436.102.863-.074 1.282-.835.826-1.253 2.656-2.571 2.261-1.335-.4-.831-2.133-.927-3.327-.09-1.125.099-2.264-.133-3.465-.404.717-.366 1.607-1.146 2.024-.354.077-.622-.038-.814-.343-.618-1.282-.549-2.582-.118-3.892 2.105-2.076 4.795-2.956 7.563-3.671.754.27 1.256 1.122 2.206.963.11-.019.219.014.31-.006-.176-.178-.452-.119-.653-.274-.611-.456-.405-.959-.111-1.469.17-.215.372-.4.6-.553.577-.321 1.118-.738 1.824-.751z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F53C4B"
        d="M243.07 144.902c.027-.4.054-.801.083-1.201 3.254-1.085 6.789-1.695 8.662-5.117l.054-.094c.778-.067 1.542-.434 2.339-.11.696.41 1.309.908 1.741 1.605.351.726.422 1.495.346 2.286-.692 2.467-2.366 3.989-4.685 4.936-2.255.922-3.561 3.303-6.002 3.958-.719 0-1.448.076-2.155-.017-1.001-.132-2.586.594-2.697-1.138-.117-1.824 1.5-1.209 2.505-1.332.8-.098 1.652.095 2.294-.619.602-.669 1.524-1.187 1.147-2.311-.357-1.067-1.317-.754-2.091-.818-.511-.04-1.028-.02-1.541-.028z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FC3444"
        d="M245.608 151.166c2.363-2.902 5.543-4.651 8.796-6.323.886-.456.836-1.579 1.192-2.408 1.013-.868 2.123-.914 3.299-.388 1.188 1.16.129 1.908-.608 2.499-1.179.943-2.202 2.251-3.942 2.232-3.27 1.625-5.746 4.569-9.36 5.619l.623-1.231z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F63A4E"
        d="M240.647 154.987c-.271.558-.68.953-1.292 1.115-1.39-.915-2.63-.235-3.881.367-1.187.146-1.909-.523-2.292-1.499-.42-1.068.818-.838 1.189-1.307h.001c1.425.001 2.851.018 4.275-.002.987-.014 1.864.085 2 1.326z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A1329D"
        d="M254.318 138.738c-.818-.082-1.635-.163-2.451-.246l1.235-1.15 1.226.11c.58.992 1.945.286 2.568 1.187l-.12.139c-.83.666-1.647.52-2.458-.04z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FBDDB0"
        d="M235.636 88.776c.198-.021.396-.035.594-.042.611-.435.865-1.613 1.9-1.151.915.409 1.096 1.383 1.298 2.301.368 1.667-.976 3.431.308 5.034.197.433.314.888.375 1.357.113 1.326.236 2.688.018 3.979-.468 2.781.441 4.751 2.949 6.004l.027 2.461c-2.555-.046-5.21.498-7.481-1.25l.012-18.693z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4808B2"
        d="M157.011 358.377c-.013-56.082-.024-112.163-.042-168.245-.003-8.412-.038-16.824-.059-25.235.294-1.024-.373-2.269.718-3.11.812-.027 1.016.561 1.197 1.175-.463 3.821-.335 7.661-.335 11.496-.003 59.429.001 118.859-.015 178.289 0 1.75.28 3.541-.433 5.238-.237.411-.582.54-1.031.392z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4D12CE"
        d="M158.235 162.388l-.607-.601c2.307-5.357 6.409-7.784 12.194-7.504 1.129.054 2.263-.018 3.395-.032l.601.024c15.303.032 30.606-.018 45.909.056 1.148.005 2.799-.834 3.363 1.143l-.026.076c-1.196.921-2.635.812-4.016.958-15.114 0-30.229.138-45.34-.054-2.33-.084-4.666-.066-6.996-.029-2.748.185-4.658 1.677-6.25 3.824-.598.805-.736 2.223-2.227 2.139z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7442D4"
        d="M224.272 153.719c.005.192-.021.378-.082.561-.448.32-.954.335-1.482.333-15.885-.049-31.77-.011-47.656-.027-.617 0-1.251.08-1.825-.253l-.011-.082a21.82 21.82 0 00-.017-.57l51.073.038z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#500DC1"
        d="M102.7 217.337l8.096 2.481.007.029c-1.139.958-2.451.86-3.786.621l-4.95-1.897c-.561-.225-.925-.557-.665-1.228l1.298-.006z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5E1AE4"
        d="M101.401 217.343l.665 1.228c-.024.839-.491 1.234-1.296 1.285-1.194-.101-1.508-1.173-2.271-1.825.889-1.125 1.976-.531 2.902-.688z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5A1AD3"
        d="M246.233 105.009c1.336-.13 2.179-1.094 3.098-1.892.423-.367.84-.714 1.341-.421.567.333.325.902.108 1.365-.551 1.178.414 2.185.339 3.305a6.024 6.024 0 01-.582.109c-2.016.387-3.05-1.847-4.922-1.843.06-.353.269-.557.618-.623z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5F1CF2"
        d="M102.07 222.305c1.141-2.505 3.355-.695 4.984-1.241.363-.357.778-.383 1.228-.197.625.561.661 1.277.541 2.034a2.006 2.006 0 01-.385.734 1.303 1.303 0 01-.786.141c-2.247.983-3.956-.089-5.582-1.471z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#601FDC"
        d="M102.07 222.305c1.973-.057 3.555 1.644 5.605 1.245.369.413.369.821-.007 1.228l-4.936.057-1.276-1.484.614-1.046z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4411B0"
        d="M108.291 221.09l-1.237-.026a14.942 14.942 0 00-.038-.597c1.108-1.145 2.516-.466 3.786-.621l-.003 2.479a.833.833 0 01-.715.132c-.669-.359-1.24-.852-1.793-1.367z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7436E2"
        d="M246.233 105.009l-.618.623-.708.622-1.736-1.333c-.15-.044-.3-.089-.45-.131-2.021-2.434.169-3.942 1.245-5.698 2.776-2.271 4.677-5.526 8.011-7.177.759-.147 1.533-.265 2.082-.91.298-.276.628-.492 1.035-.566.432.113.737.305.509.825-.051 4.469-.1 4.295-4.194 4.282-.999-.003-2.116 1.842-3.245 2.779-1.055.876-3.204 1.829-1.403 4.058.537.664-.103 1.784-.528 2.626z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4D3788"
        d="M110.16 222.337c.213-.003.426-.006.639-.011l1.288.633-.084.667c-.695.197-1.11.678-1.354 1.333l-1.128-.486c-.571-.067-1.487.332-1.204-.89l.003-.009c.625-.393.669-1.652 1.84-1.237z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5A4293"
        d="M104.561 226.639c.688-.858 1.642-.513 2.511-.551-.693.847-1.233 2.38-2.511.551z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5629C6"
        d="M108.317 223.584l1.203.89c-.613.323-1.228.644-1.841.966l-.011-.661.007-1.229c.214.012.428.024.642.034z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F8D9C5"
        d="M243.08 106.258c-2.653-.14-4.145-1.202-3.784-4.194.232-1.919.066-3.887.078-5.833 1.716.255 1.207 1.833 1.688 2.821.533 2.021-.49 4.592 2.088 5.892l.021-.023-.091 1.337z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#723FD0"
        d="M254.354 136.134l-1.212-.554-.001-1.909c1.589.237 1.09 1.503 1.213 2.463z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C6D2F6"
        d="M154.426 426.996l.031 19.963c-.167.234-.39.303-.663.229l-20.521-.264c-.379-.385-.374-.775-.007-1.164 5.776-.002 11.553-.072 17.328.029 2.003.035 2.734-.594 2.679-2.641-.121-4.535-.04-9.078-.04-13.615-.478-.471-.561-1.031-.375-1.65.19-.455.608-.639 1.007-.842.188-.002.375-.018.561-.045z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BED9EF"
        d="M135.126 417.68c.478 2.186 1.675 3.969 3.12 5.615.848.418 1.339 1.336 2.285 1.617 1.009.395 2.349.455 2.126 2.098-2.967.424-4.534-.697-6.286-3.43-2.981-4.646-3.322-9.439-3.086-14.533.132-2.848 2.965-6.717 4.959-6.992l.177.389c-.158.551-.456 1.031-.799 1.484l-.001.002c-2.839 4.218-4.499 8.652-2.495 13.75z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8F6FD"
        d="M142.657 427.01c-.493-1.094-1.625-1.326-2.524-1.873-.186-.139-.247-.275-.185-.41.062-.137.124-.205.187-.205 3.856.025 7.714-.184 11.472 1.145.922.328 1.577.801 2.259 1.375l-.63.629c-3.492 2.381-6.733.785-9.985-.631a5.907 5.907 0 00-.594-.03z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C3D9ED"
        d="M153.232 397.066l-.011 1.297c-4.964-.215-9.929-.439-13.737 3.668-.387.393-.791.414-1.209.055l-.031-.031c1.373-3.887 4.176-5.33 8.187-5.014 2.253.178 4.533.027 6.801.025z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C1DAF1"
        d="M143.25 427.039c3.306.564 6.585 1.564 9.985.629l-.002 1.865c-3.109-.057-6.29.447-9.169-1.314-.503-.307-.731-.656-.814-1.18z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BCD5EC"
        d="M133.266 445.76l.007 1.164-5.646.01 1.234-4.91c1.199 1.56 1.32 4.394 4.405 3.736z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EBF3FD"
        d="M99.556 372.105c-1.85.457-2.735 2.824-4.974 2.506-2.552.092-4.667-1.326-6.972-2.068-1.126-.361-1.298-1.531-1.351-2.602a60.694 60.694 0 010-5.611c.066-1.49.887-2.242 2.141-3.092 2.68-1.816 5.32-3.086 8.61-2.096 5.142 3.016 6.263 8.737 2.546 12.963z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E3F5FC"
        d="M97.046 359.629c-1.525.012-3.053.08-4.575.016-.894-.037-1.29.205-1.411 1.139-.056.426-.59 1.145-.881 1.131-4.206-.186-2.958 2.887-3.09 5.104-.062 1.025.031 2.063-.018 3.088-.059 1.221.347 1.889 1.668 2.082 2.13.313 4.071 1.189 5.843 2.424-3.636 1.664-6.2-.432-8.774-2.496-2.088-1.943-2.93-6.467-1.691-9.082 1.931-4.07 5.479-6.115 9.697-5.451 1.304.205 3.02.008 3.232 2.045z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BED8F0"
        d="M97.046 359.629c-4.008-3.104-6.528-1.684-9.82.352-2.942 1.82-3.878 5.531-2.72 9.018.354 1.064.864 2.08 1.302 3.117-.863-.121-1.875.277-2.39-.902-1.507-3.461.272-11.209 3.609-13.221 2.995-1.807 6.599-1.283 9.813-.334 3.448 1.018 5.152 3.736 5.213 7.375.026 1.551-.098 3.111.029 4.65.161 1.953-.69 2.654-2.526 2.422.418-1.361.953-2.701 1.231-4.094.731-3.643-.806-6.344-3.741-8.383z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B9D6EE"
        d="M113.302 367.764l-.01-.65c1.533-1.326 2.836-2.766 2.504-5.021 3.189.039 1.693 2.754 2.096 4.15.367 1.273-1.385 1.363-2.462 1.48-.702.078-1.418.033-2.128.041z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B8D8F3"
        d="M70.87 359.605c-.369-1.256-1.744-2.17-1.257-3.715l1.239-.008c-.584 2.189 2.478 1.955 2.49 3.748l-2.472-.025z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B8D7F7"
        d="M128.272 322.18v7.486c-1.794-1.684-1.794-5.809 0-7.486zM128.271 329.666c1.667.203 1.128 1.514 1.253 2.492-1.681-.195-1.133-1.51-1.253-2.492z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C3D5E2"
        d="M138.287 340.916c.855 2.971-.804 3.371-3.146 3.072-.075-2.174 1.901-2.25 3.146-3.072z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FCDCB3"
        d="M266.823 72.56c1.891-.326 4.128.801 5.59-1.332.451 1.491 1.006 2.932 2.006 4.159.385.715.529 1.583 1.302 2.053.229.738-.063 1.36-.429 1.968-.545.611-.952 1.324-1.433 1.986-.817.613-1.772.982-2.64 1.518a4.011 4.011 0 01-.915.29c-1.685.221-3.374.18-5.066.138-1.491-.067-2.788-.57-2.859-2.237-.097-2.307-.91-4.805 1.22-6.73.939-.847 2.051-1.385 3.224-1.813z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#231B59"
        d="M283.06 72.529c-.6-.421-1.208-1.423-1.307.407-.095 1.746 1.86 2.79 1.3 4.581-.294.282-.527.598-.581 1.017.087-.4.289-.734.584-1.014 1.484-.384 2.312 1.171 3.645 1.234.228.218.31.481.249.791-1.551 1.36-2.252 3.469-4.055 4.613-1.17.449-2.402.599-3.636.751-.679-.035-1.242-.27-1.554-.922a2.162 2.162 0 01-.013-1.354 19.688 19.688 0 001.672-6.996 1.48 1.48 0 00-.572-.337c-.43-.08-.901.03-1.293-.25-.54-.385-1.553-.583-.333-1.461 1.009-.726 1.976.014 3.082-.115-.804-3.326 2.188-5.754 1.956-9.034-.088-1.251.408-2.434-1.03-3.155-.346-.698.149-.966.634-1.24 2.169.612 1.12 2.393 1.198 3.643.185 2.938-.579 5.893.051 8.84l.003.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DCD1CF"
        d="M277.5 75.052l1.043-.565c.959.688.922 1.671.799 2.681-.553 1.51-1.058 3.06-2.761 3.719-.297.124-.607.18-.928.177a1.532 1.532 0 01-.852-.36c-.242-.447-.236-.882.076-1.299l.514-1.993-.057-.261.202-.173c1.362.079 1.552-1.037 1.964-1.926z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7E305E"
        d="M274.231 54.413l1.34-.596 1.85.004c1.087.579 1.892 1.482 2.741 2.343.863.876.973 1.72.016 2.589-.265.188-.528.176-.792-.004l-1.284-1.189c-1.222-.666-2.468-1.287-3.697-1.939l-.174-1.208z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1E296D"
        d="M279.386 58.75a2.92 2.92 0 01.512-.012c.246-.22.47-.212.671.06-.309 1.131.975.686 1.24 1.25-.211.414-.422.828-.634 1.24-.206 0-.411.001-.617.004-.827.667-1.658.667-2.494.017.072-1.045-.355-2.346 1.322-2.559z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5D1E48"
        d="M274.405 55.621c1.49.155 2.861.535 3.697 1.939-1.72.284-2.807-.641-3.697-1.939z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#182D6B"
        d="M276.501 62.025c-.212.438-.603.517-1.015.458-.384-.053-.952-.093-.758-.657.083-.243.626-.426.974-.454.374-.03.85.055.799.653z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4A1660"
        d="M278.065 61.308l2.494-.017c-.062.671-.319 1.158-1.083 1.206-.858.055-1.343-.315-1.411-1.189z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F2DDE8"
        d="M275.536 76.978a2.582 2.582 0 01-.145.435c-1.441-.14-.981-1.191-.972-2.024.709.292 1.069.831 1.117 1.589z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#211D57"
        d="M286.787 55.688c1.465 3.382 2.144 6.952 2.51 10.595 0 .206.006.412-.003.617-.066 1.501.338 3.161-1.259 4.176-.392.25-.947.006-1.026-.377-.356-1.728-2.397-3.218-1.176-5.107 1.077-1.665 1.256-2.341-.841-3.38-1.956-.97-.624-5.428 1.795-6.524z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#302443"
        d="M280.57 58.797l-.671-.06c1.477-2.8-2.027-3.089-2.477-4.917 2.152-.396 2.562 2.271 4.366 2.485.345.406.394.817.016 1.233l-1.234 1.259z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#211D64"
        d="M281.803 57.54l-.016-1.233c.188-.322.326-.863.575-.921.465-.108.615.38.644.791.06.849-.34 1.316-1.203 1.363z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#312643"
        d="M291.22 68.783l-.636 1.356-.13-5.021.156-.128c1.961.982 1.41 2.367.61 3.793z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#261D63"
        d="M283.059 72.53c.905.023 1.867-.081 2.532 1.775-1.222-.657-2.381-.134-2.53-1.775h-.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8E2D3"
        d="M240.653 85.011c-1.698 3.168-1.212 6.619-1.292 9.996-1.554-.274-1.22-1.313-1.005-2.365.183-.896.341-1.814.351-2.724.022-2.071-1.161-1.81-2.477-1.184l.002-1.239c1.406-1.312 2.489-3.004 4.397-3.722l.024 1.238z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5DBBB"
        d="M256.846 75.024l1.237-.01c1.016.954.856 2.229.817 3.406-.063 1.919.409 3.584 1.792 4.953.386.602.478 1.235.207 1.907l-.333.378c-2.821-1.621-4.015-4.062-3.751-7.288.091-1.11.026-2.231.031-3.346z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D53240"
        d="M246.986 81.791l-2.824-1.699c.659-.869 1.672-1.014 2.516-.72 1.687.587 3.421.304 5.113.574l.102.751c-1.269 2.007-3.126 1.377-4.907 1.094z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7050C0"
        d="M257.491 88.786c.203-.036.405-.076.606-.121.98.403 1.583-.692 2.479-.625l.326.382c.253.693.184 1.322-.376 1.852-.757.483-1.604.521-2.465.5-.695-.057-1.359-.192-1.832-.775l1.262-1.213z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5DBBB"
        d="M260.576 88.041c.104-.796.576-1.592-.009-2.385l.042-.054c1.366-1.619 1.893-.053 2.637.694-.013 1.012-.711 1.56-1.423 2.101-.437.172-.863.157-1.275-.079l.028-.277z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FBDCB6"
        d="M260.595 83.763c-2.165-.608-2.633-2.192-2.521-4.202.084-1.511.013-3.031.01-4.546.181-2.453 1.779-2.709 3.735-2.408 1.299 3.613.598 7.286.331 10.947-.454.551-.973.61-1.555.209z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5DBBB"
        d="M261.835 83.758l-.017-11.152 5.005-.046c-2.027 2.145-4.62 3.833-3.851 7.609.371 1.822.832 2.553 2.61 2.344.741 1.122.837 2.277-.522 2.846-1.507.631-2.568-.216-3.225-1.601z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F1D4DC"
        d="M248.099 72.407a169.5 169.5 0 01-1.008.025c-2.085-.807-1.673.891-1.927 1.923a.608.608 0 01-.73.104l-.195-.165c.208-1.094-1.099-2.627.141-3.178 1.19-.529 2.814-.121 3.719 1.291z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ED2336"
        d="M244.434 74.459l.537-.338c.474.354.363-.328.624-.352 1.851-.316 3.466.296 4.992 1.263 1.625 1.338 1.258 3.166 1.204 4.915-1.38.711-2.569 1.95-4.336.356-.64-.578-2.168-.169-3.292-.211-1.458.125-1.939-.586-1.668-1.943l.725-1.026c.798-.708 1.177-1.608 1.214-2.664z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6E3D4D"
        d="M245.594 73.769l-.302.808c-.107-.151-.216-.3-.323-.454.173-1.236-.258-3.226 2.121-1.69-.816.089-1.576.242-1.496 1.336z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF8F8"
        d="M612.577 386.51c1.553 1.965 3.875 3.238 5.027 5.566 2.434 2.975 2.391 6.24 1.117 9.643-.668 2.904-1.764 5.492-4.883 6.58-.4.012-.801.02-1.197.029-4.244 1.125-8.539 1.09-12.855.586a4.445 4.445 0 01-.922-.59c-.217-.195-.432-.391-.65-.584-1.574.049-2.16-1-2.549-2.279-.6-4.316.396-8.717-.66-13.014a2.314 2.314 0 01-.129-1.018c2.943-7.029 12.996-8.025 17.701-4.919z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BDD9EE"
        d="M612.577 386.51c-3.686-.719-7.217-1.975-11.137-.283-2.758 1.188-4.123 3.611-6.311 5.232-1.129-1.453-1.127-2.91-.006-4.367 3.223-1.891 6.707-2.654 10.426-2.514 1.654.064 3.322.063 4.98-.002 1.405-.056 2.212.389 2.048 1.934z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C6CFFD"
        d="M595.129 423.914l.006 2.432c-.408-.18-.82-.357-1.23-.535-.139-.141-.275-.281-.414-.42-.91-2.299-.498-4.703-.455-7.047.092-5.045-.482-10.107.332-15.135 1.141-1.357 1.572-.15 2.139.588.125.361.193.736.211 1.119.104 2.4.529 4.828-.592 7.127-.001 3.957-.001 7.916.003 11.871z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E3F7FC"
        d="M599.465 408.32c4.389.344 8.781-.619 13.172.008-2.145 2.699-5.189 2.443-8.145 2.469-1.617-.943-4.533.75-5.027-2.477z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BFD8EE"
        d="M618.247 402.07c1.354-3.432.201-6.705-.643-9.994 1.811-.221 2.648.465 2.508 2.4-.129 1.832-.031 3.684-.025 5.525 0 .943.053 1.906-1.242 2.07-.2.228-.399.218-.598-.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BED7F1"
        d="M632.579 421.387c-.365-.172-.77-.291-1.082-.529-2.316-1.768-4.465-1.82-6.414.557-.213-1.912.17-3.611 2.213-4.229 1.515-.456 4.662 2.181 5.283 4.201z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BED9F0"
        d="M618.247 402.07c.199-.002.398-.002.598.002-.002.725.006 1.451-.006 2.178-.066 3.461-.773 4.033-5 4.049 1.841-1.813 3.533-3.731 4.408-6.229z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C0D7F2"
        d="M623.879 422.061c-.277 1.982.123 3.795 1.156 5.527 1.252 2.102.711 3.461-1.824 3.805.693-1.568.807-2.936-.111-4.654-.723-1.362-1.693-3.507.779-4.678z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C7D0FE"
        d="M595.124 387.092c.002 1.455.006 2.912.006 4.367.004.209.004.416 0 .623l-.424.264c-.537.08-.973-.07-1.256-.561-.746-2.049-.172-4.217-.549-6.301a1.57 1.57 0 01.309-.91c.15-.604.193-1.291 1.041-1.361.744 1.191.699 2.558.873 3.879z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BCDBEB"
        d="M595.125 412.043l-.004-7.486c1.188-.391.688.969 1.26 1.217.367.883 1.047 1.475 1.832 1.963-1.141.646-2.164 1.322-1.885 2.934.141.806-.361 1.298-1.203 1.372zM599.465 408.32c1.236 1.717 3.383 1.582 5.027 2.477-.713.021-1.547-.193-2.115.104-3.045 1.602-3.418-.258-3.514-2.576.202-.001.401-.001.602-.005z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D2BFFD"
        d="M593.887 446.945l-.281.076-.289-.031c-.369-.375-.744-.789-.758-1.32-.156-6.504-.607-13.012.248-19.504.223-.408.559-.551 1.006-.428l.09.072c-.004 7.045-.008 14.09-.016 21.135z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B7DAF2"
        d="M314.417 467.529c.511 1.854 2.758 1.627 3.644 3.033-1.08 2.596-3.261 1.58-4.67.918-1.326-.625-2.532-.75-3.846-.752-12.158-.016-24.316-.008-36.474-.008-.221-1.545-1.426-1.238-2.412-1.238-25.022-.012-50.043-.012-75.065-.004-.986 0-2.192-.303-2.411 1.242h-59.917l.002-2.496c1.625-1.369 3.581-.861 5.401-.863 56.267-.027 112.533-.02 168.799-.033 1.861 0 3.75.25 5.57-.393.631-.206 1.198-.255 1.379.594z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B9C2F7"
        d="M313.638 467.008c-.542 2.031-2.214 1.166-3.376 1.172-17.242.057-34.485.039-51.728.039-41.756.002-83.512.006-125.269.006-2.089-.395.358-.838-.013-1.25 1.091-1.102 2.507-.869 3.829-.869 57.582-.02 115.163-.021 172.744 0 1.322-.001 2.742-.237 3.813.902z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#34189B"
        d="M313.638 467.008c-.931-.051-1.861-.145-2.792-.145-58.37-.008-116.739-.012-175.108-.006-.829 0-1.656.076-2.484.117-.754-.025-1.508-.053-2.263-.08-.336-.389-.278-.707.171-.957 1.478-.691 3.058-.455 4.598-.457 17.63-.018 35.261-.008 52.891-.014 1.553 0 3.116.096 4.62-.439 1.234-.221 2.482-.18 3.726-.18 24.071-.006 48.143-.006 72.214 0 1.244 0 2.491-.035 3.727.17 1.497.527 3.054.451 4.603.451 10.753.004 21.506-.012 32.259.012 1.523.006 3.135-.287 4.453.857.539.33.703.713.165 1.191-.262-.173-.521-.346-.78-.52z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4610B3"
        d="M122.056 465.805l-4.361-1.316c-.214-.818-1.787-.723-1.345-1.992 1.533-1.881 3.486-1.396 5.433-.977.753.354 1.337.973 2.098 1.316 1.556.994 3.307.732 5.01.809 1.485.066 3.057-.313 4.375.754.341.484.364.969.005 1.457-2.415.412-4.869.404-7.297.678-1.48.696-2.606-.516-3.918-.729z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B2DAED"
        d="M103.752 467.18h9.098l.021.625h-9.106l-.013-.625z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B6DAE9"
        d="M125.769 466.984c-.006.379-.003 1.092-.018 1.092-1.944.051-3.888.047-5.834-.268.994-1.197 2.246-.676 3.365-.842.833-.622 1.66-.431 2.487.018z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B9C2F7"
        d="M125.769 466.984l-2.487-.018-1.226-1.162 3.755.305c1.598.074 3.239-.475 4.786.334.125.154.257.307.394.451-1.741.032-3.482.061-5.222.09z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3A2176"
        d="M116.44 463.174c.55.313 2.194-.418 1.254 1.314l-1.285.061c-.618-.338-1.235-.676-1.854-1.012.464-.982 1.134-.885 1.885-.363z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C2D0DA"
        d="M113.293 465.123c1.038-.867 2.082-.135 3.124-.012-1.037 1.067-2.08.815-3.124.012z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4612AB"
        d="M116.44 463.174c-.627.121-1.255.24-1.883.363-1.358-.24-2.632-.684-3.755-1.506-.654-.969-1.511-1.783-2.155-2.77.309-2.26 2.258-2.199 3.816-2.699.608.025 1.104.266 1.484.746 2.622 1.959 5.564 1.258 8.331.729 1.848-.355 3.656-.684 5.531-.684 56.869-.002 113.738-.002 170.607.004.728 0 1.457-.018 2.182.047 1.39.123 2.883.279 2.849 2.137-.033 1.83-1.57 1.939-2.922 2.123-.721.1-1.453.082-2.18.08-55.205-.068-110.41.148-165.615-.09-2.985-.014-6.027-.555-8.96.512-.61.234-1.195.225-1.737-.182-1.866.391-4.109-.992-5.593 1.19z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4B288B"
        d="M108.92 459.471c2-.154 1.919 1.219 1.881 2.561-1.418-.381-2.619-1.156-3.745-2.068l.023-.529c.624-.458 1.238-.455 1.841.036z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5015C8"
        d="M113.289 457c-.416 0-.831-.002-1.245-.006-1.671.396-3.216 1.303-5.001 1.24-5.386-1.813-3.426-6.281-3.604-9.977a.91.91 0 01.836-.094c.996.242 2.144-.18 2.997.688.335.539.353 1.111.175 1.703-.418.838-.915 1.652-.856 2.639 1.918.898 4.156.619 6.026 1.666.493.014.981.012 1.475-.025 3.141-.047 6.276-.055 9.412-.006 1.558-.16 3.118-.072 4.675-.072 56.223-.008 112.446 0 168.669-.018 3.04 0 6.192.609 8.502-2.49 1.079-1.449 2.369.359 3.513.799.716-.803.005-1.385-.139-2.014-.579-2.063-2.334-1.77-3.81-1.789-5.89-.078-11.781-.006-17.671-.047-1.428-.008-2.92.17-4.157-.848.971-2.805 3.379-1.066 5.07-1.607 6.903.016 13.809-.012 20.713.014 1.327.006 2.691-.164 3.946.494 1.154.889.967 2.186 1.042 3.404a6.374 6.374 0 01-.282 1.834c-1.047 5.189-1.481 5.592-7.098 5.508-59.591-.893-119.185-.125-178.776-.408-3.436-.018-6.828.662-10.267.422-1.447-.104-2.941.054-4.145-1.01z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4610B3"
        d="M107.042 458.234c1.543-.916 3.17-1.49 5.001-1.24-.626 1.352-2.894.627-3.123 2.477-.613-.012-1.227-.023-1.84-.037a452.09 452.09 0 00-.038-1.2z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#401392"
        d="M103.969 448.32a9.522 9.522 0 01-.532-.063.98.98 0 01.052-.609l9.803.061c.157.416.041.73-.347.949-3.039 1.145-5.986-.146-8.976-.338z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#251A50"
        d="M224.857 71.367c-2.475-2.058-.138-3.776.507-5.517.414-1.118 1.328-2.321 2.78-.842-.292.398-.925.975-.825 1.17 1.491 2.866-1.057 3.749-2.462 5.189z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4610B3"
        d="M451.557 465.762c-1.641-.242-1.121-1.545-1.242-2.533.574-1.666-.246-3.328-.014-4.992.014-.414.027-.828.043-1.242.717-1.064.852-2.836 2.854-2.35.387.355.637.838 1.107 1.113 1.623.6 3.303.334 4.951.334 55.977.016 111.953.006 167.93.039 1.811 0 3.77-.543 5.381.859-.402 1.91-1.947 1.213-3.041 1.217-11.547.049-23.094.031-34.639.031-46.08 0-92.158-.01-138.236.043-1.258.002-3.557-.916-3.59 1.102-.043 2.447 2.418 1.289 3.689 1.291 54.4.068 108.801.092 163.203-.006 4.145-.006 8.193-1.67 12.463-1.234 1.545.158 2.82.35 3.596 1.922-1.666 1.791-4.703-.939-5.943 1.873-1.563.967-3.213 1.568-5.092 1.252-1.803-.305-2.889 1.117-4.279 1.801-.42.496-.936.361-1.453.209-2.244-.807-4.613-.209-6.893-.617-5.447-.068-10.881-.436-16.322-.576-1.23-.031-3.045.656-3.406-1.535 2.152-.473 4.334-.064 6.496-.297-15.518 1.199-31.061.436-46.594.656-24.996-.023-49.99-.004-74.984-.002-1.543 0-3.131-.195-4.518.76-3.535.922-7.139.289-10.707.469-3.164.16-6.355-.33-9.498.371-.422.012-.842.028-1.262.042z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5417CB"
        d="M632.567 456.99c-58.693-.002-117.387.002-176.082-.051-1.23 0-3.037.992-3.635-1.207 1.717-1.396 3.768-.965 5.699-.965 52.357-.023 104.717-.018 157.078-.018 5.713 0 11.428.01 17.141-.008 1.211-.004 2.787.611 2.182-1.926-.334-1.402 1.986-2.092 3.947-1.053 1.645.873 3.129 2.043 4.885 2.732l.045 1.254c-.416.414-.832.83-1.248 1.242-3.338.002-6.674 0-10.012 0z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BBC4F8"
        d="M619.454 466.32c.416-.014.83-.025 1.244-.039 1.885-.176 3.77-.348 5.654-.523l2.234 1.143h-11.219c.129-.162.262-.314.4-.465.525-.6 1.099-.452 1.687-.116z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BBD7F1"
        d="M661.278 354.631c-.41-.047-.799-.678-1.238-.053-.936.426-1.4-.314-1.971-.791-1.512-1.248-3.279-1.438-5.139-1.217-.994.115-2.008.428-2.863-.408l-.029-.033c.854-2.744 2.361-2.963 5.141-2.744 3.648.291 4.544 2.97 6.099 5.246z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4BA2D9"
        d="M645.047 262.884c1.068.508 1.904 1.13 1.254 2.499-1.314-.383-2.238-.961-1.254-2.499z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FCDCB4"
        d="M290.544 55.677c1.526-.378 2.045-1.827 2.945-2.869 1.243.306.43 2.377 2.043 2.247.051 2.898 1.984 5.031 3.174 7.432 1.205 2.43 2.198 4.785 1.827 7.54-.15.917.426 2.272-1.145 2.39-1.294.097-1.982-.959-2.445-1.964-.283-.612-.115-1.416-.278-2.104-.188-.793-.889-1.173-1.61-1.152-.845.025-.729.825-.757 1.407-.045.92.082 1.92-1.249 2.046l-.022.008c-1.294-4.644-2.848-9.23-3.052-14.111.101-.35.291-.639.569-.87z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7035E3"
        d="M286.696 79.433c.92.591 1.389 1.763 2.58 2.007.254.55.646.938 1.26 1.063.071.154.107.315.107.484-.723.406-.23.927-.133 1.411-1.624.813-1.099-.982-1.7-1.425-.746-.551-1.057-1.446-2.475-1.015-1.475.449-.596 1.302-.743 1.913-.227.942.27 2.186-1.291 2.39-2.515.28-5.201-.463-7.477 1.248-1.008-1.815-.774-2.926 1.596-2.825 1.539-.127 3.195.281 4.51-.944 1.064-1.603 2.143-3.193 3.766-4.307z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4A0AC1"
        d="M592.604 447.053c.01.191.016.385.02.574a22.31 22.31 0 00-.453.416c-1.771.852-3.67.576-5.521.576-41.945.018-83.895.014-125.842.014-1.143 0-2.289.064-3.426-.006-2.443-.152-4.275.564-4.928 3.164-1.426.629-1.436-.58-1.588-1.34-.236-1.182-.223-2.387.475-3.473.467-.459 1.053-.666 1.68-.785 1.645-.322 3.311-.195 4.969-.195 41.742-.01 83.49-.006 125.234-.01 5.848 0 5.885-.039 5.891-5.898.008-11.008-.012-22.014.014-33.02.004-1.641-.246-3.348.779-4.836 1.264-.527 1.35.541 1.537 1.244.299 1.109.178 2.273.186 3.414.055 12.779-.102 25.557.084 38.328.121.51.396.943.691 1.367.067.155.132.309.198.466z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#604FA3"
        d="M593.34 425.793c-.006 7.064-.016 14.131-.023 21.197-.238.02-.475.041-.713.059l.002-.07c-1.152-1.318-.848-2.938-.85-4.459-.021-16.986-.008-33.971-.021-50.955-.002-1.332.223-2.701-.387-3.975-.748-1.537.273-2.254 1.371-2.938.164-.029.326-.055.49-.078.057.223.113.443.172.666 1.248 13.518-.115 27.037-.041 40.553z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3F13A7"
        d="M642.52 447.676c.008.209.014.416.02.623-1.012.988-2.307.816-3.533.82-14.326.021-28.652.021-42.979.004-1.037-.002-2.086.047-3.049-.461-.418-.244-.535-.59-.354-1.037l-.002.002c16.633.018 33.266.033 49.897.049z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5315D1"
        d="M643.782 454.496c-1.908 1.209-3.15-.176-4.301-1.27-1.189-1.135-2.379-1.561-3.973-.936-.051 1.559 1.684 1.902 2.43 3.441H452.85c-.029-.426-.057-.85-.088-1.275-.316-.617-.285-1.166.328-1.594 1.68-.793 3.475-.486 5.219-.486 38.021-.02 76.039.074 114.059-.055 18.275-.059 36.541.703 51.398.295-6.822-.006-17.063.033-27.303-.018-3.094-.018-3.352-.533-1.859-3.111 1.113-.838 2.377-.592 3.613-.502 1.611 1.061.654 1.25-.379 1.459 1.045-.08 2.279.109 2.738-1.393.85-.211 1.674-.174 2.473.191.918.621 1.963.619 3.002.619 11.104.014 22.207.016 33.311 0 .936-.002 1.871-.035 2.74-.449a1.356 1.356 0 011.098.064c1.472 1.528-.545 3.456.582 5.02z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5D21C1"
        d="M602.61 449.502c-.832 0-1.662 0-2.492.002-.42.381-.84.381-1.258 0-1.246 0-2.49 0-3.738-.002-1.158.234-2.748 1.316-2.49-1.258 16.635.018 33.271.035 49.908.055l.605.592c.021.195.039.391.055.588l-.643.025c-.885.73-1.955.609-2.984.611-11.326.01-22.654.01-33.984 0-1.028-.002-2.096.119-2.979-.613z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EBD5B4"
        d="M290.544 55.677c0 .207-.001.412-.003.619-.7.362-.951-.151-1.221-.626l-.669-1.213c.511-.659 1.558-.216 1.807-1.26.961 1.056-.131 1.731.086 2.48z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EDDBCD"
        d="M289.32 55.67l1.221.626c.047 3.603 1.115 6.996 2.214 10.368.436 1.338.192 2.664.273 3.993-.819-.416-.464-1.966-1.809-1.874-.045-1.29.28-2.639-.61-3.792l-1.863-8.738.574-.583z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5AA4CF"
        d="M645.053 259.763c-.494-1.889 1.684-3.096 1.266-4.966 1.221-.97 2.576-.683 3.932-.425.469.278.707.682.666 1.233a1.405 1.405 0 01-.557.752 3.55 3.55 0 01-.85.321c-1.164.124-1.889.647-1.809 1.946.072 1.119.367 2.023 1.752 1.96.289-.034.57-.028.855 0 .729.128 1.404.419 2.107.62 1.26.498 2.842-.129 3.883 1.11-1.195 2.374-3.363.687-5.006 1.193l-.002-.004c-.613-.858-1.867-.409-2.5-1.224-2.397.872-2.141-2.197-3.737-2.516z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C9EBF3"
        d="M656.299 262.315c-1.463-.343-3.078.413-4.451-.602.086-.113.174-.227.256-.342.535-.364 1.158-.415 1.773-.501 2.033-.282 3.025-1.262 2.283-3.405-.209-.607-.332-1.207.252-1.701.631-.231 1.205-.149 1.715.3l-.014-.021c.459 1.725.883 3.442-.475 4.993-.171.714-.618 1.138-1.339 1.279z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#61AEDA"
        d="M657.639 261.036c.574-1.624.613-3.301.475-4.993.881 1.765 1.566 3.508-.475 4.993z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#61AEDA"
        d="M658.127 256.064h-1.861c-.627.454-1.264.516-1.908.045-.154-.355-.098-.672.172-.95 1.039-.654 2.006-.363 2.953.215.213.23.43.46.644.69z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5B92A5"
        d="M657.483 255.374l-2.787.042c-.336-.056-.48-.252-.43-.589.512-.701 1.238-.758 2.014-.659.402.209.805.416 1.209.623.017.195.015.39-.006.583z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#43A3E5"
        d="M648.792 262.281c.986.094 2.281-.441 2.5 1.224-.981-.108-2.274.423-2.5-1.224z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#371E98"
        d="M153.794 447.188l.663-.229-.004.275c.433.504.422 1.033.091 1.582-.896.783-1.961.488-2.978.453-4.873-.162-9.747-.02-14.621-.084-1.137-.016-2.291.027-3.346-.529-.387-.225-.5-.545-.341-.963 5.75-.027 11.5-.037 17.25-.098 1.099-.011 2.27.341 3.286-.407z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3C12A5"
        d="M133.259 447.693c.007.174.011.35.011.523-1.526 1.377-3.391.908-5.162.955-3.792-.102-7.585.006-11.376-.059-1.208-.021-2.497.164-3.447-.893l.007-.514 19.967-.012z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E9F4FC"
        d="M650.067 352.162c2.367-.109 4.715-1.129 7.121-.033.674.305 1.281.549 1.582 1.26-.678 2.783-.523 5.738-1.828 8.4-.502 1.021-.102 2.018.635 2.855-1.395 1.578-3.271 1.158-5.033 1.217-6.874-2.808-7.172-8.5-2.477-13.699z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6FBFC"
        d="M657.577 364.645c-1.125.131-1.82-.305-1.682-1.5.371-3.205 2.023-6.137 2.055-9.43 0-.111.533-.219.82-.326l1.27 1.189c2.363 3.955 1.33 8.182-2.463 10.067z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F80110"
        d="M285.516 146.128c-1.849 1.16-1.979 3.185-2.517 5.004-.903.825-1.839.787-2.714.004-.84-.752-.528-1.666-.19-2.533a16.67 16.67 0 011.064-2.188c.147-.27.323-.524.507-.77 1.833-1.95 1.43-4.753 2.638-6.942.011-.21.022-.421.035-.631 1.226 1.477 2.576 2.832 1.403 5.082-.423.81-.17 1.973-.226 2.974z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E90C1C"
        d="M284.304 138.704c.016 2.772.298 5.634-2.5 7.463-.602-2.184.342-4.241.519-6.362.127-.438.406-.788.67-1.147l.088.038 1.223.008z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9BD72"
        d="M263.031 92.579l-.616-.662c-.338-4.322-.258-4.499 3.714-5.254 1.107-.211 1.765-.922 2.545-1.545.23-.226.491-.408.776-.557 1.325-.129 2.391-1.873 3.941-.648.601 1.048.505 2.184.429 3.318-.123 1.182-.852 1.92-1.817 2.48-.612.884-1.876 1.433-1.464 2.856-.475.512-1.128.548-1.746.694-1.952.014-3.961.539-5.762-.682z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7136E6"
        d="M272.992 97.605c-.092.958-.768 1.082-1.543 1.128-2.306.136-4.718-.504-6.828 1.111-.436.333-1.242.041-1.41-.743-.176-.822.063-1.466 1.003-1.554 2.615-.247 5.33.424 7.812-1.12.587-.365.989.477.966 1.178z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F4C186"
        d="M269.32 85.004c-.479 1.525-1.416 2.638-3.105 2.463-2.439-.254-3.491.615-3.179 3.113.052.414-.401.89-.621 1.336-.407-.25-.815-.501-1.222-.753-.551-1.115-.591-2.125.594-2.882-.075-1.01.851-1.36 1.326-2.007 2.036-.586 3.867-2.171 6.207-1.27z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#8B4BB3"
        d="M269.512 92.506l1.158-.563c.145-.212.338-.295.591-.23.326.189.541.455.57.844-2.002 2.583-4.788 2.643-7.662 2.347-1.152-.119-1.084-1.041-1.076-1.879 2.138-.203 4.354.579 6.419-.519z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7436DC"
        d="M259.335 112.472v10.039c-1.834-2.622-1.612-8.494.002-10.037l-.002-.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7435E3"
        d="M259.337 112.474c.244-1.336-.596-2.286-1.092-3.393-.354-.789-.425-1.87.396-2.571.244-.208.816-.209 1.161-.087 1.047.371.893 1.39.74 2.107-.284 1.336 1.091 3.23-1.207 3.942l.002.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#8648AA"
        d="M279.324 84.983c-1.912-.226-2.786.576-2.499 2.525l-1.284 2.461c-.514.518-1.092.585-1.729.251-.418-2.231 1.421-3.98 1.315-6.149.146-.301.368-.528.662-.687.836-.31 1.604-.263 2.239.442.218.508.648.638 1.146.648.443.056.493.225.15.509z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EEB5D1"
        d="M269.512 92.506c-2.004 1.843-4.209 1.2-6.418.519a4.738 4.738 0 00-.063-.446l6.481-.073z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7536D7"
        d="M256.23 89.999l1.971.095c2.698.937.019 1.608-.12 2.405l-2.479-1.235-.572-.624c.136-.708.72-.578 1.2-.641z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7F30F8"
        d="M258.082 92.499c-.147-.811 1.465-1.537.118-2.406l2.387-.109c.35.384.354.781.043 1.189-.058 1.962-1.871.553-2.548 1.326z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7738D2"
        d="M273.612 89.9l1.929.07c-.113 1.681-1.439 1.159-2.391 1.315a.901.901 0 01-.425-.59 1.325 1.325 0 01.189-.721.66.66 0 01.698-.074z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#85449A"
        d="M273.025 90.553l.123.732c-.11.765-.536 1.203-1.317 1.271l-.658-.587c.239-.968.732-1.601 1.852-1.416z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6E3979"
        d="M260.63 91.172l-.043-1.189-.038-1.665 1.239-.038c-.764.845-.55 1.891-.593 2.883l-.282.042-.283-.033z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FC3849"
        d="M282.988 139.896l-1.185 6.271-.002.005c-1.256 2.077-2.422 4.23-4.651 5.483-1.253.852-2.293 2.09-3.933 2.225-.245.028-.268-.564-.637-.256-.32.267.131-.176.137.255.014.24-.032.452-.145.659-.478.657-1.167 1.047-1.796 1.514-1.449 1.093-3.118 1.84-4.56 2.945-.642.362-1.341.587-2.024.851-2.524.711-4.61 2.351-7.01 3.309-1.219.487-2.452 1.195-3.87.725-.341-.377-.703-.727-1.238-.812-.378-.174-.368.224-.111.049.273-.186.731.188 1.051.446.523 1.019-.414 1.211-.924 1.649-.396.194-.818.315-1.245.413-1.224.337-2.342.829-2.972 2.029-.042 1.006.531 1.826.821 2.728.228.659.45 1.318.626 1.994.16.683.328 1.362.569 2.024a67.37 67.37 0 001.279 3.727c.516 1.458.844 2.969 1.286 4.449.751 3.322 1.619 6.614 2.488 9.907.245 1.961.789 3.883.796 5.875-.205 2.21-1.525 4.545.725 6.491.368 1.089-.05 1.987-.678 2.838-1.709 1.822-3.013 1.448-3.802-.808-1.172-3.353-2.606-6.665-2.157-10.356 1.524-1.887 1.653-3.971.884-6.234-1.04.015-1.452 1.708-2.698.953-1.104-1.615-1.745-3.475-2.739-5.149-.63-1.344-.401-2.802-.547-4.21-.13-1.248-.928-1.983-1.867-2.641-1.469-1.087-1.75-2.891-2.631-4.335-.282-.712-.36-1.461-.387-2.217.023-.99-.117-1.94-.697-2.784a1.787 1.787 0 01-.057-1.229c.635-.847.659-1.696.001-2.549a1.767 1.767 0 01.058-1.218c.643-1.176 1.326-2.34 1.219-3.762-.016-.646.466-.928.908-1.239 4.126-2.907 8.081-6.031 11.825-9.42 1.257-2.503 3.708-3.811 5.706-5.54 1.864-1.616 3.776-3.173 5.52-4.923l.108-.187c1.511-.432 3.052-.123 4.574-.193.293.073.594.136.887.228.706.219 1.952-.07 1.792 1.094-.135.985-1.282.77-2.07.821-.599.039-1.201.016-1.366.014 2.62.994 5.154-1.764 8.126-1.243 1.01-.084 2.115.272 2.948-.634a14.2 14.2 0 01.545-.064c1.048-.487 2.09-.791 3.12.032z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F43B5C"
        d="M276.863 141.153c-3.605-.093-6.951 2.492-10.815.887 1.439-1.674 3.45-.316 5.055-1.075-.24-.828-1.489-.158-1.798-.976.806-.58 1.638-.453 2.479-.09l.693-.043 3.049.125c.374.473 1.578-.002 1.337 1.172z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B82F82"
        d="M276.863 141.153l-1.337-1.172 3.799-.057c-.204 1.645-1.512 1.08-2.462 1.229zM282.988 139.896l-3.117-.036c.694-1.297 1.917-1.224 3.121-1.203l-.004 1.239z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E10B19"
        d="M264.325 140.026c-.983 3.637-4.729 4.58-6.929 7.048-1.199 1.346-2.85 2.291-4.297 3.416-.159-1.43.739-2.504 1.246-3.711 1.499-1.642 3.785-2.377 5-4.345.061-.111.121-.223.179-.335.427-.468.944-.834 1.418-1.251a5.182 5.182 0 012.01-1.071.652.652 0 01.701.102l.672.147z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C73B99"
        d="M271.784 139.899l-2.479.09-4.873-.149c2.458-.836 4.909-.897 7.352.059z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D43E94"
        d="M263.653 139.878a8.448 8.448 0 01-.565.137c-1.988.53-3.968 1.292-6.018.227-.345-.271-.405-.597-.181-.975 2.24.357 4.602-.624 6.764.611z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8396D"
        d="M256.889 139.266l-.019.638c-.418.358-.844.405-1.28.032-.773-.027-1.21-.414-1.272-1.197l2.458.039c.054.159.091.322.113.488z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#684EA4"
        d="M593.202 262.271l-.27-.002-.268.006c-.906-.766-.895-1.838-.896-2.868-.025-10.389-.064-20.775.016-31.163a4.571 4.571 0 01.27-1.526c.17-.381.451-.649.838-.807.758.297.721.829.422 1.438-.04 11.64-.077 23.28-.112 34.922z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF3FA"
        d="M595.12 228.563c1.455.004 2.91.006 4.365.011-1.023 1.932-2.855 1.007-4.361 1.234l-.004-1.245z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6491BB"
        d="M593.313 227.349l-.09-1.207c.553-.629 1.193-.625 1.885-.261.373.465.414.938.035 1.421l.01.242-1.84-.195z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9E5E8"
        d="M597.647 275.371c1.506-.118 3.148-1.768 4.471.094.938 1.318.607 2.726-.699 3.795-.004-.611-.045-1.228-.004-1.838.035-.566.623-1.298-.168-1.612-.59-.231-1.51-.467-1.973.212-1.652 2.434-1.164-.259-1.627-.651zM594.405 275.955c.756-1.829 1.893-1.688 3.205-.616-1.117-.045-2.19.128-3.205.616z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2F1971"
        d="M587.661 274.811c-.123-2.764-2.1-4.907-2.533-7.566-.955-1.123-1.398-2.646-2.725-3.482-.871-.943-1.809-1.861-1.551-3.331.061-.278.168-.537.314-.781.461-.523.926-1.05 1.604-1.309.785.045 1.229.624 1.742 1.1 1.049 1.208 1.684 2.652 2.307 4.103.334 1.245.689 2.481 1.244 3.651.32 1.258.674 2.51 1.178 3.712.102.453.043.884-.211 1.277l.436 1.262c-.65.454-.582 1.164-.654 1.825-.384-.156-.769-.31-1.151-.461z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3B296F"
        d="M588.879 282.217c-2.506.351-3.172 1.67-2.244 4.53.182.555 1.336 1.157.02 1.579-1.031.331-1.498-.388-1.502-1.38-.012-2.704-.643-5.624 2.5-7.241 1.603.252 1.119 1.527 1.226 2.512z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7139DC"
        d="M592.622 226.124c.016 12.05.027 24.1.043 36.151l-.02 7.902-1.18.231c-.945-.729-.943-1.8-.945-2.826a6419.93 6419.93 0 01-.004-38.759c.002-.828.055-1.658.496-2.4.451-.56.975-.735 1.61-.299z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5012C7"
        d="M591.481 226.027c-.004 14.794-.01 29.588-.016 44.381a5.606 5.606 0 01-.094.573l-1.248-.003c-1.361-1.596-.887-3.551-.908-5.35-.027-2.37.002-4.747.023-7.121-.043-9.276.129-18.552-.09-27.828-.031-1.333-.092-2.685.391-3.976.273-.597.689-.977 1.395-.923.182.083.365.166.547.247z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#631EDD"
        d="M590.104 258.508c.006 4.156.012 8.314.02 12.471-.033.704-.299 1.198-1.096 1.207-.057-.385-.113-.768-.172-1.151-.748-1.134-.137-2.746-1.309-3.732-1.043-1.035-1.27-2.336-1.234-3.727.1-.097.201-.192.299-.291 1.113-.079 1.551-.656 1.523-1.786-.027-1.089-.143-2.251.725-3.162.449-.193.869-.174 1.244.171z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#479FE2"
        d="M546.473 143.635c2.498 2.925 1.457 5.847-.012 8.768-.07.688-.506 1.185-.883 1.714-.436.525-.996.884-1.582 1.211-.488.268-.984.51-1.512.691-.422.135-.85.206-1.291.24-.76.048-1.516.051-2.275-.022-.971-.134-1.875-.425-2.598-1.132a2.006 2.006 0 01-.357-.895c-.023-.493.092-.94.428-1.315.895-.553 1.824-.122 2.734-.073 4.441.236 6.979-2.509 6.254-6.779-.053-.308-.021-.621.023-.933.163-.633.462-1.167 1.071-1.475z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#42A1EB"
        d="M532.754 146.159c.256-3.357 2.463-5.167 5.352-5.97 2.652-.738 5.357-.559 7.102 2.184.342.359.375.764.18 1.203-.529.512-1.074.254-1.619.045-.387-.187-.74-.427-1.094-.668-1.592-.776-3.189-.826-4.793-.042-1.902.432-2.096 2.831-3.891 3.384-.391.77-.105-1.865-.709-.142-.045.129-.328.095-.528.006z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B72C8"
        d="M543.922 154.884l1.299-1.205c1.225-.753 2.457-.893 3.699-.035l.643.027c-1.957 1.714-1.445 5.575-5.07 5.846-1.262-.07-1.127 2.111-2.637 1.644-.504-.444-.807-1.002-1-1.635-.289-1.394-.432-2.768.584-3.968l1.248-.075c1.156 1.34.781-.486 1.234-.599z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#356FD0"
        d="M527.653 153.708c1.666-.366 3.514.622 5.055-.67.219-.22.438-.439.652-.659.533-.115.809.193 1.018.614.336 1.573-.646 2.554-1.6 3.553-1.27.194-2.541-.153-3.816.02-.82-.139-1.363-.593-1.59-1.406-.018-.31.049-.602.205-.872.041-.191.066-.385.076-.58z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3B6BD9"
        d="M543.874 158.727c1.35-.188 3.293.573 2.645-2.264-.508-2.234 2.748-1.04 3.045-2.792.205-.003.412-.002.619.002l.006 1.261c-.242 1.016-1.412 1.567-1.363 2.73.127 3.042-1.613 3.462-4.064 2.891-.75-.388-1.42-.82-.888-1.828z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#39A3E0"
        d="M533.956 153.03l-.596-.651c-.217-1.029-.436-2.058-.654-3.085.719-.63.82 1.082 1.553.408 1.346.353 1.803 1.534 2.41 2.576a.764.764 0 01-.199.742l-.039 1.31c-1.497.843-1.831-.523-2.475-1.3z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1380D4"
        d="M550.184 149.919c-2.297-1.218-1.076-2.951-.635-4.572.959 1.414.498 3.037.635 4.572z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#39AAF9"
        d="M533.991 149.885c-.857.739-.723-.687-1.285-.591.145-1.043-.682-2.101.049-3.135.396.318.842-2.025 1.203.024 1.001 1.224 1.041 2.459.033 3.702z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#148CC7"
        d="M548.92 153.645l-3.699.035c.191-.64.643-1.029 1.24-1.277.959.139 2.268-.415 2.459 1.242z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3AA6F6"
        d="M545.172 143.708c.014-.444.025-.89.035-1.335.771.071 1.217.466 1.264 1.262-.047.516-.139 1.011-.648 1.296-.561-.225-.914-.559-.651-1.223z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4C1DB1"
        d="M527.577 154.288c.016.214.031.429.049.643-.5 1.258-1.533 1.189-2.596 1.043-3.291-.452-6.598-.154-9.895-.214-1.299-.023-2.508.123-3.008 1.6-2.115.101-2.02-2.077-3.119-3.021l18.569-.051z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CCF0F7"
        d="M617.043 297.212c.344.003.686.003 1.031.005.354.523 1.674-.03 1.375 1.228-.832.548-2.443.327-1.945 2.67.43-1.707 1.17-2.593 2.514-2.751 1.861 2.3 1.594 3.547-1.148 5.403-3.705.355-4.871-.849-4.43-4.564.49-1.158 1.543-1.578 2.603-1.991z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4085B3"
        d="M614.92 299.046c-.539 3.391.242 4.28 3.922 4.464.217.129.291.255.217.381-.072.129-.145.193-.219.193.004.2-.012.399-.047.599-4.127.39-4.967-2.492-5.576-5.601.408-.216.818-.435 1.229-.65a.751.751 0 01.474.614z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3B80AF"
        d="M618.84 304.084l.002-.574c1.855-1.479 3.012-3.055.676-5.093h-.008c-.479-.4-.955-.801-1.434-1.2.945-.101 1.818.13 2.637.604 1.832 2.957 1.276 4.817-1.873 6.263z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3A79B3"
        d="M614.92 299.046l-.475-.614c.508-1.168 1.514-1.272 2.598-1.22l-2.123 1.834z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7442D5"
        d="M281.917 154.275c.096-.694.719-.495 1.124-.665l81.166.015 18.696.006c20.438.011 40.878.013 61.315.054 1.189.003 2.508-.47 3.555.556v.045c-1.264.925-2.729.883-4.189.883-52.616.001-105.229.007-157.846-.015-1.319 0-2.74.248-3.821-.879z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#531DBA"
        d="M281.917 154.275l165.858.011c-.324 1.694-.887 3.266-2.258 4.425-.125-.072-.246-.145-.371-.216.127-3.035-2.023-2.044-3.627-2.029-19.52.095-39.028.165-58.536-.019-6.695-.059-13.39-.043-20.086-.001-10.805.237-21.613.072-32.418.097-14.654.032-29.305.011-43.958.003-1.452 0-2.912.084-4.353-.208-.633-.12-1.187-.387-1.632-.861.089-.828 1.011-.698 1.381-1.202z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#332B75"
        d="M449.077 156.158c1.361 1.381 3.795 2.618.137 4.297-1.951.895-2.127 3.958-.531 5.859.795.952 1.801 1.737 2.541 2.725.586.782.52 1.831.113 2.687-.447.937-1.432.625-2.229.615-.918-.012-1.223-.608-1.27-1.437-.064-1.113.451-2.299-1.52-2.652-2.162-.389-.375 2.003-1.699 1.955-.172-.007-.352.202-.527.31a1.401 1.401 0 01-.408-.743c-.021-.29.002-.576.051-.859.271-.941.154-2.021.977-2.77 1.796-3.179 2.005-7.052 4.365-9.987z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#683BCF"
        d="M445.518 158.711c-.238 1.321-.344 2.693-1.4 3.704-.596.252-.16 1.91-1.521 1.117-1.045-1.821-.229-3.396.65-4.966.684-1.419 1.361-1.73 2.018.019l.253.126z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2D2364"
        d="M444.711 166.146c-.158 1.052.404 2.248-.627 3.124-.701-.11-1.129-.567-1.459-1.149a1.695 1.695 0 01-.057-.759c.158-.498.395-.941.859-1.225l1.284.009z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#603BB4"
        d="M443.428 166.137c-.17.449-.342.897-.51 1.347-.49-.318-.678-.808-.781-1.351-.08-.916-.043-1.798.732-2.459l1.248-1.259c-.23 1.241-.458 2.482-.689 3.722z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F3030F"
        d="M270.556 155.526l1.868-1.305c1.645-.146 2.894-1.684 4.683-1.34.822.009 1.581.193 2.188.794.123 1.095-1.394 1.412-1.205 2.54.344.363.35.77.159 1.205a1.984 1.984 0 01-.729.496c-.729.221-1.481.233-2.234.262-.776.017-1.552.029-2.324-.094-1.28-.404-2.433-.928-2.406-2.558z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E90C1C"
        d="M279.293 153.676l-2.499-.045c-.661-.813-.545-1.62.022-2.422l4.984-5.036c-.22.655-.327 1.378-.679 1.954-1.417 2.319-.835 3.307 1.877 3.007l-.014 1.175c-1.195.548-3.114-.853-3.691 1.367z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7B32E1"
        d="M277.97 157.298l.118-1.083c.92.096 1.769-.039 2.449-.738l1.263.071c2.223 2.727 2.165 3.115-.712 4.697a1.435 1.435 0 01-.763-.345c-.455-1.161-1.587-1.716-2.355-2.602z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#66B3E5"
        d="M625.051 249.732c-.113 1.822-1.592 1.112-2.547 1.375l-4.301-.064c0-.206.002-.412.012-.617 2.157-1.452 4.514-.899 6.836-.694z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4F9FDA"
        d="M612.645 257.2c-.01-.402-.016-.802-.021-1.204.973.13 2.258-.366 2.496 1.242l-2.475-.038z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F0FAFA"
        d="M625.051 249.732c-2.16 1.393-4.547.552-6.836.693-.555-.247-1.107-.494-1.662-.74-1.629-2.009-1.453-4.056-.133-6.128.984-1.274 1.969-2.549 2.949-3.824.568-.518 1.072-1.236 1.994-.625l.025.022c.359 1.057.428 2.109-.049 3.153-.332 1.306.662.869 1.256.954 4.036.424 4.22.909 2.456 6.495z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CCEEF7"
        d="M615.657 249.72c-2.195.441-3.393-.015-3.291-2.698.088-2.321.156-4.118 3.207-3.432.791 2.033.619 4.079.084 6.13z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7C9BA7"
        d="M615.657 249.72l-.084-6.129.848-.032.133 6.127c-.302.01-.598.022-.897.034z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B3DEEA"
        d="M621.34 242.283c.018-1.05.033-2.103.049-3.153.201-.019.398-.004.596.039-.178 1.046.527 2.274-.645 3.114zM621.364 239.108c-.662.208-1.328.418-1.994.625.388-1.09.703-2.417 1.994-.625z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5AA1D1"
        d="M608.866 252.265c-.838-.618-1.164-1.491-1.246-2.487 1.64.213 1.103 1.521 1.246 2.487z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B1972"
        d="M592.719 384.652c-.045 1.027-1.439 1.293-1.352 2.396-.023.139-.049.275-.07.414-1.115 1.945-3.502 2.275-4.896 3.867-.984 1.031-2.203 1.514-3.605 1.586-1.357.014-2.602 1.1-4.029.434-.242-.459-.24-.893.125-1.291.855-1.41 2.715-.785 3.744-1.846 1.148-.986 2.07-2.313 3.752-2.498 2.404-.262 3.041-2.869 4.979-3.748.29.546.823.614 1.352.686z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#332A72"
        d="M596.374 374.611c-.076-.789.266-1.785-.566-2.254-.834-.475-2.264-.393-1.768-1.893.352-1.059 1.156-1.832 2.395-2.094 1.602-.34 1.662 1.172 2.412 1.85-1.009 1.362-.358 3.655-2.473 4.391z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#332A72"
        d="M593.891 379.619c-1.287-2.719 1.154-3.59 2.484-5.01.17 2.162-.9 3.713-2.484 5.01z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FB364E"
        d="M641.92 217.992c.6.943.689 1.994.639 3.073.387.419.359.848.033 1.287-.039.81-.076 1.621-.113 2.43-1.225.422-2.064 1.229-2.48 2.465-2.043 1.809-4.107 2.002-6.197.077-1.197-.139-1.695-1.208-2.498-1.876-.17-.959.541-1.036 1.186-1.182.516.003.971.151 1.316.558.717 1.404 1.969 1.527 3.18 1.027 2.338-.965 3.982-2.614 4.316-5.275.111-.885-.3-1.893.618-2.584z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF5F0"
        d="M638.856 222.395c-.141.681-.49 1.145-1.24 1.193-.945.542-2.264.949-2.596-.247-.496-1.801-2.098-1.316-3.063-2.047-.355-.381-.416-.825-.293-1.313.15-.309.377-.538.682-.693 1.832-.928 3.803-.149 5.656-.191 1.875-.043 1.473 1.916.854 3.298z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9384E"
        d="M628.85 222.326l.104-3.77c1.58-.282 1.725-2.638 3.604-2.483l.066 2.736c.027.472-.287.745-.596 1.021l-.154-.03c-.621.819.199 1.72-.141 2.556-.576 1.053-1.127.723-1.67-.027l-1.213-.003z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F83A4B"
        d="M632.565 216.064c1.379-2.604 3.537-1.716 5.598-1.241l1.734 1.839c-2.744 2.007-4.906-.79-7.332-.598z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FBE6EE"
        d="M632.063 221.071c1.361.43 4.096-1.273 3.473 2.238l2.08.279c-.545.643-.916 1.575-2.053 1.235-.918-.591-2.127-.695-2.82-1.669a4.837 4.837 0 01-.547-.63c-.186-.469-.678-.916-.133-1.453z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6D0D1"
        d="M632.028 219.83c.199-.341.396-.683.596-1.023 1.877-.103 3.764-.377 5.629-.261 1.826.114 2.051 1.817.604 3.849-.146-3.389-.514-3.602-5.342-2.992-.505.064-.991.281-1.487.427z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CD5765"
        d="M632.596 222.267c.988.854 1.977 1.705 2.967 2.557h-1.758l-1.18-.041c-.71-.832-.824-1.667-.029-2.516z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E64252"
        d="M633.801 227.324c2.072.525 4.143.685 6.197-.076.029.356.061.713.09 1.07-2.406 1.521-4.961 1.088-7.521.574l1.234-1.568z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F23E3D"
        d="M632.596 222.267l.029 2.516c-.531.042-1.043.122-1.32.666-1.412-.643-1.24-1.915-1.242-3.119.416.037.84.678 1.252-.011.426-.372.854-.359 1.285-.004l-.004-.048z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E74455"
        d="M642.592 222.352l-.033-1.287 1.133-1.161c.029.996.473 2.175-1.1 2.448z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3B80A8"
        d="M632.651 172.331c3.568 1.891 3.533 5.618-.08 8.788-1.662-.096-3.332.857-4.988-.044-.18-.28-.146-.542.064-.791.166-.12.34-.24.535-.289 5.475-1.378 5.598-1.619 3.633-7.026-.066-.186-.02-.399.037-.604.258-.208.523-.228.799-.034z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3A81AD"
        d="M627.661 180.303l-.078.773c-3.811-2.17-4.168-6.496-.721-8.747.248-.207.508-.228.773-.04.311.763-.047 1.431-.439 1.992-1.516 2.159-.026 4.044.465 6.022z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2E85B5"
        d="M627.86 172.533l-.996-.203c.238-.394.475-.788.715-1.181 1.758.099 3.842-1.193 5.07 1.183l-.914.144c-1.277.926-2.568.897-3.875.057z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D6C5FA"
        d="M580.698 298.034c-.072.164-.037.304.104.415.469.406.324 1.005.475 1.512.846 3.434 1.693 6.865 2.543 10.299-.273.776-.402 1.619-1 2.257-1.355 1.645-2.693 3.303-3.732 5.175-.719 1.811-.164 3.152 1.395 4.27 1.756 1.26 3.439 2.625 5.201 3.885.906.65 1.975 1.213 1.955 2.58.738 7.572 1.604 15.139 1.102 22.773-.49 7.434-2.012 14.564-6.084 20.953-2.498 4.42-6.277 6.529-11.357 6.855-10.955.701-19.4-4.77-27.596-10.893-5.797-4.334-10.883-9.473-16.01-14.557-1.043-1.031-2.023-2.086-2.383-3.566-8.365-9.816-16.174-20.043-23.184-30.879-.99-1.531-1.186-2.461.713-3.132.779-1.125 2.055-1.339 3.223-1.681 6.941-2.035 13.803-4.321 20.723-6.416 3.373-1.75 4.811-5.215 4.369-9.727-.785-8.048-3.293-15.602-6.396-22.978-4.24-10.076-9.615-19.517-16.441-28.088-2.402-3.018-5.145-5.69-8.523-7.637-2.275-1.313-4.609-1.86-7.078-.516-1.17.64-2.26 1.408-3.359 2.156-5.672 3.752-11.316 7.549-16.977 11.324-.809.538-1.484 1.524-2.705 1.096-2.006-3.083-2.777-6.657-3.896-10.071-5.902-18.01-10.484-36.284-10.527-55.415a69.503 69.503 0 011.135-12.688c.986-5.421 3.105-10.28 6.498-14.602 1.258-2.89 3.914-4.135 6.611-4.694 8.602-1.785 16.434.101 23.254 5.771 20.178 13.505 34.801 32.14 48.08 52.02.635.95 1.281 1.891 1.92 2.835-.645 1.659-1.822.662-2.707.437-2.582-.659-4.822-2.193-7.338-3.05-.621-.411-1.451-.673-1.25-1.689 1.729-.978 1.807-2.64 1.762-4.313-1.297 1.77-2.541.26-3.775-.164-1.223-.42-2.375-1.507-3.939.187 2.646-.983 4.422.446 6.121 1.563.729.481.549 1.928-.258 2.827-1.115.781-2.146.149-3.18-.214-1.1-.388-2.184-.444-3.268.021-1.727.585-1.889 2.27-2.539 3.607-1.117 2.294-2.027 4.673-2.904 7.066-.867 1.75-1.615 3.552-2.33 5.37-.566 1.446-.678 2.794.568 3.962 2.35 1.799 5.242 2.41 7.871 3.594 1.113.449 2.299.798 2.924 1.971.064.96-.426 1.375-1.141 1.409 2.113-.454 4.096 3.414 6.617.492 2.855-.091 4.406-1.679 5.104-4.338.227-.867.326-1.81.953-2.54.262-.17.549-.25.863-.244 1.494.48 1.117 2.024 1.723 3.01.885 1.896 1.24 3.709-.793 5.169-.211.15.361.852 1.174 1.422.607 1.126.299 2.536 1.111 3.602.527 1.125-.156 2.834 1.637 3.35.148 3.084.666 6.105 1.416 9.094-.059.491-.23.937-.557 1.313-.508.626-1.207.855-1.961.965-.252.068-.594.087-.686.353-.123.353.201.419.477.458 1.195-.09 1.467-1.318 2.307-1.845.832-.194 1.559.199 1.873.813 2.58 5.025 7.773 5.601 12.297 7.312.668.253 1.424.27 1.959.837.6 2.103-.434 2.601-2.199 2.072-.855-.259-1.693-.579-2.574-.744-2.553-.633-5.232-.697-7.711-1.718-.5-.205-1.359-.34-1.494.498-.139.856.955.46 1.27.948.742.999.096 1.692-.516 2.396a4.138 4.138 0 01-.68.587c-3.236 1.33-6.248 2.997-8.461 5.818-2.693 2.357-3.799 5.56-4.715 8.862-.684 2.154-.264 4.371-.383 6.553-.152 3.979 1.465 7.322 3.736 10.431a11.938 11.938 0 003.973 4.255c.977.557 1.963 1.104 2.57 2.109.416.839 1.264.9 2.029 1.112.264.095.498.235.715.407.406.518.986.633 1.596.778 1.076.255 2.119 1.658 3.193-.009 1.563-.372 3.148-.192 4.723-.239 1.455-.095 2.994.385 4.318-.625 1.867-1.067 3.836-1.97 5.547-3.301 1.518-1.269 2.947-2.618 4.105-4.233.145-.237.309-.46.475-.681a8.696 8.696 0 001.08-1.75c.113-.267.244-.523.377-.78 1.805-3.423 2.447-7.106 2.502-10.927.225-.584.32-1.312 1.24-1.13l.555.622c2.189 2.335 1.924 5.429 2.545 8.246z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B2468"
        d="M469.672 253.516c6.451-4.315 12.9-8.629 19.354-12.943.684.332 1.377.65 1.707 1.416.111.293.182.596.215.907-.834 2.774-1.141 5.671-1.594 8.05 1.141-1.352 1.619-.065 1.621 1.211.006 2.291.902 4.195 2.035 6.061 5.047 14.84 11.51 28.922 21.828 40.948a18.676 18.676 0 006.9 6.427c1.273 1.975 3.652 1.887 5.439 2.907l-24.34 7.482c-1.947.29-3.094-.739-3.926-2.342-5.449-10.476-11.852-20.413-16.588-31.31-3.488-8.026-7.479-15.848-10.697-24.009-.633-1.608-1.301-3.205-1.954-4.805z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#262159"
        d="M532.721 180.481c.205-1.541-1.074-2.181-1.885-3.105-.381-.595-.365-1.111.297-1.499 12.104 1.085 24.236.268 36.354.528 1.648.036 3.332-.184 4.906.552.576.328.814.87.945 1.481.1.59.088 1.178-.061 1.758-.77 2.043-2.574 1.774-4.182 1.781-8.764.043-17.529.012-26.293.026-1.129.002-2.268-.124-3.357.147-.191.469.045.927.373 1.054 4.174 1.617 3.889 6.546 6.797 9.109.604.531.775 1.42.721 2.276-.117.485-.428.774-.902.898-1.229-1.065-2.783-1.741-3.74-3.129-3.033-3.064-5.504-6.583-8.109-9.993v.001a4.335 4.335 0 01-1.864-1.885z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D3C6F8"
        d="M545.157 248.528c-.414-.169-.816 1.679-1.188.04-.186-.813-.619-1.693-.035-2.544-1.131-1.005-.078-2.738-1.24-3.733-.793-.79-1.855-.092-2.939-.4 1.553-1.768 4.234-2.958 2.314-5.827.211-1.708-.258-3.324-.68-4.946-.021-.786.107-1.525.672-2.125.316-.27.672-.504 1.086-.547 2.479-.252 2.047-1.524 1.066-2.997.027-.277.131-.527.301-.749.865-.199 1.623-.928 2.611-.539a84.44 84.44 0 016.822 11.867c-.271.736-.666 1.411-1.033 2.104a2.578 2.578 0 01-.924.793c-.969.325-2.133.237-2.738 1.315-.814.569-.904 1.562-1.359 2.339-.873.998-.539 2.388-1.127 3.478-.646.751-.775 1.842-1.609 2.471z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#362C76"
        d="M525.309 349.992c6.637 6.854 13.238 13.74 21.078 19.287 4.164 2.949 8.494 5.582 13.297 7.357 8.559 3.168 16.479 2.98 22.971-4.484.459 2.848-.891 4.422-3.494 5.357-2.15.771-3.822 3-6.52 2.074-2.492-.502-4.986-.525-7.479.014-3.371.391-6.256-.621-8.668-3.002-.217-.215-.518-.582-.717-.543-5.959 1.139-8.041-4.889-12.328-6.934-1.889-.9-3.547-2.875-5.961-3.313-.939-.17-1.061-.906-1.02-1.656.111-2.133-1.521-3.553-2.898-4.055-3.393-1.227-4.801-4.422-7.373-6.389-1.329-1.017-.931-2.394-.888-3.713z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#241F5A"
        d="M569.004 236.02c2.566.041 1.074-1.232.609-2.032-3.146-5.442-5.758-11.193-9.377-16.368-.15-.215-.057-.603-.076-.91-.252-.684-1.324-1.415-.217-2.073 1.088-.643 1.93.083 2.566.988.803 1.792 1.764 3.479 3.104 4.949.643.702 1.162 1.298 2.289 1.25 2.576-.112 3.146 1.571 2.818 3.693-.256 1.666-.229 2.796 1.684 3.688 1.453.676 1.578 2.755 2.176 4.268.182.862-.008 1.798.592 2.919.674-1.302.248-2.603.832-3.631 1.654-1.506 2.141-.171 2.365 1.098.32 1.818.117 3.682.137 5.525-.023.896-.021 1.798-.432 2.631-.273.479-.713.719-1.23.841a3.08 3.08 0 01-1.424-.094c-1.248-.514-2.002-1.685-3.129-2.369-.584-.405-1.088-.902-1.617-1.375-.859-.828-2.394-1.289-1.67-2.998z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#27214B"
        d="M443 168.031l1.084 1.238c-.004.205-.01.409-.012.614-.645 1.177-.668 2.55-1.182 3.769.092 4.953-1.795 9.689-1.34 14.731.666 7.329.912 14.697 1.338 22.049.396 1.465.654 2.967 1.186 4.396l.012 1.242c1.182 1.478.174 3.491 1.221 5l.061 3.072c.072 1.152 1.225 2.531-.684 3.271-1.666-1.295-1.578-3.288-1.943-5.068-1.67-8.106-2.5-16.329-3.26-24.561 0-4.563-.113-9.125-.016-13.687.016-.904.027-1.811.217-2.7.484-1.288.4-2.643.445-3.982.027-1.809.523-3.543.842-5.307.287-.903.461-1.842.766-2.744.262-.593.58-1.137 1.265-1.333z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#372D74"
        d="M492.747 161.816c-3.48-1.539-6.746-3.514-10.449-4.609-7.113-2.103-13.662-1.589-19.416 3.533-.443-2.008.252-3.169 2.287-3.896 3.008-1.075 5.635-4.157 8.996-3.049 3.668 1.209 7.313.814 10.957 1.24 1.205.141 2.092 1.237 3 2.097.65.615 1.176 1.591 2.254 1.485 2.63-.259 2.47 1.477 2.371 3.199z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#26214F"
        d="M482.829 317.119c1.963.293 2.678 2.133 3.33 3.43 3.66 7.268 8.75 13.598 13.432 20.139 1.527 2.135 2.807 4.752 5.033 6.453.258.736-.113 1.154-.73 1.447-1.18-.004-1.869-.803-2.506-1.615-6.68-8.553-13.039-17.332-18.654-26.633-.428-.709-.855-1.422-.824-2.297.118-.494.43-.797.919-.924z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#312C72"
        d="M515.231 162.405c2.285.282 2.725 2.715 4.369 3.744 1.193.707 2.377 1.426 3.428 2.341 1.25 1.127 2.459 2.296 3.57 3.563.678.866 1.313 1.769 2.135 2.515.648.854 1.84 1.426 1.48 2.81-3.254.655-5.193-1.052-6.205-3.822-.719-1.968-2.428-2.492-3.924-3.088-3.767-1.506-5.494-4.013-4.853-8.063z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#28244C"
        d="M450.95 246.032c2.26 6.051 4.596 12.075 6.746 18.165.938 2.653 2.754 5.036 2.623 8.037.15.623-.211.826-.736.901-1.648-.497-1.664-2.144-2.354-3.32-1.172-3.348-3.416-6.266-4.002-9.854-.307-1.827-.986-3.542-1.615-5.273-.617-2.488-2.002-4.779-1.932-7.448.197-.637.319-1.361 1.27-1.208z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#231D5B"
        d="M578.891 392.059c.01.43.016.859.023 1.291.176.34.119.633-.172.883-.424.289-.9.438-1.402.52-7.668 1.408-15 .297-22.043-2.965-.586-.252-1.137-.578-1.729-.826-.59-.273-1.09-.639-1.305-1.291-.1-.461-.053-.898.174-1.313 1.857-.803 3.25.156 4.615 1.225.201.006.402.01.605.01.813.463 1.809.559 2.502 1.258 4.879 1.887 9.904 2.281 15.057 1.525 1.216-.181 2.451-.216 3.675-.317z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2A244F"
        d="M459.551 272.917l.768-.683c2.031.557 1.773 2.724 2.23 3.979 2.422 6.677 6.33 12.623 8.982 19.165.645 1.189-.027 1.455-1.037 1.48-1.996-1.29-2.863-3.267-3.348-5.479-.129-.939-.094-1.951-1.094-2.522-1.48-1.482-2.111-3.457-3.049-5.254-.273-.692-.5-1.403-.828-2.075-.916-1.856-1.809-3.722-2.498-5.677-.337-.961-.868-1.922-.126-2.934z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#292350"
        d="M450.95 246.032c-.557.313-.631.868-.707 1.419-2.623-1.542-1.861-4.593-3.033-6.783-.178-.783-.354-1.566-.736-2.285-1.527-3.547-2.826-7.128-1.641-11.075.852-.941.35-2.112.535-3.167 1.639 2.072 1.17 4.719 1.891 7.055 1.501 4.87 3.292 9.687 3.691 14.836z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#351D53"
        d="M546.434 195.488l.629-.636c.91-2.729 3.814-2.714 5.68-4.135.986-.357 1.889-.889 2.813-1.378 1.436-.41 2.867-.422 4.295.021.936.57 1.957.983 2.912 1.529.584.892 1.617 1.623 1.072 2.93-.684.521-1.475.569-2.285.53-3.184-.938-6.373-2.149-9.475.229-1.674.934-2.48 2.867-4.242 3.7-.723.078-1.045-.445-1.391-.932l-.008-1.858z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#282251"
        d="M470.35 296.588c.773-.032 1.17-.433 1.182-1.209.854.595 1.139 1.484 1.273 2.452.613.496.6 1.398 1.223 1.889h.002c1.678.974 1.697 2.895 2.494 4.372.836 3.103 3.494 5.164 4.621 8.102.229.599 1.051 1.087.395 1.876-.355.357-.789.488-1.283.447-1.248-.263-1.783-1.279-2.352-2.246-1.912-3.256-3.877-6.484-5.572-9.864-.547-1.977-2.52-3.472-1.983-5.819z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B2650"
        d="M552.682 388.332c-.016.463-.027.924-.043 1.389a1.536 1.536 0 01-.844.369c-6.484-2.023-11.822-5.986-17.057-10.119-.334-.264-.422-.691-.422-1.117.797-1.486 1.475-.662 2.154.111 2.684.008 3.643 2.766 5.924 3.711 2.174.9 4.34 2.129 6.537 3.164 1.056 1.125 3.569.053 3.751 2.492z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#28234F"
        d="M503.881 348.645l.742-1.504 8.725 10c1.43 1.061 2.646 2.332 3.73 3.736.004.215.012.43.016.645.162.58-.191.826-.648 1.004-1.309.219-2.178-.58-2.932-1.42-3.098-3.459-6.115-6.986-9.162-10.49-.477-.55-.863-1.184-.471-1.971z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6E53AA"
        d="M587.637 328.426c-2.367-1.822-4.65-3.764-7.117-5.432-2.193-1.484-2.961-3.305-2.238-5.807.539-.191.818.135 1.066.527.475 1.898 1.867 3.037 3.309 4.219 2.1 1.719 4.756 2.807 6.178 5.311l3.234 2.824c-.246.293-.49.584-.732.877l-3.7-2.519z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4F1F6A"
        d="M546.442 197.345l1.295.692c.496.464.572 1.06.545 1.69-.23 1.253-.617 2.503-.117 3.781.34 1.754.816 3.444 2.178 4.729.723 1.005 1.932 1.563 2.502 2.711.191.697-.248 1.044-.75 1.358-2.828-.741-5.324-3.462-5.68-6.19-.914-2.1-.875-4.204-.033-6.313l.06-2.458z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#714FAD"
        d="M532.752 213.547c2.627.287 4.703 2.057 7.197 2.686.908.229 1.719 1.25 2.797.439.938.604 1.746 1.301 1.816 2.528-.119.47-.406.763-.893.847-1.98-.448-3.701-1.58-5.646-2.125a6.865 6.865 0 01-.814-.336c-1.68-1.345-4.486-.936-5.406-3.467.145-.476.352-.852.949-.572z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#25224D"
        d="M516.358 362.174l.736-.652c3.121 2.904 6.24 5.811 9.361 8.717-.895.766-1.918-.293-2.832.203-3.089-2.169-6.367-4.174-7.265-8.268z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6F51A5"
        d="M543.819 220.059l.744-.859 1.24 2.513c-.258 1.091-.01 2.394-1.277 3.063h.01c-.457 1.547-.434 3.314-1.994 4.358-.697.496-.426 1.238-.48 1.898-.498.564-.17 1.601-1.094 1.924l-.668.103c-.502-.126-.82-.447-.971-.939.804-4.276 3.095-8.003 4.49-12.061z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2D2756"
        d="M536.471 378.965c-.658-.184-1.352-.988-1.934.115-3.227-1.078-5.732-3.09-7.609-5.906l.096-.426c1.002-.672 1.754-.428 2.689.346 2.301 1.904 5.108 3.213 6.758 5.871z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5E1740"
        d="M552.094 212.308c.199-.372.396-.744.598-1.115 1.875-1.14 3.986.233 5.891-.565 2.797-.146 4.07-3.083 6.65-3.635.334.051.594.213.791.488.232 2.82-1.982 3.936-3.74 5.375-1.561.516-3.172.328-4.768.36-1.668.014-3.381.296-4.846-.846a5.6 5.6 0 00-.576-.062z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#87205F"
        d="M569.004 236.02c.168 1.411 1.586 1.688 2.336 2.569-1.068.92-2.115.505-3.047-.169-1.736-1.26-3.68-1.611-5.756-1.519-1.531-.103-3.113.237-4.582-.475-1.129-1.422.668-1.078.986-1.626 3.378.204 6.901-.774 10.063 1.22z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3C2774"
        d="M552.67 212.369l5 .083c1.234.925 2.197 1.943 1.254 3.622-1.432-.65-2.74-1.541-4.494-1.287-1.861.27-1.756-1.18-1.76-2.418z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#322A72"
        d="M534.584 182.366c3.475 2.706 5.637 6.475 8.109 9.993-3.771-2.465-6.614-5.682-8.109-9.993z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2E1C5E"
        d="M558.924 216.073c.363-1.478-1.158-2.304-1.254-3.622l4.973-.166c.924 1.44 1.545 2.834-.6 3.789-.406-.752-.947-1.527-1.865-1.039-.631.334.121 1.1-.016 1.674-.412-.212-.826-.423-1.238-.636z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#322B71"
        d="M552.682 388.332c-.852-1.43-3.076-.793-3.75-2.492 2.711-.639 4.854 1.697 7.629 1.373 1.314-.156.738 1.453.492 2.369-1.457-.418-2.914-.832-4.371-1.25z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#312A6E"
        d="M476.524 304.092c-1.467-1.095-1.813-2.83-2.494-4.372 4.215-.476 3.084 2.102 2.494 4.372z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#332C69"
        d="M586.387 387.715c-1.105 1.051-2.006 2.408-3.752 2.496.127-3.512.422-3.707 3.752-2.496z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4A2770"
        d="M546.381 199.805c.012 2.104.021 4.208.033 6.313-1.728-1.698-1.744-4.531-.033-6.313z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#322A72"
        d="M526.862 181.841c1.596-.885 3.162-.934 5.521.063-2.424.683-3.972.451-5.521-.063z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#302A6B"
        d="M517.079 360.877c-1.891-.598-2.738-2.242-3.73-3.736 1.708.781 3.886 1.095 3.73 3.736z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D3BDFB"
        d="M544.526 224.776c.291-1.078.461-2.206 1.277-3.063.439.815.881 1.63 1.322 2.447-.744.725-1.455 1.581-2.599.616z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#282249"
        d="M480.01 314.161c.51-.029 1.021-.062 1.529-.092.979.785 1.449 1.784 1.285 3.05-.205.23-.414.465-.621.695-1.724-.619-2.468-1.83-2.193-3.653z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4F2062"
        d="M558.942 234.8l-1.266 1.269c-.795 1.083-1.688 1.941-3.193 1.354-.305-.422-.367-.862-.102-1.329 1.203-1.541 2.901-1.352 4.561-1.294z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B265B"
        d="M445.307 221.071c-1.588-1.377-1.172-3.246-1.221-5 2.471 1.162.735 3.354 1.221 5z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2C2267"
        d="M565.163 379.598c2.492-.975 4.984-.936 7.479-.014-2.493.006-4.987.01-7.479.014z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#232148"
        d="M523.971 370.199c.857-2.068 1.643.809 2.484.039l.568 2.51-.031.094c-1.675-.117-2.513-1.192-3.021-2.643z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B265B"
        d="M444.075 214.828c-1.045-1.29-1.326-2.787-1.186-4.396.914 1.325 1.279 2.798 1.186 4.396z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2D2364"
        d="M442.891 173.652c-.127-1.419-.01-2.762 1.182-3.769l.02.634c.04 1.214-.305 2.279-1.202 3.135z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2A2164"
        d="M530.213 177.378l-1.871-2.492c.484-.523 1.057-.52 1.672-.281.557.36.852.86.82 1.534.002.412.002.824.002 1.236l-.311.003h-.312z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EBAED8"
        d="M554.381 236.095c.076.369.156.739.234 1.109-.477.741-1.082 1.103-1.957.655-.021-.931.098-1.758 1.289-1.831.143.041.286.062.434.067z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#322A72"
        d="M532.721 180.481c.816.435 1.459 1.044 1.863 1.886-1.404.145-2.023-.485-1.863-1.886z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#312A6E"
        d="M474.028 299.72c-1.25-.084-1.232-.988-1.223-1.889 1.26.079 1.25.978 1.223 1.889z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#322B71"
        d="M560.161 390.85c-.982-.125-1.859-.459-2.502-1.258 1.08-.071 2.045.088 2.502 1.258z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4389C7"
        d="M595.143 227.302c-.018-.423-.033-.846-.051-1.27-.166-.262-.158-.51.055-.743a1.88 1.88 0 01.83-.143c.949.207 1.988.072 2.82.724l.129 1.681c-1.345 1.199-2.523-.162-3.783-.249z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D0C6F9"
        d="M557.672 269.126c1.064.12 2.133-.209 3.16.619 1.6 1.294 1.779.017 1.836-1.237 1.945-.859 3.813-1.987 6.07-1.81 1.035.261 1.033 1.232 1.354 1.983l3.838 10.375c.342.55-.008.794-.443.997a1.89 1.89 0 01-.887-.06c-.539-.278-.906-.738-1.26-1.211-1.914-2.28-4.318-3.937-6.887-5.381-.625-.301-1.283-.507-1.945-.697-.785-.277-1.643-.353-2.363-.814-.633-.907-1.563-1.451-2.492-1.994a.721.721 0 01.019-.77z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3B2973"
        d="M570.092 268.682l-1.021-1.504c-.467-.242-.664-.654-.734-1.151a2.398 2.398 0 01.313-1.341c2.189-1.641 4.535-3.106 6.152-5.404 2.039-.809 1.939-2.872 2.623-4.479.402-.5.914-.816 1.551-.923.336-.001.627.108.881.322 1.014 1.716 3.004 3.163 1.545 5.564l-.018.004c-.779.518-1.918.313-2.496 1.238-1.096.111-2.244-.254-3.482.426 2.064 2.809.736 3.421-2.08 3.374-2.456-.041-3.271 1.646-3.234 3.874z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2C2C81"
        d="M581.389 290.973c-.725-3.391 1.781-6.229 1.809-9.582 1.006 2.113.936 4.46.566 6.567-.355 2.052-1.256 4.026-1.379 6.178-.012.212-.646.388-.992.58-1.014-1.247-1.049-2.494-.004-3.743z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3E2B77"
        d="M581.389 290.973l.004 3.743c-.654 1.017-.641 2.174-.695 3.318-1.07-2.679-2.064-5.383-2.549-8.243 1.963-2.023 1.953 1.353 3.24 1.182z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#312985"
        d="M578.887 261.008c-.34-2.774 1.027-2.111 2.496-1.238-.461 1.547.932 2.467 1.268 3.743.363.418.318.833-.018 1.241-2.603.107-3.822-1.172-3.746-3.746z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#25316F"
        d="M582.633 264.754c.004-.413.01-.828.018-1.241 1.863.555 2.639 1.832 2.477 3.731-1.954.293-2.756-.567-2.495-2.49z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#8FABEF"
        d="M577.594 289.169c-.205.402-.404.805-.609 1.206-.258.167-.512.161-.76-.021-.846-1.323-.371-3.022-1.238-4.34a5.963 5.963 0 01-.309-.769c-.031-.965-1.121-2.137.527-2.783 1.188 2.095 1.883 4.366 2.389 6.707z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#836DBD"
        d="M594.391 306.731c-1.955-.958-3.787-2.888-6.137-.787-.795-1.384.615-1.398 1.197-1.925.531-.514 1.078-.978 1.879-.516l.041-.039c.598 1.467 3.046 1.224 3.02 3.267zM588.25 305.953c-.68 1.712-1.703 3.162-3.223 4.233-.515-2.62 1.286-3.478 3.223-4.233z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#212F8D"
        d="M585.747 274.518c.863 2.021.852 3.407.012 5.446-.841-2.047-.848-3.434-.012-5.446z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#41266A"
        d="M583.333 279.317c-.9-1.362-.844-2.749-.162-4.771 1.029 1.927.72 3.343.162 4.771z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#431FB1"
        d="M591.331 303.504c-.625.171-1.252.345-1.879.516-.141-.526-1.57-.929-.287-1.56.945-.464 2.048-.554 2.166 1.044z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7E60C0"
        d="M582.44 312.063c.252-.761.625-1.427 1.379-1.803.188.201.377.402.564.605.178.971-.467 1.461-1.131 1.938-.429-.074-.705-.315-.812-.74z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4087CC"
        d="M575.206 282.462c-.82.95.244 1.928-.043 2.884-1.807-.117-1.742-1.49-1.85-2.753.043-.32.158-.616.336-.886.244-.268.525-.31.84-.128.24.293.478.588.717.883z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3E2B77"
        d="M581.276 299.961c-.16-.502-.316-1.007-.475-1.512.488.051.492-1.346 1.313-.398 1.123 1.294-.676 1.228-.838 1.91z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A7B8EF"
        d="M574.489 281.579a2.13 2.13 0 01-.561-.064c-.652-.387-.963-.926-.742-1.696l.744-.762c.684.729.836 1.579.559 2.522z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#43A5E3"
        d="M650.792 254.922l-4.473-.125c.096-.292.191-.84.283-.84 2.195.011 3.357-1.601 4.703-2.922.357.43 1.102.202 1.361.8a1.16 1.16 0 01-.121.8c-.486.677-.771 1.488-1.389 2.077a19 19 0 01-.364.21z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#56A7D9"
        d="M652.569 252.306c-.422-.424-.844-.847-1.264-1.271 2.449-1.139 4.098-.099 4.975 3.133-.352.658-.98.571-1.572.587-1.043-.261-.582-1.673-1.539-1.997a1.95 1.95 0 01-.6-.452z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6728E0"
        d="M444.081 77.524c1.092-1.125 2.496-.425 3.746-.64-1.18.621-1.971 3.517-3.746.64z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4E12C5"
        d="M588.245 160.521c.025-.486.09-.954.607-1.189 1.926 2.241 2.508 4.919 2.518 7.777.029 7.149.051 14.298.074 21.448-.539.421-1.063.416-1.568-.055-.809-1.318-.684-2.796-.662-4.234.092-5.602-.164-11.211.123-16.799.124-2.477-1.53-4.522-1.092-6.948z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3830BD"
        d="M590.137 188.61l1.307-.054.666.054c-.076.514-.195 1.006-.717 1.27-.688.771-1.414 1.474-2.578 1.317-.295-.363-.348-.772-.227-1.214a2.813 2.813 0 011.549-1.373z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF9F8"
        d="M608.231 194.852l3.301.567c1.141 1.703 2.811 3.028 3.592 4.991.166.161.229.33.193.507-.035.183-.078.273-.127.273-1.174.647-1.908-.398-2.83-.731-2.215-1.249-3.465-3.212-4.129-5.607z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E4F7F5"
        d="M615.083 201.111c.014-.234.029-.467.041-.701.396.288.795.577 1.189.865.242.556.484 1.112.729 1.667l-1.949-.597c-.368-.408-.372-.82-.01-1.234z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4592C1"
        d="M607.995 214.72c-1.029-.109-1.018.999-1.617 1.387l-3.779 2.309a2.163 2.163 0 01-.635-1.174c-.113-1.609.156-2.771 2.238-2.734 1.535.026 2.535-2.26 4.426-1.209l.287.336c-.307.361-.616.722-.92 1.085z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4B93C2"
        d="M613.924 209.909c-1.461 1.523-3.121 2.779-5.01 3.725l-.135-.117c-.189-2.482.623-4.194 3.391-4.409.51.019.992.144 1.43.415.109.127.217.256.324.386z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7F6E4"
        d="M616.401 208.646c1.441-.939 2.799-1.704 2.41 1.159-1.314.681-2.893 1.909-2.41-1.159z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4B93C2"
        d="M616.7 206.233c.305.843-.018 1.559-.457 2.252l-2.318 1.422-.135-.133c-.447-2.115.941-2.958 2.535-3.659.123.046.248.084.375.118z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#438FBE"
        d="M602.168 218.673c-1.389 1.176-2.773 2.353-4.162 3.53-.834.993-1.816.858-2.848.382a2.15 2.15 0 01-.6-.82c-.594-2.059-.768-4.205-1.248-6.291-.279-1.454-.357-2.912-.035-4.368.092-.295.24-.567.422-.818 1.184-1.134 2.561-.974 3.941-.513 1.559.519 1.672-.446 1.684-1.558.043-.807.117-1.602.684-2.247.477-.269.955-.271 1.441-.019.619.682.68 1.531.721 2.387.021.495.02.992.004 1.486-.023.806-.07 1.61-.494 2.333-1.174.95-2.502.885-3.865.584-.607-.083-1.168-1.199-1.828-.076-.08.366-.123.73-.16 1.098-.703 1.087.463.903.857 1.254.352.654.348 1.324.145 2.006-.215.665-.83 1.326-.006 1.987 1.445.227 2.363-1.33 3.797-1.104.619.053 1.205.168 1.55.767z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EFF6F2"
        d="M595.2 222.145l2.809.059 2.105.112.002.002c.469.747 1.242.593 1.941.659l-2.123 1.803c-1.338.58-2.686 1.101-4.186.667a1.923 1.923 0 01-.607-.083c-.676-.187-.916-.672-.91-1.326.125-.729.26-1.459.969-1.893z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EFF6F2"
        d="M600.114 222.316c.098-1.025.699-1.365 1.635-1.119.199.052.506.473.459.567-.477.928-1.381.398-2.092.554l-.002-.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3892CE"
        d="M602.168 218.673a673.62 673.62 0 00-2.059-.11c-.211-2.474 1.148-1.832 2.477-1.247l.012 1.1a.475.475 0 01-.43.257z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FCFCFC"
        d="M608.231 194.852c1.643 1.501 2.211 3.944 4.365 4.998.586.659.723 1.396.387 2.211-.307.498-.926.833-1.273.464-2.043-2.186-5.004-2.147-7.5-3.213-1.1-.469-1.893-1.028-1.594-2.494-.961 1.229-2.51 1.187-3.504 2.103-.951 1.211-1.393 2.75-2.488 3.867-1.256 1.949-.273 4.424-1.498 6.378-.273.57-.797.92-1.199 1.376l.02-.051c-.445.383-.781 1.104-1.543.496-.852-1.209-.344-2.729-.92-4.001-.223-.569-.451-1.134-.633-1.718-.273-1.044-.291-2.101-.152-3.164 1.656-2.358-.588-4.108-.973-6.148-.064-1.101.701-1.773 1.301-2.535.842-.681 1.736-1.314 2.189-2.358l-.012-.003c1.035 1.194 2.152 1.868 3.594.589.943-.838 3.326-.699 2.063-3.037.211-1.651 1.52-1.124 2.498-1.258.619.688 1.25.43 1.879.02.594.354 1.201.39 1.818.06-.287 1.613.77 2.659 1.705 3.655 1.027 1.094 1.677 2.232 1.47 3.763z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E4F6F9"
        d="M591.385 193.606c-.422.831-.842 1.663-1.262 2.494-1 .929-2.135.866-3.318.461-1.311-2.585 1.281-2.692 2.383-3.75a1.02 1.02 0 01.926.089l1.277-.528c.371.414.336.824-.006 1.234z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5F6DE2"
        d="M590.114 192.9c-.174.065-.35.108-.535.129-.672.32-1.088-.047-1.455-.544-.168-.69.131-1.114.768-1.346l2.502-1.258c-.075 1.155-1.647 1.676-1.28 3.019z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6FAF3"
        d="M591.385 193.606l.006-1.234 1.824-1.31c.03 1.307-.832 1.977-1.83 2.544zM603.237 187.372l-1.01 2.254c-1.328-.448-.662-1.529-.869-2.273.65-2.362 1.254-.073 1.879.019z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3A8FCF"
        d="M616.325 206.116c-.846 1.22-1.691 2.439-2.535 3.66l-1.203.034c-.859-1.347-1.537-2.708-3.266-3.405-1.584-.639-1.381-2.296-.898-3.746.396-.64.932-.728 1.57-.391.717 2.302 2.838 1.634 4.432 2.087.25.133.467.306.652.516l1.248 1.245z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FAFAE7"
        d="M612.592 202.332c0-.828.004-1.655.004-2.483l2.486 1.261c.002.412.006.824.01 1.235-.793.017-1.215.423-1.279 1.209a1.077 1.077 0 01-.74.354 1.108 1.108 0 01-.711-.417c-.164-.434-.129-.829.23-1.159z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E4F7F5"
        d="M613.047 203.672l.768-.117c1.959-1.037 1.445.296 1.262 1.316l-.291-.079-.299.004c-.42-.45-1.481-.082-1.44-1.124z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4E1BB1"
        d="M585.102 155.515c.008.218.018.436.025.654-.68.58-1.488.698-2.34.636-8.516-.613-17.043-.109-25.564-.305-1.619-.038-3.41.246-4.443-1.55a3.095 3.095 0 01.035-.616c1.469-.733 3.039-.316 4.555-.327a2041.15 2041.15 0 0122.271-.007c1 .004 2.066-.315 3.006.34.652.74 1.486 1.096 2.455 1.175z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#713ED5"
        d="M582.647 154.34l-29.832-.006-.084-.681c8.91.003 17.82-.009 26.729.032 1.076.005 2.312-.452 3.187.655z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#621BE8"
        d="M552.78 154.95c1.119.725 2.379.566 3.611.567 6.404.001 12.811.033 19.213-.01 3.197-.021 6.377.04 9.523.662.174 1.231-.207 2.328-1.08 3.15 1.211 1.059 2.73.026 3.588 1.208.225.32.189.61-.1.871-2.186 1.035-4.328 1.358-6.842.855-3.428-.686-6.998-.163-10.506-.236-5.822-.122-11.695.075-17.268-1.96-.969-.353-.695.28-.859.504-.883 1.221-1.902 1.494-3.17.604-.385-1.594.441-2.973.846-4.409.211-.752.867-1.147 1.705-.626.835.046 1.196-.445 1.339-1.18z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4439DC"
        d="M551.442 156.129c-2.254.965-.764 3.798-2.504 5.02l-.367.357c-1.17.526-2.316.547-3.424-.179-.309-.471-.338-.938.023-1.398 1.836.28 3.623.667 2.701-2.378-.539-1.776 1.25-1.99 2.316-2.617.78.02 1.216.399 1.255 1.195z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F3E4F7"
        d="M588.834 327.244c-2.803-2.037-5.623-4.045-8.393-6.125-.998-.752-1.699-1.754-1.463-3.137.418-1.521 1.252-2.623 2.922-2.873.262.669.703 1.172 1.375 1.453a.699.699 0 01.166.732c-.355.689-.693 1.383-.141 2.133 1.357 1.361 2.99 2.361 4.498 3.521.785.779 1.846 1.242 2.482 2.189a.757.757 0 01-.135.771c-.437.447-.873.891-1.311 1.336z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7749CA"
        d="M592.069 318.682c.418.699-.742 2.635 1.145 2.068 3.129-.939 2.748.859 2.504 2.713-.107.801-.348 1.586-.527 2.381-.373.436-.83.457-1.326.26-.646-.578-.719-1.391-.879-2.164-1.205-1.525-2.967-2.65-3.4-4.734-.082-1.385.121-2.535 1.938-2.355.859.407.916 1.055.545 1.831z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9F8E9"
        d="M592.719 318.48l5.113-.139c.404-.223.758-.207 1.014.227 1.33 1.279.463 2.715.18 4.035-.152.721-1.072.859-1.266.039-.555-2.324-2.059-3.07-4.242-3.057-.621.005-.768-.564-.799-1.105z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7C57BF"
        d="M598.846 318.568c-.338-.076-.676-.15-1.014-.227l.053-.619c.504-.762.535-1.582.311-2.438.74-1.335 1.764-1.24 2.813-.466.686.507 1.084 1.185.779 2.137-.481 1.502-1.645 1.65-2.942 1.613z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#783BE0"
        d="M592.069 318.682c-.059-.582-.111-1.168-.701-1.504-1.15-.631-2.557-.197-3.697-.881-.396-.235-.674-.561-.77-1.023.67-.327 1.338-.652 2.004-.979 1.264.287 2.639-.884 3.828.3.258.65.275 1.301-.018 1.945-.061.611-.117 1.223-.178 1.832a2.898 2.898 0 00-.468.31z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F8FBE1"
        d="M597.6 314.668c-3.863-1.942-.029-2.558.641-3.72 1.759 1.579-.586 2.451-.641 3.72z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#723FD1"
        d="M590.147 325.91c.01-.172-.012-.34-.066-.504.014-1.742.93-2.391 2.592-2.135.697 1.209.881 2.516.754 3.885-.281.291-.58.314-.9.07l-2.38-1.316z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#593C9E"
        d="M598.196 315.284c.885.066 1.277.563 1.236 1.425-.047 1.049-.807 1.02-1.547 1.016-.563-.768-1.354-1.51-.275-2.459a.66.66 0 00.586.018z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6F4F9B"
        d="M592.526 327.227l.77-.125c.41-.273.094-.941.625-1.148.424-.037.846-.074 1.27-.109-.009 2.153-.761 2.882-2.665 1.382z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FBF9EE"
        d="M592.467 311.113c-1.365-1.031-1.477-2.569-2.219-3.705-.242-.368.244-1.358.629-1.002.893.824 2.684.313 2.906 1.915.153 1.102-.88 1.703-1.316 2.792z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7353B1"
        d="M581.901 315.109l-2.922 2.873c-.232-.266-.463-.531-.697-.795 1.387-1.708 2.773-3.415 4.158-5.125.27.246.539.492.813.74a494.54 494.54 0 00-1.352 2.307z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7F8DC"
        d="M589.143 312.856c-1.719.685-2.811.986-3.787-.072-.16-.176.035-1.04.172-1.067 1.201-.246 2.053.554 3.615 1.139z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6F4FB0"
        d="M586.901 315.273c.236.214.471.429.703.643-.176.947-.789 1.5-1.658 1.82-1.055.223-2.088.322-2.889-.629a3.15 3.15 0 00.219-.545c1.207-.429 2.416-.858 3.625-1.289z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6745A9"
        d="M592.616 314.782c-1.221-.287-2.553.282-3.709-.488.416-.273.83-.545 1.248-.817 1.17-.227 2.863-1.438 2.461 1.305z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F3EAF6"
        d="M592.616 314.782c.119-2.21-1.41-1.308-2.463-1.306.803-.96 1.973-1.026 2.646-.268.82.927.742 2.236-.084 3.33-.031-.584-.066-1.17-.099-1.756z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#621DE8"
        d="M587.631 161.152l.004-.625c.203 0 .406-.001.609-.006 1.611 2.418 1.975 5.079 1.922 7.953-.125 6.71-.033 13.424-.031 20.137-.047.796-.465 1.225-1.262 1.279-.465.344-.92.31-1.369-.029-.381-.899.303-2.714-1.959-1.934-1.27.438-2.887.38-3.297-1.343-.438-1.828.779-3.331 2.352-3.416 3.697-.201 3.576-2.506 3.449-5.095-.092-1.959.021-3.926-.078-5.893.377-3.694-.584-7.344-.34-11.028z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D7F4F7"
        d="M595.749 225.447c1.373-.362 2.732-.808 4.186-.667l-1.135 1.093c-1.038.002-2.135.438-3.051-.426z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#631AED"
        d="M587.631 161.152c1.775 3.594 1.16 7.454 1.248 11.235-.67 2.648-.258 5.343-.287 8.012-.016 1.597-.328 2.672-2.18 2.573-1.76-.095-3.959.691-4.484-2.044-.314-1.638-.186-3.312-.158-4.967.027-1.763-.58-2.706-2.508-2.702-13.48.026-26.965-.209-40.438.174-2.971.084-5.637.378-8.063-1.55-1.201-.092-2.205-.605-3.043-1.452-.879-.953-1.752-1.914-2.732-2.771-.967-1.196-2.543-1.603-3.553-2.744-1.297-.346-2.027-1.266-2.492-2.456-1.191-2.765-3.957-3.591-6.217-5.041l-.002-.001c-.566-1.049.039-1.732.928-1.727 5.059.027 10.191-.975 15.127.947.863.195 1.646.507 1.969 1.441.916 3.684 1.504 4.033 4.539 2.674a2.94 2.94 0 012.121-.053c.721.33 1.326.941 2.203.905.875.094 1.645-.294 2.449-.516 1.037-.456.139-2.396 1.814-2.362.096.764.547 1.144 1.297 1.203.006.408.012.816.016 1.224 1.252 1.117 2.496.499 3.744-.008l.008.004c2.795-.306 2.838-.355 2.955-3.332 1.467 1.987 6.184 3.289 8.664 2.41.373-.133.889-.338 1.172-.191 4.406 2.302 9.117.843 13.668 1.035 4.065.171 8.155.767 12.235.08z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#591DD7"
        d="M528.969 157.408c-1.17-.917-2.441-1.335-3.982-1.285-3.289.106-6.586.023-9.879.04-.994.005-2.162-.25-2.385 1.254a5.159 5.159 0 01-.596-.057c-1.949-2.37.609-2.292 1.533-2.325 3.779-.134 7.59-.464 11.348.171.979.166 1.787.237 2.617-.277.449.407.9.812 1.35 1.218.377.423.352.843-.006 1.261zM512.725 157.419c4.104.405 5.959 1.907 6.217 5.041-2.803-.779-4.447-2.988-6.217-5.041z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5E1FD1"
        d="M521.434 164.916c1.527.417 3.236.56 3.789 2.474-.291.374-.691.529-1.143.586a2.509 2.509 0 01-1.264-.239c-.602-.401-1.055-.92-1.27-1.627-.034-.398-.073-.796-.112-1.194z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2A1C70"
        d="M521.547 166.11c.779.021 1.164.439 1.217 1.195.332.461.307.908-.047 1.345-1.576-.166-2.338-1.343-3.117-2.5l1.947-.04z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4412AD"
        d="M452.819 465.719c.301-1.715 1.668-1.215 2.699-1.221 5.758-.039 11.516-.02 17.271-.02 1.648-1.064 3.451-.523 5.203-.512 1.123.297 2.271.246 3.412.246 20.893.012 41.783.012 62.676.002 1.141-.002 2.289.049 3.41-.252 1.789-.195 3.59-.068 5.381-.107h29.449c3.434.379 6.869-.885 10.305 0 .809.949 1.916.646 2.898.602 5.26-.248 10.449 1.064 15.713.684.439-.031.91.363 1.365.563-6.563.736-13.15.127-19.723.326-1.744-.133-3.523.301-5.242-.293l-5.018.002c-3.889.664-7.809.271-11.709.252-6.068-.027-12.15.393-18.211-.25l-79.924-.002c-6.645.494-13.291.459-19.938.018l-.017-.038z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#301985"
        d="M552.7 465.74c9.973 0 19.947 0 29.92-.002-.516.674-1.26.602-1.977.602-8.654.002-17.313.002-25.969 0-.715 0-1.461.074-1.974-.6z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#351D8C"
        d="M592.627 465.738l19.973-.035c2.271.367 4.67-.719 6.854.617-.563.037-1.123.076-1.686.115l-25.143-.129c-.205-.129-.273-.254-.205-.381.069-.124.139-.187.207-.187z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#321886"
        d="M452.838 465.756c6.646-.008 13.291-.014 19.938-.018-1.021 1.051-2.328.566-3.502.582-4.512.057-9.025.041-13.539.008-.985-.008-2.078.34-2.897-.572z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#32169A"
        d="M592.627 465.738c-.002.189-.004.381-.002.568-1.662-.191-3.441.643-4.988-.57 1.664 0 3.328 0 4.99.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#221D54"
        d="M442.829 382.092c1.234-1.668.77-3.619.471-5.322-.34-1.938-.408-3.854-.506-5.789.246-.449.662-.65 1.131-.771 2.533.504 4.033-1.73 6.154-2.328.305.023.592.113.861.264.332.336.439.748.408 1.207-.246 1.111-1.359 2.113-.43 3.383.609 2.063-.279 4.279.699 6.293.229.223.457.432.717.611 2.668.723 5.385.125 8.059.385.898.086 2.217-.023 2.264 1.102.045 1.141-1.277 1.104-2.154 1.197-1.959.215-3.928.398-5.906.334-2.197-.072-3.332.688-3.545 3.182-.393 4.652-.432 9.414-1.283 13.926-1.447 7.674-.672 15.314-1.037 22.959-.223 1.816.207 3.637.01 5.455-.088.764-.164 1.531-.326 2.287-.174.721-.107 1.438.057 2.152.33 3.902 2.457 7.627 1.16 11.715-.098.305 1.107-.059 1.217.736.332 2.787-.078 5.588.299 8.377.219 1.611-.75 2.732-2.082 3.537-1.898.164-1.732-1.127-1.9-2.43-.604-4.707-1.307-9.4-2.076-14.084-.125-.754-.232-1.676-1-2.213l.002.002-.008-1.24c-.506-1.645-1.77-3.098-1.244-4.998l-.018-1.865c-.885-1.057-.475-2.443-.916-3.615-2.131-5.418-2.516-11.053-2.098-16.789.514-7.027.822-14.068 1.488-21.084.211-2.264.139-4.59 1.532-6.576z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5114C9"
        d="M412.928 435.082c.748.473 1.121 1.135 1.172 2.035.334 5.801 1.863 11.514 1.318 17.383-.492 1.137-1.439 1.697-2.566 2.041-1.186.316-2.246.988-3.469 1.221-6.333.49-12.673.174-19.009.215-9.248.061-18.496.029-27.744.002-1.54-.004-3.143.201-4.521-.783-.174-1.945 1.355-1.08 2.066-1.088 6.655-.078 13.309-.047 19.967-.045 8.65.004 17.305-.016 25.447.008-.434.227-1.441-.045-2.41-.043-13.313.021-26.625.008-39.935.021-2.485.002-4.952.02-7.446.402-2.309.355-4.805.529-6.836-1.234-1.352-3.904-.721-7.898-.461-11.863.053-.82.516-1.58 1.557-1.592 1.666.84 1.092 2.436 1.258 3.777.295 2.377-.648 4.873.695 7.139.483.141.967.26 1.47.303 1.622.102 3.259-.096 4.86.299.611.117 1.205.313 1.838.313 15.569-.021 31.139.154 46.697-.102 1.258-.387 2.585-.334 3.866-.543.27-.105.547-.195.82-.285.998-.316 1.725-.855 1.676-2.043-.283-4.551-1.961-8.975-1.191-13.613.069-.747.241-1.444.881-1.925z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2A215B"
        d="M409.153 417.705l-.006.457c-3.11 2.025-6.542.76-9.825.973-1.842.006-3.119-1.191-4.518-2.133-1.459-1.531-3.617-2.514-3.955-4.947 1.043-1.324 2.514-1.799 4.098-2.061 4.814-.236 9.641.25 14.446-.285a3.66 3.66 0 01.959-.357c.914.15 1.152.617.656 1.416l-.027 6.291c-3.45.611-6.886.137-9.606.281 2.052.459 5-.483 7.778.365z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#611DE2"
        d="M351.714 453.842c-1.541-.186-1.236-1.377-1.248-2.354-.035-3.178-.038-6.357-.055-9.537-1.84-4.357-.664-8.443 1.127-12.477.518-.355 1.076-.387 1.662-.211 1.132.652 2.379.633 3.624.633 10.773.006 21.546.006 32.319 0 1.252 0 2.494-.006 3.576-.771.932-.424 1.926-.438 2.918-.469 4.457-.01 8.912-.023 13.368.004 1.33.01 2.732-.18 3.787.955.027 1.637.057 3.271.084 4.904-2.105.775-2.553-1.287-3.707-2.146-.645-.693-1.483-.742-2.313-.615-4.287.668-8.701-.455-12.949 1.018-1.354.467-2.887.203-4.338.203-10.174.006-20.345 0-30.518.004-4.955.002-6.076 1.029-6.333 6.131-.177 3.523-.017 7.057-.062 10.586-.018 1.441.133 2.935-.942 4.142z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5F4F4"
        d="M413.077 372.111c-.621 4.137-1.332 8.266-1.316 12.471a20.96 20.96 0 00-.381.285 1.727 1.727 0 01-.951-.008c-.961-.398-1.621-1.125-2.165-1.982-1.436-2.014-1.561-4.275-.979-6.541.445-1.74 1.245-1.07 1.901-.025-1.288-1.855-2.341-3.648-.207-5.719.736-.717.496-1.967.502-2.998.016-4.246-.029-8.49.023-12.736.016-1.434-.098-2.941 1.197-4.012a1.413 1.413 0 011.041-.152c1.992.881 2.699 2.291 2.205 4.494-.5 2.227-.174 4.533-.193 6.803-.102 1.896 1.145 3.822-.107 5.697-.119 1.045-.24 2.09-.357 3.135.195.472.041.89-.213 1.288z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#211D53"
        d="M422.862 412.053c.006-.211.01-.418.014-.627 1.297-3.006.102-6.338 1.229-9.363.523-2.719.447-5.486.65-8.23.117-1.574.549-2.723 2.475-1.756.623 3.332 1.246 6.668 1.867 10 .783 2.473.506 5.049.461 7.551-.035 1.855-.475 4.055-3.271 3.939-1.215-.049-1.244.834-1.266 1.67-.029 1.121.215 2.266-.365 3.328-.469.594-.57 1.74-1.633 1.492-.807-.189-.863-1.1-.816-1.791.141-2.077-.863-4.282.655-6.213z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#322B73"
        d="M442.829 382.092c-.807 9.453-1.609 18.908-2.422 28.365-.393 4.59.223 9.088 1.324 13.525.252 1.016.525 1.998.479 3.049-.209.217-.416.217-.627 0-1.363-3.26-2.766-6.469-2.537-10.176.201-3.309.291-6.658-.008-9.949-.703-7.748 1.338-15.307 1.285-22.994-.012-1.918 1.22-1.84 2.506-1.82z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#352979"
        d="M412.913 455.783l2.506-1.283c1.094-.156 1.213-.939 1.203-1.832-.016-1.451.047-2.906-.014-4.354-.094-2.301-.219-4.551 3.217-4.072.133.02.359-.641.541-.986.449-.369.918-.352 1.4-.063.572.678.621 1.521.738 2.344.936 2.541-.068 5.287.82 7.836.143.395-.023-.109.113.285 1.529 4.441 1.027 5.012-4.037 4.588a2.803 2.803 0 01-1.184-.67c-1.541-2.246-3.639.08-5.367-.643-.276-.4-.347-.787.064-1.15z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#332B76"
        d="M421.616 443.256h-1.25c-.006-3.215.779-6.697-.197-9.582-1.563-4.617-.701-9.166-1.041-13.727-.143-1.928.406-3.822.049-5.807-.465-2.586 1.613-2.014 3.076-2.082.236 4.439.104 8.885.215 13.326.117 4.678.049 9.361.008 14.041-.013 1.323.245 2.741-.86 3.831z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#251E5A"
        d="M424.108 418.293c.666-1.098-.1-2.191-.023-3.299.121-1.77-.295-3.902 2.707-2.23 1.135.635 1.291-.625 1.564-1.271 1.291-3.047.564-6.27.74-9.416 1.566 4.951 1.332 10.146 2.021 15.217.014.09-.488.25-.752.377-2.115-.707-3.904.83-5.914.873a16.718 16.718 0 00-.343-.251z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E7E7EE"
        d="M398.55 418.332c3.531-.055 7.063-.113 10.597-.17 1.215.053 2.328.209 1.996 1.895.18.814.389 1.631-.414 2.277-3.245 2.611-11.075.041-12.179-4.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#251E5A"
        d="M421.616 443.256c.217-10.398-.559-20.818.637-31.197.205 0 .404-.002.609-.006v7.818l1.246-1.578c1.531 1.809-.857 3.422-.248 5.188-.143 1.049-.043 2.098-.004 3.152-.746 5.057-.402 10.141-.363 15.217-.693 1.256.209 3.277-1.844 3.887l-.033-2.481z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C2AFEA"
        d="M398.55 418.332c2.811 3.521 7.459 4.965 11.474 3.688 1.123-.357.842-1.262 1.119-1.965.551.74.35 1.613.43 2.434-1.211 1.635-3.02.561-4.489 1.053.279.869 2.075 1.021 1.304 2.494-.845.555-1.749.516-2.673.289-2.24-1.131-4.266-2.889-7.063-2.404a3.022 3.022 0 01-.805-.32c-.719-1.502-.648-3.375-2.906-4.063-.92-.277-.201-2.154-.109-3.305l3.718 2.099z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3D1A99"
        d="M427.864 428.285c2.078 0 4.154.002 6.232.004.4.473.357.949.016 1.432-.42.33-.904.5-1.424.574-.924.113-1.859.039-2.787.135-.803.082-1.41.414-1.436 1.309-.154 5.051-.877 10.102-.006 15.158.092.344.143.689.18 1.043.055 2.201.455 4.426-.469 6.557-.563.539-1.104 1.229-1.916.33-.697-1.246-.508-2.617-.512-3.947-.023-6.104-.008-12.205-.014-18.305 0-1.461-.002-2.912 1.055-4.098.315-.321.675-.385 1.081-.192z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#221F4D"
        d="M423.481 423.287c-1.471-1.877 1.391-3.207.627-4.994 1.545-1.563 3.77-.994 5.59-1.754 1.008-.42.439.736.668 1.131-.014.166-.02.332-.016.498a.96.96 0 01-.719.402c-1.328.082-3.498-.822-2.391 2.064 1.199 1.902 3.311.883 4.9 1.529.254.143.477.324.67.543-.346.609-.34 1.215.023 1.816-1.334 1.006-2.834.348-4.264.441-.732-.148-1.443-.371-2.168-.563-.971-.373-2.141-.234-2.92-1.113z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C2A7FA"
        d="M405.386 425.781l3.188-.029c1.063-.645 1.732-.16 2.254.771.494.396.99.789 1.484 1.184.119.432-.02.748-.42.951-5.19.359-10.378.467-15.565-.047-.998-1.895.637-1.996 1.684-2.271 1.283-.34 2.648-.125 3.973-.197 1.146.015 2.205-.836 3.402-.362z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#352979"
        d="M417.844 437.133c.002 1.133.018 2.268-.004 3.4-.014.813-.318 1.41-1.264 1.381-.742-.023-1.154-.457-1.162-1.16a437.133 437.133 0 01-.012-7.422c.006-.701.357-1.164 1.105-1.217.922-.064 1.313.465 1.33 1.307.025 1.238.007 2.474.007 3.711z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EDEDF4"
        d="M432.032 422.555c-1.834-.684-4.629 1.621-5.578-1.799-.793-3.211 1.176-2.967 3.248-2.594l.648.006 1.193.162c.827 1.332 1.512 2.682.489 4.225z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8A129"
        d="M413.647 367.688c-.234-1.809-.471-3.617-.703-5.424.59-2.1-.086-4.328.646-6.414.658-.807.131-2.504 1.875-2.498.881 1.039 1.014 2.41.664 3.502-1.109 3.455.049 6.629.816 9.875-.289.926-1.104 1.084-1.887 1.293a1.3 1.3 0 01-.914-.205 1.579 1.579 0 00-.497-.129z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#45255E"
        d="M414.145 367.816l.594-.209c4.426-.318 8.715.783 13.07 1.238.564.096 1.072.303 1.461.74.227.582.188 1.111-.311 1.547-2.051.451-4.094.758-6.076-.277-2.533-.375-4.881-1.686-7.576-1.316-1.105.152-1.162-.877-1.162-1.723z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2E1776"
        d="M449.065 456.982c2.424-3.939.797-8.275 1.217-12.41-.611-.834-.697-1.686-.082-2.557 2.441 1.117 1.789 3.092 1.387 4.996.217 1.623-.557 3.369.605 4.875.117-.059.234-.115.354-.174a.94.94 0 01.576.484c.104.408.033.768-.303 1.049-.018.404-.037.809-.053 1.211-.984.68-.809 2.463-2.422 2.537l-1.279-.011z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#211B60"
        d="M427.229 392.076c-1.795-.154-1.754 1.014-1.918 2.338-.32 2.557-.186 5.199-1.207 7.648 0-3.328.002-6.656.004-9.982a6.787 6.787 0 01-.086-3.576c.234-.963.469-2.105 1.955-1.414.418 1.662.836 3.324 1.252 4.986z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2A2258"
        d="M410.829 426.523c-.752-.256-1.502-.514-2.254-.771-1.142-.865-2.28-1.729-3.882-2.941l6.88-.322c-.065 1.38 1.51 3.062-.744 4.034z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#621CE4"
        d="M410.379 432.021c.342 1.322 1.174 2.156 2.498 2.498.041.188.057.375.051.563l-.1 1.947c-2.689.922-5.401-.631-5.581-3.215-.066-.967.131-1.848 1.059-2.393.902-.525 1.558-.204 2.073.6z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#382683"
        d="M444.088 438.256c.426 2.998-2.012 5.365-1.732 8.381-1.152-2.867-1.018-5.834-.584-8.617.285-1.828 1.43.822 2.318.238l-.002-.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2A2261"
        d="M428.479 424.525c1.449-.75 2.902-.035 4.355-.002.363 2.355-.459 3.543-3.01 3.148-.699-.109-1.461-.082-1.961.613-.207.012-.414.021-.621.025-.355-.287-.473-.672-.469-1.109.649-.837.12-2.43 1.706-2.675z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DDA360"
        d="M437.534 370.844h-.012c-1.623-.518-3.275-.426-4.904-.119-1.166.221-2.256.457-3.033-.75.07-.389.283-.668.635-.842 1.559-.635 3.191-.309 4.795-.377 3.893.686 7.574-1.119 11.426-.984.34.107.627.291.865.555-.158 2.373-2.168 1.773-3.535 2.207-2.079.157-4.187-.331-6.237.31z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2F286E"
        d="M425.977 387.09c-1.348.135-1.193 1.15-1.258 2.08-.068.994.361 2.105-.611 2.91-1.621-1.52-1.711-5.346-.053-6.35 1.447-.88 1.721.274 1.922 1.36z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3F3160"
        d="M422.883 370.855c2.092-.01 4.186-.018 6.279-.027 1.252-.396 2.492-.529 3.715.107-2.006 2.455-4.703.717-7.049 1.102-1.005.166-2.589.721-2.945-1.182z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3F1399"
        d="M412.155 428.197c.082-.152.137-.316.158-.49.709.498.537 1.217.48 1.908l-17.403-.117c-.172-.424-.041-.717.389-.873 4.463-.057 8.926.018 13.388-.045.994-.014 2.076.389 2.988-.383z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4A2325"
        d="M411.008 410.768l-.354-1.223c-.621-.168-.813-.676-.977-1.209-.271-1.938-.113-3.889-.135-5.834.018-.682.09-1.355.398-1.979a.956.956 0 01.76-.523c1.025.352.309 1.439.838 2-.184 2.924.824 5.92-.53 8.768z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#251E5A"
        d="M424.104 402.063c.002 2.156-.006 4.314.008 6.471.01 1.154.047 2.299-1.236 2.893.103-3.163-.536-6.421 1.228-9.364z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#342973"
        d="M442.838 432.02c.885 1.549 1.279 3.219 1.244 4.998-3.109-2.709-3.232-3.207-1.244-4.998z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3E2495"
        d="M434.081 429.553c.008-.422.012-.842.016-1.264 1.852.338 1.129 1.822 1.236 2.887.109 1.09.051 2.195.066 3.293l-.119.094c-1.559-.209-1.654-1.475-1.91-2.629-.08-.887.097-1.702.711-2.381z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#221F45"
        d="M409.153 417.705h-8.616a67.998 67.998 0 00-.01-.646h10.458c-.426.74-1.168.584-1.832.646z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3A238A"
        d="M439.106 457.006c-.004-1.674-.004-3.348-.008-5.021 1.988 1.671 1.996 3.343.008 5.021z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5C3924"
        d="M432.877 370.936c-1.24-.033-2.479-.07-3.715-.107l-.029-1.064c.145-.25.346-.305.6-.164 2.459 1.26 5.309.076 7.785 1.244-1.545.028-3.092.061-4.641.091z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4C2650"
        d="M411.76 384.582c1.777 1.248 1.77 2.508.018 3.773a22.485 22.485 0 00-.408-.277c-.594-1.109-.664-2.199.133-3.252a.317.317 0 01.257-.244z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#63320C"
        d="M411.778 388.355c-.07 2.281-.143 4.563-.215 6.844-.402.168-.713.066-.938-.307-.336-2.295-1.502-4.701.877-6.635l.276.098z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#49240B"
        d="M411.045 395.191c.174.002.346.004.518.008l-.021 6.803c-.682-.51-.477-1.291-.605-1.969-1.069-1.64-1.138-3.258.108-4.842z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3E3A5E"
        d="M432.032 422.555c.457-1.48-.307-2.818-.488-4.225 2.391.889.912 2.898 1.268 4.377-.263-.051-.52-.1-.78-.152z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#342973"
        d="M441.583 427.031h.627c1.037.877.48 2.068.611 3.123-1.985-.42-.971-2.025-1.238-3.123z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5C3924"
        d="M437.534 370.844c2.115-.793 4.354-.482 6.529-.734.365.246.361.486-.014.719-.416.053-.836.102-1.254.152l-5.261-.137z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#393F63"
        d="M413.077 372.111c-.088-.457-.18-.914.213-1.289.631.158 1.793-.27 1.686.758-.085.801-1.216.447-1.899.531z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1A1840"
        d="M418.483 456.994c.209.215.418.424.629.639 1.176.615 2.453.363 3.646.25 3.012-.287 3.617.162 3.688 3.205a3.527 3.527 0 01-.439 1.783c-1.428 1.029-1.662 2.6-1.865 4.186-.129.855-1.137.498-1.475 1.064-1.941 1.207-4.063.494-6.109.584-1.797.604-3.16 1.912-4.734 2.881-3.948 2.428-8.04 2.324-11.421-.279 1.805-1.844-1.361-2.602-.912-4.148.127-.25.316-.443.563-.58.824-.34 1.805-.289 2.508-.965a3.29 3.29 0 01.674-.373c.727-.227 1.436-.486 1.977-1.063.92-.727 1.652-1.65 2.535-2.418a3.284 3.284 0 011.101-.424c.504-.111 1.012-.203 1.482-.424 1.031-.893 1.434-2.307 2.578-3.104 1.732-1.115 3.416-2.593 5.574-.814z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B7DAF3"
        d="M364.267 470.73c-.064-1.211-.002-2.477-1.389-3.096.156-1.469 1.358-1.469 2.334-1.471 10.996-.01 21.992-.313 32.984.139 1.836.881 1.049 2.422.943 3.793-2.191.824-4.371 1.215-6.477-.227-.75-.51-1.594-.383-2.414-.393-1.66-.018-3.332.117-4.982-.027-6.406-.561-12.65.795-18.945 1.541-.774.091-1.4.091-2.054-.259z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#17223E"
        d="M399.14 470.096c-.986-1.141-.451-2.113.332-3.061.1.078.199.158.297.236.182.355.275.832.563 1.039.715.512 2.314-.488 2.318 1.209.006 1.373-1.713.906-2.248 1.789l-1.262-1.212z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C2D5F6"
        d="M416.557 468.705c1.938-1.229 4.039-.748 6.109-.584 1.826.197.385.861.191 1.35h-.623c-1.041.961-2.078-1.018-3.117 0-.908-.078-1.947.289-2.56-.766z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B5D5F0"
        d="M419.118 469.471c1.039-1.346 2.076.15 3.117 0-1.041 1.349-2.078-.155-3.117 0z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1F1556"
        d="M424.141 467.057c-1.039-1.732-1.32-3.227 1.203-3.844.352.42.391.85.047 1.293a3.695 3.695 0 01-.643 2.334c-.201.072-.404.142-.607.217z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#611AE8"
        d="M434.112 432.008c.139.969.42 1.869 1.17 2.555-.393 4.23 2.109 8.16 1.287 12.434-1.564 1.174-3.217 1.033-4.906.336-1.096-1.199-1.826-2.734-3.34-3.566-.564-.309-.873-.881-.625-1.572.996-2.785.334-5.707.719-8.559.465-3.436.291-3.459 3.891-3.381.976.198 1.175 1.196 1.804 1.753z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5317CA"
        d="M427.831 454.48l.033-6.855c1.037-.848 2.156-.977 3.357-.408 1.715.969.75 2.576.988 3.621-.121-1.896 2.102-2.119 3.123-3.385.449-.139.883-.188 1.262.176 2.006 1.543 1.043 3.746 1.229 5.678.117 1.211.006 2.445-.002 3.67-1.258.998-2.729.621-4.135.617-1.021-.002-2.043-.127-3.064.049-1.002.172-1.965 1.609-3.004.279-.869-1.119-.463-2.328.213-3.442z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4810B2"
        d="M427.831 454.48c.135 1.111-.23 2.275.383 3.436 2.955-2.996 6.428-.289 9.607-.939l-.02 1.229c-2.502-.004-3.727 1.465-3.336 3.719.324 1.848-1.516 2.361-1.641 3.777-1.652.004-3.305.006-4.957.012-1.633-1.848-.133-4.537-1.736-6.395-.076-1.426-.814-2.934.514-4.184.395-.219.789-.438 1.186-.655z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#490BC6"
        d="M431.6 447.633c-1.246-.004-2.49-.006-3.736-.008a8.78 8.78 0 01-.002-.607c1.238-1.096 2.486-.938 3.738-.027l4.971.006.023.633c-.418.002-.838.004-1.258.008-1.246.969-2.492.96-3.736-.005z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#291861"
        d="M426.645 455.135l-.01 4.336c.838 1.807 1.086 3.537-.662 5.004a8.725 8.725 0 00-.582.031c-.014-.43-.031-.859-.047-1.293-.031-.891.469-1.652.33-2.654-.279-2.006-.723-3.092-3.117-2.404-1.033.297-2.439.541-3.445-.523 1.668-.191 3.469.459 5.199-.922-1.908-.619-1.391-2.135-1.461-3.451l.402-.141c1.264.418 1.307-.355 1.299-1.281-.027-3.385.014-6.77-.047-10.156-.25-3.043.566-6.148-.547-9.131-.758-1.439-.059-2.611.689-3.771.354-.576.855-1.021 1.328-1.49a2.64 2.64 0 01.602-.461.57.57 0 01.652.201l.014 1.283c-1.08 3-.604 6.119-.635 9.188-.058 5.877.018 11.756.038 17.635z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3D1A99"
        d="M425.973 464.475c.543-1.627.709-3.303.662-5.004 2.549 1.66.578 4.209 1.232 6.242-.923.031-1.534-.414-1.894-1.238z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#051235"
        d="M359.806 473.779c-1.445.541-2.887.4-4.327-.031 1.45-1.045 2.893-1.088 4.327.031z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#332A78"
        d="M322.944 461.297c-2.528.408-4.952-.4-7.423-.646-.989-1.033-.856-2.191-.395-3.391 1.877-1.75 2.148-4.033 2.106-6.42.03-.477.112-.945.229-1.404.624-1.977 1.066-3.986 1.051-6.076.066-.508.225-.975.52-1.395.242-.24.529-.41.85-.52.631-.189 1.275-.207 1.921-.107.58-.131 1.797 1.518 1.651-.645-.137-2.047.184-4.121-.688-6.107-.62-1.414-.386-2.611 1.286-3.225 2.232-.824 3.313-2.57 3.703-4.834.258-1.516.988-2.475 2.712-2.18.751.58.751 1.596 1.339 2.268 1.59 1.553 3.847.338 5.564 1.346.55.451.949.957.605 1.723-.4.346-.875.52-1.389.605-1.621.195-3.252.049-4.873.094-1.662-.174-1.684.963-1.675 2.125-.556 2.301-1.315 4.555-1.613 6.914-1.17 1.539-.776 3.344-.847 5.066-.009.809-.073 1.609-.379 2.369-.839 1.15-.85 2.586-1.318 3.865-.877 2.709-1.867 5.391-1.934 8.291.07.607-.027 1.182-.34 1.713a1.681 1.681 0 01-.663.571z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#301985"
        d="M315.525 456.973c-.002 1.227-.004 2.453-.004 3.678-1.76 1.598-1.104 3.734-1.269 5.688-12.646 0-25.293.012-37.94-.014-1.089-.004-2.304.412-3.234-.584 1.173-1.197 2.698-.871 4.105-.875 10.232-.035 20.465-.006 30.698-.027 1.225-.004 2.49.217 3.639-.402 1.243-2.508.839-5.264 1.191-7.904.864-.969 1.7-.516 2.534.049l.28.391z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#191B37"
        d="M322.944 461.297c.019-.195.04-.389.062-.584 1.732-.998 2.927-.426 3.733 1.279v6.014c-2.109-.666-2.661-1.857-2.476-3.441.16-1.364-.282-2.42-1.319-3.268z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#43149B"
        d="M329.871 465.707c-.217.014-.432.025-.648.037-1.641-.828-.916-2.469-1.283-3.734-.706-.84-2.409-1.371-.886-2.895 1.837-.545 2.766.32 2.96 2.049.171 1.508.496 3.051-.143 4.543z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#231261"
        d="M326.691 459.516c-.045 1.063 1.414 1.371 1.248 2.494-.4-.008-.801-.012-1.2-.018-1.269-.357-2.183-1.748-3.733-1.279.208-.412.413-.826.621-1.238.641-.693 1.438-.711 2.279-.529.324.105.584.298.785.57z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#332A79"
        d="M351.763 429.627c-.787 4.072-1.649 8.137-1.352 12.324-1.459.297-1.175 1.461-1.177 2.439-.009 3.574.015 7.152.028 10.727.508.658 1.097 1.262 1.456 2.029.128.428.095.832-.169 1.205-1.621.729-3.822-1.178-5.102 1.119-2.291.787-4.307.129-6.193-1.186-.045-.881.045-1.854-1.25-1.924a1.406 1.406 0 01-.461-.85c-.016-.504.113-.943.558-1.24 2.223.33 3.034-.637 2.833-2.846-.145-1.6-.093-3.232.275-4.83.355-8.385 1.238-16.715.523-25.164-.865-10.283-3.005-20.451-2.887-30.855-1.539 3.537-2.066 7.287-2.502 11.053-.225 1.961-.361 3.93-1.414 5.676-1.612 1.428-.969 3.352-1.092 5.096-.08 1.102.014 2.211-.071 3.313a5.156 5.156 0 01-.158.918c-.353.988-.505 2.027-.7 3.057a3.767 3.767 0 01-.346.838c-.643.826-1.092 1.912-2.428 1.791a1.105 1.105 0 01-.621-.605c-.541-2.145-.229-3.887.785-6.098 1.527-3.328.811-7.326.327-11.016-.22-1.674-2.133-1.629-3.36-2.408.464 2.535.295 5.006.248 7.467-.02.992.094 2.135-1.121 2.672-2.379-.551-1.547-2.537-1.791-4.029-.333-2.049.788-4.373-1.178-6.111-1.002-1.611-.379-3.551-1.074-5.223-.242-1.598-.458-3.191.289-4.723 2.92-1.486 6.037-1 9.1-.791 1.729.117 1.894 1.559 1.889 2.432-.288-1.99-.293-4.453 1.008-6.748.255-.449.377-1.008.785-1.332 1.314-1.037 2.769-2.279 4.476-1.521 1.917.848 1.461 2.738 1.1 4.377-.097.436-.104.91-.396 1.404.436-.322.164-1.17.807-1.066.727.117.955.822.937 1.438-.085 2.572.288 5.176-.216 6.998-.238-4.471 1.67-9.465 1.254-14.691a9.157 9.157 0 01.141-2.486c.209-1.074.611-2.07 1.876-2.158 1.119-.076 1.581.799 1.985 1.682 1.067 2.318 1.588 4.535.604 7.176-1.23 3.309 1.001 6.693.372 9.338-.048-1.445-.325-3.6.886-5.742.93-1.65.57-3.631.141-5.496-.956-4.156-1.409-8.381-1.523-12.926-5.249 1.813-10.616.1-15.92.738-2.334.283-3.141-1.088-3.159-3.184a1.77 1.77 0 01.413-.91c.58-.438 1.258-.557 1.953-.623 1.529-.051 3.061-.061 4.59.043 1.473.07 2.639 1.123 4.091 1.262 3.312 1.619 5.36-1.301 7.971-2.223 2.219-.145 3.245 1.102 3.637 3.102 1.078 7.734 2.724 15.408 2.429 23.283-.063 7.662-.028 15.32-.01 22.975.183 3.289-.139 6.543-.804 9.766-.185.83-.46 1.637-.745 2.438-.17.282-.352.559-.547.829z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#341A95"
        d="M399.769 467.271a.787.787 0 01-.297-.236c-11.701-.053-23.404-.107-35.104-.152-.604-.002-1.277-.059-1.489.752-1.389-.324-2.668-.865-3.688-1.902 1.133-1.168 2.656-.715 4.011-.98 10.996-.033 21.989.271 32.987-.012 1.338-.031 2.707-.078 3.947.619.598.451.654.996.277 1.613-.214.099-.427.201-.644.298z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#41149F"
        d="M362.949 465.715c-1.253.006-2.504.01-3.758.018-1-.078-1.84-.482-2.521-1.219-1.193-.896-2.496-1.637-3.653-2.584a8.175 8.175 0 01-.125-.57c-.252-1.158-2.209-1.707-1.182-3.322 1.758-.949 3.086-.084 3.863 1.313 1.359 2.449 2.988 4.316 5.953 4.707.734.096 1.581.565 1.423 1.657z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#211255"
        d="M351.656 458.266c.102 1.154 1.746 1.693 1.239 3.094-2.309-1.322-4.689-2.344-7.446-1.889.644-4.447 3.285-1.098 5.018-1.287.421-.325.818-.272 1.189.082z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2E156F"
        d="M353.017 461.93c1.85-.033 2.838 1.154 3.653 2.584-1.745-.116-3.133-.739-3.653-2.584z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4512AB"
        d="M326.691 459.516c-.191-.002-.385-.01-.577-.023-.444-.371-.983-.66-1.132-1.293-.184-.75-.171-1.49.133-2.217.16-.271.39-.461.681-.578.468-.1.911-.025 1.335.186 1.812.971 3.739.715 5.598.334 1.019-.209 1.766-.424 2.107.811-.021 2.355.661 4.637.731 6.996.036 1.172-.318 1.684-1.315 1.971l-4.381.006c-.785-1.201-.717-2.566-.605-3.881.166-2-.795-2.568-2.575-2.312z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4311B9"
        d="M334.251 465.701c.76-1.367.32-2.781.197-4.195-.135-1.502-.146-3.014-.21-4.521a13.801 13.801 0 012.44-2.016c.681-.148.965.342 1.275.791.011.201.027.402.051.602l-.047 3.096c-.873 1.061-.834 2.127-.02 3.195-.199 2.259-1.123 3.644-3.686 3.048z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3C1894"
        d="M337.939 462.652c-1.877-1.074-1.936-2.141.02-3.195l-.02 3.195z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FCFDFB"
        d="M133.271 320.93c4.484.453 6.909 2.988 6.061 6.98-.176.834-.702 4.352-3.542 2.352-.995-.703-1.493.619-2.532.084-2.437-1.254-3.453-4.717-1.768-6.986.597-.805 1.701-1.24 1.777-2.426l.004-.004z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E5F3F7"
        d="M135.126 417.68c-2.374-5.166-1.262-9.697 2.494-13.75-.061 1.723-1.101 3.072-1.906 4.439-1.806 3.061-.666 6.194-.588 9.311zM140.135 424.521c-.002.205-.003.41-.002.615-.85-.387-1.466-1.014-1.886-1.842.911-.024 1.52.417 1.888 1.227zM138.274 402.086l1.209-.053c-.362.887-1.005 1.494-1.862 1.895l.653-1.842z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5A42CA"
        d="M155.702 427.012l.03 19.977c-.228.156-.451.156-.666-.025l.131-19.965c.168.017.336.021.505.013z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4D10C3"
        d="M155.066 446.963l.666.025c2.498-1.137.671-3.367 1.262-4.984.282-.186.551-.156.809.049.604.799.57 1.768.637 2.688.077 1.072.634 1.449 1.635 1.361.875-.029 1.743.055 2.616-.043 24.022-.16 48.04-.039 72.057-.068a19228.9 19228.9 0 0148.036.008c1.65.002 3.34-.197 4.905.588.404.248.523.596.36 1.041-1.656.273-3.459-.625-4.995.623-1.692 1.465-3.756.986-5.679.986-36.078.031-72.157.039-108.235-.012-2.554-.004-4.756.244-5.944 2.844-1.255.549-1.661-.299-1.911-1.25-.325-1.234-1.028-1.385-2.056-.852-1.928.408-3.345-.584-4.711-1.711l-.064-1.021.612-.272z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FB3846"
        d="M234.372 153.663c-1.664 1.882.228 1.968 1.257 2.49 1.063-.713 2.12-.876 3.16.044l-.748 1.168c-.364.363-.754.43-1.179.107l-7.473 3.081c-1.834-3.747-1.294-7.85 1.233-9.373 2.518-1.086 2.336 1.903 3.75 2.483z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FC3552"
        d="M230.622 151.182c-1.96 1.438-1.086 3.538-1.222 5.384-.096 1.322-.014 2.658-.011 3.988l.024 4.281c.355.428.338.875.063 1.333-2.438-.172-1.743-2.777-3.007-3.863-1.031-2.535.051-4.958.396-7.422-.414-1.521.902-2.401 1.34-3.606l1.186-.118 1.231.023z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6394C"
        d="M226.866 154.883c.745 2.506-.429 5.017.019 7.523 1.49 3.321 2.551 6.72 2.108 10.443-.135 1.132-.081 2.293.663 3.284.184.492.204.993.091 1.503-.645 1.354-1.057 3.683-2.631 3.308-1.519-.363-2.192-2.546-2.273-4.38-.112-2.571-.008-5.145-.06-7.716-.021-1.11.179-2.31-.956-3.085-.466-.281-.869-.622-1.125-1.113-.462-1.634-.82-3.259.486-4.708 2.049-1.075.811-3.742 2.433-5.023.414-.013.829-.025 1.245-.036z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4E1BAD"
        d="M173.228 154.333l50.964-.053c-.033.707-.52.995-1.103 1.194-.959-.947-2.17-.534-3.265-.536-14.447-.03-28.895-.013-43.343-.041-1.094-.002-2.309.412-3.253-.564z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#8630D1"
        d="M223.187 159.94l.031 4.892c.854 1.277.972 2.565.062 3.87-2.166.488-2.012-1.147-2.234-2.438.094-2.808-.301-5.635.286-8.429.229-.565.624-.946 1.225-1.097 1.018.908.284 2.161.63 3.202z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7230E6"
        d="M222.556 156.737l-.662.68c-.354.348-.769.389-1.222.243-.679-.548-1.513-1.003-1.276-2.107l3.668-.005-.508 1.189z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4809AD"
        d="M157.601 442.012c-.203 0-.405-.002-.607-.008l.017-83.627h.574c1.125 1.076.887 2.492.889 3.814.023 25.332.023 50.664 0 75.998-.002 1.321.234 2.737-.873 3.823z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F73645"
        d="M229.377 177.384l.001-1.254c-.99-3.326-.977-6.653-.009-9.98l.044-1.313c.193.036.387.057.583.063.119.121.238.241.36.361.585 1.262.527 2.666.874 3.983.617 3.764.041 7.622.927 11.364-.064 5.454.605 10.955-1.045 16.304-2.232.52-3.57-.409-3.543-2.496.012-.943.435-1.803.646-2.707.352-1.498.814-2.765-.783-4.181-1.33-1.179-1.888-3.21-.841-5.144 2.318-.89 2.019-3.242 2.786-5z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F0020A"
        d="M231.245 180.521c-.894-3.909-.533-7.885-.64-11.836-.73-1.175.202-2.616-.602-3.78l-.006-.006c.005-1.391.048-2.773 1.046-4.609 1.51 3.187.453 6.079.946 8.966 1.104-.206 1.031-2.022 2.337-1.85 1.103.97.809 2.295.901 3.521.004.841-.004 1.685-.006 2.526-.001.925-.014 1.853-.032 2.781-.074 3.798-.091 3.813-3.944 4.287z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DD062B"
        d="M241.274 159.909l-.631 1.133c-.204.413-.573.593-.987.709-.917.166-1.871.219-2.624.884a2.859 2.859 0 01-1.197.346 2.2 2.2 0 01-1.228-.301l-.269-.335c1.337-3.589 4.431-2.175 6.936-2.436z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BD1449"
        d="M234.494 171.151l-.167-3.746.005-1.243c-.56-.746-.688-1.528-.198-2.362 1.146-.638 1.421.358 1.889 1 .2.468.309.959.359 1.463a26.519 26.519 0 01-.011 3.464c-.061.506-.219.976-.525 1.388-.442.345-.892.395-1.352.036z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F40207"
        d="M236.862 157.473l1.18-.107c1.099.258 2.453-.428 3.728 1.239-1.973-.437-3.812 1.354-4.908-1.132z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F03C5E"
        d="M238.789 156.197l-3.16-.044c1.217-1.935 2.459-1.888 3.727-.05a2.287 2.287 0 01-.567.094z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E00436"
        d="M234.421 163.612l-.09 2.55c-1.863-1.276-1.845-2.549.007-3.818l.146.178c.265.38.269.744-.063 1.09z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F63855"
        d="M255.59 139.936l1.28-.031 6.218.11-1.85 1.177c-.353.839-1.963-.239-1.894 1.243v-.001l-3.75.001c0-.833-.002-1.666-.004-2.499z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7335E5"
        d="M157.601 442.012l-.016-83.635c.013-61.201.019-122.4.053-183.599.002-4.134-.375-8.298.596-12.39 1.75-3.113 3.73-5.966 7.55-6.768 2.48.658 5.058-.201 7.535.49.483 1.479-.56 1.793-1.605 2.032-1.115.255-2.269.254-3.396.167-2.534-.194-4.524.314-4.876 3.304-.91 1.206-.574 2.608-.574 3.929-.007 76.642-.02 153.283-.004 229.926.011.611.017 1.223.002 1.838-.034 13.41.007 26.82-.024 40.232-.003 1.438.231 2.924-.547 4.271-.464.559-1.031.58-1.651.313-1.599-3.223-.434-6.668-.806-9.99-.079-1.781.071-3.563-.026-5.344-.269-14.795.028-29.588.021-44.381-.103-1.203-.081-2.41-.022-3.617-.123-7.232-.148-14.463.004-21.695.07-62.934.007-125.868.003-188.802 0-.671.501-1.562-.491-1.986-.353 1.37-.207 2.728-.207 4.071-.01 61.393-.027 122.784.016 184.178.005 7.994.202 15.99.014 23.984-.005 1.186.118 2.373-.021 3.557-.064 3.273-.021 6.547-.02 9.822.008.584.007 1.168.006 1.754.252 14.342.033 28.68.001 43.02-.003 1.449-.173 2.916.292 4.33.208.324.377.67.521 1.027.461 1.684.767 3.357-.445 4.893-1.231.148-1.898-.303-1.855-1.637.036-1.097-.015-2.197-.028-3.294z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7433EF"
        d="M163.219 161.149c-.475-2.875.566-4.199 3.626-3.775 1.409.194 2.868.029 4.304.034.948.003 1.912.047 2.059-1.256-.218-.128-.291-.257-.222-.389.071-.132.142-.198.213-.198l46.196-.011c.404.632 1.349.9 1.258 1.866 1.245 2.64.329 5.442.61 8.152-.634 2.827 1.524 4.795 2.231 7.215 0 .622-.241 1.096-.825 1.368-3.273.551-6.539 1.024-9.882 1.009-12.369-.059-24.738-.018-37.107-.03-1.45-.001-2.955.215-4.325-.348-2.301-.946-3.066.424-3.407 2.224-.269 1.423-.099 2.903-.099 4.358-.002 79.724 0 159.446-.011 239.167 0 1.867.191 3.744-.247 5.578-.271.453-.45 1.123-1.213.756-.171-.084-.056-.125-.126.162-.098.393.028-.188.282.158.857.736 1.271 1.777 1.921 2.641.145.219.278.447.411.668.933 1.195 1.553-.164 2.333-.299.326-.125.651-.197.996-.234 23.388-.145 46.766.008 70.142-.137 2.22-.012 4.046 1.791 6.294.922 1.519-.996 2.775.557 4.196.438 1.662-1.367 3.335-2.719 5.594-1.107 1.208 1.85 3.658.521 5.03 1.957.87 1.217 2.098 1.572 3.53 1.576 8.094.023 16.189-.082 24.283.053 2.685.045 4.05-2.381 6.313-3.061.642-.338 1.298-.414 1.975-.111 1.078 1.205.045 2.127-.413 3.133-1.219 1.736-2.473 3.451-3.551 5.289-.807 1.379-1.865 2.406-3.645 2.264-36.036.646-72.067.645-108.1.592-5.401-.008-10.802.014-16.203-.01-1.445-.006-2.923.115-4.258-.646-1.559-2.689-.493-5.609-.719-8.412 1.259-2.227 1.255-4.459.012-6.697-.044-1.492-.277-2.994.275-4.449.791-1.225.625-2.605.625-3.947.01-77.789.012-155.579.001-233.369 0-1.342.143-2.721-.657-3.932-.748-5.496-.256-11.018-.288-16.53-.006-1.029.522-1.735 1.376-2.225 1.018-1.322 2.541-.912 3.702-1.068-.967.261-2.328-.377-3.31.72-.407.318-.8.261-1.18-.059z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7538FB"
        d="M173.2 155.565c.005.196.007.391.008.587-2.468-.27-5.018.595-7.424-.533 2.473-.017 4.945-.036 7.416-.054z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5629C6"
        d="M110.16 222.337c-.619.404-.858 1.375-1.84 1.238l-.029-2.485c.919-.027 1.829-.042 1.869 1.247z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7050C0"
        d="M252.407 92.501c.469-.735 1.035-1.316 1.998-1.277-.124 1.273-1.018 1.341-1.998 1.277z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FCDBA9"
        d="M269.32 85.004c-2.077.385-3.984 1.599-6.207 1.27-.954.221-1.403-1.443-2.504-.67l-.015-1.841 1.241-.005c1.539.456 3.846 3.228 3.748-1.245l5.624.012c.406 1.614-1.082 1.787-1.887 2.479z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F4C186"
        d="M269.32 85.005l1.886-2.48h-.001c.659-.637 1.72-.539 2.328-1.27.196-.799.1-1.813 1.344-1.851l.023 1.228c.553.872.13 1.723-.048 2.583a2.015 2.015 0 01-.513.737c-.454.195-.877.172-1.254-.175-1.293.29-2.213 1.727-3.765 1.228z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FCDBA9"
        d="M273.534 81.255c-.313 1.274-1.333 1.25-2.328 1.27.418-1.081 1.297-1.315 2.328-1.27z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2A213F"
        d="M276.157 80.553c1.084-.849 2.082-1.773 2.672-3.054.479-.979-.188-2.13.468-3.081.32.253.928.523.914.756-.151 2.597-.371 5.196-2.142 7.326-.874-.417-2.106-.481-1.912-1.947z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2C1868"
        d="M276.157 80.553c.348.933 2.017.568 1.912 1.947l-.04 1.327-2.421-.262c-.948-.929-.619-1.891-.072-2.858l.621-.154z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#241E4F"
        d="M283.057 77.521v3.33l-.94-.076c-.128-1.134-1.228-2.375.937-3.257l.003.003z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2C1868"
        d="M279.324 84.983a2.667 2.667 0 00-.147-.509c1.146-.777 2.452-.75 3.755-.734-.645 2.036-2.085 1.762-3.608 1.243z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#343241"
        d="M279.297 74.418c-.093 1.036.398 2.162-.468 3.08l-.287-3.012.755-.068z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3F1E2D"
        d="M275.536 80.707c.023.953.046 1.906.071 2.858l-.064.269c-.72.271-.904-.324-1.198-.742-.063-.876-.298-1.792.557-2.46.211.025.422.051.634.075z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E7F8F2"
        d="M596.381 405.773l-1.26-1.217-.006-.625c-.355-1.229-1.33-2.182-1.531-3.479-.023-1.623-.023-3.25 0-4.873.311-1.254.547-2.543 1.527-3.508l.018.01c1.707.289 1.207 1.646 1.221 2.67.049 3.675.027 7.349.031 11.022z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B6A8FE"
        d="M593.887 395.209l.014 5.602c.367.621.434 1.242.006 1.865-.029 7.688-.063 15.377-.092 23.063a5.002 5.002 0 01-.475.055c.012-13.518.027-27.037.041-40.553 1.08 2.217.184 4.588.535 6.861.76 1.043.395 2.074-.029 3.107z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E4E0FA"
        d="M593.907 402.676c-.002-.621-.004-1.242-.008-1.865.945.83 1.268 1.902 1.217 3.121-.403-.42-.807-.836-1.209-1.256zM593.887 395.209c.01-1.035.018-2.072.029-3.107.398-.008.797-.02 1.195-.029.054 1.224-.259 2.306-1.224 3.136z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4312AC"
        d="M312.983 464.471c-.353 1.951-1.917 1.221-2.99 1.225-12.305.053-24.61.041-36.916.043-26.638.002-53.277.002-79.916.002-.767.467-1.617.279-2.433.279-18.351.012-36.703.012-55.054 0-.81-.002-1.667.217-2.416-.316l.004-1.225c.14-.129.28-.258.419-.391 1.643-.734 3.392-.359 5.097-.486 16.233.061 32.465-.131 48.698.088a6.59 6.59 0 011.192.213c1.21.389 2.461.316 3.704.316 22.203.002 44.406.006 66.609-.002 1.345 0 2.704.09 4.004-.389 3.401-.453 6.823-.094 10.232-.266 12.092-.207 24.182-.063 36.274-.07 1.243-.002 2.499.049 3.492.979z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#301886"
        d="M133.259 465.703c19.968.012 39.935.023 59.902.037-1.036 1.051-2.356.572-3.541.578-19.675.064-39.349.09-59.024.125l-4.785-.334c2.444-.845 4.971-.175 7.448-.406z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4712A5"
        d="M122.032 461.984l1.247-.002c4.679-1.283 9.354-.568 14.023.053.524.07.901.471.931 1.072-1.525 1.355-3.377.484-5.064.744-3.294-.234-6.654.564-9.889-.621-.809-.023-1.23-.433-1.248-1.246z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#470FBD"
        d="M123.279 463.23l9.981.004c.372.414.372.828.003 1.244-2.336 0-4.673-.004-7.009-.002-1.167.001-2.198-.314-2.975-1.246z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4610B3"
        d="M138.258 463.23c-4.898-1.557-9.954-1.223-14.979-1.248.4-1.912 1.946-1.217 3.041-1.221 11.334-.047 22.668-.027 34.003-.027 46.273 0 92.546.01 138.819-.063 1.256-.002 3.745 1.184 3.648-1.33-.077-1.979-2.368-1.061-3.634-1.061-57.295-.053-114.591-.047-171.886-.037-3.878 0-7.519 1.861-11.529 1.328-1.856-.248-2.686-.697-2.452-2.572 64.125-.006 128.25-.01 192.375-.014 5.667-.002 5.667-.004 7.292-5.006 1.076 1 .908 2.229.653 3.477a4.084 4.084 0 01-.558.9c1.045 2.715-.475 5.406-.066 8.113-13.305.004-26.61.006-39.916.008-2.671-1.273-5.522-.674-8.253-.564-9.639.381-19.276.135-28.914.182-12.751.064-25.504.006-38.257.027-1.438.002-2.913-.191-4.287.459-1.728.27-3.455.424-5.168-.104h-.001a2.665 2.665 0 00-1.019-.539c-14.813-.203-29.626-.023-44.438-.094-1.339-.008-2.695.172-4.014-.238-.155-.126-.308-.249-.46-.376zM113.199 460.813c.009.426-.015.891-.584.82-.197-.023-.441-.385-.502-.631-.093-.373-.125-.916.347-1.004.481-.09.624.416.739.815z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5416CD"
        d="M161.973 451.994c.29-.107.829-.211.831-.322.073-4.094 3.004-3.428 5.59-3.428 38.22.01 76.44.006 114.66.006 7.833 0 15.665.047 23.495-.033 1.893-.016 3.033.371 2.721 2.531-1.608 1.383-3.629.865-5.363.787-2.594-.117-5.189-.037-7.226-.158 1.294.037 3.147-.096 4.989.076.736.07 1.499.287 1.471 1.24-.021.74-.667.986-1.259 1.191-1.102.383-2.253.355-3.395.355-56.96.012-113.919.014-170.879-.008-1.746 0-3.584.172-4.924-1.363-.745-1.291-2.004-1.242-3.247-1.246-2.977-.01-5.953.014-8.928-.012-1.216-.012-2.493.164-3.459-.867l-.001-1.863c2.136-.57 4.29-.344 6.439-.129 4.227.422 8.459-.543 12.693.063.677.096 1.435-.148 2.073-.535l5.017-.063c7.082.014 14.165.027 21.247.037 1.879-.49 3.073 1.754 4.957 1.24.768.898 1.523 1.81 2.498 2.501z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5315D3"
        d="M123.277 451.994c.399 1.91 1.945 1.217 3.042 1.221 11.025.047 22.05.029 33.076.029 46.598 0 93.196.002 139.794-.018 1.143 0 2.403.359 3.921-.73-3.883-1.105-7.502.082-10.893-.822l-.007-.926h17.059c2.34.902 1.389 2.969.997 4.23-.454 1.461-1.442.443-1.896-.447-1.101-2.158-2.094-3.5-3.475-.125-.372.912-1.411 1.484-2.608 1.344-.616-.072-1.247-.008-1.87-.008-59.047-.004-118.093-.004-177.14-.004-1.532-1.479-3.452-1.604-5.439-1.65-1.595-.039-3.323.391-4.669-.951-.232-.58-.188-1.09.368-1.471 3.263-.295 6.53-.842 9.74.328z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#241D5D"
        d="M313.077 455.709l-.121-3.729c.036-.408.075-.818.113-1.229.746-1.457.365-3.025.505-4.545.138-1.486.706-2.654 2.198-.793.839 2.406.581 4.801.081 7.203.91-.234.592-2.219 2.141-1.869.111 1.641-.174 3.217-.543 4.82-.279 1.201-.904 1.459-1.926 1.404h-.007c-.594-.84-1.703-.698-2.441-1.262z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5016D9"
        d="M123.277 451.994l-9.985.002c-2.357 1.244-4.716 2.479-7.486 1.244.116-.979-.426-2.289 1.243-2.496 4.515.002 9.029-.021 13.544.021 1.028.01 2.394-.488 2.684 1.229z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5416CD"
        d="M113.292 453.244c2.249 0 4.498.021 6.747-.006 1.767-.023 2.967.623 3.24 2.5h-9.988c-.602-.645-.699-1.365-.327-2.158l.328-.336z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#32177F"
        d="M315.495 445.734c-.414.008-1.085-1.596-1.208.156-.12 1.703.266 3.508-1.218 4.861l-.117-3.121a4.24 4.24 0 01-.505-.863 4.404 4.404 0 01-.173-1.498c.856-3.086 1.127-6.266 1.448-9.439.501-.789.393-2.279 2.024-1.785.676.99.678 2.115.654 3.25-.262 2.816.883 5.787-.905 8.439z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5C1FC8"
        d="M128.253 448.279c-.895 1.047-2.08 1.26-3.375 1.215-5.943-.211-11.887-.41-17.831-.615-1.032-.152-2.192.391-3.079-.559l9.316-.1c4.99.018 9.98.04 14.969.059z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4A0AC1"
        d="M312.973 446.996c-.006.211-.013.424-.021.635-8.301-.002-16.602-.004-24.903-.004l.004-.592c.569-.701 1.375-.811 2.195-.889 6.61-.068 13.221-.01 19.833-.006 1.041.003 2.074.073 2.892.856z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5416CD"
        d="M105.806 453.24c2.667.611 4.82-1.854 7.486-1.244v1.248c-.865.607-.405 1.881-1.253 2.498-1.782-.369-3.206-2.85-5.527-.5-.624.635-.409-1.297-.706-2.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5512E0"
        d="M112.039 455.742c.12-.982-.42-2.297 1.253-2.498l-.001 2.494c-.418 0-.835.004-1.252.004z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4712A3"
        d="M477.788 464.48c-1.666 0-3.33 0-4.998-.002.504-2.055 2.182-1.209 3.342-1.211 25.516-.049 51.031-.037 76.547-.037.193.164.316.371.357.623a1.003 1.003 0 01-.354.625l-4.998.002c-.762.484-1.615.291-2.43.293-21.678.01-43.357.01-65.039 0-.812-.002-1.666.192-2.427-.293z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#430CAB"
        d="M552.68 463.857c0-.209 0-.418-.002-.627h49.119l.021.625h-9.193c-3.33.207-6.662.414-9.99.623-2.643-.691-5.33-.225-7.994-.309-7.318-.224-14.646.36-21.961-.312z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#621AED"
        d="M582.717 392.139c1.48.293 2.412-.955 3.664-1.311 3.439-1.186 4.582-.596 4.551 2.795-.027 2.82.863 5.775-.793 8.457-.006 13.516-.004 27.029-.021 40.545-.006 4.24-.17 4.375-4.408 4.375-44.287-.006-88.572-.01-132.861-.018-1.98-2.912-2.33-6.152-1.918-9.547 1.109-2.336 1.5-4.705.316-7.152.006-.629.313-1.055.879-1.313 1.629-.512 3.303-.316 4.957-.316 38.24-.012 76.482-.008 114.725-.008 1.039 0 2.076.006 3.117-.004 3.99-.035 4.313-.32 4.326-4.215.029-7.793.008-15.586.01-23.381 0-1.039.109-2.092-.018-3.113-.358-2.872.757-4.798 3.474-5.794z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5417CB"
        d="M452.792 452.023a1.826 1.826 0 01-.6-.137c.045-4.254.045-4.258 4.352-4.258 45.359-.002 90.723-.004 136.082-.004-.004.205-.002.412.006.619-.039 2.143 2.082.002 2.49 1.258-1.441 2.139-.654 2.559 1.639 2.539 10.701-.1 21.4-.059 32.102-.025 1.086.002 2.262-.363 3.264 1.23H452.82c-.008-.408-.02-.816-.027-1.227 1.391-1.045 3.008-.627 4.527-.627 39.998-.023 79.998-.02 119.994-.021-40-.002-80-.006-120 .02-1.517.001-3.14-.435-4.522.633z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#713ED7"
        d="M591.368 387.049c.967-.352 1.301.008 1.27 1.004-.051 1.557.002 3.119 0 4.676l-.031 54.25-1.207.014c-.619-1.07-.307-2.238-.309-3.357-.025-12.361.064-24.725-.055-37.084-.051-5.389-.166-10.787-.494-16.17-.074-1.219.256-2.24.797-3.26l.029-.073z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5417CB"
        d="M591.338 387.121c.02 19.957.041 39.914.059 59.871-1.061-.896-.623-2.121-.627-3.203-.029-12.826-.008-25.658-.037-38.486-.002-1.084.418-2.303-.594-3.223-.008-2.553-.229-5.131.033-7.658.316-3.086-.961-4.049-3.791-3.594 1.112-1.957 3.414-2.322 4.957-3.707zM451.581 437.006c-.199 3.404-.031 6.762 1.268 9.977l-1.262.029c-.814-1.574-.201-3.506-1.256-5.023-.775-3.227-1.232-6.512-1.885-9.762-.045-.732-.029-1.457.303-2.137.799-.975 1.695-1.436 2.844-.529-.008.404-.016.807-.027 1.209-.029.133-.061.266-.086.398-.615 1.602-.559 3.15.354 4.641.041.425.073.849-.253 1.197zM602.61 449.502l39.947.002c-.229 1.533-1.426 1.234-2.412 1.236-11.711.01-23.418.01-35.129 0-.984-.002-2.183.297-2.406-1.238zM598.86 449.504h1.258c-.045.428 1.371.887.143 1.182-1.174.283-2.471.063-3.867.063.605-1.126 2.032-.181 2.466-1.245z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DCFAFB"
        d="M649.485 260.957c-1.523.701-2.637.629-2.617-1.442.014-1.679-.59-3.824 2.416-3.379 1.383 1.552 1.228 3.17.201 4.821z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C9EBF3"
        d="M651.848 261.714l-1.791-.751c-.482-1.634-.582-3.265.063-4.884.152-.052.303-.099.457-.139.131.047.26.092.391.137.855 1.72.693 3.633 1.031 5.451l-.151.186z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#85A9B6"
        d="M650.12 256.079c-.02 1.628-.041 3.258-.063 4.886 0-.002-.287.018-.287.018l-.285-.023-.201-4.824c.277-.018.558-.037.836-.057z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C9EBF3"
        d="M650.577 255.94c.07-.339.145-.68.215-1.019l-.063-.06c.361-.449.809-.485 1.307-.266.4.425.846.879.338 1.466-.463.534-1.039.313-1.578.058l-.219-.179z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6FBF4"
        d="M650.795 256.12c.947-.088 1.809-.233 1.023-1.5-.02-.862.039-1.7.752-2.325l-.002.011a2.01 2.01 0 01.559-.068c1.371-.024.885 1.069 1.029 1.755.133.645-.467 1.447.434 1.92.559.052 1.117.101 1.676.152.447 1.317 1.922 2.278.672 4.107-1.4 2.045-3.195 1.315-4.939 1.356-1.577-1.543-1.153-3.528-1.204-5.408z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C9EBF3"
        d="M654.59 255.912c-1.668-.755-.043-2.821-1.463-3.675 2.488-.392 1.229 1.568 1.58 2.518l-.014.661a.722.722 0 00-.103.496z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EDB1A3"
        d="M274.345 83.092l1.199.742c.484 2.381-.361 4.34-1.932 6.066a3.136 3.136 0 00-.517.095c-.92.651-1.494.255-1.908-.629.422-.825 1.995-.468 1.887-1.836 1.019-1.05.198-2.686 1.192-3.742l.079-.696z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E4A5C6"
        d="M271.187 89.367l1.908.629c-.017.186-.04.373-.069.557l-1.851 1.415a5.67 5.67 0 00-.504-.026c-1.333-1.16.139-1.757.516-2.575z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F8C25B"
        d="M274.266 83.788c-.019 1.368.513 2.911-1.192 3.741l.011-3.752 1.181.011z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E50719"
        d="M253.096 163.647c4.118-.486 7.141-3.734 11.174-4.436 1.256.269 2.623-.345 3.811.479.342.407.406.869.276 1.371-.567 1.025-1.41 1.698-2.553 1.98-1.929.051-3.661.749-5.322 1.665-.362.215-.735.411-1.121.582-.906.296-1.818.58-2.595 1.17-.907.393-1.811.787-2.652 1.316-.727.277-1.445.303-2.146-.078-.358-.273-.495-.648-.494-1.083.056-.596.493-1.13.308-1.773.439-.396.876-.794 1.314-1.193z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EC0511"
        d="M251.765 182.411c-.732-1.367-1.09-2.836-1.179-4.377-.566-1.202-.181-2.743-1.328-3.74-.676-.495-.555-1.219-.55-1.911.449-.504 1.008-.544 1.615-.383.272.118.495.299.681.529.529 1.25 1.867 1.751 2.62 2.802 1.646 3.018 1.95 6.422 2.809 9.67-.032 1.203.138 2.438-.569 3.53-.398.395-.871.475-1.395.325-1.772-1.781-1.379-4.474-2.704-6.445z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E4071E"
        d="M255.666 207.236l.495-2.393c-.528-.68-.654-1.422-.354-2.23 1.925-1.446.349-3.076.228-4.635-.012-1.898-.449-3.84.616-5.617.482-.379.995-.396 1.53-.125 1.252 3.212 2.263 6.473 2.016 9.989-.078 2.404.211 5.01-3.076 5.677-.581-.009-1.101-.158-1.455-.666z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DF4060"
        d="M255.666 207.236l1.322.12c.049 2.765-1.929 2.753-3.854 2.819-1.428-.648-2.161-1.895-2.489-3.305-.648-2.792-1.731-5.437-2.562-8.165-.097-1.462-.769-2.856-.541-4.359.081-.323.235-.607.459-.853 2.446-.69 1.602 1.873 2.592 2.624-.294 3.564.992 6.797 1.982 10.123.646 2.166 1.61 2.064 3.091.996z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E5060D"
        d="M256.905 192.241l-.067 6.36a1.34 1.34 0 01-1.144.44 1.914 1.914 0 01-.737-.406c.081-2.112-.983-4.108-.626-6.249-.349-1.258-.679-2.517.016-3.771l1.271-.015c.508-.396.993-.333 1.462.074.698 1.227.741 2.42-.175 3.567z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F43D44"
        d="M250.593 196.117c-1.791.06-.723-2.557-2.42-2.585-.788-.792-.775-1.599-.049-2.421 1.742.343.834-3.915 3.382-1.995 1.013.762.207 6.04-.913 7.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#8A32CB"
        d="M235.592 171.12l.171-1.221c.288-.353.658-.37 1.06-.258.561.308.968.798 1.439 1.212.415.43.892.764 1.477.928.354.121.627.352.864.631l.103 2.301-.231.406c-.395.28-.843.408-1.318.464-.796.074-1.593.08-2.391-.017-.503-.079-.961-.257-1.345-.602a2.019 2.019 0 01-.366-.934c-.041-1.009-.198-2.042.537-2.91z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F0041A"
        d="M250.642 172.344l-1.934.039-.593-1.868c.782-1.474-.074-2.343-1.155-3.13.816-1.415 2.14-2.066 3.656-2.427.396.415.984.632 1.23 1.2l-.006 1.223c-.694 1.583.057 3.516-1.198 4.963z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E90614"
        d="M270.556 155.526c.822.709 1.367 1.793 2.611 1.935.292.458.212.888-.088 1.306-1.194.665-2.264 1.677-3.809 1.391-.764-1.095-2.354-.536-3.151-1.565.999-1.716 2.964-2.035 4.437-3.067z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D43E5D"
        d="M243 178.627c2.177.53 2.711 2.079 2.619 4.09-.051 1.103.054 2.213.089 3.321l-.368.216c-2.056-.918-1.456-3.244-2.498-4.703a4.355 4.355 0 01-.277-.833c-.106-.747-.16-1.487.435-2.091z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E6081A"
        d="M254.346 188.616l-.016 3.771c-1.291-3.213-2.04-6.566-2.564-9.977 1.931 1.623 2.131 3.967 2.58 6.206z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DB4062"
        d="M248.124 191.11l.048 2.422-.105.777c-1.275-.025-1.27-1.15-1.67-1.931-.291-1.347-.767-2.635-1.27-3.917-.186-.801-.25-1.585.341-2.269l.239-.153c1.602 1.311 2.302 3.051 2.417 5.071z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EE3B43"
        d="M254.957 198.635c.172.008.346.013.519.017 1.144 1.068.997 2.383.709 3.724l-.023 2.467c-2.108.133-1.885-1.382-1.79-2.665.087-1.189.381-2.363.585-3.543z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#501850"
        d="M243 178.627l.132 2.48c-2.716-.411-3.777-2.892-2.585-6.04a.912.912 0 01.158-.354c1.422.92 1.124 2.849 2.295 3.914z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DF0C29"
        d="M276.817 151.208l-.022 2.423c-1.581-.714-2.714 1.874-4.372.59.032-.177.059-.353.082-.531.151-.223.327-.244.527-.063l3.785-2.419z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BF3F77"
        d="M239.475 164.964l-.027 1.185c.582.83.583 1.658-.001 2.487l.022 1.184-.399.318c-.545.12-1.007.009-1.332-.482-.596-1.507-.591-3.015-.004-4.524.325-.494.789-.606 1.338-.487l.403.319z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DF397E"
        d="M239.419 161.153l1.223-.11c1.383 1.835-.138 2.804-1.168 3.921l-.207-.114c-.916-1.272-.863-2.505.152-3.697z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FA0000"
        d="M266.118 158.592c1.06.39 2.685-.724 3.174 1.19-.345.433-.735.499-1.178.148-1.276-.266-2.747.511-3.843-.719.462-.663 1.187-.545 1.847-.619z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EC1112"
        d="M246.961 167.385c.839.126 1.963-.345 2.295.907.269 1.013-.201 1.768-1.14 2.223-.443-1.022-1.255-1.908-1.155-3.13z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5365B"
        d="M253.095 163.648h-3.325l.075-.937c1.132-.127 2.371-1.227 3.25.937z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E93C68"
        d="M273.032 153.628c-.174.042-.35.062-.528.063-.556-.102-1.246.127-1.568-.537-.055-.113.241-.552.438-.604.909-.243 1.595-.031 1.658 1.078z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F10701"
        d="M251.847 166.158c-.769-.033-1.219-.393-1.23-1.201l1.167-.115c.446.134 1.117.09.999.784-.038.225-.609.358-.936.532z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F24040"
        d="M239.446 168.636v-2.487c1.666.83 1.665 1.66 0 2.487z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DF3680"
        d="M240.603 172.412l-1.156-.086c-.764-.749-.773-1.55-.167-2.393l.187-.113c1.548.353 1.075 1.589 1.136 2.592z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EC0D15"
        d="M249.258 174.293c1.908.726 1.199 2.381 1.328 3.74-.898-1.084-1.12-2.409-1.328-3.74z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FC3444"
        d="M259.345 142.435c-.226-.318-.673-.893-.646-.916.759-.653 1.683-.217 2.539-.327-.401.764-.998 1.23-1.893 1.243z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4E7DCE"
        d="M594.42 224.224c.24.381.479.76.721 1.14-.018.224-.031.447-.049.669l-1.869.107-.301-.025s-.301.006-.301.008l-1.141-.096-.076-.013c-.658-.635-.727-1.405-.514-2.24.277-.778.67-1.459 1.523-1.73 1.382.069 1.826 1.006 2.007 2.18z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#601EE2"
        d="M586.313 263.575l-2.371-3.847c-.424-.913-.836-1.831-1.641-2.497-.281-.59-.334-1.206-.217-1.843.072-.326.205-.624.389-.902 1.326-1.212 2.273-3.077 4.557-2.651.629.246 1.258.789 1.074 1.355-1.088 3.347-.123 7.016-1.676 10.27l-.115.115z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1F216C"
        d="M582.579 255.441c.049.584.096 1.168.143 1.752.285.447.313.884-.063 1.299-.039.8-.432 1.252-1.26 1.273.523-2.26-1.779-3.566-1.887-5.615.082-.401.32-.666.699-.81.699-.002 1.078.537 1.559.911.397.31.572.771.809 1.19z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5525C4"
        d="M587.547 267.302c2.422.548.904 2.478 1.309 3.732-1.117-1.005-1.32-2.331-1.309-3.732z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3D159C"
        d="M582.659 258.492l.063-1.297c1.453.339 1.121 1.539 1.221 2.533-.429-.412-.857-.823-1.284-1.236z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#611BEB"
        d="M586.383 252.271c-1.688.154-2.029 2.314-3.707 2.488-.721-.4-.744-1.419-1.561-1.739-.414-.158-.811-.343-1.148-.645a2.584 2.584 0 01-.441-.87c-.229-.862-.221-1.744-.248-2.625-.025-11.22-.053-22.438.039-33.655.012-1.268-.789-3.35 1.813-3.386 1.838 1.777 1.057 4.148 1.031 6.151-.082 5.979.549 11.97-.23 17.939.078-1.576.268-3.1.68-4.659.723-2.714.678-5.53-.082-8.271-.25-.904-.879-2.025-.33-2.676 1.51-1.794.725-3.469.168-5.223.199-.519.631-.687 1.133-.75 2.428.266 2.813 2.809 4.438 3.975 1.301 1.417 2.346 2.983 2.803 4.885-.031.976.16 1.998-.58 2.827-.02 10.823-.035 21.648-.055 32.471l-1.221.013c-1.686-2.986-.59-6.261-.85-9.383-.424-5.044.09-10.147-.49-15.22-.217 4.63-.205 9.264-.236 13.896-.01 1.535.211 3.144-.926 4.457z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3121B2"
        d="M590.159 226.037l-.037-3.066c.703-.342.988.053 1.152.657l.131 2.387-1.246.022z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6419F0"
        d="M586.383 252.271c-.158-6.606.328-13.223-.271-19.82-.037-.415-.23-.864.152-1.119.496-.329.92-.028 1.359.315 1.211.947 1.277 2.215 1.273 3.606-.035 7.755-.016 15.511-.014 23.267-.002 1.234-.1 2.475.018 3.698.256 2.67-.896 2.332-2.473 1.241.336-3.155-1.014-6.466 1.027-9.487.517-.761.007-1.578-1.071-1.701z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2F81B7"
        d="M545.172 143.708c.219.407.436.815.65 1.223 1.148 2.615.779 5.021-1.24 7.014-2.387 2.355-5.232 2.043-8.113 1.074a6.124 6.124 0 01.002-.606c.186-.225.414-.386.689-.488.551-.151 1.104-.107 1.65.018.742.213 1.48.229 2.203-.089.678-.279 1.326-.597 1.76-1.229.344-.541.596-1.129.906-1.688 1.221-1.629-.205-3.122-.244-4.684.002-.454.148-.849.477-1.168.422.207.842.415 1.26.623z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1980C9"
        d="M533.956 153.03c.871.346 1.412 1.319 2.475 1.298.018.188.029.375.037.563 1.283 1.831.029 2.858-1.223 3.889-1.967 1.512-2.252-.252-2.828-1.46-.105-.42-.057-.807.25-1.136.408-1.059 1.507-1.838 1.289-3.154z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2C77C8"
        d="M534.567 158.638c.783-1.172 2.443-1.9 1.9-3.745l2.49.664c.887 1.083.914 2.249.344 3.475-1.254 1.082-2.604.316-3.922.208a1.766 1.766 0 01-.812-.602z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1981C1"
        d="M538.942 159.292c.004-1.246.008-2.49.016-3.735h2.482c-.006 1.437-.012 2.875-.021 4.312-.686.738-1.473.712-2.311.301-.301-.245-.359-.538-.166-.878z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1088C5"
        d="M543.922 154.884c-.551.925 2.023 1.585.369 2.356-1.348.628-1.619-.645-1.604-1.757.411-.2.821-.4 1.235-.599z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3485BE"
        d="M537.252 152.32l-.781.093c-1.271-.408-1.285-2.047-2.48-2.528-.01-1.235-.021-2.468-.033-3.703.996-1.5 1.527-3.445 3.678-3.838.141.05.281.1.424.148.229.194.375.441.453.731-2.936 2.683-2.268 5.867-1.261 9.097z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3485BE"
        d="M537.635 142.345c1.91-1.247 3.791-.915 5.662.098-.531.564-1.217.738-1.953.79-1.283.112-2.5-.09-3.611-.779l-.098-.109z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#377196"
        d="M541.428 142.496l1.869-.054.615.643c-.016.462-.033.925-.051 1.387-1.104.148-1.883-.386-2.529-1.202a.736.736 0 01.096-.774z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3A6AD6"
        d="M538.958 159.892l2.461-.023c.494.261.645.7.641 1.221-.168 1.733-1.479 1.191-2.488 1.251-1.091-.594-1.462-1.368-.614-2.449z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#402FDA"
        d="M532.667 156.186l.064 1.21c.574.844.102 1.435-.48 2.001-.895.336-1.471-.183-2.025-.755-.029-.81-.457-1.21-1.256-1.233l.006-1.26c1.241-.989 2.464-.232 3.691.037z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EEF2F8"
        d="M619.518 298.417c-.326.579-1.16.855-.814 1.833.283.805.24 1.727-.943 1.876-.67.086-1.354-.137-1.328-.929.031-.956-.279-2.184.914-2.658.639-.253 1.438-.095 2.164-.122h.007z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7433EF"
        d="M265.622 162.455l2.48-1.26c1.522-.759 3.223-1.076 4.718-1.899.722-.162 1.459-.199 2.193-.229 1.252-.153 2.166-.876 2.979-1.771l-.023.003c1.8-.062 2.957.515 2.589 2.606-.3.289.081-.097-.208.201-.068.07.005.006.208-.202 3.22-.651 1.361-2.751 1.243-4.355l81.146.013c.221.248.4.521.544.818.265.788.254 1.607.275 2.421.034.781.028 1.563.018 2.344-.011.921-.313 1.822-.208 2.754 1.044-2.512 1.604-2.694 4.629-1.5.645.996.549 2.122.576 3.223.008 3.792 4.025 6.794 7.467 5.572 1.572-.559 4.292-6.976 3.642-8.57-.291-.711-.982-.628-1.539-.847-1.434-.563-2.92-1.005-4.254-1.804.203-2.438 1.994-2.125 3.654-2.176 1.662-.051 3.634.68 4.585-1.542.18-.24.373-.471.574-.693l59.925-.005c1.316.671.305 2.275 1.242 3.098-.885 1.557-1.631 3.147-1.209 5.02-.033.81-.066 1.62-.102 2.429-2.65 1.387-2.697 4.137-3.42 6.539-.779.922-.828 2.405-2.205 2.869-1.521.491-3.09.382-4.643.382-57.131.008-114.263.008-171.394.001-1.349 0-2.702.056-4.031-.164a3.868 3.868 0 01-1.005-.272c-1.694-.715-.619-3.361-2.668-3.844a1.745 1.745 0 01-.603-.678c-.229-1.03.162-1.845.878-2.551.268-.176.561-.293.874-.36.805-.139 1.549-.019 2.19.523.67.508.961 1.529 2.078 1.526-.098-1.033-1.183-.611-1.593-1.124-.345-.263-.679-.534-.72-1.011.027-.284.14-.533.322-.751.646-.475 1.496-.568 2.105-1.117.21-.156.438-.281.677-.383.888-.216 1.66-.669 2.396-1.2 1.322-.48 2.484-1.232 3.618-2.034z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7637F6"
        d="M382.912 155.563l.004.593c-.25.182-.465.468-.77.506-6.144.772-12.289.835-18.433.001-.304-.042-.521-.324-.769-.506 0-.199 0-.397.002-.595l19.966.001zM444.079 158.655c-2.117-.351-.355-2.255-1.242-3.098h3.465c-.404 1.187-.723 2.107-1.037 3.029-.378.322-.913-2.051-1.186.069z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#723ED7"
        d="M439.059 172.342c.088-4.798.697-5.821 3.709-6.238l.15 1.379c-.006.188.02.371.082.548-.217.393-.432.788-.646 1.181-.93.266-.551 1.223-.938 1.779-.447.658-.66 1.538-1.631 1.693a1.048 1.048 0 01-.726-.342z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7B32E1"
        d="M277.993 157.295c-.183 1.464-1.086 2.246-2.452 2.59-.311-.354-.507-.757-.518-1.238.035-.481.23-.877.634-1.157l2.336-.195z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C11461"
        d="M275.657 157.49l-.104 1.145c-.543.624-1.228.664-1.968.478a1.233 1.233 0 01-.618-.567l.197-1.086c.833.01 1.663.019 2.493.03z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FBF8EF"
        d="M622.581 248.53c-.207 1.544-1.389 1.229-2.377 1.208-1.063-.021-1.504-.642-1.207-1.638.273-.933 1.066-.888 1.762-.605.643.261.998 1.064 1.822 1.037v-.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FBF8EF"
        d="M622.581 248.531c.121-1.09-.281-2.239.336-3.288 2.424 1.504 2.414 1.596-.336 3.287v.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3F1795"
        d="M451.592 429.561c-.924-.164-1.723.154-2.49.621a1.254 1.254 0 01-.316-.982c.205-.781.729-1.264 1.473-1.537a5.15 5.15 0 011.15-.215c40.236-.115 80.469-.02 120.701-.053 6.418-.004 5.891.447 5.898-5.896.01-7.795-.01-15.592.014-23.389.004-1.438-.215-2.945.863-4.166.002-.199.012-.398.029-.594l3.803-1.211c-2.639 1.754-2.662 4.332-2.617 7.17.145 8.729.055 17.463.035 26.193-.01 3.756-.314 4.043-4.129 4.043-41.47.008-82.943.012-124.414.016z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B6534C"
        d="M632.6 222.314l-1.285.004c.064-.866-.246-1.815.559-2.518.063.423.127.847.189 1.271.18.414.357.828.537 1.243z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D7F5FA"
        d="M627.86 172.533c1.289-.296 2.58-.275 3.877-.057 1.803 1.517 2.912 3.307 1.803 5.692-1.217 2.614-3.549 2.444-5.879 2.135-2.797-2.951-2.756-4.471.199-7.77z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1A1841"
        d="M490.278 242.275c.008-.201.01-.401.01-.601.598-1.07 1.232-2.119 1.826-3.191 2.465-2.185 5.012-1.405 7.48-.096 3.732 1.978 6.719 4.892 9.285 8.167 10.701 13.646 18.283 28.843 22.242 45.76.871 3.735 1.203 7.59.285 11.415-.559 2.329-1.561 4.296-4.229 4.771-2.373.21-4.492-.152-5.709-2.542-1.387-1.309-3.242-2.094-3.85-4.25-.342-1.224-2.031-1.273-3.027-1.989-2.955-2.208-4.773-5.396-6.738-8.36a123.065 123.065 0 01-13.783-27.868c-.563-1.63-1.719-3.089-1.322-4.969-1.871-4.544-3.646-9.094-2.225-14.169.183-.656.257-1.437-.245-2.078z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3EA4EB"
        d="M573.842 282.255c.064 1.191.285 2.314 1.32 3.091l-.008-.017c.734 1.729.791 3.592 1.076 5.41.539 4.097-.971 7.784-2.313 11.505l.055.015c-.719.428-.904 1.209-1.25 1.883l-.021-.054c-.398.402-.697.913-1.264 1.127-1.23.144-1.889.903-2.188 2.052a4.35 4.35 0 01-1.615 1.495 2.026 2.026 0 01-1.316-.04c-1.111-.792-2.373-.792-3.654-.674-1.443.126-1.9 1.321-2.533 2.325-.52.821-.652 1.938-1.754 2.329a92.369 92.369 0 01-8.566.088c-.566-.023-1.088-.173-1.523-.556a1.293 1.293 0 00-.518-.09c-.834-.454-1.967-.313-2.535-1.29-.852-.632-1.699-1.265-2.549-1.897-.459-.582-.672-1.254-.742-1.977.137-1.457-1.262-1.572-1.996-2.276a2.292 2.292 0 01-.334-.89c.41-3.92 2.309-7.514 2.426-11.51.029-1.069.662-2.062 2.109-1.33 1.189 2.165.447 4.512.641 6.769a7.747 7.747 0 01-.123 1.395c-.564 1.279.041 1.904 1.244 2.187 2.322-.512 4.434 1.581 6.791.526.988-.37 1.891-.909 2.813-1.41 1.186-.422 2.418-.314 3.637-.323 5.383-.038 5.383-.034 6.873-5.121-.064-.781 1.469.449 1.037-.826a4.19 4.19 0 01-.201-1.812c.334-2.803-.049-4.852-3.709-4.058-.666.145-1.346-.388-1.82-.972a1.436 1.436 0 01-.133-1.286c1.072-1.144 2.486-.721 3.988-.851-.805-.774-1.873-.882-2.586-1.53.703-2.081-1.301-4.007-.359-6.107.146-.263.359-.457.631-.586 2.182.187 3.59 2.616 6.023 2.075 1.307.261 2.355 1.132 3.607 1.531.697.36.814 1.182 1.339 1.68z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EABAEC"
        d="M568.829 266.053c.082.374.162.751.242 1.125-2.25-.113-4.031 2.032-6.402 1.33-4.732-.036-8.656-2.357-12.58-4.575-1.639-.925-1.205-3.834-3.648-4.174l.004.004c0-.417.002-.834.004-1.251a1.578 1.578 0 011.225-.451c2.736 1.465 3.881 4.71 6.752 6.025 1.205.636 2.521.984 3.785 1.475 3.102.475 6.188.265 9.27-.171.531.055.978.282 1.348.663z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D8C6F0"
        d="M515.752 224.573c-.658-.911-.418-1.51-.002-2.188 1.268-2.083 1.229-4.081-.645-5.825-.719-.669-1.219-1.379-1.115-2.423.07-.729 0-1.537.967-1.693 1.086-.175 1.453.454 1.521 1.444.053.769-.277 1.933.883 2.005 1.168.073 1.414-1.104 1.549-1.995.172-1.153.76-1.938 1.811-1.409 1.74.873-.213 1.244-.408 1.887-.785 2.615-2.982 4.726-2.637 7.762.151 1.333-1.029 1.795-1.924 2.435z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6B4DA8"
        d="M539.639 232.306c.221.25.441.502.66.753-.598 5.342-2.178 7.167-6.359 7.349-1.994-.51-4.217-.461-5.646-2.333l-3.047-1.525c.066-1.112.943-1.043 1.688-1.166 1.883.148 3.496 1.12 5.213 1.763 3.631 1.361 4.082 1.201 5.59-2.278.203-.471.377-.954.594-1.423.284-.551.639-1.027 1.307-1.14z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D5C6F2"
        d="M531.397 212.413c-.396-3.479-.58-3.589-6.703-3.962 1.273-2.827 2.063-3.039 4.598-1.401 1.336.862 2.766 2.482 4.211-.241-.23 2.205 2.541 5.274-2.094 5.598l-.012.006z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DDC3F5"
        d="M543.053 273.095c-3.482.239-3.908 2.925-5.35 4.582-.73.841-1.557 1.277-2.258.706-.59-.479-.426-1.651.266-2.233 1.916-1.616 2.567-5.633 7.342-3.055z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D9C5F3"
        d="M557.672 269.126c0 .208-.002.413-.004.619-2.486 1.35-4.977 1.309-7.469.015h-3.619c3.008-2.993 3.254-3.106 6.426-1.566 1.514.736 3.33-.416 4.666.932z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7254AB"
        d="M518.907 222.883c1.406-3.951 2.037-8.275 5.434-11.268.557-.142 1.129-.385 1.598.201-.43 1.927-1.949 3.32-2.531 5.173-.104.254-.225.501-.342.748-.391.866-.654 1.784-1.09 2.63-.23.475-.477.941-.703 1.418-.285.593-.439 1.248-.852 1.78-.227.167-.479.24-.76.214-.409-.167-.664-.462-.754-.896z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D5C6F1"
        d="M517.975 239.759c-1.631.095-2.705.034-2.771-1.8-.066-1.833 1.158-2.178 2.326-2.008 1.236.179 2.572.909 2.609 2.458.049 1.8-1.459 1.247-2.164 1.35z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D3C4F1"
        d="M528.293 238.076c1.881.779 3.764 1.555 5.646 2.333-.873 2.474-2.578 2.223-3.816.681-1.4-1.74-3.729-.639-5.143-2.048.97-1.223 2.622.728 3.313-.966z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E7B8E0"
        d="M547.78 258.486l-1.332.025c-1.443-3.197-1.307-6.599-1.291-9.984.148-.972-.359-2.263 1.23-2.538.436.319.637.775.752 1.285.096.494.119.994.129 1.493.02 1.767-.037 3.535.051 5.3.076 1.081.543 2.068.766 3.116.07.475.031.924-.305 1.303z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B8CAF8"
        d="M550.2 269.76l7.469-.013c1.279-.016 2.662-.171 2.518 1.801-.566.473-1.236.309-1.877.309-1.793-.032-3.588-.082-5.381.087-1.326.289-2.67.812-3.92-.222.247-.745 1.288-1.008 1.191-1.962z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7354B2"
        d="M518.907 222.883l.691.623c.334.328.443.731.396 1.187-.789 2.244-1.867 4.417-1.766 6.894-.141.615-.465 1.068-1.094 1.257-1.563-1.379-1.539-3.029-.727-4.743.828-1.742 1.158-3.725 2.5-5.218z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5089C6"
        d="M573.918 302.244c.514-3.784 1.975-7.408 1.883-11.291.227-.223.277-.609.656-.689.178.032.354.069.527.111.173 4.264-.509 8.31-3.066 11.869z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4C8FCA"
        d="M535.221 286.614c.746-3.407 2.07-6.499 4.82-8.809.387-.201.787-.313 1.221-.185.631 1.887-1.531 2.704-1.643 4.307a3.826 3.826 0 01-.479.622c-.592.514-.889 1.22-1.225 1.902-.783.875-.553 2.381-1.832 2.945-.487-.042-.68-.405-.862-.782z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#538EC4"
        d="M538.85 304.903c-2.732-3.096-4.195-6.692-4.283-10.833a.804.804 0 01.914-.064c.635.406 1.189.994 1.266 1.696.328 3.008 2.438 5.43 2.695 8.445a1.352 1.352 0 01-.592.756z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E3C0F9"
        d="M557.665 314.686c1.531.154 3.148-.338 5.281.678-3.541 1.154-6.641.018-9.516.939-.396.125-.684-.349-.615-.821.094-.65.629-.71 1.131-.803 1.238-.457 2.48-.466 3.719.007z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#76579F"
        d="M517.135 232.843c.215-.422.434-.843.65-1.265 3.197.528 6.012 2.056 8.879 3.438.402.194.553.582.395 1.036-.643.029-1.336-.126-1.813.498-2.73-1.179-5.761-1.701-8.111-3.707z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5485B7"
        d="M549.555 312.181c3.121-.013 6.242-.023 9.363-.034.664-.546 1.396-.652 2.191-.33.287.159.428.409.443.734-.873 1.229-2.357.058-3.342.852-1.832-.014-3.666-.023-5.502-.037-1.051-.389-2.586.5-3.153-1.185z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4E9DDC"
        d="M566.403 308.437l1.217-.006c.393.063.627.291.707.683-1.699 1.386-3.527 2.537-5.646 3.177-.412.271-.818.306-1.223-.016l-.066-.09c.006-1.596 1.543-1.957 2.342-2.916.829-.466 1.44-1.649 2.669-.832z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7150B8"
        d="M525.844 212.332c-.34-.581-.924-.643-1.504-.717 2.592-1.869 4.684.711 7.057.797l.012-.006c.447.381.895.762 1.344 1.142-.225.21-.449.421-.676.631-2.623 1.226-4.311-.711-6.233-1.847z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4D85BD"
        d="M541.42 277.853c-.459-.016-.918-.03-1.377-.047 2.313-2.862 5.096-4.982 8.828-5.613.063.128.125.259.188.389-1.982 2.572-4.934 3.741-7.639 5.271z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D3C4F1"
        d="M520.348 241.89c1.029-1.585 1.934-2.659 3.672-1.727.445.238 1.18.63.805 1.07-1.135 1.339-2.651 1.282-4.477.657z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4F8DC5"
        d="M538.85 304.903l.117-.862c.697-.325.887.314 1.234.65l.004.006c.826.634 2.039.762 2.475 1.899 0 .788.004 1.575.006 2.362-1.586-1.062-3.043-2.245-3.836-4.055z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BBC6F6"
        d="M549.555 312.181c.809 1.044 2.313.239 3.154 1.188-.586.685-1.014 2.316-2.021.227-.125-.268-1.332.009-2.039-.007-1.629-.038-.264-.896-.361-1.354.421-.02.845-.038 1.267-.054z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4D8DC1"
        d="M568.327 309.113l-.707-.683 1.271-1.267c.576-1.08 1.398-1.91 2.492-2.471.438-.201.879-.402 1.318-.605-.656 2.378-2.806 3.447-4.374 5.026z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#29245B"
        d="M492.114 238.483c-.551 1.097.473 3.095-1.826 3.191-.734-.009-1.209-.314-1.262-1.102a2067.22 2067.22 0 013.088-2.089z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8BCFC"
        d="M543.942 259.766l2.502-.003-.004-.004c.27 1.925-.531 2.787-2.486 2.501-.684-.828-.678-1.66-.012-2.494z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D9BEE6"
        d="M540.967 232.957c.363-.642.73-1.283 1.094-1.924.227 1.676 1.438 3.351.008 5.029-1.158-.753-.143-2.28-1.102-3.105z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5183B4"
        d="M535.196 294.091l-.629-.019c-.139-2.519-.455-5.051.654-7.458l.609.612c.59 2.362.598 4.672-.634 6.865z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8BDFC"
        d="M542.694 242.29c2.27.626.813 2.494 1.24 3.733-2.254-.631-.816-2.492-1.24-3.733z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D6C7E4"
        d="M575.799 316.938c.699 1.66.809 2.65-.012 3.949-.896-1.289-.761-2.285.012-3.949z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BBC6F6"
        d="M561.458 312.274l1.223.016c-1.059 2.099-2.957.821-4.469 1.112 1.08-.377 2.163-.751 3.246-1.128z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DCC6DC"
        d="M537.793 241.083c.369.104.922.083.777.68-.113.462-.586.518-.996.463-.387-.051-.928-.076-.785-.668.112-.457.581-.489 1.004-.475z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C3CFEB"
        d="M543.942 259.766l.012 2.494c-.67-.064-1.168-.314-1.217-1.085-.057-.868.33-1.346 1.205-1.409z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D4CADE"
        d="M513.364 225.161c.547.077.563.508.561.909 0 .403-.029.888-.576.883-.553-.005-.563-.494-.561-.896.002-.402.017-.834.576-.896z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4D7AC0"
        d="M549.008 271.722c1.227-.158 2.506.011 3.66-.587a.95.95 0 01.125.991c-1.238 1.146-2.521 1.161-3.842.143l-.08-.076c.046-.16.09-.315.137-.471z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BBC6F6"
        d="M557.665 314.686l-3.721-.007c1.244-.935 2.482-.937 3.721.007zM545.235 310.854c.969.182 1.834.575 2.533 1.29-1.033-.06-2.402.545-2.533-1.29z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7388BD"
        d="M572.723 304.142c-.09-.965-.197-1.938 1.248-1.883-.094.841-.471 1.495-1.248 1.883z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#29245B"
        d="M490.278 242.275c.781.614.705 1.507.592 2.297-.703 4.837.943 9.342 1.879 13.948-1.838-.505-2.08-2.469-2.291-3.626-.691-3.836-2.908-7.764-.219-11.7.146-.215.031-.609.039-.919z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1C184A"
        d="M514.592 299.718c2.48-.21 4.24.489 4.445 3.348.105 1.506 2.467 1.211 2.432 2.892-3.154-1.13-5.373-3.293-6.877-6.24z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#26235A"
        d="M560.165 189.864h-4.984c-.619.841-1.893.381-2.498 1.251-1.422 1.922-4.072 2-5.619 3.737-.82-2.798-3.625-4.396-4.354-7.269-.674-2.656-3.645-3.178-5.008-5.212.854-.821 1.936-.609 2.947-.611 9.623-.016 19.244-.022 28.869-.002 3.531.007 3.707.207 3.754 3.656.004.312.002.622.002.932-.008 1.345.016 2.689-.002 3.423-.49-2.874.859-6.463-.621-9.891v-1.247c.852-.735 1.848-1.233 2.848-1.729 1.912-.332 2.865.403 2.672 2.406-.797 1.234-.768 2.457.076 3.668.348 3.877.631 7.752-.008 11.625-1.066 1.251-1.082 2.769-1.059 4.293-.502 1.81-.42 3.655-.297 5.505a2.653 2.653 0 01-.422.801c-.801.691-1.494 1.717-2.781.887-.287-.378-.43-.813-.5-1.276-.135-1.169-.016-2.363-.334-3.512-1.242-1.551-2.848-2.864-3.314-4.935-.166-.874-.131-1.822-.928-2.458-.477-.392-.947-.739-1.4.033-.164.364-.328.72-.541 1.054-.389.461-.854.751-1.482.696-.844-.409-1.525-.925-1.311-2.02-.57-.771-1.479-1.382-1.205-2.552-.606-.871-1.879-.412-2.5-1.253z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2D1973"
        d="M577.631 194.85l-.004-12.47c-.646-.839-.65-1.673.016-2.504.281-1.944-.551-2.776-2.494-2.495-.832.668-1.668.661-2.506.016-11.646-.005-23.291-.037-34.938.008-2.396.009-4.732-.007-6.871-1.265-.49-.259-.617-.717-.66-1.219.145-.14.289-.28.434-.423 1.154-.63 2.424-.48 3.658-.481 13.486-.017 26.977-.025 40.467-.002 5.398.009 6.322 1.273 6.197 6.781-.109 4.86.111 9.731.08 14.598-.014.579-.047 1.157-.176 1.725-.49 1.279-1.063 2.459-2.781 2.171-1.472-1.354-1.275-2.865-.422-4.44z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2A2164"
        d="M572.651 179.877c1.627.603 2.268 1.168 1.525 3.327-.77 2.229-.223 4.908-.285 7.388-.021.815-.045 1.66-.27 2.431-.156.538-.814.609-1.33.445-.729-.232-.467-.66-.225-1.178 1.262-2.659.389-5.483.539-8.229.123-2.19-1.676-1.669-2.906-1.672-10.666-.03-21.332-.019-31.998-.019-.461-2.494 1.496-1.175 2.182-1.181 9.918-.094 19.834-.045 29.752-.093 1.09-.005 2.625.68 3.016-1.219zM572.643 177.397l2.506-.016c-.207 1.667-1.518 1.13-2.498 1.25l-.008-1.234z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EC3E48"
        d="M552.659 237.859l1.955-.654 3.063-1.136 4.996.047c.641 1.353-.393 1.525-1.273 1.829-.955.332-2.047-.049-3.117.648 1.627.593 2.826-.476 4.154-.659 2.602-.356 3.389.546 2.813 3.286-.719.556-1.566.627-2.422.663-3.717-.433-7.545.635-11.191-.804a1.91 1.91 0 01-.541-.86c-.146-.794.324-1.267.887-1.692.223-.222.449-.445.676-.668z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D3BDFB"
        d="M542.542 229.134c.695-1.439.924-3.091 1.994-4.358-.262 1.185 1.412 1.453 1.25 2.516-.293 1.91-1.659 2.111-3.244 1.842z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5A9D0"
        d="M546.463 247.349l-.076-1.359c.482-1.218-.889-3.082 1.291-3.71.277-.188.547-.182.805.047.523 1.112-.068 2.105-.334 3.134-.418.756-.4 1.91-1.686 1.888z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EBAED8"
        d="M551.981 238.527c-.188.374-.369.747-.553 1.12-.533 1.126-.994 2.326-2.547 2.344-1.447-.775-.395-1.473.07-2.189.477-1.686 1.856-1.235 3.03-1.275z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E3C2ED"
        d="M548.952 239.802c.203.622-.824 1.334.139 1.899a.646.646 0 01-.027.638.52.52 0 01-.617.022l-.768-.081c.132-.976-.415-2.301 1.273-2.478z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#292160"
        d="M562.043 216.074c1.127-1.115.434-2.52.602-3.789.475-2.018 3.174-2.616 3.152-4.95-.055-.939.393-1.683.934-2.392a1.87 1.87 0 011.184-.574c.463-.002.879.125 1.209.463 1 1.789-.434 3.073-.957 4.542-.334.939-1.123 1.998.762 2.115 1.672.314 1.813-2.029 3.332-1.938.203-.045.186.424.484.234-.174-.035-.297-.137-.375-.327-.104-.423.006-.773.268-1.093.371-.26.785-.367 1.225-.375 1.098-.022 1.74.777 2.473 1.367.131.199.422.142.406.118-.326-.479-.773-.878-.924-1.478-.281-1.138-.207-2.208.57-3.149l.018-.018c.279-.235.598-.313.957-.235 1.658 1.213 2.584 2.836 2.75 4.894-.961 3.466-.492 7.011-.596 10.522-.193 6.521.393 13.052-.316 19.565-.443.565-.963.612-1.545.228-.01-2.075.113-4.163-.078-6.22-.131-1.374-.74-1.461-1.182-.032-.826.654-1.65.663-2.48.011-1.236-1.356-.623-4.042-3.539-4.354-.93-.1-.852-1.999-.518-3.317.758-2.993.139-3.555-2.883-2.881-.432.095-.875.288-1.01-.167-.778-2.571-3.694-3.895-3.923-6.77z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F8374B"
        d="M551.485 240.427c3.674 1.141 7.465.187 11.18.614.834.81 1.666.809 2.496-.004.27-2.768-1.318-2.818-3.291-2.203-.367.115-.619.602-.988.709-1.299.377-2.643.474-3.916-.05-.529-.216-.615-.886-.373-1.351.766-1.479 2.193-.625 3.322-.839 1.014-.193 2.395.509 2.758-1.185 2.27-.308 4.375.174 6.105 1.653.811.691 1.639.774 2.564.819.43.447.859.896 1.291 1.344.344.351.404.742.172 1.175-2.031.494-2.381 2.183-2.742 3.869-.355.28-.764.423-1.201.49-2.121.077-4.139-1.386-6.32-.419-2.998-.922-5.98-1.423-8.883.313-.277.567-.514 1.162-1.133 1.461-2.072-.448-1.771-2.144-1.91-3.612-.012-.677.041-1.347.256-1.995.144-.312.347-.573.613-.789z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#570D58"
        d="M576.377 242.337l1.246.009c1.098.986.664 2.654 1.654 3.691.297.754.207 1.546.234 2.327-.029 1.104.076 2.212-.117 3.312a1.42 1.42 0 01-.58.732c-.965-.055-1.295-.79-1.637-1.517-.369-1.628-.412-3.341-1.258-4.851a5.348 5.348 0 01-.268-1.417c-.043-.853.131-1.638.726-2.286z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B1D6C"
        d="M573.915 233.564c.828-.003 1.652-.006 2.48-.011-.473 1.383 1.125 3.988-1.123 4.036-2.225.048-1.07-2.566-1.357-4.025z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#34176B"
        d="M578.885 246.044c-2.217-.62-.84-2.467-1.262-3.7l.031-2.539 1.227-.031c.967 2.09.961 4.18.004 6.27z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CD3A50"
        d="M572.641 241.034l-.008-1.102c1.25.312 1.781 1.403 2.488 2.302.363.296.432.675.318 1.106a1.031 1.031 0 01-.604.506c-.814.091-1.219-.403-1.516-1.054-.231-.581-.617-1.105-.678-1.758z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#79162D"
        d="M575.2 243.494l-.078-1.259c.42.033.84.067 1.256.102-.006.846-.014 1.692-.023 2.537-.995.051-1.151-.601-1.155-1.38z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FEFEFE"
        d="M470.35 296.588c.84 1.858 1.684 3.72 2.523 5.581.217 5.451-.078 5.834-5.893 7.685-2.832 1.382-5.494 1.136-7.955-.852-.076-.219-.023-.398.17-.526-.242-.116-.191.239-.381.239-.664.411-1.33.366-2.004.09-.783-.43-1.242-1.206-1.902-1.765-1.006-1.053-2.205-1.68-3.695-1.682-1.908-.601-3.85-1.146-5.084-2.918-.578-2.413-2.594-2.58-4.529-2.961-1.598-.314-3.533-.479-2.594-3.031.799-1.585 2.029-2.913 2.723-4.563 2.467-3.845 2.4-7.979 1.406-12.22-.148-.626-.082-1.234.113-1.837.787-1.229 1.346-2.384-.627-3.083-1.188-.419-2.117-1.228-3.016-2.107-1.494-1.456-3.203-1.777-5.063-.647-.514.28-1.035.534-1.646.468-.574-.198-.965-.629-1.361-1.057-1.361-1.812-1.361-1.812-.086-2.607-1.941 1.114-3.746 2.575-6.1 2.693a4.745 4.745 0 01-.85.149c-1.646 0-3.225-.554-4.887-.507-3.873.111-5.898 1.814-6.574 5.518-.217 1.188.703 1.309 1.314 1.76.248.144.471.317.676.514.395.518.652 1.048.25 1.698-1.158 1.868.52 1.168 1.232 1.34.576.079 1.102.299 1.607.575.816.505 1.445 1.085.867 2.149-.979 2.388-.064 4.863-.322 7.282-.002.738.121 1.459.314 2.172.098.453.119.906.057 1.364a3.364 3.364 0 01-.281.855c-1.404 1.787-2.279 1.417-2.756-.55.295 2.253-.414 4.869 2.262 6.567 1.061.672.707 2.105-.469 2.45-1.66.483-1.596 1.598-1.656 2.854-.082 1.801-.596 3.45-1.977 4.728-.533.361-1.137.501-1.76.571-1.15.03-2.178.058-2.641 1.517-.6 1.894-2.097 2.397-3.958 1.968a2.992 2.992 0 01-.803-.426c-.408-.312-.682-.759-1.297-1.289.105 2.115-.248 4.012.561 5.916.852 2.006-.191 2.604-2.1 2.5-2.775-.146-5.592-.656-8.271.617-3.883-1.35-7.688-.785-11.471.447-2.316-.039-4.626-.783-6.947-.031-1.188.061-2.377.143-3.521-.301-.754-.357-1.289-.961-1.793-1.6-.719-1.168-.863-2.652-2.66-3.111-3.883-.992-4.083-1.457-3.409-5.257-3.779 3.847-3.94 3.792-7.062-2.422-.025.64.353 1.504-.413 1.813-.881.359-1.256-.502-1.531-1.129-.541-1.229-.971-2.508-2.174-3.293a17.12 17.12 0 01-1.525-1.593c-.564-.912-1.024-1.832-.221-2.846.328-.438 1.076-.896-.083-1.251-1.087-.244-2.263-.135-3.215-.858-.268-.379-.321-.796-.218-1.24.484-.867.928-1.752 1.127-2.738.445-1.247.725-2.546 1.221-3.776.242-.406.565-.682 1.072-.658 1.558 1.021.729 2.633 1.141 4.618-.009-4.109 2.753-5.778 5.224-6.745 4.341-1.696 5.635-4.948 6.255-8.943.195-.751.631-1.288 1.371-1.549.879.108 1.413-.165 1.26-1.177.18-.708.639-1.166 1.275-1.468.932-.227 1.547-.778 1.76-1.743.311-.668.795-1.139 1.52-1.329 3.586-.843 7.904-4.834 8.173-7.562.688-.565 1.635.229 2.291-.456.824-.349.883-1.181 1.172-1.869 1.57-2.982 4.891-4.202 6.844-6.88 1.133-1.556 1.875-2.896 1.396-4.772.061-.636.357-1.122.914-1.441 4.256-.446 8.289-3.787 9.523-7.916.148-.499.152-1.181.539-1.427 2.447-1.555 1.027-3.17.156-4.794.09-.98.438-1.779 1.465-2.101 2.816 1.406 5.272.638 7.69-1.148-.834-1.487-5.642-.645-2.35-4.176.217-.169.463-.287.729-.357.574-.071 1.244.009 1.377-.821.295-1.27-.646-2.206-.883-3.331-.025-1.468.828-2.452 1.838-3.35 1.973-.197 2.398-2.55 4.18-3.021 3.439-.771 3.846-3.862 4.945-6.432.768-1.794 1.594-3.569-.348-5.173.227-2.535 2.008-4.341 3.033-6.503 1.961-3.186 3.385-6.651 5.15-9.94 1.32-1.83 2.174-3.915 3.238-5.883.52-.956.84-2.144 2.211-2.296 1.758.634 2.268 2.28 2.875 3.76.471 1.149.691 2.203 2.191 2.625 1.49.419.691 1.933.748 2.949.086 1.567-.912 3.206.359 4.69.99 8.936 1.773 17.903 3.715 26.705.197.891.52 1.754.785 2.629.551 3.809.945 7.651 2.354 11.282.287.332.441.715.068 1.044-.516.456-.895.103-1.221-.313-.256-.304-.492-.623-.641-1 .115.384.369.682.621.985-.182 1.497.381 1.873 1.689 1.13.848 2.338 1.691 4.677 2.539 7.014.654 2.428 1.313 4.856 1.967 7.283.947 2.029-1.551 3.681-.697 5.696 1.063.444 1.496-1.146 2.502-.657 1.268 3.324 2.533 6.651 3.799 9.978.402.64.424 1.128-.475 1.315-.314.066-1.514-.365-.604.582 1.898 1.973 1.273 4.514 1.648 6.763.361 2.16.924 3.276 3.252 2.857.404-.072.811.109 1.172.332.502.444.678 1.031.721 1.673-.209 1.781.836 3.258 1.18 4.902.25 1.186.305 2.398-.256 3.541-.322.451-.783.807-.982 1.354.199-.27.316-.594.564-.84.904-.813 1.934-1.361 3.129-1.575.328.054.508.246.541.576.269 2.092 1.658 3.628 2.654 5.357z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FBFBF8"
        d="M440.333 197.975c-.604.178-1.246.455-1.246-.615-.002-1.237.043-2.438.449-3.651.246-.733.076-2.329.043-2.33-4.729-.185-2.615-5.596-5.479-7.133-.785-.936-.184-1.768.189-2.62 1.115-1.228 1.309-3.254 3.246-3.78 1.537 1.2 1.221 3.198 2.035 4.71.014 1.288-.447 2.581.102 4.266.002.011.463-.505.082-.338-.162.071-.283.013-.26-.159.131-.94-.813-2.208.813-2.698.008 4.783.016 9.565.026 14.348z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FEFEFE"
        d="M439.834 172.447l1.23-1.86c1.02-.035.902.468.521 1.095l-.727 5.703c-1.061.553-2.133.512-3.213.048-.482-.958-.016-1.717.51-2.464.373-.966.648-1.996 1.679-2.522z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F8FCEA"
        d="M437.692 177.337c1.057-.122 2.117-.352 3.168.046.092 1.32.059 2.625-.438 3.878-.822-.081-.785.867-1.334 1.111-1.645-1.027-.775-3.069-1.764-4.361-.329-.471-.068-.62.368-.674z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FEFEFE"
        d="M439.088 182.373c.156-.719-.41-1.73.549-2.098.635-.244.594.583.785.987-.039.788-.078 1.576-.115 2.365-1.096.775-.191 2.141-1.219 3.532v-4.786z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DECAF2"
        d="M441.586 171.682l-.521-1.095c.402-1.562.457-1.618 1.289-1.374-.312.804.115 1.841-.768 2.469z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6F4FD"
        d="M466.551 309.07c4.256-.33 5.867-3.089 6.322-6.901l7.137 11.992c.732 1.22 1.461 2.437 2.193 3.653 6.338 10.9 13.551 21.186 21.678 30.83 3.887 4.76 7.41 9.855 12.477 13.529 1.863 3.316 4.701 5.705 7.613 8.025 1.006.883 2.014 1.762 3.021 2.643 2.182 2.484 5.117 4.055 7.545 6.238 5.482 4.076 10.975 8.135 17.408 10.652.014.998-.805 1.029-1.455 1.26-4.578-.043-8.949-1.443-13.434-2.127-12.492-1.904-24.928-4.195-37.525-5.348a6.174 6.174 0 01-1.002-.172c-1.25-.492-2.566-.426-3.875-.447a9.369 9.369 0 01-1.959-.244c-1.439-.498-2.934-.314-4.408-.342-1.035-.012-2.068-.016-3.086-.248-2.074-.641-4.205-.268-6.311-.354-1.504-.033-3.012.07-4.496-.264-6.6-.379-13.186-.949-19.805-.947-1.203 0-2.482.402-3.619-.367a.752.752 0 00-.064-.566c-.578-2.377-.1-4.795-.277-7.184-.35-.926.008-1.82.1-2.729l.139-1.041c-.525-2.221.014-4.432.125-6.637.068-1.355 1.273-1.727 2.465-1.871 1.412-.174 2.799-.4 3.938-1.645-1.332-.4-2.186.354-3.129.65-3.021.943-3.133.885-3.438-2.453.088-.797.354-1.516.939-2.086.234-.195.496-.346.783-.457 1.686-.223 3.002-.926 3.49-2.699.189-.375.457-.682.814-.9.711-.313 1.436-.609 1.771-1.406.986-1.656 2.525-2.668 4.139-3.596 1.887-.396 3.004-1.549 3.377-3.432a4.626 4.626 0 011.293-1.73c2.283-2.768 4.762-5.486 2.191-9.389-.453-1.633 1.084-2.98.84-4.627-1.4.109-1.031 2.846-3.002 1.713-.744-2.141-.951-4.154 1.291-5.596 1.492-2.045 1.248-4.34-.791-6.497-.814 1.321.078 2.132.746 2.983.826 1.055 1.381 2.121.25 3.32-1.029.729-2.176.934-3.404.789-1.609-1.045-.701-3.982-3.254-4.332-.951-.678-1.311-1.672-1.488-2.763-.217-4.039-.221-4.183 3.598-4.323 1.985-.069 1.079-2.018 2.139-2.557z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2F1580"
        d="M522.717 168.65c.016-.448.033-.896.047-1.344l1.137.126c1.619.999 2.955 2.302 4.107 3.809.127.473.064.909-.254 1.295-.465.227-.902.214-1.297-.146a10.195 10.195 0 01-3.74-3.74z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2D1973"
        d="M526.458 172.389l1.355-.053c1.318-.662 1.85.452 2.568 1.14.207.432.234.858-.041 1.274l-.166.17-1.832-.033c-1.002-.552-1.82-1.241-1.884-2.498z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9F9F8"
        d="M462.807 281.601c-.998.205-1.984.473-2.988.599-1.17.149-1.955-.171-2.027-1.619-.1-2.146-.404-4.281-.602-6.422-.066-.708.094-1.656-.83-1.768-1.818-.218-1.273-1.362-.857-2.194.85-1.696 1.332-.052 1.947.327l.363-.772c1.004.821.451 2.499 1.738 3.166.446 3.133 2.549 5.646 3.256 8.683z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7F8F6"
        d="M454.014 259.773c-.311.268-.662.501-.922.809-.449.533-.172 1.868-1.559 1.32-1.242-.488-1.438-1.515-1.117-2.555.486-1.572 1.186-3.078 1.793-4.613.905 1.572 1.475 3.262 1.805 5.039z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#27225E"
        d="M450.971 380.133c6.73.068 13.465.121 20.197.225 1.229.02 2.451.254 3.68.389-3.047 1.053-6.148.104-8.809.428 9.662.361 19.793-.07 29.791 1.684 2.311 1.635 4.574 2.018 7.553 1.35 3.932-.881 7.939.875 11.938 1.303 1.5.164 3.012.553 4.561.713 7.074.74 14.064 1.928 21.047 3.379 4.611.955 9.348 2.75 14.25 1.229 7.178 3.313 14.643 4.549 22.479 3.129.729.887.602 1.957.604 2.986.012 9.037.023 18.076-.004 27.113-.008 3.508-.43 3.848-4.018 3.631-1.244-.074-2.492-.037-3.738-.037-38.65-.002-77.297.006-115.945-.016-1.424-.002-2.918.35-4.266-.469-.627-1.701.627-1.971 1.762-2.174 1.225-.221 2.484-.092 3.729-.092 37.145-.004 74.291.002 111.438-.021 1.623 0 3.344.4 4.803-.703.33-.438.627-.936-.164-1.145-.906-.24-1.859-.111-2.791-.113-37.777-.002-75.555-.008-113.33.012-1.426 0-2.92-.324-4.236.559-1.328 1.865-2.541 1.566-3.67-.203 0-3.832-.008-7.662 0-11.494.01-8.52 1.387-16.914 2.463-25.33.189-1.473-1.174-3.84 1.092-4.342 1.455-.32 3.055-.793 4.828-.414 1.867.398 3.959-.248 6.445-.486-4.189-1.091-8.087.637-11.689-1.091z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#31197D"
        d="M450.329 427.041c40.563-.002 81.125-.006 121.688-.006 5.613 0 5.623.01 5.629-5.619.01-9.152.01-18.305.012-27.457.41-.006.82-.012 1.229-.016.004 10.385-.049 20.77.057 31.156.023 2.338-.494 3.246-3.086 3.242-41.852-.09-83.705-.074-125.559-.086-.351-.411-.304-.816.03-1.214z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B2855"
        d="M555.178 390.83c-2.34 2.709-5.602 1.572-7.934.9-3.322-.955-6.742-1.125-10.049-2.063-6.545-1.857-13.395-1.996-20.096-2.908-3.486-.473-7.408-.072-10.773-2.02-.748-.432-2.242-.352-2.996.125-3.07 1.93-5.406 1.145-7.447-1.518.838-1.182 2.189.008 3.135-.676 10.236.613 20.297 2.535 30.406 4.08 7.121 1.086 14.217 2.348 21.326 3.533 1.043.26 2.086.363 3.119-.055.436.204.874.401 1.309.602z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A8A4CF"
        d="M553.87 390.23c-1.02 1.313-2.074.449-3.119.055.398-.184.797-.367 1.195-.553l.693-.012c.41.169.82.341 1.231.51z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9F9F6"
        d="M467.125 290.985c-.764 1.059-1.805 1.427-3.072 1.234-.115-2.069.396-4.191-1.047-6.105-.646-.86.088-1.93.521-2.841.926 1.763 1.852 3.525 2.781 5.288.935.585 1.525 1.286.817 2.424z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2C2847"
        d="M467.125 290.985c-.273-.809-.545-1.615-.816-2.424 2.057.058 1.342 1.565 1.395 2.67-.194-.082-.385-.165-.579-.246z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7F7F7"
        d="M445.954 239.167c.641.296 1.242.517 1.232-.576.693.468.609 1.156.518 1.846-.344.879-1.191 1.632-1.895 1.243-1.23-.678-.063-1.66.145-2.511v-.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DD3756"
        d="M551.569 194.261c3.1-2.834 6.451-1.937 9.826-.658.307.555 1.924.105 1.143 1.494-.682.49-1.471.54-2.268.554-2.068-.057-3.771-2.061-6.031-1.14-.91.131-1.846.51-2.67-.25z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DD4C5B"
        d="M551.569 194.261l2.436-.599c.293.384.301.794.107 1.22-1.768 1.049-3.705 1.914-4.445 4.087-.158.424-.377.807-.74 1.091-.461.18-.889.165-1.256-.207.021-.605.045-1.211.066-1.817 1.137-1.4 1.955-3.127 3.832-3.775z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5D1D40"
        d="M562.504 194.88a631.46 631.46 0 00-1.109-1.277l2.475.064 1.313 1.805c.502.558.531 1.16.166 1.8-1.96.406-2.632-.719-2.845-2.392z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#262159"
        d="M552.682 191.115c.199-1.68 1.514-1.134 2.498-1.251-.209 1.665-1.517 1.13-2.498 1.251zM560.165 189.864c.984.117 2.299-.429 2.5 1.25-.983-.12-2.293.415-2.5-1.25z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F23749"
        d="M548.92 199.837l.045-1.215c1.285-.741 1.576.267 1.873 1.119.26.756.281 1.597.822 2.25.355 1.32 1.25 2.18 2.416 2.81.336.917.205 4.412-.189 5.253-1.586.359-2.547-.997-3.855-1.405-1.91-1.107-2.445-2.883-2.393-4.943-.73-1.673-.076-2.888 1.281-3.869z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E03A5B"
        d="M550.032 208.649c1.596-.613 2.58.832 3.896 1.157 1.779-1.331 3.066.264 4.545.752.266.162.451.391.576.673-2.127 1.225-4.24.2-6.357-.04-.863-.871-2.297-1.146-2.66-2.542z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E64150"
        d="M548.92 199.837c-.395 1.299-1.641 2.317-1.281 3.868-.969-1.291-.559-2.571.031-3.852.416-.004.834-.01 1.25-.016z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9F1FA"
        d="M525.844 212.332c2.238.068 3.947 1.93 6.232 1.848 1.553 1.68 4.098 1.512 5.715 3.068-.449.612-1.201.725-1.781 1.123.959.227 1.184-.749 1.771-1.13 2.23.474 4.326 1.235 6.037 2.819.326 3.474-2.006 6.095-2.953 9.162-.326 1.054-.813 2.058-1.227 3.085-.25.413-.502.826-.754 1.239-.215.194-.453.242-.723.124-.648-.486-1.43-.785-1.982-1.411a2.248 2.248 0 01-.236-.816c.008-.449.141-.851.453-1.183 1.248-.516 2.465-1.061 2.492-2.755-1.004.212-1.332 1.361-2.309 1.517-.299.07-.598.094-.898.093-.604-.018-1.236-.159-1.799.059-2.205.858-3.18-.231-3.646-2.207-.268-1.631-.418-3.261.125-4.868.141-.293.373-.492.682-.595a.94.94 0 01.734.396c.197.819.578.682 1.033.166.426-.134.799-.063 1.129.235.576.517.646 1.198.631 1.908.119-.819-.123-1.505-.766-2.039-1.186-2.318-3.193-4-4.764-6.021-.717-.922-2.406-2.75-3.236.257-.4.993-.502 2.299-1.914 2.368-.867.043-1.088-.726-1.174-1.463.763-1.836.798-4.128 3.128-4.979z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E03A5B"
        d="M565.073 207.285c-1.881 1.513-3.256 3.794-6.027 3.945.004 0-.168-.196-.168-.196-.184-.258-.389-.638-.217-.847 1.842-2.19 4.027-3.995 6.438-5.532.275.207.459.475.561.804.149.721-.009 1.342-.587 1.826z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6D1D4A"
        d="M565.073 207.285c.039-.58.078-1.161.119-1.741.559-.595-.305-1.953 1.117-2.084.834.461.396 1.342.658 1.992-.389.628-.781 1.256-1.17 1.883l-.724-.05z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#40A3E8"
        d="M548.952 272.269c1.244-.207 2.654.486 3.725-.68 1.797-.552 3.639-.14 5.453-.27 1.441.516 2.99.631 4.445 1.116.748-.198 1.463-.229 2.047.402 1.824 2.099 4.611 3.022 6.369 5.203.549.78 1.082 1.574 1.783 2.233a.608.608 0 01-.174.714c-1.531.473-2.426-.945-3.693-1.251-1.152-.819-2.199-1.761-3.217-2.743-1.086-1.048-2.115-1.052-3.023.246-.943.828-1.869.542-2.854.03-2.375-1.234-4.688-.852-5.813 1.538-.713 1.513-2.438 2.37-2.455 4.321-.006.939-1.17 1.029-1.982 1.112-1.439.149-2.893.144-4.334.041-3.018-.214-3.543-1.049-2.791-4.271.869-1.145 2.205-.935 3.393-1.183 1.939-.402 3.324-1.299 5.059-3.361-3.398.544-5.936 1.821-8.004 4.073-.936.946-1.428 2.294-2.688 2.944-.469.139-.898.09-1.264-.266.277-1.771 1.156-3.198 2.486-4.368 1.881-2.707 5.282-3.37 7.532-5.58z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5486C4"
        d="M570.784 278.503c-1.553-1.427-3.084-2.858-5.016-3.827-.574-.289-2.002-.478-1.146-1.838 2.951 1.202 5.35 3.117 7.258 5.658-.364.37-.727.356-1.096.007z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5479B3"
        d="M562.575 272.436c-1.367.313-2.572-.09-3.691-.852.014-.13.025-.263.041-.396.42.12.84.24 1.262.359.808.262 1.905-.253 2.388.889z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6F8AC3"
        d="M572.6 280.988c.023-.201.033-.404.027-.605-.186-.178-.234-.34-.148-.485.08-.137.158-.205.23-.205.162.032.322.072.477.126.248.564.496 1.132.742 1.696l-.082.74c-.814-.032-1.176-.507-1.246-1.267z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#368BC7"
        d="M572.709 279.692c-.025.23-.053.46-.082.69-.793-.451-1.457-1.031-1.844-1.88l1.096-.007c.276.401.555.799.83 1.197z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E63D59"
        d="M575.129 259.766c-1.576 2.265-3.402 4.229-6.166 5.044-.416.313-.857.334-1.314.103-.73-1.2.148-1.703.984-2.152 1.508-.804 2.596-2.049 3.676-3.313.922-.965 1.227-2.281 1.92-3.378.521-.828.828-1.937 2.205-1.443.365.354.514.799.535 1.296.098 1.62-.945 2.695-1.84 3.843z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#621C63"
        d="M575.129 259.766c.432-1.241.865-2.479 1.301-3.72.447-.392.084-1.342.986-1.419l.307.216c-.082 2.053.154 4.276-2.594 4.923z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5D1860"
        d="M577.766 251.027l1.117 1.246c.557.615.504 1.234.016 1.857l-1.176.712-.135-.099c-.918-1.284-1.037-2.531.178-3.716z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BE4D68"
        d="M567.649 264.707c.436.034.877.066 1.314.101l-.135 1.245-1.252-.212c-.428-.271-1.213.06-1.309-.774.331-.621.776-.791 1.382-.36z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1D2063"
        d="M578.899 254.131l-.016-1.857.07.021c.395-.392.809-.387 1.24-.068l.035-.036c.279.463.307.911-.084 1.331l-.633.629a43.09 43.09 0 01-.612-.02z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4681C3"
        d="M576.458 290.264l-.656.689c.117-1.915-.994-3.684-.646-5.624 1.542 1.354 1.143 3.217 1.302 4.935z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#56A7D9"
        d="M652.571 252.295c.055.875-.229 1.641-.752 2.325-.365.079-.729.161-1.09.241.582-.879.154-2.482 1.842-2.566z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5342DE"
        d="M587.645 189.889h1.229c.004.417.01.833.018 1.25l-.678 1.203c-1.25 1.644-2.313 3.586-4.914 3.065a1.869 1.869 0 01-.799-.477c-.314-.654-.195-1.341.412-1.611 1.834-.815 2.947-2.584 4.732-3.43z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3290D6"
        d="M608.87 202.272c.031 1.838-.678 3.852 2.57 3.981 2.01.081.838 2.309 1.146 3.557-2.854-.391-2.584 2.425-3.807 3.707-2.381-.486-3.461 2.965-6.004 1.984l-.189 1.815c-.973.125-2.271-.401-2.477 1.247-1.363.079-2.055 2.155-3.746 1.263-.434-.837-.602-1.676-.014-2.521v-2.455c-.457-.374-.791-.866-1.207-1.28l.002-1.229c.822-.689 1.652-.666 2.486-.023 1.234.315 2.473-.643 3.707.008.844-.816.824-1.645.039-2.486.004-.42.004-.84.008-1.26a2.652 2.652 0 011.029-.631c.846-.283 2.072-.437 1.434-1.735-.631-1.285-1.631-.864-2.504-.102l-1.207-.055c-.406-.309-.58-.741-.664-1.226.025-1.425-.02-2.854.141-4.28.84-1.849 2.43-1.498 3.949-1.342 2.077.489 4.333.663 5.308 3.063z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EAF9F8"
        d="M594.42 224.224c-1.02-.231-1.102-1.365-1.814-1.893-1.799-1.186-3.41-2.496-3.268-4.96.814-.66 1.49.334 2.021.249-1.043-2.231.553-4.504.023-6.708.439-.207.855-.189 1.227.153l1.336-.572.006 4.773c.512 2.122-.135 4.452 1.164 6.431.082.142.109.29.084.449-.115.746.048 1.597-.779 2.078z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2A92DB"
        d="M601.344 206.112c.346-.69-.553-2.432.924-1.956 1 .323 3.092.333 2.865 2.586-.131 1.304-.564 1.911-1.881 1.843-.621-.032-1.246-.005-1.869-.005-.011-.823-.025-1.645-.039-2.468z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DBF6FC"
        d="M593.926 210.542l.568-1.35c.367-.514.824-1.075 1.469-.932 2.182.483 2.174-.983 2.26-2.406.098-.462.287-.87.674-1.163.342-.08.615.02.822.299.246 1.245-.189 2.547.318 3.769.145 2.103-.551 2.953-2.609 1.734-1.183-.7-2.342-.473-3.502.049z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D7F4F7"
        d="M595.116 221.695c-2.32-1.792-.877-4.268-1.164-6.43.386 2.144.777 4.287 1.164 6.43z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3892CE"
        d="M597.631 212.318l-2.486.023c.053-.67.303-1.155 1.066-1.207.86-.058 1.331.331 1.42 1.184z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2A92DB"
        d="M601.377 209.84c.879.066 1.25.554 1.188 1.413-.057.766-.561 1.008-1.227 1.073l.039-2.486z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6097BA"
        d="M600.038 208.759c-.873-1.142-.479-2.531-.746-3.791.234-.314.508-.35.813-.107.012.399.021.798.033 1.196l-.1 2.702z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3892CE"
        d="M595.143 213.57c.811.042 1.217.464 1.207 1.279-.313.22-.82.688-.91.62-.647-.503-.168-1.258-.297-1.899zM596.35 217.305c.004.841.008 1.682.014 2.521-.43-.838-2.197-1.668-.014-2.521z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6FAF2"
        d="M586.311 196.083l3.813.017c1.033 1.739 3.406 3.181 1.242 5.626-.201.205-.443.32-.727.346a1.65 1.65 0 01-.762-.297 8.05 8.05 0 01-.584-.569c-1.201-1.106-2.969-.187-4.203-1.166-.279-.339-.359-.726-.279-1.15 1.412-.411-.125-1.038.107-1.539.233-.68.448-1.376 1.393-1.268z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF9F8"
        d="M608.87 202.272c-1.498-1.154-3.205-1.865-5-2.397-1.432-1.063-3.244-.253-4.744-.972-.1-.115-.197-.23-.297-.347 1.025-1.796 4.061-.854 4.109-3.76 1.033.888 1.07 1.579.684 2.056-.99 1.223-.385 1.597.789 1.742 1.736.215 3.17 1.605 5.049 1.276 1.943-.34 1.459 2.441 3.133 2.463l.025 1.163c-1.072.896-1.723.247-2.311-.628l-1.437-.596z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FCFAF2"
        d="M598.825 206.128c.936 4.38-2.641 2.388-4.33 3.064.402-1.474.748-2.943.646-4.503-.063-.97-.281-2.151 1.234-2.349 1.57-.738 1.736.485 1.916 1.469.145.786-.121 1.65.534 2.319z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E5F9FD"
        d="M598.825 206.128c-1.262-.188-1.219-1.146-1.211-2.07.01-.885-.16-1.624-1.238-1.717.91-1.202.826-3.047 2.453-3.784l.18.196c.291.383.355.826.342 1.29-.17 1.594.775 3.303-.482 4.789-.013.432-.031.864-.044 1.296z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FEFEE7"
        d="M592.61 211.064l-1.229.008c-.982-1.008-.82-2.186-.508-3.388.221-.504.586-.839 1.127-.968 1.198 1.31.389 2.902.61 4.348z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D8ECF5"
        d="M590.625 201.779l.74-.053.029 3.749c.293 1.095-.525 1.583-1.18 2.163-.42.191-.859.246-1.313.174a1.697 1.697 0 01-.748-.435c-.135-1.191 1.086-1.572 1.461-2.46.57-.972.197-2.249 1.011-3.138z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6FAF2"
        d="M590.118 207.327l1.277-1.853c.494.272.594.736.605 1.242l-.619.624c-.423.373-.845.328-1.263-.013z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4B83C2"
        d="M586.311 196.083c-.393.405-.783.811-1.176 1.217-.51.677-1.072 1.306-1.744 1.834-3.73 2.826-3.922 4.074-1.328 7.865 1.025 1.502 2.537 2.731 2.775 4.704-.211.923-.859 1.146-1.697 1.063a1.69 1.69 0 01-.734-.425c-.527-1.235-1.078-2.457-2.301-3.197a12.677 12.677 0 01-.568-.568 4005.75 4005.75 0 00-2.43-3.784c-.693-1.371-.568-2.748-.029-4.127.242-.62.605-1.139 1.236-1.424.654-.611 1.311-1.222 1.967-1.833.459-.691 1.373-.866 1.793-1.603.334-.468.834-.689 1.334-.915 2.443.742 2.719-2.613 4.805-2.548l1.365.688c-.662 1.472-2.688 1.488-3.268 3.053z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4789B4"
        d="M610.307 202.867l2.311.628a.44.44 0 00.43.178l1.439 1.125c-1.023.011-2.049.089-3.064.014-1.239-.092-1.864-.657-1.116-1.945z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5A21DD"
        d="M548.93 161.146c-1.246.81-2.49 2.594-3.744.008l3.744-.008z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7636E3"
        d="M592.633 323.428c-1.236.162-1.783 1.215-2.553 1.979-.822-.613-1.643-1.227-2.463-1.842-.277-.387-.359-.805-.174-1.254.936-.83 1.922-1.609 2.68-2.623l3.734 3.75c-.409.355-.819.359-1.224-.01z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7432E6"
        d="M583.057 317.107l3.311.031c.557 1.354.322 2.424-1.104 3.07-.996.246-1.896-.072-2.785-.471-.568-1.044-1.303-2.124.578-2.63z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7144C0"
        d="M582.479 319.738l3.289-.064c.209-.229.447-.277.719-.119.566.639.643 1.508 1.041 2.229.037.133.068.264.1.396l-.01 1.385-5.139-3.827z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7733F5"
        d="M586.354 319.693c-.195-.002-.393-.01-.586-.02.201-.846.398-1.689.6-2.535a1.948 1.948 0 011.24-1.223c1.396-.011 2.779.023 3.76 1.262-1.639.23-1.143 1.516-1.244 2.51.279 1.941-.555 2.77-2.496 2.492l.004-.004c-.854-.607-.682-1.741-1.278-2.482z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6F2BFE"
        d="M592.633 323.428c.408.002.816.006 1.225.01l.063 2.516c-.088.449-.104.936-.625 1.148-.344-1.204-.868-2.373-.663-3.674z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6518F1"
        d="M587.645 189.889c-.691 2.626-3.637 2.98-4.984 4.946-2.209.644-1.848-1.088-1.854-2.179-.023-4.569-.117-9.139-.051-13.708.063-4.27-.352-4.683-4.549-4.687-13.826-.016-27.65.004-41.477-.003-1.664-.001-3.375.171-4.492-1.482-.395-.536-.436-1.081-.035-1.635 1.055-.203 2.549-2.084 2.67.951.055 1.383 1.693 1.019 2.592.872 7.523-1.234 15.09-.377 22.631-.542 7.254-.158 14.516.039 21.771-.078 2.205-.035 3.004.709 2.793 2.858-.127 1.335.123 2.713-.053 4.037-.371 2.779.986 3.306 3.412 3.192 1.818-.086 2.197-.813 2.285-2.46.129-2.527-.729-5.146.574-7.583 0 2.895-.076 5.792.025 8.683.064 1.801-.436 2.762-2.418 2.573-.797-.077-1.713-.219-2.365.433-.693.693-1.867 1.292-1.27 2.536.584 1.224 1.805.813 2.742.587.992-.238 1.852-1.83 2.947-.585 1.151 1.306-.96 2.063-.894 3.274z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5824E7"
        d="M530.225 158.641l1.863.61c.447-.229.734.015 1 .332.297.443.711.733 1.205.919.369.143.711.326.926.675-.432 1.829-1.918 1.388-2.922 1.044-1.552-.529-2.332-1.834-2.072-3.58z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3E57D1"
        d="M538.958 159.892c-.1.893.156 1.697.613 2.45-.922.077-1.758.023-1.867-1.183-.662-.931-2.031-.351-2.699-1.267-.18-.453-.154-.871.213-1.229 1.283-.043 2.576-.136 3.725.628-.005.202.001.402.015.601z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5822C3"
        d="M527.688 171.186c-1.697-.813-2.938-2.086-3.785-3.754.439-.014.879-.029 1.32-.042 1.309.354 2.139 1.189 2.496 2.497.371.442.328.874-.031 1.299z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5E1ED2"
        d="M527.688 171.186l.031-1.3 2.484 1.254c.006.415.012.83.02 1.245.365.434.32.86-.029 1.28-.793-.442-1.586-.886-2.381-1.328-.043-.384-.082-.767-.125-1.151z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4A29DE"
        d="M535.19 159.873c.975.162 2.34-.439 2.514 1.287l-2.484.018-1.264-.031c-.363-.648.035-1.036.477-1.411a.702.702 0 01.757.137z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4816B4"
        d="M477.788 464.48h69.896c-.92 1.02-2.139.604-3.225.604-21.148.025-42.297.025-63.445.002-1.09-.002-2.308.412-3.226-.606z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4B13B6"
        d="M552.68 463.857c8.912-.002 17.822-.018 26.732.016 1.088.004 2.305-.418 3.223.605h-29.953c-.002-.208-.002-.414-.002-.621z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#272358"
        d="M450.329 427.041c-.01.406-.021.811-.029 1.215l-.602.021c-.621.457-1.242.535-1.867.008l-.002-4.998c.83-.777 1.664 2.555 2.494-.002.9-.688 1.871-.668 2.879-.297 1.631.988 3.443.648 5.186.65 36.295.02 72.59.01 108.885.025 1.646.002 3.334-.268 4.924.453.154.137.305.277.455.418-.506 2.053-2.186 1.207-3.35 1.211-30.129.047-60.26.035-90.391.035-8.518 0-17.039-.023-25.559.029-1.092.009-2.643-.69-3.023 1.232z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F2F9F3"
        d="M451.526 356.418l.123 2.574c1.652-.594 3.262-.908 4.756-1.736.66-.363 1.953-.516 2.436.596.523 1.201-.393 1.445-1.328 1.889-3.111 1.475-5.648 4.898-6.609 8.563-.027.098-.025.205-.035.309a6.536 6.536 0 01-.445-.283c-.578-.475-.822-1.109-.885-1.836-.07-1.047-.041-2.098-.064-3.15a48.669 48.669 0 01-.014-1.621c.018-1.229-.098-2.467.131-3.674.192-1.012.426-2.119 1.934-1.631z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2C176D"
        d="M449.04 432.033c.299 3.334 1.699 6.527 1.291 9.955-.016.859-.031 1.723-.049 2.582-.428.023-.592.973-1.191.34-.055-.055-.031-.205-.012-.303.852-4.322-1.271-8.342-1.264-12.578.408-.33.816-.383 1.225.004z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#30233E"
        d="M450.305 366.535l.117 1.793c-2.102.887-3.525 3.506-6.373 2.5.006-.238.01-.479.014-.719.969-.787 2.58-.416 3.227-1.787.094-.758.59-1.25 1.131-1.711.613-.373 1.228-.798 1.884-.076z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#17152F"
        d="M450.922 372.111c.363 2.484.395 4.971-.016 7.455-1.223-2.402-.299-4.977-.588-7.453.198-.22.401-.213.604-.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#30233E"
        d="M450.922 372.111c-.203-.004-.404 0-.604.002-1.014-.646-1.014-.646.41-2.459.065.821.132 1.637.194 2.457z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#31197D"
        d="M449.04 432.033c-.41 0-.816 0-1.225-.004-.631-.418-.631-.844-.01-1.271.568-.258.078-1.572 1.238-1.236.02.219.037.439.059.66-.021.619-.043 1.234-.062 1.851z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2C176D"
        d="M449.043 429.521c-.414.412-.826.822-1.238 1.236l.025-2.473 1.867-.008-.654 1.245z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#631AEC"
        d="M410.379 432.021c-.865-.43-1.783-.846-2.286.4-.35.861-.436 1.803.31 2.576 1.207 1.25 2.412 2.525 4.426 2.031-.826 5.088 1.709 9.891 1.262 14.947-.768.521-1.865.408-2.459 1.27l-.004.004c-1.086.527-2.215.227-3.341.213-.758-.01.329-.947-.586-.885-13.705.926-27.426-.061-41.132.371-2.742.086-5.459.49-8.208-.021-1.879-.35-3.594.615-5.396.93-.417-.006-.834-.01-1.251-.014-.002-4.578.25-9.174-.101-13.721-.204-2.645 1.2-4.719 1.522-7.139.205-1.549 1.877-.932 2.91-.936 11.645-.041 23.307.287 34.936-.162 5.539-.213 11.082-1.098 16.664-1.088 1.035.002 2.428-.52 2.734 1.224z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4611B1"
        d="M351.656 458.266c-.396-.027-.791-.053-1.189-.082-.002-.396-.006-.793-.01-1.191.128-.121.254-.24.381-.363 2.064-.504 4.156-.197 6.237-.205.345.1.638.285.882.547 17.471.002 34.941.002 52.413.006.1.094.199.186.301.279.344.646.324 1.314.121 1.994-.096.254-.229.49-.383.713-.547.584-.652 1.461-1.299 1.982-.379.033-.757.068-1.134.102-1.309.639-2.588 1.313-3.48 2.521-.461.496-1.182.617-1.627 1.135l-.002-.002c-.807.701-1.623.688-2.455.047-12.488-.01-24.976-.021-37.463-.033-.629-.768-1.484-1.221-2.432-1.199-2.744.066-4.052-1.752-5.04-3.844-.802-1.696-1.87-2.675-3.821-2.407z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5E1EDE"
        d="M352.965 453.857c2.76-2.297 5.676-2.377 9.021-1.211 1.155.404 2.787-.693 4.343-.686 11.076.064 22.15-.006 33.226.066 2.426.018 4.805.596 7.285.037 1.63-.367 2.856 2.029 4.786 1.186-1.1 1.117-2.504.414-3.755.629-.66.432-1.406.285-2.117.285-15.23.008-30.458.01-45.688 0-.713 0-1.457.15-2.113-.295l-4.988-.011z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#561CC7"
        d="M357.957 456.971h-.638c-2.266-.5-4.537-.439-6.812-.043l-.051.064c-1.236-.092-1.305-.926-1.196-1.875 4.046 1.107 8.188.514 12.271.561 14.231.162 28.463.055 42.695.078.998.002 2.053-.297 3.064.305-1.021.572-2.082.289-3.09.289-14.229.023-28.46.004-42.691.037-1.191.002-2.513-.471-3.552.584z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4607C3"
        d="M357.955 453.869c16.639.002 33.277.006 49.918.01-.816.945-1.924.596-2.916.598-14.695.02-29.394.02-44.093 0-.991-.002-2.099.345-2.909-.608z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4611B1"
        d="M412.913 455.783l-.049 1.182-.248.361c-.832.609-1.6.74-2.207-.299l-.039-.051c.664-.79 1.515-1.181 2.543-1.193z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5E1EDE"
        d="M411.631 453.246c.178-1.662 1.494-1.127 2.459-1.27-.597.856-1.474 1.169-2.459 1.27z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C6AEF8"
        d="M405.386 425.781l-2.502 1.246c-1.885-1.178-3.957-.553-5.939-.533-1.209.012-2.418.174-3.635.01-2.342-.891-4.512-2.031-5.906-4.246-.33-1.207-.613-2.527-1.824-3.133-3.191-1.596-5.262-4.287-7.251-7.09-1.092-2.338-.68-4.764-.445-7.182.412-1.283.504-2.605.449-3.938-.146-3.654.603-6.881 4.128-8.814.262-.254.563-.441.9-.576 1.621-.336 3.238-.582 4.73.451 1.098 4.816 1.375 9.709 1.332 14.629-.012 1.445-.133 2.898.934 4.09.332.441.549.914.402 1.484l4.072 4.053c.393 1.801.707 3.412 3.025 4.043 2.205.604-1.01 1.98.043 3.008-.178.234-.393.414-.701.439.563.221.918-.174 1.32-.438 2.712-.331 5.134.138 6.868 2.497z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B224E"
        d="M390.759 412.18l-.438-.449c-1.049-1.596-.77-3.221-.766-5.074.006-4.229.477-8.457.234-12.688-.061-1.029-.189-2.219 1.012-2.676 1.105-.422 1.996.143 2.598 1.139.867 5.324.029 10.695.484 16.027.16.48.381.943.494 1.439a.96.96 0 01-.275.908c-1.114.46-2.229.917-3.343 1.374z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D1A466"
        d="M394.101 410.354c-.246-.264-.494-.527-.74-.789-.125-.369-.02-.652.307-.857.32-.117.65-.162.988-.143 4.486-.027 8.998.738 13.443-.42.24-.396.489-.781.839-1.09 1.209-.537.904.914 1.518 1.158l.199 1.332c-.127.24-.252.479-.377.719-5.392.41-10.784.246-16.177.09z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#754808"
        d="M394.101 410.354c5.393-.029 10.785-.063 16.177-.09-2.534 1.291-5.231.381-7.845.541-2.768.17-5.553.016-8.33.002a3.425 3.425 0 01-.002-.453z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5E1DEB"
        d="M392.894 429.6c-.279 1.539-1.506 1.162-2.473 1.164-11.643.018-23.283.02-34.926-.002-.953-.002-2.186.42-2.527-1.096.894-1.186 2.216-.998 3.433-1.004 11.007-.033 22.013-.029 33.019-.002 1.22.006 2.533-.166 3.474.94z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3C1389"
        d="M392.894 429.6c-13.309.021-26.619.043-39.926.066-.402-.012-.803-.025-1.205-.039l.037-.9c1.174-.902 2.561-.693 3.882-.695a7989.52 7989.52 0 0135.642.01c1.4.002 2.939-.332 4.061.961.004.166.006.33.006.496-.833.032-1.665.067-2.497.101z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6F4FE"
        d="M353.008 393.014c.062-7.701-1.429-15.248-2.261-22.855-.258-2.025 1.095-2.164 2.613-2.527 5.523-1.322 11.15-1.363 16.762-1.625.869-.043 1.666.059 1.867-1.051.127-.959.172-1.932.59-2.826 1.107-1.705 1.211-3.711 1.719-5.6.307-1.152.105-2.559 1.355-3.338 1.268-.199 1.332.615 1.322.842 4.296-3.906 10.49-5.547 15.496-9.074.441-.58.965-1.035 1.719-1.152.467.039.768.314.998.695 1.795 1.408 3.34 3.385 5.898 3.232 1.234-.076.695 1.605 1.793 1.402.268.018.518.08.766.17 1.299.568 2.559 1.617 3.984.268.227-.195.477-.336.759-.434 1.385-.186 2.465.084 2.613 1.744-1.113 2.041-.553 4.256-.6 6.391-.086 3.92.014 7.846-.047 11.768-.02 1.205.637 2.855-1.496 3.131-.195.023-.534.459-.487.604 1.089 3.473-2.043 7.252.769 10.588.578.992.127 1.4-.854 1.51-1.094-.545-1.307-2.441-3.055-1.994.146.449.549.828.455 1.369a1.076 1.076 0 01-.518.641c-2.195.18-4.691 1.396-5.891-1.863-.699 1.084.801 2.053-.082 2.99-.35.289-.758.436-1.201.504-.201.031-.432.105-.604.029-2.795-1.271-4.256-.102-4.875 2.643-1.145 1.262-2.785 1.314-4.262 1.766-1.77.471-3.621.514-5.369 1.094l.006-.008c-1.359 1.211-3.275.982-4.767 1.85-2.34 1.285-4.998 1.697-7.432 2.729-5.33.963-10.024 3.984-15.409 4.787-1.975-.287-1.523-2.039-1.967-3.252-.193-1.713.247-3.461-.307-5.148z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F2F5EE"
        d="M411.002 350.885c-.777-1.078-1.865-1.395-3.132-1.26-.334-.365-.375-.785-.232-1.238.736-1.1 1.792-1.912 2.636-2.922 1.514-1.129 2.984-2.311 4.361-3.613 2.799 1.572 1.236 4.129 1.434 6.287-.777 2.045-2.15 3.139-4.441 2.744-.208.002-.415.002-.626.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6EDDE"
        d="M411.627 350.883c.754-1.5 2.775-.57 3.619-1.893.303.172.512.424.637.746a3.23 3.23 0 01-.182 2.416c-1.424.863-1.182 2.408-1.512 3.719-.844 2.047-.24 4.377-1.246 6.393-.01-2.756-.545-5.563.467-8.236.71-1.876-1.89-1.71-1.783-3.145z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D39234"
        d="M411.045 395.191c-.035 1.615-.07 3.229-.109 4.842a3.189 3.189 0 01-.488.313c-1.5-1.537-.822-3.479-.918-5.252-.105-1.936-.033-3.881-.02-5.816-.002-.492.006-.99.004-1.48.078-.777-.375-1.424-.566-2.139.264-1.348 1.461-.615 2.168-.975.143.014.27.061.389.143-.002 1.145-.002 2.289-.002 3.432-.78 2.268-.448 4.61-.458 6.932z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9E6D3"
        d="M411.116 384.684c-.721.355-1.441.713-2.162 1.068-.956 1.123-2.202.801-3.403.686a2.295 2.295 0 01-.791-.42c-.41-.742.15-1.064.621-1.424l.004-.004c.83-.613 1.666-.801 2.525-.053.808.025 1.208-.375 1.231-1.172l1.975 1.319z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#211D5D"
        d="M421.649 445.736c1.264-.963-.102-2.783 1.215-3.729.566-.414 1.053-.264 1.494.207.766 2.795.234 5.639.332 8.461.047 1.289-.773 2.023-1.824 2.563l-.016.02c-.756-.361-.973-.857-.766-1.744.458-1.946.069-3.877-.435-5.778z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#291861"
        d="M418.483 456.994c-2.215-1.139-3.801.543-5.604 1.248l-.26-.268c-.137-.381-.078-.723.213-1.016l.031.006c1.878-.665 3.761-2.636 5.62.03z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#201E4F"
        d="M424.11 442.01l-1.246-.002c.012-4.307-1.027-8.596-.051-12.928.246-1.084.051-2.273.672-3.299.133-.119.268-.242.4-.365 1.35-.211 3.049-1.008 2.719 1.611l-.002.002c-.58.252-.828.836-1.242 1.25.4 1.52-1.652 2.221-1.246 3.742 1.18 3.143.582 6.354.369 9.553l-.373.436z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#201E4F"
        d="M423.481 423.287c1.053.148 2.248-.418 3.123.621.594 1.035.156 1.533-.896 1.453-.809-.059-1.588-.318-2.223.42-1.139-.828-.313-1.662-.004-2.494z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C2A7FA"
        d="M398.519 423.285c-.809 1.557-1.955 1.363-3.691.699 1.176-.99 2.188-.58 3.072-.701.205 0 .412 0 .619.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5F1FDD"
        d="M431.6 446.99l-3.738.027c-1.279-4.031-.459-8.129-.395-12.201.004-.301.205-.592.24-.895.551-4.438.547-4.438 5.115-4.355.398.395.348.799.025 1.209-2.941-.51-3.947.625-3.842 3.666.09 2.582.855 5.309-.664 7.846-.486.809.555.811 1.068 1.049 1.552.711 2.418 1.863 2.191 3.654z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5429BE"
        d="M432.848 430.775l-.025-1.209c.42-.006.84-.01 1.258-.014.012.82.02 1.639.031 2.455-.836.013-1.225-.429-1.264-1.232z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#251E5A"
        d="M423.485 425.781c.107-1.102.719-1.41 1.691-1.004.922.387 1.346.066 1.428-.869.686.025 1.424-.107 1.875.617-.326.879-.293 1.939-1.25 2.502l-.313.002-.313-.002c-.407-1.996-2.02-.976-3.118-1.246zM429.702 418.162c-1.695.098-3.736-.238-3.248 2.594-.778-3.227-.344-3.574 3.248-2.594z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#845BD1"
        d="M395.384 429.002c-13.287-.033-26.576-.063-39.862-.105-1.241-.004-2.481-.109-3.722-.168-.028-.6-.183-1.23.395-1.689.383.055.76.133 1.135.229 12.243.309 24.485.043 36.727.141 1.656.012 3.322-.143 4.969.197.389.127.719.342.992.643 5.381-.018 10.758-.035 16.138-.051-1.182 1.305-2.723.582-4.077.629-4.23.149-8.464.129-12.695.174z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C8B0EA"
        d="M396.017 428.248l-.674-.041c-.828-.592-2.035-.582-2.58-1.621a.749.749 0 01.158-.807c2.539.002 5.078-.01 7.617.014.975.008 2.141-.268 2.346 1.234-2.273.496-4.926-1.138-6.867 1.221z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FD9F01"
        d="M415.284 351.98l.186-2.244c.377-.943.383-2 .908-2.896 1.115-2.23 1.002-4.471.043-6.715-.383-.594-.9-1.084-1.252-1.705a1.706 1.706 0 01.012-.869c.627-.936.984-2.291 2.604-1.721.416.299.424.834.717 1.238.236-.809-.604-.914-.857-1.387-.73-1.188-2.242-1.602-2.867-2.9-.742-4.604-.221-9.223-.24-13.832.027-.531.113-1.051.316-1.543 1.326-1.443.629-3.463 1.41-5.065 1.518-1.183 1.607-3.714 3.91-4.167 1.057.518 1.301 1.662 1.939 2.503.398.646.977 1.172 1.262 1.891.893 3.25-.955 6.058-1.49 9.079-.66 3.744-1.838 7.4 1.211 10.828 1.191 1.342.572 3.412.6 5.16.025 1.703-.088 3.398 2.092 3.955.508.131.912.494 1.021 1.061.064.326-.043.793-.262.838-2.867.596-1.02 3.906-2.852 4.967-1.572.906-2.549.016-2.736-2.324-.018-.205.1-.543.01-.596-.246-.146-.09.199-.209.277-1.172 2.057-1.246 4.105-.08 6.174.158.289.27.592.35.908-.059 2.82.047 5.645-.162 8.457-.193.568-.785.881-.967 1.461-.195.369.518.326.139.156-.049-.023 0-.301.088-.502.119-.271.336-.48.541-.699.641-1.688.244-3.439.313-5.158.051-1.299.232-2.445 1.553-3.063 4.012-.629 7.459-2.98 11.428-3.746 2.412.438 4.879 1.146 5.951-2.207.268-.836 1.191-1.053 2.086-.895.951.17 1.365.867 1.514 1.713.213 1.191.635 2.389.148 3.615-1.201 1.41-2.725 2.045-4.584 2.164-4.225.273-5.51 2.148-4.426 6.291.234.773-.949 2.313 1.137 2.082 1.066 0 2.133-.037 3.146.371 1.133.996 2.779.699 3.967 1.568.188.318.242.654.168 1.014-.852 1.439-2.299 1.156-3.596 1.193-2.16.061-4.322.018-6.484.027-1.613-.006-3.229-.027-4.844.004-1.945.033-3.596 1.4-5.586 1.234-1.969-.271-4.057.238-5.885-.916-1.1-2.828-3.148-5.379-1.439-8.836.652-1.316.125-3.217.137-4.852-.398-.439-.373-.908-.089-1.391z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D89B3F"
        d="M416.672 367.061l6.131.086c1.482 1.324 3.543-.227 5.043 1.02.328.439.371.883-.008 1.324-4.391-.461-8.832-.555-13.1-1.883.516-.643 1.264-.456 1.934-.547z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8B242"
        d="M415.284 351.98c.029.465.059.928.086 1.393-.395.832-.785 1.666-1.18 2.498.225-1.336-.688-2.992 1.094-3.891z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECA325"
        d="M427.838 369.49l-.014-1.098c1.375-.854 2.492-1.113 2.551 1.096l-.643.111a2.33 2.33 0 00-.6.164c-.428-.091-.86-.183-1.294-.273z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FD9F01"
        d="M446.672 368.369c-3.791.121-7.395 2.023-11.287 1.164-.26-.26.318-.924-.129-.83-1.074.225-1.996.154-1.922-1.082.074-1.227 1.285-1.088 2.182-1.111 2.045-.051 4.09.029 6.137-.041 1.215-.043 2.113-.389 1.18-1.852-.41-.49-1.578-.189-1.381-1.318.377-.658.928-1.145 1.578-1.525a2.713 2.713 0 012.158-.045c.822.574 1.723.928 2.74.955.434.066.836.211 1.189.48.285.352.355.746.244 1.176-.881.199-1.072.795-.896 1.598-.039.398-.193.756-.387 1.102-.374.542-1.054.763-1.406 1.329z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F99E0D"
        d="M442.833 364.617c.869.098 1.305.553 1.16 1.447-.191 1.158-1.113 1.035-1.92 1.041-2.727.016-5.457.006-7.838.006-1.424 2.285 3.088-.055 1.15 2.422-1.67-.016-3.338-.029-5.01-.043-.34-1.555-1.58-1.014-2.551-1.098-1.641-.545-3.832 1.125-5.02-1.246 1.912.477 3.143-1.762 5.057-1.273 1.66.949 3.32.951 4.98-.002 2.547-.002 5.094.008 7.639-.014.979-.007 2.145.266 2.353-1.24z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CE9C87"
        d="M446.672 368.369c-.051-.832.473-1.125 1.174-1.254.287-.188.527-.15.711.152-.234.58-.68.906-1.27 1.057a2.7 2.7 0 00-.615.045z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F1A117"
        d="M410.301 388.301c.049 4.016.096 8.027.146 12.045-.014.553-.029 1.105-.041 1.658-.51.463-1.012.408-1.514-.018-1.397-4.162-.49-8.393-.295-12.594.04-.865.585-1.587 1.704-1.091z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D39234"
        d="M409.149 402.092l1.258-.088c.018 2.07.031 4.143.049 6.211-.41-.377-.824-.754-1.234-1.129-1.367-1.645-1.306-3.311-.073-4.994z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3B1991"
        d="M404.111 464.449c.635-1.852 1.881-2.717 3.865-2.402-.445 1.248-1.297 2.07-2.561 2.463-.453.344-.884.304-1.304-.061z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#291861"
        d="M412.879 458.242c-1.004.898-.465 3.039-2.5 3.107-.547-.619-.494-1.236.004-1.854l.006-.01c.627-.768.949-2.096 2.418-1.314l.072.071z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#37188A"
        d="M410.383 459.496c0 .617-.002 1.236-.004 1.854-.277.514-.736.629-1.27.596.14-.966-.392-2.282 1.274-2.45z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2A146B"
        d="M404.111 464.449c.436.02.869.039 1.301.061-.27 1.629-1.539 1.125-2.543 1.193.013-.814.463-1.197 1.242-1.254z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2C0A6C"
        d="M400.412 465.748l2.455-.047c-.137 1.74-1.484 1.139-2.453 1.271 0-.408 0-.818-.002-1.224z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5314D9"
        d="M431.6 447.633c1.244 0 2.492 0 3.736.004-.021.309.057.838-.076.895-2.443 1.078-2.578 3.367-2.963 5.631-1.064-2.157-.539-4.382-.697-6.53z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#241E4E"
        d="M422.866 453.238c2.285-3.535.84-7.484 1.244-11.229.416-.367.826-.367 1.234.008v13.697c-1.533-.724-1.314-2.216-2.478-2.476z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#251E5A"
        d="M425.344 442.018l-1.234-.008c.002-3.33.002-6.66.002-9.988 1.504.215 1.229 1.383 1.234 2.359.018 2.547.002 5.092-.002 7.637zM425.36 428.279l-.082-1.641 1.324.391c-.014.815-.434 1.227-1.242 1.25z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#221E53"
        d="M341.73 447.018c.002 1.729.014 3.459.007 5.189-.017 4.018-.272 4.174-3.725 2.301-.89-.764-.884-1.826-.89-2.852-.045-6.398-.034-12.801-.009-19.197.005-1.039.06-2.074.804-2.912-.207-.465-.416-.93-.624-1.393-1.063-1.221-1.01-2.76-.717-4.102.871-4.004.095-7.723-1.452-11.385-.238-.563-.357-1.176-.402-1.797a5.517 5.517 0 01.088-1.621c1.072-2.418 1.271-4.994 1.283-7.584.004-1.252.212-2.469.338-3.701.12-1.174.882-1.588 1.896-1.641 1.322-.07 1.45.918 1.493 1.885.156 3.619-.528 7.332.318 10.84.681 2.818 1.412 5.545 1.265 8.467-.085 1.656.013 3.32-.768 4.863-.514 1.01-.46 2.08.13 2.975 1.785 2.695 1.854 5.723 1.529 8.701-.472 4.319.121 8.667-.564 12.964z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#601BE9"
        d="M331.126 429.533l5.479.082c.637.498.717 1.205.731 1.939.132 6.264-.221 12.535.243 18.793.03.396-.205.791-.303 1.188-1.07 1.742-2.544 1.549-4.121.861a2.327 2.327 0 01-.988-1.512c-.434-2.268-2.017-3.166-4.072-3.553a1.6 1.6 0 01-.584-.746c-.248-1.467-.099-2.939-.131-4.412.009-.49.029-.98.174-1.459 1.328-2.746 2.178-5.621 2.32-8.689-.055-1.066.182-1.988 1.252-2.492z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E5DDF9"
        d="M335.441 410.871c2.945 5.514 2.313 11.406 1.853 17.283-1.579.584-3.218.266-4.83.338-1.06.049-1.457-.49-1.397-1.479-.387-1.275-.432-2.551-.017-3.83.723-.871.581-2.15 1.388-2.986l-.027.029c.672-.977-.16-2.236.604-3.195.143-.104.158-.225.041-.355.48-1.781.07-3.668.637-5.428.338-1.055.83-1.814 1.748-.377z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#322981"
        d="M329.864 422.035c.21.002.417.002.625.002.359.336.53.75.524 1.236-.086.459-.199.906-.537 1.254-3.074.775-1.491 4.443-3.619 5.848-.35.229-.4 1.291-.604 1.299-3.834.082-2.898 1.883-2.168 4.482.689 2.449.148 5.246.148 8.086-1.662-.275-.929-2.441-2.486-2.232-1.756-3.018-.487-6.309-.855-9.451.018-.693.058-1.387.309-2.043 1.835-1.992 3.311-4.291 5.183-6.262.511-.512.724-1.146.871-1.846.519-2.445 1.52-1.777 2.609-.373z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#221E4D"
        d="M315.495 445.734l.048-8.688c3.01.332 3.073 2.861 3.713 4.965l-.006 1.244c-.982 1.971-.544 4.221-1.238 6.248l-.018 1.244c-.86.707-1.15 1.674-1.281 2.729-.077.621-.501 1.061-.986.502-.35-.402-1.646-.283-1.073-1.053 1.703-2.29.466-4.814.841-7.191z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#261C5E"
        d="M319.255 442.012c-1.949-1.123-1.382-4.129-3.713-4.965-.021-1.066-.045-2.131-.066-3.193-.464-.449-.512-.994-.361-1.58.424-.807 1.03-1.588.307-2.541a1.053 1.053 0 01.063-.82c.468-.48 1.021-.512 1.619-.326 1.849 2.217 3.563 4.58 2.736 7.639-.383 1.422 1.051.457 1.027 1.129.289 1.688.047 3.256-.993 4.654l-.619.003z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3C1894"
        d="M336.736 452.01c.949-2.834-.123-5.67-.018-8.52.169-4.619-.054-9.25-.111-13.877.437-.021.875-.045 1.313-.066.03 8.318.06 16.641.092 24.961l-.058 1.252c-.404-.215-.809-.432-1.213-.646-.949-1.032-.793-2.067-.005-3.104z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#37218E"
        d="M325.49 458.246c.207.416.414.83.624 1.246-.83-.008-1.657-.012-2.487-.018-.907-.707-.916-1.896-.516-2.559 1.014-1.682 1.206-3.438 1.244-5.301.014-.594.6-.779 1.13-.877 1.239 1.664 1.14 3.332.011 5.004-.439.835-.834 1.669-.006 2.505z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#431FA5"
        d="M325.496 455.742c-.004-1.67-.006-3.338-.011-5.004.421-1.248-.962-3.084 1.228-3.75.428-.355.852-.355 1.271.016l.053-.029c.208.287.313.607.316.961-1.24 2.453-.008 5.43-1.634 7.803a99.815 99.815 0 00-1.223.003z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4522A5"
        d="M330.429 432.012c.273 3.238-.941 6.076-2.381 8.855-.418-.447-.452-.918-.082-1.41-.736-2.676 1.139-4.904 1.277-7.432.392-.367.786-.373 1.186-.013z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#352A6D"
        d="M319.874 442.008c-.306-1.727.599-3.303.618-4.988-.361-.393-.466-.861-.428-1.377.567-1.201-.381-3.109 1.678-3.621l.006 9.988c-.625-.002-1.249-.002-1.874-.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#261C5E"
        d="M318.011 449.504c.211-2.123-.707-4.467 1.238-6.248.071 2.178-.068 4.316-1.238 6.248z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4522A5"
        d="M327.984 447.004l-1.271-.014c.018-.832.033-1.662.05-2.492.855-.611-.507-2.34 1.253-2.5l-.032 5.006z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#431FA5"
        d="M328.015 441.998c-1.035.523-.263 1.957-1.253 2.5.464-1.664-1.159-3.83 1.204-5.039.025.469.054.938.079 1.408-.008.377-.018.754-.03 1.131z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#442193"
        d="M330.429 432.012l-1.186.014c-.045-1.338-.133-2.709 1.883-2.492-.231.825-.464 1.652-.697 2.478z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#383762"
        d="M330.476 424.527c.01-.408.02-.818.027-1.227.453-.391.9-.35 1.346.014-1.049 1.068-.147 2.547-.783 3.699-.877-.667-.481-1.636-.59-2.486z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2E1B7B"
        d="M313.077 455.709c.955.15 2.245-.35 2.441 1.264l-2.468-.615c.008-.217.017-.432.027-.649z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E7DEFC"
        d="M392.921 425.779c.002.193.002.385 0 .578.701 1.83-.699 1.617-1.654 1.574-3.295-.146-6.6-.178-9.895-.227-9.646-.148-19.296-.027-28.943-.082l-.234-.584c.225-3.232 1.096-6.408.824-9.682.595-5.236.077-10.49.275-15.732.043-1.102-.361-2.268.357-3.301.955.578.066 2.484 1.804 2.496 1.324 1.629.717 3.566.868 5.383.102 1.215-.205 2.465.481 4.152.431-2.061.294-3.689.266-5.285-.036-2.119.868-3.406 2.759-4.385 3.873-2.002 8.118-3.018 12.063-4.809 2.258-.889 3.049.242 3.152 2.297.186 3.73-.076 7.467.406 11.209.34-3.045.27-6.107.295-9.168.014-1.348-.08-2.703.176-4.035.23-1.217.676-2.238 2.25-1.883.611.303.994.855.888 1.469-.502 2.91.152 5.873-.467 8.77.229 2.504-.644 5.088.559 7.523.793 2.928 2.719 4.934 5.199 6.543 1.393.908 2.482 2.184 3.555 3.447 1.321 1.715 3.352 2.478 5.016 3.732z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#332A7B"
        d="M329.238 369.619c.246 2.396 1.674 3.031 3.775 2.371 2.257-.705 4.469.324 6.661.064 2.49-.297 5.32 1.279 7.501-1.297.265-.313 1.514.211 2.703.414-2.394 2.357-.613 4.771-.695 7.098-.141 4.025 2.028 7.834 1.283 11.953-.106.604.028 1.279-.588 1.678-2.244 1.445-1.535 3.385-.629 5.098.55 1.039.614 1.848.316 2.873-.344-.096-.687-.139-.69-.199-.244-4.918-3.729-9.52-1.098-14.773 1.031-2.055-1.146-3.951-1.69-5.973-.218-.807-1.309-.314-1.625.443-.229.547-.285 1.225-.225 1.826.625 6.223-1.38 12.137-2.379 18.221v-9.855c-1.25.328-.309 1.484-1.385 1.916 0-1.275.107-2.463-.029-3.621-.129-1.102.725-3.066-1.042-3.025-1.436.035-3.106.602-4.02 2.553-1.256 2.68-1.089 5.363-1.159 8.107-.02.783.244 1.684-.648 2.246-.674.059-.555-.496-.571-.83-.274-5.266-.284-5.383-5.438-4.746-1.574.193-3.043.023-4.561-.08-1.337-1.518-1.242-3.543-1.904-5.303-.331-5.084-1.572-10.152-.286-15.266.054-.5.066-1.004.058-1.508-.006-.652-.199-1.346.392-1.875.642-.342 1.286-.281 1.932-.012 1.804 1.334 4.299-.092 6.041 1.502z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#261C53"
        d="M321.763 387.068c.906 1.547 1.223 3.242 1.242 5.012.004 1.666.011 3.336.016 5.002.642 1.574.04 3.24.367 4.838.42.988.709 2.125.201 3.027-1.204 2.143-.798 4.451-1.022 6.695a3.56 3.56 0 01-.385 1.387c-1.012.713-2.798.852-2.114 2.834-.033.902.343 1.516 1.162 1.945.691.361 1.031.967.672 1.783-.817.744-1.846 1.111-2.809 1.602-.695.182-1.348.131-1.922-.354-.331-.439-.477-.943-.523-1.482.682-4.604-1.031-9.074-.758-13.656-.357-3.682.852-7.477-.823-11.059-.495-1.24-.387-2.543-.426-3.834.156-2.004-.366-4.07.514-6.012.349-.488.829-.594 1.382-.473 1.41 1.047 1.136 2.549 1.075 3.98.339-.979-.169-2.561 1.708-2.525 1.15 1.277.451 3.006 1.094 4.727.85-1.169.29-2.659 1.349-3.437z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#231C58"
        d="M341.73 447.018c-.002-3.943-.068-7.887.014-11.828.07-3.514.087-6.916-2.208-9.975-.49-.652-1.592-2.182.257-3.439 1.369-.934.949-8.877-.266-10.314-.564-.666-.27-1.352-.278-2.01-.045-3.527.015-7.057-.054-10.582-.012-.668.604-1.879-.78-1.912-1.263-.029-1.745.799-1.7 2.064.07 1.971-.037 3.945.033 5.914.061 1.705-.601 3.168-1.285 4.646-1.576-.277-1.865-1.172-1.213-2.52 1.752-4.033 1.275-8.479 2.316-12.67.604-2.43 1.621-4.629 2.281-6.893.754-.064.979.281.951.715-.293 4.467.852 8.869.648 13.314-.314 6.875 2.336 13.365 2.268 20.26-.051 5.152.445 10.307-.111 15.475-.23 2.152-.152 4.342-.275 6.512-.063 1.096.395 2.309-.598 3.243z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#332A7B"
        d="M329.864 422.035c-.667.152-2.165-1.76-1.887.775.099.887-.13 1.643-1.231 1.725-2.439-3.25-2.319-3.574-.719-8.121.457-1.301-.454-3.033.719-4.361-.125-4.004.419-8.023-.404-12.141 1.1 1.258 2.002 2.275 3.767 2.465 1.329.141 1.664 1.625 1.644 2.994-.048 2.91-.016 5.82-.016 8.732 0 .313.124.777-.032.914-2.231 1.93-1.582 4.59-1.841 7.018z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#342B75"
        d="M326.746 412.053c-.274 1.764.473 3.553-1.033 5.336-.756.896-.767 3.174.393 4.57.672.813.604 1.678.641 2.576-1.599 1.926-2.209 4.732-4.982 5.617-.576-.541-.598-1.215-.471-1.928.922-2.064.762-4.328 1.17-6.488.954-3.623 1.245-7.256.387-10.959-.646-2.779.744-5.473.51-8.25.09-.156.18-.313.271-.467 1.525-.117 1.928.711 1.881 2.08-.064 1.844-.033 3.693-.007 5.537.011.983-.278 2.163 1.24 2.376z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7DDBB"
        d="M347.485 367.859c-2.291 1.654-4.4 3.932-7.671 2.27-2.148-2.133.32-2.357 1.311-3.197.454-.242.896-.504 1.254-.883.081-.1.169-.191.25-.291.158-.215.328-.414.496-.617.961-1.178 1.303-2.855 2.861-3.557 1.984.082 4.768-1.66 5.098 2.217-.51.938-1.036 1.869-1.414 2.873-.333 1.127-1.717.306-2.185 1.185z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EEF5FB"
        d="M347.485 367.859c.153-1.008 1.431-.578 1.754-1.369 1.8-1.193 3.881-1.357 5.921-1.449 4.848-.223 9.719.234 14.549-.602 1.117-.193 2.287-.061 3.213.791-.066 1.063-.52 1.787-1.684 1.803-2.545.039-5.115.299-7.628.027-4.058-.439-7.682 1.939-11.706 1.512-1.055-.111-.596 1.174-1.156 1.586.081-2.424-1.729-2.166-3.263-2.299z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#322A81"
        d="M345.886 434.006c-.699-.285-1.889-.748-1.231-1.6 1.187-1.535.665-3.154.804-4.742.078-.865.099-1.701 1.189-1.859 1.263-.182 1.308-1.1 1.329-2.068.017-.742.077-1.527 1.054-1.59.367-.023 1.021.146 1.079.354.21.77.55 1.746.259 2.375-1.288 2.783-3.827 5.006-3.68 8.428.021.483-.207.766-.803.702z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#403561"
        d="M353.652 398.324c-.047 5.24-.064 10.48-.156 15.719-.02 1.107.16 2.279-.477 3.313-.004-8.113-.006-16.227-.011-24.342.747 1.705.259 3.56.644 5.31z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DEE7F5"
        d="M336.107 368.805c-1.67.023-3.336.051-5.004.074-.328-.176-.686-.297-.982-.531-.5-.574-.49-1.143.013-1.711.345-.396.661-.832 1.22-.963.424.027.803.189 1.172.383 1.574.691 3.57-.35 4.934 1.199.167 1.06-.646 1.258-1.353 1.549z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#372F74"
        d="M334.25 407.063c.072 1 .447 1.854 1.213 2.516-.009.434-.016.863-.021 1.295-.879-.498-1.224-.227-1.375.762-.262 1.689-.668 3.359-1.012 5.037-.024-2.43-.061-4.859-.061-7.289-.002-.98-.244-2.134 1.256-2.321z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8DBDA"
        d="M336.107 368.805c.412-.359.827-.719 1.242-1.078.216-.48.51-.891 1.016-1.109 1.207-.33 2.391-.5 3.376.541-.47 1.102-3.247.711-1.927 2.971-1.516.335-2.307-1.351-3.707-1.325z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#123285"
        d="M329.238 369.619c-2.048-.477-4.429 1.051-6.207-1.039.075-.143.15-.289.223-.434.738-.492 1.541-.443 2.357-.291 1.168.455 2.604.072 3.584 1.135.012.209.027.418.043.629z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#508ACE"
        d="M329.195 368.99c-1.258-.285-2.643.289-3.814-.568.64-.879 1.658-.857 2.568-1.098 1.088-.191 1.791.486 2.521 1.107.212.146.424.297.636.447a378.3 378.3 0 00-1.911.112z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#372F74"
        d="M331.849 423.314l-1.346-.014c-.004-.422-.011-.842-.015-1.264.785-.467.888-1.662 1.948-1.84-.02 1.074.013 2.156-.587 3.118z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#342B75"
        d="M323.003 402.057l.018-4.975c1.213 1.535.331 3.328.609 4.979l-.011.01c-.211.279-.416.275-.616-.014z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#332A7B"
        d="M333.922 402.752c.308.922.591 1.902-.349 3.029-.583-1.242.186-2.092.349-3.029zM333.337 370.676c.49-1.186 1.266-1.127 2.114-.926-.375 1.105-1.135 1.084-2.114.926z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#372F74"
        d="M333.013 417.031c.023 1.107.013 2.209-.604 3.195.075-1.089-.474-2.296.604-3.195z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#332A7B"
        d="M324.552 399.668c-.443-.648-.385-1.281-.025-2.133.462.815.492 1.442.025 2.133z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5217C8"
        d="M326.719 455.738c.351-2.713-.845-5.676 1.292-8.107 1.846-.463 3.057.238 3.712 2 .314.846.631 1.697 1.294 2.354 1.238.021 2.475.496 3.719.025l.006 3.104c-.201 1.471-1.358 1.664-2.503 1.871-1.71.004-3.419.023-5.128.006-.994-.012-2.164.255-2.392-1.253z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#431FA5"
        d="M325.49 458.246c-2.193-.84-.439-1.67.006-2.504l-.006 2.504z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7235EB"
        d="M289.895 446.949c-.614.027-1.228.055-1.842.086-40.471-.016-80.941-.027-121.412-.043-1.557-.002-3.113-.029-4.669-.047-.614-2.479.035-3.744 2.32-4.383 1.315-.369 2.681-.287 4.03-.287 36.471-.008 72.941.018 109.412-.043 3.015-.004 5.928.896 8.979.568 1.585-.168 2.35 1.492 3.342 2.512.269.577.28 1.129-.16 1.637z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7333EF"
        d="M289.912 445.752c-.609-.801-2.205-.555-2.189-2.064.001-.121-.67-.426-.764-.344-2.528 2.225-4.978-.17-7.465-.164-37.591.111-75.184.088-112.776.059-2.654-.002-4.852.307-4.745 3.709l-2.487-.006-.007-4.932.27-.254c.382-.129.72-.084.983.252h1.238c.471-.361.64-1.029 1.255-1.248 30.366 0 60.736.227 91.098-.113 11.826-.131 23.656-.494 35.488-.49 1.091 0 2.314-.418 3.234.607 1 1.783-1.014 2.541-1.31 3.883-.426.669-.97 1.142-1.823 1.105z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5115DD"
        d="M161.973 451.994c-1.951.283-2.764-.568-2.499-2.5.096-.844.533-1.277 1.418-1.172.945.109 1.057.797 1.07 1.543.013.709.008 1.418.011 2.129z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F13C52"
        d="M229.369 166.149l.009 9.981c-.601.178-1.239.425-1.245-.607-.005-.917-.159-1.868.025-2.747.76-3.618-1.343-6.857-1.275-10.37 2.077.419.886 3.008 2.486 3.743z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F13C52"
        d="M229.377 177.384c0 .9-.081 1.81.017 2.699.214 1.953-.798 2.476-2.497 2.299-1.048.268-1.3-.618-1.76-1.207-.808-1.551-1.088-3.258-1.46-4.941a8.963 8.963 0 01-.084-1.465c.013-.337.058-.669.125-.999.167-1.385-.326-2.745-.15-4.13.477-1.54-.258-3.277.777-4.723 1.342.531 1.299 1.685 1.292 2.837-.011 1.848.023 3.698-.003 5.546-.036 2.525-.236 5.075 1.648 7.228a5866.5 5866.5 0 002.095-3.144z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C13D90"
        d="M224.345 164.917l.006 4.988a1.083 1.083 0 01-.734.324 1.192 1.192 0 01-.702-.406c-.177-.417-.142-.807.146-1.166l.156-3.826 1.128.086z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#832FD7"
        d="M220.648 166.14l.005-8.72 1.241-.002-.006 8.731c-.416.365-.829.365-1.24-.009z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7B31E2"
        d="M220.648 166.14l1.239.009c.122.962-.415 2.233 1.174 2.508l.112 1.211c.581.864.752 1.714-.087 2.531-2.066-1.598-2.599-3.793-2.438-6.259z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E1071B"
        d="M235.622 174.266l.12.758c1.498 3.586 1.028 7.404.513 10.968-.515 3.565-.891 7.14-1.309 10.713-.814 1.511-1.991 2.043-3.625 1.329a1.715 1.715 0 01-.684-.795c.804-5.551.564-11.14.607-16.718.807-.219.512-2.058 1.514-1.467 1.892 1.116 1.546-.234 1.59-1.185.065-1.427.047-2.858.065-4.288.693-.285.873.337 1.209.685z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F33D5A"
        d="M230.638 197.239l.654.129c-.872 2.013-2.388 1.391-3.862.947-1.025-.702-1.433-1.786-1.364-2.915.18-2.972-.637-5.851-.689-8.792.043-1.197.08-2.397-.258-3.571-.091-.703-.051-1.373.5-1.906l1.278 1.251c-.006 2.214.05 4.222 2.261 5.789.794.563.634 2.847-.11 4.042-1.535 2.461-.665 3.898 1.59 5.026z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EA0618"
        d="M230.003 164.904c1.136 1.11.444 2.513.603 3.78-1.035-1.126-.46-2.51-.603-3.78z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C50F68"
        d="M235.622 174.266a369.49 369.49 0 01-1.209-.684l.08-2.43 1.1-.031.029 3.145z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#8A28E5"
        d="M238.18 164.965l-.014 4.878c.328.443.288.867-.068 1.273-.818-.002-1.198-.439-1.223-1.23-1.14-1.015-.132-2.706-1.179-3.75l-.103-1.201c-.366-.829-.618-1.654.069-2.452l1.043-.185c2.523-.234 2.011 1.21 1.475 2.667z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#982DB0"
        d="M238.18 164.965c-.148-1.079.254-2.46-1.474-2.667.405-1.563 1.671-1.088 2.712-1.146-.049 1.232-.1 2.465-.151 3.697l-1.087.116zM235.662 162.483l-.069 2.452-1.172-1.323.064-1.09 1.177-.039z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9826D4"
        d="M235.696 166.136c2.131.703.773 2.504 1.179 3.75l-1.112.013-.067-3.763z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7137EC"
        d="M163.223 179.877c.674.11 1.18.409 1.207 1.17.029.831.039 1.663.039 2.494.001 78.277.006 156.555-.044 234.83 0 1.24.975 3.043-1.201 3.664-.906-.955-.603-2.158-.608-3.268-.032-6.031 0-12.064-.027-18.094-.006-1.223.281-2.518-.612-3.602v-1.248c1.02-1.404.605-3.021.606-4.543.021-68.961.014-137.921.041-206.881 0-1.51-.476-3.134.599-4.522z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7335F1"
        d="M158.244 378.969c-.004-70.239-.012-140.478.025-210.72 0-1.162-.842-2.842 1.207-3.353 1.076 1.388.6 3.011.601 4.522.027 61.057.02 122.112.042 183.168.001 1.523-.414 3.141.606 4.541l-.002 21.846c-.827.656-1.654.664-2.479-.004z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7630F2"
        d="M163.223 179.877c0 70.76.005 141.521-.046 212.283 0 1.24.974 3.041-1.201 3.664-.002-76.486-.002-152.97-.009-229.453 0-1.14.09-2.314-.143-3.412-.281-1.317.277-1.711 1.395-1.81l1.252.002c-2.357 3.41-1.11 7.376-1.431 11.044-.213 2.454.017 5.118.183 7.682z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6F33F2"
        d="M159.823 357.127c-.243-.107-.347-.623-.344-1.48.003-.934-.002-1.869-.002-2.805 19.137 26.127 0-125.298 0-187.946.048-.716-.11-1.674.347-2.377l-.001 194.608z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7335F1"
        d="M158.853 442.006c-1.018-.922-.6-2.143-.602-3.23-.023-15.146-.011-30.291-.008-45.439 1.322-2.953.263-6.068.621-9.086.135-1.133-.247-2.723 1.861-2.156v44.938c-1.533 3.303-.821 6.826-1.013 10.262-.09 1.601.358 3.309-.859 4.711z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7630F2"
        d="M161.976 397.072c1.894.393 1.209 1.924 1.218 3.01.055 7.318.029 14.635.03 21.953v4.373c.87 1.871.964 3.744-.001 5.615v8.736c-.022.816-.441 1.23-1.254 1.248l.007-44.935z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7333EF"
        d="M160.725 382.094c-1.532.219-1.23 1.412-1.239 2.396-.023 2.789-.072 5.582.016 8.369.053 1.697-.563 1.055-1.259.477v-1.266a32.91 32.91 0 00-.002-9.967l.002-3.135 2.479.004c.001 1.042.003 2.081.003 3.122zM158.853 442.006c.272-4.404-.579-8.854.535-13.232.209-.82.219-1.672 1.337-1.742v4.992c-1.105 1.496-.438 3.221-.625 4.836-.2 1.715.497 3.541-.621 5.148v.002l-.626-.004z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7335F1"
        d="M159.479 442.008c0-2.543-.014-5.088.006-7.633.007-.979-.262-2.145 1.24-2.352l.006 9.984-1.252.001zM158.241 382.104c.999 3.322.997 6.645.002 9.967l-.002-9.967z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7431ED"
        d="M166.344 427.031c1.123-1.141.598-2.574.599-3.861.027-81.432.046-162.863-.083-244.295-.004-2.401 1.082-4.089 1.803-6.046.282-.765 1.488-.598 1.779.089.738 1.743 2.157 1.329 3.437 1.331 13.728.017 27.456.002 41.184.017 2.697.002 5.307-1.02 8.031-.631.394.607.386 1.156-.23 1.619-4.063 1.314-8.251.523-12.367.583-12.262.179-24.527.05-36.792.072-4.22.007-4.304.153-4.479 4.369-.113 2.7-.125 5.4-.125 8.103-.005 79.3.013 158.6-.004 237.899-.025.979.018 1.965-.239 2.926a2.095 2.095 0 01-.645.947c-1.255-.667-1.654-1.839-1.869-3.122zM166.063 182.819V421.59c-.204 0-.408 0-.611.004V182.82l.611-.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#621AED"
        d="M314.308 435.85c.288 3.395-.571 6.639-1.296 9.902-.871.74-1.928.615-2.947.617-4.731.014-9.463.027-14.194-.008-1.185-.012-2.546.299-3.231-1.158-.441-2.23 1.054-2.578 2.714-2.77 2.25-.26 4.471.471 6.289.205-4.152-.092-4.441-.455-3.529-4.775.318-1.51.415-3.053.547-4.588l1.245-2.496c.13-.127.261-.25.389-.379 2.103-.746 4.219-.6 6.341-.102.979.631 2.044 1.006 3.221.881 2.478-.266 3.899.926 4.553 3.221.167.496.197.985-.102 1.45z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7333EF"
        d="M298.035 430.781c-2.292 1.867-4.139 4.023-7.775 3.857-8.135-.377-16.299-.162-24.451-.086-1.89.018-3.04-.363-2.727-2.529-.604-2.082 1.045-1.938 2.176-2.049 2.065-.201 4.148-.078 6.224-.08 7.474-.004 14.947-.021 22.42.016 1.417.006 2.944-.308 4.133.871z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#692FE2"
        d="M168.21 430.152l.027-.666c1.437-1.188 3.164-.826 4.79-.828 28.324-.025 56.647-.008 84.971-.023 12.477.027 24.955-.008 37.433.023 1.435.002 2.928-.244 4.259.588.361.322.401.68.125 1.074-10.682.303-21.367.041-32.051.143-1.956.016-3.907-.158-5.854.459-1.291.41-2.686.23-3.815-.746h-3.698c-.123 1.061 1.704.189 1.231 1.221-.465 1.012-1.648.52-2.531.627-1.446-1.289-3.028-1.971-4.963-1.09-14.095-1.059-28.202-.285-42.298-.455-10.692-.127-21.386-.033-32.079-.01-1.015.002-2.081-.283-3.044.309l-.001.002c-.834.66-1.665.664-2.494-.01l-.008-.618z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#733AED"
        d="M170.713 430.777c1.03-1.074 2.356-.602 3.544-.604 25.031-.027 50.063-.021 75.094-.021.219.139.292.275.22.414-.072.139-.143.209-.216.209-.591 2.023-2.35 1.541-3.231.898-1.458-1.064-2.924-.887-4.434-.887-23.659-.016-47.318-.009-70.977-.009z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#611DE7"
        d="M298.66 433.275c1.065 1.953.999 3.975.001 5.859-1.185 2.238-.131 2.762 1.841 2.881 1.522.094 3.087-.313 4.581.309-.017 1.262-.968.9-1.567.912-2.691.047-5.382.006-8.073.029-.986.01-2.184-.295-2.403 1.24-.624.139-1.247.109-1.872 0-.098-1.609 1.97-2.133 1.874-3.742 2.478-2.042 3.208-5.396 5.618-7.488z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#733AED"
        d="M258.094 430.176c13.937-.01 27.874-.018 41.81-.025.157.131.214.268.172.41-.042.145-.087.219-.137.219h-.034l-1.871.002c-10.645-.002-21.29-.021-31.935.021-1.09.006-2.625-.678-3.018 1.221-1.607-.764-4.433 1.757-4.987-1.848z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7335E5"
        d="M164.471 161.152c1.673-2.5 3.827-.809 5.804-.661-1.85.961-3.86.519-5.804.661z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7230E6"
        d="M216.291 167.202c.788 1.565.704 3.146-.038 4.759-.714-1.537-.763-3.123.038-4.759z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7137EC"
        d="M163.223 432.023l.001-5.615c1.728 1.871 2.251 3.744-.001 5.615z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7333EF"
        d="M249.355 430.775a65.003 65.003 0 01-.003-.623c1.313.496 3.623-1.008 3.745 1.871-1.546.481-2.468-.916-3.742-1.248z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7230E6"
        d="M216.068 162.298c-.521-1.293-.628-2.29.45-4.036.353 1.828.745 2.842-.45 4.036z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#962DA0"
        d="M223.105 174.819l-.013-1.185-.005-1.235.085-2.53c.192.023.384.042.577.056.862 1.352-.263 3.014.68 4.352l-.087.674c-.449.314-.861.257-1.237-.132z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7431ED"
        d="M166.343 427.031c-1.021-.102-1.365-.697-1.118-1.633.052-.199.472-.504.565-.455.924.475.398 1.375.553 2.088z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7333EF"
        d="M168.217 430.77c.832.006 1.663.008 2.494.01-.069.865-.538 1.258-1.403 1.199-.763-.051-1.016-.543-1.091-1.209z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4712A3"
        d="M193.181 464.479c.221-1.545 1.426-1.238 2.412-1.238 25.022-.012 50.044-.012 75.065 0 .984 0 2.192-.309 2.41 1.238l-9.988.002c-.762.484-1.615.291-2.429.293-21.681.01-43.361.01-65.043-.002-.814-.001-1.667.201-2.427-.293z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4816B4"
        d="M193.181 464.479l69.899.002c-.919 1.02-2.138.604-3.227.605-22.813.021-45.625.021-68.438-.002-1.089-.002-2.308.414-3.227-.605h4.993z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4B13B6"
        d="M188.188 463.854v.625c-16.643-.002-33.286-.002-49.929-.002-.201-.465-.058-.76.431-.889 15.896-.084 31.793-.016 47.69-.033.615 0 1.254-.096 1.808.299z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4610B3"
        d="M138.257 463.857l.001.619-4.995.002-.003-1.244c1.666-.002 3.331-.004 4.997-.004.219.139.291.279.218.418-.071.139-.144.209-.218.209z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#430BAE"
        d="M138.257 463.857v-.627c15.463 0 30.926-.012 46.389.021 1.187.002 2.514-.475 3.541.602l-49.93.004z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#601DE3"
        d="M291.169 444.506c.625-.387 1.248-.387 1.872 0 .293 1.719 1.662 1.225 2.691 1.23 5.76.037 11.52.018 17.28.016l-.039 1.244c-7.693-.016-15.385-.029-23.078-.047l.017-1.197 1.257-1.246z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5F26D4"
        d="M314.308 435.85l-.096-1.352c-.762-.881-.544-1.945-.564-2.969.047-.291.135-.57.247-.844.395-.561.595-1.406 1.587-1.135l.043-.029c.653.828.644 1.672.063 2.531l-.111 1.801c-.391.665-.78 1.331-1.169 1.997z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6915FB"
        d="M451.581 437.006c-.008-.408-.014-.816-.018-1.227-.896-1.67-.902-3.338.002-5.01h.002c2.267 2.075 1.57 4.155.014 6.237z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5214D5"
        d="M452.792 452.023c.5-2.043 2.17-1.238 3.348-1.242 23.607-.045 47.215-.033 70.82-.033 17.369 0 34.734-.008 52.104.018 1.053.002 2.219-.342 3.131 1.254H452.793v.003z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#621AED"
        d="M451.565 430.77l-.002 5.01c-1.928-1.671-2.029-3.341.002-5.01z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CA0F58"
        d="M254.274 168.611l-.297-.027-.296.029c-.706.733-1.688 1.392-.68 2.576l.119-.062c.331.337.333.718.148 1.124-.851.794-1.735.574-2.627.084v.009c.451-1.643-1.236-3.801 1.201-4.964l2.375-.107.337.25c.162.429.151.813-.28 1.088z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#AB1B90"
        d="M265.622 162.455c-.531 1.915-1.982 2.443-3.752 2.491-.89.548-1.478.22-1.879-.648 1.707-1.135 3.398-2.316 5.631-1.843z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C11461"
        d="M273.058 159.897c-1.542.852-3.111 1.603-4.956 1.298l.011-1.264c.393-.048.786-.098 1.179-.148 1.332-.096 2.199-1.576 3.677-1.236l.207.219c.277.41.255.789-.118 1.131z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#902BC5"
        d="M259.991 164.298l1.879.647c-.299 1.58-1.523 1.169-2.549 1.183-.327-.411-.358-.831-.035-1.262l.705-.568z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CB0C5B"
        d="M259.286 164.866l.035 1.262.003-.001c-.562.624-1.259.667-2.013.47a1.148 1.148 0 01-.599-.602c.413-1.391 1.584-1.052 2.574-1.129z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CB0C5B"
        d="M254.217 167.274c.352-1.364 1.538-1.099 2.496-1.277l.191.215c.308.413.304.787-.131 1.111l.045.045c-.733.669-1.512.724-2.334.169a16.554 16.554 0 00-.267-.263z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#990F4A"
        d="M255.646 184.789l-2.651-9.88c.091-.103.181-.205.271-.31.37-.209.77-.285 1.19-.271.425.044.78.232 1.08.533l-.095.179c-.034.75.542 1.251.776 1.901-.364 2.718 1.994 5.164.779 7.959-.477.299-.935.34-1.35-.111z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E50620"
        d="M250.641 172.335c.808-.548 1.564.067 2.346.103l.372.283c.444.764.338 1.49-.151 2.19 0 0-.213-.004-.214-.003-1.786.059-2.555-.813-2.353-2.573z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D90B1D"
        d="M255.646 184.789l1.136.109c.469.32.652.801.749 1.331.079.897.046 1.762-.724 2.402l-1.189-.029c.008-1.271.018-2.543.028-3.813z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3D1C63"
        d="M259.469 202.304c.285-3.416-1.458-6.542-1.408-9.923-.939-1.989-.757-4.018-.212-6.056 1.337-1 1.835-.069 2.135 1.007.572 2.06-.723 4.743.342 6.118 1.623 2.097.806 3.975.924 5.968-.514 1.009-.206 2.532-1.781 2.886z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#421232"
        d="M259.469 202.304c.836-.602.111-1.911 1.106-2.439 1.524 2.251.829 4.677.559 7.07-2.612 2.492-4.863 5.773-9.313 4.329-.355-.479-.375-.978-.085-1.494.495-.366.998-.275 1.503-.023 1.45-.482 3.139-.59 3.748-2.392 3.173-.532 2.097-3.15 2.482-5.051z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#950E3F"
        d="M258.047 186.157l.014 6.224-1.157-.139c-.032-1.205-.064-2.408-.098-3.611l.077-2.553c.264-.306.585-.329.939-.19l.225.269z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E50B08"
        d="M256.185 202.376c-1.039-1.089-.374-2.501-.709-3.725l1.362-.05c-.163 1.269 3.538 3.205-.653 3.775z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4B194F"
        d="M253.239 209.748l-1.405.103c-.437.357-.906.358-1.398.13-1.537-1.286-1.911-3.022-1.899-4.907.152-1.453-.391-2.751-.918-4.056-.204-.824-.219-1.627.274-2.37.274-.265.57-.289.884-.074a45.167 45.167 0 012.497 7.815c.291 1.323.89 2.485 1.965 3.359z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6D184F"
        d="M248.777 198.573l-.679.016c-2.606-1.426-2.289-3.621-1.56-5.926.132-.114.267-.227.401-.34l1.127 1.985.711 4.265z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2E236A"
        d="M236.841 175.167c.843-.295 1.683-.204 2.521.029.069.076.201.152.201.229-.005 5.597 1.529 11.189.088 16.795-.728.827-1.68 1.414-2.388 2.277-.574.699-1.293.959-2.001.087-.297-.687-.419-1.47-.212-2.12 1.657-5.212 1.069-10.584 1.238-15.903.016-.528.172-1.007.553-1.394z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#332166"
        d="M239.362 192.358c-.016-2.965.782-6.259-.255-8.807-1.273-3.125 1.355-5.595.255-8.357l1.186-.128c.018 2.376.401 4.594 2.585 6.042l-.004.007c.34.458.296.963.185 1.477-1.012 1.917-.447 3.986-.573 5.988-.076 1.209.07 2.447-.562 3.569-.66.799-1.482.899-2.407.559l-.41-.35z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5B163E"
        d="M236.841 175.167c-.001 4.049-.187 8.109.062 12.143.164 2.661-2.019 4.841-1.189 7.53.268.369.463.766.495 1.231.007.465-.104.896-.368 1.282-.37.33-.791.393-1.253.236l-.313-.323c.108-7.44 1.755-14.778 1.467-22.243.366.049.733.097 1.099.144z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A22FB2"
        d="M238.098 171.117l.068-1.273 1.115.089c.054.798.11 1.597.166 2.394-.858.051-1.283-.378-1.349-1.21z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4D1D51"
        d="M243.019 182.413l.109-1.298c1.532 1.346.894 3.693 2.342 5.078l.211 2.358-.392.312c-.531.121-.984.009-1.331-.435-1.042-1.891-2.197-3.766-.939-6.015z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4D1D51"
        d="M245.68 188.551c1.017 1.059 1.135 2.417 1.259 3.773l-.224.076c-.463.316-.886.219-1.286-.127-.305-.393-.452-.847-.512-1.335-.08-.834.057-1.61.629-2.264l.134-.123z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#528EC5"
        d="M589.368 217.359l3.238 4.972-1.332 1.296c-.385-.218-.768-.438-1.152-.657-.842-1.446-1.682-2.893-2.523-4.34-.602-.803-.242-1.414.395-1.971.721-.291 1.151 0 1.374.7z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#651ABF"
        d="M581.309 252.336c1.779.06 1.164 1.472 1.367 2.424-.033.227-.064.455-.096.682-.375-.23-.748-.463-1.119-.695-.586-.77-.625-1.575-.152-2.411z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#281B82"
        d="M581.309 252.336c.049.804.102 1.607.15 2.41l-1.314-1.225c.027-.443.057-.887.084-1.331.359.048.721.096 1.08.146z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6419F1"
        d="M582.649 214.807c-.025.847.652 1.235 1.131 1.766 1.295 1.438 1.229 1.376-.389 2.67-.754.602-.957 1.608-.527 2.572 1.674 3.75 1.502 7.427-.029 11.225-.789 1.957.246 4.27-.518 6.326l-.92.004v-26.972a.872.872 0 01.59-.398c.26.014.467.125.637.32l.041.008c.197.238.354.5.469.787.154.654-.036 1.21-.485 1.692z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4133CC"
        d="M582.112 212.303l-.715.094c-2.578-.568-1.16 1.484-1.166 2.108-.1 10.734-.072 21.47-.08 32.207 0 1.031-.041 2.063-.064 3.093-1.176.223-.682-.937-1.107-1.334-.029-.809-.063-1.617-.094-2.426 0-2.09-.002-4.18-.004-6.27.021-8.777.07-17.553.035-26.33-.006-1.669.111-3.284.621-4.869.184.017.365.036.551.06.73 1.19 2.568 1.771 2.023 3.667z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#537ED5"
        d="M582.692 212.899a35.91 35.91 0 00-.027-.572c.67-.035 1.393.108 1.867-.568.186-.23.418-.312.705-.225.754.416 1.104 1.194 1.637 1.81.695.983 1.789 1.799 1.408 3.248-.229.679-.455 1.358-.684 2.038-1.959-.56-2.008-2.918-3.596-3.827-.759-.412-.873-1.27-1.31-1.904z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#292160"
        d="M578.979 248.47c.371.445.738.89 1.107 1.334l.107 2.422-1.24.068c.01-1.273.018-2.549.026-3.824z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3D36CC"
        d="M582.692 212.899c.773.402 1.17 1.063 1.309 1.904-.449.001-.902.001-1.352.003.012-.635.027-1.271.043-1.907z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DBF4FA"
        d="M541.44 142.906c.809.521 1.615 1.044 2.422 1.566.453 1.605 2.4 3.158.172 4.858-.506.232-.82-.034-.869-.477-.227-2.06-1.238-2.495-2.914-1.403-.797.519-1.607-.215-2.48.229.037 1.659 3.043 2.69 1.154 4.776l-1.672-.135c-2.756-5.272-2.65-6.141 1.115-9.201.982-.674 2.035-.352 3.072-.213z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EDF4F0"
        d="M538.924 152.456c.207-1.349-.211-2.347-1.41-3.132-.914-.6-1.482-1.632-.742-2.656.574-.793 1.451-.577 2.131.111.293.295.469.322.963.134 3.869-1.479 3.885-1.442 4.168 2.417.033.762-.451 1.271-.879 1.809-1.609-1.208-1.111.822-1.734 1.128-.803.429-1.565 1.405-2.497.189z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CCEDF8"
        d="M541.42 152.267c-.18-1.541.24-2.158 1.734-1.128-.331.754-1.077.87-1.734 1.128z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#356FD0"
        d="M535.19 159.873a3.757 3.757 0 01-.6.063c-.617.391-1.23.513-1.818-.054-.229-.21-.457-.419-.684-.63.213-.619.43-1.237.643-1.855 1.305-.609.152 2.411 1.836 1.242l.65.025-.027 1.209z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#416D85"
        d="M541.44 142.906l-3.072.214c-.211-.223-.422-.445-.635-.667l3.695.042c.008.137.012.275.012.411z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B2468"
        d="M260.575 207.313v-7.449c.608-4.309-2.112-8.271-1.309-12.616.134-.727-.532-1.033-1.218-1.091l.008.001c-.589-2.794-.825-5.66-1.812-8.375-.204-.56-.13-1.217-.697-1.62-1.662-.223-.145-.742-.105-1.124 33.041-.029 66.082-.071 99.125-.085 26.496-.012 52.992.014 79.489.009 1.244 0 2.486-.135 3.727-.207.295-.128.545-.077.744.183-.277.8-.555 1.599-.834 2.397l-.367.674c-.824 1.339-1.648 2.68-2.469 4.02-1.811 1.36-2.238 3.654-3.596 5.323-1.209 1.487-1.588 3.339-2.125 5.115-1.346 3.46-3.104 6.709-5.035 9.87-2.379 2.846-4.768 5.575-5.809 9.38-.766 2.793-2.424 5.401-4.953 7.192-1.201-.319-2.393-1.362-3.623-.058-.383.381-.701.823-1.107 1.184a2.82 2.82 0 01-.759.347 7.62 7.62 0 01-1.23.182c-1.668-.021-2.633 1.307-3.906 2.047-.783.237-1.477.22-1.869-.653.043-.845.615-1.343 1.193-1.84 1.23-.777 2.254-1.818 3.426-2.675 3.116-2.278 3.114-2.28.512-5.182a2.448 2.448 0 01-.338-.798c.281-2.335-1.307-2.424-2.949-2.44-.76-.108-1.457-.399-2.148-.712-8.365-4.811-17.143-5.9-26.367-2.904-.777.253-1.635.396-2.088 1.206-.074.687.186 1.373.002 2.058-.158.426-.443.713-.893.821-.447.019-.801-.162-1.088-.494-.447-.632-.848-1.307-1.514-1.756-.621-.492-1.51-.485-2.068-1.097-.283-.661-.135-1.214.443-1.63 2.611-1.882-.184-1.049-.689-1.358-.729.001-1.458.018-2.186.022-1.35.005-2.701-.02-4.054-.008-5.114.044-7.597 4.002-5.698 9.1.275.314.423.685.513 1.083.099.949.362 1.843.873 2.657.146.4.153.802.019 1.205-.496.749-1.274 1.345-1.283 2.362-1.242 1.33.576 2.816-.211 4.172-.359.276-.771.398-1.216.43a3.06 3.06 0 01-1.269-.24c-1.096-.889-1.93.044-2.841.418-1.849-.405-1.272 1.016-1.388 1.876-.271 2.051.627 4.272-.896 6.142-.646.516-1.331.627-2.071.218-.569-2.182-2.862-.909-3.979-1.964-1.222 1.01-1.937 3.544-4.202 1.417-.701-1.315-.408-2.756-.532-4.143.032-1.105-.905-1.871-1.033-2.92.021-2.703-1.628-4.536-3.315-6.35-.289-1.923-2.311-3.023-2.402-5.037.275-.402.816-.163 1.138-.463-.388.168-.792.085-1.194.082-1.51-.09-3.064.014-4.318-1.083-1.465-1.761-3.68-2.724-4.991-4.652-4.011-3.75-8.889-4.644-14.143-4.301-.48.012-.958.011-1.438.007-2.434-.171-4.805.148-7.121.897a8.088 8.088 0 01-1.822.27c-1.487.225-3.034-.447-4.49.306a.925.925 0 01-.437.537c-.592.368-1.811-.213-1.73 1.164a2.583 2.583 0 01-.751.335c-3.148-1.404-3.836 2.146-5.875 3.029-1.026.444-1.773.725-2.769.327a62.432 62.432 0 00-4.67-2.252c-.395 1.068.355 1.262.788 1.559 1.917 1.322 2.523 2.544.231 4.213-1.147.836-1.412 2.466-2.134 3.703-3.305.831-4.51 4.308-7.339 5.856-1.118.612 1.086 1.089 1.099 2.002-1.837 3.354-.89 7.177-1.817 10.724-.891 3.406.459 6.713 1.764 9.885.541 1.108.275 2.155-.159 3.238-.326.812-.854 1.746.353 2.365.658.126 1.32.126 1.981.113 2.198.102 1.544-2.099 2.45-3.04.403-.258.826-.286 1.268-.124.248.171.433.398.568.667.674 3.099 1.703 5.977 4.792 7.543.971.377 1.742 1.029 2.455 1.763.802 1.348 2.358 2.093 2.93 3.626.359 1.117 1.102 1.845 2.222 2.193.978.367 1.748 1.018 2.445 1.771.728 1.079.301 1.697-.822 1.998-.668.18-1.451-.023-1.978.612-.592.676-1.702.945-1.652 2.107.071.254.162.552.499.421.259-.101.277-.428.336-.693.102-.69.27-1.345.812-1.833.087-.06.222-.186.252-.167 3.288 2.305 6.717 2.077 10.227.589 2.569-.041 5.141-.111 7.695.029 3.852.212 7.518-.483 11.104-1.773.404-.254.843-.43 1.292-.573.729-.141 1.318-.577 1.935-.956 1.7-.823 3.708-1.209 4.56-3.232.738-1.028 1.727-1.84 2.48-2.857.671-.743 1.303-1.538 2.301-1.879 1.511-.173 2.445 1.5 3.977 1.232.869-.233.764-.971.833-1.609.235-.969-1.114-1.465-.749-2.473.381-.71.785-1.408 1.051-2.175.624-.951 1.012-2.001 1.296-3.096.993-2.43 1.138-5.087 2.03-7.543.063-.826.167-1.639.539-2.393.332-.521.654-1.044.943-1.592.297-.562.719-1.058 1.443-.893.852.193 1.047.924 1.119 1.66.113 1.189-.455 2.49.589 3.519.809.937.534 1.925.126 2.918-.689 1.688-.654 3.405-.099 5.137-.07-2.745 1.322-5.508-.225-8.245-.511-.747-.464-1.538-.218-2.35.855-1.152.648-2.538.895-3.833.333-1.759.613-3.721 3.123-3.711 1.883 3.314.712 6.802.665 10.209 2.263-2.91.194-6.625 1.63-9.719.656-.754 1.318-1.501 2.321-1.797 1.155-.154.349-1.145.692-1.684.695-1.095 1.171-.907 1.665.116.556 4.875.099 9.764.293 14.636-.182 1.385.175 2.537 1.121 3.654 1.851 2.184 2.478 5.163 4.544 7.234.471 1.031.556 2.074.092 3.124a3.828 3.828 0 01-.449.546c.133-.109.266-.218.422-.34 1.752-.679 2.787.372 3.598 1.6.58.877 1.164 1.66 2.137 2.093.813.77 1.104 2.239 2.68 1.993.52-.004 1.125-.013 1.404.428 1.504 2.396 3.846 2.249 6.197 2.133 1.707.021 3.381.118 4.387 1.821.25.658.182 1.247-.391 1.715-.916.576-1.811-.113-2.729-.066-.113.717.73 1.017.707 1.682-.023.467-.262.815-.621 1.091-3.24 2.33-6.539 4.598-8.473 8.267a2.303 2.303 0 01-.512.69l-1.292 1.265c-.374.561-.787 1.071-1.501 1.213a6.8 6.8 0 01-3.379-.133c-1.021-.498-2.088-.862-3.223-1.033-.953-.146-2.208-.539-2.236-1.401-.131-4.199-3.977-5.114-6.373-7.031-2.805-2.242-5.989-4.569-9.964-4.319-3.407.214-6.604 1.47-9.815 2.569-3.762.612-7.396 2.047-11.322 1.667-.832-.082-1.958-.135-2.227 1.138.113.426.402.642.796.823 2.659 1.236 2.671 1.344.597 3.68-.725.354-1.469.383-2.229.144-1.849-1.157-3.793-1.301-5.813-.512-.191.178-.385.352-.567.535-1.054 1.358.749 2.194.625 3.387-.004 9.346.448 18.686-.23 28.009-1.748 1.86-2.242.338-2.505-1.055-.302-1.596.247-3.229.072-4.681-.07.847.137 1.899-.333 2.881-1.196 2.102-.495 4.388-.661 6.587-.16 2.117.274 4.27-.35 6.361-1.396 1.561-2.671 1.418-3.575-.438-1.847-3.789-2.117-3.939-6.145-2.598a2.231 2.231 0 01-.917-.027c-3.888-1.117-7.81-.826-11.729-.262a7.166 7.166 0 00-.82.912 92.02 92.02 0 01-.717 1.037c-.158.256-.323.502-.484.756-.574 3.893-.101 7.801-.254 11.695-.053 1.328.131 2.678-.32 3.977-.701 1.328-1.863 2.227-2.969 3.18-.697.383-1.462.463-2.236.492-2.278-.09-2.801 2.395-4.529 3.109-.662.486-1.362.922-2.027 1.412a3.294 3.294 0 01-.812.268 3.043 3.043 0 01-1.688-.256c-2.521-.947-7.248.104-9.077 2.082-.529.57.196.85.479 1.211.234.383.271.783.139 1.203-.438.893-1.777.773-2.052 1.848-.101.26-.229.502-.369.742a2.581 2.581 0 01-.586.594c-1.061.662-2.249 1.096-3.267 1.836-2.363 1.307-3.958 3.461-5.844 5.297a1.142 1.142 0 01-.835-.137c-.579-.68-1.099-1.4-1.522-2.189a3.704 3.704 0 01.036-2.68c.814-1.07.963-2.311.893-3.6-.021-1.031.108-2.109-.894-2.83-.637-.5-1.475-.531-2.157-.92-1.294-1.188-2.27.246-3.402.42-4.066.158-8.127.426-12.174-.141-1.537-.65-1.101-2.314-1.742-3.406-1.203.059-.577 1.297-1.13 1.762-.83 1.09-.589 2.465-.956 3.678-.39 1.039-.394 2.316-1.707 2.789a2.104 2.104 0 01-1.036-.068 1.58 1.58 0 01-.735-.74c-.767-4.797-.156-9.627-.369-14.436-.058-1.314.295-2.684-.477-3.902-.399-.273-.815-.52-1.234-.76-.705-.41-1.394-.857-2.263-.83-2.177-.068-4.355.072-6.522-.076-1.173-.08-2.642.033-2.54-1.867 1.067-1.254 2.551-.928 3.932-1.063 1.663-.16 3.427.51 4.962-.582.002-.102.077-.248.036-.295-1.765-2.09-6.757-1.609-8.079.773-.179.459-.5.809-.845 1.145-2.3.775-4.632 1.465-7.016 1.861-1.152.189-2.178.461-3.09 1.176-1.478.855-1.174 2.363-1.178 3.631-.065 23.658-.049 47.318-.026 70.979.001 1.453-.014 2.951 1.45 3.867 1.421 1.277 3.013 1.047 4.596.453 1.676-.627 3.395-.752 5.122-.475 1.142.184 2.331.539 1.523 2.182-2.037 1.107-4.458.658-5.883 1.398 7.277-.135 15.214-.037 23.149-.057 5.792-.014 11.584-.023 17.376.012 1.43.008 2.922-.162 4.17.834.287.582.274 1.115-.251 1.566-16.016.17-32.027.027-44.292.088 12.218.098 28.19-.08 44.156.064.404.232.508.563.313.982-1.442 1.127-3.155.854-4.787.859-13.161.029-26.322-.002-39.482.031-1.827.004-3.949-.291-4.086 2.498.894 1.148 2.139.586 3.192.592 14.285.037 28.571.021 42.856.033 1.439.002 2.903-.174 4.307.342 1.588 1.408.393 2.299-.599 3.229-.524.24-1.06.252-1.601.072-1.309-.822-2.784-.654-4.222-.654-10.757-.01-21.515.01-32.272-.018-2.889-.006-5.792.217-8.667-.301-.2-.037-.412 0-.606-.049.266.393.838.27 1.119.66.292.551.256 1.066-.12 1.559-1.636 1.012-3.459.508-5.203.658-5.34-.01-10.68.021-16.02-.018-1.313-.008-2.699.209-3.822-.783-.453-1.783.812-1.865 1.982-1.916 1.974-.088 3.952-.031 5.929-.027-1.836-.031-3.674-.064-5.508-.004-2.153.068-3.029-.932-2.925-3.02.057-1.141.005-2.289.005-3.432 0-78.271 0-156.545-.002-234.816-.003 79.156.001 158.314-.012 237.469 0 1.764.146 3.541-.255 5.289-.657 1.184-1.641 1.059-2.689.674a1.78 1.78 0 01-.673-1.01c-.008-3.004-.115-6.01-.115-9.014.001-76.715.006-153.43-.021-230.146-.001-2.513.358-4.935.816-7.393.451-2.414 1.764-3.341 4.06-3.369 2.702-.032 5.406.023 8.107-.033 11.113-.233 22.237.515 33.344-.477 2.482-.221 4.964.339 7.405.852 1.386.574 2.104 1.699 2.225 3.118.333 3.919 1.04 7.8 1.355 11.702.178 2.198-.309 4.475.245 6.702-.071 1.257-.788 2.177-1.595 3.045-1.822 1.938-4.03 2.208-6.47 1.472-.397-.12.114 0-.294-.084-.046.237.277.215.292.434-.121.692-.636.921-1.199 1.102-1.63.225-3.333.131-4.778 1.132-1.753.68-3.532 1.308-5.152 2.29-1.339.734-2.788 1.292-3.882 2.421-2.25 1.762-4.152 3.874-6.075 5.969a1.637 1.637 0 01-1.22.374 1.724 1.724 0 01-.746-.413c-.647-.82-1.239-1.826-2.449-.699-1.204.446-2.471.245-3.705.376-.972.104-1.873.375-2.271 1.37-.434 1.088-.719 2.401-.055 3.31 1.03 1.411 1.665-1.348 2.828-.528.523.625.578 1.386.63 2.149-.071 1.073.232 2.051.758 2.978.164 1.147-.531 1.677-1.459 2.041-1.292.443-1.59-.931-2.556-1.487.082 2.922 1.46 5.113 3.007 7.239.467 1.769.261 3.566.256 5.354a4.378 4.378 0 01-.297 1.361c-.754.984-.959 1.985-.078 3.017.592 2.739.559 5.457-.401 8.223 1.179.313 1.596-.789 2.367-1.085.258-.122.531-.187.814-.196.274.041.518.154.729.336.494.742.581 1.719 1.32 2.326.442.489.946.906 1.457 1.32.763.679 1.292 1.49 1.44 2.521.032 1.598.74 2.71 2.308 3.2.672.329 1.215.742 1.013 1.589-.038.19-.167.285-.374.248.143.18.25.142.338-.133 1.102-.376 1.63.481 2.303 1.027.183.201.332.426.456.665.245 1.186 1.212 1.604 2.168 2.037 1.317.697 2.6 1.463 4.053 1.86 1.615-.015 2.82 1.389 4.462 1.269.712.037 1.661-.063 2.03.463 1.369 1.944 2.599.721 3.81-.056.58-.373.935-1.074 1.67-1.275.458-.088.895-.03 1.307.19.357.287.598.659.805 1.055 1.053 1.491 2.651.563 3.953.909 1.82.483 3.556-2.471 5.534-.081.163.196 1.571-2.313 3.359-1.872.347.229.543.584.784.909.36.485.855 1.166 1.431.599.55-.539-.415-1.001-.515-1.565-.147-1.069.586-1.554 1.4-1.644 1.737-.194 1.786-1.315 1.67-2.613.054-.294.193-.537.413-.738.246-.154.512-.264.791-.34 3.459-1.793 6.96-3.543 7.367-8.104.032-.56.137-1.087.669-1.407 1.143-.167 1.769-.994 2.362-1.867 1.712-4.078 2.84-8.292 2.834-12.73-.002-2.274.102-4.493 1.091-6.583 3.149-3.27 3.73-7.257 3.385-11.579-.087-1.079-.271-2.509 1.634-2.73 1.234-.143.175-1.125.292-1.709-.271-1.677-.245-3.36-.19-5.043.778-5.07-.065-10.163.211-13.936-.166 3.095.352 7.505-.182 11.901-.788.564-1.269.158-1.661-.53z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7434E8"
        d="M362.945 156.156l19.971-.001c.297 2.073-.74 2.489-2.635 2.571-2.046.088-4.472-1.225-6.101 1.174-1.367.624-2.738 1.214-4.25.433-1.139-.885-2.486-.809-3.813-.848-1.119-.033-2.272.048-3.172-.826v-2.503z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7238E0"
        d="M370.426 160.516c1.211-.446 2.359-1.278 3.754-.615 2.367-.543 4.127 1.85 6.507 1.341.432-.093.834.373.678.8-1.17 3.22-1.609 6.735-3.783 9.545-.285.366-.906.792-1.275.718-2.797-.559-5.715-.961-7.971-2.864-.9-.76-.285-2.181-.398-3.297 1.889-.479 1.588 2.145 3.113 2.183.717.15 1.377.515 2.092.615 1.662.232 3.121-.178 4.053-1.682.77-1.241.82-2.608.094-3.847-.84-1.427-2.084-2.237-3.879-2.079-.949.084-1.752.676-2.711.637-.537-.183-.602-.597-.527-1.077.085-.126.167-.252.253-.378z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6E34F7"
        d="M263.083 168.642c-.098-1.331.2-2.101 1.696-2.755 1.27-.557 3.322-.681 3.562-2.88.068-.623 1.025-.694 1.586-.378.776.436.728 1.199.322 1.875-.622 1.035-1.985 1.519-2.176 2.887-1.55.868-3.058 1.904-4.99 1.251z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7432F8"
        d="M362.945 158.66c1.818 0 3.639.045 5.456-.018 1.363-.047 2.156.378 2.025 1.874l.008.013c-.389.645-.863 1.175-1.672 1.27-1.93-.292-3.99.572-5.817-.651v-2.488z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7932E8"
        d="M263.083 168.642c1.65-.471 3.1-1.743 4.99-1.252.87.098 1.537.692 1.124 1.425-1.053 1.869-3.354 1.315-5.015 2.09-1.221.571-.952-1.339-1.099-2.263z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7434E8"
        d="M362.945 161.147l6.243.008c.459 1.291.072 1.734-1.248 1.247-4.096-1.007-3.724 2.246-4.353 4.729-.933-2.03-.509-4.038-.642-5.984z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6E36CF"
        d="M367.939 162.401c.814-.019 1.225-.439 1.248-1.247l1.246-.626c.014.441.023.882.037 1.323-.072 2.237-.246 4.473-.002 6.71-2.07.479-.881-2.457-2.531-2.417l.002-3.743z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7933E2"
        d="M256.844 168.64c.204.001.418-.039.611.009 1.055.267 2.657-.721 3.016 1.135.213 1.103-.673 1.262-1.566 1.353-1.98.201-2.164-1.012-2.065-2.493l.004-.004z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#8230D3"
        d="M255.536 174.861l-1.181-.042c-.854-.588-.402-1.846-1.25-2.438l-.117.058.133-1.311c3.241-.332 2.38 1.99 2.415 3.733z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#794CB9"
        d="M438.526 174.94l-.744-.182c.119-.967-.242-2.189 1.277-2.416l.775.104c-.201.955-.578 1.817-1.308 2.494z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BA2092"
        d="M253.001 171.189c-.854-.134-1.186-.661-1.11-1.487.108-1.163.993-1.056 1.791-1.089l-.681 2.576z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#932ABF"
        d="M273.058 159.897l.116-1.132c.794-.042 1.586-.086 2.379-.129l-.012 1.25-2.483.011z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7B32E1"
        d="M280.558 159.903c-.099 1.022-.695 1.367-1.632 1.119-.199-.053-.505-.473-.457-.566.478-.923 1.378-.396 2.089-.553z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#902BC5"
        d="M256.773 167.323l.131-1.111 2.42-.084c-.232 1.718-1.523 1.177-2.551 1.195z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7933E2"
        d="M254.484 167.537l2.335-.168.025 1.271-.004.005-2.564-.033c.068-.359.138-.717.208-1.075z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7F29FD"
        d="M259 173.104c-.207.438-.596.52-1.004.465-.383-.052-.915-.083-.776-.667.108-.457.575-.515.984-.462.387.047.849.067.796.664z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EDF4F8"
        d="M627.575 176.134c.748-1.26 1.646-2.865 3.17-1.296.758.78 3.613 2.094.568 3.782-1.105-1.038-2.604-1.488-3.738-2.486z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9F2E6"
        d="M627.575 176.134c1.918-.181 3.188.612 3.738 2.486-1.729-.104-4.131.809-3.738-2.486z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3BA5ED"
        d="M542.694 279.737c-.51 2.965.658 4.182 3.699 3.779 1.498-.2 3.041-.036 4.486-.036.412-1.724-1.713-.791-1.482-2.244 1.611-.304 3.377-.153 3.516-2.941.111-2.266 5.24-3.56 6.932-1.975.875.822 1.773.946 2.822.92.018 3.177.018 3.177 2.139 4.24-.223 1.189-2.32.43-2.137 2-.367.332-.781.375-1.229.205-1.063-.949-.879-3.084-2.936-3.097-3.65-.709-3.561 2.314-4.398 4.415-1.971 1.998-4.338 3.087-7.164 3.069-1.049-.006-2.047.152-2.961.691-2.193.21-2.18-1.818-2.887-3.001-.615-1.029-.762-2.309-.896-3.53.342-1.323 1.176-2.151 2.496-2.495z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#41A3E9"
        d="M540.198 282.233c2.139 1.062 1.02 3.68 2.453 5.151.406.417.59 1.01 1.277 1.087.398.323.547.759.574 1.253-.023.497-.18.934-.588 1.248-.34.194-.973.385-.977.584-.059 4.563-1.859 8.753-2.736 13.135l-1.234-.65c-1.932-3.062-2.256-6.73-3.771-9.95.059-2.302-.203-4.633.635-6.864 1.068-.779.268-2.666 1.859-3.134.781.584.852 1.567.711 2.265-.615 3.019-.076 5.757 2.033 8.621.084-2.886.85-5.506-.988-7.932-1.154-1.523-1.65-3.078-.504-4.824l-.008-.002 1.264.012z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5FA6D0"
        d="M566.444 294.786c-.107 5.423-.834 6.166-6.063 6.179-1.738.004-3.475.004-5.209.006-.855.631-1.729.729-2.627.09-.449-.708-.445-1.409.035-2.101 3.146-.62 6.309.174 9.457-.126 2.277.021 2.072-2.092 2.836-3.351.459-.761.082-2.164 1.646-2.021.263.458.273.903-.075 1.324z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#56A1CF"
        d="M566.444 294.786l-.084-1.42c-.686-.618-.748-1.474-.73-2.278.037-1.603-.908-1.87-2.191-1.782-.299.011-.594.002-.893-.009-.766-.019-1.531-.011-2.291-.124-.617-.128-1.193-.325-1.463-.978.342-1.177 1.344-.96 2.205-1.039.148.015.293.029.441.047.697.18 1.393.505 2.094.516 4.141.072 4.143.049 4.135 4.289-.002.933.148 1.899-.047 2.791-.286 1.324-.77-.083-1.176-.013z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3BA5ED"
        d="M562.667 277.24c-.26-2.424.756-2.785 2.568-1.484 1.482 1.063 3.012 2.135 3.672 3.981-2.756.86-4.217-1.525-6.24-2.497z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#459FE9"
        d="M563.911 309.692c-.443 1.232-1.738 1.601-2.518 2.492l-2.475-.038c.432-2.268.639-4.704 3.746-4.948.696.692 1.022 1.569 1.247 2.494z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#36A8EE"
        d="M552.68 302.205c-.18 1.308-1.232 1.613-1.965.967-1.719-1.527-3.682-.733-5.529-.973-.701-1.312.131-2.03 1.045-2.72.426-.192.863-.22 1.311-.096.877.659 1.756.507 2.635-.013a1.745 1.745 0 011.191.081c.846.571.504 1.735 1.193 2.388.039.122.078.244.119.366z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#56A1D1"
        d="M558.92 279.729c2.225.325 2.59 1.891 2.504 3.757.656.832.652 1.664-.008 2.492.008.408.016.816.021 1.226l-.041.036c-1.703.719-1.783-.768-2.293-1.68-.336-1.2-.449-2.447-.738-3.66a3.332 3.332 0 01.047-1.395c.13-.284.297-.543.508-.776z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#38A4F8"
        d="M561.417 285.978c.004-.83.004-1.663.008-2.492.414-.003.828-.003 1.244-.005 1.916-.344 3.061 1.226 5.463 1.859-2.735.988-4.764.469-6.715.638z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5097D2"
        d="M547.678 299.741c-.414-.007-.828-.011-1.24-.018-.836.512-1.666.721-2.482-.045.012-.417.02-.834.031-1.253.236-.195.494-.362.77-.501a4.07 4.07 0 01.9-.194 44.505 44.505 0 014.133-.009c.314.019.619.081.918.178.301.106.559.28.781.511.262.443.277.875-.061 1.292-.414.002-.83.005-1.244.009-.828.55-1.662.678-2.506.03z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#33ABE5"
        d="M563.911 309.692c-1.678-.201-1.125-1.515-1.246-2.494 1.244.422 3.102-1.01 3.738 1.238l-2.492 1.256z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6795BB"
        d="M544.584 298.41l-.301.018-.299-.002c-.021-2.484-.045-4.968-.07-7.453.016-.411.033-.819.051-1.23.406-.194.729-.101.971.28.623 2.826 1.049 5.647-.352 8.387z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#49A1F7"
        d="M543.956 299.679l2.482.045c-.359.855-1.338 1.397-1.252 2.476-.566-.764-1.932-1.139-1.23-2.521z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4E9DDC"
        d="M571.383 304.693c-.59 1.067-1.383 1.93-2.492 2.471-.244-1.908.586-2.731 2.492-2.471z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#36A8EE"
        d="M552.682 300.915c.83.02 1.66.037 2.49.056-.209 1.667-1.52 1.112-2.492 1.234l-.006-.006c-.369-.43-.33-.858.008-1.284z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#41A3E9"
        d="M542.68 306.597c-.877-.566-2.053-.739-2.475-1.899 1.346-.044 2.7-.103 2.475 1.899z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EF3D50"
        d="M547.78 258.486c-.023-.4-.051-.801-.076-1.2-.359-.371-.332-.803-.191-1.25 1.406-.866 1.768.33 2.258 1.182.809 1.403 1.766 2.198 3.6 2.344 2.842.225 3.322 1.224 3.342 4.972-.85 1.261-1.807-.164-2.701.105-2.859-1.261-4.383-3.872-6.232-6.153z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B13C63"
        d="M566.438 265.385l1.139.456c-3.287 1.213-6.596 1.425-9.939.22.125-.132.25-.263.371-.396 2.788-.712 5.591-.984 8.429-.28z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B63D57"
        d="M554.01 264.639c.838-.959 1.609.361 2.426.07 1.205-.43 1.641-.034 1.295 1.204l-.094.147c-1.344-.129-2.504-.726-3.627-1.421z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F2E3F6"
        d="M538.319 233.553l.566-.008c-.406 1.151-.76 2.323-1.229 3.446-.775 1.856-2.131 2.333-3.994 1.591-2.191-.873-4.4-1.689-6.604-2.53-2.926-1.838-6.51-2.306-9.273-4.474-.814-2.638.662-4.671 1.797-6.794.904.432 1.656 1.029 2.127 1.94.045.285.008.559-.096.826-1.928 1.848-.244 2.363 1.115 2.99.855.473 1.738.879 2.676 1.168.668.234 1.316.513 1.973.772 1.627.58 3.242 1.228 4.73 2.081 2.059 1.182 3.52.936 4.486-1.32.644-.253 1.22-.16 1.726.312z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FBF9FB"
        d="M521.393 226.675c-.789-.453-1.777-.714-1.811-1.89.004-.427.01-.852.016-1.278.133-.012.268-.027.402-.042.434-.304 1.895-.103.613-1.261-.084-.076.096-.337.256-.471.188-.435.379-.869.566-1.303 1.154-.735.742-2.111 1.275-3.101l.006-.019c2.258 2.458 1.758-.651 2.504-1.239.947-.808 1.955-.698 2.826.019.979.807 2.148 1.48 2.119 3.119-.006.383 1.566.252 1.67 1.351.043.447-.092.805-.377 1.126l-.73.04c-.746.366-1.533.004-2.291.136-.965.083-1.566.73-2.16 1.392-.426.511-.826 1.048-1.354 1.465-1.128.739-2.083 1.792-3.53 1.956z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9F1FA"
        d="M522.711 217.33c-.248 1.106.771 2.734-1.275 3.101.193-1.129.563-2.185 1.275-3.101z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F2E3F6"
        d="M520.87 221.733c-.063.692 1.691 2.292-.869 1.732.289-.578.578-1.155.869-1.732z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C63A5E"
        d="M546.463 247.349c.363-.685.729-1.369 1.094-2.051l.416.321c.404.609.496 1.304.533 2.012-.232 1.633.723 3.572-1.211 4.773-1.152-1.101-.098-2.635-.748-3.833l-.084-1.222z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CC2D4F"
        d="M546.547 248.571c.955 1.131.334 2.484.516 3.723.783.628 1.24 1.366.832 2.405-.371.39-.766.437-1.188.079-.519-2.057-.486-4.128-.16-6.207z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B83859"
        d="M546.708 254.778l.957-.004c.354.385.402.793.1 1.228l-.061 1.284c-.696-.692-.836-1.603-.996-2.508z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3784C4"
        d="M558.924 271.188c-.006.133-.02.266-.041.396-2.068.003-4.137.005-6.207.005 0-.152 0-.304-.008-.456 2.088-.268 4.174-.331 6.256.055z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#39A6EF"
        d="M538.942 282.223c-.166 1.923.242 3.487 1.717 5.008 1.861 1.913.898 8.016-1.332 9.65-.928-1.682.645-4.668-2.543-5.173-.113-.017-.316-1.134-.09-1.384 1.711-1.887.76-4.146.996-6.229-.002-.907-.014-1.817 1.252-1.872z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2D1E60"
        d="M568.903 212.331c-2.08.015-3.27-.249-1.738-2.784.824-1.365 2.109-2.795 1.744-4.7.271-1.207.584-2.41.455-3.667.291-1.636-1.42-2.853-.955-4.526.104-.29.268-.538.492-.746.459-.19.883-.163 1.254.196 1.248.719.014 3.968 3.18 2.96.654-.208-.303 1.303-.059 2.025-.047 1.145.088 2.297-.141 3.436a3.563 3.563 0 01-.373.774c-1.408 2.275-2.189 4.899-3.859 7.032z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2A2164"
        d="M557.204 187.345c-1.225-.647-4.219 1.33-4.209-1.338.008-2.256 2.867-.789 4.418-1.091 1.191-.231 2.463-.042 3.699-.028.797.008 1.434.237 1.465 1.188.031.949-.563 1.252-1.377 1.265-1.237.018-2.473.004-3.996.004z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#262159"
        d="M565.118 197.442l.064-1.97 1.229-.617c.949-.368 1.096.49 1.496.969.129.245.219.502.285.769.055.952.213 1.908-.078 2.853a1.54 1.54 0 01-.504.624c-.971.342-1.484-.283-1.988-.938a4.928 4.928 0 01-.621-.977.768.768 0 01.117-.713z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#212559"
        d="M576.387 204.849l.01 3.736c.375.417.332.834-.002 1.25l-2.498-1.249c-.623-.833-.766-1.665.006-2.496l2.484-1.241z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2A2164"
        d="M578.315 199.241c-.23.39-.457.78-.686 1.17-.67-.127-.852-.76-1.232-1.188.445-1.448-1.076-3.452 1.234-4.374.073 1.489-.257 3.039.684 4.392z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#212559"
        d="M576.397 199.224l1.232 1.188c-.346 1.439-.813 2.865-.523 4.38l-.701.039c-.053-1.87-1.112-3.737-.008-5.607z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2D1E60"
        d="M566.417 193.605c.072-.665.328-1.155 1.09-1.204.867-.056 1.334.339 1.4 1.203.666.832.666 1.664.004 2.496l-.008.005c-.414.366-.828.366-1.246.002v-.003c-.475-.804-.395-1.882-1.24-2.499z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#331A66"
        d="M573.903 206.09l-.006 2.496-1.238-.005c-.984-1.244-.76-2.491-.008-3.739l.004.002c.41-.371.824-.372 1.24-.007.004.418.006.836.008 1.253z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1D2169"
        d="M573.895 204.837l-1.24.007c.193-1.253-.508-2.656.621-3.755 1.125 1.098.42 2.497.619 3.748z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2A2164"
        d="M577.643 179.875c-.004.834-.01 1.669-.016 2.504-.859-.081-1.244-.55-1.188-1.412.056-.758.544-1.013 1.204-1.092zM568.911 196.101l-.004-2.496c1.668.208 1.133 1.517 1.248 2.5l-1.244-.004zM566.417 193.605c1.664.211 1.127 1.516 1.24 2.499l-1.246-1.249c.004-.417.004-.834.006-1.25z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#631AED"
        d="M530.194 173.665c.012-.427.02-.853.029-1.28 3.154 2.184 6.807 1.307 10.188 1.349 12.875.157 25.752-.003 38.627-.131 2.045-.021 2.4.904 2.377 2.648-.068 5.296-.047 10.596-.002 15.893.008 1.028-.527 2.433 1.248 2.691l.748.055c-.277.394-.551.787-.826 1.181-.781.704-1.57.705-2.361.02-.053-5.578-.168-11.155-.129-16.732.023-3.506-.74-4.41-4.293-4.425-15.154-.063-30.307-.122-45.459-.183-.049-.363-.096-.725-.147-1.086z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5342DE"
        d="M580.221 196.091l2.361-.02c-.047 1.686-1.381 1.158-2.303 1.336-.019-.438-.04-.877-.058-1.316z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FE315D"
        d="M565.161 241.036c-.061.873-.533 1.26-1.396 1.209-.768-.045-1.025-.538-1.1-1.205.832 0 1.664-.001 2.496-.004z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BE304F"
        d="M551.485 240.427c-.039.19-.064.381-.08.573-.633.939-.941 2.28-2.529 2.032-.207-.265-.197-.514.061-.74a8.85 8.85 0 00.154-.591l2.336-2.053.058.779z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C63A5E"
        d="M548.936 242.292c.008.196.012.392.008.588.77 1.416.559 2.363-1.225 2.552l-.16-.135c.295-.98.59-1.958.887-2.938.16-.036.324-.058.49-.067z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#212559"
        d="M572.651 204.842c.004 1.247.006 2.492.008 3.739-.002.418-.004.836-.008 1.254v-.001c-1.625.27-1.33 3.417-3.748 2.497.537-2.852 1.582-5.452 3.748-7.489z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1E2758"
        d="M570.153 201.1c-.414 1.248 1.008 3.108-1.244 3.747-.443-.009-.889-.016-1.332-.024-.82-1.661-1.16-3.315.053-4.955l.045-.025c1.501-.913 1.722.696 2.478 1.257z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#631645"
        d="M567.629 199.867l-.053 4.955-.609.631c-.686-.503-.52-1.282-.637-1.969-1.002-1.541-1.756-3.11-.564-4.904.721.286.877 1.387 1.863 1.287z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#26235A"
        d="M576.395 209.834l.002-1.25c.848.071 1.271.535 1.225 1.38-.033.553.172 1.438-.666 1.368-.727-.061-.493-.937-.561-1.498z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#212559"
        d="M572.651 209.834c1.027.098 1.365.7 1.119 1.634-.053.2-.475.506-.566.458-.924-.478-.397-1.38-.553-2.092z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E94450"
        d="M568.883 244.802l1.273-.016c.127.106.254.212.383.316 2.148 2.333 1.135 4.792.324 7.268-1.145 3.489-5.816 6.918-9.4 6.86-.803-.201-1.543-.469-1.545-1.493 1.48-1.448 3.863-1.11 5.309-2.785.807-.934 1.832-1.658 2.188-2.918 1.039-1.942.926-3.855-.162-5.74a1.886 1.886 0 01.162-.815c.365-.494 1.08-.23 1.468-.677z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F33C45"
        d="M551.426 242.92c.121 1.344-.473 2.931 1.252 3.739.25.232.404.517.467.854.047.512-.061.992-.289 1.448-1.232 1.862.232 4.422-1.58 6.139-2.217.708-3.107-.453-3.053-2.42.063-2.209-.055-4.479.945-6.565.647-1.138.374-2.931 2.258-3.195z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D34851"
        d="M552.67 248.534c.006-.412.01-.822.012-1.234.57-.475.682-1.269 1.229-1.764 2.73-2.378 5.762-1.347 8.756-.763 2.08-2.138 4.145.093 6.219.029-.334.564-.912.632-1.475.735-.779.732-1.801.5-2.715.694-.84.134-1.264.899-1.938 1.29-.264.11-.535.156-.82.156-.742-.087-1.279-.604-1.918-.903-2.533-1.18-4.502.061-4.504 2.863-.002.986.518 2.023-.416 2.867a1.392 1.392 0 01-1.32-.123c-.582-1.221-1.84-2.249-1.11-3.847z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EC3F51"
        d="M562.667 244.773c-.123.46-.189 1.25-.85.87-2.742-1.578-5.318-1.154-7.861.412-.643-.208-.793-.908-1.275-1.275 2.757-1.781 8.288-1.785 9.986-.007zM551.426 242.92c-.84.867-.979 2.016-1.242 3.114-.957.158-.949 2.212-2.471 1.255l.006-1.856c1.104-.516 1.281-1.479 1.225-2.552.822-.627 1.643-1.252 2.461-1.879l.021 1.918z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E94450"
        d="M572.641 241.034c.604.24 1.021.652 1.223 1.277-1.393.589-2.057 2.272-3.709 2.473l.002.002c-1.176-2.419-.502-3.437 2.484-3.752z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FE2B49"
        d="M552.68 244.78c.836.015 1.229.471 1.275 1.275-.041.807-.463 1.226-1.273 1.245 0-.213-.002-.427-.004-.641.002-.625.002-1.252.002-1.879z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B12E4D"
        d="M577.766 251.027c-.057 1.24-.117 2.479-.178 3.718l-1.158 1.3-.055-1.303c-.334-.394-.445-.854-.408-1.358.602-2.099-.561-4.127-.254-6.218.109-.503.318-.944.771-1.233 1.393 1.456 1.038 3.35 1.282 5.094z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CD3A50"
        d="M576.485 245.933c-.039.46-.074.918-.113 1.377-2.838-.37-2.092-2.023-1.318-3.686l.146-.13 1.156 1.38.129 1.059z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9384A"
        d="M575.053 243.625c.453 1.225-.779 3.051 1.318 3.686-.27 2.086 1.607 4.154.049 6.25-1.088.096-1.51-1.794-2.848-.955-.422.073-.799-.011-1.107-.302.084-.397-.086.158-.174-.245-.084-.389-.223-.356-.104.008.814 2.529 1.879 5.036.467 7.699-.656 2.676-3.623 3.008-5.006 4.941-.482.088-.984.137-1.211.678-2.854.967-5.793.567-8.707.528-.078-.782-.57-1.118-1.295-1.204-1.801-.726.846-3.527-1.514-3.675-3.547-.223-5.396-2.478-7.158-5.032-.033-.408-.064-.818-.096-1.228-.203-.826-.404-1.653-.605-2.48 1.217-1.539.313-3.353.65-5.005.822-.419 1.646-.837 2.471-1.255-.996 1.987-1.273 4.085-1.299 6.306-.023 1.942.697 2.666 2.547 2.431.303-.334.682-.396 1.1-.323 1.041.55 2.029-.152 3.049-.137.822.144 1.246.603 1.164 1.459-.9 1.738.523.814 1.061.909.434.019.83.141 1.172.409.664.707-.164 1.578.258 2.371.758-.257 1.455-.627 2.186-.911 3.609-.064 7.594-3.827 8.889-6.99 1.035-2.531.029-4.535-.154-6.773 1.068-1.078 1.504-3.103 3.709-2.473.055.745.456 1.18 1.188 1.313z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B2468"
        d="M401.015 221.901c.539.505 1.205.406 1.854.396l.26.34c-.084 1.544-1.77 3.111.066 4.629.205.385.322.796.391 1.224.098 1.792.727 3.231 2.578 3.86.197 1.401-.607 2.247-1.635 2.972-2.555 1.48-4.533 3.393-4.869 6.529a2.872 2.872 0 01-.406.753c-1.271 1.876-4.033 2.655-4.023 5.474-.258 2.259-1.633 3.713-3.477 4.829-.32.383-.643.766-.963 1.147-.07 1.147-.701 1.616-1.814 1.502-1.195-.829-2.377-1.33-3.84-.451-.791.478-1.744.309-2.592-.135-1.949-1.219-4.24-.186-6.255-.945-1.063-.554-2.213-.909-3.291-1.426-.813-.967-.773-2.932-2.852-2.427-.783-.282-1.258-.854-1.555-1.604-.281-1.611-1.193-2.969-1.857-4.417-.592-1.29-.23-2.102.875-2.768 1.293-1.094.834-2.604.965-3.981.16-1.682-.488-3.455.547-5.042.402-.389.857-.422 1.352-.214 1.609 2.64.186 5.69 1.133 8.389.887-2.267.801-4.486-.127-6.685a2.527 2.527 0 01-.221-1.195c-.734-1.811-1.549-.717-2.35-.062-.699 1.459-.203 3.01-.352 4.512-.105 1.074.303 2.29-.865 3.07-.912.338-1.762.29-2.512-.398-1.216-3.692-.42-7.477-.515-11.216.05-.349.163-.683.325-.996 1.006-1.134 2.463-1.471 3.756-2.1.979-.364 2.68.422 2.594-1.635.248-.626.164-1.255-.002-1.886.027-.845.475-1.243 1.307-1.23 2.566.669 1.691-1.591 2.234-2.645.211-.615.6-1.057 1.211-1.29 5.316-.4 10.648-.936 15.785 1.119 2.283.913 4.688 1.693 5.678 4.331.217.576.625.782 1.156.26.722-.398 1.298-1.363 2.306-.588z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#221E53"
        d="M444.012 278.045c-.688 2.124.09 4.514.344 6.332.467 3.312-.816 5.432-2.061 7.902-1.846-.194-1.48-1.722-1.465-2.774.033-2.336-.381-4.041-3.223-4.165-1.557-.066-2.391-1.981-4.1-1.902a7.038 7.038 0 01-1.352-.103c-1.166-.331-2.363-.31-3.559-.295-.438.015-.879.007-1.318-.002-2.125.291-4.193-.821-6.336-.253-.299.056-.6.075-.9.063-2.51-.462-3.703-2.233-4.049-4.51-.322-2.115.779-4.03 2.873-4.061 3.486-.049 6.604-.793 9.496-2.685.328-.216.803-.153 1.221-.175 1.26-.15 2.379.338 3.518.748.334-.201.666-.402 1.002-.603 3.937-.027 8.958 3.259 9.909 6.483z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FBFDFB"
        d="M405.384 315.937c1.889.043 3.704.261 3.862-2.603.102-1.847 1.932-.889 3.006-1.141.082 2.054.229 4.109.066 6.166-.389 1.135-.816 2.152-1.951.547-.031-.082-.053-.188-.111-.268-.182-.26-.164-.229-.23-.139-1.78 2.414.203 5.221-.799 7.713-.24.906-.555 1.771-1.358 2.352-.441.213-.879.221-1.316-.012-.623-.602-.543-1.523-1.059-2.479-1.285 1.203-.029 4.586-3.262 3.705.168 1.742 2.615 1.859 2.455 3.723-.6 2.391-1.836 1.334-3.025.564-1.072-1.102-2.414-1.213-3.838-1.025-.789-.063-1.299-.525-1.688-1.166-.5-1.818-1.895-1.459-3.203-1.307-.443-.025-.805-.225-1.129-.508-.766-.834-1.738-1.357-2.748-1.824a7.735 7.735 0 01-1.449-.906c-.525-.5-1.072-.982-1.377-1.666.15-2.822 2.842-3.959 5.656-2.309 1.041.609 1.865 1.604 3.367 1.703-.352-.633-.99-.984-1.104-1.633.844-2.346 2.813-1.053 4.244-1.184 1.705-.158 3.896.861 5.07.109 1.375-.879-1.082-2.529-.666-4.268.41-1.715.09-3.605.758-5.598l1.829 3.454c-.342.356-.473.815-.611 1.271.189-.431.283-.907.611-1.271z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FCFCF9"
        d="M352.963 308.447c2.76.176 2.131 2.92 3.509 4.765.146-1.397.254-2.411.361-3.425.203 2.201 2.212 3.422 2.895 5.515.566 1.741 2.406-.289 3.022-1.421.534-.986.796-2.151 2.101-1.422 1.01.566.545 1.594.032 2.46-1.425 2.403.077 3.433 2.082 3.431 2.832-.004 3.506 1.465 3.469 3.818-.314.377-.732.502-1.203.508a2.79 2.79 0 01-.855-.227c-.607-.313-1.045-.896-1.898-1.225-.475 1.34.168 2.295.836 3.248.57.861 1.379 1.666.723 2.836-3.584 1.199-4.575 4.205-5.184 7.475-.094.031-.188.059-.28.094-.852.344-1.337-1.869-2.36-.336-.902-1.396-.534-2.967-.59-4.471-.045-1.238-.096-2.447-.922-3.463-.719-.908-.907-2.025-1.254-3.08-.789-3.941-2.33-7.58-4.383-11.02-.428-.699-.734-1.439-.779-2.27-.004-.683.109-1.323.678-1.79z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#221F4B"
        d="M418.381 295.974l.205-.64c.348-.4.697-.794 1.279-.834.693.072 1.072.644 1.592.994.652.418 1.422.456 2.139.664.875 0 1.902 1.048 2.545-.395-.535-1.608.75-1.61 1.672-1.848 1.191-.306 2.43.079 3.637-.167 1.082.021 2.211.18 2.873-1.003.371-.42.805-.745 1.35-.898.264-.052.531-.064.799-.048.795.158 1.57-.077 2.355-.149 2.229.113 2.127 1.476 1.535 2.995-.324.834-1.346 1.204-1.598 2.135a1.308 1.308 0 01-.299.719 3.393 3.393 0 01-.703.415c-1.93.685-3.826 1.414-4.932 3.326-2.029.841-3.924.458-5.873-.421-4.059-1.827-4.605-1.414-4.125 2.811a1.896 1.896 0 01-.914.311c-3.492-1.44-4.544-3.819-3.537-7.967z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F1D9BF"
        d="M434.836 293.086c-.412 2.349-1.914 1.45-3.238 1.087-4.309-.424-8.674-.563-12.701-2.456-1.057-2.483-.471-5.051-.361-7.592.65-.889-.748-.591-.664-1.151.713-1.037 1.91-.086 2.734-.67l.209.005c2.178.458 4.361 1.084 6.529-.034l.893.047c1.279.561 2.621.361 3.947.306.422.09.842.178 1.264.266 1.033 1.279 2.352 2.329 3.096 3.844.219.772.234 1.562.209 2.357-.029.631-.145 1.241-.529 1.765-1.201.58-1.377-.428-1.695-1.134-1.648-3.666-4.34-4.956-8.266-3.812-1.104.323-2.137.796-3.318.415-.795-.255-1.494-.16-1.623.83-.131.999.408 1.722 1.377 1.684 4.279-.169 7.396 3.705 11.73 3.324.415-.037.64.441.407.919z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F8DFB4"
        d="M375.43 323.43c2.279-1.219 4.556-.021 6.835.01.629.344 1.109.791 1.078 1.582-.389 1.787-1.879 1.623-3.176 1.742-1.68.154-3.396-.123-5.822.355 3.668.881 6.71-.145 9.57.887 1.139.852.711 1.977.564 3.074-.203 1.547-.242 3.07 1.156 4.182.922 1.713 3.646 1.955 3.623 4.438-.355.344-.791.457-1.273.443-1.107-.174-1.949-.859-2.814-1.494a26.569 26.569 0 01-1.684-1.605c-.418-.463-.994-.943-1.004-1.533-.049-3.977-2.705-3.914-5.55-3.76-1.971.107-3.953.049-5.504-1.5-.627-.611-1.205-1.258-1.523-2.092-.357-3.576-.115-3.895 3.256-4.102.809-.051 1.623-.01 2.268-.627z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9F9F6"
        d="M391.753 252.907l3.281-4.893c.518-2.54 2.691-3.856 4.18-5.68l-.021.024c.881-1.375.727-3.596 3.086-3.755.924 1.016 1.848 2.03 2.916 3.2-1.879.708-4.027 1.35-3.146 4.14.051.164-.029.498-.15.567-2.762 1.536-3.516 5.071-6.635 6.404-1.395.597-2.35.13-3.511-.007z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FBFAFA"
        d="M363.017 283.506c.393-.203.783-.408 1.175-.611.587 4.248-2.21 8.407-6.284 9.347-1.89.434-4.824 4.049-4.964 6.036-.054.769.341 1.662-.53 2.328-2.039-1.887-.488-4.476-1.342-6.557-.258-.873.332-1.363.893-1.795a117.21 117.21 0 009.376-8.022c.468-.446 1.178-.345 1.676-.726z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FAFAF5"
        d="M418.381 295.974c-.229 3.209.559 5.924 3.643 7.528.318.068.504.265.553.586-.418 2.52-3.061 3.038-4.311 4.809-1.629.792-1.477 3.511-3.814 3.539l-.34-.253c.854-2.231 1.543-4.479 1.287-6.934-.111-1.073.094-2.025 1.521-.956.516.386 1.004.03 1.246-.487.273-.575-.051-1.207-.523-1.263-3.094-.365-2.193-2.688-2.258-4.498-.064-1.8-.014-3.603.348-5.426 1.264.939.658 2.228.916 3.316.502 2.139 1.144.383 1.732.039z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2E275F"
        d="M363.017 283.506c-3.686 3.852-7.831 7.178-11.945 10.543l-.641.605c-.225.271-.51.369-.856.301-1.718-1.3-.941-2.832-.411-4.347.262-.554.557-1.095.839-1.641.274-.541.565-1.069.979-1.523 3.07-.62 5.043-3.519 8.198-3.968 1.278.011 2.558.022 3.837.03z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9F9F5"
        d="M420.985 208.577c1.813 1.193 2.041 2.212.947 4.483-1.299 2.7-1.889 5.635-4.426 7.68-.961.772-1.125.396-1.514-.297-.621-.537-.91-1.243-1.045-2.031 1.803-3.405 2.645-7.404 6.038-9.835z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7F3F4"
        d="M389.179 255.427l1.611-1.372c1.17.786 1.545 1.563.715 3.018-.854 1.493-3.961 4.467-5.35 5.527-1.188.907-1.896 2.503-3.244 3.408-.688.442-.516 1.465-1.256 1.874-.764 1.187-1.578.667-2.398.072l-.242-.345c.129-1.348 1.049-2.265 1.781-3.285 1.254-1.669 2.982-2.905 4.17-4.632.809-1.258 1.906-2.268 2.91-3.356.356-.417.713-.833 1.303-.909z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#262248"
        d="M420.606 282.304c-.74.929-1.828.424-2.736.67-.395-.252-.791-.505-1.188-.755-1.727-.467-.635-2.508-1.826-3.273l.055.054c-.295-.073-.422-.253-.361-.554.418-.927-.088-1.829-.074-2.747.99-2.473 2.77-3.804 5.471-3.393 1.873.284 3.387-.411 4.916-1.256.207.06.375.004.51-.163 1.295-.201 2.611-.597 3.76.443.201.313.191.618-.027.918-1.055-.156-1.742.421-2.387 1.146-1.486 1.67-3.73 1.85-5.5 1.6-2.068-.293-3.625-.133-4.385 1.705-.875 2.109.578 3.692 2.039 5.023.411.377 1.145.398 1.733.582z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F8F8F8"
        d="M414.93 278.471c-.012.176-.02.351-.02.528-1.441-.586-3.85.511-2.5-3.279 2.533-7.124 7.52-5.282 12.451-4.67-1.375 2.064-3.1 2.539-5.545 1.806-2.492-.747-3.42 1.515-4.557 3.138.165.817.097 1.652.171 2.477z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FBF8F6"
        d="M404.355 234.888c.553-.834 1.102-1.668 1.654-2.503.379-1.604 1.02-2.984 2.854-3.35.869.574.85 1.267.268 2.032-.137 1.019-2.093 2.749.994 2.507 1.244-.099 1.693.965 2.461 1.636-5.673 3.697-6.54 3.833-8.993 1.483-.461-.903.008-1.415.762-1.805z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#292140"
        d="M436.18 286.563c-1.201-1.008-2.896-1.646-2.732-3.671 2.979-.625 8.057 3.085 8.156 5.892.043 1.183-.488 2.521.691 3.495-.355 1.739-1.619 2.914-2.639 4.238-.266.406-.598.412-.975.166-.791-1.236.793-1.247 1.027-1.975.418-1.278 1.115-2.62-1.24-2.485-.578-1.04.051-1.975.297-2.927.297-1.159.164-2.023-1.172-2.314-.46-.174-.954-.235-1.413-.419z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#31264B"
        d="M419.1 291.554c4.139.999 8.506.918 12.498 2.619-1.303 1.251-2.865-.034-4.324.466-1.668.571-.068.83-.033 1.22-.373.648-1.008.683-1.648.71-1.549.137-2.973-.706-4.52-.586-.443-.422-.887-.845-1.328-1.269-.49-.032-.695-.776-1.301-.522-.176-.616-.35-1.234-.525-1.85.248-.482.617-.781 1.181-.788z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FAF9F5"
        d="M466.551 309.07c-.119 1.309.277 2.663-.309 3.942-4.303-1.725-4.697-1.47-4.717 2.993-.652.229-1.096-.131-1.52-.542-.658-.892-1.291-1.801-1.574-2.898a3.837 3.837 0 00-1.072-2.021c-.447-.516-.904-1.022-.953-1.75.059-.124.119-.248.182-.372.822.009 1.648.018 2.473.025 2.416 1.175 4.818 2.514 7.49.623z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#30295C"
        d="M420.985 208.577c-1.945 3.297-3.887 6.594-5.83 9.891-.098 1.382-.457 2.557-2.127 2.699-.926-.814-.938-1.676-.135-2.58 2.078-2.3 4.232-4.675 4.883-7.737.834-3.914 3.262-6.385 6.324-8.511-1.037 2.079-2.078 4.159-3.115 6.238z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FCFCF3"
        d="M382.925 324.654c-.221-.404-.439-.811-.66-1.215 2.189-.201 4.061-1.637 6.447-1.336 1.895.24 3.82.045 5.438 1.322l3.791 1.947c-2.51.875-4.422.898-6.027-1.021-1.209-1.445-2.842-.99-4.309-.793-1.289.176-.828 1.424-.932 2.281-1.711 1.067-2.685-.198-3.748-1.185z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F4F5F7"
        d="M444.012 278.045c-.35-2.779-3.264-2.86-4.889-4.05-1.295-.949-3.053-2.259-5.02-2.432 1.439-1.588 3.299-1.509 4.742-.46 1.857 1.35 3.645 2.742 5.672 3.878 2.019 1.132-.513 1.992-.505 3.064z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F4E0C4"
        d="M375.43 323.43c-.113 1.068-.861 1.379-1.736 1.223-3.256-.59-3.5 1.354-3.252 3.756-.885.434-1.398-.277-2.023-.648a1.57 1.57 0 01-.443-.607c.051-1.076-.939-1.611-1.291-2.477-.986-3.158-.986-3.158 1.904-2.537.201.002.402.01.604.027.664.746 1.861.443 2.486 1.264l3.751-.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7F3F4"
        d="M376.77 269.79c.635-.197.51-.751.572-1.216.377-.706.945-.986 1.732-.791l.184.169c1.244 2.422.111 3.812-2.105 4.584-1.27.44-1.84 1.59-2.791 2.343-.943.751-1.73 1.883-3.197 1.141.135-2.063 1.762-2.815 3.248-3.692l.486-.567c.105-1.15.996-1.554 1.871-1.971z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9F2D8"
        d="M438.682 296.684l.975-.166c-.518 1.129-.473 1.713 1.041 2.072 1.396.334 2.826.115 4.287.886 1.447.762 1.646 1.513 1.559 2.785-.328.349-.746.501-1.215.546a3.687 3.687 0 01-1.338-.192 26.386 26.386 0 00-3.375-1.258c-1.74-.762-3.201-1.687-2.23-3.971.097-.236.198-.469.296-.702z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5025BD"
        d="M412.893 218.587c.037.873-.164 1.779.35 2.588.834 1.324-.824 1.526-1.064 2.365-.855.854-1.52 1.829-1.887 2.992-.186.757-.461 1.435-1.357 1.582-.484-.111-.741-.445-.866-.901-.154-2.013 2.03-3.093 2.015-5.053 1.846-1.773.418-2.675-.957-3.591 1.26-1.417 2.52-2.277 3.766.018z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#302B56"
        d="M429.135 192.469c-.563-4.621 3.102-7.266 5.047-10.713.014-.027.439.178.674.275l-.756 2.214c-1.904 2.592-2.767 5.811-4.965 8.224z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FBFCF5"
        d="M424.104 208.525c-.418-.075-1.713.186-1.385-1.294.234-1.056.865-2.479 1.941-2.43.951.043 2.115 1.183 2.152 2.339.042 1.292-1.126 1.549-2.708 1.385z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2F2A5D"
        d="M404.355 234.888c-.252.601-.506 1.205-.762 1.806a3.38 3.38 0 00-1.314 1.91l-3.086 3.755c-.078-3.515 1.611-5.961 5.162-7.471z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FBFAFA"
        d="M351.718 304.695c-1.136.828.212 1.662-.006 2.494-2.65 1.012-1.742-1.923-2.885-2.582-.701-.714-1.632-.687-2.527-.814-.95-.138-1.151-.691-.65-1.509a1.85 1.85 0 01.699-.492c.613-.155 1.161-.06 1.615.411 1.281-.007 2.582-.124 3.736.623.559.618.502 1.242.018 1.869z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#28224C"
        d="M374.412 272.327c-1.084 1.229-2.166 2.462-3.248 3.692-.439.444-.877.89-1.316 1.337-.561.667-1.111 1.345-1.91 1.756-.648.18-1.057.602-1.256 1.236-.262.458-.514.939-1.184.781 1.805-4.115 4.873-6.949 8.914-8.802z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F8F8F8"
        d="M429.059 271.474c-1.158-.648-2.41-.695-3.688-.587 2.773-.115 4.789-3.177 8.16-2.355-.85 1.53-2.041.384-2.871 1.04l1.576 1.373c-.923.993-2.073.626-3.177.529z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5FBF8"
        d="M411.624 318.412c.195-2.074-.611-4.251.629-6.219.621-.004 1.24-.009 1.859-.011l.02.015c1.537 2.095-.949 3.69-.689 5.629a1.886 1.886 0 01-.52.779c-.473.208-.915.19-1.299-.193z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E9F9F8"
        d="M349.215 304.086c.679.342 1.261.733 1.046 1.655-.289 1.241.591 1.342 1.451 1.448.804.032 1.223.449 1.251 1.258-.015.655-.03 1.31-.043 1.964-.636.212-1.104-.128-1.574-.466-1.114-1.378-2.993-2.069-3.556-3.945.358-.725.747-1.427 1.425-1.914z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FAFAF3"
        d="M468.344 297.72c1.629 1.407 3.074 2.023 1.961 3.756-.486.753-1.283.978-1.873.51-1.535-1.227.201-2.414-.088-4.266z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F8F6EB"
        d="M419.1 291.554c-.393.264-.787.524-1.182.788.387-2.726-1.137-5.595.617-8.217 1.13 2.404-.236 4.999.565 7.429z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F4EBF9"
        d="M412.178 223.54c.355-.79.709-1.579 1.066-2.366.637-.9 1.273-1.803 1.91-2.706.891.399.828 1.202.838 1.974-1.603.624-1.019 3.945-3.814 3.098z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F8F4E9"
        d="M409.02 227.903l1.271-1.372c1.295 1.006 1.51 2.384 1.332 3.896-.59.306-1.293.275-1.867.628l-.625.013c-.025-.669.115-1.384-.531-1.878-.454-.623-.037-.961.42-1.287z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EEC383"
        d="M445.303 302.244c.414.004.828.011 1.24.017 1.482 1.184 3.158 1.981 4.979 2.488.51.3 1.033.59.699 1.33a1.84 1.84 0 01-.773.352c-1.35.053-2.322-.929-3.521-1.292-.625-.321-1.176-.749-1.752-1.147-.532-.463-1.157-.882-.872-1.748z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F8F8F8"
        d="M414.856 278.945c1.502.593 1.078 2.262 1.826 3.273-.809.316-1.447 1.512-2.453-.047-.795-1.234-.443-1.444.631-1.811.144-.047.004-.922-.004-1.415z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9F0CA"
        d="M452.262 305.91c-.246-.387-.492-.774-.74-1.161 1.766-.433 2.768.71 3.785 1.827.428.473.514 1.016.328 1.614a.775.775 0 01-.701.415c-1.18-.609-2.338-1.244-2.672-2.695z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9F9F6"
        d="M464.086 292.106c-.17 1.217.254 2.381-.715 3.393-.468-1.17-1.308-2.381.715-3.393z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#272241"
        d="M429.059 271.474c.941-.88 2.051-.758 3.178-.529.287.409.576.815.865 1.222-1.334.028-2.666.056-3.998.082-.016-.258-.031-.517-.045-.775z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FDFCE7"
        d="M413.063 310.799c-.176-1.468-.473-2.433.471-3.5.883 1.245.484 2.133-.471 3.5z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F1F2F2"
        d="M365.498 281.13l1.184-.781c.254.717 1.117 1.515.197 2.158-.648.454-.846-.685-1.395-.877.008-.167.014-.333.014-.5z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FBFAFA"
        d="M349.871 294.842c.177-.092.363-.153.561-.188.017 1.405-.307 2.701-1.211 3.812-.104-.088-.206-.178-.311-.263-.359-.602-.584-1.241-.521-1.955.226-.751.871-1.06 1.482-1.406z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6FADC"
        d="M381.656 267.882c.012-.896-.031-1.832 1.256-1.874-.327.686.853 2.383-1.256 1.874z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FBFAFA"
        d="M349.22 298.466c-.127.976.414 2.285-1.248 2.492-.402-.336-.556-.783-.59-1.285.008-.503.147-.961.487-1.344.469-.242.918-.239 1.335.122l.016.015z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5F6EC"
        d="M347.959 299.7l.013 1.258c-.004.415-.006.83-.008 1.245l-1.861.007c-.295-1.515.101-2.517 1.856-2.51z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FEFBE9"
        d="M351.718 304.695c-.004-.622-.011-1.247-.018-1.869.373-.407.852-.666 1.094.008.342.945.146 1.739-1.076 1.861z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FAF9F5"
        d="M459.809 306.158c.586.907.719 1.601-.182 2.142-.16.097-.377.101-.566.147.131-.718-.316-1.583.748-2.289z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FEF1DC"
        d="M371.678 323.43c-1.074.063-2.023-.121-2.486-1.264l1.242.002c.798.043 1.234.443 1.244 1.262z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1F162F"
        d="M418.444 294.191c.152-.361.346-1.046.449-1.033.918.12.316 1.153.852 1.556-.232.494-.666.611-1.158.62l-.143-1.143z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7F7F7"
        d="M445.954 239.169c-1.52-.276-1.395-1.027-.549-2.192.795.69.455 1.503.549 2.19v.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F1F2F2"
        d="M367.938 279.112c.639-.586 1.273-1.172 1.91-1.756.078 1.361-.594 1.906-1.91 1.756zM369.484 281.096c-.289.444-.588.374-.818.175-.217-.186-.455-.444-.5-.703-.068-.386.246-.499.529-.287.307.229.543.553.789.815z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FAF9F5"
        d="M455.446 308.296l-.139-1.72c.832.333 1.24.962 1.281 1.848 0-.002-.021.02-.021.02-.43.371-.803.312-1.121-.148z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FBF8F6"
        d="M409.756 231.055c.355-1.005 1.012-1.117 1.867-.628-.353 1.009-1.009 1.12-1.867.628z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#221D54"
        d="M499.018 382.672c-.854 1.113-2.078.508-3.135.676-10.303-1.77-20.787-1.035-31.133-2.602h10.098c1.398.055 2.801.107 4.199.16 2.131.682 4.375-.139 6.51.488l2.863.168c1.453.596 3.047-.143 4.5.467.576.041 1.148.08 1.725.119 1.268.635 2.703-.063 3.982.496.143-.142.272-.13.391.028z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7AB38"
        d="M462.899 345.928c-1.213 1.299-2.992 1.971-3.932 3.57-.313.457-.756.66-1.297.678-.523-.014-.979-.184-1.305-.613-.338-1.131.225-2.363-.848-3.486-1.119-1.172.002-1.908 1.129-2.07 1.949-.283 3.928-.434 5.865.209.305.17.504.422.605.758a1.44 1.44 0 01-.217.954z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5F5F2"
        d="M539 386.902c-1.625.799-2.508-1.609-4.236-1.234-.535.119-.742-.6-.729-1.154.018-.584.34-.895.887-1.105 1.615-.625 5.363.648 6.295 2.188.197.328.598.861.502.984-.713.915-1.674.405-2.719.321z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F4F8F3"
        d="M469.047 322.18c.33-1.666-.811-2.59-1.727-3.703-.711-.869-.934-2.037-.545-3.169.197-.579.836-.685 1.297-.502 1.189.468 2.07 1.258 2.213 2.659.121 1.186.057 2.32.566 3.555.758 1.83-1.127.83-1.807 1.156l.003.004z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7F5ED"
        d="M467.883 328.342c.684-.537.996-1.301 1.121-2.109.141-.906.389-1.656 1.492-1.461 1.332.236 1.055 1.348 1.002 2.205-.09 1.395-1.678 2.355-1.211 3.945-.318.342-.713.408-1.152.314-.693-.271-1.182-.77-1.561-1.393a1.472 1.472 0 01-.014-1.23l.323-.271z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FDF1D6"
        d="M469.071 330.902l1.217.02c1.938 3.566.836 7.711-2.631 9.906-.293-.43-.314-.9-.205-1.391 1.902-2.583.873-5.73 1.619-8.535z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7F5ED"
        d="M465.374 322.777c1.135-.754 2.418-.592 3.674-.598l-.002-.004c-1.439 1.857-1.375 4-1.162 6.166l-.111.094c-1.895-.17-2.115-1.895-2.889-3.111-.193-.602-.248-1.211-.078-1.83.114-.297.304-.535.568-.717z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E4B756"
        d="M451.526 356.418c-2.469 1.475-.348 3.893-1.17 5.707-1.568.682-1.67-.416-1.641-1.447.041-1.27-.254-2.361-1.176-3.256-.592-.832-1.596-1.496-1.146-2.76.32-.348.727-.453 1.18-.416 1.414.967 2.824-.168 4.24-.023.271.1.469.279.604.533-.297.553-.592 1.107-.891 1.662z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6F7F1"
        d="M461.522 355.816c-.17-.063-.447-.162-.729-.264.828-1.396.516-2.867.293-4.334.98-.143 1.701-1.574 2.615-1.02.762.461.26 1.455-.41 2.082-.691.646-.428 1.535-.51 2.328-.073.71-.382 1.15-1.259 1.208z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EAB64C"
        d="M467.813 339.68c-.053.383-.105.766-.156 1.15-.35.494-.695.99-1.043 1.488-1.152 1.137-1.662 3.084-3.779 3.014l-.088-.709c.227-2.244 3.205-5.908 5.131-6.309.259.469.275.928-.065 1.366z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EBB354"
        d="M452.417 354.756l-.787-.131c-.51-2.494 1.709-4.758 4.924-5.027.428.018.854.031 1.281.049.324.742-.273.914-.73 1.17-.215.191-.428.379-.645.566-.779 1.561-2.533 2.041-3.613 3.268a1.68 1.68 0 01-.43.105z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FAEDCB"
        d="M465.374 322.777l-.154.779c-.441.281-.877.234-1.309-.025-.799-1.164-1.309-2.447-1.611-3.824-.01-.486.133-.918.48-1.273 2.867.252 2.383 2.504 2.594 4.343z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5E6C3"
        d="M452.846 354.65c.258-2.137 2.311-2.287 3.615-3.268.092 2.526-1.41 3.288-3.615 3.268z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9ECCB"
        d="M462.834 345.332c1.541-.654 2.109-2.527 3.779-3.018-.043 2.436-1.26 3.664-3.715 3.613a4.51 4.51 0 01-.064-.595z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E7BE75"
        d="M462.78 318.434c.008.414.014.832.023 1.246a1.005 1.005 0 01-.725.354 1.454 1.454 0 01-.746-.342c-.51-.82-.914-1.701-1.393-2.541a2.299 2.299 0 01-.086-1.267c.1-.278.27-.503.51-.674.387.265.777.53 1.164.796.071.988.575 1.752 1.253 2.428z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#27225E"
        d="M485.557 381.395c-2.174-.121-4.416.674-6.51-.488 2.19-.091 4.377-.165 6.51.488z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E6FDF5"
        d="M452.174 369.287c-.52-.076-.547-.498-.545-.9.004-.4.016-.893.568-.889.547.002.568.488.568.891.001.4-.005.838-.591.898z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#27225E"
        d="M492.92 382.029c-1.508-.072-3.092.555-4.5-.467 1.528-.111 3.045-.123 4.5.467z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B2855"
        d="M498.627 382.645c-1.344-.053-2.766.549-3.982-.496 1.357-.077 2.709-.11 3.982.496z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5E6C3"
        d="M457.104 350.816c.244-.389.486-.781.73-1.17.377-.049.756-.098 1.133-.145.098 1.452-.865 1.409-1.863 1.315z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#292063"
        d="M452.819 423.287c-.832 0-1.664 0-2.496-.002.506-2.055 2.188-1.209 3.352-1.211 30.039-.047 60.078-.037 90.119-.037h31.143c-.484 1.443-1.039 2.273-2.285 2.498-1.293-.982-2.807-.611-4.227-.611-37.021-.021-74.041-.01-111.063-.033-1.524-.002-3.137.404-4.543-.604z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FB3847"
        d="M553.915 194.851c.029-.396.057-.793.088-1.188 2.309-.889 4.039 1.168 6.162 1.202.379.446.359.914.078 1.397-1.342.799-2.842 1.19-4.309 1.672-2.225-.011-3.17-.864-2.019-3.083z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EC3C4F"
        d="M560.167 196.104c0-.414 0-.826-.002-1.24l2.34.017 2.613 2.562c.012.219.027.438.043.657.502.733.301 1.525.191 2.308-1.041.543-1.637-.209-1.869-.927-.561-1.726-2.037-2.429-3.316-3.377z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E64150"
        d="M553.915 194.851c-.25 1.925.564 2.78 2.512 2.5.391-.359.85-.308 1.314-.217.551.403.906.879.594 1.603a2.137 2.137 0 01-.818.458c-.752.193-1.525.187-2.293.205-.568.019-1.141.009-1.707.069-1.924.076-.93 2.285-2.115 2.897-1.279-.158-1.215-1.123-1.213-2.038 0-.868-.125-1.632-1.223-1.705 1.064-2.027 2.249-3.894 4.949-3.772z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F13D47"
        d="M557.69 197.365l-1.264-.015c.98-1.213 2.338-1.303 3.74-1.247 2.018-.145 3.33.713 3.75 2.727.162.769.535 1.305 1.223 1.647.961 1.447.637 2.889-.014 4.332-1.367 2.792-4.709 3.606-6.248 6.226-1.887.543-3.076-1.719-4.949-1.229-.014-1.591-.029-3.182-.045-4.772.09-.107.18-.215.268-.324 1.926.854 3.732.204 5.539-.444.439-.42 2.088 1.08 1.506-1.01-.303-1.095.863-2.02.629-3.171-.018-1.381-.76-1.99-2.094-1.97-.754-.057-1.422-.332-2.041-.75z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DD4C5B"
        d="M551.401 202.364c.469-1.352-1.201-3.931 2.1-3.656-.82 2.12.127 4.112.443 6.15l-.061.174c-1.775-.007-2.789-.723-2.482-2.668z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#753BDB"
        d="M536.471 233.554c.197 2.692-.902 3.34-3.307 2.186-2.027-.976-4.113-1.831-6.17-2.738-.055-.728-.01-1.44.318-2.109.541-.861 1.176-.609 1.828-.157 1.234.878 2.086 2.161 3.26 3.107.41.249.834.4 1.311.193-.305-.16-.66-.082-.979-.209-1.049-1.763-2.709-3.201-2.854-5.438.193-.583.451-1.113 1.053-1.383.506 1.193.619 3.134 2.633 1.257.785-.73 1.502-.029 2.203.333 1.176.878-.109 2.241.631 3.206a.542.542 0 00.047.5c.378.408.378.825.026 1.252z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FAFBEF"
        d="M531.459 221.688c-2.066-1.885-2.404-5.692-6.238-5.616-.039-2.229.469-3.406 2.807-1.615 2.715 2.08 5.199 4.299 5.93 7.863l.002-.002-1.254.006c-.416.364-.83.361-1.24-.012l-.007-.624z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F8F7E6"
        d="M536.465 228.564l.518-.325c.914-.571.59-2.731 2.496-1.998.889.345.9 1.305.438 1.787-.955.997-.721 3.862-3.406 2.387-.518-.604-.485-1.223-.046-1.851z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FBFBE4"
        d="M537.782 217.24c-.254.881.357 2.221-1.111 2.466-1.365.226-1.771-.94-2.518-1.77 1.24-1.03 2.52-.392 3.639-.688l-.01-.008z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6859A1"
        d="M530.932 227.004c-.098.556-.078 1.167-.68 1.493-.404-.282-.588-.694-.693-1.154-.135-.734-.109-1.474-.117-2.212.053-1.01-.234-1.833-1.248-2.259a2.096 2.096 0 01-.625-.53c-.166-.717.375-.954.842-1.241.887-.218 1.629.108 2.318.627l.203 5.276z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FBFAE6"
        d="M533.958 222.32c1.51.034 1.035 1.504 1.605 2.219.365.457.992.992.049 1.368-.705.282-1.467.062-1.57-.872-.104-.897-.061-1.811-.082-2.718l-.002.003z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6E46B8"
        d="M537.106 224.065c-1.324-.75-1.156-1.877-.512-2.872.697-1.072 1.801-1.245 2.969-.647.93 1.357-.916 1.149-1.064 1.903-.189.32-.359.65-.508.99-.18.369-.512.526-.885.626z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#774FC6"
        d="M538.323 222.212c-1.146-1.714 1.859-.343 1.24-1.666 1.471.737 1.645 1.776.721 3.073-.492-.056-.98.323-1.477.017-.404-.392-.488-.893-.484-1.424z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#644698"
        d="M538.922 223.501c.461-.053.961-.558 1.359.118-.896 1.296-1.951 1.459-3.176.446l.609-.523c.392-.368.796-.347 1.208-.041z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FAEFE8"
        d="M531.465 222.313l1.24.012c-.053.755.189 1.596-.516 2.229-1.099-.591-.579-1.512-.724-2.241z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F3E7E8"
        d="M536.471 233.554c-.01-.418-.018-.837-.025-1.255.9.005 1.828-.03 1.873 1.254l-1.848.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F2E3F6"
        d="M536.465 228.564l.045 1.851-.111 1.383c-.65-.98-.438-2.134-.631-3.206.232-.008.463-.019.697-.028z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DE4172"
        d="M565.125 204.809l.014-4.332c.006-.793.012-1.586.021-2.379l.605.482c.188 1.634.375 3.27.564 4.904l-1.139 2.059c-.02-.244-.041-.489-.065-.734z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3BA5ED"
        d="M552.536 275.174c-2.158 3.017-4.734 4.688-8.291 4.535-.502-.021-1.303.488-1.506-.293-.166-.646-.246-1.688.541-1.93 2.918-.893 5.279-3.807 9.256-2.312z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F53C44"
        d="M572.655 259.766c.59-3.165-1.473-6.226-.627-9.663.926.784.496 1.529.629 2.167.406.595.82.616 1.238.013 1.289-.458 2.229-.227 2.525 1.277-.014.396-.029.789-.045 1.183-1.652.77-1.73 2.559-2.451 3.913-.322.607-.58 1.036-1.269 1.11z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#438FBE"
        d="M598.868 204.832l-.15-5.057c1.299-.444.846.969 1.398 1.317.447 1.257.053 2.513-.012 3.77l-.813.106a8 8 0 01-.423-.136z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6097BA"
        d="M600.116 201.092l-1.398-1.317c.098-.341.195-.681.291-1.022 1.846-.6 3.443-.124 4.861 1.121-1.25.413-3.104-1.045-3.754 1.218z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2295E7"
        d="M602.59 201.152c.393.043.891.021.887.574-.002.546-.49.56-.891.563-.402.004-.891-.017-.889-.565.005-.541.487-.544.893-.572z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FCFCFC"
        d="M588.282 216.593l-1.879-3.089c-.621-1.713.658-3.102.795-4.687.324-.766 1.17-.906 1.701-1.424l1.219-.066 1.264.014v3.732c.449 1.396 2.189 2.702.246 4.278-.223.181-.053.791-.166 1.172-.342 1.167 2.605-.065 1.197 1.471-.939 1.023-2.23-.119-3.291-.634-.362-.257-.725-.511-1.086-.767z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EEF7F7"
        d="M585.077 211.88a3.31 3.31 0 01-.545-.122c-1.109-1.593-2.295-3.139-3.309-4.789-2.77-4.508-2.512-5.53 1.922-8.418.672-.354 1.342-.522 1.99.051 0 .415 0 .831.004 1.246.346.332.416.741.33 1.193-.121.416-.313.803-.492 1.194-1.096 2.311.727 4.076 1.148 6.105-.111 1.252.024 2.576-1.048 3.54z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4190BB"
        d="M584.526 201.723l.607-.685c1.684-.932 3.365-1.753 4.957.157.023.176.043.353.057.529.262 1.257.559 2.514.014 3.774-.211 1.155-1.439 1.084-2.078 1.726a1.072 1.072 0 01-.91.3c-3.108-1.492-3.296-1.904-2.647-5.801z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E4F6F9"
        d="M590.09 201.195c-1.615-1.195-3.283-.74-4.957-.157.002-.396.002-.793.006-1.19 1.619.567 3.922-1.388 4.951 1.347zM585.135 198.603l-1.99-.051c.549-.599 1.061-1.258 1.99-1.252-.429.434 2.076.867 0 1.303z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#588B9E"
        d="M590.161 205.499c-.004-1.258-.008-2.517-.014-3.774.162.001.32.019.479.054.085 1.269.74 2.611-.465 3.72z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EEF7F7"
        d="M587.784 207.264c.094-.08.191-.093.299-.038l.816.167c-.061.787-.486 1.182-1.271 1.194-1.332.534-1.646-.05-1.389-1.263.502-.357 1.019-.326 1.545-.06z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5C73E1"
        d="M582.112 212.303c-.098-1.542-1.916-2.134-2.023-3.668 1.965.458 2.699 1.763 2.535 3.686-.172-.005-.344-.009-.512-.018z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7432E6"
        d="M586.354 319.693c.861.604 1.172 1.49 1.277 2.482-1.654-.195-1.132-1.509-1.277-2.482z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3E57D1"
        d="M532.772 159.882l1.818.054c-.213.404-.424.808-.635 1.211-.822-.022-1.246-.418-1.183-1.265z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#27225E"
        d="M452.819 423.287c38.727 0 77.451-.01 116.174.043 1.24.002 3.041-.971 3.658 1.205-38.723 0-77.447.008-116.172-.045-1.238-.004-3.037.969-3.66-1.203z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F1A311"
        d="M447.717 357.016c1.787.475 2.137 1.813 1.84 3.359-.172.883-.527 1.641.799 1.75l-.002 1.254c-.424.408-.846.055-1.266-.002-.424-.006-.846-.01-1.27-.014-.609-.857-1.869-.402-2.494-1.23l-2.291.029a81.88 81.88 0 00-.328-.281c.053-.848.611-1.252 1.322-1.525.76-.232 1.639-.262 1.982-1.191.499-.774.456-1.979 1.708-2.149z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E4B756"
        d="M449.088 363.377c.424-.682.844-.07 1.266.002-.018 1.051-.031 2.104-.049 3.156-.857-.416-1.182.447-1.748.732-.236-.049-.475-.102-.711-.152.012-.387.021-.773.033-1.164.352-.486.717-.963 1.18-1.35.012-.408.02-.816.029-1.224z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4712A3"
        d="M373.387 463.443h19.072c.006.207.008.414.012.621h-19.089l.005-.621z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5114C9"
        d="M350.507 456.928c2.278-.891 4.549-.945 6.812.043l-6.812-.043z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#37188A"
        d="M412.807 458.172c-1.041.008-1.564.967-2.42 1.314.008-.82.014-1.641.02-2.461.826.557 1.617-.016 2.426-.066-.01.404-.018.809-.026 1.213z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2C245D"
        d="M387.972 390.256c1.432-.457 2.865-.91 4.299-1.365a.908.908 0 01.91.348c.504 1.025.596 1.994-.371 2.826-.875.117-2.729-1.324-2.314.93.727 3.939-.57 7.783-.125 11.686.15 1.291-.1 2.627.627 3.18-1.83 1.154-.363 2.758-.676 3.871-1.506-.752-1.762-2.051-1.811-3.607-.174-5.352-.461-10.697-.705-16.045-.416-.652-.416-1.264.166-1.824z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C3B1EC"
        d="M387.906 422.049c-3.486-2.832-8.568-4.268-8.754-9.99a26.447 26.447 0 007.826 7.23c1.053.639.943 1.729.928 2.76z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C3B0EA"
        d="M378.593 404.535c-.433-3.313.656-6.721-.638-9.977-.398-.398-.4-.811-.033-1.23 1.466-1.164 3.203-1.291 4.97-1.283-.09.496-.072 1.367-.283 1.43-3.918 1.119-3.205 4.373-3.451 7.213-.114 1.289.494 2.697-.565 3.847z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C1BBE3"
        d="M387.972 390.256c-.057.607-.109 1.215-.166 1.822-1.641-.008-3.279-.018-4.92-.025 1.553-1.004 3.309-1.424 5.086-1.797z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7A3703"
        d="M392.81 392.064c.016-.998.029-1.998.043-2.996.164-.059.33-.113.492-.17.877.547.9 1.457 1.012 2.336.025.373.031.74.035 1.113.008 4.34.02 8.68 0 13.018-.008 1.23.129 2.5-.725 3.563l-.307.637c-1.002-4.053-.23-8.168-.453-12.248-.095-1.749-.068-3.501-.097-5.253z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FC9F03"
        d="M409.149 402.092l.072 4.994-.135 1.197c-2.597.561-5.208 1.471-7.724-.232-.283-.189-.336-.174-.682-.072-3.049.91-3.488.619-3.609-2.451-.125-3.111-.033-6.223-.045-9.334-.006-1.482-.074-2.928-1.564-3.801-.607-.666-.76-1.441-.557-2.297.102-.314.283-.578.535-.787.943-.527 2.043-.729 2.965-.303 1.65.76.266-1.127 1.02-1.049.754-.42 1.582-.443 2.412-.475 1.688.264 3.111-.807 4.695-.941 1.266-.105 2.649-.455 3.767.592.002.389.004.777.004 1.168-.672.137-1.137.463-1.141 1.223-.003 4.189-.009 8.376-.013 12.568z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FA9D0D"
        d="M395.39 392.074c1.826-.217 2.607.471 2.539 2.426-.127 3.615-.082 7.238-.004 10.855.021 1.008-.631 2.584 1.043 2.801 1.869.244 1.223-1.447 1.477-2.424.068-.27.238-.514.621-1.309.768 5.504 3.938 4.227 7.07 3.199.221-.072.632.426.95.66-.16.35-.311 1-.48 1.004-4.841.156-9.7.902-14.505-.363-.445-.986-.242-2.006-.164-3.018.877-.83 1.1-1.701.932-3.008-.443-3.479-.711-7.004.17-10.482l.351-.341z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DF9E66"
        d="M394.281 405.811l-.18 3.113c-.145.004-.289.004-.434.004l-.025-17.438c.758.002.936.547 1.064 1.137.225 3.719-.139 7.447.207 11.164.071.756-.179 1.422-.632 2.02z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FCFDFD"
        d="M367.975 327.152c.197.004.393.012.59.02.609 1.361 1.93 1.844 3.104 2.506 2.523 2.084 5.516 1.17 8.316 1.184 1.994.01 3.307.336 2.857 2.668-.299 1.545 1.07 2.348 1.398 3.594-.34 1.115.018 1.566 1.184 1.244 1.086-.049 1.623.916 2.455 1.336.592.578 1.58.82 1.602 1.881-.24 1.098-.268 2.066 1.188 2.313.918.154 1.842.344 2.232 1.373-1.52 1.773-3.588 2.834-5.656 3.602-3.307 1.23-5.777 4.016-9.33 4.742-.41.082-.637 1.059-.959 1.643-.508-.545-.105-1.502-.902-1.873-.76-2.881.787-5.375 1.336-8.039.676-1.113.953-2.35 1.085-3.631.311-1.525.984-2.936 1.363-4.451.422-1.678-.098-2.229-1.74-2.381-2.729-.246-5.352.631-8.037.59-2.258-.039-4.563.451-6.767-.461-.115-.119-.231-.244-.347-.367.604-1.543-1.606-3.266.172-4.648 1.475-1.149 2.43-3.294 4.856-2.845z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E6DFF6"
        d="M371.682 396.449c-3.676 2.35-8.035 3.172-11.84 5.309-1.43.805-2.041 1.42-1.902 2.943.072.822.188 1.703-.025 2.473-.441 1.59 1.269 4.6-1.281 4.543-2.313-.053-.914-3.041-1.117-4.693-.252-2.039-.06-4.131-.06-6.203 5.053-1.488 9.81-3.863 14.984-4.994.682-.335 1 .068 1.241.622z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E6E0F6"
        d="M371.682 396.449l-1.242-.623c2.494-.834 4.988-1.666 7.482-2.498l.033 1.23c-1.729.285-1.254 1.656-1.264 2.705-.041 4.15 0 8.301-.029 12.449-.01.975.281 2.32-1.363 2.217-1.377-.088-1.1-1.289-1.105-2.164-.029-3.84-.15-7.686.035-11.516.111-2.302-.877-2.36-2.547-1.8z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E0ECF1"
        d="M372.922 365.23c-7.895.42-15.79.842-23.683 1.26-.079-1.066.095-2.01 1.213-2.496 6.019-.1 12.015-.684 18.027-.789 1.596-.027 2.57-1.283 4.031-1.336.143.084.285.17.426.256l-.014 3.105z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E3EDF2"
        d="M377.934 345.275c-.629 2.703-1.254 5.406-1.881 8.107-1.223 2.176-.975 4.727-1.775 7.018-.275.781-.225 1.66-1.342 1.725l-.004-.004c-1.102-1.266-1.064-2.873-.443-4.104 1.846-3.666 1.805-7.797 3.158-11.563.242-.676.404-1.436 1.078-1.822.66-.378 1.171-.259 1.209.643z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F1F7F3"
        d="M392.853 389.068a5.51 5.51 0 00-.582-.178c.176-.787.4-1.57.518-2.369.293-1.992 1.102-2.588 2.785-1.131.688.598 1.547.4 2.348.461.393.486 1.59.162 1.328 1.311-.676.803-1.635 1.15-2.543 1.574-.402.154-.828.188-1.252.215-.82.24-1.627-.242-2.447-.047l-.155.164zM405.38 384.594l-.723 1.125c-1.807 1.465-3.65 1.281-5.516.123.018-1.195-1.955-1.869-.941-3.266.541-.75 1.506-.48 2.309-.424.256.018.627.201.725.412.822 1.756.807 1.752 2.943 1.805.403.008.803.145 1.203.225z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FBFBF3"
        d="M392.9 345.27c-.82-.451-1.703-.568-2.637-.654-2.455-.225-2.85-1.307-1.105-3.094.26-.539.639-.9 1.287-.861.953.232 1.793.695 2.551 1.309.557.613 1.109 1.23 1.162 2.119l-1.258 1.181z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9F2ED"
        d="M402.912 349.619c-3.023-.91-5.777-2.35-8.285-4.256-.094-.07.133-.564.209-.859.471-.422 1.02-.402 1.586-.283.266.084.512.211.74.365 1.117.996 2.34 1.785 3.879 1.957.281.061.549.156.813.273.67.352 1.266.771 1.459 1.568.054.471-.083.882-.401 1.235z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5F4F4"
        d="M407.91 384.537l-2.525.053c.051-1.506-1.625-.949-2.158-1.777 3.28-1.493 4.593-1.006 4.683 1.724z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9E6D3"
        d="M399.142 385.842c1.838-.041 3.678-.08 5.516-.123.066.082.133.168.199.254-.563 1.641-2.016 1.555-3.34 1.719-.834-.037-1.725.148-2.381-.594l-1.215-1.246c.407-.004.815-.008 1.221-.01z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7EFCC"
        d="M402.912 349.619c.004-.438.006-.873.012-1.311 1.27-1.041 2.705-.773 4.141-.516.35.131.633.35.854.648l-.047 1.184-.002.002c-1.453.967-2.902.775-4.357.01a23.84 23.84 0 01-.601-.017z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E29152"
        d="M396.587 344.703l-1.752-.199c-.115-.318-.299-.527-.678-.416-.703-.432-1.377-.885-1.32-1.857l.359-.381c2.239-.368 3.854.009 3.391 2.853z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9F2ED"
        d="M393.292 350.785c-.49-1.268-.572-2.229-.049-3.197 2.132 1.314 2.132 1.314.049 3.197z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F2F5EE"
        d="M403.511 349.637l4.357-.01c-.716 1.861-2.181 1.863-4.357.01z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F2CB96"
        d="M416.624 347.15c-.201.943-.383 1.895-1.154 2.586l-.219-.746c.041-1.719.1-3.434.125-5.15.014-.855-.094-1.66-1.242-1.666-.494.377-.965.336-1.42-.072-.357-1.459.58-1.91 1.713-2.219 2.714 1.215 3.445 3.638 2.197 7.267z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EDF5CF"
        d="M412.977 342.189c.385-.006.771-.012 1.156-.016.424 2.857-2.398 2.537-3.668 3.742a1.047 1.047 0 01-.443-.664 1.93 1.93 0 01.15-.811c.764-.961 1.43-2.049 2.805-2.251z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FACDB0"
        d="M410.383 345.264l.082.652c-.465 1.227-1.309 2.076-2.548 2.525-.238-.029-.475-.057-.713-.088.184-1.929 1.131-3.076 3.179-3.089z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F1A117"
        d="M401.644 387.066l3.213-1.094c1.363-.072 2.73-.145 4.097-.221.787.129 1.438.393 1.348 1.381-3.083-.955-5.675 1.719-8.698 1.174-.337-.425-.331-.837.04-1.24z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F1DFF9"
        d="M352.429 427.623c.603-.225.32-1.402 1.107-1.256 8.053 1.514 16.174.236 24.252.664 3.843.203 7.685.496 11.533.557 1.236.018 3.029.969 3.6-1.229.838.574 1.984.746 2.422 1.848-13.689.023-27.378.055-41.066.059-.652 0-1.502.334-1.848-.643z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FE9F01"
        d="M421.612 310.944c-.805-.632-1.141-1.495-1.246-2.478-.014-.898.445-1.463 1.258-1.777 1.666-.441 2.797.254 3.6 1.684.459.816.943 1.625 1.955 1.865.268.099.521.227.766.368 1.213 1.057 2.439.898 3.674.034a1.92 1.92 0 011.248.013c1.887 1.307 2.652-.726 3.902-1.315 3.746-.623 4.238-.231 3.621 3.47-.447 2.672 1.951 3.692 2.869 5.558.49 1.559.352 3.277 1.203 4.746.447 1.279.814 2.584 1.295 3.855.111.295.188.596.242.908.195 1.426.15 2.859.164 4.291-.023 1.111.033 2.229-.248 3.318-.43 1.545-1.764 2.443-2.629 3.678-.99 1.074-1.879 2.242-2.926 3.266-.377.229-.791.355-1.225.432-1.664-.199-1.863 1.543-2.887 2.189-1.52.488-2.486 1.527-2.996 3.023-.328.527-.822.799-1.408.941-2.996-.305-4.689 2.004-6.838 3.414a3.53 3.53 0 01-.891.338c-1.318.203-2.631.348-3.752-.631h-.002c-.936-2.078-.939-4.156 0-6.234.549-1.166-1.166-3.352.258-3.379 1.789-.037.709 2.285.975 3.557.207 1.002-.367 2.627 1.699 1.795.268-.107 1.129-.07.688-.557-3.27-3.596 1.455-3.018 2.299-4.498-.654-1.443-2.896.146-3.256-1.547-.273-1.295-.049-2.684-.18-4.018-.201-2.041 1.072-4.65-2.133-5.654-.297-.094-.281-1.318-.34-2.023-.389-4.648.547-9.059 2.211-13.396.455-1.187.205-2.647.279-3.984.018-.417-.148-.794-.297-1.164-.146-.365-.09-.806-.404-1.107-.015.427-.208.763-.548 1.019z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6820A"
        d="M415.368 318.416c0 4.998.002 9.994.004 14.99 1.195 1.453.758 2.91.004 4.367l.014.635c.27.762-.15 1.174-.756 1.486a21.89 21.89 0 00-.891.156c-1.404-.221-1.777-1.402-1.262-2.289 1.545-2.662-.553-4.98-.479-7.494.023-.842-2.121.031-2.211-1.502a5.238 5.238 0 01-.168-1.311c-.004-.727.029-1.449.195-2.154.072-.266.184-.516.322-.752.52-.594.814-1.309 1.035-2.063.102-.244.23-.467.385-.68.539-.59.652-1.414 1.1-2.059a.794.794 0 01.699-.184c-.432-.061.502-.119.248.191-.203.248.211.338.186.16-.181-1.292.036-2.054 1.575-1.497z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F48902"
        d="M431.6 348.393c.512-.012.977-.123 1.246-.625 1.012-.984 1.854-2.166 3.211-2.75 1.1-.338 1.695-1.789 3.119-1.42 1.033.221 2.141.211 3.039.898.391 1.004-.252 1.518-.98 1.932-2.352 1.328-4.258 3.494-7.139 3.832-3.721 1.332-7.143 3.551-11.242 3.748-.402-1.654 1.246-1.254 1.879-1.873 2.266-1.291 4.475-2.686 6.867-3.742z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FC9C0B"
        d="M434.096 350.26c2.363-2.359 5.943-2.963 8.111-5.604.76-1.268 1.389-2.707 3.275-2.488.486.629.596 1.398.246 2.037-.898 1.643.127 2.191 1.367 2.686-.037 2.41-1.531 3.934-3.232 5.336-.137-.061-.275-.123-.412-.182-.174-.594-.303-1.203-.531-1.771-.412-1.018.67-2.758-1.256-3.016-1.707-.232-1.469 1.572-1.867 2.402-1.675 3.502-3.789.735-5.701.6z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5A72C"
        d="M434.11 360.855c-2.115-3.898-.02-7.563 4.469-7.398 1.912.068 3.17-1.256 4.873-1.412l.027.066a.944.944 0 01.197.873c-.504 1.428-1.652 2.006-3.029 2.297-4.244.902-4.244.904-4.727 4.945-.1.309-.268.574-.5.801-.472.221-.916.209-1.31-.172z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FD9A09"
        d="M424.733 352.135l-1.879 1.873c-2.049 1.166-.926 3.156-1.254 4.775-.234 1.168.816 2.836-1.234 3.338h-.002v-9.986h4.369z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E29D2E"
        d="M421.616 307.196l-1.25 1.271c-1.904.622-1.477 3.457-3.637 3.838a19.483 19.483 0 00-.334-.295c-.148-1.448.756-2.467 1.461-3.566l4.602-4.178c1.049-.388 1.688.008 1.982 1.046a1.48 1.48 0 01-.258.791c-.713.693-1.935.199-2.566 1.093z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FE9F01"
        d="M417.34 331.715c-.934-3.814-.756-7.646-.076-11.486 1.049 3.81.395 7.65.076 11.486z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6A017"
        d="M414.118 339.676l.631-.07c.633-.383 1.262-.486 1.879.033 1.783 1.701 1.779 5.826-.004 7.512-.193-1.627-.371-3.256-.58-4.881-.145-1.102-.529-2.01-1.883-1.979-.166-.125-.229-.258-.186-.4.045-.143.092-.215.143-.215z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8A334"
        d="M443.034 362.162c-.232.67-.555 1.246-1.389 1.246-.865.678-1.736.607-2.611.016l-3.656-.084c-.701-.77-.715-1.574-.109-2.406l.178-.146c2.488.336 4.896 1.1 7.402 1.338l.185.036z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E38A31"
        d="M415.368 318.416c-2.051.338-.779 2.176-1.498 3.141-.705-.393-.152-1.564-1.031-1.908-.311-.41-.338-.824-.016-1.244l.02-.029c.559-.646.443-1.508.725-2.234.348-.914.656-2.02 2.066-1.286.465.834.338 1.61-.236 2.341-.011.405-.023.813-.03 1.219z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FA9D0F"
        d="M415.375 337.773c0-1.457-.002-2.912-.004-4.365 1.936-.268 2.77.563 2.496 2.5-1.341-.062-1.392 1.6-2.492 1.865z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6A017"
        d="M420.362 345.9v6.234c-1.783-1.675-1.785-4.57 0-6.234z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F3A115"
        d="M421.612 310.944c.07-.888-.209-1.857.59-2.61 1.348 2.97 1.348 2.97.66 3.861-.807-.027-1.229-.44-1.25-1.251z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FE971A"
        d="M432.842 365.871c-1.658 2.01-3.318 1.998-4.98.002l4.98-.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E49927"
        d="M415.397 317.195l-.129-2.693c-.688-1.333-.189-2.104 1.166-2.467.096.092.193.182.293.27-.633 1.579 1.029 3.782-1.33 4.89z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FE9F01"
        d="M419.997 336.313c-.764.832-.717 2.574-2.207 2.121-.701-.213-.207-1.029-.105-1.623.339-1.998 1.552-.229 2.312-.498z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F99F10"
        d="M420.366 362.121c-.389.922 1.588 1.307.574 2.27-.439.416-1.277.285-1.57-.316-.465-.959-.279-1.783.994-1.953h.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6A013"
        d="M435.268 360.934l.109 2.406c-2.994.486-1.975-1.078-1.268-2.484.388.025.774.052 1.159.078z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5A524"
        d="M439.034 363.424c.871-.008 1.738-.012 2.611-.018l1.188 1.211c-1.278-.367-3.063.895-3.799-1.193z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FE9F01"
        d="M421.254 333.938c.041.598-.428.609-.813.66-.412.049-.877-.02-.977-.482-.127-.586.404-.605.789-.652.412-.05.804.026 1.001.474z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FA9D0F"
        d="M416.627 339.639l-1.879-.031c.213-.4.426-.801.641-1.201.805.017 1.205.441 1.238 1.232z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FE961C"
        d="M445.325 362.133c.982.107 2.291-.451 2.494 1.23-.977-.115-2.287.446-2.494-1.23z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F1A311"
        d="M449.059 364.602c.035.826-.395 1.242-1.18 1.35.034-.766-.474-2.007 1.18-1.35z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6915F6"
        d="M332.778 437.865c-1.327-1.961-.95-3.984-.993-5.973-.01-.443.221-.822.693-.822.465-.002.772.365.746.803-.121 2.002-.293 3.996-.446 5.992z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4A0ECD"
        d="M333.017 451.984c-.999.016-1.48-.693-1.649-1.471-.406-1.857-1.621-2.641-3.356-2.883.009-.217.018-.436.025-.656 3.793.128 4.199.536 4.98 5.01z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#261C5E"
        d="M321.758 428.279c0 .625.003 1.248.005 1.873-.009.623-.016 1.246-.021 1.869-1.29.961.064 2.791-1.234 3.752-1.042-1.779-.758-3.771-.771-5.67-.009-1.023.253-2.443 2.021-1.824z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#231E54"
        d="M321.758 428.279c-1.872.357-1.159 1.857-1.228 2.938-.099 1.514-.023 3.035-.023 4.555-.004.418-.011.832-.016 1.248-.611.439-1.469 1.385-1.221-.42.414-3.025-.875-5.434-2.588-7.721-.637-.738-.739-1.639-.798-2.557.13-1.951-.439-4.098 1.537-5.535.61.002 1.222.002 1.831.002 1.232.395 1.842-.461 2.49-1.238-.25-1.635-3.408-1.344-2.488-3.756 3.356-.129 4.26.715 4.052 3.842-.054.801.21 1.648-.308 2.391-.225 2.12.69 4.47-1.24 6.251z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3E199B"
        d="M316.632 426.367l.052 2.512c-.401.225-.802.447-1.202.672l-1.14 1.146c-3.599-.42-7.221-.406-10.834-.555-1.22-.049-2.505.262-3.601-.576l-41.749-.125c.763-1.992 2.538-1.373 3.93-1.381 10.645-.066 21.29-.031 31.935-.041 1.34-.002 2.689.111 4.009-.225a5.494 5.494 0 011.117-.268c1.289-.133 2.586-.092 3.88-.115 3.414-.008 6.83.07 10.237-.08 1.251.148 2.257-.593 3.366-.964z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#341384"
        d="M315.587 432.053c-.021-.842-.041-1.688-.063-2.531 1.744.8 1.747 1.646.063 2.531z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#202052"
        d="M321.763 387.068c-.016 1.223-.012 2.449-.05 3.672-.021.67-.302 1.191-1.062 1.248-.881.063-1.345-.395-1.362-1.254-.032-1.633-.025-3.264-.036-4.898-2.673-4.244-2.443-8.854-1.705-13.533 1.057-1.463 2.184-2.723 4.187-1.445-1.446 5.404.182 10.806.028 16.21z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#202052"
        d="M321.14 368.402l.597 1.207c-.974 1.369-3.369-.58-3.953 1.703-.425.412-.729 1.014-1.47.922-1.786-1.25-1.776-2.955-1.221-4.799.387-.684 1.033-.6 1.666-.563.594.041 1.188.104 1.784.158.438.037.868.129 1.285.279.547.234 1.047.523 1.312 1.093z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#241F54"
        d="M317.384 370.865c-.314-1.229-.373-2.324 1.42-1.711.971.332 1.926.496 2.933.455l-.002 1.248c-1.542-.479-2.454.926-3.729 1.248-1.137.057-1.014-.525-.622-1.24z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#508ACE"
        d="M321.14 368.402c-.445-.193-.893-.389-1.337-.586 1.228-.914 2.368-1.283 3.173.5l.055.264c-.629-.057-1.26-.117-1.891-.178z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#241F54"
        d="M315.544 367.051c.015 1.779-.431 3.668 1.211 5.055.896 4.164 1.162 8.324.002 12.484-.428.01-.855.018-1.284.023-.556.379-1.063.313-1.528-.164-1.843-3.637-1.313-7.551-.964-11.324.196-2.119.021-4.375.938-6.42.699-.625 1.297-.767 1.625.346z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#251A58"
        d="M323 422.027c.575-3.172-.338-5.451-3.744-6.232 0-.307.037-.619-.006-.924-.334-2.385.48-2.924 2.494-1.57.909-.414.336-.836.006-1.256-.813-3.484 1.359-6.592 1.254-9.988.205.008.41.012.616.014.18 3.773-.185 7.539.518 11.332.528 2.863.213 5.878-1.138 8.624z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E6D7F2"
        d="M316.632 426.367c-.521.902-.459 2.873-2.344 1.283-.917-.121-1.458-.811-2.083-1.377-.31-.289-.604-.592-.899-.896-.632-.76-1.561-1.324-1.625-2.459 1.499-2.295 4.23-2.486 6.35-3.73.465-.096.899-.031 1.288.256.036.449.07.896.104 1.346l-.791 5.577z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#291859"
        d="M316.757 384.59l-.002-12.484c.017-.508.12-.977.629-1.24.01.514.121.977.622 1.24-.472 4.66.449 9.189 1.247 13.73-1.141.744-1.01 2.133-1.628 3.365-.352-1.662-1.042-3.049-.868-4.611z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C82532"
        d="M317.318 419.443c-.424.023-.849.047-1.273.068-.367.219-.629.131-.788-.266.677-4.213-1.244-8.293-.612-12.514.197-1.314-.115-2.684.294-3.994.128-.322.334-.584.616-.789 1.855.84.201 2.762 1.189 3.869-.229 4.56 1.677 9.031.574 13.626z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C82532"
        d="M315.466 390.861c.026 1.23.052 2.459.076 3.689.898 2.496.904 4.992.007 7.49l-.145.125a1.305 1.305 0 01-1.063.094 1.94 1.94 0 01-.663-.863c-.625-3.799-.287-7.617-.235-11.432.061-.541.215-1.047.556-1.48 2.348-.359.485 1.889 1.467 2.377z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6E1C43"
        d="M315.549 402.041l-.007-7.49c1.281.207 1.177 1.191 1.18 2.109.01 3.053.016 6.105.023 9.158-1.219-1-.035-2.759-1.196-3.777z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1B1E61"
        d="M318.708 407.854c-.908-1.76-.85-3.553-.221-6.059 1.175 2.41.737 4.232.221 6.059z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#311651"
        d="M321.744 419.551c-.129.834.383 1.938-.803 2.346-.928.316-1.574-.053-1.688-1.107.207-1.665 1.506-1.138 2.491-1.239z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6E1C43"
        d="M315.466 390.861c-.38-.861-.761-1.719-1.142-2.578-.794-.623-.819-1.492-.768-2.387.079-.537.263-1.02.711-1.363l1.205.08-.006 6.248z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1B2443"
        d="M321.75 412.045c.846.063 1.271.506 1.205 1.361-.032.406-.167.898-.634.803-.245-.053-.387-.59-.577-.908l.006-1.256z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF8F8"
        d="M377.934 345.275c-.289-.365-.916-.559-.988-.174-1.049 5.742-4.012 11.035-4.014 17.02-3.836 3.322-8.663 1.484-12.967 2.406-2.59.557-5.369.199-8.061.34-.773.039-1.146-.285-1.452-.873.659-1.42-.153-1.82-1.348-1.859-1.204-.037-2.411.008-3.617.018-1.177 1.006-1.8 2.393-2.521 3.709l-.025-.014c-3.671 1.342-7.473.34-11.201.635-.207-.207-.412-.416-.618-.621-.56-.471-.636-1.1-.591-1.77.109-.801.431-1.535.717-2.281 1.924-4.619 3.156-9.469 4.682-14.217 1.289-2.217 1.026-5.006 2.605-7.119.635-.914 1.02-1.959 1.478-2.967.147-.232.351-.404.604-.514.96.842 2.075-.809 3.038.176 3.129.537 6.25.951 9.295-.416.762-.287 1.521-.33 2.27.029 1.309 2.518 2.268 2.697 4.394.607 1.192-1.17 2.306-2.313 4.163-2.1 4.133.006 8.229-.568 12.348-.613 3.525-.035 4.355 1.117 3.47 4.574-.24.951-1.109 1.814-.42 2.9-.009 1.204.194 2.49-1.241 3.124z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DEE7E7"
        d="M331.74 366.482c3.672-1.299 7.475-.297 11.201-.635l-.006.654c-1.579.799-3.389-.248-4.959.621-.207.201-.418.402-.627.604-1.619-1.542-3.996.327-5.609-1.244z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EFE6D4"
        d="M342.966 365.861c-.13-1.895.596-3.211 2.521-3.709-.616 1.387-.773 3.086-2.521 3.709z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EEEEF6"
        d="M337.976 367.123c1.521-1.258 3.312-.367 4.959-.621-.221.541-.702.607-1.194.654l-3.765-.033z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9D8AA"
        d="M341.996 368.439c.167.09.586.182.64.375.144.514-.28.697-.708.738-.375.031-.907.127-.929-.418-.017-.466.449-.618.997-.695z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C0D8ED"
        d="M331.747 362.123c-.21.623-.417 1.25-.627 1.875-.776.924.095 2.174-.618 3.109-.719.426-.043.881-.032 1.324-.857-.188-1.718-.371-2.577-.557-.09-.125-.182-.248-.274-.371-.239-.605-.182-1.201.034-1.797.779-1.137.711-2.59 1.385-3.773.773-.773 1.456-1.777 2.807-1.152.214.465.259.918-.098 1.342z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DEE7E7"
        d="M330.501 367.107c.137-1.051-.43-2.24.618-3.109 0 .621 0 1.244.002 1.863-.023.508-.12.977-.62 1.246z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4BA0DC"
        d="M322.976 368.316c-.934-.965-2.09-.498-3.173-.5l-1.149-.127c-.153-.533.166-.801.567-1.023.896-.518 2.229.096 2.862-1.102.293-1.033-.469-1.725-.828-2.549-.331-1.074-.336-2.143.052-3.205.308-.627.807-1.01 1.489-1.158.695-.053 1.246.252 1.743.699.804.922 1.769 1.787 1.303 3.225-.685.818-.83 1.621.09 2.385.888.738 1.405 1.766 2.079 2.67l-.117.244c-.713.758-1.682.33-2.512.547l-2.406-.106z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5514D5"
        d="M329.81 456.268c-1.655.221-1.875-.732-1.805-1.883.06-.955-.201-2.625 1.234-2.189 1.354.41 3.688.545 3.81 2.219.142 1.899-2.296 1.087-3.239 1.853z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#361B87"
        d="M223.133 177.376c-16.265 0-32.53.036-48.794-.043-2.423-.012-3.122.468-3.851 3.189-1.847 6.899-.923 13.773-.934 20.618-.118 71.921-.071 143.841-.079 215.761 0 3.373.665 6.746-.006 10.119-.41.334-.819.383-1.228-.004-.01-40.871-.024-81.744-.03-122.615-.006-41.809-.004-83.616-.004-125.426 0-4.07.007-4.074 4.044-4.082 16.951-.027 33.902-.05 50.853-.076.413.043.825.086 1.238.131l.002 1.175c-.423.399-.64.998-1.211 1.253z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#352364"
        d="M223.133 177.376c.021-.788.413-1.217 1.212-1.251l1.273 5.006.236 1.942c.343.938-.351 2.037.45 2.904.503 4.006.04 8.105 1.157 12.052a1.19 1.19 0 01-.744.891c-.423.089-.795.011-1.085-.335-.19-2.239-.148-4.611-.328-6.69-.415-4.816-.099-9.901-2.171-14.519z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#AD3EB2"
        d="M224.43 174.276c-1.268-1.288-.415-2.908-.68-4.352.2-.02.4-.026.601-.02l.079 4.372z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3F0D2F"
        d="M226.834 198.589l.627-.56c1.265-.286 2.7.401 3.831-.663 1.028.939 1.991.01 2.982-.102l.143.227c.203.263.27.557.203.883-.574 1.261-1.563 1.967-2.92 2.188-.81.106-1.625.109-2.442.097-.858-.019-1.702-.086-2.418-.64-.316-.475-.336-.952-.006-1.43z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FB000F"
        d="M232.497 193.954c.551.079.564.51.562.912-.002.402-.028.889-.576.885-.552-.005-.563-.493-.56-.896.003-.404.023-.832.574-.901z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F13C52"
        d="M226.304 185.978c-.89-.854-.525-1.901-.45-2.904.705.881.272 1.94.45 2.904z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#451EA8"
        d="M168.242 427.018c.409 0 .818.002 1.228.004l.003.002c.392.414.824.762 1.405.881 7.282.271 14.562.096 21.841.105 19.762.031 39.524.016 59.286.006 1.657 0 3.334.156 4.952-.4 11.214-.49 22.433-.09 33.649-.217 1.662-.018 3.326-.043 4.986.021 1.12.045 2.336-.105 3.069 1.076-1.046.678-2.221.387-3.336.389-11.303.023-22.604.006-33.907.039-1.092.002-2.298-.414-3.258.518-23.75.029-47.501.066-71.252.09-6.223.006-12.446-.029-18.668-.045-.001-.825.001-1.647.002-2.469z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#591FD7"
        d="M299.907 429.566c3.992-.012 7.982-.033 11.975-.025.98 0 2.141-.291 2.46 1.156l-.091.088c-2.492.984-4.983.918-7.475-.004l-6.837-.002-.035-.629c.003-.195.003-.39.003-.584z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6914F4"
        d="M306.776 430.781l7.475.004-.04 3.713c-1.41-2.234-3.437-2.936-5.986-2.506-.827.141-1.349-.347-1.449-1.211z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3D1C63"
        d="M255.547 176.163c1.122 2.313 3.758 4.038 2.646 7.227-.292.836-.104 1.839-.136 2.767l-1.173-.079-.101-1.181c.062-2.978-1.837-5.679-1.236-8.734z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A620AE"
        d="M253.104 172.381c1.615.2 1.15 1.464 1.25 2.439l-1.146.091-.104-2.53z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1A1841"
        d="M260.575 207.313l1.258.651c.73.424.57 1.431 1.24 1.895l.017 5.583c.389.556.48 1.22.057 1.696-.544.611-.791-.198-1.183-.408-.907-.485-1.046.186-1.063.839a78.65 78.65 0 00-.005 4.317c.099 3.401-1.017 6.17-3.98 8.066-.421.271.331.729.076 1.139-.501 1.11-1.665 1.31-2.558 1.886-4.08 1.151-5.82-.703-5.066-5.381.25-.734.449-1.485.573-2.253.047-.308.119-.607.199-.907.915-2.677-.471-5.167-.635-7.757 1.102-1.737.739-4.093 2.361-5.611 3.756.729 5.69-2.771 8.709-3.755z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2D2556"
        d="M251.865 211.068c-.428 2.011-.279 4.219-1.978 5.796-1.055.091-1.623-.631-2.214-1.316-3.214-4.288-7.65-6.989-12.268-9.459a1.545 1.545 0 01-.003-1.336c.929-1.181 2.065-.79 3.05-.236 2.663 1.497 5.109 3.376 8.159 4.156.875.224 1.493 1.059 1.895 1.929.262.628.242 1.346.512 1.959.447 1.015.755.463.994-.167.278-.842-.226-1.864.6-2.57l1.224.026c.008.406.018.812.029 1.218z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2D2368"
        d="M248.105 211.084c-3.966-2.463-7.698-5.393-12.468-6.251-1.735-1.267-1.321-2.969-.951-4.663.162-.989.222-2.014.933-2.821l.07-1.208c1.259-.203 2.396.672 3.66.408 1.555.162 1.791-1.414 2.723-2.076.732-.321 1.455-.315 2.167.053 1.019.951.871 2.081.209 3.057-.623.919-.753 1.868-.76 2.518 1.286-2.075 1.134-4.825 1.593-7.45.108-.099.217-.195.326-.292l1.109.04c.308 2.098-.276 4.395 1.382 6.191l.015 2.493c.742 1.145.242 2.688 1.209 3.76-.416 1.879.777 3.342 1.288 4.981-.313.84.627 1.676.008 2.517-1.524.951-1.668-.853-2.513-1.257z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#302465"
        d="M249.322 204.842c-2.214-.67-.808-2.506-1.209-3.759 1.187 1 1.296 2.349 1.209 3.759z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#341E6C"
        d="M239.363 197.352c-1.361.01-2.796.244-3.674-1.212l.024-1.3c1.504-.406 1.265-3.372 3.649-2.481l.001-.001c1.192 1.664 1.194 3.33 0 4.994z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#27256C"
        d="M245.565 191.133l.042 1.226-.025.012c-.339.313-.722.541-1.183.622-.768.099-1.518.068-2.222-.302l-.318-.327c.001-2.494-.03-4.989.02-7.482.019-.949-.433-2.202 1.139-2.47-.505 2.276 1.479 4.009 1.35 6.202.825.638.398 1.87 1.197 2.519z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#202B5F"
        d="M239.363 197.352l.001-4.994 2.496.005.002-.003c.66.828.662 1.658.006 2.489.259 1.93-.554 2.786-2.505 2.503z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2D2556"
        d="M235.619 197.349l-.005 3.127c-1.845-.111-.857-1.585-1.17-2.433a5.094 5.094 0 01-.027-.551l1.202-.143z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3F1D68"
        d="M245.565 191.133c-1.607-.266-1.102-1.535-1.196-2.52l1.178.059.018 2.461z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EEFAEF"
        d="M586.379 207.408c.041.792.477 1.163 1.248 1.179.256 1.805-.221 3.427-1.225 4.917-.443-.542-.883-1.083-1.326-1.623.094-1.332-.102-2.713.678-3.927-.214-.668.069-.765.625-.546z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FA394B"
        d="M266.324 344.754a.808.808 0 00.522-.139c.674-.736 1.937-.531 2.447-1.531 1.344-.559 2.487-1.482 3.801-2.098.823-.434 1.693-.693 2.625-.732.753-.164 1.511-.168 2.27-.064 2.947 2.057 5.754-.109 8.625-.314.413-.031.868-.406.551-.869-1.693-2.471.904-3.139 1.838-4.504 1.365-.646 2.847-1.139 3.547-2.676 1.657-1.814 4.088-2.395 6.017-3.787.291-.135.593-.23.905-.295.48-.096.964-.141 1.452-.15.506-.025 1.02.01 1.516-.074 3.779-.643 3.778-.65 3.861 3.16a3.05 3.05 0 01-.466 1.381c-.345.375-.768.48-1.254.35-.794-.277-.764-1.824-2.03-1.346.057.688.711.328 1.003.586.409.211.743.5 1.035.846 2.087 3.453 3.233 7.191 2.997 11.221-.153 2.602.61 4.613 2.585 6.291 1.356 1.152 2.565 2.475 2.32 4.496-.387 1.717-1.4 3.291-1.144 5.15-.019.828-.065 1.648-.539 2.369-.356.377-.785.475-1.275.322-.275-.307.064.111-.225-.188-.233-.236-.372-.537-.58-.787.13.268.305.504.514.729.745.674.952 1.744 1.8 2.334.588.549 1.171 1.102 1.629 1.77 1.091 1.07 1.07 2.461.936 3.785-.502 4.947-.308 9.891-.012 14.832-.048 1.131-.893 1.666-1.684 2.238-.236.17-.497.311-.762.434-.89.326-1.819.568-2.645 1.068a7.772 7.772 0 01-.723.379c-.895.395-1.75.857-2.593 1.357-11.636 6.135-23.498 11.818-35.266 17.688-4.451 2.221-8.867 4.506-13.283 6.793-1.468.76-2.885 1.686-4.668 1.338-1.213-.656-1.92-1.875-3.199-2.838.78 1.387 1.795 2.584.592 4.006a2.245 2.245 0 01-1.287.352c-1.404-.072-1.738-1.215-2.274-2.207-.672-1.242-1.254-2.6-2.755-3.135a2.707 2.707 0 01-.55-.758c-.538-1.467-1.573-2.77-1.468-4.443.365-1.814-2.368-3.609-.051-5.441.631-.383 1.482-.658.791-1.676a2.565 2.565 0 01-.297-.748 2.037 2.037 0 01.239-1.189c.01-.479 1.161-.881.083-1.404-.671 1.045-.498 2.229-.628 3.357-.543 1.258-1.356 1.566-2.205.387-.568-.791-1.137-1.672-1.167-2.729.086-.262.228-.488.453-.656-.262.092-.44.355-.759.367-.442-.084-.972-.301-.943-.691.404-5.523-3.112-10.621-1.739-16.244.241-.992.148-2.129 1.516-2.363.555.199.894.6 1.057 1.115-.045-.461-.445-.738-.749-1.082-.498-.721-.415-1.459-.094-2.215.462-.697 1.019-1.293 1.772-1.688.835-.289 1.64-.293 2.379.268.725 1.398-.476 2.57-.474 3.902.002 1.369-.006 2.695.852 3.857.922 2.814-.105 5.789.696 8.586 1.2-2.986.212-6.061.475-9.072-.287-3.143.691-6.369-.68-9.426-.426-2.102-1.651-3.994-1.67-6.207.097-.82.414-1.51 1.162-1.936 1.067-.381 1.418-1.148 1.181-2.229a2.3 2.3 0 01.057-.826c.204-.389.534-.621.936-.762.852-.074 1.502-.432 1.781-1.299 1.346-1.783 3.324-2.912 4.742-4.619 1.195-.65 2.373-1.328 3.333-2.316l.02.027c2.309-1.064 4.727-1.873 6.958-3.127.924-.52 1.733-1.068 2.274-1.979.145-.254.319-.482.515-.695.949-.995 2.407-.864 3.478-1.587z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FEFEFE"
        d="M250.002 227.375c-.753 4.657.494 6.072 4.35 4.938 2.155-.615 1.758 1.05 1.84 2.146.395 5.271-.968 10.231-2.764 15.106-.62.998-1.058 2.143-2.181 2.742l-.736 1.188c-.246 1.042-.474 2.099-1.801 2.291-.927-.02-1.771-.253-2.437-.945-.355-.74.084-1.123.314-1.26-.495.688-1.971.81-2.452 2.101.376-.888.963-1.389 2.012-1.093.608 1.596-.578 2.656-1.214 3.844-.472.877-1.253 1.592-1.376 2.657-.201.604-.678.908-1.235 1.123-.187.002-.372.008-.558.017-1.69.995-3.541.731-5.36.652.929.203 2.143-.229 2.503 1.188-.209.622-.681.95-1.274 1.143-1.738-.246-3.408.449-5.17.344-1.114-.065.104.359.08.627-.08.873-.703 1.191-1.312 1.572-.969.352-1.902.991-2.994.392-.576-.559-.401-1.253-.373-1.885-.149.433-.001.939-.11 1.425-.126.282-.326.49-.598.634-1.051.318-2.056.399-2.843-.542.569-1.075-.691-.194-.737-.665-.893-3.562-.623-7.16-.469-10.754.293-1.024 1.052-1.549 2.039-1.66 4.302-.487 7.797-2.59 10.957-5.384 2.167-1.655 3.508-3.896 4.509-6.377 1.049-3.055 1.528-6.174 1.106-9.397.003-1.547-.756-3.03-.397-4.606 1.574-4.338.451-6.654-3.984-8.197-1.561-.543-3.574-3.804-3.333-5.784.233-1.918 1.871-2.749 3.465-3.104 2.729-.608 5.625-1.641 7.461 1.974.532 1.046 2.182 1.47 3.166 2.394 2.647 2.365 1.874 5.729 2.535 8.675.105.199.077.376-.087.533-1.472.289.469 1.528-.542 1.947z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FB384A"
        d="M280.425 258.576l-2.181-1.393c-.468-.232-.684-.643-.793-1.125-.162-.754-.141-1.487.278-2.146.059-.091.149-.187.22-.299 0 0-.083.059-.27.187-1.564.007-1.548-1.446-2.111-2.313-.826-1.271-1.245-2.804-2.513-3.788a2.594 2.594 0 01-.481-.755c-.265-1.36-.492-2.734-1.49-3.812-1.686-3.513-1.519-7.25-1.221-10.965.146-1.834 1.12-3.111 3.234-2.974 1.296.234 2.513.694 3.65 1.357 1.295 1.288 2.878.978 4.442.78a4.494 4.494 0 012.228.562c.287.179.466.433.545.76-.49 3.246.645 6.3 1.132 9.426-.121 1.678.207 3.251 1.105 4.69.185.967 1.128 1.692.906 2.79-.537.915-1.165 1.692-2.373 1.529-.393.003-.063-.385-.184.01-.047.15.171.275.385.293 1.212.341 2.223-.217 3.256-.676 2.473-.116 3.015 2.937 5.262 3.191.893.092 1.796.054 2.677.247.297.07.583.176.858.309 4.659 3.119 9.32 2.542 13.983.002.543-.273 1.125-.388 1.724-.438 2.684-.015 3.938-1.787 4.869-3.962.159-.257.377-.447.646-.58.444-.109.857-.047 1.224.24.561.896 1.076 1.854 2.344 1.872 1.301.654 2.632.336 3.963.13.637.095 1.133.39 1.438.974 1.562 3.218-.697 5.184-2.402 7.331-.439.629-.961 1.166-1.664 1.5-1.109.464-2.698-.161-3.295 1.468-1.818 2.357-4.92 2.153-7.19 3.626-4.614 2.534-9.589 1.274-14.432 1.345-.712.011-1.382-.372-1.654-1.148.262-1.808 1.817-1.31 2.892-1.521 1.799-.357 3.687.173 5.479-.557-3.071-.554-6.125-.699-9.183.25-.663.206-.656.64-.756 1.119-.745.62-1.601.625-2.488.475a3.05 3.05 0 01-.822-.347c-.572-.48-1.14-.969-1.438-1.686-.097-.458-.031-.877.292-1.234.802-.611 2.056-.241 2.688-1.232.503-.417 1.112-.432 1.721-.449-.724-.019-1.417.05-1.925.659-1.045.843-2.623.483-3.557 1.579a3.473 3.473 0 01-2.225.133 2.809 2.809 0 01-.774-.411c-1.646-2.103-4.067-3.282-6.019-5.023z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#221E53"
        d="M359.18 283.477c-2.573 1.61-4.571 4.28-7.983 4.351-.469.018-.862-.173-1.232-.428-1.709-1.146-3.66-.399-5.477-.68a6.431 6.431 0 01-1.281-.221c-.539-.146-1.074-.313-1.621-.437-1.158-.218-2.154-1.181-3.455-.728-1.491.4-3.151-.23-4.54.772-.231.208-.468.392-.71.582-1.782 1.186-3.566 2.411-5.177-.223-.041-1.129 2.092-2.685-.644-3.281-1.268.582-.553 2.313-1.712 2.954-2.591.075-1.407-2.557-2.544-3.525a6.137 6.137 0 01-.514-1.217c-.149-.729-.701-1.269-.951-1.956-.283-1.224.263-2.06 1.254-2.688.733-.379 1.587-.744 1.82-1.566.525-1.858 2.006-2.424 3.576-2.938 1.279-2.429 3.996-1.525 5.928-2.215 3.326-1.187 6.758-.861 10.303 1.461 3.004 1.967 5.915 4.003 8.621 6.319.888.76 2 .285 2.726.991.062 1.163-2.223.883-1.409 2.347.566 1.022 1.65 1.148 2.74 1.084 1.012-.059 1.846.23 2.282 1.242z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FAFAFA"
        d="M401.015 221.901c-.553.316-1.105.635-1.656.952-2.223-.23-2.783-2.574-4.533-3.517-5.01-2.701-10.258-3.482-15.807-2.551-.925.155-1.839.226-2.771.211-1.775-.268-1.891-1.944-2.635-3.089-.398-1.735-1.9-3.132-1.588-5.089.639-1.04 1.078-2.458 2.787-1.472 1.705 1.279.975 3.502 1.965 5.059.869.395 1.375 1.594 2.652 1.181-.199-2.133-2.292-.531-3.009-1.567-.264-3.915-.313-4.084 3.494-5.159 1.914-.54 3.412-2.705 5.332-1.732-2.1-.518-4.621 1.168-7.162.191-.311-.12-.26-.232-.287.275-.08 1.484-1.572 1.562-2.707 1.895-1.225-1.053-2.834.036-4.109-.742-.758-.488-.695-.964.109-1.255 10.345-3.749 20.402-3.749 29.964 2.389.137 1.166 1.145.881 1.85 1.108 1.564.26 2.357 1.44 3.145 2.629l-.098.199c1.482 3.664 1.412 4.305-2.293 6.176-1.348.68-1.441 1.351-1.389 2.462l-1.254 1.446z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2C2360"
        d="M171.959 427.031c-.029-1.072-1.576-1.883-.226-3.301.59-.621.221-2.191.222-3.33.006-79.15.002-158.299.025-237.448 0-1.292-.39-2.665.498-4.095 1.12.943.709 2.135.71 3.139.028 15.081.02 30.162.02 45.244v193.141c0 4.15.002 4.15 4.25 4.154 4.281.002 4.281.002 6.432 1.246-3.177 0-5.722-.018-8.267.012-.988.008-2.196-.309-2.416 1.238-.414.328-.831.328-1.248 0z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FCFCFD"
        d="M298.872 328.543c-1.591 1.768-4.199 1.846-5.842 3.527-.224.354-.551.557-.947.662-.875.148-1.796.156-2.516.809-.238.145-.492.24-.763.305-.624.27-1.652-.428-1.869.805a1.567 1.567 0 01-.619.488c-2.522-.213-3.827 1.605-5.291 3.174-.242.225-.52.363-.841.432-.552.023-1.003-.143-1.286-.65-.255-.52-.185-1.074-.206-1.625-.009-4.307-.018-8.607.006-12.91.006-1.105-.222-2.273.56-3.254a.46.46 0 00.1-.502c2.887-1.797 6.088-.754 9.144-.984 2.481-.186 4.968.215 7.465.039 1.649-.117 3.285.277 3.422 2.322.165 2.46.624 4.979-.517 7.362z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F4F4F5"
        d="M193.947 422.572c-.662-4.297-.662-4.283 3.511-4.293 15.211-.035 30.423-.08 45.635-.119 1.096-.793 2.283-.729 3.504-.379.864.34 1.489.967 2.032 1.695.627 1.27 1.987 2.557-.082 3.77-10.658-.559-21.324-.191-31.985-.273-6.537-.049-13.075.008-19.611-.027-1.001-.005-2.081.357-3.004-.374z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#631AEB"
        d="M196.953 255.982c0-1.038-.998-1.523-1.316-2.386-.111-1.924-.001-3.965-2.468-4.64a13.607 13.607 0 01-1.491-1.582 3.484 3.484 0 01-.361-.833c.067-1.571-1.286-3.292.477-4.69 1.417-.52 2.547.037 3.623.923 1.039.854 2.148 1.537 3.612.849-.114-1.041-1.875-1.578-.85-2.899 1.421-1.168 2.998-1.332 4.695-.751.777.403 1.023 1.206 1.425 1.89.689 1.301 1.139 2.709 1.765 4.039.25 1.542 1.212 2.646 2.292 3.673.51.673.506 1.771 1.624 1.936.256.052.502.124.75.201.25.084.484.2.707.336.607.559 1.365.749 2.151.882.432.116.808.314 1.057.706.154.453.099.885-.117 1.304-1.331 1.92-3.109 2.069-5.161 1.372-1.998-.68-2.787.042-2.174 2.095.42 1.403.787 2.778-.246 4.088-.921.573-1.902.62-2.921.344a4.622 4.622 0 01-.881-.539l.07-.121c-1.008-1.475-2.098-2.844-4.016-3.162-1.352-.568-1.5-2.022-2.246-3.035z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2F2268"
        d="M193.181 412.053c-1.854.232-2.535-.502-2.531-2.439.052-24.996.051-49.992.001-74.988-.004-1.908.614-2.711 2.504-2.455.14.148.281.299.423.445.714 1.475.471 3.061.472 4.6.016 21.393.015 42.785.014 64.172.059 2.461-.249 4.936.185 7.393.268.615.543 1.234.558 1.926-.185.875-.509 1.588-1.626 1.346z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FCFBFB"
        d="M320.46 207.467c1.176 1.628 3.807 1.789 4.221 4.187.038.662-.338 1.093-.815 1.469a2.465 2.465 0 01-.815.28c-3.94.603-5.555 2.313-5.27 5.597-.207 1.196-1.047 1.438-2.082 1.389-1.315-.193-2.174-1.29-3.382-1.7a22.782 22.782 0 00-4.369-1.387c-1.382-.287-2.906-.628-2.871-2.586.36-2.022.109-4.066.205-6.099.112-6.417 1.193-7.072 7.488-4.953 2.758.928 5.47 1.838 7.69 3.803z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#302267"
        d="M215.646 332.162c1.721.291 1.226 1.66 1.232 2.691.038 5.762.02 11.521.021 17.283.765.828.863 1.859.863 2.908.008 15.045.07 30.088-.032 45.133a5.727 5.727 0 01-.24 1.531c-1.185 1.695-.84 3.668-1.048 5.555-.14 1.271-.032 3.133-2.353 2.105-.76-1.234-.558-2.611-.559-3.945-.017-16.375-.533-32.773.228-49.115.339-7.281.783-14.578.995-21.879.025-.853.317-1.62.893-2.267z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2C236E"
        d="M243.109 415.795h-49.5l-.083-1.105c3.784.416 7.062-2.045 10.889-1.391 1.396-1.189 3.093-.859 4.709-.938 4.479-.207 8.998.666 13.438-.51.325-.195.67-.336 1.033-.441 3.166-.26 6.333-.521 9.484.164 1.442 1.051 3.116.795 4.744.877 1.813.096 3.715-.428 5.398.701.605.909.651 1.795-.112 2.643z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2F255F"
        d="M223.137 412.047c-.285 1.725-1.656 1.229-2.685 1.234-5.345.039-10.691.018-16.037.018-1.857-2.42-4.09-1.266-6.232-.611-1.789.547-3.604 1.713-5.002-.635l1.247-1.219c1.082-1.092 2.484-.875 3.809-.891 4.66-.063 9.321.064 13.971-.08.314-.074.642-.096.965-.07 1.027-.102.598 1.551 1.677 1.389 1.933-.725 1.18-2.613 1.72-3.943 1.349-17.238.33-34.494.661-51.732.022-1.123-.286-2.289.291-3.369l.624-.002c1.152 1.193.858 2.711.862 4.127.046 16.867.034 33.736-.011 50.605-.008 2.576 2.448.475 2.668 1.967.951.856 1.106 2.083 1.472 3.212z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2E2271"
        d="M221.861 409.572c-3.053-2.223-2.196 1.07-2.858 2.219-.286-.039-.571-.08-.857-.117v-59.539c1.012-.535.238-1.963 1.247-2.496 1.248 1.293.859 2.934.863 4.449.033 14.252.007 28.5.035 42.748.003 1.422-.354 2.941.731 4.186.47.35.956.682 1.262 1.201.562 2.488 1.059 4.976-.423 7.349z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#38138D"
        d="M221.861 409.572l-.015-7.521c-.755-.84-.82-1.881-.821-2.926-.012-16.412-.054-32.824.021-49.236.002-.52.079-1.033.224-1.537.35-.834.87-1.408 1.88-1.236 4.571.002 9.142.004 13.713.008.833-.646 1.671-.645 2.513-.018.855.123 1.842-.242 2.487.668.219.352.167.656-.157.914-.45.307-.954.447-1.487.498-4.234.205-8.475.01-12.711.131-1.248.037-2.788-.389-3.452 1.311-.091.518-.162 1.035-.281 1.551-.071.363-.168.719-.271 1.074-.254 17.445-.056 34.889-.096 52.326a3.97 3.97 0 00.423 1.793c.804 1.465 2.23 1.297 3.545 1.287 4.209-.029 8.408.396 12.62.25.862.211 1.537.684 1.989 1.453.04.357-.098.629-.409.811-1.57.703-3.49.111-4.927 1.33-.824.182-1.639.227-2.426-.154-3.657-1.627-7.371-1.178-11.096-.309l.009.008c-1.674-.183-1.113-1.515-1.275-2.476z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#322070"
        d="M244.36 425.781c.417-.824.836-1.646 1.253-2.471.366-.383.801-.334 1.246-.199.226.189.396.42.513.688.381.906-.024 2.363 1.661 2.367 1.49.104 2.993-.139 4.462.268.917.516 1.707 1.064.543 2.111-20.171.057-40.34.068-60.509-.006-.766-.342-.704-.883-.365-1.496 1.67-.004 3.34-.008 5.01-.014 1.013-.938 2.281-.871 3.52-.867 13.657.059 27.316-.16 40.973.123.636.012 1.24.045 1.693-.504z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#611DE3"
        d="M240.582 348.436l1.255.021c.764.699.602 1.637.645 2.521-.084 1.23.268 2.529-.54 3.654l-.014 3.113c.862 1.17.559 2.422.257 3.672a.972.972 0 00.303.09c.218.523-.074.852-.43 1.16-.875.4-1.575 1.598-2.76.625-2.969-1.527-1.443-4.586-2.283-6.947-1.251 3.834-.59 5.686 2.475 7.146.558.686.534 1.441.288 2.229-.994 1.402-.959 3.486-2.839 4.307-.479.09-.933.025-1.346-.244.753-2.432-1.82-3.711-2.031-5.82-.104-2.695-.033-5.389-.065-8.082a40.45 40.45 0 01.026-2.148c.063-1.33-.011-2.801 1.574-3.34 1.587-.539 3.042-.32 3.963 1.307 1.641 1.744.605 3.924.977 5.881-.262-1.717.357-3.502-.414-5.182-.78-1.588-1.114-3.067.959-3.963z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2C2657"
        d="M214.402 412.045c-1.642-.109-.387-1.268-.676-1.869-.988-1.131-.822-2.521-.822-3.855-.015-23.424-.026-46.85.022-70.275.003-1.404-.561-3.191 1.479-3.893l1.241.01c0 5.908.624 11.896-.111 17.713-2.513 19.883-.384 39.811-1.113 59.699.649.827.633 1.654-.02 2.47z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#331E6A"
        d="M220.641 402.066c-2.047-.506-1.205-2.178-1.209-3.34-.056-16.363-.038-32.727-.039-49.088.426-1.246-1.011-3.109 1.246-3.742l.402.471c.349.682.222 1.418.222 2.135.002 16.658.009 33.318-.008 49.977-.003 1.216.251 2.505-.614 3.587z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#382081"
        d="M321.773 279.716c.848.058 1.248.494 1.156 1.354-1.111.95-2.459.774-3.766.801-2.042.06-4.084.115-6.113-.197-3.542-.387-4.135.073-4.151 3.459-.032 6.863-.013 13.726-.002 20.588.032.918.083 1.834.002 2.751-.017 1.306.077 2.608.009 3.913-.304 2.826.66 5.763-.751 8.489-2.088-.086-1.828-1.902-2.066-3.111-.371-1.872-.657-3.854.678-5.57-.002-9.984-.007-19.968-.011-29.951-.648-.837-.657-1.671.016-2.501 2.078-.963 4.163-.907 6.251-.039.824.003 1.647.003 2.472.007 2.094-1.183 4.186-1.35 6.276.007z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B246C"
        d="M266.83 252.275c-2.046-.716-1.477-2.302-.797-3.424.569-.944.813-1.797.796-2.817-.763-4.765-1.126-9.539-.661-14.372.136-1.415.447-2.753 1.406-3.669.739-.706 1.198-1.298 1.271-2.331.057-.811.663-1.249 1.551-1.081.94 1.264 1.936 2.504 1.997 4.189-1.953.908-2.548 2.472-2.478 4.558.093 2.8.01 5.605.268 8.398-.108 1.268.066 2.475.786 3.563.177.438.269.896.292 1.366.058 1.331-.627 2.314-1.507 3.206-.873.927-1.94 1.621-2.924 2.414z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2A2270"
        d="M198.174 425.783c-1.513-.139-3.072.301-4.934-.451 1.238-1.078 2.453-.975 3.701-.969 14.381.074 28.762.105 43.143.199 1.091.006 2.63-.688 3.026 1.219-.857.828-1.947.609-2.961.611-12.997.018-25.994.016-38.991.006-1.03 0-2.099.122-2.984-.615z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2C2563"
        d="M198.174 425.783l44.935-.002h1.25c.532.191 1.545.408.524 1.031-.7.426-1.814.211-2.743.211-14.656.01-29.312.006-43.967.006l.001-1.246z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2E2364"
        d="M270.558 224.81c-1.229 2.052-3.336 4.038-3.494 6.17-.287 3.861-1.305 7.968.76 11.733.819 1.493-.977 2.123-.995 3.32-2.038-1.276-2.041-3.69-2.315-5.504-.36-2.381-1.07-5.156.804-7.458.171-.209.288-.719.161-.877-2.362-2.991.66-4.972 1.352-7.379.341-1.347.938-2.536 2.412-2.865 1.103-.246 1.715.389 1.879 1.474.005.54-.143 1.019-.564 1.386z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B2660"
        d="M354.207 213.581v-1.249c-1.312-3.819-.636-5.75 2.969-8.461 1.857-1.399 4.546-1.246 6.848.381.44 2.462-.173 3.312-2.359 3.257-.099-.002-.199-.049-.297-.076-1.795-.477-2.979.578-3.289 2.003-.48 2.201 1.875.769 2.568 1.624.286.398.397.846.395 1.331-.177 1.453-1.095 2.31-2.338 2.906a2.816 2.816 0 01-1.861-.064c-.902-.513-1.873-.917-2.636-1.652z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#302267"
        d="M214.405 332.152c-1.076 1.025-.603 2.355-.604 3.545-.045 24.824-.056 49.652-.074 74.479a8.42 8.42 0 00-.319.012 1.702 1.702 0 01-.838-.873c-.687-2.551-.38-5.17-.384-7.742-.036-22.004-.114-44.006.006-66.006.124-.914.097-1.838.166-2.756.019-.354.093-.697.21-1.033.162-.309.359-.598.587-.861.416.409.834.821 1.25 1.235z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2C236C"
        d="M189.436 219.822c-.472.659-.863 1.403-1.437 1.958-.799.773-1.675.796-2.202-.352-1.607-3.5.411-6.583 4.296-6.6 1.026-.004 2.054-.001 3.081-.001.894.238 1.741.573 2.446 1.197l.154.153c.468.542.544 1.169.411 1.844-.181.648-.546 1.153-1.151 1.467-1.885-.254-3.702.703-5.598.334zM186.939 242.29c-.259 2.071.915 4.636-2.683 6.229 1.367-3.702-2.381-6.776-.479-9.667 1.909-2.897-1.308-6.179 1.361-9.189 1.048 2.25-.41 5.087 2.753 5.806.426.097.951 2.383-.763 2.989-.74.262-1.384.427-1.433 1.34.84.619.379 1.887 1.244 2.492z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#272572"
        d="M306.769 312.191c.076 2.958-.411 5.998 1.229 8.736.367.412.384.863.153 1.346a8.294 8.294 0 01-3.12 1.467c-1.172-.186-1.335-1.055-1.365-2.016-.026-3.33-.022-6.656-.003-9.982.008-1.125-.206-2.311.611-3.293.146-1.929-.304-3.897.63-5.833.959 2.092.411 4.375.638 6.555.115 1.1-.669 2.625 1.227 3.02z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2E2760"
        d="M236.864 249.634c-3.525 3.842-8.146 5.463-13.078 6.452-.831 2.821-.024 5.709-.354 8.55-.101.878.388 1.863-.443 2.617-.372 0-.743 0-1.114-.003-1.519-2.117-.675-4.537-.832-6.819-.118-1.725-.081-3.466.039-5.192.14-1.269.756-2.228 2.074-2.365 4.277-.446 8.326-1.434 11.721-4.294.462-.39 1.148-.473 1.791-.275.56.368.569.822.196 1.329z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#611DEC"
        d="M410.413 222.354c.096 1.934-1.746 3.104-1.938 4.922-.229.351-.177.784-.337 1.155-.67 1.534-1.994 2.478-3.492 2.605-1.422.122-.795-1.867-1.719-2.492-.033-.374-.064-.747-.1-1.119-.65-.941-.842-1.994.182-2.665 1.094-.713 1.494.598 2.371 1.265-.174-1.476-1.914-2.107-1.5-3.558.137-.25.332-.447.576-.592 1.279-.459 2.393-1.189 3.418-2.071.168-.039.338-.054.511-.049 2.334-.427 2.78.619 2.028 2.599z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2D246D"
        d="M360.417 211.078c-.958-.133-1.675 1.816-2.866.233-.621-.825-1.196-1.646-.413-2.41 1.104-1.076 1.962-3.343 3.763-2.548 2.109.928 2.708.104 3.292-1.512.052-.123.103-.246.152-.372.566-.945 1.576-1.405 2.349-2.124 1.248-.096 2.219.292 2.717 1.439-.607 1.239-2.66.567-2.715 2.318.635.904.039 1.366-.641 1.797-1.34.675-2.733 1.26-3.985 2.108-.528.389-.994.88-1.653 1.071z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2C2460"
        d="M327.99 272.248c-.975 1.035-2.633 1.379-2.74 3.309-.053.965-1.105 1.639-2.257 1.678-3.284-.751-6.774.164-9.979-1.241.081-1.067-.267-2.676 1.458-2.428 4.643.664 8.968-1.378 13.518-1.318z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2C265A"
        d="M237.538 264.775c.393-.253.785-.507 1.177-.762.669-1.089 1.568-1.646 2.882-1.251.817 1.519 2.546 3.375-1.242 3.102-.545-.041-1.258.122-1.616.757-.51.544-1.021 1.089-1.869.634-.845-.011-1.192.731-1.768 1.14-.854.604-1.619 2.632-2.858.212-.223-.435-1.272.55-1.86.64-2.442.372-5.096 1.861-7.217-.805 1.4-.816 3.014.262 4.42-.5l-.026.027c.126-.37.32-.389.571-.106 1.153.293 2.108-.343 3.128-.672 2.049-.92 3.955-2.211 6.278-2.416z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#292546"
        d="M246.851 423.303l-1.238.008c-16.254-.006-32.508-.01-48.763-.029-1.005-.002-2.01-.119-3.014-.195-.028-.002-.076-.176-.057-.254.023-.094.109-.174.168-.26 18.471-.008 36.942-.02 55.414-.027l.185.426a1.01 1.01 0 01-.523.715c-.801.311-1.529.198-2.172-.384z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#272359"
        d="M217.522 352.137c0 17.541.009 35.086-.023 52.627-.002 1.188.473 2.514-.598 3.543-1.017-2.078-.878-4.156-.006-6.236l.004-49.934c.208-.002.415-.002.623 0z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B246C"
        d="M270.577 223.569c-.488-1.801-1.396-1.427-2.231-.334-.456.597-.431 1.592-1.515 1.581-.93-.148-2.302.436-2.408-1.175-.088-1.339.94-1.818 2.052-1.732 1.237.095 1.193-.928 1.637-1.528 1.247-1.684 2.453-3.417 4.958-3.056.324-.213.604-.165.84.142.388 1.67.006 3.25-.554 4.813-.748.81-1.306 2.04-2.779 1.289z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2A2660"
        d="M273.707 217.335l-.638-.011c.036-2.132.861-3.821 2.661-5.051.965-.659.765-1.717-.912-2.226-2.076-.628-1.841-1.837-1.51-3.645 2.092 1.164 4.587 1.249 6.003 3.432-.034.13-.067.261-.099.392-.371.744-.409 1.561-.51 2.365a3.014 3.014 0 01-.445 1.194c-1.264 1.017-1.828 2.563-2.845 3.771-.616.289-1.188.246-1.705-.221z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3A1F57"
        d="M315.531 267.289c-2.125 1.987-4.898 2.235-7.523 2.397-4.142.255-8.31.063-12.466.061-.649-.657-1.495-.563-2.313-.645-1.156-.115-2.059-.507-1.524-1.97.412-.357.91-.456 1.434-.478 3.54.46 6.971 1.532 10.64 1.29 3.026-.198 6.063-.008 8.902-1.346.511-.053 1.022-.13 1.54-.058.521.101.981.309 1.31.749z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B2560"
        d="M336.884 232.312c1.648.179 2.443-.405 2.4-2.215-.027-1.089.188-1.093 1.191-.289 1.652 3.328.726 6.655.003 9.983-.003.833-.005 1.665-.005 2.497-2.541-.809-.43-3.213-1.645-4.577-1.385-.07-.465 2.275-1.994 2.089-.818-.56-.847-1.433-.918-2.291.041-1.498-.158-3.014.291-4.487a1.35 1.35 0 01.677-.71z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2D2660"
        d="M304.263 322.172c.027.811.445 1.232 1.257 1.268.856.229 1.812.406.828 1.594-2.391.352-4.51 2.76-7.189.957-.376-1.533-.092-3.096-.178-4.641-.045-.801.2-1.725-.92-2.035-1.393-.658-3.117.311-4.398-.893 3.124-2.558 6.296-1.717 6.807 1.984.259 1.883 1.299 1.779 2.563 1.768.408-.367.819-.365 1.23-.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2E295C"
        d="M252.526 249.779c1.931-4.854 3.268-9.834 3.006-15.116-.044-.89.506-2.226-1.18-2.351l2.475-1.277c.21-.25.421-.238.632 0-.845 3.162.04 6.565-.782 9.563-.962 3.506-.271 7.71-3.57 10.436-.513-.27-.276-.888-.581-1.255z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#28254B"
        d="M243.076 417.656h-48.523l-.002-.611h48.559c.142.211.139.418-.034.611z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2D226F"
        d="M364.192 204.841c-5.769-3.09-9.983.072-9.985 7.491-.424.003-1.137 1.614-1.229-.16-.098-1.867-.074-3.745.009-5.613.056-1.214 3.391-4.18 4.655-4.202 2.184-.039 4.368-.01 6.552-.01.668.833.67 1.664-.004 2.495l.002-.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#262570"
        d="M344.22 232.304l2.494-.001.002.003c0 2.285-.151 4.58.037 6.85.227 2.708-1.301 4.064-3.561 5.196 1.724-3.952.87-8.037 1.028-12.048z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#361B87"
        d="M193.164 427.043l.023 1.229c-7.907.512-15.814.506-23.722.002l.007-1.25c.83.004 1.659.008 2.487.008h1.25l19.955.011z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#381C88"
        d="M221.872 254.8l.003 12.45c-2.047 3.04-2.467 3.306-5.965 1.318-.393-.225-1.005-.063-1.515-.082-.303-.541-1.949-.1-1.095-1.49 1.265-.779 2.576-.469 3.876-.14 1.88.479 2.676-.235 2.663-2.167-.021-2.873-.109-5.75.06-8.625.077-.505.254-.963.585-1.356.484-.286.95-.308 1.388.092z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#33206A"
        d="M291.77 267.276c.159 1.281 1.126 1.236 2.05 1.231.884-.004 1.629.156 1.721 1.239-.412.011-1.01-.152-1.207.06-3.458 3.71-5.843.417-8.479-1.249-.081-.052-.201-.039-.302-.054l-.002-.002c.06-1.072.772-1.297 1.658-1.238 1.022.068 1.239-.368.839-1.243 1.605-.665 2.608.462 3.722 1.256z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#23266F"
        d="M255.615 348.404c-.718-.209-1.873.447-2.053-.686-.071-.449.736-1.371 1.298-1.529 2.847-.811 5.061-3.771 8.544-2.51.573.207.897.352.922.951-.229.73-.741 1.213-1.397 1.564-1.174.563-2.284 1.254-3.481 1.777-1.235.531-2.406 1.638-3.833.433z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4923A8"
        d="M296.789 203.594c2.317-1.438 4.903-1.248 7.461-1.221 1.633 3.928.927 7.975.61 12.001-.754 1.809-2.188 2.493-4.061 2.451-.517-.036-1.004-.176-1.438-.464-1.125-2.801 2.063-1.747 2.672-2.995.126-.401.168-.815.197-1.231 0-.436.002-.869.003-1.304-.008-.752-.014-1.502-.017-2.251-.013-.745.007-1.49-.019-2.232-.032-.424-.06-.851-.204-1.254-1.451-1.501-3.788.094-5.204-1.5z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#481C53"
        d="M350.462 244.786c-.006-5.408-.011-10.816-.018-16.223-.777-1.24-.924-2.293.818-2.797.369.052.65.242.842.564.492.986.407 2.056.459 3.108.286 4.629-.668 9.321.69 13.896.13.313.216.64.265.976.045.329.033.662-.025.99a1.89 1.89 0 01-.44.847c-1.457.681-1.85-.668-2.591-1.361z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2D2373"
        d="M313.014 275.993c2.542 0 5.084-.013 7.628.009.973.009 2.143-.273 2.351 1.232-1.106.483-1.324 1.403-1.22 2.483-2.092-.004-4.184-.009-6.275-.011.248-1.067 2.047-2.758-1.017-2.488-.85.076-1.391-.324-1.467-1.225z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6F8F8"
        d="M402.269 220.457c-.363-.818-1.969-.854-1.553-2.007.271-.744 1.752-.431 2.096-.864 1.096-1.394 5.053-1.226 2.754-4.645-.133-.199.246-.741.385-1.123 4.278 3.16 4.294 3.18.119 6.161-1.229.876-2.235 2.113-3.801 2.478z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#31206E"
        d="M203.167 328.416c-.216-1.797.433-2.67 2.385-2.521a34.69 34.69 0 005.218 0c1.954-.148 2.6.727 2.383 2.523-3.329.986-6.658.988-9.986-.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#30216C"
        d="M346.714 232.303c0-2.448-.031-4.896.021-7.342.018-.854-.442-2.05.685-2.431 1.317-.444.968 1.325 1.788 1.662 1.423 2.287.242 4.575 0 6.863-.699.678-1.328 1.5-2.492 1.251l-.002-.003z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#302D55"
        d="M320.46 207.467c-3.395-1.474-6.701-3.119-10.372-3.936-2.666-.592-4.232-.375-3.848 2.877.082.702-.117 1.437-.187 2.157-2.163-1.906-1.177-4.073-.513-6.213 4.89-.459 9.411.573 13.524 3.315.689.46 1.488.765 1.396 1.8z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1C184D"
        d="M257.458 231.035h-.631c-2.003-1.825.895-2.536 1.226-2.939 2.161-2.627 2.657-5.461 2.638-8.695-.006-1.009-1.79-4.624 2.251-2.749l.148-1.21c.84.873.991 1.977.163 2.742-.697.644-1.064-.687-1.98-.88-.428 4.82 1.438 10.332-3.815 13.731z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B236E"
        d="M340.474 242.288c2.043.498 1.113 2.156 1.213 3.329.142 1.641.035 3.303.023 4.957-.004.911-.218 1.686-1.366 1.602-.968-.068-1.003-.806-1.116-1.555-.441-2.913.56-5.597 1.246-8.333z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2A2953"
        d="M279.259 320.305l.03 16.842c-.408.383-.819.336-1.23.008 0-5.082-.026-10.162.036-15.242.007-.647-.767-2.216 1.164-1.608z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B236E"
        d="M340.479 239.791c0-3.329-.003-6.656-.003-9.983 1.135.034 3.027 2.854 2.938-1.929 1.123 2.059.67 3.295.807 4.425v-.001c-1.859.91-2.462 2.479-2.531 4.457-.036 1.093.704 2.637-1.211 3.031z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#321F6E"
        d="M263.074 209.858c-1.233-.095-1.251-.985-1.24-1.895 0-4.003-.036-8.005.026-12.007.016-1.054-.445-2.242 1.214-3.957v17.859z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#331D7E"
        d="M279.311 209.834c3.599-.317 4.693-1.543 3.86-4.796 1.665.885 3.259 1.241 4.93 1.083.31.373.341.785.178 1.227-1.061 1.164-2.416 1.956-3.662 2.885-.89.342-1.842.564-2.531 1.305-.565.484-1.098 1.021-1.874 1.166-.51.021-.944-.122-1.241-.57-.36-.837-.273-1.607.34-2.3z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2A2470"
        d="M192.547 249.777c-.35.365-.666.773-1.057 1.091-.822.667-1.585 2.038-2.804 1.057-1.079-.87.136-1.729.432-2.638.735-2.263.182-4.656.315-6.991.407-.337.845-.362 1.306-.13 1.067 1.531-.269 3.645 1.226 5.074l-.001.008c.524.767.978 1.549.583 2.529z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2C236C"
        d="M189.311 232.274c-3.437-2.611-4.292-6.286-1.938-8.349.051-.045.195.017.366.036.976.607-.21 2.655 1.683 2.727.553.425.675 1.041.749 1.678.04 1.089.094 2.182-.239 3.244-.122.3-.33.521-.621.664z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#571149"
        d="M213.154 330.916l-.024.627c-1.113 1.025-2.505.852-3.837.859-4.976.029-9.952-.016-14.928.031a2.38 2.38 0 01-1.106-.277l-.103.014c.12-.506.304-1.176.845-1.129 3.169.271 5.93-2.113 9.153-1.357l-.004-.004c.231 1.504 1.408 1.193 2.375 1.203 2.543.033 5.086.023 7.629.033z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#382873"
        d="M305.541 202.351c.197 2.069-.566 4.217.513 6.213.079 2.151.193 4.304-.453 6.404-.353-.392-.714-.153-1.073-.011a19.176 19.176 0 01-.28-.179l.002-12.406 1.291-.021z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3F3D68"
        d="M297.857 318.902c1.526.227 1.466 1.369 1.467 2.502.002 1.502.044 3.004.067 4.508.553.814.604 1.617-.058 2.402-.15.086-.304.16-.462.229-.032-2.387-.127-4.777-.071-7.164.03-1.283-.28-1.916-1.703-1.871-5.911.182-11.835-.363-17.739.295l.728-.922c3.615-1.314 7.386-.814 11.034-.537 2.232.168 4.509.203 6.737.558z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2D2273"
        d="M336.23 213.879c2.875 1.948 1.335 4.749 1.777 7.258-2.562-1.981-5.123-3.813-1.777-7.258z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#302C55"
        d="M248.739 255.401l1.773-1.906c.617 1.975.133 3.81-1.593 4.76-2.254 1.238-3.186 4.704-6.596 3.958l.873-1.025c1.456-2.304 3.546-4 5.543-5.787z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#32245B"
        d="M304.263 322.172c-.411 0-.82 0-1.23.002-.002-3.684-.031-7.366.014-11.05.013-1.025-.486-2.388 1.227-2.675-.005 4.574-.008 9.151-.011 13.723z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#38215D"
        d="M356.705 258.516l-.053-3.688.316-.303c.284-.089.57-.1.863-.034.268.129.504.303.705.521 1.488 1.849 2.787 3.853 4.691 5.356.579.458 1.411 1.015.915 2.048-.437.225-.847.209-1.226-.12-1.053-.099-2.148.178-2.553-1.425-.438-1.732-1.799-2.569-3.664-2.355h.006z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3C1E60"
        d="M350.462 244.786c1.07-.116 1.342 1.268 2.355 1.254 1.969 1.42 2.379 3.763 3.406 5.739.239.963 1.283 1.781.543 2.925l-.113.124c-1.885-.503-2.433-2.167-2.903-3.689-.72-2.338-3.55-3.544-3.288-6.353z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2D2660"
        d="M280.558 318.426c-.074-.449-.489-1.17.311-1.182 3.775-.057 7.552-.023 11.327.041.552.008.758.604.85 1.131-4.163.522-8.325.502-12.488.01z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#391C78"
        d="M372.939 267.246c-2.613.113-5.297.408-6.658-2.659-.025-.056-.547.107-.836.169-.603-.586-.671-1.296-.487-2.068.094-.282.235-.544.417-.779.746-.671 1.396-1.591 2.629-1.043.982.949-.184 2.647 1.211 3.448.205.167.406.342.609.511.758.614 1.809.42 2.604.938.443.401.816.826.511 1.483z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5028B3"
        d="M369.242 265.379c-.039-.197-.08-.396-.117-.593.189-.261.432-.445.73-.561 1.93-.685 3.465.667 5.197.995 1.102-.071 2.033 1.403 3.244.346.746-.626 1.304-1.538 2.417-1.604.439.21.736.486.479 1.021l-2.119 2.801-1.732.789c-1.246-1.172-2.77-1.429-4.402-1.326-.219-.388-.436-.774-.652-1.162-.853-.934-2.156.072-3.045-.706z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#232666"
        d="M349.208 231.055v-6.863c.052-.798-.078-1.707 1.102-1.82.882-.084 1.322.351 1.406 1.203.616.827.755 1.648-.021 2.463-1.633.24-1.108 1.547-1.25 2.524-1.116.822-.238 2.152-.793 3.117-.207.362-.564.248-.289-.056.073-.076-.096-.373-.155-.568z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2D2272"
        d="M200.671 207.332c.413-.921-1.773-1.486-.508-2.3 1.63-1.047 3.496-1.556 5.251.5-.947.924-1.442 2.635-3.501 1.813-.417.37-.831.323-1.242-.013z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#451F60"
        d="M356.697 214.827c.59.011 1.18.02 1.773.03.579 1.33-.476 2.147-1.074 3.011-1.053 1.517-1.574 3.123-1.489 4.95-.343.864-.821 1.369-1.759.676-.613-1.437-2.094-2.877.026-4.297-.364-1.126.931-1.185 1.217-1.89l.058-1.227a2.27 2.27 0 011.248-1.253z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E1415E"
        d="M263.097 347.137c-2.457 3.414-5.966 4.729-9.994 5.004.031-.176.064-.348.1-.523.726-1.439 2.507-1.322 3.495-2.375 1.014-.223 1.832-.84 2.705-1.352 1.277-.018 2.19-1.844 3.694-.754z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#121B43"
        d="M226.834 198.589l.066 1.234c1.088 1.434 1.147 3.009.376 4.542-.605 1.205-1.708 1.236-2.853.712-1.154-1.31-.91-2.637-.049-3.973l1.257-2.519 1.203.004z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D93B5A"
        d="M273.107 247.27c2.502.648 2.519 3.187 3.615 4.884.385.594.449 1.323 1.337 1.375l-.004-.004.018 2.496c-3.447-1.038-3.665-4.39-4.982-6.955a.95.95 0 00-.062-.505c-.336-.453-.294-.882.078-1.291z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E63C51"
        d="M324.261 259.78c1.285-2.183 3.57-4.005 2.539-7.025.871-.469 1.529-.041 2.163.507 1.102 1.271.976 2.57.085 3.887-.371.565-1.063.476-1.572.765l-1.938 1.882c-.429.333-.855.36-1.277-.016z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C44268"
        d="M250.072 354.682c-.787 2.293-3.409 2.912-4.499 4.928-.634.514-1.254.555-1.855-.055 1.081-2.654 3.313-4.141 5.628-5.545.39.064.631.289.726.672z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#45262E"
        d="M323.66 212.941c-.038-.729.497-1.005 1.021-1.289 1.33 1.091 3.262.079 4.557 1.301.209.103.293.225.252.367-.043.154-.094.23-.154.23.826 1.659 2.948 2.658 2.518 4.956-.113.077-.227.155-.338.234-.605.014-1.029-.31-1.393-.744-.69-.969-1.264-2.022-2.039-2.935-.795-1.223-2.051-.983-3.223-1.015-.596-.157-1.051-.465-1.201-1.105z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#212969"
        d="M203.167 328.416c3.329 0 6.657 0 9.986.002-.208 1.51-1.378 1.229-2.356 1.24-2.548.023-5.097.016-7.646.021l.004.004.012-1.267z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3D2547"
        d="M189.469 228.592l-.046-1.905c.373-.643 1.351-.906 1.183-1.888-.572-.753-.568-1.592-.382-2.464.619-1.26 1.174-2.623 3.034-2.017.775 3.226-.742 5.799-2.375 8.343-.484.264-.959.278-1.414-.069z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#451E4E"
        d="M243.076 417.656c.022-.203.033-.406.033-.611v-1.25l-.086-2.477c-.132-.301-.087-.566.162-.791 2.485 1.09 3.017 3.396 3.547 5.705a2185.51 2185.51 0 00-3.638-.072c.005-.17 0-.336-.018-.504z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#30235F"
        d="M193.299 220.496c-1.468-.25-1.765 1.17-2.6 1.824-.422.369-.843.366-1.263-.005l-.001-2.492c1.714-1.41 3.58-1.491 5.552-.635a.53.53 0 01.165.407c-.009.151-.031.227-.061.228-.289.397-.693.635-1.139.817a.699.699 0 01-.653-.144z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EA3857"
        d="M216.895 203.601l1.27-.623c1.823-.146 3.799-1.352 5.299.762-.014.598-.33 1.021-.78 1.37-.628.38-1.326.501-2.044.536-1.193.02-2.391.067-3.583-.083-.561-.163-1.251-.253-1.353-.945-.124-.846.871-.576 1.191-1.017z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5E1FDD"
        d="M296.789 203.594c1.416 0 2.832.002 4.248-.002.931-.003 1.897-.07 1.972 1.262-1.444 1.223-3.194.723-4.83.861-1.63-.007-3.288.235-4.842-.503-.346-.981-.346-.981 1.632-1.584.606-.01 1.212-.023 1.82-.034z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2A2762"
        d="M269.322 249.779c.07-1.192 1.654-1.778 1.268-3.155.264-.186.542-.201.833-.068.625.538 1.032 1.125.42 1.932-.197 1.689.824 4.188-2.518 3.788-.67-.833-.673-1.665-.003-2.497z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1E1A3C"
        d="M280.558 318.426c4.162-.002 8.324-.006 12.487-.01.205.014.412.016.618.006 1.388.252 2.89-.482 4.195.482-5.925-.01-11.849-.016-17.771-.021l.471-.457z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E23C55"
        d="M216.895 203.601c.317.413-2.067.87.021 1.253.305.336.504.72.537 1.18-.212 1.636-1.291 2.374-2.417 1.196-1.051-1.098-2.23-.777-3.318-1.174-.196-.44-.169-.85.165-1.216 1.469-1.227 3.213-1.344 5.012-1.239z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4B133C"
        d="M273.091 249.067c1.892 2.152 2.423 5.28 4.982 6.955l.17 1.162c-3.539-1.547-5.022-4.404-5.152-8.117z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7F7F6"
        d="M227.587 267.941c-1.414.695-2.936.435-4.42.5a423 423 0 01-.178-1.188c.623-3.697-.339-7.507.797-11.167.341 3.714-.573 7.498.602 11.169l-.001-.002c.89 1.05 2.149.389 3.2.688z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#350E3E"
        d="M223.089 204.111c-1.198-2.309-3.353-.453-4.924-1.133-.592-.028-1.183-.058-1.774-.085 2.626-.914 5.617.181 7.985-1.788l.02 3.733c.518 1.379-.115 1.642-1.315 1.357-.52-.697-.326-1.391.008-2.084z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D74355"
        d="M280.425 258.576c2.642.975 5.178 2.083 6.331 4.958-.343.327-.754.392-1.204.317-.891-.439-1.822-.826-2.373-1.731-.335-1.634-2.708-1.685-2.754-3.544z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2C2274"
        d="M236.87 267.255l1.869-.634c.539.819 2.4.726 1.705 2.392-.419 1.004-1.364.717-2.134.702-1.773-.03-1.353-1.408-1.44-2.46z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3E1D69"
        d="M273.156 341.641c-1.163.779-2.354 1.496-3.746 1.793-.309.307-.556.262-.743-.131 1.341-1.373 1.81-3.809 4.424-3.631 1.119.619.7 1.291.065 1.969z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3F2744"
        d="M331.853 218.507c2.516 1.351 3.665 3.49 3.639 6.308-.607.381-1.048-.002-1.504-.325-.771-.792-1.321-1.745-1.941-2.65a4.847 4.847 0 01-.326-.759c-.184-.79-.631-1.57-.106-2.391l.238-.183z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4A3135"
        d="M336.63 242.243c-1.219 2.379-.521 5.357-2.357 7.543-.408.367-.834.328-1.269.051-.925-1.505.323-2.626.683-3.906.633-1.21.755-2.65 1.655-3.744.441-.251.873-.282 1.288.056z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#522940"
        d="M354.148 223.495c.946.077 1.284-.471 1.34-1.306.976-.696 1.863-.258 2.753.207.787.533 1.937.757 1.802 2.088-.734 1.279-1.979 1.083-3.154 1.1-1.326-.209-2.652-.419-3.828-1.135-.283-.27-.309-.564-.082-.88.389-.025.78-.051 1.169-.074z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5A21D9"
        d="M193.219 248.517c3.788 1.599 3.983 2.008 2.419 5.079-.758-.118-1.132-.586-1.207-1.326-.805-.637-.542-1.801-1.231-2.493l-.073.038c-.285-.455-.348-.895.092-1.298z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#312458"
        d="M327.476 257.913c.066-.675.627-.592 1.063-.701.67-.476.923-1.616 2.086-1.313.642.438 1.226.927 1.554 1.66.22.807.17 1.562-.439 2.206-1.893.468-2.832-1.257-4.264-1.852z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C33F66"
        d="M196.768 215.908c1.526-2.634 3.625-4.695 6.248-6.231a.95.95 0 01.477.692c-1.384 2.644-3.387 4.668-6.047 6.036a.916.916 0 01-.678-.497z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4E1D51"
        d="M285.541 263.502l1.215.032.037-.006c.742.71 1.813.479 2.651.92.646.721 1.658.902 2.336 1.576v-.004c.378.387.952.235 1.377.496a.616.616 0 01-.019.688l-1.368.071c-1.532.444-2.442-.954-3.723-1.256l-2.5-1.265c-.368-.413-.331-.832-.006-1.252z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C33F66"
        d="M195.722 218.003l.052-1.827c.332-.089.664-.178.995-.269.088.093.179.184.273.273 1.46 1.119 3.792 1.283 4.065 3.709a1.597 1.597 0 01-.446.755c-2.229.207-3.704-.994-4.939-2.641z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7F7F6"
        d="M241.597 262.763c-1.053.205-1.704 1.334-2.882 1.251-1.088-1.016-2.58-.131-4.387-.99 2.822-.724 5.066-1.188 7.436-.794a4.833 4.833 0 01-.167.533z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#212960"
        d="M200.671 207.332l1.242.013c-.419 1.846-2.048 2.355-3.535 3.212-.483-2.057-.347-3.522 2.293-3.225z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3A2851"
        d="M332.964 252.883c.031.912.051 1.816-1.22 1.89-.343.354-.755.417-1.214.298-.703-.332-1.026-1.032-1.51-1.575-.216-.424-.194-.842.023-1.256.201-.21.441-.369.711-.481.816-.228 1.639-.459 2.504-.295.618.281.376.991.706 1.419z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#461C4F"
        d="M322.993 262.488c-.151 3.243-2.915 2.905-4.931 3.594a.911.911 0 01-.246-.77c.935-1.485 2.481-2.21 3.876-3.124.253-.113.519-.18.794-.203.293.039.465.208.507.503z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2D2373"
        d="M313.026 279.7c-2.083.014-4.167.026-6.251.039 1.641-1.771 4.512-1.788 6.251-.039z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5C1DDC"
        d="M410.413 222.354c.049-1.431-.4-2.473-2.027-2.595.109-.483.188-.985.74-1.191 1.061.07 2.426-.266 2.674 1.243.169 1.047.132 2.279-1.387 2.543z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#35335E"
        d="M406.048 211.619l-3.207-2.408c-.188-.142-.25-.281-.184-.417.066-.135.131-.203.193-.203 1.633-1.18 2.646.283 3.676 1.022 1.005.72-.845 1.187-.478 2.006z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#361D6F"
        d="M312.611 271.574c-1.797.866-3.598.854-6.227.124 2.574-1.018 4.398-.734 6.227-.124z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2D2A57"
        d="M376.77 269.79c-.443.827-1.039 1.512-1.871 1.97-.303-.244-.572-.595-.922-.717-.99-.344-1.275-1.093-.861-1.887.535-1.029 1.301-.453 2.018-.034.501.295 1.087.451 1.636.668z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3F3C54"
        d="M372.139 208.663c.66 1.649 1.316 3.299 1.973 4.948-.256.604-.652.909-1.328.622-.572-.632-.984-1.377-1.457-2.083-.354-.954-.793-1.902-.289-2.939l.629-.602c.19-.259.347-.228.472.054z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3E1D60"
        d="M278.059 337.154c.41-.004.82-.006 1.23-.008l.128 1.09c-.027.611-.385 1.035-.812 1.418a2.89 2.89 0 01-.732.428c-.412.133-.834.152-1.263.127-.439-.055-.819-.215-1.07-.602.397-1.273 1.208-2.121 2.519-2.453z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#361E87"
        d="M213.17 267.197c.408.43.816.859 1.225 1.292-1.886.487-3.104-1.705-4.983-1.243-.41-.496-.356-.979.033-1.459 1.661-.638 3.249-1.082 3.725 1.41z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#541EC8"
        d="M199.437 258.512c1.667.802 4.028.89 3.777 3.667-1.138.237-1.444-1.304-2.528-1.179l-.001-.003c.012-.827-.445-1.197-1.223-1.258-.401-.402-.425-.81-.025-1.227z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C8485D"
        d="M211.883 204.841l.008 1.227c-.922 1.998-2.553 2.215-4.448 1.774a1.284 1.284 0 01-.687-.638c1.464-1.32 3.279-1.878 5.127-2.363z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3A1C6A"
        d="M273.928 256.314l1.132 3.143c-.384.068-.86.316-1.139.176-1.559-.792-.562-2.069-.769-3.13.259-.063.517-.124.776-.189z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#33235C"
        d="M365.4 262.215l.045 2.541c-1.917.282-2.756-.541-2.528-2.462l1.335-.064c.378-.345.761-.3 1.148-.015z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2D2277"
        d="M356.697 214.827c-.02.811-.439 1.227-1.248 1.254-1.662-.212-1.123-1.521-1.242-2.5.974.122 2.293-.434 2.49 1.246z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#202C5C"
        d="M285.553 268.504l-.002 2.496c-.834.664-1.666.668-2.496-.008-.277-1.942.559-2.769 2.496-2.49l.002.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5823BF"
        d="M287.994 207.296l.106-1.175c.189-.006.377-.019.565-.037.463-.665 1.323-.72 1.887-1.231l.009-.002c.65-.557 1.313-.575 1.988-.042-.564 2.742-1.797 3.415-4.555 2.487z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#331C7D"
        d="M209.426 265.954l-.013 1.292c-1.206-.9-3.061-.809-3.773-2.465l.309-.327c.716-.383 1.451-.344 2.196-.101.643.358 1.426.608 1.281 1.601z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BE4761"
        d="M203.015 209.677c.807-1.49 2.293-1.953 3.741-2.472.091.07.181.142.269.215.521 1.444-.581 2.041-1.442 2.766-.826.339-1.617.342-2.342-.252a7.978 7.978 0 00-.226-.257z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C83A62"
        d="M250.072 354.682l-.726-.672c1.185-.752 2.196-1.846 3.737-1.896-.429 1.529-1.356 2.476-3.011 2.568z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4E1A55"
        d="M259.35 348.396a3.914 3.914 0 01-2.436 1.281c-.468.299-.922.332-1.353-.072l.053-1.201c1.539.443 2.442-.967 3.725-1.273.368.42.37.842.011 1.265z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#222B60"
        d="M195.62 216.024c-.994-.034-2.241.449-2.446-1.197l.315-1.431c1.207.473 2.036 1.253 2.131 2.628z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4A2527"
        d="M336.669 227.315l.213 4.996-.168.01c-.279.177-.551.165-.813-.032-.496-.612-.71-1.348-.941-2.081-.227-.929-.286-1.859.007-2.789.508-.961 1.069-1.144 1.702-.104z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#341E89"
        d="M199.437 258.512l.024 1.228c-1.958-.503-2.715-1.808-2.508-3.757 1.624.06 1.053 2.276 2.484 2.529z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#322070"
        d="M223.15 347.115c-.418.221-.836.439-1.254.658-.615-.51-.591-1.223-.615-1.922.046-.855-.155-1.775.619-2.447 2.246.623.812 2.481 1.25 3.711z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2E2177"
        d="M330.48 254.76l1.265.013c-.109 1.093 1.797 1.184 1.24 2.498-.417.366-.836.368-1.258.005-.821-.021-1.217-.467-1.255-1.266-.373-.419-.317-.835.008-1.25z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#341C84"
        d="M292.441 204.896l-1.88-.045c.052-.417-1.631-1.062.1-1.225 1.423-.135 2.87-.008 4.307.001l-1.946 1.205c-.172.214-.366.235-.581.064z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B2468"
        d="M404.679 222.245a1 1 0 00-.52.187c-.424.263-.832.261-1.227-.064l-.064-.07c.691-1.681 1.949-2.5 3.766-2.466.153 1.456-.97 1.878-1.955 2.413z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2D1F7E"
        d="M277.081 332.824c-1.664.686-2.658.795-3.982-.018 1.322-.88 2.318-.781 3.982.018z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#501F4D"
        d="M263.058 345.848c.066-.779.501-1.172 1.27-1.217.666.039 1.331.08 1.997.123-.53 1.533-2.079 1.32-3.188 1.861-.182-.154-.254-.318-.217-.496.038-.181.083-.271.138-.271z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FAFAF6"
        d="M372.139 208.663a3.156 3.156 0 01-.473-.053l-.686-1.863c1.35-.291 2.701-.595 3.822.59v.001c-1.384-.554-1.505 1.425-2.663 1.325z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6D184B"
        d="M255.562 349.605c.451.025.901.049 1.352.072-1.053 1-2.353 1.527-3.712 1.939-.419-2.085 1.042-1.964 2.36-2.011z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2A2085"
        d="M190.621 242.319l-1.188-.022c-.843-.066-1.246-.505-1.204-1.366.037-.743.464-1.042 1.144-1.101.727.221 1.261.67 1.605 1.348.104.449.063.854-.357 1.141z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B2660"
        d="M364.19 204.842l.004-2.495 2.5-.002c-.342 1.326-1.184 2.15-2.504 2.497z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3C2175"
        d="M241.942 354.633l-.096-3.756c.42-.357.838-.359 1.256.004-.396 1.248.968 3.039-1.16 3.752z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2E2364"
        d="M269.322 249.779l.002 2.496h-2.495c.342-1.32 1.171-2.154 2.493-2.496z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#192D68"
        d="M221.899 343.404l-.022 2.484c-.409.373-.82.373-1.233.004l-.006.004c.014-.881.02-1.764.045-2.645.013-.422.221-.854.646-.742.251.067.384.583.57.895z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#331C7D"
        d="M203.144 262.3c.207-.006.413-.006.62-.002.759.713 2.669.483 1.958 2.398l-.083.085c-1.885.232-2.743-.568-2.495-2.481z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3C2443"
        d="M190.692 241.06c-.788-.036-1.215-.461-1.319-1.23l.072-1.294a.577.577 0 01.603-.235c.337.125.625.333.907.55.391.276.817.507 1.152.862.201.342.241.706.15 1.089-.11.242-.279.424-.518.543-.402.102-.76.036-1.047-.285z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2F2B35"
        d="M332.964 252.883c-.497-.257-.591-.716-.612-1.213-.462-.71-.015-1.213.397-1.723.12-.047.242-.093.363-.138l1.16-.023c.093 1.255-.206 2.347-1.308 3.097z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4F1C4B"
        d="M275.541 339.607c.42.01.84.021 1.26.029.388 1.268-.987.711-1.297 1.256-.783.25-1.566.5-2.349.748.131-.66.381-1.328-.064-1.969l2.45-.064z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3C2175"
        d="M242.185 361.418c-.687-1.182-.303-2.438-.257-3.672 1.176.076 1.195.924 1.189 1.787.35.477.381.9-.192 1.234-.246.217-.493.436-.74.651z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#633110"
        d="M336.63 242.243l-.978-.025c-.487-.255-.573-.702-.573-1.192.28-1.207.094-2.517.785-3.637.25-.264.525-.298.832-.103.047.837.092 1.675.137 2.514-.066.813-.134 1.628-.203 2.443z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#28247A"
        d="M329.335 213.551a1.5 1.5 0 01-.098-.597c1.131.091 2.223-1.308 3.547.013-1.064 1.035-2.336.436-3.449.584z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#572CC0"
        d="M404.679 222.245l1.955-2.414 1.24-.024c-.564 1.468-1.326 2.68-3.195 2.438z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#512B3C"
        d="M336.669 227.315c-.438-.137-.903-.671-1.271.094-.986-.01-1.281-.755-1.587-1.49-.131-.646-.109-1.255.446-1.723.414.206.824.412 1.234.618-.104 1.067 1.366 1.395 1.178 2.501z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#472917"
        d="M371.037 209.211c.613.953.719 2.01.646 3.105l-.367.138c-.691-.226-1.01-.838-1.422-1.359-.322-.473-.553-.978-.543-1.567.135-.576.25-1.176 1.086-.953l.6.636z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#342A2E"
        d="M365.414 207.314c.76-.053 1.236-.404 1.281-1.212.85.096 1.826-.337 2.475.596-.348.435-.682.885-1.164 1.193-.855.466-1.627 1.301-2.744.628-.206-.433-.182-.839.152-1.205z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#33206A"
        d="M285.541 263.502l.007 1.254c-1.32-.402-2.292-1.116-2.369-2.636.94.199 1.76.606 2.362 1.382z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#663604"
        d="M189.949 238.544l-.252.004-.251-.012-.133-6.263.15.042c.402-.19.723-.098.962.279.57 2.041 1.059 4.077-.476 5.95z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#AD3A56"
        d="M324.261 259.78c.426.004.852.009 1.277.015-.375 1.346-1.484 1.994-2.546 2.691a.79.79 0 01.017-.377c-.385-.359-.371-.725-.021-1.097l1.273-1.232z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3C1697"
        d="M243.102 350.881l-1.256-.004-.009-2.42.025-.684c1.472.614 1.246 1.905 1.24 3.108z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#312B4B"
        d="M252.526 249.779c.476.287.563.755.58 1.254-.208 1.024-.591 1.795-1.858 1.274l1.278-2.528z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4A2944"
        d="M367.875 207.242l1.297-.544c.383.651 1.383.888 1.266 1.877-.48.221-.584.637-.578 1.111-1.911.201-1.594-1.408-1.985-2.444z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#322070"
        d="M239.376 347.105c-.838.004-1.676.01-2.513.018.825-1.746 1.663-1.746 2.513-.018z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2D2373"
        d="M306.774 279.739l-.015 2.501c-.861-.079-1.25-.55-1.19-1.412.051-.762.541-1.016 1.205-1.089z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#38215D"
        d="M356.701 258.516c-.152.713.372 1.611-.552 2.088-.093.05-.512-.259-.565-.458-.246-.935.097-1.531 1.121-1.63h-.004z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#272A56"
        d="M186.939 242.29c-1.677-.199-1.129-1.51-1.243-2.49 1.679.199 1.124 1.512 1.243 2.49z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#381B76"
        d="M283.055 270.992c.832.002 1.664.004 2.496.008-.067.869-.54 1.258-1.406 1.203-.768-.05-1.018-.546-1.09-1.211z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B2754"
        d="M200.686 261c-.275 1.396-1.069 1.469-2.193.861.354-1.354 1.465-.618 2.191-.864l.002.003z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6F8F8"
        d="M402.851 208.591c-.002.207-.006.413-.01.621-.854.016-1.797.761-2.498-.209-.096-.133.459-.735.711-1.121l1.797.709z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2E1F7A"
        d="M342.926 223.648c-.104.372-.101.95-.667.755-.244-.083-.429-.627-.454-.973-.028-.37.062-.92.65-.777.457.11.488.576.471.995z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2C236C"
        d="M189.437 222.314l1.263.005-.093 2.48c-1.625-.248-1.034-1.538-1.17-2.485z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D4465B"
        d="M242.925 360.768c.064-.41.128-.82.191-1.234.2.021.4.029.602.021l1.855.055c-.257 1.816-1.604 1.142-2.648 1.158z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#172C75"
        d="M331.727 257.275c.419-.002.839-.005 1.258-.005-.122.978.433 2.291-1.245 2.495l-.013-2.49z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6E2462"
        d="M271.842 248.487l-.625-1.797c.023-.598.116-1.16.753-1.437 1.307.158.376 1.546 1.109 2.021l.028-.004-.077 1.29c-.397-.023-.792-.048-1.188-.073z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#521B55"
        d="M268.667 343.303l.742.131c-.59.969-1.446 1.359-2.563 1.182-.007-1.292.993-1.182 1.821-1.313z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#401E92"
        d="M193.219 248.517l-.091 1.297a5.362 5.362 0 00-.581-.037c-.405-.795-.764-1.599-.583-2.529.844.003 1.15.535 1.255 1.269z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#451F60"
        d="M352.978 223.567l.064.755c.302.373.309.777.137 1.203-.37.475-.778.858-1.445.552l-.039-.039c.006-.821.013-1.643.021-2.463l1.262-.008z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#491AC4"
        d="M193.2 249.776c1.106.487 1.295 1.428 1.231 2.493-1.716-.186-1.13-1.51-1.231-2.493z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#33206A"
        d="M285.09 266.245c-.46.607-1.125 1.125-1.572.631-.613-.678.234-.771.701-.828.259-.029.539.116.871.197z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4C1A58"
        d="M318.011 265.487c.002.199.019.398.051.595-.104.776-.528 1.173-1.326 1.137a1.54 1.54 0 01-.318-1.412c.406-.737.915-.946 1.593-.32z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#341C84"
        d="M290.552 204.854c-.351.836-.983 1.241-1.887 1.231-.608-2.309 1.242-.847 1.887-1.231z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B2660"
        d="M355.391 217.308c.185 1.01-.825 1.251-1.217 1.89-.911-1.478.171-1.673 1.217-1.89z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5C1744"
        d="M316.738 265.92l-.002 1.299-1.205.07c-.448-.025-.896-.052-1.343-.079-.105-.97.635-1.224 1.303-1.545.453-.106.877-.058 1.247.255z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B480FB"
        d="M370.469 168.562c-1.387-2.238-1.574-4.475.002-6.71 2.73-1.895 4.898-1.866 6.83.176 1.828 1.928 1.871 4.028.291 6.107-1.651 2.172-3.758 2.263-7.123.427z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#55A2CF"
        d="M544.471 289.742l-.254-.004-.252.004c-.014-.424-.023-.847-.037-1.271.137-1.067.893-1.371 1.775-1.229 3.18.521 5.619-1.191 8.168-2.601.25.243.377.537.385.886-2.154 3.107-2.17 6.638-2.002 10.206-.027.834-.047 1.673-.49 2.424a15.44 15.44 0 01-.373.342l-.621-.06c-1.607-2.762-.469-5.755-.75-8.612-.393-.021-.77.013-1.15.025-.844.027-1.68-.007-2.504-.146-.633-.122-1.266-.129-1.895.036z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#57A5D3"
        d="M553.922 285.31l-.051-.665c.199-4.55.563-4.905 5.049-4.916-.021.259-.045.52-.066.781-.68.545-1.654.725-2.049 1.63-.803 1.204-.65 3.274-2.883 3.17z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D9F6FA"
        d="M563.293 288.445c4.904-.778 2.486 3.004 3.066 4.921-.594 1.657-1.297 3.288-1.74 4.984-.305 1.15-.914 1.474-1.959 1.375-.391-.804.377-1.332.473-2.025 1.811-3.054 1.145-6.152.16-9.255z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E2F9FD"
        d="M563.885 298.421c-.408.435-.814.871-1.225 1.305-3.34.131-6.693.422-9.932-.774a.983.983 0 01-.287-.864.992.992 0 01.668-.616c3.08-.019 6.143 1.068 9.248.142.653-.194 1.196.199 1.528.807z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#50A0E6"
        d="M552.676 298.46c.021.164.037.329.053.491-.016.655-.029 1.312-.047 1.967l-.008 1.281c-1.67-.206-1.113-1.523-1.246-2.497-.01-.402-.023-.802-.037-1.204 0 .002.115-.109.115-.109.411-.306.801-.293 1.17.071z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FAFCFC"
        d="M563.885 298.421c-3.758.323-7.521.747-11.189-.604-.756-.387-.559-1.467-1.34-1.835-.07-3.782-.889-7.742 2.566-10.673 1.771-.663 1.479-2.612 2.377-3.818.896-.327 1.779-.355 2.643.115.928 1.139.496 2.544.752 3.814.428.981-.367 1.646-.635 2.447.373.184.746.37 1.119.557.822.894 1.652.857 2.492.023.207 0 .414 0 .623-.003 3.237 3.147 1.647 6.577.592 9.977z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5F99B2"
        d="M559.059 287.868c-.654-1.042.643-1.576.635-2.449.643.539.396 1.908 1.703 1.82-.602.873-1.525.543-2.338.629z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D9F6FA"
        d="M562.67 288.448c-.063.881-.529 1.292-1.414 1.228-.783-.058-1.021-.573-1.078-1.251.832.008 1.662.014 2.492.023z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#49A1F7"
        d="M547.678 299.741c.834-.011 1.67-.021 2.506-.03-.822 1.089-1.641 2.345-2.506.03z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BAECF9"
        d="M558.942 281.606c-.908.605-1.787.533-2.641-.115.424-1.434 1.486-1.213 2.553-.981.029.365.057.731.088 1.096z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C0E5F1"
        d="M548.889 289.194c.402-.004.805-.006 1.209-.011.617 3.068.676 6.134-.041 9.194-1.615.016-3.232.028-4.848.043-.16-.178-.211-.353-.158-.528.057-.176.109-.263.158-.263 3.721-1.229 3.709-1.229 3.434-5.438-.066-1.003-.435-2.046.246-2.997z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B2E3FA"
        d="M545.254 297.756c-.016.22-.031.442-.045.665l-.625-.009c-.037-2.89-.074-5.782-.113-8.67.223-.706.34-1.626 1.379-.681.137.76.148 1.525.146 2.296.031.809.031 1.615.041 2.424-.013 1.375.212 2.796-.783 3.975z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5E91A2"
        d="M550.057 298.378l.041-9.194c1.447.386.619 1.54.656 2.28.119 2.321.025 4.651.016 6.977l-.713-.063z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7335EF"
        d="M530.204 227.317c.014.394.031.787.049 1.181.369 1.901 3.006 2.704 2.453 5.053-.07.342-.273.554-.619.618-1.486-.604-2.414-1.765-3.141-3.13-.314-.662-.91-.922-1.568-1.089-1.834-.157-3.609 1.292-5.479.2-1.33-.795-1.031-1.833-.441-2.915a.828.828 0 00-.064-.562c1.049-.776 2.098-1.551 3.143-2.327 1.648.278 1.82-1.81 3.188-1.981 1.926-.31 2.852.383 2.436 2.424-.664.856-1.619 1.715.043 2.528z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#743BDC"
        d="M522.706 229.859c1.07-.49 2.518.458 3.414-1.143.303-.545 1.49.019 1.602 1.082-.35.476-.676.973-1.043 1.437-.406.451-.984.657-1.455 1.018l-2.529-1.02c-.345-.461-.353-.919.011-1.374z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7252AF"
        d="M522.706 229.859l-.012 1.372c-1.123-.419-2.631-.407-2.998-1.816-.33-1.266.816-1.732 1.762-2.179.146 1.003-.491 2.378 1.248 2.623z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7335EF"
        d="M525.223 232.252c.025-.809.471-1.185 1.254-1.208.416-.355.83-.377 1.236.014-.002.736.064 1.497-.719 1.942-.734.09-1.273-.283-1.771-.748z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6E429F"
        d="M527.723 222.367c-1.467 2.473-1.641 2.581-3.186 1.981.436-.454.869-.908 1.303-1.363.539-.396 1.025-.921 1.797-.767l.086.149z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F2E3F6"
        d="M527.637 222.219l-1.797.767c.543-1.057 1.234-1.91 2.57-1.885-.257.372-.513.745-.773 1.118z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2A2164"
        d="M570.153 201.1c-.826-.419-1.654-.838-2.479-1.258-.008-1.246-.012-2.491-.018-3.735l1.246-.002c-.484 1.892 1.747 3.102 1.251 4.995z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9F1F5"
        d="M562.661 247.28c.326-.637.5-1.407 1.385-1.536 1.127.055 2.266-.035 3.367.294 2.355 1.812 1.885 3.954.719 6.175-.857.055-.916-.624-1.092-1.192-.135-.156-.359-.151-.416.079-1.232 5.04-5.453 3.684-8.828 4.143-1.432-.489-2.352-1.422-2.563-2.964-.129-.712-.215-1.432-.395-2.13-.467-1.839.063-3.321 1.684-4.258 1.498-.864 3-.691 4.264.559.537.531 1.053 1.003 1.879.829.928.703-.502 1.378.109 2.367 1.185-.969.435-1.669-.113-2.366z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F2F3EF"
        d="M557.821 254.746c1.299-.963 2.535-1.431 4.145-.408 1.01.642 2.205 1.091 2.416-1.179.148-1.593 2.117-2.58 2.459-4.473 1.438 1.056.25 2.655 1.291 3.527-1.594 3.631-4.838 5.683-7.842 4.953a29.125 29.125 0 00-.418-.004c-2.038-1.226-2.038-1.226-2.051-2.416z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EE3E4B"
        d="M561.42 258.548c-.137.152-.252.404-.412.438-1.053.227-.641 2.697-2.32 1.69-1.809-1.087.102-2.249.215-3.389.422-.428.879-.345 1.352-.104l.035-.018c-.155.898.296 1.298 1.13 1.383z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F2F3EF"
        d="M567.413 246.038c-1.17.443-2.283.23-3.369-.295 1.088-.647 2.24-.218 3.367-.206.043.167.043.334.002.501z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FD3352"
        d="M552.678 254.77l-1.246.001c.66-2.03-1.4-4.601 1.238-6.236.365 1.265 1.717 2.194 1.268 3.734.344.321.393.713.273 1.146a2.795 2.795 0 01-1.533 1.355z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EC3F51"
        d="M553.932 253.52c.002-.418.004-.835.004-1.251.432.003.863.005 1.297.01l2.588 2.468 2.434 2.438-1.352.104-1.229-.021c.459-1.301-1.021-.648-1.26-1.249-.018-.813-.438-1.219-1.242-1.241-.441-.394-1.05-.621-1.24-1.258z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EE3E4B"
        d="M564.946 261.211c-.783 2.178-1.764 3.147-3.756 2.281-.688-.3-1.178-.729-.814-1.351 1.105-1.892 2.808-1.009 4.57-.93z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E84247"
        d="M570.084 258.638c-.057.76-.512 1.074-1.229 1.048-.949-.034-1.215-.637-1.104-1.456.107-.776.697-.954 1.361-.887.762.075 1.008.594.972 1.295z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EE3E4B"
        d="M556.415 256.018c.777.057 1.951-.285 1.26 1.249-.91-.548-1.441 1.923-2.346.374-.459-.786.054-1.523 1.086-1.623z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EE3D4C"
        d="M553.932 253.52c.809.027 1.225.444 1.24 1.257-.832-.135-1.672 2.533-2.494-.007.024-.813.446-1.225 1.254-1.25z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FB325F"
        d="M573.895 252.282c-.063.75.193 1.596-.51 2.229-1.098-.598-.592-1.512-.729-2.242l1.239.013z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FA3949"
        d="M352.963 244.763a.556.556 0 01-.056-.502c-.976-3.744-.443-7.563-.557-11.349-.038-1.277.431-2.261 1.748-2.54 1.885-.396 3.619-1.596 5.669-1.106 3.094 1.752 4.469 4.347 4.024 7.939-.101.825-.531 1.879.539 2.526.184.216.32.458.419.723.318 1.856-.032 4.005 2.21 5.015 1.084.836 1.525 2.098 2.146 3.238.375.394.75.787 1.123 1.181 1.666 1.036 2.682 2.206.824 3.973-.963.464-1.207 1.429-1.574 2.31-.379.638-.896 1.149-1.449 1.633-3.865 3.461-4.4 3.423-7.827-.518a47.285 47.285 0 00-2.309-2.474l-.029.039c-.524-.881-.824-1.892-1.56-2.648-.194-1.662-1.521-2.935-1.608-4.631.259-1.45-.853-2.056-1.733-2.809z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#322C58"
        d="M376.016 216.934c4.527-.882 8.955-1.841 13.652-.359 3.906 1.231 7.113 3.175 9.691 6.279-.979.16-.35 1.271-1.191 1.835-1.516-2.805-3.375-5.067-6.623-6.182-3.91-1.342-7.832-1.119-11.789-1.18l-3.722-.054-.018-.339z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#381E8C"
        d="M389.179 255.427l-.947 1.261c-2.49.093-4.992.391-7.465.047-1.201-.166-3.105.029-2.583-2.276 1.609-.383 3.214-.665 4.738.312.701-.096 1.621.059 2.07-.331 1.951-1.696 3.125-.735 4.187.987z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5A243A"
        d="M356.662 224.868c1.066-.233 2.321.39 3.188-.721 2.274-.507 4.105.392 5.772 1.814.217.484.188.943-.131 1.376a9.49 9.49 0 00-.043.606c-.346.313-.74.528-1.212.58-2-.042-3.69-1.099-5.523-1.693a6.029 6.029 0 01-.819-.338c-.592-.403-1.375-.663-1.232-1.624z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5E1FDA"
        d="M402.933 222.367l1.227.063c.076 1.066 1.031 1.501 1.631 2.158.619.674 1.045 1.322.598 2.178-.162.31-.623.626-.965.647-.986.06-.926-.906-1.256-1.486-.15-.256-.281-.524-.434-.821-1.371.417-.602 1.573-.906 2.32-3.102-1.752-.565-3.386.105-5.059z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#462464"
        d="M364.025 227.97l1.422-.026c.008 3.94.016 7.879.021 11.82.576.749.711 1.534.203 2.375-1.861.472-.75-1.366-1.414-1.824a.726.726 0 00-.122-.502c-1.176-2.759-.237-5.683-.665-8.498.285-1.095.363-2.23.555-3.345z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3E1F63"
        d="M365.4 242.336c.021-.857.045-1.715.068-2.572l2.467.034c.762.828.621 1.658.004 2.49-.988.154-1.012.426-.576 1.406.707 1.604 2.268 2.972 1.744 5.014-1.346-.415-1.414-1.967-2.402-2.699-.713-1.125-2.188-1.98-1.305-3.673z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#392C49"
        d="M365.49 227.337c-.025-.385-.053-.772-.078-1.16.721-1.454 1.631-2.79 2.529-4.138.416-.261.871-.39 1.355-.441.854-.065 1.643.082 2.289.697.457.105 1.111.048 1.018.743-.029.215-.605.356-.932.531a12.951 12.951 0 00-2.484 2.488c-1.271.315-2.162 1.729-3.697 1.28z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4D1D5F"
        d="M370.512 253.562c2.268-1.403-.15-2.451-.281-3.673l2.305-1.059c.684 1.093.248 2.333.418 3.468.301.295.482.648.533 1.069.033.419-.027.825-.172 1.221a2.653 2.653 0 01-.479.689c-.736.678-1.461 1.396-2.609 1.146a1.294 1.294 0 01-.658-.538c-.128-.953.185-1.729.943-2.323z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5E2EC4"
        d="M402.927 228.545c1.4-.601.641 2.819 2.809 1.388 1.152-.763 1.803-1.802 2.739-2.657.18.209.363.417.545.626l-.42 1.286c-.862 1.064-1.728 2.128-2.591 3.196-3.531.731-2.541-2.168-3.082-3.839z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#252860"
        d="M367.939 242.288l-.004-2.49c-.025-2.064.111-4.148-.133-6.186-.164-1.384.527-1.295 1.381-1.309.002 2.544.014 5.087-.006 7.632-.007.978.266 2.145-1.238 2.353z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#442E3A"
        d="M376.016 216.934c.004.113.012.227.018.34-.199.438-.398.877-.6 1.317-.766.698-1.193 2.11-2.689 1.272a2.472 2.472 0 01-.455-.882c-.229-1.349-.285-2.694.08-4.033.127-.329.342-.59.637-.785l1.105-.551c.632 1.107 1.269 2.214 1.904 3.322z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#341E6E"
        d="M371.68 242.288c-1.502-.208-1.232-1.373-1.238-2.351-.02-2.542-.004-5.085-.002-7.628.412-.332.824-.332 1.238 0 .002.415.004.831.008 1.246.964 2.912.97 5.823-.006 8.733z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B265E"
        d="M371.68 242.288l.006-8.733c1.794 1.695 1.791 7.049-.006 8.733z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2F2A5D"
        d="M399.214 242.335c-1.109 2.101-2.564 3.949-4.18 5.68-.803-.414-1.145-1.145-.449-1.733 1.547-1.309 2.459-3.378 4.629-3.947z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#381D87"
        d="M382.921 254.77c-1.668.001-3.332.001-4.996.003-.361.381-.795.406-1.264.254a1.52 1.52 0 01-.754-1.107c.057-.144.111-.287.17-.432 1.605.017 3.214.039 4.822.042.934.001 1.866-.021 2.022 1.24z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#311E7D"
        d="M369.188 226.058c-.229-1.885.539-2.775 2.484-2.488 2.017 3.67-1.121 2.192-2.484 2.488z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5D3327"
        d="M372.889 219.201l.076.65c.344.404.281.783-.072 1.142-.836.032-1.209.527-1.305 1.302l-2.338.04c-.246-.211-.346-.475-.275-.795.816-1.597 1.814-2.888 3.914-2.339z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2D2955"
        d="M372.893 220.994c.023-.38.049-.761.072-1.142l2.469-1.261c-.246 1.436.476 3.9-2.541 2.403z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B265E"
        d="M371.678 232.308h-1.238l-1.256-.004c.508-1.968 2.133-1.466 3.102-.96.941.491-.114.782-.608.964z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#381D87"
        d="M372.986 253.601l-.033-1.303c1.211-.044 2.455-.183 3.125 1.19l-.07.09c-1.002.867-2.01.762-3.022.023z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#262248"
        d="M427.344 282.274c-2.164 2.002-4.342 1.948-6.529.034.82-.798 1.455-1.134 2.725-.352.964.599 2.515.247 3.804.318z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#361D1F"
        d="M432.184 282.627c-1.387.807-2.709.785-3.947-.306 1.322.004 2.681-.451 3.947.306z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F67D1B"
        d="M392.837 342.23c-.838-.436-1.678-.869-2.52-1.301-.549-.279-1.049-.602-1.154-1.279l-3.787-3.66c-1.555-2.514-2.033-5.053-.178-7.645.402-.289.844-.346 1.311-.201.824.867 1.502 2.166 3.016 1.021.967-.232 1.863-.127 2.639.547.246.109.494.219.74.326 1.385.162 2.734.404 3.666 1.602.451.357.596 1.215 1.461.891.191.248.316.525.375.834.02.631-.055 1.221-.697 1.559-1.766-.125-3.488-.951-5.314.123-.957.563-1.943-.059-2.627-.982-.426-.572-.998-1.225-1.748-.496-.652.631-.189 1.314.191 1.93.586.898 1.701.932 2.484 1.51 1.084 1.482 3.703 2.275 2.209 4.916a.52.52 0 00-.067.305z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FDD9BB"
        d="M382.925 324.654l3.748 1.186c.691.111 1.232.389 1.301 1.186-.582.701-1.521.232-2.186.67-.611.08-.779 1.145-1.615.732-3.098-.004-6.197-.002-9.296-.02-.822-.004-1.773.049-1.84-1.125-.08-1.404.988-1.344 1.924-1.352 1.859-.02 3.72.006 5.58-.018.994-.011 2.173.265 2.384-1.259z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FDFBF2"
        d="M404.138 333.41c-1.027-1.58-3.23-2.291-3.344-4.557.514-.516 1.229-.584 1.668-.137 1.385 1.418 1.332.07 1.525-.74.117-.496.131-1.023.152-1.539.033-.879.117-1.725 1.301-1.676 1.191.049 1.16.953 1.182 1.793.018.621.01 1.244.012 1.863.713.738.791 1.645.695 2.592a3.333 3.333 0 01-.219.809c-.344.67-1.15 1.006-1.326 1.807a1.291 1.291 0 01-.471.57c-.626.09-.856-.416-1.175-.785z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5FBF8"
        d="M408.506 325.922c.316-1.357.951-2.672-.319-3.988-.576-.598-.553-1.764.17-2.221.901-.574 1.962-.727.78-2.045-.279-.313.236-.439.5-.377.607.141.697.662.756 1.184.801 1.502.803 3.107.582 4.738-.02.561-.225 1.049-.564 1.486l-.002.002c-.531.404-.252 1.43-1.172 1.537a.963.963 0 01-.731-.316z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5F3E3"
        d="M404.138 333.41c.439.23.879.463 1.318.695.584 1.74-.121 2.762-1.809 3.23-1.199-1.262-3.416-1.697-3.279-4.043.451-.279.873-.221 1.271.107.837-.756 1.657 2.56 2.499.011z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FCF0D1"
        d="M410.442 323.541c-.016-1.689-.033-3.379-.051-5.066.395-.395.924 2.027 1.232-.061l1.199-.01c.006.416.012.83.016 1.244l.01.006c-.486.805-.393 1.887-1.209 2.535l-.02-.027c-.503.365-.095 1.508-1.177 1.379z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DC9248"
        d="M385.378 327.115c.826-1.184 1.732-.01 2.596-.09l1.184.775c.207.336.154.629-.15.879-.848.467-1.631.357-2.352-.273-.416.006-.828.012-1.242.02-.366-.428-.342-.865-.036-1.311z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FCE7C0"
        d="M396.57 331.641c-1.223-.533-2.443-1.068-3.666-1.602 1.705-.57 3.4-1.117 3.666 1.602z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E1954A"
        d="M389.132 328.48c.01-.227.018-.453.025-.68 1.172.373 2.432.605 3.006 1.912-.99-.029-1.98-.063-2.969-.092-.351-.36-.417-.739-.062-1.14z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FEFEFE"
        d="M405.431 315.89c-.209 1.173.281 2.411-.902 4.118-.471-1.996-.719-3.194.902-4.118z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FDFBF2"
        d="M401.64 333.4l-1.42.117c-1.061.734-1.738.131-2.359-.674a.39.39 0 01.17-.313c1.429-.657 2.711-.686 3.609.87z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5F3E3"
        d="M406.697 331.658l-.063-3.24c.391-.023.781-.049 1.172-.072.117.109.232.221.352.33.393 1.424.185 2.556-1.461 2.982z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5F3E3"
        d="M408.506 325.922c.242.014.486.025.73.039.305.363.406.785.352 1.25-.219.789-.633 1.355-1.552 1.334 0 0-.23-.197-.23-.199l.7-2.424z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D7F6FC"
        d="M355.458 337.162l-2.503-.004c-3.324.99-6.65.975-9.977.01-.833-.117-1.678 1.48-2.502-.014-.184-.371-.151-.719.095-1.051 1.123-1.244 2.64-.988 4.066-1.055 3.72-.174 7.46.342 11.158-.33 3.38-.59 3.349-.584 2.812-4.068-.244-1.59-.654-3.236.479-4.705 2.582 2.561.839 5.809 1.383 8.691-.453 2.227-2.643 3.331-5.011 2.526z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3B84B5"
        d="M353.646 312.172c2.27 3.348 3.779 7 4.392 11.008.278 1.252.388 2.512.182 3.785-1.326 1.088-2.079.098-2.099-.938-.076-3.953-2.367-7.154-3.398-10.771-.287-1.003-.582-1.975-.005-2.965.271-.32.581-.358.928-.119z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EBF4F4"
        d="M355.458 337.162c2.181.174 3.808-.756 5.011-2.525.832-2.285 1.65.225 2.479.006l-.002.02c.368.414.368.832 0 1.246-1.317.035-1.891 1.041-2.607 1.916-.843 1.029-1.744 1.813-3.301 1.887-2.393.114-2.925-.534-1.58-2.55z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4A86AF"
        d="M357.924 327.203c.036-1.34.075-2.68.113-4.021.349.92.7 1.842 1.048 2.764.176 1.951.255 3.918.546 5.852.415 2.748-.409 4.156-3.405 3.576-1.534.268-3.064.488-4.565-.154-.13-.354-.043-.646.257-.871.268-.174.564-.295.877-.365 1.479-.432 3.205.461 4.518-.838.618-1.941-1.002-4.113.611-5.943z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F1E7D9"
        d="M368.588 322.139c-2.375-.463-2.145 1.033-1.904 2.537-.209-.221-.482-.404-.615-.662-.67-1.295-1.329-3.063-.096-3.859 1.039-.673 1.857 1.091 2.615 1.984z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4380AB"
        d="M353.646 312.172c-.244.02-.486.039-.729.056-2.235.284-1.468-1.262-1.44-2.357l.321-.27 1.123.811.725 1.76z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F8D9B5"
        d="M434.836 293.086c-2.154-.402-5.402-.135-6.27-1.189-2.127-2.58-4.605-1.761-7.008-2.282-2.043-.445-1.24-2.371-1.006-3.622.227-1.213 1.227-1.624 2.322-.631.984.892 1.715.402 2.725-.152 2.281-1.258 7.705.167 9.289 2.167.85 1.076-.529 2.76 1.043 3.597.342.367.406.742.033 1.129-.376.329-.751.656-1.128.983z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#241D52"
        d="M422.87 303.414c-1.301-1.136-1.875-2.221-.689-3.975 1.334-1.969 2.332-.274 3.357.066 2.387.789 4.676 1.938 7.309 1.452.383.364.488.817.439 1.322-.213.855-.746 1.396-1.594 1.637a2.472 2.472 0 01-1.346-.133c-1.498-1.271-2.893-.563-4.283.239-1.154.262-2.266.296-3.193-.608z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EEBB84"
        d="M431.495 303.439l1.393-1.127c1.5-1.853 2.699-4.014 5.064-4.991a.62.62 0 01.434.063c-.029 1.885 1.094 2.866 2.707 3.468-.828 1.02-2.506 1.086-2.9 2.593-.879 1.792-2.875 1.758-4.342 2.539-1.389.735-1.723-.943-2.42-1.707a.968.968 0 01.064-.838z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#412934"
        d="M431.495 303.439c.02.225.037.449.057.676.236.3.223.584-.045.858-2.377 1.352-4.783 2.192-7.342.428-.572-.381-1.141-.762-1.711-1.138-.141-.253-.283-.508-.428-.762l.844-.088 3.744.032c1.219-.824 2.451-.809 3.695-.058.397.018.793.036 1.186.052z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E0CDCB"
        d="M437.329 286.797c2.074-1.263 2.98-.64 2.494 1.693-.268 1.284-.891 2.492-1.354 3.733-.605.334-1.227 1.348-1.793-.038-.113-.923-.068-1.849-.08-2.775.102-.913-.271-1.957.733-2.613z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#301C32"
        d="M437.952 297.321c-2.049 1.299-2.217 4.503-5.064 4.991-.016-.451-.027-.903-.041-1.354.159-3.376 3.132-2.807 5.105-3.637z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#22235D"
        d="M429.045 297.007c2.264-2.385 5.068-.233 6.982-1.804-1.579 2.963-4.194 1.603-6.982 1.804z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C3BBDA"
        d="M425.331 296.049c.637-.064 1.271-.129 1.91-.19.775.494.607 1.031-.121 1.245-1.281.376-2.578.275-3.77-.433.5-.721 1.414-.115 1.981-.622z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E4CEB5"
        d="M437.127 289.521c.014.916.391 1.894-.451 2.664-.238-.028-.473-.054-.711-.084-.01-.376-.021-.753-.033-1.129.035-.67.072-1.338.109-2.007.502-.089.803.213 1.086.556z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D7CFEA"
        d="M425.331 296.049c-.502.712-1.311.447-1.98.622-.793-.115-1.652-.015-2.277-.688 1.432-.893 2.833.273 4.257.066z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#32241F"
        d="M437.127 289.521c-.361-.186-.725-.37-1.086-.556l.139-2.402c.447-.24.904-.528 1.148.233-.066.907-.132 1.816-.201 2.725z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E29950"
        d="M385.378 327.115c.014.438.023.873.035 1.311-1.846 2.512-.043 5.041-.037 7.564-3.563-2.02-1.252-4.973-1.203-7.563.403-.437.805-.874 1.205-1.312z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EEFDFC"
        d="M385.423 338.367c-.262 1.393-1.246 1.721-2.096.846-.861-.887-.453-1.846.912-2.088.8.029 1.167.467 1.184 1.242z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FCF1DF"
        d="M371.668 329.678c-1.746.049-2.85-.705-3.104-2.506l1.877 1.236c.577.26 1.012.656 1.227 1.27z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FDF5E0"
        d="M389.164 339.65c.572.254 1.105.547 1.154 1.279-.385.195-.771.393-1.16.592-.377-.639-1.326-.879-1.279-1.818.429-.017.857-.037 1.285-.053z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7F1CE"
        d="M416.434 312.035c-.891.584-1.098 1.493-1.166 2.467l-2.426 3.873c-.723-2.299 1.502-3.984 1.289-6.178 2.252-.248 1.688-3.292 3.725-3.754-.473 1.199-.949 2.394-1.422 3.592z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7DCB9"
        d="M347.959 299.7c-1.114.471-1.348 1.592-1.856 2.51l-.011.006c-.331.219-.625.176-.882-.126-.71-1.245-.62-2.546-.268-3.863 1.444-3.081 1.561-6.386 1.607-9.706.334-.563.855-.859 1.459-1.046.475-.086.924-.021 1.332.252.689.777.422 1.744.52 2.641-.182 1.49-1.469 2.986.01 4.475.087.933-.908 1.102-1.232 1.741-.045.693-.092 1.385-.646 1.904l-.033 1.212z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8D2C3"
        d="M349.861 290.367c-.928-.64-.563-1.626-.664-2.486 1.364-.607 1.625.054 1.428 1.243l-.764 1.243z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6B5C72"
        d="M350.625 289.124c.039-1.008-.41-1.45-1.428-1.243-.386-.064-.771-.13-1.156-.196-.201-.327-.137-.591.195-.787.813-.368 1.56-.283 2.225.335.244.199.49.396.736.595-.192.432-.381.863-.572 1.296z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#611BEC"
        d="M376.693 254.757c.412.007.822.011 1.232.016 2.47 2.121 5.404 1.234 8.146 1.066 1.053-.065 1.707-.152 2.162.847-.857 1.041-1.713 2.078-2.568 3.118-2.172.937-3.707 2.64-5.238 4.347a4.05 4.05 0 01-1.859 1.883c-1.052.53-2.082-1.461-3.142-.03-2.066.488-3.473-1.93-5.578-1.269-2.74-1.946-.563-3.856.035-5.78.146-.263.348-.483.592-.661.402-.16.807-.16 1.197.02 1.348-.085.057-1.077.484-1.479.066-.764.227-1.489.752-2.085l.01.007c1.26-.874 2.518-.687 3.775 0z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6227CF"
        d="M380.427 264.15c.723-2.681 2.162-4.499 5.236-4.347l-4.471 5.179-.765-.832z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#19142E"
        d="M414.93 278.471c-.771-.776-.924-1.596-.17-2.478.432.8 1.637 1.547.17 2.478z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EABA67"
        d="M460.364 315.21c-.043.277-.086.554-.127.83-.461.304-.932.271-1.406.034-1.219-1.042-2.176-2.161-1.117-3.861.451-.309.891-.411 1.291.077.454.973.906 1.946 1.359 2.92z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9F0CA"
        d="M455.446 308.296c.375.049.746.099 1.121.147.426.611.852 1.226 1.277 1.838.27.267.26.525-.025.776-1.633-.111-2.637-.819-2.496-2.618l.123-.143z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FBF2D2"
        d="M457.786 311.002l.059-.721c.807.428 1.27 1.052 1.16 2.009-.379-.045-.758-.093-1.139-.14-.096-.113-.189-.227-.283-.34a.923.923 0 01.203-.808z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FA9E09"
        d="M442.817 318.436c-1.387-1.109-2.912-2.104-3.342-4.005-.109-.479-.424-1.129-.229-1.42 2.715-4.03-.547-3.2-2.652-3.313-.08-.111-.162-.225-.244-.336-.018-1.615 1.854-1.938 2.234-3.282.154-.235.336-.449.533-.65 1.424-.819 1.508-2.676 2.789-3.608.77-.144 1.494.075 2.225.263l1.172.161 1.203 1.328c-.002 1.756-2.131 1.849-2.547 3.281-1.34 3.394.051 6.889-.408 10.313-.107.502-.314.945-.734 1.268z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FCBC5E"
        d="M444.131 302.083c-.846.045-1.691.09-2.537.138-.951 1.163-1.441 2.64-2.506 3.73-.494.41-.955.302-1.402-.084-.58-.845-.475-1.646.156-2.415-.475-2.809 1.559-2.489 3.25-2.601 1.178.004 2.178.445 3.039 1.232z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5F6EC"
        d="M345.463 302.173c.21.016.419.03.629.043-.097.478-.685 1.346.528.952 1.186-.387 1.889.167 2.595.918.011.909.005 1.806-1.253 1.863a1.154 1.154 0 01-.898.299c-1.16-.198-2.344-.365-2.777-1.732-.049-1.003-.381-2.15 1.176-2.343z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4380AB"
        d="M347.294 305.883c.223.021.445.045.668.066 1.279 1.215 2.988 1.98 3.835 3.651l-.167.176c-.672.584-1.457.65-2.291.509a2.866 2.866 0 01-1.587-.956c-.492-1.267-1.94-1.782-2.429-3.06.504-.915 1.233-.671 1.971-.386z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FDAD2C"
        d="M442.852 317.141c.23-3.732-1.363-7.565.619-11.202.764-.505 1.566-.435 2.293-.005 1.475.878 1.633-.37 2.066-1.206 1.506-.379 2.34 1.177 3.676 1.279.67.706 2.023.984 1.525 2.422-1.721 1.287-.279 2.063.539 2.807.838.757 1.541 2.604 3.051.723.447-.165.861-.117 1.229.197 0 0 .016-.003.016-.005-.59 1.574.902 2.486 1.199 3.778-.367 1.421-.826 2.888 1.439 3.089.43.104.771.363 1.104.631.193.002.383.012.572.031.926 1.092.887 2.703 2.002 3.689l1.037.188c.047.533.098 1.064.145 1.596.543 2.291 1.855 4.215 2.971 6.236.391 2.377.963 4.764-.578 6.975-1.67 2.086-3.338 4.174-5.01 6.26h-6.969c2.811 1.508 2.143 3.184.775 4.977-1.598 1.717-4.783 1.881-4.924 5.025-1.271.059-2.561 2.629-3.811-.029-.818-.475-1.291-1.871-2.625-.982-.762.002-1.404-.211-1.738-.973.004-.178.01-.352.023-.529 1.24-1.656 2.48-3.311 3.725-4.963.064-.396.297-.682.598-.92.654-.459.717-1.313 1.246-1.857 1.262-.514 2.473-1.168 3.855-1.338 1.742.039 3.455-.721 5.219-.16.389.068.186-.26.033-.195-.465.186-1.027.031-1.414-.352-.682-.668-.459-1.264.205-1.811.682-.561 1.76-.703 1.996-2.07-1.59.266-2.086 2.037-3.488 2.262-.645.068-1.209-.047-1.549-.678-.109-1.359.789-2.211 1.57-3.119.588-.605 1.262-1.107 1.967-1.563.742-.516.596-.986-.084-1.424-.926-.623-1.801-1.289-2.275-2.346-.605-.578.93-1.322-.158-1.863-.641-.496-1.436-.658-2.119-1.051-.758-.609-1.711-.795-2.584-1.164-2.051-1.402-3.52-3.377-5.133-5.207-1.25-1.501-1.582-3.398-2.236-5.153z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E4BD63"
        d="M452.813 308.439c.146-1.123-1.313-1.387-1.307-2.433l.754-.095c1.023.841 2.043 1.684 3.063 2.527.822.854 1.643 1.707 2.463 2.563l.064 1.153c-.426.013-.852.023-1.277.036-1.678-.825-3.75-1.254-3.76-3.751z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FAB021"
        d="M447.831 304.728c-.209.888 1.406 1.414.717 2.107-.73.729-2.01.616-2.869-.016-.699-.513-1.328-.937-2.207-.881l3.037-2.366c.687.101 1.06.565 1.322 1.156z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5E9D9"
        d="M347.992 298.487c-.02-.715-.154-1.468.646-1.904.715.465.537 1.198.566 1.868l-1.212.036z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8BA62"
        d="M467.756 338.363c.012-2.477.021-4.955.033-7.434-.369-.471-.328-.924.059-1.359.406.445.814.889 1.223 1.332.93 3.119 1.18 6.143-1.258 8.777-.02-.437-.039-.876-.057-1.316z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E9B051"
        d="M467.848 329.57c-.018.453-.039.906-.059 1.359-1.904-1.465-2.689-3.4-2.426-5.775.801 1.094 1.605 2.186 2.408 3.281l.077 1.135z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FADAA7"
        d="M443.456 352.641c.625.24 1.248.479 1.873.717.584.27.977.711 1.182 1.32-.09 1.033 1.371 1.27 1.207 2.338l-1.201 2.529c-.498.984-1.693.73-2.398 1.352l-1.27 1.229c-2.777 1.262-5.152.313-7.402-1.338-.533-5.342-.363-5.59 5.006-6.262 1.354-.169 2.258-.846 3.003-1.885z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EEB713"
        d="M446.51 354.678c-.723-.145-1.111-.59-1.182-1.32.07-.879.568-1.281 1.422-1.174 1.67.205.273 1.799 1.068 2.412l-1.308.082z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5B03C"
        d="M464.182 323.369c-1.779-.625-1.951-2.125-2.002-3.689.207-.014.414-.014.623 0 .52 1.209 1.432 2.267 1.379 3.689z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F8B11F"
        d="M460.297 319.68c-.93-.119-2.236.381-2.41-1.125-.119-1.02-.521-2.346 1.178-2.626.393.036.783.072 1.172.111.025.384.053.769.078 1.155.541.834.684 1.662-.018 2.485z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5B03C"
        d="M460.297 319.68c.004-.828.01-1.656.018-2.484 1.107.461 1.281 1.416 1.293 2.453-.436.009-.875.021-1.311.031z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6EDEE"
        d="M553.944 204.859c-1.393-1.961-2.9-3.913-.445-6.15l1.506-.04c.949.556 1.898.538 2.848.005a.457.457 0 00.445-.08c1.912-.865 2.742.357 3.463 1.795-.172 1.78-.398 3.537-2.313 4.41-1.819 1.439-3.649 1.784-5.504.06z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DD4C5B"
        d="M561.329 200.614c-.689-1.155-1.602-1.976-3.031-2.021-.203-.41-.406-.819-.607-1.228l2.471-.008c.758.711 1.922 1.149 1.697 2.521a1.363 1.363 0 01-.53.736zM557.852 198.673c-.951 1.664-1.898 1.001-2.848-.005l2.848.005z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D9455D"
        d="M561.329 200.614c.047-.273.094-.547.139-.82.416-.32.811-.312 1.186.071.125 1.873-1.521 3.678.266 5.783-1.59.128-2.359-1.133-3.471-.849.993-1.232 1.727-2.578 1.88-4.185z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EC3C4F"
        d="M562.653 199.865a445.05 445.05 0 01-1.186-.07c-.434-.813-.871-1.626-1.307-2.438 1.84-.166 2.298 1.039 2.493 2.508z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6F38F6"
        d="M532.086 234.169l.619-.618c.926.416 1.277-1.617 2.289-.554.197.207.189.905-.008 1.136-.907 1.068-1.921.822-2.9.036z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7139C6"
        d="M527.713 231.059l-1.236-.014c.002-.828.441-1.217 1.244-1.247.789.038 1.229.422 1.225 1.242-.412-.047-.832-.673-1.233.019z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7139D7"
        d="M530.204 227.317l-3.172-.165c1.314-1.014 1.854-2.11 3.129-2.362.011.844.027 1.686.043 2.527z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6E38FE"
        d="M538.922 223.501l-1.207.042c-.43-.733-.328-1.222.607-1.33.471.303.628.752.6 1.288z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D8ECF5"
        d="M586.379 207.408l-.625.546c-1.736-1.815-2.775-3.769-1.229-6.23-.551 2.811.246 4.826 3.258 5.542-.464.046-.933.093-1.404.142z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3191E4"
        d="M588.825 203.439c.012.678-.184 1.227-.957 1.321-1.068.131-1.5-.447-1.48-1.438.014-.606-.041-1.321.941-1.101.693.155 1.472.229 1.496 1.218z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F3B04B"
        d="M444.118 360.896c.58-.842 1.461-1.148 2.4-1.352-.053 1.778-1.422 1.216-2.4 1.352z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DF9E66"
        d="M393.007 388.904c.668-.703 1.537-.555 2.373-.568.387.412.387.832.035 1.262l.002.008c-.627.367-.744 1.486-1.801 1.221-.126-.665.065-1.432-.609-1.923z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECA12D"
        d="M393.617 390.826c.576-.445.83-1.359 1.801-1.221-.01.82-.02 1.645-.027 2.469v-.01c-.402.381-.809.383-1.227.027-.172-.201-.348-.402-.521-.604l-.026-.661z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EC9F30"
        d="M395.416 389.598c-.01-.42-.023-.84-.035-1.262.363-.031.729-.061 1.092-.094.926-.209 1.861-.633 2.732.146-.119.408 1.396.861.094 1.131-1.245.256-2.585.071-3.883.079z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E3AA44"
        d="M399.205 388.389c-.91-.051-1.82-.098-2.73-.146.695-.826 1.758-.807 2.662-1.146.834-.008 1.67-.02 2.508-.029-.014.414-.029.828-.041 1.24-.802.024-1.599.051-2.399.081z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F1A117"
        d="M406.369 391.23c-.086.719-.514.775-.912.787-.887.025-1.301-.449-1.248-1.326.025-.445.318-.938.697-.74.588.307 1.033.887 1.463 1.279z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECA705"
        d="M394.164 392.092l1.227-.027c.404 4.145-.748 8.354.826 12.477.691 1.809-1.154 1.023-1.939 1.27-.036-4.574-.075-9.148-.114-13.72z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E4EDF1"
        d="M362.945 335.908v-1.246c4.866.258 9.688-.416 14.534-.594 3.632-.135 3.904.328 2.974 3.971-.354 1.391-.85 2.744-1.279 4.113-1.384-1.234-.109-2.492-.002-3.725.176-2.033-.127-3.162-2.705-3.227-4.543-.114-9.006.736-13.522.708z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FB7C14"
        d="M392.904 341.924c.564-2.322-2.199-2.895-2.506-4.76-.598-.877-1.875-.41-2.488-1.256-1.715-.297-1.205-1.613-1.176-2.658.021-.74.592-1.033 1.266-1.049.996-.02 2.123-.271 2.402 1.197.232 1.232 1.246 1.639 2.008.945 2.051-1.869 3.719-.492 5.504.311 2.154-.121 3.74.979 5.176 2.398 1.219 1.666 2.525-1.211 3.752.074.643.613.564 2.123 1.681 1.963 1.324-.191.73-1.703 1.156-2.533 1.381-2.68-.012-4.914-.949-7.244.17-.951.572-1.504 1.619-.945.92.834.92.834 2.186-.854-1.031 3.559 3.18 6.678.521 10.434-.537.758.002 1.576 1.063 1.729.002.207.016.41.043.615-.406.625-1.355.912-1.184 1.898-.846.82-1.693 1.643-2.539 2.461-.496.359-1.211.432-1.578.893-2.04 2.557-4.616 2.582-7.417 1.686l-.221.002-.189-.111c-1.527-.713-2.873-1.762-4.428-2.428l-.018.012c-.315-2.136-1.997-2.462-3.684-2.78z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DF8F42"
        d="M401.443 347.229c2.51-.127 5.168.309 6.946-2.268.27-.387 1.346-.221 2.047-.311a6.23 6.23 0 01-.053.613c-1.059 1.031-2.12 2.061-3.179 3.09-1.428-.014-2.855-.029-4.281-.045-.496-.359-.986-.72-1.48-1.079z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E29152"
        d="M396.605 344.691c2.139-.4 3.254 1.07 4.428 2.428-1.912-.014-3.352-.887-4.428-2.428z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F87F10"
        d="M445.344 322.15c2.035 1.32 3.48 3.229 5.023 5.041.326.434.324.906.164 1.396-1.318 3.066-.207 6.328-.76 9.453a3.462 3.462 0 01-.299.861c-.477.744-1.189 1.27-1.791 1.898-.74.521-1.084 1.744-2.348 1.357-1.211.621-1.668 2.189-3.127 2.498-1.053-.166-2.254.406-3.127-.641-.498-.625-.5-1.246.016-1.863.408-.006.816-.01 1.227-.014 1.26-.695 1.967-1.834 2.504-3.111.049-1.666 1.754-2.018 2.494-3.137 1.133-1.018.303-2.508.873-3.664.803-1.871.234-3.51-.865-5.057v.002c-.432-1.521-.877-3.043-.355-4.637.123-.124.246-.253.371-.382z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F78207"
        d="M445.329 327.17c.232-.189.555-.59.676-.535 1.041.459 1.449 4.73.568 5.537-.412.361-.82.359-1.225-.008-.006-1.664-.014-3.328-.019-4.994z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F3A115"
        d="M421.616 307.196c.217-1.703 1.588-1.074 2.553-1.263 1.502-.764 1.305.67 1.719 1.318.355.735.865 1.38 1.232 2.104.215.516.482 1.029.115 1.583-1.566.242-2.125-.859-2.551-2.011-.551-1.485-1.617-1.912-3.068-1.731z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F8AC34"
        d="M427.235 310.939l-.617-1.264c2.424-.691 5.152-.073 7.357-1.716.484-.063.943.015 1.363.278.348.385.416.827.281 1.315-.664.979-1.611 1.405-2.775 1.398l-1.23.014c-1.258 1.131-2.518 1.123-3.779.006-.2-.013-.401-.024-.6-.031z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FD9A09"
        d="M431.6 348.393c-1.791 2.162-4.209 3.176-6.867 3.742 1.892-1.973 3.633-4.233 6.867-3.742z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F18E13"
        d="M442.852 317.141c1.193 1.488 1.992 3.178 2.492 5.01l-.016.039c-1.314-.5-.65 1.008-1.25 1.234-1.639-1.354-1.164-3.246-1.262-4.988.013-.432.026-.866.036-1.295z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FA9E09"
        d="M432.844 310.952c.625-.819 1.504-1.146 2.482-1.278.424-.35.842-.35 1.258.015l.01.009c-1.002 1.158-1.385 4.166-3.75 1.254z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FE960F"
        d="M439.096 342.152c-.008.621-.012 1.24-.016 1.863-1.037.42-2.074.84-3.111 1.258-.16-.139-.213-.277-.16-.418.055-.141.105-.211.158-.211.735-1.214.938-3.101 3.129-2.492z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FE990C"
        d="M435.967 344.645c0 .211 0 .42.002.629-.781 1.158-1.541 2.34-3.123 2.494.086-1.993 1.135-3.028 3.121-3.123z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F48905"
        d="M442.827 339.027c.117 1.803.15 3.535-2.504 3.111.176-1.566 1.344-2.333 2.504-3.111z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F78207"
        d="M444.079 323.424c.057-.777-.285-1.957 1.25-1.234v4.982c-.914-1.082-1.192-2.379-1.25-3.748z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EB8A1C"
        d="M445.348 332.164l1.225.008c-.422 1.238 1.029 3.107-1.252 3.719.008-1.243.017-2.483.027-3.727z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F3A115"
        d="M427.834 310.972a6.257 6.257 0 003.779-.006c-1.253 1.892-2.515 1.894-3.779.006z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E18836"
        d="M406.619 337.135c-1.254-.172-2.477 2.977-3.756.033.258-.297.549-.336.875-.111.758-.877 1.42-1.807 1.717-2.951.002 0-.014-.02-.014-.02.318-.668.34-1.496 1.068-1.936a.456.456 0 00.188-.492c.678-.939 1.291-1.904 1.34-3.113.38-.455.757-.914 1.136-1.369.371-.371.752-.377 1.145-.033l.031 1.225c-.795.068-1.191.51-1.213 1.303-.239 2.688-.553 5.354-2.517 7.464z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DB9249"
        d="M410.317 327.143c-.381.01-.762.023-1.145.033l.064-1.215c.391-.42.779-.84 1.172-1.26-.029.813-.06 1.627-.091 2.442zM410.442 323.541c.393-.459.783-.92 1.178-1.379-.094.992.469 2.299-1.209 2.537.009-.385.021-.773.031-1.158z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E38A31"
        d="M411.639 322.189c.047-1.016.35-1.906 1.209-2.535-.015 1.03.486 2.307-1.209 2.535z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9A100"
        d="M445.334 342.158l1.873-1.877c.947.4 1.264 1.207 1.387 2.139-.014 1.412.119 2.852-.748 4.109-.213.205-.43.41-.643.617-2.518.107-4.338-.186-2.055-3.211.308-.408.134-1.175.186-1.777z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F0BF8C"
        d="M425.342 307.202c-.527-.295-.055-1.521-1.174-1.269a1.289 1.289 0 01-.004-.532c2.543.406 5 .147 7.357-.927.313 2.602-2.125 2.914-3.502 3.994-1.296 1.023-1.872-.611-2.677-1.266z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CC244D"
        d="M298.66 428.496l-41.905-.031a17.504 17.504 0 00-.425-.182c-.77-.85-3.058-.965-1.438-2.975.893-.279 1.745-.094 2.594.197 1.69.574 3.435.656 5.198.652 11.56-.033 23.119.041 34.675-.051.898.08 1.822.055 2.654.496 1.387 1.195-.177 1.199-.667 1.641-.228.085-.457.167-.686.253z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#331C74"
        d="M312.389 425.785l1.899 1.865c-3.729 1.346-7.576.334-11.36.582-.314-.518-.252-.994.152-1.438 1.078-.725 2.312-.564 3.507-.607 1.945.043 3.89.077 5.802-.402z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#700E42"
        d="M303.09 427.084l-.161 1.148c-1.195.002-2.391.008-3.584.012l1.181-1.215.268-.313c.738-.393 1.482-.756 2.342-.361.163.252.139.497-.046.729z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#46A1E5"
        d="M315.544 367.051c-.279-.408-.664-.447-1.097-.305-.73-.078-1.357-.342-1.772-.986-.391-.865-.366-1.705.163-2.512 1.906-1.158 3.769-2.51 6.202-1.49.44.301.569.732.513 1.238-1.406 1.254-2.468 2.727-2.793 4.641-.405-.194-.809-.389-1.216-.586z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#45A0ED"
        d="M316.759 367.637c-.165-2.006-.398-4.053 2.496-4.271l.357.371c.55 1.186.503 2.316-.342 3.363-.206.197-.413.393-.617.59a1133.7 1133.7 0 00-1.894-.053z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DB465F"
        d="M313.12 365.793c.578.127 1.139.275 1.327.949-.554 5.926-1.472 11.848-.179 17.791l-.19 1.359c-.146.387-.357.736-.829.613-.308-.08-.387-.367-.248-.674-.002-4.93-.092-9.859.04-14.783.05-1.908-.271-3.59-1.29-5.166.435-.366.891-.392 1.369-.089z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D8283A"
        d="M315.443 419.422c.199.035.4.068.602.09-1.574 1.834-4.447 1.646-5.844 3.754-.55.572-1.189.582-1.876.309-.521-2.135.575-3.57 3.489-5.021 1.574-.784 2.718-.679 3.629.868z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#262646"
        d="M308.075 423.334c.707-.021 1.415-.047 2.124-.068.524.625 1.048 1.25 1.571 1.871-1.047 2.352-3.016.885-4.577 1.109-.558-.227-.779-.67-.796-1.244.082-.754.529-1.24 1.177-1.576.165-.031.333-.063.501-.092z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2C225E"
        d="M306.803 425.797c1.645-.303 3.453.629 4.966-.66.206.217.412.434.619.648-1.472 2.24-3.742.863-5.623 1.242-.369-.422-.317-.83.038-1.23z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F51E2C"
        d="M315.443 419.422c-2.779-1.123-5.45.295-7.368 3.912l-.022-.004c-.738.41-1.522.658-2.372.662-.483-.035-.934-.174-1.319-.457-2.236-1.676-4.586-.516-6.891-.205-.46.063-.887.457-1.399.547-2.569.641-5.18.344-7.77.357-8.623.043-17.246-.002-26.219.025 1.495.797 2.759.541 3.971.547 7.796.027 15.593.012 23.39.014 2.079.002 4.12-.109 6.174-.621 2.432-.611 2.997.16 2.407 2.797-12.819.014-25.639.037-38.458.02-1.033 0-2.404.477-2.746-1.211-.758-.916-2.294-.902-2.686-2.25-.015-.768-.698-.973-1.162-1.367-.331-.092-.117-1.76-.988-.322-.304.5-.797.859-1.355 1.102-.447.123-.861.061-1.238-.213l-.031-.209c.333-1.309-1.229-1.742-1.316-2.854-.415-.891-.68-1.775.054-2.641.42-.006.84-.012 1.26-.021.697-.682 1.57-1 2.495-1.215 3.412-.424 6.081-2.615 8.997-4.076 10.263-5.141 20.529-10.27 30.833-15.33 4.617-2.268 9.157-4.701 13.849-6.826.822-.43 1.798-.549 2.489-1.242l.006-.004c.976-.568 2.229-.451 3.11-1.256h-.001c2.891-1.424 2.082 1.639 3.066 2.527l.068 12.447c-1.373 2.707-.066 5.705-1.065 8.453.938-2.754-.28-5.742 1.065-8.453.379.037.757.074 1.135.109.04 3 .074 5.996.123 8.992.021 1.316-.055 2.559.846 3.803 1.167 1.613-.1 3.07-.932 4.463z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ED2236"
        d="M314.203 389.607c-1.675-.049-.825-3.164-3.066-2.527.352-.818.977-1.229 1.864-1.248.323.654.71.193 1.078.061l.246 2.391-.122 1.323z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BBDFF3"
        d="M331.747 362.123l-.015-1.26c-.873-.969-.828-2.104-.61-3.273.178-.76.46-1.49.702-2.232.254-.703.477-1.42.703-2.135.974-2.014.932-4.477 2.7-6.143.729-.285 1.183.037 1.491.68-1.75 4.756-2.506 9.855-4.971 14.363z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B2DEF7"
        d="M336.718 347.76c-.402-.205-.803-.408-1.205-.611-.91-3.037 1.291-5.4 1.746-8.143.084-.289.192-.566.311-.844.381-.803.605-1.736 1.617-2.039.471-.074.898.014 1.256.35.01.227.023.453.033.682l-.004.006c-.561.977-.736 2.107-1.228 3.111l-2.526 7.488z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F1F3F1"
        d="M342.978 337.168c3.326-.004 6.65-.008 9.977-.01-.103.855-.595 1.242-1.448 1.238-2.357-.008-4.715-.008-7.072-.002-.848.004-1.352-.363-1.457-1.226z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D7F6FC"
        d="M339.245 340.271c-.054-1.219.25-2.299 1.228-3.111.055 1.221-.266 2.293-1.228 3.111z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F3DEC0"
        d="M331.759 357.033c-.008 1.277-.02 2.553-.027 3.83l-2.518 1.314a1.552 1.552 0 01-.835.311c-.974-.141-1.724-.582-2.073-1.557a2.061 2.061 0 01.137-1.313c.238-.328.569-.771.927-.67 2.532.725 1.364-.725 1.021-1.691-.096-.615.152-1.086.627-1.457.838-.365 1.504.266 2.257.4.362.159.682.347.484.833z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#93D9FB"
        d="M328.011 367.631c-1.538-.553-2.355-1.961-3.453-3.01-1.341-1.281-.361-1.701.938-1.787.611-.238 1.23-.527 1.723.213.344.902 1.615 1.551.782 2.785.004.6.008 1.199.01 1.799z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A7CFE9"
        d="M328 365.832c-.038-1.143-1.626-1.621-1.253-2.938.34-.859 1.154-.486 1.754-.674.237-.016.475-.029.713-.045-.094 1.323.528 2.882-1.214 3.657z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#33A9EA"
        d="M319.255 363.365l-.002-1.244c-.9-1.107-.939-2.295-.342-3.545 1.51-1.17 2.252-.279 2.832 1.055l.004 3.734c-.318.389-.746.537-1.232.563-.489-.021-.896-.229-1.244-.561l-.016-.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#33A8F1"
        d="M319.271 363.367l1.229.002a9.007 9.007 0 012.49 2.5c-.632 2.252-2.479.828-3.722 1.23.003-1.244.003-2.486.003-3.732z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#68A4CA"
        d="M321.744 359.631c-.862-.352-1.396-1.354-2.488-1.248a2.777 2.777 0 01-1.56-1.422c-.11-.463-.04-.885.282-1.252 2.341-.543 3.672 1.061 5.124 2.406a.968.968 0 01-.045.881c-.438.213-.878.422-1.313.635z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#71A1BB"
        d="M328.501 362.221c-.398.715-1.148.502-1.754.672-.413-.096-.86.477-1.252-.061.458-1.424-1.148-2.02-1.29-3.203 1.32-.563 1.896.441 2.578 1.225l1.718 1.367z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CAD8DE"
        d="M326.784 360.854l-2.578-1.225c-.383-.211-.766-.42-1.148-.633a6.253 6.253 0 00-.093-.611c.373-.459.882-.643 1.444-.723 1.198.137 2.846-.271 2.39 1.924-.007.424-.011.844-.015 1.268z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#45A0ED"
        d="M322.991 365.869c-1.319-.348-2.142-1.186-2.49-2.5l1.247-.004c1.67.211 1.14 1.514 1.243 2.504z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1D163F"
        d="M223.163 206.105c.802-.042 1.202-.475 1.232-1.268 4.351.085 1.751-3.301 2.505-5.014l2.484.036c1.546 1.582-.003 4.032 1.577 5.604.21.208.373.447.497.715.104.777-.203 1.429-.616 2.051-.769.757-1.095 2.109-2.566 1.943-2.398-.081-1.426 1.237-.962 2.341.279.752.314 1.513.11 2.288a2.825 2.825 0 01-.781 1.207c-1.733 1.309-3.562 2.308-5.855 1.752-1.051-.507-1.845-1.265-2.283-2.365-.542-2.948 2.412-4.341 3.018-6.782.664-.756.813-1.855 1.64-2.508z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1D1442"
        d="M234.444 198.042c.934.549.172 1.915 1.171 2.433-1.097 1.458-.335 2.907.022 4.357l-.005 1.283c.619.757.717 1.563.236 2.426-1.257.959-2.153.43-2.904-.699-.116-.963-.495-1.675-1.624-1.655l-.13-.143c-.697-2.16-.47-4.221.662-6.185 1.209-.107 1.689-1.247 2.572-1.817z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#0F1D43"
        d="M231.872 199.86c.02 2.088.155 4.188-.662 6.186-1.249.133-1.874-.366-1.834-1.685.045-1.5.009-3.001.008-4.501h2.488z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#39129C"
        d="M169.465 428.273l23.722-.002c20.398-.018 40.795-.031 61.193-.049.796-.611 1.574-.521 2.339.061l.037.182c-.916.744-2 .42-3.006.42-27.019.021-54.037.023-81.056 0-1.09 0-2.313.422-3.229-.612z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6F6F3"
        d="M250.631 224.892c-.569-2.054-2.25-3.788-1.454-6.261.251-.782-.869-1.494-1.699-1.932-.258-.722.077-1.148.713-1.423l1.695 1.588c1.325 2.576 1.928 5.219.745 8.028zM250.002 227.375c-.166-.557-.352-1.11-.489-1.675-.081-.327-.362-.824.157-.922.241-.046.579.415.873.646.056.717.018 1.406-.541 1.951z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9F9F8"
        d="M248.192 215.276l-.713 1.423c-1.222-1.774-4.189-1.589-4.597-4.571-.155-1.138-8.417 2.041-8.153 2.215 2.21 1.45.116 4.327 2.077 5.565.536.338 1.391.125 2.066.298 3.705.949 5.25 5.561 2.835 8.396-1.402-.149-1.548-1.453-2.109-2.346-1.134-1.807-2.185-3.668-4.116-4.782-1.323-1.301-2.885-2.293-4.377-3.38a2.102 2.102 0 01-.268-.841c.029-.914.334-1.762.631-2.612 1.255-2.107 1.133-5.166 4.162-6.052.441-.824.067-1.648.002-2.472 5.536 1.202 9.214 4.953 12.56 9.159z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#31246D"
        d="M248.105 211.084c1.536-.977 1.228 1.73 2.512 1.257-.285.761-.058 2.314-.862 2.159-1.65-.317-1.745-1.945-1.65-3.416z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#20286A"
        d="M244.364 192.359l1.218.012c.592 3.142-.644 6.018-1.305 8.978-.169.759-.701 1.022-1.378.881-1.021-.214-.387-.729-.3-1.319.312-2.112 1.838-3.855 1.754-6.061-.654-.833-.655-1.663.011-2.491z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3F1D68"
        d="M244.364 192.359l-.01 2.491-2.486-.001-.005-2.489 2.501-.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F3375D"
        d="M236.875 378.35c-.874.104-1.239.619-1.237 1.471.004 3.104-.02 6.205.02 9.309.004.355-.411.898.515 1.102 2.518.555 2.06 2.182 1.253 3.934-.495 1.076-1.334 2.371.693 2.908.044 1.146 1.087 1.781 1.424 2.861.39 1.246.902.426 1.074-.359.415-.373.829-.373 1.242.004l-.004-.006c.679.828.673 1.658.013 2.49-1.533.293-1.557 1.33-.8 2.232.759.91.815 1.82.752 2.852-.403.287-.832.309-1.283.131-.881-.611-1.531-1.396-1.802-2.459a7.362 7.362 0 00-.956-2.701c-.33-.885-.602-1.801-1.286-2.51a13.945 13.945 0 01-1.374-2.707c-.273-1.34-.408-2.725-1.268-3.877-.191-.486-.277-.988-.311-1.508.037-4.564-.264-9.133.161-13.689 1.036-1.549 1.098-3.365 1.37-5.127.117-.318.31-.584.575-.799.318-.133.645-.158.982-.084.323.139.556.367.705.684.402 1.186.318 2.307-.433 3.342l-.029 2.514.004-.008z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F23D4C"
        d="M280.54 338.26c.009-.152.023-.307.044-.459 1.953-1.293 3.922-2.553 6.238-3.123l-.001.002c.335-.375.76-.561 1.261-.582.502.033.934.199 1.229.633-.075 1.066-1.088 1.445-1.613 2.184-.362.51-.971.994.021 1.387 2.585 1.023.279 2.215-.197 2.26-2.239.221-4.312.959-6.433 1.57-1.304.375-1.868-1.195-3.034-1.234-.365-.422-.364-.857-.044-1.303l.007.008c.76-.599 1.976-.343 2.522-1.343z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8444E"
        d="M311.755 354.631c.404-2.547-1.74-3.572-3.127-4.936-1.354-1.328-2.064-2.67-1.879-4.594.377-3.926-.535-7.615-2.297-11.125-.258-.514-.146-1.211-.204-1.824l.018-.018 1.187.02c.958.863 1.844 1.801 2.84 2.627.254.4.394.836.466 1.301.084 3.736.018 7.488 1.203 11.1.136.25.271.506.421.746.436.707 1.006 1.307 1.596 1.885.303.287.591.584.877.889.578.646 1.166 1.287 1.17 2.236-.094.771-.374 1.445-1.025 1.922-.46.167-.883.13-1.246-.229z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F83556"
        d="M236.938 369.654c1.481-.857.53-3.205 2.355-3.852.449-.309.886-.309 1.312.047-.178 2.205 2.003 3.936 1.257 6.254-.036.131-.07.262-.102.395-.385.699-.454 1.572-1.153 2.1-.829 0-1.657 0-2.485.002-.88-.566-.383-1.785-1.142-2.408l-.118-.1c-.639-.832-.687-1.649.076-2.438z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FD3552"
        d="M241.859 392.078c-1.504-.207-1.23-1.373-1.238-2.352-.021-2.545-.007-5.088-.007-7.633-.5-.588-.748-1.33-.466-1.998 1.083-2.564.65-5.438 1.715-7.992h-.001c1.499.213 1.234 1.373 1.241 2.355.019 2.547.006 5.092.007 7.637-1.124 1.555-.415 3.334-.629 5-.214 1.661.537 3.44-.622 4.983z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F93752"
        d="M306.221 357.514c.618 2.994.321 6.074 1.73 8.883.321.637.154 1.748-1.031 1.867-1.15.115-1.044-.859-1.445-1.561-1.836-3.221.331-6.119.746-9.189z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F93C3E"
        d="M241.864 372.104c.081 3.393.153 6.783-1.25 9.99-2.706-2.496-1.069-4.996-.007-7.496.125-.979-.416-2.295 1.257-2.494z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D64465"
        d="M305.622 331.049c-.033-.707-.049-1.416-.102-2.121-.072-.977-.028-2.033-1.5-.924-1.04.785-2.347.354-3.541.404 1.563-2.547 3.883-3.582 6.62-2.947.727 1.742.738 3.482-.028 5.217-.394.467-.869.625-1.449.371z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F43E40"
        d="M241.859 392.078c.001-2.545-.011-5.09.011-7.635.009-.977-.27-2.146 1.24-2.348-.002 3.217.029 6.432-.022 9.645-.019 1.186-.3 2.119-1.229.338z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2F255F"
        d="M243.157 412.59l-.132.729c-2.495-.006-4.988.006-7.481-.027-.983-.016-2.195.316-2.413-1.236.415-.336.832-.379 1.255-.016.825 0 1.649.002 2.474.004 1.43-1.313 3.51.082 4.949-1.191l.033-.074c.696-.355.91.213 1.205.629l.25.617c.163.241.117.43-.14.565z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ED3E46"
        d="M251.854 415.814c-.23 1.639-1.515 1.115-2.495 1.215.545-2.064-1.533-2.926-2.382-4.869 2.808.121 3.869 1.852 4.877 3.654z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B85A88"
        d="M313.12 365.793c-.456.031-.914.061-1.37.09-.416-.416-.831-.834-1.248-1.254-.65-.83-.648-1.672-.045-2.525l.085-2.441c.351-.391.77-.408 1.228-.229.769.75.92 1.852 1.527 2.697.126.461.072.883-.263 1.248l.086 2.414z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E03E53"
        d="M243.157 412.59c.043-.189.09-.377.14-.566 2.594-.6 2.204 2.08 3.315 3.107.554.51.182 1.867 1.487 1.92l-.054 2.639c-.776-.18-.962-.893-1.312-1.457-1.308-1.811-1.935-4.045-3.576-5.643z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3F2154"
        d="M306.726 325.27c-2.51.191-4.256 1.906-6.246 3.139l-1.147-.094.059-2.402c2.631.658 4.7-1.873 7.317-1.289.069.107.139.213.209.318l-.192.328z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E33B64"
        d="M311.762 359.621c-.406.014-.813.029-1.219.041-.421-1.875.33-3.469 1.213-5.031l1.145-.004c.456.264.652.693.766 1.178.135.797.078 1.578-.221 2.336-.376.703-.923 1.213-1.684 1.48z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9187BD"
        d="M305.622 331.049c.34-.082.682-.164 1.023-.244.128.043.256.086.387.123.457.303.849.672 1.193 1.098.222.354.333.742.375 1.152.029.412-.016.814-.148 1.205-.117.254-.311.43-.567.537-1.623-.209-2.431-1.131-2.433-2.766.057-.369.112-.738.17-1.105z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DB4A5D"
        d="M289.311 334.73l-1.392-.113c-.117-1.07.995-.713 1.386-1.195h.003c.603-.867 1.723-.711 2.489-1.258.411-.031.822-.061 1.232-.094-.436 2.01-1.842 2.664-3.718 2.66z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BD3484"
        d="M240.605 365.85l-1.311-.047.112-2.395.003.002c1.114.154 1.214-1.678 2.464-1.256.687.832.66 1.643-.072 2.432-.811.031-1.164.494-1.196 1.264z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9A2A8A"
        d="M243.047 411.406c-.402-.211-.803-.42-1.205-.629-.427-.41-.855-.822-1.283-1.23-.578-.826-.681-1.637.069-2.424.397.008.794.016 1.192.021-.472 1.676 1.58 2.622 1.227 4.262z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#521D55"
        d="M263.058 345.848l.079.768c.018.176.005.352-.04.521-1.249.422-2.498.842-3.747 1.26l-.011-1.266c1.262-.363 2.205-1.651 3.719-1.283z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FE3063"
        d="M236.871 378.355c2.225.709.915 2.133.804 3.313-1.158-.928-.647-2.189-.8-3.318l-.004.005z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EB4241"
        d="M309.27 362.121c-2.057-.74-1.155-2.082-.806-3.896 1.157 1.51.65 2.77.805 3.898l.001-.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F83C41"
        d="M236.979 372.191c1.676.189.957 1.514 1.142 2.408-.027.789-.409 1.229-1.222 1.242l.08-3.65z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FB3B3E"
        d="M241.858 399.578l-1.242-.004c.419-1.246-1.02-3.109 1.24-3.746.765.816.63 1.645.022 2.475l-.02 1.275z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7375D"
        d="M241.878 398.303l-.021-2.475c.181-.496.475-1.545.962-.615.505.959 1.029 2.578-.941 3.09z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F73B35"
        d="M301.769 330.908c.432-.754.979-1.484 1.934-1.006.921.457.454 1.461.563 2.232 0 0-.018.02-.018.018-.404.006-.809.01-1.213.018-.361-.482-1.048-.637-1.266-1.262z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FC3660"
        d="M241.801 364.586l.072-2.432.615-.648c.802 1.258 1.379 2.465-.687 3.08z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F3375D"
        d="M238.781 394.646c.671 1.045.803 1.738-.096 2.279-.161.096-.377.1-.567.146.049-.739-.159-1.54.663-2.425z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FB3B3E"
        d="M241.867 402.063l-.013-2.49c.869.057 1.266.521 1.215 1.393-.046.763-.536 1.02-1.202 1.097z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DD4A41"
        d="M301.769 330.908c.818.021 1.25.434 1.266 1.262-.722-.117-1.673.342-2.105-.469-.343-.644.423-.656.839-.793z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EA3E4E"
        d="M250.595 359.58c-.403-.029-.884-.029-.88-.576.005-.549.49-.568.892-.564.401.002.884.031.879.574-.003.55-.489.537-.891.566z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E94249"
        d="M310.457 362.104l.045 2.525c-1.647-.229-1.119-1.525-1.232-2.508l-.001.002c.396-.008.792-.014 1.188-.019z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FE2E5E"
        d="M272.748 349.035c-.074.521-.497.551-.902.547-.401-.004-.892-.018-.89-.57.002-.549.49-.568.892-.568.402-.003.839.005.9.591z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ED2236"
        d="M311.137 387.08c-.616 1.465-1.91 1.246-3.11 1.256.806-.99 1.892-1.287 3.11-1.256z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C53F60"
        d="M278.011 339.594l.044 1.303-2.55-.004 1.296-1.256c.403-.016.807-.03 1.21-.043z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8444E"
        d="M303.933 337.621c.492.629.486 1.42-.046 1.623-.814.313-.67-.406-.482-.881.105-.261.333-.474.528-.742z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ED2236"
        d="M308.021 388.34c-.474 1.129-1.423 1.303-2.489 1.242.631-.811 1.501-1.143 2.489-1.242z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#302A5A"
        d="M235.676 220.93c3.297 1.544 4.301 4.895 6.031 7.671.082 1.681 1.123 3.208.788 4.957-.495 1.352-.068 2.785-.349 4.152-.194.947-.111 2.138-1.588 2.158-.677-.661-.729-1.525-.775-2.39 1.23-5.698-1.821-10.138-4.343-14.734a2.285 2.285 0 01-.206-.959c.035-.342.183-.627.442-.855z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6F7F5"
        d="M248.739 255.401c-1.33 2.426-3.332 4.205-5.543 5.786-.405-2.809 2.296-4.147 3.035-6.415l.001-.002c.913-.097 1.727.199 2.507.631z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7F7F6"
        d="M237.538 264.775c-1.9 1.307-3.999 2.094-6.278 2.415 1.256-1.146.521-1.373-.946-1.474 2.533-.772 4.775-1.564 7.224-.941z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2F2C54"
        d="M240.623 239.795c2.218-1.601.381-4.419 1.873-6.238.694 3.477.058 6.771-1.382 9.953-.917-.011-1.005-.729-1.178-1.376-.07-.867-.041-1.706.687-2.339z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#322C5C"
        d="M240.599 242.287l.514 1.223c-.873 2.418-2.112 4.583-4.248 6.125l-.006-1.11c.122-2.56 2.148-5.938 3.74-6.238z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6F7F5"
        d="M246.231 254.772c-1.886-.133-1.594 1.858-2.563 2.715.144-3.239 2.22-5.037 5.178-4.057-1.129.396-2.338.183-2.614 1.34l-.001.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7F7F6"
        d="M224.388 267.255c.155-.711-.373-1.613.551-2.088.094-.05.514.257.566.455.247.938-.097 1.534-1.119 1.631l.002.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9F9F8"
        d="M244.314 220.857c.01.516-.02.981-.484 1.081-.59.128-.607-.408-.656-.792-.052-.411.019-.873.48-.978.61-.138.527.452.66.689z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7F7F6"
        d="M228.132 267.862c-.191.036-.381.072-.571.106.182-1.075-.712-2.479 1.567-3.436-.97 1.3-1.08 2.303-.996 3.33zM230.528 263.814c.65-.442 1.283-.387 2.137-.027-.815.464-1.445.492-2.137.027z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B2468"
        d="M300.585 216.118c1.464.222 2.61-.43 3.662-1.339l.069.084c2.25 2.762 5.721 2.353 8.656 3.334 1.031.36 1.919.934 2.624 1.776 1.152.251 2.535.094 2.949 1.659.095.286.149.581.185.878 0 1.142-.283 2.167 1.131 3.042 1.288.795 1.664 2.459 1.057 4.073-1.17 1.177-.263 2.24.197 3.331.37 2.061.402 4.118-.021 6.169-.19.689-.578 1.313-1.008 1.84-.949 1.166-1.112 2.368-.552 3.719-.323.667-.843 1.156-1.438 1.576a1.93 1.93 0 01-1.228.128c-.86-.387-1.798.242-2.646-.18-.133-.111-.272-.364-.389-.358-.172.007-.211.254-.126.479.54 1.888 1.917.291 2.808.694.708.438.309 1.246.607 1.827-.214 1.772-1.711 2.578-2.779 3.71a3.514 3.514 0 01-.811.336c-1.457-.063-2.66 1.006-4.12.938-1.363-.938-2.708-.957-4.033.09-2.365-.104-4.709.189-7.061.38-.723.013-1.422-.167-2.135-.23a2.78 2.78 0 01-.776-.311c-.621-.547-1.386-.812-2.156-1.067a2.812 2.812 0 01-.685-.456 44.794 44.794 0 00-2.36-2.314c-2.148-1.698-2.994-4.413-4.922-6.289a2.533 2.533 0 01-.305-.873c-.209-3.496-1.734-6.799-1.481-10.357a.502.502 0 01-.441-.234c-.624-.847-.004-1.328.605-1.639.833-.426 1.093-1.091 1.143-1.929.051-.426.145-.839.285-1.243.59-1.626 2.079-2.768 2.415-4.529.114-.265.283-.494.491-.693.382-.182.766-.219 1.126-.009.146.133.26.24.322.305-.087-.076-.182-.21-.291-.428.083-1.047.674-1.774 1.405-2.424.897-.495 1.837-.912 2.703-1.469 2.458-.607 4.846-1.465 7.324-1.997z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3A1C7B"
        d="M285.497 228.48c1.02 2.442-1.961 2.241-2.439 3.693l-1.892-.436c-.39.282-.808.256-1.236.109-.973-1.885-3.088-.965-4.48-1.823-.83-.85-2.231-.573-3.01-1.521-1.78-.643-2.079-2.041-1.882-3.691l.019-1.242c.811-.432 1.623-.864 2.434-1.298.116.101.232.2.351.297.244.399.35.836.376 1.296-.392 1.726.019 2.997 1.995 3.209 2.849.304 5.471 2.198 8.501 1.202.452-.128.878-.087 1.263.205z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F43D41"
        d="M294.912 265.967c-.413-.271-1.161-.528-1.173-.817-.034-.764.771-.237 1.148-.481 3.322-2.158 7.024-.809 10.546-1.112.679-.06 1.185.321 1.242 1.078.068.925-.456 1.331-1.303 1.34-2.863.025-5.727.025-8.59.036a1.342 1.342 0 01-1.167.424 1.318 1.318 0 01-.703-.468z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4D1854"
        d="M272.44 228.502c1.096.332 2.688-.616 3.196 1.237-.647.566-1.335.434-2.035.12-1.997-.265-2.852.72-2.905 2.623-.105 3.728-.143 7.447 1.142 11.03.472.613.539 1.233.031 1.863-.065.514-.141 1.022-.652 1.316l-.627-.065-.022-1.214c-.847-.884-.295-2.307-1.222-3.16-.009-3.319.016-6.638-.038-9.956-.036-2.202.867-3.537 3.132-3.794z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5C1E46"
        d="M314.188 252.27c.243-1.684 2.394-2.014 2.629-3.701.35-.522.616-1.104 1.108-1.523.32-.207.676-.329 1.037-.427.627-.138 1.091-.577 1.635-.877a2.16 2.16 0 01.785-.104c.84.149 1.512.571 2.023 1.247.349.563.852.952 1.441 1.239a8.8 8.8 0 01.982.635c.85.601 1.748 1.142 2.4 1.979.363.513.825.964 1.018 1.588.007.394.012.788.018 1.183-.231.266-.481.302-.758.07l-1.709-.821c-.394-.186-.789-.368-1.186-.552-.611-.317-1.285-.509-1.869-.892-1.814-.869-3.145-3.537-5.728-1.523l.007.043c-1.044 1.178-1.427 3.399-3.833 2.436z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F53C45"
        d="M291.696 259.43c.171 1.031-.329 1.187-1.036 1.292-.888.133-2.307.712-2.361-.406-.111-2.307-2.224-2.707-3.217-4.118-.505-.718-1.235-1.586-.478-2.078.813-.53 2.549-1.246 3.025-.112.847 2.019 2.453 3.229 3.758 4.768.19.219.26.542.309.654z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CF445F"
        d="M295.513 266.042l1.269-.032c.111.669.437 1.219 1.172 1.166 4.51-.33 9.164 1.202 13.531-1.07.419-.218 1.01-.106 1.52-.147.085.09.171.178.258.266.124.381.093.721-.258.976-6.621 2.126-13.245 1.542-19.867.009a2.934 2.934 0 01-.099-.574c.71-.678 1.756.052 2.474-.594z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D43E62"
        d="M311.18 254.807c-2.627 2.693-7.863 3.279-11.404 1.349-.958-.523-2.648.586-3.012-1.332.324-.428.775-.592 1.289-.622 3.286.466 6.572 1.509 9.868.043.82-.188 1.64-.086 2.461-.005.327.101.593.29.798.567z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F53C46"
        d="M306.814 261c-1.988 0-3.935.006-5.882-.005-.757-.004-1.474-.135-1.55-1.089-.091-1.134.663-1.378 1.572-1.375 2.288 0 4.838-.589 5.86 2.469z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DC4352"
        d="M286.797 249.778l-1.222-2.505a1.529 1.529 0 011.204-.443c1.52.375 1.936 2.063 3.225 2.714.784 1.156 2.083 1.762 2.989 2.789l-.023.027c.389.291.578.687.612 1.165-.011.48-.209.878-.535 1.22-2.239-.475-2.795-3.204-4.997-3.73a2.24 2.24 0 01-1.253-1.237z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#421F52"
        d="M283.499 232.408c.175.102.506.209.503.305-.139 3.703 2.037 7.084 1.5 10.836-1.144.275-.667-.979-1.205-1.277-.563-3.264-1.772-6.477-.798-9.864z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ED4259"
        d="M316.738 265.92l-1.184.133c-.82.346-1.645.554-2.492.081l-.058-.176c1.128-2.025 3.677-1.026 5.169-2.415.435-.404 1-.601 1.079-1.281 1.067-.723 2.131-.877 3.188.02-1.477 1.067-2.952 2.137-4.43 3.206-.51-.114-.945-.001-1.272.432z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D83D57"
        d="M314.188 252.27c1.81.023 2.338-1.969 3.835-2.437-.388 2.948-2.131 4.646-5.033 4.899a1.472 1.472 0 01-.409-1.208c.141-.651.633-.956 1.187-1.201a.618.618 0 00.42-.053z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#631E5A"
        d="M273.601 229.859l2.034-.12c1.225.032 2.45.037 3.673.104 1.32.072 1.186.807.696 1.665-1.234.903-2.211.096-3.223-.483-1.059-.39-2.12-.777-3.18-1.166z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BE4764"
        d="M318.016 249.79c.797-1.958 2.097-2.03 3.634-.907.904.661 1.73 1.431 2.592 2.151-.644.691-1.426.649-2.246.433-.958-.476-1.921-.948-2.738-1.664l-1.242-.013z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F53C46"
        d="M306.191 261.194h6.38c-.019.293-.038.586-.055.879-1.946.135-3.919.719-6.325-.879z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F53C45"
        d="M286.797 249.778c.803.022 1.227.429 1.253 1.238-.886 2.312-2.368 1.111-3.727.633-.346-.409-.347-.824-.022-1.245 1.093.831 1.56-.831 2.496-.626z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F83E35"
        d="M319.257 249.803c1.025.004 2.251-.417 2.518 1.188.348.435.346.86-.025 1.278-1.921.281-2.77-.523-2.493-2.466z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F53C46"
        d="M293.041 262.262c1.217-2.298 2.951-1.076 4.57-.636-1.415.959-3.037.499-4.57.636z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E63C51"
        d="M321.75 252.27c.009-.425.018-.852.025-1.277l2.467.041c.629.189 1.074.595 1.371 1.172-1.275.775-2.556 1.146-3.863.064z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C14468"
        d="M284.297 242.271l1.206 1.278.029.023c.569 1.185 2.107 2.02 1.336 3.691l-1.293.01c-.933-1.537-1.643-3.131-1.278-5.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E74347"
        d="M322.441 262.281l-3.188-.02c.631-2.253 2.49-.839 3.735-1.249.009.365.015.731.021 1.1a.644.644 0 01-.568.169z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E4425D"
        d="M289.149 264.826c-1.002-.04-1.897-.273-2.356-1.298.835-.007 1.67-.011 2.506-.018.41-.357.816-.363 1.221.009l.043 1.22c-.447.421-.924.357-1.414.087z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E53B4A"
        d="M310.241 256.855c1.351-.265 1.949.323 2.782 1.151-1.58.732-2.401.516-2.782-1.151z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EE3E40"
        d="M290.52 263.52c-.407-.002-.813-.007-1.221-.009.98-1.217 2.337-1.303 3.742-1.249h-.001c-.203 1.696-1.544 1.11-2.52 1.258z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D3455D"
        d="M276.781 231.025c1.074.161 2.148.323 3.223.483.388.075.775.152 1.163.229-1.598.601-3.255 1.564-4.386-.712z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C94065"
        d="M271.87 245.375l-.031-1.863c2.183.671.88 2.49 1.241 3.763l-1.21-1.9z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D43E62"
        d="M293.047 254.746l.066-1.374c.838-.519 1.633-.521 2.37.193l.032.007c.406.284.952.481.72 1.161l-3.188.013z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6375E"
        d="M284.301 250.404l.022 1.245c-.931.85-1.212.265-1.218-.609-.005-.846.234-1.486 1.196-.636z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EC453E"
        d="M278.06 253.529c.097-1.026.696-1.373 1.637-1.127.2.052.507.475.458.568-.479.929-1.385.396-2.099.555l.004.004z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ED433D"
        d="M282.43 255.119c.547.074.563.505.561.905-.001.401-.029.885-.574.882-.55-.003-.56-.493-.559-.894.001-.4.015-.83.572-.893z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#572158"
        d="M296.235 254.733l-.72-1.161 2.497-.031c.385.395.385.799.034 1.214l-1.283.067a1.04 1.04 0 00-.528-.089z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CB446C"
        d="M289.149 264.826l1.414-.087c.797.058 1.244.449 1.217 1.285-1.113.121-2.016-.222-2.631-1.198z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CB446C"
        d="M295.513 266.042c-.662.877-1.625.494-2.474.592-.5-.04-.982-.115-1.259-.613 1.044-.018 2.088-.034 3.132-.054l.601.075z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C13E6D"
        d="M312.988 253.48l.003 1.253c-.604.023-1.208.048-1.812.073l-.805-.13c.459-1.298 1.262-1.846 2.614-1.196z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2D2347"
        d="M327.997 285.973c1.649 3.047 3.303.345 4.954.005.413.372.539.851.526 1.384-.396 1.801-1.321 3.414-1.827 5.196-.414 1.468-1.412 1.666-2.314.19-.282-.824-.235-1.721-.53-2.544-.27-.749-.901-.976-1.601-1.098-.547-.132-1.046-.344-1.328-.881-.242-.728.013-1.363.368-1.981.16-.23.368-.412.616-.545.271-.068.545-.068.816.009l.32.265z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#611DDE"
        d="M319.257 280.965c1.225.034 2.447.068 3.672.104l.16 1.151c.693 1.265.733 2.544.088 3.84-3.262.739-4.957-1.465-3.92-5.095z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#351467"
        d="M323.041 285.973c.017-1.251.031-2.501.049-3.752 1.082.133 1.164.913 1.164 1.767 0 .916-.05 1.879 1.246 1.985l.293.304c.317.481-.085 1.115.33 1.577.264.502.734.62 1.242.667a.874.874 0 01.276.715c-.106.672-.196 1.348-.29 2.025-.088.435-.262.821-.623 1.102-.668.131-1.127-.196-1.525-.674-.693-1.578-1.375-3.166-2.479-4.52-.123-.46-.078-.875.317-1.196z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3A292F"
        d="M333.033 285.346c1.689-1.251 3.632-.336 5.434-.629.883.169 1.154.771 1.121 1.59a1.79 1.79 0 01-.409.762c-.787.699-1.587.579-2.397.047-1.111-.885-2.721-.714-3.749-1.77z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8D2C3"
        d="M347.896 287.299c.053.129.102.255.145.386-.241.599-.744.764-1.326.793-2.349 1.232-3.461.118-3.994-2.101.093-.144.183-.286.274-.43.364.025.729.049 1.093.072 1.206.613 2.813.04 3.808 1.28z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E5D1CC"
        d="M333.033 285.346c1.619-.209 3.024.314 4.313 1.25-1.17 1.784-2.614 1.741-4.219.635l-.176-1.253c.027-.21.053-.422.082-.632z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#33273C"
        d="M347.896 287.299c-1.351-.182-2.666-.473-3.809-1.279 2.092.578 4.679-1.452 6.373 1.213-.855.024-1.709.044-2.564.066z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#201A6A"
        d="M326.757 282.237c.925.125 2.234-.391 2.404 1.113.118 1.009.537 2.342-1.165 2.622v.002c-.733-.714-1.015-1.702-1.547-2.541-.108-.453-.051-.864.308-1.196z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2D2347"
        d="M326.757 282.237v1.229c.648.841.657 1.677-.012 2.512l-.003.002c-.415.365-.83.365-1.243-.007.426-1.244-1.031-3.119 1.258-3.736z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DFD1E0"
        d="M339.216 286.535c.104-.753-.205-1.335-.75-1.818 1.504-1.995 1.97 1.331 3.223.627.223 1.378-.934 1.213-1.681 1.511a1.066 1.066 0 01-.792-.32z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8D2C3"
        d="M339.847 286.574c.615-.409 1.229-.819 1.842-1.23.531-.006.993.14 1.306.604l-.122.178c-1.524 1.733-1.876 1.787-3.026.448z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2D2347"
        d="M331.224 284.396c-.59.047-.617-.411-.669-.796-.052-.409.007-.873.464-.982.584-.139.609.392.663.772.056.41-.023.797-.458 1.006z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FAFAF6"
        d="M374.803 207.337c3.477-4.334 8.24-1.699 13.058-2.799-.748.652-.902.882-1.002.861-3.166-.667-5.051 2.375-7.828 2.713-2.853.347-2.414 2.344-2.357 4.218v.001c-.471-.058-1.398-.202-1.305-.307 1.635-1.823-.709-3.107-.566-4.687zM389.156 206.713c2.014-1.886 4.266-.375 6.4-.4.611-.007 1.053.7.943 1.382-.158.984-1.057 1.023-1.701.846-1.904-.524-3.765-1.206-5.642-1.828z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FAFAF6"
        d="M376.674 212.33c1.6-2.257 2.664-.434 3.777.54.455.4.135.938-.15 1.368-.404.61-1.033.659-1.629.489-1.177-.337-1.894-1.127-1.998-2.395v-.002zM389.156 206.714c-1.264-.368-2.625 1.317-4.277-.388 1.742-.181 3.05-.719 4.277.388z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9E8E4"
        d="M286.823 334.678c-1.873 1.455-4.002 2.398-6.238 3.123 1.571-2.055 3.272-3.852 6.238-3.123z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9E8E4"
        d="M289.305 333.422l-1.386 1.195-1.098.063c.199-.457-1.667-.682-.127-1.322.913-.379 1.745-.071 2.611.064z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C53F60"
        d="M280.54 338.26c-.125 1.793-1.44 1.348-2.522 1.344.466-.457.934-.912 1.4-1.365.374.005.748.011 1.122.021z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9E8E4"
        d="M291.797 332.164c-.686.707-1.479 1.193-2.489 1.258.192-1.684 1.489-1.176 2.489-1.258z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B2468"
        d="M240.599 242.287c-1.735 1.786-1.91 4.508-3.741 6.237-1.873.745-3.296 3.051-4.573 3.324-2.538.543-4.939 2.053-7.703 1.718-1.016-.124-2.419-.499-2.71 1.234l-1.225-.036c-2.069-.588-4.441.424-6.316-1.193l-1.132-.071c-.327-.286-.612-.605-.795-1.004-.956-3.015-3.719-4.359-5.842-6.297-.826-1.035-1.772-2.021-1.468-3.523.769-1.936-1.417-1.653-1.96-2.6-.822-.628-1.986.628-2.718-.494 2.635-2.269 4.52-5.131 6.375-8.021.108-.169.26-.302.225-.539-.071-1.183-.873-1.902-1.631-2.648.019-4.469.12-4.569 3.899-3.942.648.361 1.145.888 1.598 1.46.353.412.336 1.194.992 1.26.422.042.434-.506.506-.861.023-.745.067-1.485-.441-2.111-.165-.18-.324-.366-.489-.543-.525-.582-1.313-.661-1.955-1.025a1.209 1.209 0 01-.418-.667c-.021-1.138.866-1.687 1.532-2.382.793-.61 1.673-1.063 2.6-1.432 1.552-.376 3.346-.258 4.193-2.07a3.02 3.02 0 01.545-.647c.266-.149.527-.149.785.018.857.406 1.492 1.04 1.929 1.879 1.232 2.472 3.382-.021 4.9.899 1.551.906 3.146 1.72 4.867 2.273.928.535 1.84 1.299 2.865.163 1.333-.859 1.712.34 2.31 1.071.008.201.016.402.022.603-.453 1.823-.162 3.633 1.045 4.958 2.501 2.741 2.404 5.98 2.263 9.291-.03.708-.333 1.403.01 1.992.132-.798.118-2.022 1.673-1.262l.01 2.5c-.012.826-.019 1.657-.027 2.488z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#621AEE"
        d="M206.893 262.309c-.102-1.391.371-2.834-.807-4.09-.756-.805-.318-1.668.437-2.418.708-.703 1.594-1.461 2.383-.731 2.065 1.908 3.741.522 5.53-.338.133.063.266.126.4.187.781.711 1.608 1.413.705 2.584-1.995 1.673-4.356 3.117-3.892 6.314-1.262.659-2.551.557-3.854.159-.668-.358-1.077-.854-.902-1.667z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5C1FE5"
        d="M198.174 241.032c.052.197.079.406.159.59.46 1.052 3.4.66 1.97 2.511-1.066 1.382-3.207 1.066-4.68-.122-1.121-.905-2.043-2.047-3.702-1.725-.373-.413-.35-.805.056-1.182l-.018-.033c2.063-1.293 4.135-1.293 6.215-.039z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#311E79"
        d="M206.912 246.034c2.719 1.452 5.25 3.09 6.225 6.274-.617.481-1.243.471-1.874.028a10.843 10.843 0 01-.56-.161c-1.223-1.77-3.199-2.905-4.148-4.909-.073-.467.007-.888.357-1.232z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#351B7B"
        d="M198.174 241.032l-6.215.04.023-1.188c1.117-1.287 2.646-.8 4.029-.946.355-.013.71-.009 1.066-.004 1.238.038 2.517-.105 3.577.766.837.302 1.716-.995 2.533.065.15.159.194.313.13.46-.062.143-.12.215-.175.215-1.704-.212-3.352.057-4.968.592z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3A1A8B"
        d="M214.33 253.57c1.722-.225 3.416.652 5.181.034.687-.24 1.047.476 1.135 1.159l-.033 1.307c-2.274.544-4.239-.351-6.185-1.331l.008-.007-.106-1.162z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#42219E"
        d="M206.925 247.268c.916 1.902 3.942 2.178 3.779 4.909l-.658.08c-1.137-.424-1.23-1.669-1.919-2.445-1.752-.644-2.618-1.88-2.513-3.765 1.209-.422.761.935 1.311 1.221z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#401E92"
        d="M191.977 241.104l-.056 1.182c-.876 1.659.495 3.299.043 4.954-.423-.101-1.026 1.675-1.238-.039-.199-1.609-.083-3.254-.105-4.884l.07-1.258c.429.016.857.031 1.286.045z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4E24B9"
        d="M206.893 262.309l.645 1.2c.384.345.983.586.595 1.286-.804-.032-1.608-.064-2.411-.099-.054-1.288-1.604-1.354-1.958-2.398 1.043.005 2.087.007 3.129.011z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3C1A87"
        d="M206.925 247.268l-1.312-1.221c-1.175-.973-1.134-2.542-1.829-3.749.619-.542 1.241-.542 1.862-.005-.451 1.542.915 2.471 1.265 3.742l.014 1.233z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#32207B"
        d="M205.647 242.292l-1.862.005c-.757-.432-.58-1.186-.641-1.858l.045-.675c.62 1.037 3.768-.386 2.458 2.528z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5223C7"
        d="M208.126 249.812c1.199.376 1.359 1.568 1.919 2.445-1.987.243-1.922-1.123-1.919-2.445z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5712CC"
        d="M211.264 252.336l1.874-.029.06 1.192c-.908.049-1.806.084-1.934-1.163z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#631243"
        d="M193.259 332.156c.16.008.32.016.481.016l.434.426c.499.844.497 1.785.496 2.717-.029 21.762.13 43.523-.072 65.287a3.339 3.339 0 01-.367 1.127c-.233.391-.567.506-.995.352l.023-69.925z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9A4161"
        d="M213.172 409.553l.233.635c-2.236 1.156-4.634.494-6.957.559-4.004.115-8.014.066-12.021.088l-.705-1.279c-.351-2.5-.38-4.998.016-7.5l.141.023a.935.935 0 01.911.432c.648 1.152.552 2.432.478 3.656-.135 2.213.637 3.275 3.013 3.172 4.46-.195 8.935.23 13.394-.246a1.977 1.977 0 011.497.46z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6C102E"
        d="M193.738 402.055l-.015 7.5c-1.15-2.428-.297-4.984-.488-7.475l.503-.025z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#48304D"
        d="M318.118 221.83c-.362-1.27-1.733-1.169-2.522-1.856 1.078.189 1.654-.425 2.073-1.292.924-2.913 3.181-4.495 5.752-5.763l.239.024 1.282.67c.171.217.257.462.243.74-.357 1.043-1.386 1.593-1.867 2.545-.836 1.042-1.844 1.949-2.507 3.133-.747.826-1.36 1.853-2.693 1.799z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F2F5EC"
        d="M323.42 212.918l-5.752 5.763c-1.547-2.049-1.692-3.572 1.326-4.324 1.492-.371 2.245-3.066 4.426-1.439z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2D2850"
        d="M312.973 218.197c-3.211.471-7.448-1.161-8.656-3.334.446-.177 1.002-1.708 1.285.105.714 1.792 2.437 1.252 3.764 1.676 1.241.397 2.406 1.026 3.607 1.553z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FCFEE8"
        d="M315.505 213.537c-.402-.032-.883-.033-.879-.579.004-.547.492-.564.892-.564.402 0 .884.031.88.576-.005.55-.49.536-.893.567z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#25286C"
        d="M216.895 402.07l.006 6.236c-.151 1.703.818 4.152-2.499 3.74l.02-2.473c2.233-.736.822-2.613 1.225-3.922.373-1.208-.902-2.989 1.248-3.581z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#322070"
        d="M234.386 412.039c-.418.004-.836.01-1.255.016l-10.003-.016c.124-.656.417-1.176 1.17-1.182 2.976-.014 5.952-.016 8.927-.006.759.003 1.04.532 1.161 1.188z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1F276C"
        d="M220.645 345.893l1.233-.004.018 1.885-.049 54.277c-.402.004-.805.01-1.207.016l.005-56.174z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#621BEA"
        d="M240.628 407.123l-.068 2.424c-4.919.699-9.844-.141-14.767.035-1.01.033-2.427.547-2.676-1.238-.9-2.426.193-3.248 2.5-3.158 1.141.045 2.285-.014 3.864.047-6.645-.131-6.645-.131-6.645-6.42 0-14.438-.007-28.877.013-43.314.002-1.123-.266-2.285.268-3.373l-.001-.014c3.261-1.438 6.574-1.066 9.901-.293 1.114 1.107.587 2.533.729 3.826.321 2.98-.696 6.055.622 8.969.053.197.061.541.165.572 2.85.881 2.456 2.549 1.107 4.461.67.828.617 1.674.06 2.533l-.04-.039c-1.259 1.141-.161 2.959-1.2 4.164-1.055.891-.688 2.111-.7 3.209-.041 3.947-.016 7.895-.015 11.838-.029 1.113-.097 2.24.86 3.084.19.428.215.869.091 1.318-.452.807-.851 1.637-.896 2.586 0 .014-.381.648.206.277.138-.088.196-.346.369-.49 2.683-.313 1.442 2.318 2.459 3.25.16.221.292.461.408.707.29.674.339 1.506 1.2 1.807.356.158.644.404.887.701l1.299 2.531z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#611AF3"
        d="M233.126 355.881l-.002-3.746c-1.498-1.105-3.225-.438-4.841-.627-1.719-.201-3.548.502-5.154-.627-.291-1.83.364-2.602 2.332-2.553 5.039.127 10.081.082 15.123.107l-1.216 3.701.002-.002c-1.249-.957-2.748-1.914-4.166-1.031-1.766 1.104-.463 3.178-.835 4.777-.415.368-.829.368-1.243.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#611DE3"
        d="M223.118 352.125c.009 16.205.124 32.412-.061 48.617-.037 3.303.993 4.215 4.043 3.859 1.851-.215 3.748-.039 5.614.395-2.341 1.191-4.788.809-7.164.764-1.996-.039-2.606.797-2.433 2.584-.861-.848-.566-1.941-.567-2.945-.014-16.777-.012-33.555.01-50.334.002-.997-.328-2.094.558-2.94zM223.128 350.881c2.547.002 5.094-.008 7.641.016.977.008 2.148-.271 2.354 1.238-3.336-.01-6.671-.018-10.007-.023l.012-1.231z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#322070"
        d="M241.809 410.852c-1.156 2.453-3.331.666-4.949 1.191 1.149-2.48 3.318-.717 4.949-1.191z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#561A4E"
        d="M256.719 428.283c-.78-.02-1.56-.039-2.34-.061-.061-.811-.532-1.164-1.307-1.184-1.033-1.166-2.97-.164-3.887-1.619a2.245 2.245 0 01-.318-.846c-.022-.48.142-.893.459-1.25a3.21 3.21 0 01.064-.57c.421-.074.842-.15 1.262-.227 1.673.582 2.995 1.551 3.619 3.289.421 1.216 2.16 1.123 2.448 2.468z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2C2563"
        d="M249.411 425.084c.9 1.252 3.271-.25 3.662 1.955l-4.963-.01c-.344-1.168.357-1.636 1.301-1.945z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2A2270"
        d="M249.411 425.084l-1.301 1.945c-2.01-.398-.985-2.018-1.254-3.117 1.068-.734 1.676.389 2.505.619.013.186.03.369.05.553z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B2468"
        d="M249.361 424.531c-1.093.836-1.568-.824-2.505-.619-.001-.203-.002-.406-.005-.609.826.006 1.651.012 2.477.02.01.404.022.808.033 1.208z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6617F4"
        d="M239.406 363.408c-2.039.854-3.432-.121-3.742-2.811-.164-1.428-.036-2.889-.025-4.332.006-.773.162-1.477 1.124-1.537 1.162-.068 1.314.732 1.351 1.627.097 2.412-.479 4.949 1.296 7.055l-.004-.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5E1BF4"
        d="M233.126 355.881h1.242l.001 8.732c-1.501-.201-1.228-1.365-1.238-2.342-.022-2.13-.006-4.259-.005-6.39z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6119F7"
        d="M239.366 352.137c1.6 1.529 1.787 5.068.002 8.955v-8.957l-.002.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9119B4"
        d="M235.701 372.18l-.06-2.535 1.297.01-.077 2.439c-.386.027-.773.056-1.16.086z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#631AEC"
        d="M323.041 285.973l.012 1.134c.905 1.775 1.132 3.87 2.551 5.406.13.27.186.554.162.854-.209.735-.753 1.245-1.209 1.812-.684.862-.823 2.379-2.124 2.497-3.155.284-3.782 2.353-3.835 4.95-1.827 1.929-3.778 3.634-6.653 3.651a1.469 1.469 0 01-.719-1.085c-.227.691.118 1.369-.003 2.048-1.039 3.005-1.283 3.1-3.109 1.195l-.019-2.478c.801-1.109.537-2.394.542-3.615.027-5.698-.006-11.397.019-17.097.016-3.403.617-3.962 4.404-4.286l6.199.006c.51 2.235.289 5.023 3.782 5.008z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5A23DC"
        d="M313.058 280.959c-3.247.782-4.02 2.883-3.859 6.07.271 5.367.094 10.761.046 16.143-.01 1.027.533 2.402-1.152 2.785-.021-7.217-.053-14.435-.06-21.652-.003-3.529 1.365-4.425 5.025-3.346zM311.766 305.949c2.429-.666 4.433-2.041 6.242-3.742.503-.487 1.076-.552 1.707-.291 1.186 1.558-.312 2.084-1.102 2.887a6.13 6.13 0 01-.743.487c-3.237 1.479-5.794 3.662-7.261 6.989a2.357 2.357 0 01-.813.419c-.66.115-1.237-.032-1.708-.528l.023-3.735c1.57 1.087 2.274.479 2.412-1.234.47-.364.627-1.036 1.243-1.252z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4335C2"
        d="M308.089 312.17h1.741c1.087 3.365.051 6.652-.336 9.969-.194.873-.216 1.875-1.442 2.008-.595-.637-.526-1.299-.063-1.971l.009-1.248.091-8.758z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2A2762"
        d="M269.346 242.251c1.941.46.966 2.048 1.222 3.16-1.458-.647-1.245-1.94-1.222-3.16z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EC9C13"
        d="M357.941 222.964l-2.453-.775c-1.491-1.726.361-2.753.913-3.996.526-1.185 1.367-2.23 2.069-3.336.845-.635 1.634-1.32 2.008-2.358.266-.537.702-.518 1.182-.366 1.159 1.329.496 2.477-.395 3.565-1.664 2.034-2.688 4.333-2.996 6.948-.107.106-.219.212-.328.318z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#46302E"
        d="M361.672 212.265l-1.194.234c-.021-.474-.04-.947-.062-1.421.077-.773.479-1.211 1.276-1.245.525-.483 1.103-.568 1.738-.231.677 1.72-.496 2.221-1.758 2.663z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F13B53"
        d="M213.172 409.553h-1.25c-5.136.68-10.295.15-15.441.271-.725.018-1.113-.447-1.038-1.211.868-1.416 2.299-1.111 3.604-1.182.849 0 1.703-.053 2.551.018 2.128.051 4.262.061 6.396.037 1.003-.01 2.173.166 2.063-1.455.252-1.289.47-2.574-.152-3.84-.3-1.65-.214-3.313-.215-4.971-.007-19.07.024-38.145-.052-57.219-.006-1.572.856-3.627-1.408-4.586-1.207-.039-2.438.195-3.604-.309-.795-.443-1.408-1.059-1.768-1.904-.063-.559-.046-1.082.606-1.307 2.65-.076 5.302-.023 7.952-.029 1.559.314.755 2.125 1.761 2.789-.003 24.966-.004 49.931-.005 74.898z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7F3C73"
        d="M211.881 332.229c-2.909.012-5.817.018-8.726.027-.389.291-.808.518-1.292.605-.777.121-1.562.105-2.345.107-1.052-.006-2.104-.027-3.157-.043a6.764 6.764 0 01-.888-.045 3.82 3.82 0 01-.864-.188 3.258 3.258 0 01-.713-.514l-.156-.008c1.032-1.049 2.352-.596 3.544-.605 5.282-.051 10.564-.023 15.846-.023l.037.629c-.413.362-.842.366-1.286.058z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CF385A"
        d="M211.881 332.229c.429-.02.857-.039 1.286-.057l.009 2.484c-1.646-.16-1.16-1.459-1.295-2.427z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#59192F"
        d="M195.722 218.003l4.875 2.596c.185.258.154.498-.064.72-.749.456-1.584.574-2.438.623-.462-.083-.744-.357-.852-.812-.8.119 1.481-1.45-.421-.761-.497.18-1.026.008-1.498-.249l-.279-.315c0-.208-.019-.414-.056-.618.243-.395.488-.789.733-1.184z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#382081"
        d="M307.989 322.176l.113 1.828c.156.268.143.527-.02.787-.408.236-.802.264-1.175-.074l-.199-.09-1.189-1.188c.195-1.652 1.487-1.156 2.47-1.263z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#36234B"
        d="M363.636 209.897l-1.943-.064c.66-1.697 2.578-1.537 3.723-2.519.002.414.006.828.01 1.241.133 1.419-.528 1.782-1.79 1.342z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#321F82"
        d="M273.707 217.335l1.808-.06.334.333c.188 2.222-.556 3.899-2.765 4.717l-.073-.055a14.177 14.177 0 01.696-4.935z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#321F82"
        d="M275.515 217.275c-.064-1.861.695-3.155 2.546-3.697.519.284.776.76.957 1.294.052.275.048.55-.012.823-.158.401-.441.695-.789.936-.818.363-1.434 1.403-2.554.785l-.148-.141z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#421AA7"
        d="M278.636 214.824c-.491-.277-.547-.754-.575-1.246l.02-1.208c.378-.406.782-.411 1.207-.077l1.22-.004c.495 1.237-.401 1.916-1.079 2.681-.297.129-.561.079-.793-.146z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B2468"
        d="M279.288 212.293l-1.208.077c.097-.997-.462-2.313 1.231-2.535l-.023 2.458z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#95405E"
        d="M313.063 266.134c.831-.028 1.661-.056 2.492-.081-.455.387-.91.771-1.365 1.159l-1.184-.013c.018-.355.037-.711.057-1.065z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#703D0C"
        d="M336.697 237.286c-.162.006-.327.015-.492.023-1.339-1.67-1.294-3.354-.047-5.051.186.015.372.036.557.063l-.018 4.965z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#631AEB"
        d="M208.132 264.795l-.595-1.286c1.455 0 2.909 0 4.364-.002l.429.009c1.354.624 2.331 2.011 4.132 1.745 1.718-.252 2.564-.811 1.579-2.599a2.335 2.335 0 01-.267-.799c.783-2.027 1.194-3.896-1.845-4.28-.095-.103-.188-.21-.281-.314.11-1.093-1.383-1.412-1.221-2.528 2.207-.228 4.181.62 6.185 1.33-.003 3.094-.063 6.189.011 9.28.057 2.4-1.153 3.143-3.204 2.426-1.418-.494-2.817-.518-4.25-.579-.865-1.57-2.411-1.087-3.746-1.243-.428-.389-.86-.773-1.291-1.16z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#631BE8"
        d="M278.636 214.824l.626-.026c1.051-1.306 3.193-1.579 3.441-3.644.366-.645 1.171-.758 1.603-1.325 1.077-1.066 2.079-2.241 3.688-2.533 2.013.184 3.424-.75 4.447-2.4.19-.051.384-.072.581-.063l5.027.026c1.428 1.328 3.537-.103 4.966 1.226l-.004 2.505c-2.357 1.716-5.215.334-8.082 1.22 2.853.979 5.716-.46 8.065 1.265l-.005 1.267c-1.283 1.152-2.889.72-4.368.893-1.943.667-3.843 1.577-5.981.581-.825-.385-1.322.329-1.77.913-.579.757-1.343 1.281-2.135 1.786-4.58 2.917-5.654 2.808-10.005-1.045l-.094-.646z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#611AF3"
        d="M302.994 211.075c-2.703 0-5.406.008-8.11-.002-.861-.003-1.747-.058-1.74-1.246.008-1.188.899-1.228 1.757-1.23 2.704-.011 5.407-.007 8.11-.007l-.017 2.485z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#631BE8"
        d="M302.961 213.563c-.002 1.13-.758 1.271-1.644 1.271-.918 0-1.884-.057-2.111 1.188-.631.82-1.554.609-2.398.677-.55-.002-1.036-.167-1.421-.574-.418-2.346 1.879-2.106 2.918-3.068 1.569.002 3.198-.522 4.656.506z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3F1F96"
        d="M296.832 216.1l2.374-.078 1.379.096c-2.178 1.831-4.774 2.389-7.526 2.47a1.22 1.22 0 01-.342-.79c.048-.299.19-.547.412-.752 1.11-.797 2.625-.012 3.703-.946z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6717F7"
        d="M302.961 213.563l-4.925.014c-.332-.415-.375-.829 0-1.244l4.954.008c-.011.407-.019.814-.029 1.222z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6617F8"
        d="M303.016 206.084c-1.628-.52-3.821 1.248-4.966-1.227l4.959-.004c.001.411.005.821.007 1.231z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EE3C53"
        d="M364.025 227.97c.589.811 1.143 1.627.259 2.586-.809.621-1.521.751-1.991-.378-.332-.676-.857-.726-1.482-.451-.122.029-.242.055-.361.08-2.431-.369-4.341 1.545-6.758 1.507-.945-.015-.709 1.32-.719 2.103-.043 3.613-.047 7.229-.064 10.844-2.064-3.682-1.134-7.695-1.269-11.587-.038-1.139.081-2.282.126-3.424.609-.569-.248-1.846 1.012-2.096.646.233.895 1.315 1.863.864 1.506-.179 2.965-.438 3.908-1.812 1.827.587 3.652 1.176 5.476 1.764z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E04154"
        d="M355.454 247.285c-.253 1.825 1.804 3.059 1.267 4.957-.361.389-.724.385-1.083-.004l-2.817-6.198c.056-.21.113-.419.172-.629 1.579-.374 1.647 1.237 2.461 1.874z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EE3C53"
        d="M355.454 247.285c-1.335.051-1.391-1.581-2.462-1.874a35.09 35.09 0 01-.028-.648c1.92-.236 2.774.58 2.49 2.522z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#612165"
        d="M352.937 227.268c-.391.659-.78 1.32-1.172 1.98-.01-1.057-.021-2.115-.034-3.171.377-.22.751-.441 1.126-.661.252.165.426.387.506.678.052.462-.051.867-.426 1.174z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5B20D8"
        d="M283.061 211.089c.431 2.974-1.86 3.161-3.798 3.709-.045-1.065.972-1.603 1.245-2.509l1.333-1.192c.404-.364.81-.406 1.22-.008z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5722C3"
        d="M283.061 211.089l-1.221.008c.447-1.152 1.375-1.37 2.466-1.268-.014.817-.454 1.212-1.245 1.26z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4E3113"
        d="M190.008 232.297l-.546.017.007-3.722c.39-.013.779-.023 1.168-.036.575.458.597 1.078.514 1.732-.196.774-.417 1.537-1.143 2.009z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C64663"
        d="M357.896 254.813c1.746.355 2.646 1.842 3.654 3.015 1.775 2.07 3.305 2.514 5.11.147.275-.359.832-.501 1.26-.742 1.129 2.665-1.609 3.367-2.537 4.988l.018-.006c-.382.004-.765.011-1.148.015-2.298-2.319-5.18-4.137-6.357-7.417z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B23A6E"
        d="M355.637 252.238l1.083.004c1.589.337 1.201 1.546 1.148 2.608l-1.102-.146-1.129-2.466z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#461A61"
        d="M365.383 262.221c.387-1.895 2.6-2.864 2.537-4.988l1.207-1.346c.211-.203.398-.182.559.063l.854.116c.631.845.533 1.658-.111 2.445-.844.823-1.059 2.278-2.5 2.505-1.091-.104-1.394 1.44-2.546 1.205z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4920B8"
        d="M367.928 261.017c.795-.873 1.041-2.295 2.5-2.505.473 2.137-2.578 3.944-.58 6.223l-.723.052c-2.979-.437-.816-2.509-1.197-3.77zM369.242 265.379c1.027.177 2.244-.465 3.045.703-1.016-.23-2.213.321-3.045-.703z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5F20D9"
        d="M375.426 266.003c1.07-2.591 2.102-.708 3.142.03-1.076 2.974-2.089-.578-3.142-.03z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6F2354"
        d="M328.507 253.578l.758-.07c.404.417.811.834 1.215 1.252l-.008 1.25-1.93 1.202c.362-1.215 1.232-2.434-.035-3.634z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ED971C"
        d="M323.019 216.741c-.037-1.356 1.409-1.544 1.936-2.457 1.398-.891 2.535-.015 3.716.552.744.944 1.743 1.738 1.822 3.076.176.148.246.308.214.48-.031.179-.074.268-.121.268-1.496.782-2.104-.89-3.237-1.189-.291.915.282 2.436-1.142 2.526-1.601.1-2.379-1.411-3.329-2.472-.127-.292-.072-.552.141-.784z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B17E50"
        d="M328.67 214.836l-3.716-.553-.013-.671c1.66-.864 2.989-.714 3.729 1.224z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E39E3B"
        d="M330.349 218.639c.047-.242.097-.484.144-.727.372.259.747.518 1.121.776l.815 2.313c-.873.726-1.635.613-2.293-.301-.293-.724-.3-1.42.213-2.061z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F79B11"
        d="M190.643 230.325l-.006-1.769 2.662-8.061c.155-.019.311-.021.465-.011 1.693-.163 2.663 1.811 4.412 1.489.677-.135 1.184.081 1.493.714.181.955.441 1.93-.615 2.593-3.641 1.192-5.29.951-5.084 6.683.112 3.107-.937 3.949-3.564 3.769.07-1.804-.285-3.625.237-5.407z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CD924E"
        d="M198.332 222.32c-1.97.5-3.268-.668-4.567-1.835.214-.627.716-.71 1.279-.68l.056.06c.714.582 2.031.184 2.338 1.431l.675.464c.243.119.316.305.219.56z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BF485F"
        d="M220.677 204.848l1.805-.007c.632 1.076-.067 2.04-.252 3.049-.669.326-.541 1.568-1.627 1.418a1.88 1.88 0 01-.521-.797c-.223-.795-.236-1.6-.116-2.413.097-.495.362-.897.711-1.25z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F53A40"
        d="M220.677 204.848l-.062 1.242c-1.237.985-2.476.963-3.714.003l.015-1.239 3.761-.006z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#441234"
        d="M221.85 207.902l.632-3.062.607-.729.074 1.993c-.145.969.363 2.251-1.213 2.537-.33-.205-.364-.453-.1-.739z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F93550"
        d="M216.9 206.093l3.714-.003-.075 2.494c-1.66 1.409-3.679.627-5.52.909-2.195 1.292-4.913.737-7.168 2.155-.969.609-2.809.359-2.213-1.864-.068-1.098 1.314-1.348 1.385-2.364 1.807.213 3.368-.459 4.867-1.352 1.304-.88 2.556-.945 3.398.54.324.571.578.862 1.094.516.28-.186.353-.677.518-1.031z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FE9C08"
        d="M334.257 224.196l.084 1.746c.807 2.11.07 4.55 1.396 6.55.092 2.302.041 4.602.03 6.901-.71 1.012-.785 2.331-1.591 3.297-1.861 1.167-3.147.525-3.182-1.517-.105-6.211.032-12.426.252-18.638.253-.543.695-.866 1.241-1.074.593.913 1.18 1.824 1.77 2.735z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FC9F13"
        d="M332.489 221.462l-.751.86c-.922.623-1.984.894-2.557-.229-.514-1.012.111-1.684 1.299-1.65.494.724 1.222.643 1.949.56.1.142.119.296.06.459z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F1A116"
        d="M334.277 246.023c-.387 1.262-.773 2.524-1.164 3.787l-.2-.061c-.345.386-.76.396-1.206.228-.822-.985-1.516-2.043-2.711-2.732-.898-.518-1.883-1.371-.952-2.705 2.122-.574 4.197.577 6.315.174.199.451.22.89-.082 1.309z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DB9714"
        d="M334.277 246.023l-.135-1.305c-.644-.817-.541-1.619.043-2.413.187-.954-.353-2.25 1.211-2.552.51.436.406.935.146 1.449l.108 1.017c-.5 1.252-.404 2.719-1.373 3.804z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EC9C13"
        d="M368.137 222.421c-.232 1.74-.951 3.129-2.723 3.756-1.857-.676-3.709-1.353-5.565-2.03l-1.908-1.183.095-.113c2.494-1.528 5.119-1.251 6.824.715.074.083-.048.42.209.235.119-.086.103-.396.257-.531.805-.709 1.479-1.887 2.811-.849z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D5455E"
        d="M353.032 226.104l-.173-.688c.06-.365.121-.729.184-1.093 1.322-.575 2.402.445 3.619.546l1.41 1.155c-.661.785-1.572.838-2.496.861-.929.002-1.826-.105-2.544-.781z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7394A"
        d="M205.639 209.784c.434 1.668 1.265 1.9 2.312.523.491-.647 1.091-.53 1.616-.445 1.825.296 3.325-.479 4.84-1.272.629.685 1.477.59 2.286.649 1.004.075 1.844.341 1.712 1.622a1.409 1.409 0 01-.612.651c-1.197.519-2.659-.218-3.881.802 1.141.294 2.169-.763 3.188 0 .452.634.489 1.321.265 2.039-.493.605-1.355.903-1.518 1.798-.684.622-1.689.654-2.361 1.298a3.575 3.575 0 01-.69.382c-1.179.255-2.093 1.084-3.201 1.493-1.691.442-1.77 2.22-2.716 3.281-.98.542-2.011.517-3.06.289a2.49 2.49 0 01-.771-.41c-.581-1.069-1.046-2.243-2.328-2.72-.755-1.679-3.331-1.489-3.68-3.583 2.39-1.762 4.519-3.783 6.2-6.248l2.399-.149z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E33A5E"
        d="M200.72 219.764c2.306-.708 2.485.756 2.47 2.419-.151.244-.374.349-.659.336-.771-.289-1.434-.714-1.826-1.475a58.128 58.128 0 01-.109-.446l.124-.834z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DC9945"
        d="M331.738 249.779c.392-.009.783-.02 1.175-.03-.187.642-.372 1.281-.561 1.921-.636.624-1.391.734-2.223.522-.858-.25-1.651-.616-2.302-1.25l-2.33-1.998c.884-1.64 2.255-1.109 2.993-.213.976 1.184 2.02 1.165 3.248 1.048z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4A2B0F"
        d="M327.828 250.942c1.057-.115 1.68.563 2.302 1.25l-.882.132c-.867-.055-1.251-.606-1.42-1.382z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4D290F"
        d="M373.006 214.163c-.061.334-.119.667-.182 1a1.283 1.283 0 01-.783-.303c-.533-.716-.982-1.451-.533-2.386l.176-.158c1.238.044 1.265.956 1.322 1.847z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DB9714"
        d="M335.398 232.332c-2.404-1.791-.688-4.262-1.057-6.39.354.489.706.979 1.057 1.467.063.949.127 1.897.188 2.847.199.715.431 1.434-.188 2.076z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C59465"
        d="M335.398 232.332c.063-.691.127-1.383.188-2.075l.571 2.003c.015 1.682.029 3.366.047 5.049-.287 1.286.139 2.692-.663 3.892-.047-.482-.097-.965-.146-1.448l.003-7.421z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BF9361"
        d="M190.643 230.325l.116 5.701c.296.277.521.605.707.959.458 1.142 2.082.641 2.534 1.793-.016.333-.185.548-.488.667-.947 0-1.897.128-2.832-.113l-.732-.79.06-6.247.635-1.97z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#613300"
        d="M190.681 239.333l2.896-.25c.994-.394 2.055-1.12 2.63.537l-4.225.262c-.434-.183-.868-.365-1.301-.549z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FB9E06"
        d="M368.137 222.421c-1.273-.263-1.656 1.08-2.588 1.44-.418.161-.705.748-1.271.145-1.784-1.898-4.061-1.315-6.245-1.154-.937-3.011.724-5.228 2.42-7.323.822-1.016 1.451-1.933 1.22-3.264l1.964-2.367c.819-.15 1.42-.592 1.79-1.342l2.449-1.313c1.4.216.98 1.907 1.984 2.444l.52 1.352c.627.977.564 2.144.891 3.201.854 2.129 1.887 4.249-1.244 5.576-.424.18-.658 1.23-.674 1.975-.037.181-.072.364-.104.545-.372.027-.741.056-1.112.085z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CB9347"
        d="M370.49 214.76l-.111-3.721 1.129 1.436.732 2.343c-.59.179-1.179.281-1.75-.058z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#703DC5"
        d="M377.398 164.854c.572 1.992-.537 3.155-2.174 3.688-1.701.554-3.266.041-4.268-1.609-.863-1.417-.727-2.763.398-3.95 1.363-1.436 2.9-1.826 4.602-.533-.172.633-.656.942-1.217 1.173-.896.399-2.178.67-1.762 1.979.436 1.37 1.545.882 2.475.404.704-.293.81-1.607 1.946-1.152z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6433B6"
        d="M374.771 163.073l1.186-.624c1.121.418 1.379 1.354 1.441 2.405l-1.363 1.909c-.828-1.091-1.437-2.256-1.264-3.69z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5FCFA"
        d="M545.26 290.977c-.049-.713-.141-1.439.59-1.915 1.014.045 2.025.09 3.039.133.201 1.423.514 2.839.586 4.268.227 4.465.193 4.467-4.223 4.294-.01-1.434-.025-2.864-.039-4.298 1.293-.803 1.37-1.629.047-2.482z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D9F7FE"
        d="M551.356 295.982c1.295-.007 1.322.911 1.34 1.835-.008.214-.014.429-.02.643l-1.174-.071-.146-2.407z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6FDEB"
        d="M545.26 290.977c.902.131 2.242-.411 2.326 1.114.098 1.782-1.377 1.25-2.373 1.367.018-.828.034-1.653.047-2.481z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECFDF6"
        d="M562.661 247.28c1.121.445 2.666.904 1.781 2.433-1.287 2.223-2.525-.516-3.928-.087.139-1.57 2.367-.745 2.15-2.348l-.003.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E2FCFB"
        d="M558.959 250.555c-2.168.213-2.168.213-2.236-1.869l2.236 1.869z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F73955"
        d="M362.939 229.808c-.225 1.461 1.213-.073 1.345.749l-.147 9.256c-.404-.025-.802 1.384-1.157.082-.212-.772-.034-1.649-.04-2.479-.02-2.407.603-5.036-2.328-6.421-.197-.093-.115-.778-.162-1.187.829-.668 1.659-.67 2.489 0z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C64663"
        d="M365.4 242.336l1.305 3.673c-3.082-.923-2.56-3.396-2.449-5.693.383.673.764 1.347 1.144 2.02z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EE3C53"
        d="M357.593 243.196c-.291.083-.641.262-.991.262-.376 0-.909-.071-.771-.652.109-.456.574-.513.982-.46.386.048.846.067.78.85z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BD3C60"
        d="M369.686 255.95a2.294 2.294 0 01-.559-.063c.102-.99-.256-2.253 1.385-2.325l-.826 2.388z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FA3949"
        d="M355.456 226.106c.873-.028 1.743-.057 2.616-.083a.708.708 0 01.477.182c.223 3.836-2.748 1.833-4.332 2.37-.907-1.487.61-1.754 1.239-2.469z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4920B8"
        d="M370.428 258.512l.111-2.445 2.369-1.317c-.006.822-.008 1.645-.012 2.466-.42.415-.604 1.062-1.236 1.269-.41.007-.822.016-1.232.027z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5228C0"
        d="M376.693 254.757l-3.775-.001.068-1.156c1.008-.006 2.016-.015 3.021-.021l.686 1.178z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E89D28"
        d="M370.49 214.76c.594-.354 1.178-.292 1.75.058l.584.344c.229 1.344.387 2.688.064 4.039-1.518.4-2.428 1.628-3.537 2.589-.859-.99-.232-2.589.191-2.708 3.263-.912 1.677-2.674.948-4.322z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E48F40"
        d="M403.738 337.057a65.35 65.35 0 01-.875.111c-1.65-.838-3.299-1.674-4.949-2.514-.016-.604-.033-1.209-.053-1.811l2.359.674c.889 1.463 2.932 1.78 3.518 3.54z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FB7809"
        d="M389.132 328.48c.02.381.041.762.063 1.141-.139 1.027-.746 1.477-1.711 1.158-1.211-.404-.691-1.527-.828-2.371l2.476.072z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FA7E14"
        d="M387.91 335.908c.979.121 2.299-.43 2.488 1.256-.977-.129-2.287.408-2.488-1.256z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5F3E3"
        d="M406.509 332.15c-.18.744-.449 1.436-1.068 1.936-.166-.934-.83-2.141 1.068-1.936z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#58A8D4"
        d="M340.443 336.473l-1.222-.033c-.563-.773-.535-1.482.21-2.127 4.119-.668 8.246-1.48 12.285.391 1.367 1.133 3.035.24 4.508.668-3.913.959-7.914.289-11.863.609-1.317.107-2.66-.059-3.918.492z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2686CF"
        d="M349.16 309.725l2.473.052c.478.791-.143 2.158 1.284 2.451-.456 1.885.851 3.376 1.448 4.884 1.186 3.01 2.787 5.805 2.449 9.211-.056.543.593.764 1.11.881.16 1.889-.449 3.918.981 5.584l-.943.631c-1.443 1.326-3.572-.111-5.01 1.238h-.658c-.893-1.039-.865-2.313-.848-3.555.084-6.395-.648-12.656-2.912-18.684-.377-1.01-.623-2.036.626-2.693z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3EA4EB"
        d="M349.16 309.725c-.119.49-.492 1.102-.32 1.448 3.658 7.468 3.562 15.472 3.455 23.483-.193.012-.386.025-.578.047l-12.484-.037c-1.078 1.031-.652 2.561-1.245 3.752l.007-.01c-.705.809-1.25 1.814-2.469 1.975-1.918.242-2.519 2.951-4.773 2.564-1.461-.188-2.002.969-2.717 1.873-1.183.506-1.602-.559-2.521-1.318.381 1.768 1.236 3.326.203 4.869-2.223 1.021-2.772-1.377-4.18-2.037-.61-.533-1.168-1.109-1.498-1.869-.297-.787-.336-1.611-.354-2.438-.008-1 .018-1.994.233-2.975.638-3.555 1.396-7.084 2.438-10.545.42-2.16 1.344-4.189 1.652-6.377.128-2.469-.09-4.947.123-7.413.071-.828-.175-.826-.768-.503-1.703-1.315-1.405-3.506-2.299-5.171-.324-1.865-2.459-1.826-3.311-3.138-.156-.458-.102-.877.223-1.247h-.008c1.35-1.008 3.563-.146 4.477-2.084.156-.254.354-.469.584-.654.266-.146.546-.235.844-.289 1.311-.188 2.192.839 3.322 1.17.738.307 1.229.828 1.42 1.615.032 1.684.969 2.85 2.221 3.834 1.104 1.795 3.098 1.84 4.807 2.44 2.709 1.331 5.397.676 8.082-.074 2.223 1.67 2.828-1.068 4.258-1.566l1.176.675z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2E84C1"
        d="M352.953 334.656c1.155-2.498 3.369-.705 5.01-1.238-1.16 2.477-3.366.725-5.01 1.238z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1B1E66"
        d="M430.309 303.389l-3.695.058c1.201-1.918 2.433-1.909 3.695-.058z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9BE6C"
        d="M425.342 307.202c3.217 1.712 4.512-.933 6.18-2.728-.076-.128-.068-.248.029-.361 2.336 2.061 4.242.023 6.291-.661 0 .837.002 1.671.004 2.505-.088.114-.178.229-.264.345-1.029.58-1.961 1.423-3.258 1.324-1.441-.109.59.764-.236.815-2.197 2.178-4.779 2.03-7.471 1.234-.419-.825-1.372-1.377-1.275-2.473z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FCDCB3"
        d="M345.463 302.173c-.895.677-.563 1.673-.667 2.557a1.424 1.424 0 01-.801.316c-2.736.291-5.511.901-8.028-.857a5.122 5.122 0 01-.687-.475c-.578-.618-1.378-.826-2.133-1.121a2.654 2.654 0 01-.676-.533c-.99-1.312-2.138-2.526-2.58-4.178-.219-1.148-.291-2.276.44-3.297 3.284-4.052 7.68-3.504 12.082-2.933.294.109.55.282.767.505.797 1.434.171 3.001.434 4.226.227-1.396-.48-3.151.477-4.75.895-.536 2.037-.737 1.996.565-.053 1.872.567 3.878-.62 5.637 0 1.446-.002 2.893-.004 4.338z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FBDCB1"
        d="M345.467 297.835c.045-1.729.095-3.455.133-5.184.036-1.7-.706-.965-1.38-.435-.415.37-.832.37-1.249.003-1.243-1.137-2.767-.469-4.159-.618-1.039-.111-2.176-.016-2.502-1.318-.336-1.341.236-2.199 1.621-2.471.697-.137.967-.712 1.271-1.254l.015-.023c.21.013.422.026.631.041 1.173.943 2.059-.034 3.027-.453.772 1.61 1.943 2.575 3.84 2.354.479.909 1.373 1.534.58 2.938-.746 1.32-.713 3.038-.588 4.632.07.902-.124 1.679-1.24 1.788z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7112E8"
        d="M371.66 258.483c.029-.795.469-1.193 1.238-1.269-.002 1.119-.002 2.236-.002 3.545-1.71-.386-.984-1.554-1.236-2.276z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5A322"
        d="M436.584 309.688c-.42-.007-.84-.011-1.258-.015.006-.409.012-.815.02-1.222.227-1.44 1.678-1.654 2.502-2.497l-.002.002 1.242-.006c.321 2.021-2.156 2.166-2.504 3.738z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5A322"
        d="M439.088 305.951c.51-1.463.555-3.236 2.506-3.73.139 1.897-.629 3.184-2.506 3.73z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#8EA5A6"
        d="M344.24 304.787c.188-.013.372-.032.557-.058.834.385 1.668.771 2.5 1.153-.607.158-1.425-.188-1.72.717.437.682.458 1.348-.075 1.993-.552.257-1.063.219-1.521-.207-.674-1.253-.781-2.466.259-3.598z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3BA3ED"
        d="M345.451 308.413c.041-.605.083-1.208.126-1.813 1.421.212 2.487.766 2.404 2.451-.433.819-.729 1.763-1.331 2.431-.951 1.054-1.938 1.157-2.428-.516.035-.133.068-.266.099-.396.336-.741.511-1.566 1.13-2.157z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9AF22"
        d="M455.288 340.283c.799-.779 1.629-1.531 2.391-2.346.645-.684 1.445-1.078 2.148-.42.873.816.225 1.57-.369 2.383-.666.904-1.859.752-2.576 1.564.58 1.184 2.25.359 2.803 1.703-2.037.684-4.461-.5-6.258 1.195-.203-.324-.408-.646-.611-.967-.674-.668-.236-1.467-.268-2.211.08-.264.234-.469.471-.613.71-.458 1.593.433 2.269-.288z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9AF25"
        d="M452.813 308.439c.678 1.826 3.004 2.002 3.76 3.752-.08.697.285 1.649-.41 2.013-.805.424-1.205-.584-1.709-1.016a23.696 23.696 0 01-2.627-2.627c-.43-.505-1.438-.903-1.025-1.708.363-.701 1.316-.332 2.011-.414z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F3B130"
        d="M463.18 338.02c-.898-2.184.301-4.875-1.494-6.889-.338-.379.049-1.223.836-1.348 1.09-.168 1.508.438 1.512 1.426.01 2.248.004 4.498.004 6.746l-.858.065z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7B74C"
        d="M452.708 341.482c.885.59-.113 1.285.107 1.914-1.225.453-2.336 1.25-3.721 1.227-1.033-1.043-.475-2.385-.668-3.584-.064-.746.133-1.42.555-2.031l.053-.02a.636.636 0 01.738-.088c.684.625.465 1.764 1.311 2.299.539.141 1.115.024 1.625.283z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FAB11F"
        d="M457.815 322.174c-1.363 1.443-1.363 1.443-4.971.871 1.775-1.037 3.008-2.33 4.967-2.115.369.412.373.828.004 1.244z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9ECDB"
        d="M457.792 335.895l-1.846 1.27c-.219.242-.461.256-.727.082.133-1.73.176-3.455-.346-5.146.078-.279.225-.518.445-.705.803.693 1.604 1.389 2.404 2.082.8.784.737 1.592.07 2.417z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F2A420"
        d="M449.01 340.922c.029 1.234.057 2.467.084 3.701-.465.604 1.061 2.512-1.248 1.906-.008-1.459-.014-2.92-.023-4.379.531-.279.058-1.527 1.187-1.228z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F8E5CA"
        d="M455.286 337.113c.221.016.439.033.66.051-.605.848-1.213 1.693-1.82 2.541-.371.334-.787.352-1.23.162a1.243 1.243 0 01-.408-.766c.466-1.318.993-2.548 2.798-1.988z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E9B258"
        d="M455.323 329.662c1.803.584-.559 1.152-.004 1.732l.025.268c-.688.375-1.229.139-1.695-.41-.33-.578-.645-1.158-.111-1.789.644-.367 1.238-.285 1.785.199z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5C06E"
        d="M457.792 335.895l-.068-2.418c.928-.035 1.326.445 1.297 1.334-.026.791-.521 1.06-1.229 1.084z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EAB43F"
        d="M455.323 329.662c-.637.008-1.275.016-1.914.021-.281.158-.539.125-.771-.102a1.401 1.401 0 01-.061-.861c.1-.111.195-.221.293-.334.963.149 2.263-.355 2.453 1.276z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F2B652"
        d="M450.241 328.395c.041-.4.084-.803.127-1.203.998.053 2.232-.383 2.502 1.197 0-.002-.186.113-.186.113-.656.566-1.371.586-2.129.225-.105-.11-.209-.223-.314-.332z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5B03C"
        d="M457.815 322.174c0-.414-.002-.83-.004-1.244.727.156 1.648-.371 2.172.621-.52.996-1.441.469-2.168.623z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EAB457"
        d="M452.969 339.787l1.156-.082c.242.486.689.559 1.164.578-.637.887-1.6.547-2.445.65-.322-.421-.345-.81.125-1.146z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F4DFB7"
        d="M439.754 355.85c.988.35 3.035-.672 2.859 1.191-.172 1.846-2.416 2.098-3.969 2.527-1.328.365-2.082-.332-2.063-1.863.033-2.447 1.834-1.646 3.173-1.855z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DFFDF6"
        d="M555.432 203.906l2.199-.796c.084.291.219.491.172.632-.445 1.356-1.328 1.146-2.371.164z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FC7C0A"
        d="M406.619 337.135c.908-2.467.908-5.238 2.517-7.465 3.844 2.744 1.037 6.238.965 9.396-.014.607-.939 1.697-1.778 1.379-1.388-.523-1.9-1.812-1.704-3.31z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FA7C22"
        d="M402.066 342.814c1.391-.898 2.773-.668 4.162-.148-1.346.984-2.748.797-4.162.148z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E08E4B"
        d="M449.588 339.025a3.806 3.806 0 01-.553-.037c.014-2.695.008-5.391.055-8.086.018-.977-.326-2.178 1.15-2.508l.225.119c.674.867.58 1.945.82 2.939.041.305.049.609.029.916-.37 2.275.042 4.751-1.726 6.657z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F09E1D"
        d="M449.01 340.922c-.395.41-.791.82-1.188 1.229l-.615-1.869c.631-.369.857-1.303 1.773-1.273.011.637.02 1.276.03 1.913z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FCBC5E"
        d="M437.848 305.955c-.188 1.48-1.617 1.716-2.502 2.497-.42-.005-.84-.009-1.258-.011-.057-.447-.955-1.063-.529-1.076 1.615-.049 2.617-1.762 4.289-1.41z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EF1F34"
        d="M304.269 423.279l1.25.004c.363.354.391.764.218 1.211-.184.23-.414.406-.683.525-1.701.225-3.248.801-4.525 1.994l-.004.016c-.834-.012-1.667-.021-2.5-.033.053-1.928-.285-3.371-2.567-1.742-.866.617-1.763.518-2.672.518-9.857.014-19.715-.012-29.573.033-1.581.006-2.827-.311-3.776-2.52h37.351c2.493-.949 4.987-.951 7.481-.006z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F01B3E"
        d="M254.273 425.816c-1.335-.955-2.686-1.893-3.62-3.289l2.319-2.797.124 2.307c-.488 1.314 1.019.65 1.246 1.254.593 1.068 2.488.85 2.48 2.512l-2.549.013z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3A1D53"
        d="M306.803 425.797l-.037 1.23c-1.226.018-2.452.037-3.676.057-.021-.23-.042-.459-.065-.691.017-1.787 1.967-.834 2.561-1.805h-.014c.426-.432.825-.359 1.207.064l.024 1.145z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D4244A"
        d="M305.586 424.588c-.135 1.621-2.015.768-2.561 1.805-.786.393-1.582.748-2.496.621.796-2.666 2.889-2.625 5.057-2.426z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#45A0ED"
        d="M312.915 358.33l.159-2.436a1.92 1.92 0 011.241-.588c1.487.072 2.613.879 3.663 1.83.807.025 1.256.416 1.277 1.246l-.002 3.738c-2.313-.762-4.028 1.426-6.219 1.258l-.101-1.098c-.713-1.313.71-2.637-.018-3.95z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D8283A"
        d="M306.778 424.652l-1.207-.064-.052-1.305c.845.014 1.688.029 2.533.047l-1.274 1.322z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F61C39"
        d="M314.271 402.055c-.059 3.135.291 6.314-1.247 9.949 0-3.252.006-5.875-.002-8.498-.003-.86.403-1.338 1.249-1.451z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F4201C"
        d="M304.269 423.279l-7.482.006c1.044-1.1 7.074-1.836 8.104-.945.037.031-.404.613-.622.939z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E5281F"
        d="M254.342 423.291c-.78-.055-1.949.273-1.246-1.254.721.121 1.679-.363 2.104.473.33.65-.441.646-.858.781z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3CA4EE"
        d="M330.486 342.15c.938-.117 2.219.371 2.45-1.107.265-1.68 1.491-1.326 2.556-1.387 2.016 2.879-.286 5.354-.94 7.883-.507 1.965-1.031 3.943-1.547 5.918-.038.668-.03 1.354-.61 1.844-2.216.193-3.118-1.709-4.521-2.818-.789-1.158-1.855-2.107-2.576-3.322a.758.758 0 01.197-.766c-.113-1.393.344-2.844-.848-4.09-.588-.609-.644-1.596.438-1.994.78-.287 1.458-.025 1.604.9.124.797.402 1.381 1.303 1.436.203.055.385.15.564.248.93.516 1.811 2.018 2.891.963.781-.764-.683-1.492-1.033-2.293-.223-.502-.36-.963.072-1.415z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#50A4DB"
        d="M333.004 353.457c-.426-3.24.762-6.133 2.036-8.967.724-1.605.266-3.23.451-4.834.835-.414 1.667-.832 2.502-1.248-.828 2.914-1.654 5.826-2.48 8.74l-2.509 6.309z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5B8CA9"
        d="M328.123 352.057c1.423 1.084 2.848 2.164 4.271 3.244-.01.652.073 1.336-.635 1.732l-.695-.363c-1.107-1.045-2.678-1.563-3.436-3.012-.313-.504-.611-1.012-.302-1.631.273-.162.538-.162.797.03z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#50A4DB"
        d="M337.987 338.418c.401-1.256-1.017-3.115 1.245-3.752-.004.592-.009 1.182-.011 1.773-.413.659-.823 1.319-1.234 1.979z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F4DDBA"
        d="M327.292 352.178c.223.391.445.785.668 1.178.404.865 1.109 1.582 1.277 2.564l-.619 1.203a1.06 1.06 0 01-1.334-.418c-1.845-2.912-4.497-2.102-7.094-1.6-2.113.326-3.408-.516-3.793-2.654.521-2.086 3.211-2.111 3.873-4.066 1.532-.9 2.434.428 3.467 1.064 1.02.631 1.914 1.471 2.979 2.057.247.178.438.402.576.672z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FADAAF"
        d="M320.488 354.654c.079-.861.543-1.326 1.414-1.193.377.057.828.57 1.061.469 3.361-1.496 3.998 1.748 5.656 3.193.496.766 1.922 1.076 1.308 2.383-.95 2.021-2.112-1.201-3.13.08-.291-1.516-1.521-1.131-2.508-1.242-1.456-1.033-4.039-.906-3.801-3.69z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF8F8"
        d="M329.238 355.92c-.51-.813-1.682-1.295-1.277-2.564l3.104 3.314c-.925.519-1.092-.811-1.827-.75z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E0E7D1"
        d="M320.488 354.654c.485 2.037 2.971 2.012 3.801 3.691-.439.012-.883.025-1.324.039-1.764-.613-2.973-2.342-4.973-2.48-1.047.371-1.577-.479-2.268-.953-.682-.73-1.806-1.156-1.711-2.434.254-.689.812-.893 1.475-.943.498.021.936.174 1.262.572.563 1.854 1.853 2.625 3.738 2.508z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#46A1E5"
        d="M316.269 354.561c.574.447 1.148.896 1.723 1.342-.005.412-.008.822-.014 1.234-1.506.355-2.346-1.24-3.72-1.273-.478-2.208.832-1.653 2.011-1.303z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#312361"
        d="M225.637 218.573c-.796.04-1.611-.105-2.329.438-2.41 1.827-2.706.325-2.65-1.704 2.138.192 3.917-.768 5.682-1.771.384.142.779.257 1.12.495 1.095.899 2.749.148 3.768 1.269a.78.78 0 01.257.531c-.17.574-.574.935-1.087 1.197-1.646.475-3.244.43-4.761-.455z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A94A7F"
        d="M226.883 216.205l-.543-.669.588-.574c1.703-1.71 1.292-4.816 3.915-5.922.753.226.934.833 1.019 1.509-.045 1.687-.831 3.146-1.417 4.672-.76 1.984-1.966 2.138-3.562.984z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#450C2F"
        d="M230.606 209.2c-.809 1.056-1.18 2.274-1.508 3.554-.272 1.063-.849 2.063-2.17 2.208l-.014-2.596c.24-.921.459-1.852 1.228-2.515 1.446.162 1.031-2.107 2.5-1.915.318.43.378.854-.036 1.264z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5B132B"
        d="M221.85 207.902l.1.739c.081 2.81-3.091 4.076-3.22 6.786a8.038 8.038 0 01-.58.044c-1.198-1.621-.589-3.007.558-4.322.496-.78.938-1.617 1.922-1.907l1.22-1.34z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#0F1F38"
        d="M228.142 209.85c-.114.982.422 2.283-1.228 2.515-1.884-.546-1.478-1.575-.493-2.618.534-.564 1.27-1.832 1.721.103z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#964778"
        d="M230.606 209.2l.035-1.265.699-1.749c1.13-.434 2.101-.621 1.803 1.162l-.021.405c-.15 1.219-.208 2.496-1.781 2.815-.08-.543-.17-1.083-.735-1.368z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#41284E"
        d="M235.63 208.588c-2.354 1.509-2.216 4.431-3.661 6.457-1.298-1.279-.787-2.707-.138-3.979.616-1.21.906-2.486 1.271-3.756l.04.038c.684.706 1.361 1.425 2.488 1.24z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4B1C48"
        d="M233.104 207.311c.5 2.707-2.008 4.972-1.134 7.734l-.742 2.255c-1.441-.395-3.356 1.089-4.344-1.096 1.581.506 2.62.201 3.032-1.642.306-1.369.938-2.665 1.425-3.993l1.763-3.258z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2E2556"
        d="M230.626 218.568l.858-.738c1.672.662 3.292 1.394 4.192 3.099l-.077.783c-.688-.015-.903-1.38-1.851-.646-1.529.067-2.086-1.264-3-2.083a22.558 22.558 0 01-.122-.415z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7714D0"
        d="M233.13 392.076c-.005-4.51-.031-9.018.001-13.527.007-1.045-.422-2.365 1.185-2.764.432.451.449.938.127 1.455l-.07 14.854c-.419.353-.833.353-1.243-.018z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7A10DE"
        d="M236.902 402.033c-1.106-.035-1.279-.775-1.287-1.67-.009-.914.083-1.91-1.226-2.059-.359-.438-.365-.891-.061-1.359.481-.262.943-.242 1.383.096.652.703 1.098 1.51 1.209 2.479.554.841.716 1.681-.018 2.513z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#8111CF"
        d="M234.443 377.24l-.127-1.455c.512-1.191-.986-3.125 1.346-3.645-.273 1.733.865 3.801-1.219 5.1z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#8117BB"
        d="M235.711 397.041l-1.284.002c-.375-.379-.432-.781-.082-1.209l-.056-1.25c-.316-.512-.279-.98.172-1.4 1.841.826.972 2.527 1.25 3.857z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#700EE7"
        d="M234.461 393.184l-.17 1.4c-1.595-.279-1.046-1.547-1.161-2.508.415.004.829.01 1.243.016l.088 1.092z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#AC26A1"
        d="M236.902 402.033l.019-2.514c1.583.207 1.084 1.502 1.276 2.436l-.24.324c-.408.154-.775.133-1.061-.244l.006-.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A120A7"
        d="M239.332 404.592c-.403-.01-.805-.023-1.207-.035-.65-.773-.702-1.566-.082-2.383l.154-.217c.959.629 1.406 1.479 1.135 2.635z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F3DBB8"
        d="M312.365 350.945l-.669-.561c-.197-1.006-.875-1.6-1.739-2.033l-.015-.016c-1.654-3.982-1.26-8.279-1.897-12.416-.054-.334-.106-.668-.158-1.002a.941.941 0 00.203-.291c3.082-1.51 5.946-.891 8.696.877.297.436.368.906.202 1.408-.278.461-.712.699-1.226.838-3.7 1.002-4.621 3.645-2.397 6.887.22.428.342.883.402 1.359.075 1.162.121 2.322-.123 3.473-.203.686-.558 1.241-1.279 1.477z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F4DDBA"
        d="M312.365 350.945c.216-.436.432-.869.648-1.301.897-.639.385-1.869 1.088-2.588 1.42-.074 2.867-.578 4.236.26.875 2.664-1.264 3.557-2.813 4.797-.511.035-.993.129-1.234.668-.261.246-.437.18-.535-.152-.463-.561-.925-1.123-1.39-1.684z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FAC3AA"
        d="M308.044 335.92c1.687 1.117.296 2.719.6 4.08.609 2.738.884 5.555 1.297 8.336-2.194-1.746-1.345-4.369-1.779-6.586-.369-1.877-.103-3.883-.118-5.83z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6D99C1"
        d="M313.755 352.629c.162.111.34.16.535.152l1.978 1.781c-.84.172-1.93-.043-2.01 1.301l-1.185.031-.173-1.268c.286-.665.571-1.329.855-1.997z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FAC3AA"
        d="M309.957 348.352c2.175-.688 2.333.35 1.74 2.033l-1.74-2.033z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9187BD"
        d="M306.908 324.717l1.106-.09c1.037.977.77 2.268.839 3.477.003.527-.012 1.053-.12 1.574-.269.879-.583 1.707-1.785 1.395l-.304-.268c.027-1.844.056-3.691.081-5.535.057-.186.117-.37.183-.553z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#46A1E5"
        d="M312.915 358.33c3.327 1.301-.273 2.635.019 3.951-1.697-.311-.799-1.766-1.172-2.66.151-.639.248-1.326 1.153-1.291z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4DAAEF"
        d="M308.091 329.684l.026-1.238c1.083-1.963-.032-4.559 1.815-6.305.172-.26.363-.504.555-.744.854-1.877.301-3.857.447-5.782.085-1.119-.088-2.274.547-3.304.25-.279.559-.412.933-.406.836.178 1.265.821 1.289 1.545.136 4.17 1.027 8.408-.882 12.436-.319 2.158-1.791 4.029-1.565 6.33-.093.539-.291 1.025-.691 1.416-.893.496-1.731.426-2.515-.24-.03-.398-.062-.797-.094-1.193.274-.83 1.075-1.627.135-2.515z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#71ACCE"
        d="M308.05 333.391c.822.006 1.645.01 2.467.018.71-.629 1.557-.848 2.483-.834 1.236.012 2.487-.086 3.672.406.804 1.078 3.542.621 2.519 3.156-.894.531-1.712.404-2.466-.279-2.764-1.227-5.71-1.16-8.636-1.23l-.039-1.237z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#38B6EE"
        d="M308.091 329.684c.685.08 1.111.398 1.138 1.15.032.896-.449 1.279-1.272 1.363-.675-.072-1.069-.396-1.008-1.125.709-.193 1.027-.709 1.142-1.388z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B236D"
        d="M240.613 237.295c-1.786.049-.832 1.85-1.714 2.669-.275-.984-.819-1.905-.721-2.751.5-4.295-.697-7.979-3.309-11.394-.809-1.057-1.308-2.73.752-3.504 2.434 3.534 5.706 6.689 5.018 11.599-.154 1.107-.025 2.253-.026 3.381z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#30245D"
        d="M320.492 239.783l.012-7.475c-.662-.821-.672-1.649-.02-2.48.076-1.792-.012-3.375-1.96-4.423-1.181-.634-.333-2.123-.435-3.225 1.669.051 1.985 1.618 2.875 2.546 1.145 1.639 1.823 3.501 2.582 5.329.15.47.231.949.262 1.439-.047 2.191.314 4.396-.242 6.567-.57 1.077-1.264 1.994-2.65 1.983-.139-.086-.283-.173-.424-.261z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#332067"
        d="M292.721 246.915c-1.932-1.476-4.281-2.249-2.433-5.703 1.253-2.343-.098-5.646.896-8.5 1.11 4.663-.253 9.593 1.537 14.203z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3A205A"
        d="M298.046 254.755l-.034-1.214c2.505 0 5.007-1.038 7.514-.021.805-.625 1.642-.733 2.524-.169.357.502.361 1.008.01 1.515-3.357 1.705-6.687.919-10.014-.111z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F59F0F"
        d="M320.468 224.838l-2.379-2.658a.41.41 0 00.028-.35l2.223-2.079c.411-.274.843-.344 1.307-.155.438 1.259.159 2.98 2.665 2.324 1.487-.391 1.988 1.188 1.496 2.555-.437 1.217-1.371 2.013-2.738 2.165-1.342.083-1.784-1.13-2.602-1.802z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#371C6D"
        d="M287.743 232.74v9.104c-1.08-3.016-1.024-6.052-.77-9.092.257-.003.513-.007.77-.012z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#30245D"
        d="M320.545 246.028c-.047.814-.449 1.255-1.29 1.239-.678-.83-.665-1.659.002-2.488.037-1.506-1.031-1.706-2.451-1.788 2.313-.138 2.063-2.677 3.686-3.209l.021.021c.929 1.07.877 2.363.837 3.655-.007.939-.159 1.832-.805 2.57z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#342160"
        d="M316.626 224.941c-.117 1.867.999 3.549-.821 4.734-.413.268-1.151.062-1.321-.456-.576-1.755-.186-3.196 2.142-4.278z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#421F52"
        d="M286.868 247.265c-.075-1.364-1.687-2.172-1.336-3.691 2.807 1.138 3.153 4.296 5.062 6.172-.258.305-.551.342-.878.111-1.565-.189-1.616-2.04-2.848-2.592z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#30245D"
        d="M316.757 247.283c-1.544.465-3.844 3.196-3.744-1.251.411-.366.825-.369 1.241-.007.833.797 1.676-2.547 2.505.005.374.419.33.836-.002 1.253z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#521754"
        d="M308.06 254.866l-.022-1.313c.381-.354.781-.408 1.207-.083 1.472-.522 2.774-1.707 4.522-1.146l-.778 1.157c-.993.133-1.874.509-2.613 1.197l-2.316.188z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#401CA0"
        d="M287.991 222.898c.343 2.109-1.5 3.016-2.43 4.426-.382-.291-.546-.697-.624-1.153a3.702 3.702 0 01.07-1.335c.208-.749.679-1.294 1.333-1.696.522-.264 1.048-.52 1.651-.242z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5521C8"
        d="M290.649 219.937c-.023 1.036-1.04 1.505-1.355 2.375l-.003.002-1.228.032c-.407-.336-.557-.787-.579-1.298.156-1.491 1.062-1.92 2.421-1.707.325.101.573.301.744.596z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1F2972"
        d="M309.244 253.47l-1.207.083-2.512-.032c1.215-1.925 2.454-1.909 3.719-.051z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#441A57"
        d="M289.715 249.856c.293-.036.585-.075.877-.111 1.271.426 2.182 1.185 2.4 2.589-1.552-.218-2.505-1.229-3.277-2.478z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5521C8"
        d="M292.992 217.914l.066.673c-.195 1.539-1.461 1.159-2.41 1.348 0 .002-.172-.186-.172-.186-.229-2.077.896-2.296 2.516-1.835z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#36236A"
        d="M316.757 247.283l.002-1.253 1.236.004c.349.428.387.861.018 1.298-.002.796-.428 1.182-1.196 1.236-.755-.393-.13-.853-.06-1.285z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#23217D"
        d="M318.013 247.332l-.018-1.298c.027-.813.445-1.233 1.262-1.254l-.002 2.488-1.242.064z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#572158"
        d="M295.483 253.565l-2.37-.192c-.048-.338-.095-.676-.144-1.012 1.01.042 2.351-.607 2.514 1.204z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#24247B"
        d="M316.433 231.697c-.076.52-.5.547-.902.544-.399-.002-.89-.015-.887-.568.004-.545.489-.566.889-.566s.84.005.9.59z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#371C7C"
        d="M320.484 229.828l.02 2.48c-.861-.066-1.256-.526-1.205-1.392.042-.755.506-1.032 1.185-1.088z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2C2753"
        d="M289.294 222.312c1.01.109 1.379.691 1.123 1.636-.054.2-.473.508-.566.46-.924-.476-.396-1.381-.56-2.093l.003-.003z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#172C72"
        d="M314.254 246.024l-1.241.007c.066-.749-.197-1.596.509-2.227 1.11.578.592 1.496.732 2.22z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5121BC"
        d="M285.543 226.053l.018 1.271-.064 1.157-1.161.118c-.386-.288-.517-.691-.532-1.152.025-.297.103-.581.236-.848.398-.467.818-.873 1.503-.546z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#601CE1"
        d="M288.042 221.064l.022 1.281a3.966 3.966 0 00-.072.553l-1.207.606c-.555-1.315-1.208-2.679 1.257-2.44zM284.291 227.305l.045 1.294c-.252 1.344-1.343 1.4-2.134.956-2.064-1.161-4.391-1.159-6.578-1.59-2.857-.563-3.513-1.873-2.516-4.391.75-.635 1.066-2.067 2.536-1.388.785.74.274 1.756.534 2.637 1.105.229 1.225-.884 1.828-1.311 2.031-1.442 4.353-.545 4.21 1.893-.117 1.99 1.406 1.28 2.075 1.9z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5624D1"
        d="M275.56 222.31l-2.453 1.264-.023-1.248c1.065-1.53 2.346-2.945 2.579-4.911 1.039-.018 1.263-1.521 2.418-1.324 1.462.94.688 1.996-.031 2.792-.96 1.065-1.52 2.391-2.49 3.427z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F3A00F"
        d="M331.738 249.779c-1.335.909-2.552.739-3.613-.445-.783-.875-1.615-1.164-2.627-.39-.23-.128-.462-.254-.693-.383-.482-.594-1.348-.655-1.803-1.288-.621-.417-1.238-.836-1.859-1.254-.663-.966.061-1.767.309-2.627.304-.39.684-.667 1.172-.783 2.018.167 4.264-.224 5.374 2.182.085 1.151 1.017 2.064 1.78 2.199 1.796.323 1.737 1.57 1.96 2.789z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#67341D"
        d="M321.771 243.581l-.629 2.439-.299.02-.298-.012c.005-.813.009-1.627.015-2.44.4-.427.805-.359 1.211-.007z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#734135"
        d="M323.001 247.274c.836.101 1.504.434 1.803 1.288-.891-.021-1.762-.073-1.803-1.288z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7DCB9"
        d="M339.202 286.559c-.034.702.147 1.552-.782 1.795-.959.251-1.928.478-1.537 1.759.375 1.224 1.518.791 2.377.843 1.027.063 2.061.02 3.09.015 1.05-.002.802.64.622 1.25-1.951 0-3.904-.054-5.853.015-1.776.064-3.981-.834-4.467 2.212-.178 1.106-1.414.16-2.152.27-.252.235-.55.338-.893.313a1.088 1.088 0 01-.748-.586c-.185-.97-.584-2.037.984-2.238.328.321.915 1.834 1.023.465.174-2.206 1.383-3.69 2.26-5.438 1.432-.047 2.911.227 4.219-.635.637.989 1.242.213 1.857-.04z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DECBC6"
        d="M329.843 292.204c-.893.677-.521 1.649-.594 2.519a.913.913 0 01-.787.126c-.516-.278-.84-.728-1.109-1.23-.584-.854-.026-1.927-.549-2.796.176-.607-.27-1.393.519-1.827.522.571 1.384.221 1.932.72.592.734.517 1.629.588 2.488z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#221E53"
        d="M326.746 285.978l.012-2.512c1.639.23 1.128 1.523 1.239 2.509-.417 0-.835 0-1.251.003z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FCF1F7"
        d="M329.254 289.715c-.69-.111-1.795.885-1.932-.72.03-.158.042-.316.042-.475.881.002 1.85-.136 1.89 1.195z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#221E53"
        d="M325.5 285.973l1.243.007c-.208.624-.415 1.249-.62 1.874-.732-.455-.606-1.19-.623-1.881z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5626BC"
        d="M325.466 293.471l-.01-.638c-.297-.457-.353-.9.086-1.309.37.293.742.586 1.113.881.78.544.622 1.606 1.242 2.24.548.766.826 1.615.836 2.556-.008.946.003 1.9-.771 2.619-.278.162-.58.225-.9.188a1.31 1.31 0 01-.715-.545c-.451-1.581-1.358-3.033-1.391-4.743.099-.445.241-.874.51-1.249z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5B1EE1"
        d="M325.542 291.524c-.027.437-.058.872-.086 1.312-2.038-1.391-2.854-3.295-2.404-5.729 1.865.887 2.246 2.612 2.49 4.417z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#452861"
        d="M327.361 294.678c-.928-.544-.584-1.48-.703-2.274.047-.526.098-1.053.146-1.581.535.85.998 1.725 1.07 2.753-.109.396-.119.838-.513 1.102z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#35285A"
        d="M202.661 222.232c.177-.007.353-.023.529-.049l.077.124c1.375.578 2.755 1.365 4.086-.09.227-.187.482-.308.768-.37a1.63 1.63 0 011.214.374l.148.128c.289.369.472.779.484 1.253-.028.477-.179.896-.567 1.2-3.437-.875-3.155 1.849-3.675 3.797.716.721.567 2.077 1.782 2.434.563.094 1.413-.167 1.511.619.081.654-.675.595-1.163.64-.892.082-2.256-.092-2.088 1.175.473 3.557-1.91 4.406-4.468 5.272-.29.099-.433.629-.644.958l-3.793.05c-.266-.406-.355-.83-.128-1.287.385-.483.907-.764 1.469-.982 1.294-.551 3.182.163 3.813-1.799.496-1.036.255-2.243.75-3.277.818-1.016.934-2.22.906-3.462-.006-.795.291-1.623-.303-2.337a5.832 5.832 0 01-.526-.563c-.312-.423-.61-.855-.924-1.279a2.543 2.543 0 01-.48-1.173c.098-.731.047-1.597 1.222-1.356z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C94463"
        d="M219.353 211.061c-.912 1.331-1.631 2.714-1.203 4.411a3.115 3.115 0 00-.023.587c-1.371 1.249-2.644 2.826-4.804 1.437-.146-1.941 1.396-1.209 2.315-1.462.443-.375.793-.84 1.216-1.233l.053-2.475c-.41-.715.272-.886.61-1.229.201-.018.401-.037.602-.059.419-.331.829-.297 1.234.023z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#21286A"
        d="M225.637 218.573l4.989-.004.002.012c.316.83 2.703 1.66 0 2.489-2.006-.148-3.803-.713-4.991-2.497z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B236D"
        d="M230.629 221.069c1.484-.83-.079-1.66 0-2.489 1.364.422 2.262 1.43 3.12 2.486-1.04 1.442-2.079 2.125-3.12.003z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1D2B6A"
        d="M213.151 226.052c-.136.997.436 2.521-1.383 2.397-1.532-.103-.969-1.469-1.103-2.381.318-.391.747-.54 1.232-.565.49.018.897.227 1.254.549z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#331E72"
        d="M211.909 226.055l-1.244.013c-.814-.028-1.237-.45-1.265-1.265l.007-1.234c.828-.671 1.658-.671 2.49-.008l.01.011c.664.827.664 1.656.002 2.483z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#491854"
        d="M213.323 217.496c1.86.388 3.245-.816 4.804-1.437-.632 2.765-2.833 2.541-4.9 2.57a.884.884 0 01-.394-.627.67.67 0 01.413-.585l.077.079z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#272182"
        d="M207.507 231.035c-1.98.204-1.934-1.079-1.783-2.437 2.525-.598 1.868 1.128 1.783 2.437z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A6305A"
        d="M209.335 222.222l-1.219.004c-.732-1.279.255-1.88 1.013-2.574.417-.215.847-.25 1.289-.078l.306.323-1.389 2.325z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#411C58"
        d="M211.909 226.055l-.001-2.483c1.694.186 1.112 1.512 1.243 2.481l-1.242.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#24266F"
        d="M211.897 223.561l-2.49.008.076-1.219c.976.064 2.231-.433 2.414 1.211z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A6305A"
        d="M213.219 217.989l.007.639a4.79 4.79 0 01-2.503 1.269l-.155-.19c.274-1.516 1.197-2.027 2.651-1.718z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#631AEB"
        d="M211.902 263.507c-.042-.888-.6-1.177-1.395-1.294-.552-.079-1.092-.754-.544-.97 2.241-.879 2.812-4.088 5.686-3.975 2.328.916 1.606 3.356 2.497 4.993-.33 1.698-1.684 2.729-2.615 1.711-1.357-1.479-2.516.099-3.622-.462l-.007-.003z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5E4324"
        d="M197.018 238.516l-.155 1.234a54.093 54.093 0 01-.655-.13c-.766-.72-1.766-.293-2.629-.537.148-.137.274-.293.377-.466.99-.986 2.012-.954 3.062-.101z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#934173"
        d="M193.896 332.18c.213.018.427.035.641.051.965 1.148.761 2.545.762 3.871.018 20.617.016 41.234.002 61.854-.001 1.232.135 2.498-.496 3.65-.147.148-.296.291-.445.438-.161.008-.323.021-.483.035.008-23.3.013-46.599.019-69.899z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DF4565"
        d="M195.678 408.309c.292 1.732 1.667 1.195 2.688 1.207 4.518.051 9.037.031 13.555.037-3.583 1.324-7.296.492-10.935.535-7.494.09-6.487.986-6.567-6.506-.006-.514-.038-1.025-.058-1.539l.136.033a.944.944 0 01.821-.271c.292.123.53.309.713.57.225.422.334.879.383 1.354.049 1.268.18 2.543-.19 3.791a3.884 3.884 0 01-.546.789z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B1923E"
        d="M321.767 219.871c-.475-.041-.949-.08-1.427-.12.496-1.355 1.569-2.199 2.679-3.01.031.214.063.428.098.642.441 1.313.174 2.241-1.35 2.488z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5324E5"
        d="M234.345 395.834l.082 1.209-.038 1.262-.242 2.783c-.856-2.356-2.15-3.938.198-5.254z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7713D9"
        d="M238.043 402.174l.082 2.383c-1.698-.213-1.15-1.52-1.229-2.521.382.044.765.089 1.147.138z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5C1DEC"
        d="M325.485 294.723c.225 1.698 1.725 3.095 1.171 4.974-.792 1.461-2.955.787-3.676 2.357l.023.156c-.986.742-1.982.915-3.002.063-.664-.023-1.328-.045-1.993-.066-.21-2.868.282-5.271 3.937-4.995 2.013.152.525-2.616 2.302-2.498.411.293.83-.383 1.238.009z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5F20E0"
        d="M311.766 305.949c-.021.807-.436 1.224-1.242 1.251.118-1.536-.302-3.143.492-5.031 1.103 1.416.594 2.661.75 3.78z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5B1EE1"
        d="M325.485 294.723c-.408-.364-.841 2.096-1.238-.009.406-.415.813-.83 1.222-1.243.003.417.012.834.016 1.252z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5F94FA"
        d="M317.978 304.659l.012 1.283c-.211.699-.713 1.196-1.189 1.716-1.672 1.517-4.15 2.137-5.039 4.531-.235.31-.551.408-.926.353a.653.653 0 01-.453-.481c.824-4.219 4.024-6 7.595-7.402z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#648FF7"
        d="M308.803 322.154l1.028-9.984c.185-.023.37-.06.551-.109l.184.165c.892 3.32.957 6.638-.049 9.948l-.029-.006c-.566.492-1.127.539-1.685-.014z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5788F7"
        d="M320.001 302.273c1.002-.021 2.001-.043 3.002-.063.027 4.318-3.26 1.829-5.032 2.449.326-1.096 1.917-1.112 2.03-2.386z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6B97E1"
        d="M308.803 322.154c.563.006 1.124.01 1.686.014-.699 1.516-1.563 2.969-1.26 4.768.133.789-.274 1.354-1.113 1.51-.033-1.273-.067-2.547-.102-3.818l.087-.623c.236-.618.469-1.234.702-1.851z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FD3846"
        d="M208.158 334.658c.141-.65.284-1.293 1.167-.686 1.407.969 1.342 2.414 1.34 3.891-.016 21.816-.013 43.633-.015 65.449-2.479 1.504-5.006 1.209-7.554.197-.446-.475-.634-1.059-.725-1.686-.194-21.732-.049-43.467-.071-65.199-.001-1.129-.087-2.316.867-3.205.813.014 1.223.43 1.248 1.238 1.079.752 1.885 1.592 1.443 3.094-.654 2.229-.457 4.533-.459 6.814-.008 17.24-.014 34.479.013 51.719.002 1.361-.313 2.846.813 4.236 1.14-1.051.93-2.238.932-3.301.027-18.59.026-37.18.012-55.77-.001-1.146-.034-2.303-.393-3.393-.513-1.56.113-2.595 1.382-3.398z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9394D"
        d="M208.158 334.658c-1.676 1.898.103 3.787.078 5.691-.154 11.537-.077 23.076-.077 34.613 0 8.107.004 16.215-.005 24.322-.001 1.322.308 2.791-1.868 2.791-2.174 0-1.867-1.469-1.867-2.791-.006-19.852.018-39.707-.044-59.559-.005-1.689 1.7-3.379.041-5.068l3.742.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FE364F"
        d="M203.169 333.42l-.005 68.645c-.622.387-1.167.334-1.621-.277-.629-1.154-.498-2.424-.499-3.66-.011-20.678-.018-41.355.002-62.033.001-1.324-.258-2.738.872-3.818.413-.006.824-.012 1.236-.021.006.389.011.775.015 1.164zM203.167 403.313h7.483c2.559.83-.769 1.668.002 2.502-1.286 1.129-2.868.838-4.366.873-1.657.035-3.275.09-4.366 1.619-.833-.002-1.666-.002-2.499-.002-.862-2.5-2.628.363-3.744-.635l.013-4.352c1.08-1.002 2.427-.844 3.733-.869 1.31.02 2.623.026 3.744.864z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F53B48"
        d="M201.92 408.307c-.209-1.762.386-2.648 2.343-2.525 2.122.133 4.259.031 6.389.033 1.39 2.072.74 2.695-1.61 2.527-2.363-.164-4.746-.035-7.122-.035z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F43B46"
        d="M195.677 407.67c.292-.092.697-.096.857-.295.546-.682.72-1.869 2.01-1.457 1.258.404.747 1.527.877 2.387-1.248 0-2.496.002-3.744.004v-.639z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F53C4B"
        d="M199.421 403.313c-1.244.002-2.487.002-3.731.006l-.035-1.246c.038-.189.077-.383.112-.576.341-1.221.275-2.475.275-3.717.007-19.75.002-39.496.011-59.244 0-1.572-.071-3.115-.682-4.588-.162-.609-.111-1.182.318-1.678l3.736-.01c.617.656.641 1.41.372 2.213-1.147 2.088-1.195 4.195-.102 6.326.167.492.172.982.036 1.484-.13.34-.282.664-.444.986-.191.607-.221 1.23-.222 1.852-.027 17.842-.017 35.686-.006 53.527 0 1.039.013 2.08.574 3.016.209.586.187 1.143-.212 1.649z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F33E43"
        d="M199.422 334.658l.003-2.398c.831.004 1.663.01 2.493.016l.004 69.791c-1.509.563-1.792-.527-1.998-1.563-.223-1.119-.133-2.27-.134-3.408-.004-16.568 0-33.133-.004-49.699 0-1.76.078-3.525-.362-5.254l-.006-1.244c-.343-.334-.399-.738-.294-1.182.957-1.482 1.015-3.043.385-4.66l-.087-.399z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F2415E"
        d="M195.052 402.055c-.185.006-.37.012-.555.021l.04-69.846c.176-.01.347.01.516.059.709 1.76.892 3.598.891 5.482-.012 20.043-.001 40.084-.018 60.129-.002 1.434.218 2.94-.874 4.155z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EC3B58"
        d="M195.052 402.055v-69.766c.213-.006.425-.014.638-.021l-.004 1.156c.668 1.357.612 2.818.612 4.271.001 20.252.005 40.504-.01 60.758 0 1.223.251 2.514-.597 3.607l-.036.012a30.125 30.125 0 01-.603-.017z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4F2331"
        d="M202.661 222.232c-.802.428-.73 1.2-.757 1.932-1.23.449-1.913-.188-2.402-1.208l-1.17-.635a2.436 2.436 0 01-.218-.561c.659-.98 1.695-.597 2.593-.714.843.076 1.488.484 1.954 1.186z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#55260E"
        d="M197.438 221.295l-2.339-1.433c.712.591 3.043-1.466 2.339 1.433z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6319F0"
        d="M275.56 222.31c-.26-1.471.491-2.503 1.507-3.401.861-.762 1.682-1.516 1.014-2.818l.649-.623c1.332 1.208 4.19-.411 4.644 2.531.061.392.655.1 1.018-.134 2.222-1.434 5.293-1.714 6.317-4.772a1.098 1.098 0 011.79-.502c2.006 1.949 3.736.61 5.537-.258v1.244c-.591 1.074-2.45.869-2.503 2.483-.545.935-1.948.322-2.442 1.35a1.957 1.957 0 01-.098.504c-1.121.224-2.21.493-2.515 1.835-.953.177-2.252-.285-2.436 1.315-1.632.189-1.14 1.472-1.257 2.441l-1.229 1.307c-.638.483-.787 1.286-1.235 1.893.003.2-.007.4-.029.599-.944-.275-1.416 1.686-2.681.44-.975-.961-.41-1.524.005-2.37.328-.669.215-1.544-.754-1.686-.968-.142-2.312-.58-2.652.783-.565 2.259-2.078 1.369-3.673 1.603.474-1.478 1.348-2.491 1.023-3.764z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#621AEE"
        d="M211.908 263.511c1.141-.04 1.166-.952 1.386-1.739.171-.607.695-.697 1.234-.68.468.017.894.308.714.737-.322.771-1.053 1.573.518 1.644.979.045 2.187.357 2.385-1.211 1.712.3 1.272 1.621 1.155 2.652-.149 1.313-1.303.956-2.165 1.102-2.35.398-4.089-.409-5.227-2.505z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#621AEE"
        d="M218.146 262.262c-2.193-.984-.808-3.759-2.497-4.993 4.442.03 4.785.716 2.497 4.993z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6218F7"
        d="M288.711 211.074c-.815-.038-1.753.055-1.815-1.122-.072-1.375.954-1.346 1.896-1.35.876-.005 1.694.118 1.666 1.275-.028 1.176-.903 1.175-1.747 1.197z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5925DB"
        d="M293.091 217.41c.073-1.791 1.467-1.19 2.442-1.35l1.298.04c-.83 1.625-2.412 1.105-3.74 1.31z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F63A48"
        d="M355.456 226.106l-1.239 2.469c-.184.313-.459.918-.539.895-1.21-.379-.489-1.456-.74-2.202l.095-1.166 2.423.004zM362.939 229.808l-2.49-.001c.066-.868.532-1.257 1.398-1.204.764.049 1.019.539 1.092 1.205z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FD9F01"
        d="M321.767 219.871c.755-.664 1.042-1.581 1.348-2.488 1.457.052 1.739 2.017 3.189 2.033 1.444-1.107-1.427-2.504.061-3.101 1.895-.761 2.354 2.001 3.986 2.324l.129 1.804c-.521.307-1.242.647-.928 1.333.43.94 1.439.396 2.186.545-.088 3.128 1.07 6.417.732 9.181-.341 2.762-.391 5.587-.73 8.362-.023.204.025.417-.006.616-.37 2.212.75 2.407 2.453 1.825l-.043 2.413c-2.021 2.423-4.101-.104-6.147.075-1.592-1.452-3.825-1.008-5.604-1.897-.17-.237-.18-.485-.061-.744.567-.546 1.31-.895 1.766-1.567.881-1.04.547-2.291.601-3.472a63.195 63.195 0 010-2.133c.047-.413-.146.072.015-.298 1.299-2.996.469-5.402-1.982-7.385-.131-.462-.075-.882.273-1.235 1.168-.111 1.711-1.055 2.264-1.866.211-.312.088-1.017-.129-1.411-.261-.481-.875-.495-1.375-.31-.954.355-1.822 1.833-2.905.605-1.157-1.309.875-2.045.907-3.209z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9A004"
        d="M190.733 237.272l.026-1.245c1.826-1.165 2.593-2.654 2.497-4.983-.224-5.439.637-6.149 6.216-6.257.354-.33.767-.37 1.213-.248.814.567 1.754.914 2.593 1.44l-.042-.011c.596.83.807 1.867.134 2.563-1.9 1.964-1.828 4.444-2.101 6.854a2.28 2.28 0 01-.463.811c-1.391 1.048-3.289.147-4.678 1.215a3.413 3.413 0 01-.808.387c-1.525-.206-3.216 1.02-4.587-.526z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D39554"
        d="M200.628 224.855l-1.157-.068c.19-.607-.808-1.234.03-1.831.801.404 1.602.807 2.403 1.208l.536.64c-.588.556-1.194.486-1.812.051z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EA4244"
        d="M219.353 211.061l-1.232-.024c-.082-1.104-.858-1.203-1.719-1.203-.917 0-1.884.06-1.994-1.244 2.045-.001 4.09-.004 6.134-.006l.089.66c-.273.714-.583 1.401-1.278 1.817z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FC3558"
        d="M217.518 211.095l-.61 1.229c-1.228.463-2.761.483-2.952 2.776-1.335-3.979-1.282-4.026 3.562-4.005z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E44158"
        d="M209.432 219.86c-.37.828-1.328 1.328-1.315 2.366a.962.962 0 01-.514.24c-.302.165-.54.098-.714-.197-.117-1.885.67-3.151 2.519-3.694.37.422.372.85.024 1.285z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B94877"
        d="M206.888 222.269c.239.064.477.129.714.197-1.561 3.068-2.921.695-4.336-.159l3.622-.038z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DD3F62"
        d="M209.432 219.86l-.025-1.285c1.291-.345 2.241-1.822 3.838-1.158a.704.704 0 01-.027.572c-1.001.39-2.022.75-2.649 1.717l-1.137.154z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EA4244"
        d="M216.854 214.8c.019.83-.379 1.248-1.216 1.234.07-.744-.26-1.88 1.216-1.234z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8A135"
        d="M190.733 237.272c1.653.63 3.321-.316 4.977.05 1.007-.196 1.983-.269 2.702.68l-1.395.513-3.061.099c-1.06-.479-2.899.907-3.223-1.342z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3D0B99"
        d="M374.771 163.073c.951 1.048 1.561 2.213 1.264 3.69-1.574.782-3.348 1.416-4.053-.814-.681-2.162.852-2.878 2.789-2.876z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3182C6"
        d="M353.661 331.732c-1.001-1.773-.631-3.572-.259-5.371 1.232 1.77.756 3.571.259 5.371z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4DABEE"
        d="M311.762 312.189c-.323-3.65 3.01-3.652 4.991-5.002 1.114 2.607 3.397.584 4.997 1.26l1.851 5.622c1.093 2.04.946 4.261.939 6.458-.244 2.297-1.335 4.383-1.649 6.664-1.029 2.92-1.581 5.963-2.377 8.945-.194.918.334 2.234-1.305 2.344-.65-.809-.685-1.621-.013-2.436.323-1.963-2.565-.875-2.481-2.611.096-.182.244-.314.394-.447.09-.082.31-.246.267-.236-1.443.297-3.056-.508-4.36.648-.833.004-1.665.008-2.497.01l.004-1.252c.405-2.08 2.977-3.725 1.246-6.23 2.337-4.121.887-8.588 1.137-12.896.03-.54-.614-.754-1.144-.841z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FCBD72"
        d="M327.973 304.751c-.111-.74-.507-1.224-1.259-1.382-.709-1.014.223-1.54.653-2.221.374-.442.759-.873 1.343-1.044.298-.009.553.097.771.293.8.516.066 3.372 2.392 1.562.422-.141.807-.096 1.137.223l.004-.002c.65.771 1.842.473 2.485 1.256l-.009.011c.531.687 1.789 1.026 1.395 2.154-.404 1.155-1.605 1.125-2.617 1.191-1.126.077-2.256.02-3.381-.054-1.399-.032-2.143-1.029-2.914-1.987z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#45A2E3"
        d="M330.486 342.15c-.004.842.691 1.215 1.149 1.758.688.822 2.088 1.695.877 2.811-.917.844-2.319.721-3.356-.326-.505-.508-1.164-.904-1.166-1.746-.268-1.932.554-2.774 2.496-2.497z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4DADE4"
        d="M321.75 308.447c-.809-.017-1.161.819-1.797 1.012-1.963.595-3.486.39-3.2-2.271.024-.802.434-1.22 1.237-1.245 1.475.498 3.236.573 3.76 2.504z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B8BCC"
        d="M319.876 335.842c.896-2.885 1.187-5.943 2.455-8.723 1.148-.043 1.063.555.683 1.309l-2.376 10.65c-1.057-.889.092-2.299-.762-3.236z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5C9ED7"
        d="M344.222 310.966c-2.916 1.345-5.838 2.406-8.811.137.085-.135.173-.27.258-.406 2.131-1.284 4.828.252 6.885-1.391.59-.307 1.178-.645 1.852-.214.398.658.301 1.271-.164 1.853l-.02.021z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3395DB"
        d="M323.014 328.428c-.028-.541-.163-1.023-.681-1.307.461-2.123.625-4.336 1.902-6.209.457.287.192.934.613 1.236-.61 2.092-1.222 4.188-1.834 6.28z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2787CE"
        d="M324.849 322.148c-.506-.264-.577-.74-.613-1.236l-.636-6.843c.06-.402.003-1.074.199-1.159.778-.34.815.564.827.857.131 2.792.164 5.588.223 8.381z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#65A4C1"
        d="M335.412 311.103c-2.037-.163-4.221-.045-4.959-2.645.209-.207.457-.331.75-.374.74.002 1.393.318 2.063.582.936.548 2.402.563 2.244 2.214l-.098.223z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#94A5B4"
        d="M331.184 308.332c-.244.043-.487.083-.729.126-1.59-.725-2.758-1.734-2.481-3.707 1.163-.259 1.333 1.386 2.423 1.269.354.18.567.475.698.841.149.483.299.966.089 1.471z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4E31DC"
        d="M322.98 302.054c-.441-3.387 2.593-1.353 3.676-2.357l.135.047c.451.59.536 1.213.156 1.872-.998.906-2.289-.163-3.322.496-.215-.02-.431-.04-.645-.058z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#31ABED"
        d="M325.736 307.139c-.998-.026-1.396-.394-1.41-1.134-.018-.925.498-1.295 1.358-1.216.753.069 1.007.587.99 1.279-.018.784-.53 1.017-.938 1.071z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4AA0EA"
        d="M326.676 309.678c-.011.723-.342 1.157-1.093 1.185-.912.032-1.313-.453-1.254-1.323.052-.754.533-1.047 1.243-1.025.752.018 1.094.435 1.104 1.163z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5A8EAA"
        d="M319.876 335.842c1.026.898.453 2.172.759 3.236-.066 1.014-.135 2.027-.203 3.039-.55.422-1.046.359-1.495-.166-.503-1.309-.921-2.604.611-3.561l.328-2.548z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5689AE"
        d="M325.494 348.395c.008.205.013.412.013.619-.106.451-.381.736-.837.84-1.557-.67-2.866-1.635-3.724-3.135.09-.465.372-.744.829-.846 1.658.225 2.05 2.315 3.719 2.522z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4F829E"
        d="M321.775 345.873c-.23.221-.463.443-.697.662-.807.344-1.459-.018-2.1-.451-.598-.57-.9-1.229-.604-2.064 1.206-1.514 1.653-.406 2.124.619.426.41.852.822 1.277 1.234z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#867AFD"
        d="M323.625 302.111c.861-.86 2.04-.372 3.026-.708.37-.201.735-.221 1.098.023-.345.648-.688 1.296-1.034 1.942-1.211.027-1.764-1.567-3.09-1.257z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#578CC2"
        d="M320.499 344.639c-.584-.15-.724-1.473-1.682-.637-.747-.809-.962-1.504.397-1.861l1.22-.023.065 2.521z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2EA7FB"
        d="M322.948 340.883c-.038.398-.021.891-.575.887-.548-.002-.564-.488-.564-.889 0-.402.017-.895.566-.891.541.004.542.489.573.893z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#31A9F9"
        d="M342.654 332.785c-.076.543-.5.57-.904.564-.398-.004-.89-.016-.888-.566.002-.545.489-.563.89-.564.404-.004.83.013.902.566z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F2BF7F"
        d="M330.552 307.1c-.051-.361-.102-.721-.156-1.082 1.205-.021 2.429-.18 3.613-.036 2.608.312 2.565-.771 1.48-2.535 2.713 1.773 5.852.774 8.75 1.341.031 1.258.066 2.516.096 3.773.111.217.068.404-.104.569l-1.202.591c-3.322 1.197-6.506.804-9.577-.835-.985-.563-2.003-1.075-2.9-1.786z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7DCB9"
        d="M342.971 292.22c.417-.003.832-.003 1.249-.003-.481 2.345 1.006 4.891-1.249 7.139v-7.136z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5BD83"
        d="M333.009 302.182c-.426.011-.854.02-1.279.03-1.605.175-1.695-.99-1.857-2.095a2.404 2.404 0 01.278-1.356c.108-.108.222-.218.333-.327.851 1.243 2.274 2.1 2.525 3.748z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7C488"
        d="M335.499 303.436c-1.078.077-2.047-.066-2.485-1.256.981.113 2.258-.354 2.485 1.256z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F4DECB"
        d="M329.853 294.716h.646c-.007 1.241-.011 2.479-.016 3.718l.002.034c-2.089-.933-1.451-2.327-.632-3.752z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3EA4EB"
        d="M344.231 309.13a5.94 5.94 0 01.104-.569l1.115-.147c-.099.988.462 2.291-1.209 2.531-.001-.606-.005-1.21-.01-1.815z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F8E5CA"
        d="M452.969 339.787c-.043.383-.084.764-.125 1.146-.09.172-.135.355-.137.549l-1.766.621c-.182-1.408-.357-2.809 1.816-2.512l.212.196z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F4F4F0"
        d="M452.758 339.592c-1.5.191-1.143 1.723-1.816 2.512-2.115-.293-.666-2.154-1.354-3.078.717-2.441.162-5.111 1.346-7.469.836-1.137 1.84-1.449 3.074-.617.445.24.893.48 1.336.723.42 1.822 1.479 3.652-.057 5.451-1.277.382-2.085 1.243-2.529 2.478z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9EDCD"
        d="M454.008 330.939c-1.025.205-2.049.41-3.074.617l-.088.033c-.311-.912-.393-1.797.508-2.428.652-.455 1.111.01 1.537.459.168.066.338.088.518.063.199.419.398.837.599 1.256z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F8D99C"
        d="M452.891 329.621c-2.063-.777-1.863.791-2.043 1.969-.945-.924-.354-2.041-.383-3.076.74-.006 1.48-.01 2.221-.014.066.375.137.746.205 1.121z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4A88B2"
        d="M324.839 349.723l.667-.709c1.168.76 2.246 1.598 2.614 3.043-.273.041-.552.08-.828.121-.154-.014-.306-.025-.46-.041-.83-.668-2.082-.985-1.993-2.414z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9DCAA"
        d="M315.525 352.113c.387-1.877 3.125-2.582 2.479-4.973-.148-.168-.198-.336-.148-.502.051-.166.102-.25.153-.252a1.23 1.23 0 01.862 0c.796.467 1.459 1.039 1.628 2.012.652 3.152-2.71 2.289-3.749 3.748-.409-.009-.817-.023-1.225-.033z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DEE3DF"
        d="M320.499 348.398c-.815-.428-1.459-1.029-1.878-1.857-.092-.627.111-.936.789-.729.557.24 1.112.482 1.668.723 1.254 1.064 2.508 2.127 3.762 3.188l1.993 2.414c-2.597-.422-3.871-3.092-6.334-3.739z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FED9B3"
        d="M313.011 344.645c-1.15-.43-2.716-1.035-1.784-2.422 1.151-1.715-1.033-5.967 3.669-5.08.597.111 1.232.018 1.85.02.121.121.242.244.364.363.638 1.486.629 2.975-.01 4.457-.308.41-.732.549-1.227.516-1.347-.934-2.462-1.369-2.218 1.059-.092.434-.272.817-.644 1.087z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FBD9C2"
        d="M313.011 344.645l-.001-1.252c.341-.344.752-.395 1.201-.281a7.164 7.164 0 002.847.891c.465.107.875.303 1.156.709.186.633.273 1.254-.203 1.811 0 .205-.003.412-.008.619-1.244.885-2.488.893-3.732-.002-.625-.209-.783-.887-1.258-1.246l-.002-1.249z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D6E3E0"
        d="M318.011 346.521c-.016-.625-.029-1.25-.043-1.875-1.055-1.109-.489-2.473-.589-3.734-.1-1.266.359-2.629-.627-3.748l-.007-.002-.021-1.305c.823.063 1.647.123 2.471.188l.353 2.346-.334 3.75c-.527.533-.511 1.188-.397 1.861-.354.781.203 1.268.591 1.811-.262.242-.524.484-.787.729a6.92 6.92 0 00-.61-.021z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6E3A7"
        d="M313.013 345.893c.811.021 1.224.441 1.258 1.246-.129.98.419 2.303-1.258 2.504v-3.75z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4DABEE"
        d="M310.517 322.174c.017-3.316.032-6.633.048-9.95l1.197-.034c0 2.543.015 5.088-.004 7.635-.008.976.267 2.144-1.241 2.349z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#57A6EC"
        d="M311.767 325.926c1.936 1.813 1.558 3.707-1.246 6.23-.77-2.314 1.432-4.033 1.246-6.23z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4DAAEF"
        d="M313.014 333.398c1.373-1.445 1.61-1.488 6.387-1.063-.771.984-1.802.881-2.687 1.098-1.234-.011-2.466-.021-3.7-.035z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E69623"
        d="M325.488 234.809c0 .825-.003 1.649-.003 2.473-1.138 1.021-.111 2.741-1.22 3.771-.051 1.23-.922 1.261-1.824 1.245-1.016-1.445-.105-2.604.561-3.801.492-2.477.018-4.959.051-7.438 1.308-.676 1.601.258 1.77 1.192.159.872-.075 1.837.665 2.558z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F59F0F"
        d="M325.488 234.809c-1.068-.101-1.223-.839-1.227-1.716-.004-.903.084-1.887-1.209-2.036-.038-.342-.076-.683-.117-1.025-.248-.924-.64-1.853.105-2.738 3.961 1.482 3.575 4.378 2.448 7.515z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#462C42"
        d="M323.001 238.496c.475 1.365-.693 2.487-.561 3.801a.691.691 0 00-.049.598c-.208.228-.413.457-.621.684-.404.003-.809.005-1.213.009l-.045-3.787c.831-.433 1.659-.87 2.489-1.305z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ED9835"
        d="M323.041 227.294l-.105 2.736-2.467-5.192c1.141-.206 1.438 1.337 2.535 1.224l.037 1.232z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#601CE1"
        d="M284.32 226.706c-.031-.921-.045-1.83 1.235-1.893l-.011 1.241c-.408.217-.816.433-1.224.652z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D5C3AC"
        d="M329.853 294.716c.187 1.256-.43 2.646.633 3.752 0 .42.003.839.005 1.256-.374.332-.794.458-1.279.293-2.103-1.193.126-3.11-.753-4.509-.09-.314-.002-.578.24-.792.184.011.367.013.551.007.201-.005.402-.007.603-.007z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#26162A"
        d="M328.699 294.716a.822.822 0 00-.041.595c.209.708.755 1.504-.481 1.831l-.815-2.464.514-1.103c.272.381.548.76.823 1.141z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4A222F"
        d="M328.176 297.142c.556-.507.408-1.198.481-1.831 1.957 1.294-1.164 3.115.462 4.441.235.076.327.177.276.306-.057.139-.118.207-.187.207l-.704.116c-.607.295-1.136.437-1.076-.559.736-.758.481-1.793.748-2.68z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#624077"
        d="M327.429 299.822l1.078.556c-.254.352-.507.7-.759 1.051l-1.098-.025.137-1.66.642.078z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F19E1A"
        d="M200.67 236.048c.029-2.869-.64-5.9 2.224-8.046.398-.298.241-1.337.342-2.034 2.475-.107.991 1.585 1.15 2.53-.76 1.165-.243 2.727-1.192 3.832l-.625 3.932c-.706-.856-.035-1.951-.518-2.994-.045-.267-.585.279-.205.112.175-.078.31-.027.276.124-.23.99 1.131 2.899-1.452 2.544z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E5A357"
        d="M200.67 236.048c2.069-.259.777-2.165 1.721-3.459l.177 3.671c-.545 2.591-2.675 1.398-4.158 1.744-.9-.227-1.976.236-2.702-.682l-.037-.035c1.441-1.323 3.566.115 4.999-1.239z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#473839"
        d="M203.194 232.33c-.084-1.427.053-2.784 1.192-3.832-.365 1.288 1.033 3.124-1.192 3.832z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EC9D31"
        d="M200.628 224.855l1.813-.051c.683.103.86.567.836 1.175-1.047.014-2.303.521-2.649-1.124z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FD3847"
        d="M199.424 342.143c2.043.51 1.205 2.186 1.208 3.35.054 17.744.021 35.49.075 53.234.004 1.16-.841 2.842 1.215 3.34.414-.002.828-.002 1.242-.002l.003 1.248h-3.746l-.002-1.252c-.862-1.09-.608-2.383-.608-3.605-.016-17.568-.016-35.133 0-52.699.001-1.225-.252-2.516.609-3.607l.004-.007z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FE373D"
        d="M195.691 402.061l-.005-68.639c1.288 1.057 1.242 2.518 1.241 3.984-.006 20.539.007 41.076-.032 61.615-.001 1.088.701 2.631-1.204 3.04z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FE3554"
        d="M199.419 342.148v59.914c-1.547-.219-1.236-1.428-1.237-2.412-.011-18.363-.011-36.729 0-55.092.001-.982-.306-2.189 1.237-2.41zM199.42 339.652l-.002 1.246c-1.785-1.676-1.783-4.57.004-6.24.91 1.666.912 3.33-.002 4.994z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FD3847"
        d="M199.42 339.652l.002-4.994c2.013 1.668 2.018 3.332-.002 4.994z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F3A00F"
        d="M324.265 241.052c.386-1.263-.99-3.097 1.22-3.771-.39 1.263.999 3.099-1.22 3.771z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F19E1A"
        d="M200.67 236.048c-1.164 2.438-3.347.766-4.998 1.238 1.156-2.473 3.361-.708 4.998-1.238z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F3C360"
        d="M329.209 300.265a1.056 1.056 0 00-.09-.513c.458-.009.913-.02 1.371-.028-.079 1.074.133 2.005 1.239 2.488.096.534.928 1.29.038 1.54-.828.233-1.968-.109-2.36-1.024-.307-.719-.148-1.635-.198-2.463z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E0C58D"
        d="M333.041 308.418c3.229 1.208 6.576 1.493 9.988 1.303-2.231 2.178-4.955 1.152-7.52 1.159-.428-1.209-1.923-.86-2.563-1.759-.2-.265-.157-.498.095-.703z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CABFAD"
        d="M333.041 308.418l-.094.701c-.588-.261-1.177-.521-1.763-.785-.21-.413-.422-.821-.632-1.234.977.165 2.23-.199 2.489 1.318z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F3E0BA"
        d="M316.752 337.164c1.881.35 1.166 1.854 1.232 2.928.092 1.514-.002 3.037-.017 4.555-.407-.004-.812-.006-1.218-.008-.657-.834-.65-1.668.007-2.5l-.004-4.975z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FCDFA2"
        d="M316.757 342.139l-.007 2.5c-.981-.104-2.278.424-2.483-1.24-.508-1.32-.054-1.703 1.238-1.271.418.003.834.005 1.252.011z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F3E0BA"
        d="M315.505 342.127c-.802.045-1.221.463-1.238 1.271-.418 0-.838-.002-1.257-.006v-3.672c1.39.698 2.305 1.157 2.495 2.407z"
      />
    </Svg>
  )
}
export default SvgComponent
